/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  GraphQLDate: { input: string; output: string; }
  GraphQLDateTime: { input: string; output: string; }
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  Long: { input: number; output: number; }
  Object: { input: Record<string, unknown>; output: Record<string, unknown>; }
  ObjectID: { input: string; output: string; }
  SafeString: { input: string; output: string; }
  StateChanges: { input: { id: string; from: string; to: string; createdAt: string; updatedAt: string; }; output: { id: string; from: string; to: string; createdAt: string; updatedAt: string; }; }
  URLString: { input: string; output: string; }
};

export type Account = {
  __typename?: 'Account';
  accountGroups?: Maybe<Array<AccountGroup>>;
  activatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  activeWorkflowCompletions: Array<WorkflowCompletion>;
  affiliations?: Maybe<Array<Affiliation>>;
  /** @deprecated Use feeSetting.applicableBillingSchedule instead */
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  /** @deprecated Use feeSetting.applicableFeeTier instead */
  applicableFeeTier?: Maybe<FeeTier>;
  applyForGovFunds?: Maybe<Array<Maybe<ApplyForGovFunds>>>;
  availableCurrencies?: Maybe<Array<Maybe<AccountCurrencyTypes>>>;
  baseCurrency?: Maybe<AccountCurrencyTypes>;
  /** @deprecated Use feeSetting instead. */
  billingSchedule?: Maybe<BillingSchedule>;
  /** @deprecated Use householdClientGroup or corporationClientGroup instead. */
  clientGroup?: Maybe<ClientGroup>;
  corporationClientGroup?: Maybe<ClientGroup>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  custodianAccountName?: Maybe<Scalars['String']['output']>;
  custodianAccountNumber?: Maybe<Scalars['String']['output']>;
  custodianAffiliates?: Maybe<Array<Maybe<CustodianAffiliate>>>;
  custodianConnection?: Maybe<CustodianConnection>;
  custodianCustomFields?: Maybe<Array<Maybe<CustodianCustomField>>>;
  custodianSnapshotHistory?: Maybe<Array<Maybe<CustodianSnapshotHistory>>>;
  custodianSortingOrderPriority?: Maybe<Scalars['Int']['output']>;
  custodianStatistics?: Maybe<CustodianStatistics>;
  custodianUpcomingTransactions?: Maybe<CustodianUpcomingTransactionsResponse>;
  customFields?: Maybe<Array<Maybe<AccountCustomFieldValue>>>;
  dealerAccountNumber?: Maybe<Scalars['String']['output']>;
  dealerCode?: Maybe<Scalars['String']['output']>;
  dealerName?: Maybe<Scalars['String']['output']>;
  defaultTaxRank?: Maybe<Scalars['Int']['output']>;
  eligibleForDisabilityTaxCredit?: Maybe<Scalars['Boolean']['output']>;
  externalSourceType?: Maybe<ExternalSourceTypes>;
  feePaymentAccount?: Maybe<Account>;
  feeRedirectionSignedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  feeSetting?: Maybe<AccountFeeSetting>;
  /** @deprecated Use feeSetting instead. */
  feeTier?: Maybe<FeeTier>;
  forceOpen?: Maybe<Scalars['Boolean']['output']>;
  groupEmployer?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  householdClientGroup?: Maybe<ClientGroup>;
  id: Scalars['ObjectID']['output'];
  /** Lists remaining forms to be signed for this account. */
  incompleteFormAgreements?: Maybe<Array<Maybe<IncompleteFormAgreement>>>;
  integrations?: Maybe<Array<Maybe<AccountIntegration>>>;
  /**
   * For RESP accounts, indicates the plan was transferred in from another institution.
   * When true, the beneficiary age (under 21) restriction is lifted.
   */
  isTransferredFromAnotherInstitution?: Maybe<Scalars['Boolean']['output']>;
  jurisdiction?: Maybe<Jurisdiction>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  /** Lists latest signed forms for this account. */
  latestFormAgreements?: Maybe<Array<Maybe<FormAgreement>>>;
  /** @deprecated nickName is deprecated. Use translatedNickName instead. */
  nickName?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  overrideTaxRank?: Maybe<Scalars['Int']['output']>;
  /** The Account owners defined as account user and if thats a joint Account then all joint affiliates */
  owners?: Maybe<Array<User>>;
  program?: Maybe<Theme>;
  repCode?: Maybe<RepCode>;
  requiresFeeRedirectionSigned?: Maybe<Scalars['Boolean']['output']>;
  /**
   * For evaluation of BCTESG grant, for RESP accounts in British Columbia.
   * Corresponds to the field "There is only one beneficiary named to this RESP OR all beneficiaries are siblings AND all beneficiaries listed are residents of British Columbia." in form Annex D.
   */
  respAllBeneficiariesAreInBc?: Maybe<Scalars['Boolean']['output']>;
  /** For joint accounts, specifies whether the ownership is defined with right of survivorship. */
  rightOfSurvivorship?: Maybe<Scalars['Boolean']['output']>;
  scheduledIncomeFundTransfer?: Maybe<ScheduledIncomeFundTransfer>;
  sourceOfFunds?: Maybe<SourceOfFunds>;
  sourceType?: Maybe<SourceTypes>;
  state: AccountStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<AccountStateMachineChanges>>>;
  /** Account state in translated form (en, fr). */
  stateTranslated?: Maybe<AccountTranslatedString>;
  statistics?: Maybe<Statistics>;
  /** Account's ID returned as string. It can either be the OneVest ID or an External ID from a Passthrough API. */
  stringId: Scalars['String']['output'];
  subAccounts?: Maybe<Array<SubAccount>>;
  taxRank?: Maybe<Scalars['Int']['output']>;
  tlhEnabled?: Maybe<Scalars['Boolean']['output']>;
  totalManagementFees: ManagementFees;
  transactions: Array<Transaction>;
  transactionsTotal: TransactionTotal;
  translatedAccountType?: Maybe<AccountTranslatedString>;
  translatedNickName?: Maybe<AccountTranslatedString>;
  type: AccountTypes;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  user: User;
};


export type AccountCustodianSnapshotHistoryArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<CustodianStatisticsInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type AccountCustodianStatisticsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<CustodianStatisticsInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type AccountCustomFieldsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AccountStatisticsArgs = {
  input?: InputMaybe<StatisticsInput>;
};


export type AccountTotalManagementFeesArgs = {
  endDate: Scalars['GraphQLDate']['input'];
  startDate: Scalars['GraphQLDate']['input'];
};


export type AccountTransactionsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeTypes?: InputMaybe<Array<TransactionTypes>>;
  includeTypes?: InputMaybe<Array<TransactionTypes>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type AccountTransactionsTotalArgs = {
  absolute?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  includeTypes?: InputMaybe<Array<TransactionTypes>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type AccountBilling = {
  __typename?: 'AccountBilling';
  account: Account;
  subAccountBillings: Array<SubAccountBilling>;
  total: GroupedBillingTotal;
};

export type AccountBulkMutualFundTrade = {
  __typename?: 'AccountBulkMutualFundTrade';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amountType?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currencies>;
  exchange: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  moneyAllocatedCents: Scalars['Float']['output'];
  ticker: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AccountBulkTrade = {
  __typename?: 'AccountBulkTrade';
  _id: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  exchange: Scalars['String']['output'];
  /** in CAD */
  expectedPriceCents: Scalars['Int']['output'];
  /** in actual currency */
  expectedPriceInCurrencyCents?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type AccountBulkTradeRequest = {
  __typename?: 'AccountBulkTradeRequest';
  _id: Scalars['String']['output'];
  actualTotal?: Maybe<Scalars['Float']['output']>;
  actualTradePriceCents?: Maybe<Scalars['Float']['output']>;
  actualTradePriceInCurrencyCents?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currencies>;
  exchange: Scalars['String']['output'];
  expectedTradePriceCents: Scalars['Float']['output'];
  expectedTradePriceInCurrencyCents?: Maybe<Scalars['Float']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  total: Scalars['Float']['output'];
};

export type AccountBulkUpsertItem = {
  __typename?: 'AccountBulkUpsertItem';
  batchId?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertIntegration?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertRequest?: Maybe<BulkUpsertRequest>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<AccountIntegration>>>;
  oneVestId?: Maybe<Scalars['ObjectID']['output']>;
  outputErrors?: Maybe<Array<Maybe<AccountBulkUpsertItemOutputError>>>;
  rawData?: Maybe<Scalars['Object']['output']>;
  state?: Maybe<AccountBulkUpsertItemStates>;
};

export type AccountBulkUpsertItemOutputError = {
  __typename?: 'AccountBulkUpsertItemOutputError';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
};

export type AccountBulkUpsertItemQueryFilter = {
  batchId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertIntegrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  oneVestId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<AccountBulkUpsertItemStates>;
};

export enum AccountBulkUpsertItemStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Queued = 'QUEUED'
}

export enum AccountBulkUpsertItemTransition {
  Fail = 'fail',
  Process = 'process',
  Retry = 'retry'
}

export enum AccountBulkUpsertRequestTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  PartiallyFail = 'partiallyFail',
  Process = 'process'
}

export enum AccountCurrencyTypes {
  Cad = 'CAD',
  Usd = 'USD'
}

/** Filter a custom field by key. Provide exactly one of value or valueIn. */
export type AccountCustomFieldQueryFilter = {
  /** Custom field key to filter on. */
  key: Scalars['SafeString']['input'];
  /**
   * Exact match — the stored custom field value must equal this value.
   * Mutually exclusive with valueIn.
   */
  value?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Match any — the stored custom field value must equal one of these values (OR / IN).
   * Mutually exclusive with value.
   */
  valueIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type AccountCustomFieldSelectedOption = {
  __typename?: 'AccountCustomFieldSelectedOption';
  displayText?: Maybe<AccountTranslatedString>;
  value: Scalars['JSON']['output'];
};

export type AccountCustomFieldValue = {
  __typename?: 'AccountCustomFieldValue';
  customField?: Maybe<CustomField>;
  key: Scalars['String']['output'];
  selectedOptions?: Maybe<Array<Maybe<AccountCustomFieldSelectedOption>>>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type AccountFee = {
  __typename?: 'AccountFee';
  account: Account;
  accountBaseCurrency?: Maybe<Scalars['String']['output']>;
  chargeableMarketValueCentsOnLastDay?: Maybe<Scalars['Float']['output']>;
  date: Scalars['GraphQLDateTime']['output'];
  feeCents: Scalars['Float']['output'];
  id: Scalars['ObjectID']['output'];
  marketValueCentsOnLastDay?: Maybe<Scalars['Float']['output']>;
  organizationBaseCurrency?: Maybe<Scalars['String']['output']>;
  organizationBaseCurrencyFxRate?: Maybe<Scalars['Float']['output']>;
  redirectedFromAccount?: Maybe<Account>;
  salesTaxCents: Scalars['Float']['output'];
  state: AccountFeeStates;
  transactionFeeCents: Scalars['Float']['output'];
};

export enum AccountFeeBulkTransition {
  Request = 'request'
}

export type AccountFeeSetting = {
  __typename?: 'AccountFeeSetting';
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  applicableFeeTier?: Maybe<FeeTier>;
  billingSchedule?: Maybe<BillingSchedule>;
  feeTier?: Maybe<FeeTier>;
};

export enum AccountFeeStates {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Ready = 'READY',
  Reconciled = 'RECONCILED',
  Requested = 'REQUESTED'
}

export enum AccountFeeTransition {
  Cancel = 'cancel',
  Fail = 'fail',
  Reconcile = 'reconcile',
  Request = 'request'
}

export type AccountFeesPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type AccountFeesQueryFilter = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  referenceDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  referenceDateAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  referenceDateBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  state?: InputMaybe<AccountFeeStates>;
};

export type AccountFilterInput = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  excludeAccountIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  isUngrouped?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<LanguageCodes>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * Restricts which fields 'query' is matched against. Omitted, null, or
   * empty array falls back to the default fan-out.
   */
  queryFields?: InputMaybe<Array<AccountSearchableField>>;
  repCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictToOrganizationId?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<SearchAccountStates>>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type AccountGroup = {
  __typename?: 'AccountGroup';
  accounts?: Maybe<Array<Account>>;
  activeWorkflowCompletions: Array<WorkflowCompletion>;
  /** @deprecated Use feeSetting.applicableBillingSchedule instead */
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  /** @deprecated Use feeSetting.applicableFeeTier instead */
  applicableFeeTier?: Maybe<FeeTier>;
  /** @deprecated Use feeSetting.billingSchedule instead */
  billingSchedule?: Maybe<BillingSchedule>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  customFields?: Maybe<Array<Maybe<AccountCustomFieldValue>>>;
  feeSetting?: Maybe<AccountGroupFeeSetting>;
  /** @deprecated Use feeSetting.feeTier instead */
  feeTier?: Maybe<FeeTier>;
  hasFullAccess: Scalars['Boolean']['output'];
  householdClientGroup?: Maybe<ClientGroup>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<AccountIntegration>>>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  state: AccountGroupStates;
  stateMachineChanges?: Maybe<Array<Maybe<AccountStateMachineChanges>>>;
  statistics?: Maybe<Statistics>;
  subAccounts?: Maybe<Array<SubAccount>>;
  totalAccounts: Scalars['Int']['output'];
  translatedName: AccountTranslatedString;
  type: AccountGroupTypes;
  user?: Maybe<User>;
};


export type AccountGroupCustomFieldsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AccountGroupStatisticsArgs = {
  input?: InputMaybe<StatisticsInput>;
};

export type AccountGroupBulkUpsertItem = {
  __typename?: 'AccountGroupBulkUpsertItem';
  batchId?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertIntegration?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertRequest?: Maybe<BulkUpsertRequest>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<AccountIntegration>>>;
  oneVestId?: Maybe<Scalars['ObjectID']['output']>;
  outputErrors?: Maybe<Array<Maybe<AccountGroupBulkUpsertItemOutputError>>>;
  rawData?: Maybe<Scalars['Object']['output']>;
  state?: Maybe<AccountGroupBulkUpsertItemStates>;
};

export type AccountGroupBulkUpsertItemOutputError = {
  __typename?: 'AccountGroupBulkUpsertItemOutputError';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
};

export type AccountGroupBulkUpsertItemQueryFilter = {
  batchId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertIntegrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  oneVestId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<AccountGroupBulkUpsertItemStates>;
};

export enum AccountGroupBulkUpsertItemStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Queued = 'QUEUED'
}

export enum AccountGroupBulkUpsertItemTransition {
  Fail = 'fail',
  Process = 'process',
  Retry = 'retry'
}

export enum AccountGroupBulkUpsertRequestTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  PartiallyFail = 'partiallyFail',
  Process = 'process'
}

export type AccountGroupFeeSetting = {
  __typename?: 'AccountGroupFeeSetting';
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  applicableFeeTier?: Maybe<FeeTier>;
  billingSchedule?: Maybe<BillingSchedule>;
  feeTier?: Maybe<FeeTier>;
};

export enum AccountGroupStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum AccountGroupTransition {
  Archive = 'archive'
}

export enum AccountGroupTypes {
  Household = 'HOUSEHOLD',
  Individual = 'INDIVIDUAL',
  NonIndividual = 'NON_INDIVIDUAL',
  Organization = 'ORGANIZATION'
}

export type AccountGroupsPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type AccountGroupsQueryFilter = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<AccountGroupStates>>;
  type?: InputMaybe<AccountGroupTypes>;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
};

/** The integration enum and unique integration id  */
export type AccountIntegration = {
  __typename?: 'AccountIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<AccountIntegrationTypes>;
};

/** Input type for integrations field */
export type AccountIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<AccountIntegrationTypes>;
};

/** Integrations for Account */
export enum AccountIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export enum AccountReconciliationFlagStates {
  Fixed = 'FIXED',
  Flagged = 'FLAGGED'
}

export enum AccountReconciliationFlagTypes {
  DifferentCash = 'DIFFERENT_CASH',
  DifferentHoldingBookValue = 'DIFFERENT_HOLDING_BOOK_VALUE',
  DifferentHoldingEodPrice = 'DIFFERENT_HOLDING_EOD_PRICE',
  DifferentHoldingQuantity = 'DIFFERENT_HOLDING_QUANTITY',
  PendingCashDifference = 'PENDING_CASH_DIFFERENCE',
  PendingHoldingQuantityDifference = 'PENDING_HOLDING_QUANTITY_DIFFERENCE'
}

export type AccountReconciliationSnapshot = {
  __typename?: 'AccountReconciliationSnapshot';
  account: Account;
  breakValueCents?: Maybe<Scalars['Float']['output']>;
  custodianUpdatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  date: Scalars['GraphQLDate']['output'];
  flags: Array<AccountReconciliationSnapshotFlag>;
  holdings: Array<AccountReconciliationSnapshotHolding>;
  id: Scalars['ObjectID']['output'];
  /** @deprecated Use status. */
  isFlagged?: Maybe<Scalars['Boolean']['output']>;
  oneVestUpdatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  status: AccountReconciliationSnapshotStatus;
};

export type AccountReconciliationSnapshotFlag = {
  __typename?: 'AccountReconciliationSnapshotFlag';
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['Object']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  state: AccountReconciliationFlagStates;
  type: AccountReconciliationFlagTypes;
};

export type AccountReconciliationSnapshotHolding = {
  __typename?: 'AccountReconciliationSnapshotHolding';
  currency: Currencies;
  custodianBookValueCents?: Maybe<Scalars['Float']['output']>;
  custodianEodPriceCents?: Maybe<Scalars['Float']['output']>;
  custodianQuantity?: Maybe<Scalars['Float']['output']>;
  custodianValueCents?: Maybe<Scalars['Float']['output']>;
  financialProduct: FinancialProduct;
  isCash: Scalars['Boolean']['output'];
  oneVestBookValueCents?: Maybe<Scalars['Float']['output']>;
  oneVestEodPriceCents?: Maybe<Scalars['Float']['output']>;
  oneVestPendingQuantity?: Maybe<Scalars['Float']['output']>;
  oneVestPendingValueCents?: Maybe<Scalars['Float']['output']>;
  oneVestQuantity?: Maybe<Scalars['Float']['output']>;
  oneVestValueCents?: Maybe<Scalars['Float']['output']>;
};

export type AccountReconciliationSnapshotQueryFilter = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  endDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  flagTypes?: InputMaybe<Array<InputMaybe<AccountReconciliationFlagTypes>>>;
  /** @deprecated Use status. */
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  status?: InputMaybe<AccountReconciliationSnapshotStatus>;
};

export enum AccountReconciliationSnapshotStatus {
  AwaitingData = 'AWAITING_DATA',
  Flagged = 'FLAGGED',
  TiedOut = 'TIED_OUT'
}

export type AccountSearchInput = {
  filter?: InputMaybe<AccountFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type AccountSearchResult = {
  __typename?: 'AccountSearchResult';
  accounts: Array<Account>;
  totalCount: Scalars['Int']['output'];
};

/**
 * Account-index fields available for scoping the 'query' search. Values are
 * the physical OpenSearch field names.
 */
export enum AccountSearchableField {
  AccountTypeEn = 'accountTypeEn',
  AccountTypeEs = 'accountTypeEs',
  AccountTypeFr = 'accountTypeFr',
  CustodianAccountNumber = 'custodianAccountNumber',
  HouseholdAccountGroupId = 'householdAccountGroupId',
  HouseholdClientGroupId = 'householdClientGroupId',
  Id = 'id',
  OrganizationAccountGroupId = 'organizationAccountGroupId',
  UserAccountGroupId = 'userAccountGroupId',
  UserEntityName = 'userEntityName',
  UserFirstName = 'userFirstName',
  UserId = 'userId',
  UserLastName = 'userLastName',
  UserMiddleName = 'userMiddleName',
  UserPrimaryEmail = 'userPrimaryEmail'
}

export type AccountStateMachineChanges = {
  __typename?: 'AccountStateMachineChanges';
  createdAt: Scalars['GraphQLDateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type AccountStatement = {
  __typename?: 'AccountStatement';
  account?: Maybe<Account>;
  /** OrganizationUser is the author of the AccountStatement */
  creator?: Maybe<PublicOrganizationUser>;
  /** Organization of the AccountStatement creator */
  creatorOrganization?: Maybe<PublicOrganization>;
  fileName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  /** A media type (also known as MIME type) according to RFC6838, ie. "image/png" */
  mediaType?: Maybe<Scalars['String']['output']>;
  referenceDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  s3Key: Scalars['String']['output'];
  /** @deprecated Use Query.fetchAccountStatementDocument instead */
  signedUrl?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<StatementSourceType>;
  state: AccountStatementStates;
  stringId: Scalars['String']['output'];
  taxYear?: Maybe<Scalars['Int']['output']>;
  translatedFileName?: Maybe<StatementTranslatedString>;
  type: StatementTypes;
  user?: Maybe<User>;
};

export type AccountStatementAccount = {
  __typename?: 'AccountStatementAccount';
  accountId: Scalars['String']['output'];
  custodianAccountNumber: Scalars['String']['output'];
};

export enum AccountStatementObjectTypes {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  ClientGroup = 'CLIENT_GROUP',
  User = 'USER'
}

/** AccountStatement states */
export enum AccountStatementStates {
  AwaitingReview = 'AWAITING_REVIEW',
  Failed = 'FAILED',
  Reconciled = 'RECONCILED'
}

export enum AccountStatementTransition {
  Fail = 'fail',
  Reconcile = 'reconcile'
}

export enum AccountStates {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Frozen = 'FROZEN',
  Inactive = 'INACTIVE',
  Initiated = 'INITIATED',
  Ready = 'READY',
  Requested = 'REQUESTED'
}

export enum AccountTransition {
  Activate = 'activate',
  Cancel = 'cancel',
  Fail = 'fail',
  Freeze = 'freeze',
  Ready = 'ready',
  Request = 'request'
}

export type AccountTranslatedString = {
  __typename?: 'AccountTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type AccountTranslatedStringInput = {
  en?: InputMaybe<Scalars['SafeString']['input']>;
  es?: InputMaybe<Scalars['SafeString']['input']>;
  fr?: InputMaybe<Scalars['SafeString']['input']>;
};

export type AccountType = {
  __typename?: 'AccountType';
  translatedDescription?: Maybe<AccountTranslatedString>;
  translatedName: AccountTranslatedString;
  value: Scalars['String']['output'];
};

export type AccountTypeSettings = {
  __typename?: 'AccountTypeSettings';
  affiliateSettings?: Maybe<Array<Maybe<CustodianConnectionAffiliateSettings>>>;
  availableCurrencies: Array<Maybe<CustodianConnectionCurrencyTypes>>;
  baseCurrency: CustodianConnectionCurrencyTypes;
  id: Scalars['ObjectID']['output'];
  isAutoSweepEnabled: Scalars['Boolean']['output'];
  isMultiCurrencyEnabled: Scalars['Boolean']['output'];
  type: CustodianConnectionAccountTypes;
};

export type AccountTypeSettingsInput = {
  affiliateSettings?: InputMaybe<Array<InputMaybe<AffiliateSettingsInput>>>;
  availableCurrencies?: InputMaybe<Array<InputMaybe<CustodianConnectionCurrencyTypes>>>;
  baseCurrency?: InputMaybe<CustodianConnectionCurrencyTypes>;
  isAutoSweepEnabled: Scalars['Boolean']['input'];
  isMultiCurrencyEnabled: Scalars['Boolean']['input'];
  type: CustodianConnectionAccountTypes;
};

export type AccountTypeTaxRank = {
  __typename?: 'AccountTypeTaxRank';
  accountType: TaxRankAccountTypes;
  id: Scalars['ObjectID']['output'];
  taxRank: Scalars['Int']['output'];
};

export type AccountTypeTaxRankInput = {
  accountType?: InputMaybe<TaxRankAccountTypes>;
  taxRank?: InputMaybe<Scalars['Int']['input']>;
};

export enum AccountTypes {
  CashJoint = 'CASH_JOINT',
  CorporateCash = 'CORPORATE_CASH',
  CorporateCharity = 'CORPORATE_CHARITY',
  CorporateEstate = 'CORPORATE_ESTATE',
  CorporateTrust = 'CORPORATE_TRUST',
  Dbpp = 'DBPP',
  Dpsp = 'DPSP',
  External = 'EXTERNAL',
  Fhsa = 'FHSA',
  Grsp = 'GRSP',
  GrspSpousal = 'GRSP_SPOUSAL',
  InformalTrust = 'INFORMAL_TRUST',
  InformalTrustJoint = 'INFORMAL_TRUST_JOINT',
  Investment = 'INVESTMENT',
  Ipp = 'IPP',
  Lif = 'LIF',
  Lira = 'LIRA',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  Margin = 'MARGIN',
  MarginJoint = 'MARGIN_JOINT',
  PensionPlan = 'PENSION_PLAN',
  Personal = 'PERSONAL',
  Prif = 'PRIF',
  Rdsp = 'RDSP',
  RdspJoint = 'RDSP_JOINT',
  Resp = 'RESP',
  RespAdult = 'RESP_ADULT',
  RespFamily = 'RESP_FAMILY',
  RespFamilyJoint = 'RESP_FAMILY_JOINT',
  RespSingle = 'RESP_SINGLE',
  RespSingleJoint = 'RESP_SINGLE_JOINT',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  Rlsp = 'RLSP',
  Rpp = 'RPP',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  Tfsa = 'TFSA',
  UkBrokerage = 'UK_BROKERAGE',
  UkCashIsa = 'UK_CASH_ISA',
  UkJisa = 'UK_JISA',
  UkPersonalPension = 'UK_PERSONAL_PENSION',
  UkSsIsa = 'UK_SS_ISA',
  Usa_401K = 'USA_401K',
  Usa_529 = 'USA_529',
  UsaBrokerage = 'USA_BROKERAGE',
  UsaCorporate = 'USA_CORPORATE',
  UsaCra = 'USA_CRA',
  UsaCustodial = 'USA_CUSTODIAL',
  UsaDaf = 'USA_DAF',
  UsaDbp = 'USA_DBP',
  UsaEsa = 'USA_ESA',
  UsaEstate = 'USA_ESTATE',
  UsaInhIra = 'USA_INH_IRA',
  UsaInhRtIra = 'USA_INH_RT_IRA',
  UsaIra = 'USA_IRA',
  UsaIraCustodial = 'USA_IRA_CUSTODIAL',
  UsaJtCp = 'USA_JT_CP',
  UsaJtCpMargin = 'USA_JT_CP_MARGIN',
  UsaJtJtbe = 'USA_JT_JTBE',
  UsaJtJtbeMargin = 'USA_JT_JTBE_MARGIN',
  UsaJtTic = 'USA_JT_TIC',
  UsaJtTicMargin = 'USA_JT_TIC_MARGIN',
  UsaJtWros = 'USA_JT_WROS',
  UsaJtWrosMargin = 'USA_JT_WROS_MARGIN',
  UsaKeogh = 'USA_KEOGH',
  UsaMargin = 'USA_MARGIN',
  UsaRoIra = 'USA_RO_IRA',
  UsaRtIra = 'USA_RT_IRA',
  UsaSepIra = 'USA_SEP_IRA',
  UsaSimpleIra = 'USA_SIMPLE_IRA',
  UsaSolo_401K = 'USA_SOLO_401K',
  UsaTod = 'USA_TOD',
  UsaTrust = 'USA_TRUST'
}

export enum AccountTypesFilters {
  CashJoint = 'CASH_JOINT',
  CorporateCash = 'CORPORATE_CASH',
  CorporateCharity = 'CORPORATE_CHARITY',
  CorporateEstate = 'CORPORATE_ESTATE',
  CorporateTrust = 'CORPORATE_TRUST',
  Dbpp = 'DBPP',
  Dpsp = 'DPSP',
  External = 'EXTERNAL',
  Fhsa = 'FHSA',
  Grsp = 'GRSP',
  GrspSpousal = 'GRSP_SPOUSAL',
  InformalTrust = 'INFORMAL_TRUST',
  InformalTrustJoint = 'INFORMAL_TRUST_JOINT',
  Investment = 'INVESTMENT',
  Ipp = 'IPP',
  Lif = 'LIF',
  Lira = 'LIRA',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  Margin = 'MARGIN',
  MarginJoint = 'MARGIN_JOINT',
  PensionPlan = 'PENSION_PLAN',
  Personal = 'PERSONAL',
  Prif = 'PRIF',
  Rdsp = 'RDSP',
  RdspJoint = 'RDSP_JOINT',
  Resp = 'RESP',
  RespAdult = 'RESP_ADULT',
  RespFamily = 'RESP_FAMILY',
  RespFamilyJoint = 'RESP_FAMILY_JOINT',
  RespSingle = 'RESP_SINGLE',
  RespSingleJoint = 'RESP_SINGLE_JOINT',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  Rlsp = 'RLSP',
  Rpp = 'RPP',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  Tfsa = 'TFSA',
  UkBrokerage = 'UK_BROKERAGE',
  UkCashIsa = 'UK_CASH_ISA',
  UkJisa = 'UK_JISA',
  UkPersonalPension = 'UK_PERSONAL_PENSION',
  UkSsIsa = 'UK_SS_ISA',
  Usa_401K = 'USA_401K',
  Usa_529 = 'USA_529',
  UsaBrokerage = 'USA_BROKERAGE',
  UsaCorporate = 'USA_CORPORATE',
  UsaCra = 'USA_CRA',
  UsaCustodial = 'USA_CUSTODIAL',
  UsaDaf = 'USA_DAF',
  UsaDbp = 'USA_DBP',
  UsaEsa = 'USA_ESA',
  UsaEstate = 'USA_ESTATE',
  UsaInhIra = 'USA_INH_IRA',
  UsaInhRtIra = 'USA_INH_RT_IRA',
  UsaIra = 'USA_IRA',
  UsaIraCustodial = 'USA_IRA_CUSTODIAL',
  UsaJtCp = 'USA_JT_CP',
  UsaJtCpMargin = 'USA_JT_CP_MARGIN',
  UsaJtJtbe = 'USA_JT_JTBE',
  UsaJtJtbeMargin = 'USA_JT_JTBE_MARGIN',
  UsaJtTic = 'USA_JT_TIC',
  UsaJtTicMargin = 'USA_JT_TIC_MARGIN',
  UsaJtWros = 'USA_JT_WROS',
  UsaJtWrosMargin = 'USA_JT_WROS_MARGIN',
  UsaKeogh = 'USA_KEOGH',
  UsaMargin = 'USA_MARGIN',
  UsaRoIra = 'USA_RO_IRA',
  UsaRtIra = 'USA_RT_IRA',
  UsaSepIra = 'USA_SEP_IRA',
  UsaSimpleIra = 'USA_SIMPLE_IRA',
  UsaSolo_401K = 'USA_SOLO_401K',
  UsaTod = 'USA_TOD',
  UsaTrust = 'USA_TRUST'
}

export type AccountUpsertAffiliationInput = {
  allocation?: InputMaybe<Scalars['Float']['input']>;
  relatedAffiliations?: InputMaybe<Array<AccountUpsertRelatedAffiliationInput>>;
  relation: AffiliationRelations;
  roleId?: InputMaybe<Scalars['SafeString']['input']>;
  signatureRequired?: InputMaybe<Scalars['Boolean']['input']>;
  type: AffiliationTypes;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type AccountUpsertIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type AccountUpsertRelatedAffiliationInput = {
  relation: AffiliationRelations;
  type: AffiliationTypes;
  userId: Scalars['SafeString']['input'];
};

/** @deprecated(reason: "Not used anymore.") */
export type AccountsDaily = {
  __typename?: 'AccountsDaily';
  account: Account;
  date: Scalars['GraphQLDateTime']['output'];
  holdings: Array<Holding>;
  id: Scalars['ObjectID']['output'];
  marketValueCents: Scalars['Long']['output'];
  matchingCustodianDaily?: Maybe<CustodianAccountsDaily>;
  moneyAvailableCents: Scalars['Long']['output'];
  netContributionCents: Scalars['Long']['output'];
  newContributionCents: Scalars['Long']['output'];
};

export type AccountsPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type AccountsQueryFilter = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountIds?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  clientGroupId?: InputMaybe<Scalars['String']['input']>;
  custodianAccountNumbers?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  includeHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  isUngrouped?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  sourceType?: InputMaybe<SourceTypesFilter>;
  states?: InputMaybe<Array<AccountStates>>;
  type?: InputMaybe<AccountTypes>;
  updatedAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  updatedAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type AccountsTaxRanksInput = {
  accountId: Scalars['ObjectID']['input'];
  overrideTaxRank?: InputMaybe<Scalars['Int']['input']>;
};

export type ActionButton = {
  __typename?: 'ActionButton';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ActionButtonInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddAffiliationInput = {
  accountId: Scalars['ObjectID']['input'];
  allocation?: InputMaybe<Scalars['Float']['input']>;
  relatedAffiliations?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  relation: AffiliationRelations;
  requestIpAddress?: InputMaybe<Scalars['String']['input']>;
  signatureRequired?: InputMaybe<Scalars['Boolean']['input']>;
  type: AffiliationTypes;
  userId: Scalars['ObjectID']['input'];
};

export type AddAffiliationResponse = {
  __typename?: 'AddAffiliationResponse';
  account: Account;
  incompleteFields: Array<Maybe<Scalars['String']['output']>>;
};

export type AddEntityToOrganizationUserInput = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  entityId: Scalars['ObjectID']['input'];
  organizationUserId: Scalars['ObjectID']['input'];
  readOnly: Scalars['Boolean']['input'];
  relation?: InputMaybe<OrganizationUserEntityRelationTypes>;
  roleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type AddEntityToOrganizationUserResponse = {
  __typename?: 'AddEntityToOrganizationUserResponse';
  organizationUser?: Maybe<OrganizationUser>;
};

export type AddImportFileInput = {
  bulkImportId: Scalars['ObjectID']['input'];
  fileName: Scalars['SafeString']['input'];
  s3Path?: InputMaybe<Scalars['SafeString']['input']>;
  timestamp?: InputMaybe<Scalars['Long']['input']>;
  type: ImportFileTypes;
};

export type AddImportFileResponse = {
  __typename?: 'AddImportFileResponse';
  importFile?: Maybe<ImportFile>;
};

export type AdditionalSortFieldInput = {
  sortDesc: Scalars['Boolean']['input'];
  sortField: Scalars['String']['input'];
};

/** Countries */
export enum AddressCountries {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

/**
 * Full address details
 * Normalized fields (used by both Google and Canada Post)
 * + Canada Post validation-only fields (no duplication)
 */
export type AddressDetails = {
  __typename?: 'AddressDetails';
  /** Country code ISO 3166-1 alpha-2 (Canada Post validation only, e.g. "CA") */
  CountryIso2?: Maybe<Scalars['String']['output']>;
  /** Country code ISO 3166-1 alpha-3 (Canada Post validation only, e.g. "CAN") */
  CountryIso3?: Maybe<Scalars['String']['output']>;
  /** Country full name (Canada Post validation only, e.g. "Canada") */
  CountryName?: Maybe<Scalars['String']['output']>;
  /** Province/State full name (Canada Post validation only, e.g. "Ontario") */
  Province?: Maybe<Scalars['String']['output']>;
  /** Province/State code (Canada Post validation only, e.g. "ON") */
  ProvinceCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** Country code ISO 3166-1 alpha-2 (Canada Post validation only, e.g. "CA") */
  country?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  /** Jurisdiction e.g. CA_ON, US_CA */
  jurisdiction?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

/** Jurisdictions for User's physical address */
export enum AddressJurisdiction {
  CaAb = 'CA_AB',
  CaBc = 'CA_BC',
  CaMb = 'CA_MB',
  CaNb = 'CA_NB',
  CaNl = 'CA_NL',
  CaNs = 'CA_NS',
  CaNt = 'CA_NT',
  CaNu = 'CA_NU',
  CaOn = 'CA_ON',
  CaPe = 'CA_PE',
  CaQc = 'CA_QC',
  CaSk = 'CA_SK',
  CaYt = 'CA_YT',
  GbEng = 'GB_ENG',
  GbNir = 'GB_NIR',
  GbSct = 'GB_SCT',
  UsAk = 'US_AK',
  UsAl = 'US_AL',
  UsAr = 'US_AR',
  UsAs = 'US_AS',
  UsAz = 'US_AZ',
  UsCa = 'US_CA',
  UsCo = 'US_CO',
  UsCt = 'US_CT',
  UsDc = 'US_DC',
  UsDe = 'US_DE',
  UsFl = 'US_FL',
  UsGa = 'US_GA',
  UsGu = 'US_GU',
  UsHi = 'US_HI',
  UsIa = 'US_IA',
  UsId = 'US_ID',
  UsIl = 'US_IL',
  UsIn = 'US_IN',
  UsKs = 'US_KS',
  UsKy = 'US_KY',
  UsLa = 'US_LA',
  UsMa = 'US_MA',
  UsMd = 'US_MD',
  UsMe = 'US_ME',
  UsMi = 'US_MI',
  UsMn = 'US_MN',
  UsMo = 'US_MO',
  UsMp = 'US_MP',
  UsMs = 'US_MS',
  UsMt = 'US_MT',
  UsNc = 'US_NC',
  UsNd = 'US_ND',
  UsNe = 'US_NE',
  UsNh = 'US_NH',
  UsNj = 'US_NJ',
  UsNm = 'US_NM',
  UsNv = 'US_NV',
  UsNy = 'US_NY',
  UsOh = 'US_OH',
  UsOk = 'US_OK',
  UsOr = 'US_OR',
  UsPa = 'US_PA',
  UsPr = 'US_PR',
  UsRi = 'US_RI',
  UsSc = 'US_SC',
  UsSd = 'US_SD',
  UsTn = 'US_TN',
  UsTx = 'US_TX',
  UsUm = 'US_UM',
  UsUt = 'US_UT',
  UsVa = 'US_VA',
  UsVi = 'US_VI',
  UsVt = 'US_VT',
  UsWa = 'US_WA',
  UsWi = 'US_WI',
  UsWv = 'US_WV',
  UsWy = 'US_WY'
}

/** Provinces for User's physical address (deprecated; use Jurisdictions) */
export enum AddressProvince {
  Ab = 'AB',
  Bc = 'BC',
  Foreign = 'FOREIGN',
  Mb = 'MB',
  Nb = 'NB',
  Nl = 'NL',
  Ns = 'NS',
  Nt = 'NT',
  Nu = 'NU',
  On = 'ON',
  Pe = 'PE',
  Qc = 'QC',
  Sk = 'SK',
  Yt = 'YT'
}

/**
 * Address suggestion result
 * Supports both Google and Canada Post providers
 */
export type AddressSuggestion = {
  __typename?: 'AddressSuggestion';
  /** Cursor position for navigation - Canada Post only (undefined for Google) */
  cursor?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Highlighted portion of text for matching - Canada Post only (undefined for Google) */
  highlight?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the suggestion (place_id for Google, Id for Canada Post) */
  id: Scalars['String']['output'];
  /**
   * Next action - Canada Post only (undefined for Google)
   * Values: "Find" = drill-down needed, "Retrieve" = call fetchPhysicalAddress
   */
  next?: Maybe<Scalars['String']['output']>;
  /** Full address string */
  text: Scalars['String']['output'];
};

export type AdjustmentTransferResponse = {
  __typename?: 'AdjustmentTransferResponse';
  transfer: Transfer;
};

export type AdvisorContact = {
  __typename?: 'AdvisorContact';
  address?: Maybe<AdvisorContactAddress>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  departedUser?: Maybe<PublicOrganizationUser>;
  designatedFor: Array<RepCode>;
  displayRole?: Maybe<DisplayRole>;
  /**
   * The designated codes still in effect for this row in the admin list. On an inherited
   * row whose codes a closer org partially overrides, this is the not-yet-covered subset;
   * otherwise it equals designatedFor.
   */
  effectiveDesignatedFor: Array<RepCode>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  isInherited?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkStatus: AdvisorContactLinkStatuses;
  linkedUser?: Maybe<PublicOrganizationUser>;
  organization: PublicOrganization;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExtension?: Maybe<Scalars['String']['output']>;
  state: AdvisorContactStates;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type AdvisorContactAddress = {
  __typename?: 'AdvisorContactAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type AdvisorContactAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  postal?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  unitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AdvisorContactDesignationPreviousHolder = {
  __typename?: 'AdvisorContactDesignationPreviousHolder';
  advisorContact: AdvisorContact;
  codes: Array<Scalars['String']['output']>;
};

export type AdvisorContactImportRowInput = {
  line: Scalars['Int']['input'];
  values: Scalars['JSON']['input'];
};

export type AdvisorContactImportRowResult = {
  __typename?: 'AdvisorContactImportRowResult';
  advisorContact?: Maybe<AdvisorContact>;
  errors: Array<Scalars['String']['output']>;
  line: Scalars['Int']['output'];
  matchedBy: AdvisorContactMatchKeys;
  status: AdvisorContactImportStatuses;
  warnings: Array<Scalars['String']['output']>;
};

export enum AdvisorContactImportStatuses {
  Created = 'CREATED',
  Failed = 'FAILED',
  Updated = 'UPDATED'
}

export enum AdvisorContactLinkStatuses {
  Broken = 'BROKEN',
  Linked = 'LINKED',
  Unlinked = 'UNLINKED'
}

export enum AdvisorContactMatchKeys {
  Email = 'EMAIL',
  LinkedUser = 'LINKED_USER',
  Name = 'NAME',
  None = 'NONE'
}

export type AdvisorContactPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  pinBrokenLinks?: InputMaybe<Scalars['Boolean']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type AdvisorContactQueryFilter = {
  displayRoleId?: InputMaybe<Scalars['ObjectID']['input']>;
  linkStatus?: InputMaybe<Array<AdvisorContactLinkStatuses>>;
  linkedUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  repCode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<InputMaybe<AdvisorContactStates>>>;
};

export enum AdvisorContactStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum AdvisorContactTransitions {
  Archive = 'archive'
}

export type AffiliateSettingsInput = {
  affiliateType?: InputMaybe<CustodianConnectionAffiliationTypes>;
  description?: InputMaybe<Scalars['String']['input']>;
  optionalFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requiredFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Affiliation = {
  __typename?: 'Affiliation';
  allocation?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ObjectID']['output'];
  invitationStatus?: Maybe<InvitationStatus>;
  relatedAffiliations?: Maybe<Array<Maybe<Scalars['ObjectID']['output']>>>;
  relation: AffiliationRelations;
  roleId?: Maybe<Scalars['ObjectID']['output']>;
  signatureRequired?: Maybe<Scalars['Boolean']['output']>;
  type: AffiliationTypes;
  user: User;
};

export type AffiliationInput = {
  allocation?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  invitationStatus?: InputMaybe<InvitationStatus>;
  relatedAffiliations?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  relation: AffiliationRelations;
  roleId?: InputMaybe<Scalars['ObjectID']['input']>;
  signatureRequired?: InputMaybe<Scalars['Boolean']['input']>;
  type: AffiliationTypes;
  userId: Scalars['ObjectID']['input'];
};

export enum AffiliationRelations {
  Child = 'CHILD',
  CommonLaw = 'COMMON_LAW',
  Grandchild = 'GRANDCHILD',
  Grandparent = 'GRANDPARENT',
  Guardian = 'GUARDIAN',
  NephewNiece = 'NEPHEW_NIECE',
  Other = 'OTHER',
  Parent = 'PARENT',
  PrimaryCaregiver = 'PRIMARY_CAREGIVER',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE'
}

export enum AffiliationTypes {
  AuthorizedIndividual = 'AUTHORIZED_INDIVIDUAL',
  BeneficialOwner = 'BENEFICIAL_OWNER',
  ContingentBeneficiary = 'CONTINGENT_BENEFICIARY',
  Contributor = 'CONTRIBUTOR',
  Decedent = 'DECEDENT',
  Director = 'DIRECTOR',
  Grantor = 'GRANTOR',
  Guardian = 'GUARDIAN',
  Joint = 'JOINT',
  Other = 'OTHER',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  PrimaryBeneficiary = 'PRIMARY_BENEFICIARY',
  PrimaryCaregiver = 'PRIMARY_CAREGIVER',
  Protector = 'PROTECTOR',
  SeniorOfficer = 'SENIOR_OFFICER',
  Settlor = 'SETTLOR',
  Successor = 'SUCCESSOR',
  ThirdParty = 'THIRD_PARTY',
  Trustee = 'TRUSTEE'
}

export type AlertBanner = {
  __typename?: 'AlertBanner';
  actionButton?: Maybe<ActionButton>;
  bannerCopy?: Maybe<OrganizationTranslatedString>;
  bannerType?: Maybe<BannerType>;
  configuration: AlertConfiguration;
  createdAt: Scalars['GraphQLDateTime']['output'];
  endDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization: PublicOrganization;
  persistenceBehaviour: PersistenceBehaviour;
  roleProfiles: Array<PublicRoleProfile>;
  startDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  state: AlertState;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type AlertBannerInteraction = {
  __typename?: 'AlertBannerInteraction';
  actionedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  alertBanner: AlertBanner;
  bannerEndDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  dismissedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  firstSeenAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  lastShownAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  organization: PublicOrganization;
  organizationUser: PublicOrganizationUser;
  sessionId: Scalars['String']['output'];
  state: BannerInteractionState;
};

export enum AlertBannerInteractionTransitions {
  Action = 'action',
  Dismiss = 'dismiss'
}

export type AlertBannerPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export enum AlertBannerPlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type AlertBannerQueryFilter = {
  organization?: InputMaybe<Scalars['ObjectID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<AlertStatus>>>;
};

export enum AlertBannerTransitions {
  Publish = 'publish',
  Unpublish = 'unpublish'
}

export type AlertConfiguration = {
  __typename?: 'AlertConfiguration';
  displayOnAndroid: Scalars['Boolean']['output'];
  displayOnIOS: Scalars['Boolean']['output'];
  displayOnWeb: Scalars['Boolean']['output'];
  enableAction: Scalars['Boolean']['output'];
  makeDismissible: Scalars['Boolean']['output'];
};

export type AlertConfigurationInput = {
  displayOnAndroid?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnIOS?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnWeb?: InputMaybe<Scalars['Boolean']['input']>;
  enableAction?: InputMaybe<Scalars['Boolean']['input']>;
  makeDismissible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlertReportPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type AlertReportQueryFilter = {
  createdAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<ReportStates>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  transferId?: InputMaybe<Scalars['ObjectID']['input']>;
  transferType?: InputMaybe<TransferTypes>;
};

export enum AlertState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum AlertStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Scheduled = 'SCHEDULED'
}

export type AllocationFile = {
  __typename?: 'AllocationFile';
  requestType: AllocationFileRequestTypes;
  type: AllocationFileTypes;
  url: Scalars['String']['output'];
};

export type AllocationFileInput = {
  key: Scalars['String']['input'];
  requestType: AllocationFileRequestTypes;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  type: AllocationFileTypes;
};

export enum AllocationFileRequestTypes {
  All = 'ALL',
  Buy = 'BUY',
  Sell = 'SELL'
}

export enum AllocationFileTypes {
  All = 'ALL',
  MutualFund = 'MUTUAL_FUND',
  Ptf = 'PTF',
  Securities = 'SECURITIES'
}

export enum AllocationMethodologies {
  Customized = 'CUSTOMIZED',
  Unified = 'UNIFIED'
}

/** Loose worldwide physical address (ie. client's alternate address) */
export type AlternatePhysicalAddress = {
  __typename?: 'AlternatePhysicalAddress';
  /** City/Town/Settlement name */
  city?: Maybe<Scalars['String']['output']>;
  /** Name of country using two-letter country code format (ISO 3166-1 alpha-2). Required for address validation, tax residency determination, and regulatory compliance. */
  country: AddressCountries;
  /** Jurisdiction (This can be a province, state, territory, of any country - potentially a country that we do not yet support) */
  jurisdiction?: Maybe<Scalars['String']['output']>;
  /** 1st line of address */
  line1?: Maybe<Scalars['String']['output']>;
  /** 2nd line of address */
  line2?: Maybe<Scalars['String']['output']>;
  /** Postal code string input. */
  postal?: Maybe<Scalars['String']['output']>;
};

/** An optional input that describes User's other addresses that are not the physical address. */
export type AlternatePhysicalAddressInput = {
  /** Can input name of city, town, or settlement.  */
  city?: InputMaybe<Scalars['SafeString']['input']>;
  /** Name of country using two-letter country code format (ISO 3166-1 alpha-2). Required for address validation, tax residency determination, and regulatory compliance. */
  country: AddressCountries;
  /** Prepended with ISO-3166 country codes for applicable countries. String input for state, province, or territory name.  */
  jurisdiction?: InputMaybe<Scalars['SafeString']['input']>;
  /** First address line. For example, a string input for street name, street number, or PO box.  */
  line1: Scalars['SafeString']['input'];
  /** Optional. Second address line. For example, a unit number.  */
  line2?: InputMaybe<Scalars['SafeString']['input']>;
  /** Postal code string input.  */
  postal?: InputMaybe<Scalars['SafeString']['input']>;
};

/** Scheduled Income Fund Transfer ammount payable types. */
export enum AmountPayableType {
  Gross = 'GROSS',
  Net = 'NET'
}

/** A role field pointing at a configuration document owned by a strict ancestor organization. */
export type AncestorInheritedAssignment = {
  __typename?: 'AncestorInheritedAssignment';
  assignmentField: Scalars['String']['output'];
  objectId: Scalars['ObjectID']['output'];
  objectName: Scalars['String']['output'];
  objectOrganizationId: Scalars['ObjectID']['output'];
  objectOrganizationName: Scalars['String']['output'];
  roleId: Scalars['ObjectID']['output'];
  roleName: Scalars['String']['output'];
  roleOrganizationId: Scalars['ObjectID']['output'];
  roleOrganizationName: Scalars['String']['output'];
};

/** Category of configuration object assigned on a role (extensible for new audits). */
export enum AncestorInheritedObjectType {
  PageConfiguration = 'PAGE_CONFIGURATION',
  Workflow = 'WORKFLOW'
}

export type AnnualSuitabilityCompletedResponse = {
  __typename?: 'AnnualSuitabilityCompletedResponse';
  user?: Maybe<User>;
};

export enum ApiExportFormatters {
  Date = 'DATE',
  DivideBy_100 = 'DIVIDE_BY_100',
  MultiplyBy_100 = 'MULTIPLY_BY_100'
}

export type ApiToken = {
  __typename?: 'ApiToken';
  id: Scalars['ObjectID']['output'];
  jwtToken: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: PublicOrganization;
  organizationUser: PublicOrganizationUser;
  permissions: Array<Scalars['String']['output']>;
  state: ApiTokenStates;
  whitelistAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ApiTokenStates {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum ApiTokenTransitions {
  Deactivate = 'deactivate'
}

export enum ApplyForGovFunds {
  AdditionalCesg = 'ADDITIONAL_CESG',
  BasicCesg = 'BASIC_CESG',
  Bctesg = 'BCTESG',
  Cdsgb = 'CDSGB',
  Clb = 'CLB',
  Qesi = 'QESI'
}

export type ArchiveEntityBoundModelInput = {
  /** The id of the bound entity (e.g. the household ClientGroup id). */
  boundObjectId: Scalars['ObjectID']['input'];
  /** The kind of entity whose live bound clone should be archived (HOUSEHOLD in v1). */
  boundObjectType: BoundObjectType;
  /**
   * The organization that owns the bound entity (e.g. the household's
   * organization id. The clone is minted/reused in this org.
   * The shelf master is still resolved via org inheritance. Must be
   * the caller's organization or one below it in the hierarchy.
   */
  organizationId: Scalars['ObjectID']['input'];
};

export type ArchiveEntityBoundModelResponse = {
  __typename?: 'ArchiveEntityBoundModelResponse';
  /** Whether a live bound clone was archived (false when none existed). */
  archived: Scalars['Boolean']['output'];
  /** The archived clone, when archived is true. */
  modelPortfolio?: Maybe<FinancialProduct>;
};

export type ArchiveFormCompletionInput = {
  formCompletionId: Scalars['ObjectID']['input'];
};

export type ArchiveFormCompletionResponse = {
  __typename?: 'ArchiveFormCompletionResponse';
  formCompletion: FormCompletion;
};

export type ArchiveGoalInput = {
  goalId: Scalars['ObjectID']['input'];
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
};

export type ArchiveGoalResponse = {
  __typename?: 'ArchiveGoalResponse';
  goal: Goal;
};

export type Article = {
  __typename?: 'Article';
  articleUrl?: Maybe<Scalars['URLString']['output']>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  createdBy?: Maybe<PublicOrganizationUser>;
  id: Scalars['ObjectID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<PublicOrganization>;
  state?: Maybe<ArticleStates>;
  translatedDescription?: Maybe<OrganizationTranslatedString>;
  translatedName: OrganizationTranslatedString;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /**
   * Roles this article is shown to. Empty means every role in the organization.
   * Readable only with write:news_and_insights.
   */
  visibleToRoleIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
};

export type ArticlePaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleQueryFilter = {
  createdAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /**
   * Return articles targeted to any role, not only the viewer's.
   * Ignored without write:news_and_insights.
   */
  ignoreRoleTargeting?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ArticleStates>;
  updatedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export enum ArticleStates {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export enum ArticleTransition {
  Activate = 'activate',
  Deactivate = 'deactivate',
  Review = 'review'
}

export type AssetClass = {
  __typename?: 'AssetClass';
  description: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  includeCash: Scalars['Boolean']['output'];
  integrations?: Maybe<Array<Maybe<AssetClassIntegration>>>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  riskLevel?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<AssetClassState>;
  /** Asset Class's ID returned as string. It can either be the OneVest ID or an External ID from a Passthrough API. */
  stringId: Scalars['String']['output'];
  translatedDescription: ProductTranslatedString;
  translatedName: ProductTranslatedString;
};

export type AssetClassBranch = {
  __typename?: 'AssetClassBranch';
  /** The asset class associated with the branch */
  assetClass: AssetClass;
  /** Unique identifier for the asset class branch */
  id: Scalars['ObjectID']['output'];
  /** The target percentage for the asset class branch */
  targetPercentage: Scalars['Float']['output'];
};

export type AssetClassBranchInput = {
  /** The asset class ID this branch refers to */
  assetClassId: Scalars['ObjectID']['input'];
  /** The percentage allocated to this asset class (0-100) */
  targetPercentage: Scalars['Float']['input'];
};

export type AssetClassFilterQuery = {
  assetClassIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

/** The integration enum and unique integration id  */
export type AssetClassIntegration = {
  __typename?: 'AssetClassIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<AssetClassIntegrationTypes>;
};

/** Input type for integrations field */
export type AssetClassIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<AssetClassIntegrationTypes>;
};

/** Integrations for AssetClass */
export enum AssetClassIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export enum AssetClassLevel {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export type AssetClassPaginationAndSorting = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export enum AssetClassState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum AssetClassTransitions {
  Activate = 'activate',
  Archive = 'archive'
}

/**
 * Per-financial-product assignment count, scoped to the caller's
 * organization. Counts sub-accounts at
 * PortfolioAssignmentLevels.SUB_ACCOUNT (i.e. the sub owns its own
 * portfolio) and goals that are not ARCHIVED. Sub-accounts at
 * PortfolioAssignmentLevels.GOAL or PortfolioAssignmentLevels.HOUSEHOLD
 * are intentionally excluded — their effective portfolio belongs to the
 * umbrella (goal or household ClientGroup) and is counted there (goal
 * arm; households deferred — see internal review notes).
 */
export type AssignedCountByFinancialProduct = {
  __typename?: 'AssignedCountByFinancialProduct';
  count: Scalars['Int']['output'];
  financialProductId: Scalars['ObjectID']['output'];
};

export enum AuthAudienceTypes {
  Client = 'CLIENT',
  Onehub = 'ONEHUB'
}

export enum AuthenticationConnections {
  EmailAndPassword = 'EMAIL_AND_PASSWORD',
  EmailOtp = 'EMAIL_OTP',
  Enterprise = 'ENTERPRISE'
}

export type AutoReconciliationTransactionType = {
  __typename?: 'AutoReconciliationTransactionType';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  transactionType: AutoReconciliationTransactionTypes;
};

export type AutoReconciliationTransactionTypeInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  transactionType?: InputMaybe<AutoReconciliationTransactionTypes>;
};

export enum AutoReconciliationTransactionTypes {
  Adj = 'ADJ'
}

export type BankAccount = {
  __typename?: 'BankAccount';
  EftEligibleRatio?: Maybe<Scalars['Float']['output']>;
  bankAccountHolderName?: Maybe<Scalars['String']['output']>;
  bankAccountNumber: Scalars['String']['output'];
  bankAccountNumberDisclosed?: Maybe<Scalars['String']['output']>;
  bankAccountTransitPhysicalAddress?: Maybe<BankAccountTransitPhysicalAddress>;
  bankAccountType?: Maybe<BankAccountTypes>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  currency?: Maybe<BankAccountCurrencyTypes>;
  downloadUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failReason?: Maybe<Scalars['String']['output']>;
  fieldMatchRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ObjectID']['output'];
  institutionNumber?: Maybe<Scalars['String']['output']>;
  integrations?: Maybe<Array<Maybe<BankAccountIntegration>>>;
  name?: Maybe<Scalars['String']['output']>;
  processorToken?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  source: BankAccountSources;
  state?: Maybe<BankAccountStates>;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Scalars['StateChanges']['output']>>;
  stateMachineChanges?: Maybe<Array<BankingStateMachineChanges>>;
  /** BankAccount's ID returned as string. It can either be the OneVest ID or an External ID from a Passthrough API. */
  stringId: Scalars['String']['output'];
  transitNumber?: Maybe<Scalars['String']['output']>;
  transitNumberDisclosed?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  user: User;
};

/** Countries */
export enum BankAccountAddressCountries {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

/** Jurisdictions for Bank Account physical address */
export enum BankAccountAddressJurisdiction {
  CaAb = 'CA_AB',
  CaBc = 'CA_BC',
  CaMb = 'CA_MB',
  CaNb = 'CA_NB',
  CaNl = 'CA_NL',
  CaNs = 'CA_NS',
  CaNt = 'CA_NT',
  CaNu = 'CA_NU',
  CaOn = 'CA_ON',
  CaPe = 'CA_PE',
  CaQc = 'CA_QC',
  CaSk = 'CA_SK',
  CaYt = 'CA_YT',
  GbEng = 'GB_ENG',
  GbNir = 'GB_NIR',
  GbSct = 'GB_SCT',
  UsAk = 'US_AK',
  UsAl = 'US_AL',
  UsAr = 'US_AR',
  UsAs = 'US_AS',
  UsAz = 'US_AZ',
  UsCa = 'US_CA',
  UsCo = 'US_CO',
  UsCt = 'US_CT',
  UsDc = 'US_DC',
  UsDe = 'US_DE',
  UsFl = 'US_FL',
  UsGa = 'US_GA',
  UsGu = 'US_GU',
  UsHi = 'US_HI',
  UsIa = 'US_IA',
  UsId = 'US_ID',
  UsIl = 'US_IL',
  UsIn = 'US_IN',
  UsKs = 'US_KS',
  UsKy = 'US_KY',
  UsLa = 'US_LA',
  UsMa = 'US_MA',
  UsMd = 'US_MD',
  UsMe = 'US_ME',
  UsMi = 'US_MI',
  UsMn = 'US_MN',
  UsMo = 'US_MO',
  UsMp = 'US_MP',
  UsMs = 'US_MS',
  UsMt = 'US_MT',
  UsNc = 'US_NC',
  UsNd = 'US_ND',
  UsNe = 'US_NE',
  UsNh = 'US_NH',
  UsNj = 'US_NJ',
  UsNm = 'US_NM',
  UsNv = 'US_NV',
  UsNy = 'US_NY',
  UsOh = 'US_OH',
  UsOk = 'US_OK',
  UsOr = 'US_OR',
  UsPa = 'US_PA',
  UsPr = 'US_PR',
  UsRi = 'US_RI',
  UsSc = 'US_SC',
  UsSd = 'US_SD',
  UsTn = 'US_TN',
  UsTx = 'US_TX',
  UsUm = 'US_UM',
  UsUt = 'US_UT',
  UsVa = 'US_VA',
  UsVi = 'US_VI',
  UsVt = 'US_VT',
  UsWa = 'US_WA',
  UsWi = 'US_WI',
  UsWv = 'US_WV',
  UsWy = 'US_WY'
}

export type BankAccountBulkUpsertItem = {
  __typename?: 'BankAccountBulkUpsertItem';
  batchId?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertIntegration?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertRequest?: Maybe<BulkUpsertRequest>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<BankAccountIntegration>>>;
  oneVestId?: Maybe<Scalars['ObjectID']['output']>;
  outputErrors?: Maybe<Array<Maybe<BankAccountBulkUpsertItemOutputError>>>;
  rawData?: Maybe<Scalars['Object']['output']>;
  state?: Maybe<BankAccountBulkUpsertItemStates>;
};

export type BankAccountBulkUpsertItemOutputError = {
  __typename?: 'BankAccountBulkUpsertItemOutputError';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
};

export type BankAccountBulkUpsertItemQueryFilter = {
  batchId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertIntegrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  oneVestId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<BankAccountBulkUpsertItemStates>;
};

export enum BankAccountBulkUpsertItemStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Queued = 'QUEUED'
}

export enum BankAccountBulkUpsertItemTransition {
  Fail = 'fail',
  Process = 'process',
  Retry = 'retry'
}

export enum BankAccountBulkUpsertRequestTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  PartiallyFail = 'partiallyFail',
  Process = 'process'
}

export enum BankAccountCurrencyTypes {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sle = 'SLE',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uyw = 'UYW',
  Uzs = 'UZS',
  Ved = 'VED',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}

/** The integration enum and unique integration id  */
export type BankAccountIntegration = {
  __typename?: 'BankAccountIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<BankAccountIntegrationTypes>;
};

/** Input type for integrations field */
export type BankAccountIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<BankAccountIntegrationTypes>;
};

/** Integrations for BankAccount */
export enum BankAccountIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export type BankAccountPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type BankAccountQueryFilter = {
  bankAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  institutionNumber?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<BankAccountStates>;
  /** @deprecated Use userStringId instead. */
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** User's ID as string. It can either be the OneVest ID or an External ID from a Passthrough API. */
  userStringId?: InputMaybe<Scalars['String']['input']>;
};

export enum BankAccountSources {
  Flinks = 'FLINKS',
  Plaid = 'PLAID',
  User = 'USER'
}

export enum BankAccountStates {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  AwaitingReview = 'AWAITING_REVIEW',
  Rejected = 'REJECTED'
}

export type BankAccountTransitPhysicalAddress = {
  __typename?: 'BankAccountTransitPhysicalAddress';
  city: Scalars['String']['output'];
  country: BankAccountAddressCountries;
  houseNumber: Scalars['String']['output'];
  jurisdiction?: Maybe<BankAccountAddressJurisdiction>;
  postal: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  unitNumber?: Maybe<Scalars['String']['output']>;
};

/** Bank's Account Transit Physical Address */
export type BankAccountTransitPhysicalAddressInput = {
  /** City */
  city: Scalars['SafeString']['input'];
  /** Country */
  country: BankAccountAddressCountries;
  /** House number */
  houseNumber: Scalars['SafeString']['input'];
  /** Jurisdiction */
  jurisdiction?: InputMaybe<BankAccountAddressJurisdiction>;
  /** Postal code */
  postal: Scalars['SafeString']['input'];
  /** Street name */
  streetName: Scalars['SafeString']['input'];
  /** Unit number */
  unitNumber?: InputMaybe<Scalars['SafeString']['input']>;
};

export enum BankAccountTransition {
  Approve = 'approve',
  Reject = 'reject'
}

export enum BankAccountTypes {
  Checking = 'CHECKING',
  Other = 'OTHER',
  Savings = 'SAVINGS'
}

export type BankAccountUpsertIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type BankConnection = {
  __typename?: 'BankConnection';
  bankAccounts?: Maybe<Array<BankAccount>>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  holderName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  loginId: Scalars['String']['output'];
  state?: Maybe<BankConnectionStates>;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  user: User;
};

export type BankConnectionPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type BankConnectionQueryFilter = {
  createdAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  state?: InputMaybe<BankConnectionStates>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum BankConnectionStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Pending = 'PENDING'
}

export type BankingConnectorProvider = {
  __typename?: 'BankingConnectorProvider';
  clientIframeUrl?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  instanceId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<BankingConnectorVendors>;
};

export type BankingConnectorProviderInput = {
  clientIframeUrl?: InputMaybe<Scalars['SafeString']['input']>;
  customerId?: InputMaybe<Scalars['SafeString']['input']>;
  instanceId?: InputMaybe<Scalars['SafeString']['input']>;
  vendor?: InputMaybe<BankingConnectorVendors>;
};

export enum BankingConnectorVendors {
  Flinks = 'FLINKS'
}

export type BankingStateMachineChanges = {
  __typename?: 'BankingStateMachineChanges';
  createdAt: Scalars['GraphQLDateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export enum BannerInteractionState {
  Actioned = 'ACTIONED',
  Dismissed = 'DISMISSED',
  Seen = 'SEEN'
}

export enum BannerType {
  Info = 'INFO',
  Success = 'SUCCESS',
  Urgent = 'URGENT',
  Warning = 'WARNING'
}

export type Beneficiary = {
  __typename?: 'Beneficiary';
  account: Account;
  allocation: Scalars['Float']['output'];
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  relation: BeneficiaryRelation;
  successorAddress?: Maybe<SuccessorPhysicalAddress>;
  type: BeneficiaryType;
};

export type BeneficiaryPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type BeneficiaryQueryFilter = {
  account?: InputMaybe<Scalars['ObjectID']['input']>;
  allocation?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  relation?: InputMaybe<BeneficiaryRelation>;
  type?: InputMaybe<BeneficiaryType>;
};

export enum BeneficiaryRelation {
  Child = 'CHILD',
  CommonLaw = 'COMMON_LAW',
  Friend = 'FRIEND',
  Grandparent = 'GRANDPARENT',
  Other = 'OTHER',
  Parent = 'PARENT',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE'
}

export enum BeneficiaryType {
  ContingentBeneficiary = 'CONTINGENT_BENEFICIARY',
  PrimaryBeneficiary = 'PRIMARY_BENEFICIARY',
  Successor = 'SUCCESSOR'
}

export type BillingCycle = {
  __typename?: 'BillingCycle';
  baseCurrency: Scalars['String']['output'];
  billingDate: Scalars['GraphQLDate']['output'];
  billingSchedule?: Maybe<BillingSchedule>;
  calculatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  calculationDate?: Maybe<Scalars['GraphQLDate']['output']>;
  chargeableMarketValueCentsOnLastDay?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['GraphQLDate']['output']>;
  feeCents?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ObjectID']['output'];
  marketValueCentsOnLastDay?: Maybe<Scalars['Float']['output']>;
  organization?: Maybe<Organization>;
  projectedFeeAndTaxCents?: Maybe<Scalars['Float']['output']>;
  reconciledFees?: Maybe<ReconciledFees>;
  salesTaxCents?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['GraphQLDate']['output']>;
  state?: Maybe<BillingCycleStates>;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<FeeStateMachineChanges>>>;
};

export type BillingCycleQueryFilter = {
  billingDateAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  billingDateBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  billingScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<InputMaybe<BillingCycleStates>>>;
};

export enum BillingCycleStates {
  Approved = 'APPROVED',
  AwaitingReview = 'AWAITING_REVIEW',
  CycleCompleted = 'CYCLE_COMPLETED',
  CycleInProgress = 'CYCLE_IN_PROGRESS',
  Processed = 'PROCESSED'
}

export enum BillingCycleTransition {
  Approve = 'approve',
  DangerouslyReset = 'dangerouslyReset',
  Process = 'process',
  Reset = 'reset'
}

/** BillingSchedule defines the schedule on which the fees will be collected. */
export type BillingSchedule = {
  __typename?: 'BillingSchedule';
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /**
   * It defines whether this is the default BillingSchedule within its organization.
   * The default BillingSchedule will be used in case there is no specific BillingSchedule assigned to the subAccount, Account, User, or ClientGroup.
   * If the organization does not inherit parent BillingSchedules, there must be one default BillingSchedule, otherwise the default BillingSchedule of the next parent organization will be considered.
   */
  default: Scalars['Boolean']['output'];
  /** It is the end date of the current billing period. If not specified, it will be automatically set based on the nextBillingDate and frequency. */
  endDate?: Maybe<Scalars['GraphQLDate']['output']>;
  /** The key identifying the extension that manages this resource. */
  extensionKey?: Maybe<Scalars['String']['output']>;
  /** The version of the extension schema used. */
  extensionVersion?: Maybe<Scalars['String']['output']>;
  frequency: BillingScheduleFrequencies;
  id: Scalars['ObjectID']['output'];
  /** nextBillingDate is updated at every billing cycle based on the defined frequency until the endDate (if defined). */
  nextBillingDate: Scalars['GraphQLDate']['output'];
  /** nextCalculationDate is updated at every billing cycle based on the defined frequency until the endDate (if defined). */
  nextCalculationDate: Scalars['GraphQLDate']['output'];
  organization?: Maybe<PublicOrganization>;
  requestId?: Maybe<Scalars['String']['output']>;
  /** The unique key for this resource within its extension. */
  resourceKey?: Maybe<Scalars['String']['output']>;
  /** It is the start date of the current billing period. If not specified, it will be automatically set based on the nextBillingDate and frequency. */
  startDate?: Maybe<Scalars['GraphQLDate']['output']>;
  state: BillingScheduleStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<FeeStateMachineChanges>>>;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export enum BillingScheduleFrequencies {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semestral = 'SEMESTRAL'
}

export type BillingScheduleQueryFilter = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  frequencies?: InputMaybe<Array<InputMaybe<BillingScheduleFrequencies>>>;
  nextBillingDateAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  nextBillingDateBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<InputMaybe<BillingScheduleStates>>>;
};

export enum BillingScheduleSource {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  ClientGroup = 'CLIENT_GROUP',
  Organization = 'ORGANIZATION',
  ParentOrganization = 'PARENT_ORGANIZATION',
  SubAccount = 'SUB_ACCOUNT',
  User = 'USER'
}

export enum BillingScheduleStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export enum BillingScheduleTransition {
  Activate = 'activate',
  Archive = 'archive',
  Deactivate = 'deactivate'
}

/** The entity a model-portfolio clone is privately bound to. */
export enum BoundObjectType {
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  SubAccount = 'SUB_ACCOUNT'
}

export type Branch = {
  __typename?: 'Branch';
  /** Asset class of this branch (auto-set at save time for ASSET_CLASS portfolios) */
  assetClass?: Maybe<AssetClass>;
  /**
   * Portfolio-wide weight. Equal to percentage on flat models. On ASSET_CLASS,
   * percentage × (matching assetClassBranches.targetPercentage / 100). Null when
   * the model is grouped and the sleeve has no matching group, or the parent
   * scale is unavailable. Read-only — writes still send percentage (group-relative
   * on ASSET_CLASS).
   */
  effectivePercentage?: Maybe<Scalars['Float']['output']>;
  /** The Financial product. */
  financialProduct: FinancialProduct;
  /** This is the branchId and it is auto-generated by OneVest for each Branch. */
  id: Scalars['ObjectID']['output'];
  isCashEquivalent?: Maybe<Scalars['Boolean']['output']>;
  /** This is the percentage allocated to this Branch. */
  percentage: Scalars['Float']['output'];
  taxRank: Scalars['Int']['output'];
};

export type BranchInput = {
  /** This is the child financialProductId */
  financialProductId: Scalars['ObjectID']['input'];
  isCashEquivalent?: InputMaybe<Scalars['Boolean']['input']>;
  /** This is the percentage allocated to this Branch. */
  percentage: Scalars['Float']['input'];
  /**
   * Optional tax rank for portfolio optimization (1-based).
   * When any child provides this, all children must provide it.
   * When omitted on all children, server assigns ranks by array position.
   */
  taxRank?: InputMaybe<Scalars['Int']['input']>;
};

export type BucketSubTradeRequestsInput = {
  /**
   *  @deprecated Not needed anymore, will be removed in the future
   * @deprecated Field no longer supported
   */
  bulkTradeRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Not needed anymore, will be removed in the future */
  source?: InputMaybe<SubTradeRequestSources>;
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type BulkForceReconcileActivitiesInput = {
  activityIds: Array<Scalars['ObjectID']['input']>;
};

export type BulkForceReconcileActivitiesResponse = {
  __typename?: 'BulkForceReconcileActivitiesResponse';
  activities: Array<CustodianActivity>;
};

export type BulkImport = {
  __typename?: 'BulkImport';
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<PublicOrganization>;
  organizationUser?: Maybe<PublicOrganizationUser>;
  state: BulkImportStates;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type BulkImportQueryFilter = {
  createdAtAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<InputMaybe<BulkImportStates>>>;
};

export enum BulkImportStates {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING'
}

export enum BulkImportTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  Process = 'process'
}

export type BulkTrade = {
  actualPriceCents: Scalars['Float']['input'];
  financialProductId: Scalars['ObjectID']['input'];
  totalQuantity: Scalars['Int']['input'];
};

export type BulkTradeFile = {
  __typename?: 'BulkTradeFile';
  requestType: BulkTradeFileRequestTypes;
  type: BulkTradeFileTypes;
  url: Scalars['String']['output'];
};

export type BulkTradeFileInput = {
  key: Scalars['String']['input'];
  requestType: BulkTradeFileRequestTypes;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  type: BulkTradeFileTypes;
};

export enum BulkTradeFileRequestTypes {
  All = 'ALL',
  Buy = 'BUY',
  Sell = 'SELL'
}

export enum BulkTradeFileTypes {
  All = 'ALL',
  MutualFund = 'MUTUAL_FUND',
  Ptf = 'PTF',
  Securities = 'SECURITIES'
}

export type BulkTradeInput = {
  actualPriceCents: Scalars['Float']['input'];
  financialProductId: Scalars['ObjectID']['input'];
  totalQuantity: Scalars['Int']['input'];
};

export type BulkTradePaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type BulkTradeRequest = {
  __typename?: 'BulkTradeRequest';
  createdAt: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  source: BulkTradeRequestSources;
  sourceId: Scalars['ObjectID']['output'];
  state: BulkTradeRequestStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<StateMachineChanges>>>;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type BulkTradeRequestQueryFilter = {
  source?: InputMaybe<BulkTradeRequestSources>;
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<BulkTradeRequestStates>;
};

export enum BulkTradeRequestSourceInput {
  Goal = 'GOAL',
  PortfolioOptimizer = 'PORTFOLIO_OPTIMIZER',
  Rebalance = 'REBALANCE',
  SubAccount = 'SUB_ACCOUNT'
}

export enum BulkTradeRequestSources {
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  PortfolioOptimizer = 'PORTFOLIO_OPTIMIZER',
  Rebalance = 'REBALANCE',
  SubAccount = 'SUB_ACCOUNT'
}

export enum BulkTradeRequestStates {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Requested = 'REQUESTED'
}

export enum BulkTradeRequestTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Draft = 'draft',
  Request = 'request'
}

export type BulkTradeRequestType = {
  __typename?: 'BulkTradeRequestType';
  bulkTrades: Array<AccountBulkTradeRequest>;
  type: TradeRequestTypes;
};

export type BulkTradeRun = {
  __typename?: 'BulkTradeRun';
  allTradeRequestsByExchange: Array<TotalIncompleteTradeRequests>;
  allocationFileUrl?: Maybe<Scalars['String']['output']>;
  allocationFileUrls: Array<Scalars['String']['output']>;
  allocationFiles: Array<AllocationFile>;
  autoFillActualQuantity: Scalars['Boolean']['output'];
  bulkMutualFundTrades: Array<AccountBulkMutualFundTrade>;
  bulkPTFFileUrls: Array<Scalars['String']['output']>;
  bulkTradeFileUrl?: Maybe<Scalars['String']['output']>;
  bulkTradeFiles: Array<BulkTradeFile>;
  bulkTradeRequests: Array<BulkTradeRequestType>;
  buyBulkTradeFileUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  incompleteTradeRequestsByExchange: Array<TotalIncompleteTradeRequests>;
  mutualFundFileUrl?: Maybe<Scalars['String']['output']>;
  organization: PublicOrganization;
  ptfAllocationFileUrls: Array<Scalars['String']['output']>;
  sellBulkTradeFileUrl?: Maybe<Scalars['String']['output']>;
  state: BulkTradeRunStates;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};


export type BulkTradeRunBulkTradeRequestsArgs = {
  exchanges?: InputMaybe<Array<Exchanges>>;
};


export type BulkTradeRunIncompleteTradeRequestsByExchangeArgs = {
  PTF?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkTradeRunAllocation = {
  __typename?: 'BulkTradeRunAllocation';
  account: Scalars['String']['output'];
  corporateOffsetAccount: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  fXRate: Scalars['Float']['output'];
  fillPrice: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  market: Scalars['String']['output'];
  settlementCurrency: Scalars['String']['output'];
  settlementDate: Scalars['GraphQLDate']['output'];
  shareQuantity: Scalars['Float']['output'];
  side: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  tradeCurrency: Scalars['String']['output'];
  tradeDate: Scalars['GraphQLDate']['output'];
  tradeValue: Scalars['Float']['output'];
};

export type BulkTradeRunAllocationsFilter = {
  bulkTradeRunId: Scalars['ObjectID']['input'];
  exchanges?: InputMaybe<Array<Exchanges>>;
  isPTF?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkTradeRunAllocationsPagination = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkTradeRunPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type BulkTradeRunQueryFilter = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<BulkTradeRunStates>;
};

export type BulkTradeRunReason = {
  __typename?: 'BulkTradeRunReason';
  id: Scalars['ObjectID']['output'];
  reason: BulkTradeRunReasons;
  total: Scalars['Int']['output'];
  unblockedSince?: Maybe<Scalars['GraphQLDate']['output']>;
};

export enum BulkTradeRunReasons {
  Illiquid = 'ILLIQUID',
  Paired = 'PAIRED',
  UnblockedBuys = 'UNBLOCKED_BUYS',
  Unpaired = 'UNPAIRED'
}

export enum BulkTradeRunStates {
  AllocationsCompleted = 'ALLOCATIONS_COMPLETED',
  AllocationsInitiated = 'ALLOCATIONS_INITIATED',
  AllocationsRequested = 'ALLOCATIONS_REQUESTED',
  BulkTradesCompleted = 'BULK_TRADES_COMPLETED',
  BulkTradesFilesGenerating = 'BULK_TRADES_FILES_GENERATING',
  BulkTradesInitiated = 'BULK_TRADES_INITIATED',
  BulkTradesRequested = 'BULK_TRADES_REQUESTED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  CompletedPendingPtfs = 'COMPLETED_PENDING_PTFS',
  Generating = 'GENERATING'
}

export enum BulkTradeRunTransition {
  Cancel = 'cancel',
  CompleteBulkTrades = 'completeBulkTrades',
  GenerateBulkTradeFiles = 'generateBulkTradeFiles',
  InitiateAllocations = 'initiateAllocations',
  PublishAllocations = 'publishAllocations',
  Regenerate = 'regenerate',
  ResetBulkTrades = 'resetBulkTrades'
}

export type BulkTradeType = {
  __typename?: 'BulkTradeType';
  bulkTrades: Array<AccountBulkTrade>;
  type: TradeType;
};

export type BulkTransitionAccountFeesInput = {
  accountFeeIds: Array<Scalars['ObjectID']['input']>;
  transition: AccountFeeBulkTransition;
};

export type BulkTransitionAccountFeesResponse = {
  __typename?: 'BulkTransitionAccountFeesResponse';
  accountFees: Array<AccountFee>;
};

export type BulkTransitionFailure = {
  __typename?: 'BulkTransitionFailure';
  error: Scalars['String']['output'];
  flagId: Scalars['ObjectID']['output'];
};

export type BulkTransitionFlagsForGridResponse = {
  __typename?: 'BulkTransitionFlagsForGridResponse';
  failed: Array<BulkTransitionFailure>;
  succeeded: Array<Flag>;
};

export type BulkTransitionFlagsInput = {
  flagIds: Array<Scalars['ObjectID']['input']>;
  transition: FlagTransition;
};

export type BulkTransitionFlagsResponse = {
  __typename?: 'BulkTransitionFlagsResponse';
  flags?: Maybe<Array<Flag>>;
};

export type BulkUpsertAccountGroupsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertAccountGroupInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertAccountGroupsResponse = {
  __typename?: 'BulkUpsertAccountGroupsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertAccountsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertAccountInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertAccountsResponse = {
  __typename?: 'BulkUpsertAccountsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertAdvisorContactsInput = {
  headers: Array<Scalars['String']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  rows: Array<AdvisorContactImportRowInput>;
};

export type BulkUpsertAdvisorContactsResponse = {
  __typename?: 'BulkUpsertAdvisorContactsResponse';
  created: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  results: Array<AdvisorContactImportRowResult>;
  total: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type BulkUpsertAssetClassesInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertAssetClassInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertAssetClassesResponse = {
  __typename?: 'BulkUpsertAssetClassesResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertBankAccountResponse = {
  __typename?: 'BulkUpsertBankAccountResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertBankAccountsInput = {
  /**
   * Use bulkUpsertRequestId to add items to an existing bulk upsert request.
   * If not provided, a new bulk upsert request will be created.
   */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId: Scalars['ObjectID']['input'];
  items: Array<UpsertBankAccountInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /**
   * If true, the bulkUpsertRequest will not be processed automatically.
   * It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest.
   */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertCashAndHoldingsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertCashAndHoldingInput>;
  options?: InputMaybe<BulkUpsertCashAndHoldingsOptionsInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertCashAndHoldingsOptionsInput = {
  refreshRebalanceReport?: InputMaybe<Scalars['Boolean']['input']>;
  saveAsMigrationBaseline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertCashAndHoldingsResponse = {
  __typename?: 'BulkUpsertCashAndHoldingsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

/** Creates or updates data about a client household.  */
export type BulkUpsertClientGroupsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertClientGroupInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertClientGroupsResponse = {
  __typename?: 'BulkUpsertClientGroupsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertCustodianActivitiesInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertCustodianActivityInput>;
  options?: InputMaybe<BulkUpsertCustodianActivitiesOptionsInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertCustodianActivitiesOptionsInput = {
  deferTradeRequestTransition?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true and reconcileActivities is enabled, transfer and fee reconciliation match custodian amounts to transfer.amountCents minus transfer.salesTaxCents (net of sales tax). */
  excludeTransferSalesTax?: InputMaybe<Scalars['Boolean']['input']>;
  reconcileActivities?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, reconciliation does not create ledger transactions, and (with reconcileActivities) the post-reconcile cash, holdings, and stats updates are skipped—same as when the organization has disableStatsUpdateBasedOnTransactions. When omitted, uses the organization's disableStatsUpdateBasedOnTransactions setting for the persisted reconciledOptions default. */
  skipLedgerUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertCustodianActivitiesResponse = {
  __typename?: 'BulkUpsertCustodianActivitiesResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertCustodianCashAndHoldingsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertCustodianCashAndHoldingsInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertCustodianCashAndHoldingsResponse = {
  __typename?: 'BulkUpsertCustodianCashAndHoldingsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertFinancialProductSnapshotsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertFinancialProductSnapshotInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertFinancialProductSnapshotsResponse = {
  __typename?: 'BulkUpsertFinancialProductSnapshotsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertFinancialProductsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertFinancialProductInput>;
  options?: InputMaybe<BulkUpsertFinancialProductsOptionsInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertFinancialProductsOptionsInput = {
  updateHoldingPrices?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertFinancialProductsResponse = {
  __typename?: 'BulkUpsertFinancialProductsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertGoalsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertGoalInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertGoalsResponse = {
  __typename?: 'BulkUpsertGoalsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertOrganizationUsersInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertOrganizationUserInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertOrganizationUsersResponse = {
  __typename?: 'BulkUpsertOrganizationUsersResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertOrganizationsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertOrganizationInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertOrganizationsResponse = {
  __typename?: 'BulkUpsertOrganizationsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUpsertPerformanceSnapshotsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertPerformanceSnapshotInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertPerformanceSnapshotsResponse = {
  __typename?: 'BulkUpsertPerformanceSnapshotsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertRequest = {
  __typename?: 'BulkUpsertRequest';
  apiToken?: Maybe<ApiToken>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  failedItemsCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ObjectID']['output'];
  initiatorId?: Maybe<Scalars['String']['output']>;
  initiatorType: OrganizationInitiator;
  integration?: Maybe<Integration>;
  objectType: BulkUpsertRequestObjectTypes;
  organization?: Maybe<PublicOrganization>;
  organizationUser?: Maybe<PublicOrganizationUser>;
  processedItemsCount?: Maybe<Scalars['Int']['output']>;
  queuedItemsCount?: Maybe<Scalars['Int']['output']>;
  state: BulkUpsertRequestStates;
};

export enum BulkUpsertRequestObjectTypes {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  AssetClass = 'ASSET_CLASS',
  BankAccount = 'BANK_ACCOUNT',
  CashAndHoldings = 'CASH_AND_HOLDINGS',
  CustodianActivity = 'CUSTODIAN_ACTIVITY',
  CustodianCashAndHoldings = 'CUSTODIAN_CASH_AND_HOLDINGS',
  Document = 'DOCUMENT',
  Entity = 'ENTITY',
  FinancialProduct = 'FINANCIAL_PRODUCT',
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  ModelPortfolio = 'MODEL_PORTFOLIO',
  Organization = 'ORGANIZATION',
  OrganizationUser = 'ORGANIZATION_USER',
  PerformanceHistory = 'PERFORMANCE_HISTORY',
  PriceHistory = 'PRICE_HISTORY',
  ScheduledTransfer = 'SCHEDULED_TRANSFER',
  Statement = 'STATEMENT',
  StatsHistory = 'STATS_HISTORY',
  SubAccount = 'SUB_ACCOUNT',
  SubTrade = 'SUB_TRADE',
  Trade = 'TRADE',
  Transaction = 'TRANSACTION',
  Transfer = 'TRANSFER'
}

export type BulkUpsertRequestQueryFilter = {
  createdAtEnd?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectType?: InputMaybe<BulkUpsertRequestObjectTypes>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<BulkUpsertRequestStates>;
};

export enum BulkUpsertRequestStates {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  PartiallyFailed = 'PARTIALLY_FAILED',
  Processing = 'PROCESSING'
}

export type BulkUpsertScheduledTransferInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertScheduledTransferInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertScheduledTransferResponse = {
  __typename?: 'BulkUpsertScheduledTransferResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertStatsSnapshotsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertStatsSnapshotInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertStatsSnapshotsResponse = {
  __typename?: 'BulkUpsertStatsSnapshotsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertSubAccountsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertSubAccountInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertSubAccountsResponse = {
  __typename?: 'BulkUpsertSubAccountsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertTradesInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertTradeInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertTradesResponse = {
  __typename?: 'BulkUpsertTradesResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type BulkUpsertTransactionsInput = {
  /** Use bulkUpsertRequestId to add items to an existing bulk upsert request. If not provided, a new bulk upsert request will be created. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertTransactionInput>;
  options?: InputMaybe<BulkUpsertTransactionsOptionsInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, the bulkUpsertRequest will not be processed automatically. It can be used along with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertTransactionsOptionsInput = {
  refreshSnapshotsSync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertTransactionsResponse = {
  __typename?: 'BulkUpsertTransactionsResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

/** Creates or updates at least one user or a list of users. Task is idempotent and queues users for asynchronous processing.  */
export type BulkUpsertUsersInput = {
  /** Returned ID for bulkUpsert request that can be used in other bulkUpsert operations. */
  bulkUpsertRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  items: Array<UpsertUserInput>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** If true, bulkUpsertRequest is not automatically processed. Used with bulkUpsertRequestId to add multiple requests into the same bulkUpsertRequest. */
  skipProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpsertUsersResponse = {
  __typename?: 'BulkUpsertUsersResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type CalculateGoalSuitabilityScoreInput = {
  riskQuestion1: GoalRiskLevels;
  timeHorizon: GoalTimeHorizons;
};

export type CalculatePostRebalanceMetricsInput = {
  rebalanceId: Scalars['ObjectID']['input'];
};

export type CalculatePostRebalanceMetricsResponse = {
  __typename?: 'CalculatePostRebalanceMetricsResponse';
  rebalanceMetrics: RebalanceMetrics;
};

export type CalculatePreRebalanceMetricsInput = {
  full?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CalculatePreRebalanceMetricsResponse = {
  __typename?: 'CalculatePreRebalanceMetricsResponse';
  rebalanceMetrics: RebalanceMetrics;
};

export type CalculateTradeRequestFillsInput = {
  bulkTradeRunId: Scalars['ObjectID']['input'];
  bulkTrades: Array<BulkTradeInput>;
  currencyFallbackConversions?: InputMaybe<Array<CurrencyFallbackConversion>>;
  type: TradeRequestTypes;
};

export type CalculateTradeRequestFillsResponse = {
  __typename?: 'CalculateTradeRequestFillsResponse';
  success: Scalars['Boolean']['output'];
};

export type CalculateWithdrawFeesInput = {
  accountId: Scalars['ObjectID']['input'];
  amountCents: Scalars['Int']['input'];
  /** Inclusive UTC calendar date for sales-tax configuration. Defaults to the current UTC date when omitted. */
  applicableDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  isfullWithdraw: Scalars['Boolean']['input'];
  /** Setting net to true allows you to receive the amount of fees required to have a net value of amountCents */
  net?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalculateWithdrawFeesResponse = {
  __typename?: 'CalculateWithdrawFeesResponse';
  withdrawFees?: Maybe<Array<Maybe<WithdrawFee>>>;
};

export type CancelCustodianDepositTransferInput = {
  accountId: Scalars['ObjectID']['input'];
  amount: Scalars['Long']['input'];
  bankAccount: CreateCustodianDepositTransferBankAccountInput;
  frequency?: InputMaybe<CustodianFrequency>;
  fund: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CancelIntegrationFormPackInput = {
  integrationFormPackId: Scalars['ObjectID']['input'];
  /** Optional reason that will be passed to the e-sign provider (e.g. DocuSign's voidedReason). */
  reason?: InputMaybe<Scalars['SafeString']['input']>;
};

export type CancelIntegrationFormPackResponse = {
  __typename?: 'CancelIntegrationFormPackResponse';
  integrationFormPack: IntegrationFormPack;
};

export type CancelScheduledTransferResponse = {
  __typename?: 'CancelScheduledTransferResponse';
  scheduledTransfer?: Maybe<ScheduledTransfer>;
};

export type CancelSubTradeRequestsByIdInput = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  subTradeRequestIds: Array<Scalars['ObjectID']['input']>;
};

export type CancelSubTradeRequestsInput = {
  /**
   *  @deprecated Not needed anymore, will be removed in the future
   * @deprecated Field no longer supported
   */
  bulkTradeRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Not needed anymore, will be removed in the future */
  source?: InputMaybe<SubTradeRequestSources>;
  sourceId: Scalars['ObjectID']['input'];
};

export type CancelTransferResponse = {
  __typename?: 'CancelTransferResponse';
  transfer: Transfer;
};

export type CapitalGainsAndLosses = {
  __typename?: 'CapitalGainsAndLosses';
  account: Scalars['ObjectID']['output'];
  id: Scalars['ObjectID']['output'];
  totalCents: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type CashRunSummaryInput = {
  deployCount: Scalars['Int']['input'];
  raiseCount: Scalars['Int']['input'];
  undeployableDeployCount: Scalars['Int']['input'];
};

export enum ChangeTypes {
  AffiliateAdded = 'AFFILIATE_ADDED',
  AffiliateChanged = 'AFFILIATE_CHANGED',
  AgreementChange = 'AGREEMENT_CHANGE',
  AgreementValidityExpired = 'AGREEMENT_VALIDITY_EXPIRED',
  FileDocumentDelete = 'FILE_DOCUMENT_DELETE',
  NewSubAccount = 'NEW_SUB_ACCOUNT',
  Other = 'OTHER',
  PiiUpdated = 'PII_UPDATED',
  PortfolioChange = 'PORTFOLIO_CHANGE',
  PortfolioUpdated = 'PORTFOLIO_UPDATED',
  ScheduledTransferUpdated = 'SCHEDULED_TRANSFER_UPDATED',
  UsersRequiredToSignUpdated = 'USERS_REQUIRED_TO_SIGN_UPDATED'
}

/** Input type for filtering logs by a specific field in the 'changes' object */
export type ChangesFieldMatch = {
  field: Scalars['String']['input'];
  newValue?: InputMaybe<Scalars['JSON']['input']>;
  oldValue?: InputMaybe<Scalars['JSON']['input']>;
};

export type ClientAdvisorVisibilityEntry = {
  __typename?: 'ClientAdvisorVisibilityEntry';
  advisorContact?: Maybe<AdvisorContact>;
  contributingAccountIds?: Maybe<Array<Scalars['ObjectID']['output']>>;
  displayLabel: Scalars['String']['output'];
  effectiveHide: Scalars['Boolean']['output'];
  organizationUser?: Maybe<PublicOrganizationUser>;
  precedence?: Maybe<VisibilityPrecedence>;
};

/** ClientGroup */
export type ClientGroup = {
  __typename?: 'ClientGroup';
  accountGroups?: Maybe<Array<Maybe<AccountGroup>>>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  activeWorkflowCompletions: Array<WorkflowCompletion>;
  allIncompleteFormAgreements?: Maybe<Array<Maybe<IncompleteFormAgreement>>>;
  allLatestFormAgreements?: Maybe<Array<Maybe<FormAgreement>>>;
  /** @deprecated Use feeSetting.applicableBillingSchedule instead */
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  /** @deprecated Use feeSetting.applicableFeeTier instead */
  applicableFeeTier?: Maybe<FeeTier>;
  availableCurrencies?: Maybe<Array<Maybe<AccountCurrencyTypes>>>;
  /** @deprecated Use feeSetting instead */
  billingSchedule?: Maybe<BillingSchedule>;
  businessIsMemberOfIiroc?: Maybe<Scalars['Boolean']['output']>;
  /** Coporate Business Type */
  businessType?: Maybe<CorporateBusinessTypes>;
  /** The date and time the clientGroup was completed */
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  corporationCountry?: Maybe<CorporateCountries>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  custodianSnapshotHistory?: Maybe<Array<Maybe<CustodianSnapshotHistory>>>;
  custodianStatistics?: Maybe<CustodianStatistics>;
  customFields?: Maybe<Array<Maybe<UserCustomFieldValue>>>;
  /** Date entity was established in YYYY-MM-DD (ISO 8601 format).  */
  establishedDate?: Maybe<Scalars['GraphQLDate']['output']>;
  feeSetting?: Maybe<ClientGroupFeeSetting>;
  /** @deprecated Use feeSetting instead */
  feeTier?: Maybe<FeeTier>;
  financialProduct?: Maybe<FinancialProduct>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  /** ClientGroupID */
  id: Scalars['ObjectID']['output'];
  /** Fields required to be completed to transition a clientGroup to a completed state */
  incompleteFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Lists remaining forms to be signed for this clientGroup. */
  incompleteFormAgreements?: Maybe<Array<Maybe<IncompleteFormAgreement>>>;
  incorporationNumber?: Maybe<Scalars['String']['output']>;
  integrations?: Maybe<Array<Maybe<UserIntegration>>>;
  /** Lists latest signed forms for this clientGroup. */
  latestFormAgreements?: Maybe<Array<Maybe<FormAgreement>>>;
  logs: LogsResponse;
  /**
   * The most recent proposal scoped to this client group (objectType: HOUSEHOLD,
   * objectId: this id) that has not been canceled.
   *
   * COMPLETED proposals are included, so re-rendering a document after the change
   * is applied still resolves the proposal it was generated from — but only until
   * the next model change begins, after which this field follows the newer
   * proposal. A document that must stay bound to its source proposal should
   * capture that proposal's id at render time rather than re-resolve this field.
   *
   * Null when the client group has never had a proposal.
   */
  modelChangeProposal?: Maybe<ModelChangeProposal>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  /** Client group's primary contact phone number. Must contain 7-15 digits, including country code (E.164 format). */
  phone?: Maybe<Scalars['String']['output']>;
  /** coporate address */
  physicalAddress?: Maybe<PhysicalAddress>;
  /** Client group's primary email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: Maybe<Scalars['String']['output']>;
  /** Primary contact user, defined in relationship list. Returns null if not in list. */
  primaryUser: User;
  /** Array that defines relation types relative to the user */
  relationships?: Maybe<Array<Relationship>>;
  state: ClientGroupStates;
  statistics?: Maybe<Statistics>;
  /** Household's ID returned as string. It can either be the OneVest ID or an External ID from a Passthrough API. */
  stringId: Scalars['String']['output'];
  subAccounts?: Maybe<Array<Maybe<SubAccount>>>;
  /** Encrypted corporate Tax number */
  taxNumber?: Maybe<Scalars['String']['output']>;
  taxNumberDisclosed?: Maybe<Scalars['String']['output']>;
  tradingProcess?: Maybe<PortfolioTradingProcesses>;
  /** ClientGroupTypes derived from the ENUM */
  type: ClientGroupTypes;
};


/** ClientGroup */
export type ClientGroupCustodianSnapshotHistoryArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<CustodianStatisticsInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


/** ClientGroup */
export type ClientGroupCustodianStatisticsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<CustodianStatisticsInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


/** ClientGroup */
export type ClientGroupCustomFieldsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** ClientGroup */
export type ClientGroupLogsArgs = {
  input?: InputMaybe<ClientGroupLogsInput>;
};


/** ClientGroup */
export type ClientGroupStatisticsArgs = {
  forUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  input?: InputMaybe<StatisticsInput>;
};

export type ClientGroupFeeSetting = {
  __typename?: 'ClientGroupFeeSetting';
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  applicableFeeTier?: Maybe<FeeTier>;
  billingSchedule?: Maybe<BillingSchedule>;
  feeTier?: Maybe<FeeTier>;
};

export type ClientGroupLogsInput = {
  filter?: InputMaybe<ClientGroupLogsQueryFilter>;
  pagination?: InputMaybe<PaginationAndSorting>;
};

export type ClientGroupLogsQueryFilter = {
  after?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  before?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  clientGroupOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Defines read/write permissions a clientGroup member has to user data  */
export enum ClientGroupMemberAccessTypes {
  Edit = 'EDIT',
  NoAccess = 'NO_ACCESS',
  View = 'VIEW'
}

/** Input type for filtering Users */
export type ClientGroupQueryFilter = {
  clientGroupIds?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /**
   * Filter client groups by custom field key/value pairs (AND logic).
   * Provide exactly one of value or valueIn per filter.
   */
  customFields?: InputMaybe<Array<UserCustomFieldQueryFilter>>;
  /** Filter by integration external IDs (matches integrations.externalId) */
  integrationExternalIds?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /** name  of the clientGroup */
  name?: InputMaybe<Scalars['String']['input']>;
  /** organizationId for filter clientGroups */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** primaryUserId for filter clientGroups */
  primaryUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Allows to search for a specific clientGroup by their first name, and type */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Filter by state. Default: anything but ARCHIVED. */
  states?: InputMaybe<Array<ClientGroupStates>>;
  /** type  of the clientGroup */
  type?: InputMaybe<ClientGroupTypes>;
};

export enum ClientGroupStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum ClientGroupTransition {
  Archive = 'archive'
}

/** Defines clientGroup as household or business  */
export enum ClientGroupTypes {
  Business = 'BUSINESS',
  Household = 'HOUSEHOLD'
}

export type ClientGroupUpsertRelationshipInput = {
  accessType?: InputMaybe<ClientGroupMemberAccessTypes>;
  type?: InputMaybe<Scalars['SafeString']['input']>;
  userId: Scalars['SafeString']['input'];
};

export type ClientReport = {
  __typename?: 'ClientReport';
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  entity?: Maybe<User>;
  id: Scalars['ObjectID']['output'];
  objectId?: Maybe<Scalars['ObjectID']['output']>;
  objectType?: Maybe<ClientReportTemplateObjectTypes>;
  organization?: Maybe<PublicOrganization>;
  referenceDate?: Maybe<Scalars['GraphQLDate']['output']>;
  s3key?: Maybe<Scalars['String']['output']>;
  templateParameters?: Maybe<Array<Maybe<TemplateParameter>>>;
};

export enum ClientReportComparisonOperators {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanAgo = 'GREATER_THAN_AGO',
  In = 'IN',
  Includes = 'INCLUDES',
  LessThan = 'LESS_THAN',
  LessThanAgo = 'LESS_THAN_AGO',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN',
  NotIncludes = 'NOT_INCLUDES'
}

export enum ClientReportFrequencies {
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type ClientReportScheduler = {
  __typename?: 'ClientReportScheduler';
  /**
   * For MONTHLY, day of the following month (1-28)
   * For QUARTERLY and YEARLY, day of the first month following after the term (1-28)
   * For WEEKLY, day of the following week (1-7 Monday to Sunday)
   */
  dayOfMonthOrWeek?: Maybe<Scalars['Int']['output']>;
  enableNotification?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Report generation scheduling period:
   * WEEKLY every week (Monday - Sunday)
   * MONTHLY every month (1st - last day)
   * QUARTERLY every three months (1 Jan - 31 Mar; 1 Apr - 30 Jun; 1 Jul - 30 Sep; 1 Oct - 31 Dec)
   * YEARLY every year (1 Jan - 31 Dec)
   */
  frequency?: Maybe<ClientReportFrequencies>;
  oneTimeDateEnd?: Maybe<Scalars['GraphQLDate']['output']>;
  oneTimeDateStart?: Maybe<Scalars['GraphQLDate']['output']>;
  triggerRules?: Maybe<Array<Maybe<ClientReportTriggerRule>>>;
};

export type ClientReportTemplate = {
  __typename?: 'ClientReportTemplate';
  clientReportTemplatePageConfiguration?: Maybe<ClientReportTemplatePageConfiguration>;
  condition?: Maybe<ClientReportTemplateCondition>;
  id: Scalars['ObjectID']['output'];
  isStatementOfType?: Maybe<StatementTypes>;
  objectType?: Maybe<ClientReportTemplateObjectTypes>;
  organization?: Maybe<PublicOrganization>;
  reportType?: Maybe<ClientReportTemplateReportTypes>;
  s3key?: Maybe<StatementTranslatedString>;
  scheduler?: Maybe<ClientReportScheduler>;
  settings?: Maybe<ClientReportTemplateSettings>;
  state?: Maybe<ClientReportTemplateStates>;
  templateParameters?: Maybe<Array<Maybe<Scalars['SafeString']['output']>>>;
  translatedDescription?: Maybe<StatementTranslatedString>;
  translatedName?: Maybe<StatementTranslatedString>;
  type?: Maybe<Scalars['SafeString']['output']>;
};

export enum ClientReportTemplateCombinator {
  And = 'and',
  Or = 'or'
}

export type ClientReportTemplateCondition = {
  __typename?: 'ClientReportTemplateCondition';
  ruleGroup?: Maybe<ClientReportTemplateRuleGroup>;
};

export enum ClientReportTemplateConditionCustomFieldType {
  AccountTypes = 'accountTypes',
  Boolean = 'boolean',
  Date = 'date',
  Jurisdiction = 'jurisdiction',
  MultiSelect = 'multiSelect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

export type ClientReportTemplateConditionInput = {
  ruleGroup?: InputMaybe<ClientReportTemplateRuleGroupInput>;
};

export enum ClientReportTemplateConditionObjectType {
  Account = 'ACCOUNT',
  ClientGroup = 'CLIENT_GROUP',
  Goal = 'GOAL',
  SubAccount = 'SUB_ACCOUNT',
  Transfer = 'TRANSFER',
  User = 'USER'
}

export type ClientReportTemplateCoverPage = {
  __typename?: 'ClientReportTemplateCoverPage';
  disableBrandColor?: Maybe<Scalars['Boolean']['output']>;
  enableCompanyLogo?: Maybe<Scalars['Boolean']['output']>;
  enablePreparedBy?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  preparedBy?: Maybe<StatementTranslatedString>;
  subtitle?: Maybe<StatementTranslatedString>;
  title?: Maybe<StatementTranslatedString>;
};

export type ClientReportTemplateCoverPageInput = {
  disableBrandColor?: InputMaybe<Scalars['Boolean']['input']>;
  enableCompanyLogo?: InputMaybe<Scalars['Boolean']['input']>;
  enablePreparedBy?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  preparedBy?: InputMaybe<StatementTranslatedStringInput>;
  subtitle?: InputMaybe<StatementTranslatedStringInput>;
  title?: InputMaybe<StatementTranslatedStringInput>;
};

export type ClientReportTemplateFooter = {
  __typename?: 'ClientReportTemplateFooter';
  alternateCoverPageText?: Maybe<StatementTranslatedString>;
  enableAlternateCoverPageText?: Maybe<Scalars['Boolean']['output']>;
  enableOnCoverPage?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  text?: Maybe<StatementTranslatedString>;
};

export type ClientReportTemplateFooterInput = {
  alternateCoverPageText?: InputMaybe<StatementTranslatedStringInput>;
  enableAlternateCoverPageText?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<StatementTranslatedStringInput>;
};

export type ClientReportTemplateGeneral = {
  __typename?: 'ClientReportTemplateGeneral';
  brandColor?: Maybe<Scalars['SafeString']['output']>;
};

export type ClientReportTemplateGeneralInput = {
  brandColor?: InputMaybe<Scalars['SafeString']['input']>;
};

export type ClientReportTemplateHeader = {
  __typename?: 'ClientReportTemplateHeader';
  alternateCoverPageText?: Maybe<StatementTranslatedString>;
  enableAlternateCoverPageText?: Maybe<Scalars['Boolean']['output']>;
  enableOnCoverPage?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  text?: Maybe<StatementTranslatedString>;
};

export type ClientReportTemplateHeaderInput = {
  alternateCoverPageText?: InputMaybe<StatementTranslatedStringInput>;
  enableAlternateCoverPageText?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<StatementTranslatedStringInput>;
};

export enum ClientReportTemplateObjectTypes {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  ClientGroup = 'CLIENT_GROUP',
  Goal = 'GOAL',
  Individual = 'INDIVIDUAL',
  NonIndividual = 'NON_INDIVIDUAL',
  SubAccount = 'SUB_ACCOUNT',
  /** @deprecated Use the INDIVIDUAL or NON_INDIVIDUAL instead. */
  User = 'USER'
}

export type ClientReportTemplatePageConfiguration = {
  __typename?: 'ClientReportTemplatePageConfiguration';
  clientReportTemplate: ClientReportTemplate;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  options?: Maybe<Scalars['Object']['output']>;
  organization?: Maybe<Organization>;
  /** Organization with limited attributes that is accessible from sub-organizations. */
  publicOrganization?: Maybe<PublicOrganization>;
  type: ClientReportTemplatePageConfigurationTypes;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  widgets: Array<ClientReportTemplateWidgetConfiguration>;
};

export enum ClientReportTemplatePageConfigurationTypes {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  Individual = 'INDIVIDUAL',
  NonIndividual = 'NON_INDIVIDUAL',
  SubAccount = 'SUB_ACCOUNT'
}

export enum ClientReportTemplateReportTypes {
  Html = 'HTML',
  PageConfiguration = 'PAGE_CONFIGURATION'
}

export type ClientReportTemplateResponse = {
  __typename?: 'ClientReportTemplateResponse';
  clientReportTemplate?: Maybe<ClientReportTemplate>;
};

export type ClientReportTemplateRuleGroup = {
  __typename?: 'ClientReportTemplateRuleGroup';
  combinator?: Maybe<ClientReportTemplateCombinator>;
  customFieldKey?: Maybe<Scalars['SafeString']['output']>;
  customFieldType?: Maybe<ClientReportTemplateConditionCustomFieldType>;
  field?: Maybe<Scalars['SafeString']['output']>;
  objectType?: Maybe<ClientReportTemplateConditionObjectType>;
  operator?: Maybe<ClientReportTemplateRuleGroupOperator>;
  rules?: Maybe<Array<Maybe<ClientReportTemplateRuleGroup>>>;
  value?: Maybe<Scalars['SafeString']['output']>;
};

export type ClientReportTemplateRuleGroupInput = {
  combinator?: InputMaybe<ClientReportTemplateCombinator>;
  customFieldKey?: InputMaybe<Scalars['SafeString']['input']>;
  customFieldType?: InputMaybe<ClientReportTemplateConditionCustomFieldType>;
  field?: InputMaybe<Scalars['SafeString']['input']>;
  objectType?: InputMaybe<ClientReportTemplateConditionObjectType>;
  operator?: InputMaybe<ClientReportTemplateRuleGroupOperator>;
  rules?: InputMaybe<Array<InputMaybe<ClientReportTemplateRuleGroupInput>>>;
  value?: InputMaybe<Scalars['SafeString']['input']>;
};

export enum ClientReportTemplateRuleGroupOperator {
  Contains = 'contains',
  EndsWith = 'endsWith',
  Equals = 'equals',
  Exists = 'exists',
  GreaterThan = 'greaterThan',
  GreaterThanOrEquals = 'greaterThanOrEquals',
  In = 'in',
  Includes = 'includes',
  IsAfter = 'isAfter',
  IsBefore = 'isBefore',
  IsEmpty = 'isEmpty',
  IsFalse = 'isFalse',
  IsNotEmpty = 'isNotEmpty',
  IsTrue = 'isTrue',
  LessThan = 'lessThan',
  LessThanOrEquals = 'lessThanOrEquals',
  NotContains = 'notContains',
  NotEquals = 'notEquals',
  NotExist = 'notExist',
  NotIn = 'notIn',
  NotIncludes = 'notIncludes',
  StartsWith = 'startsWith'
}

export type ClientReportTemplateSettings = {
  __typename?: 'ClientReportTemplateSettings';
  coverPage?: Maybe<ClientReportTemplateCoverPage>;
  footer?: Maybe<ClientReportTemplateFooter>;
  general?: Maybe<ClientReportTemplateGeneral>;
  header?: Maybe<ClientReportTemplateHeader>;
  tableOfContents?: Maybe<ClientReportTemplateTableOfContents>;
};

export type ClientReportTemplateSettingsInput = {
  coverPage?: InputMaybe<ClientReportTemplateCoverPageInput>;
  footer?: InputMaybe<ClientReportTemplateFooterInput>;
  general?: InputMaybe<ClientReportTemplateGeneralInput>;
  header?: InputMaybe<ClientReportTemplateHeaderInput>;
  tableOfContents?: InputMaybe<ClientReportTemplateTableOfContentsInput>;
};

export enum ClientReportTemplateStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type ClientReportTemplateTableOfContents = {
  __typename?: 'ClientReportTemplateTableOfContents';
  enabled: Scalars['Boolean']['output'];
  title?: Maybe<StatementTranslatedString>;
};

export type ClientReportTemplateTableOfContentsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<StatementTranslatedStringInput>;
};

export enum ClientReportTemplateTransitions {
  Activate = 'activate',
  Archive = 'archive',
  Deactivate = 'deactivate',
  Review = 'review'
}

export type ClientReportTemplateWidgetConfiguration = {
  __typename?: 'ClientReportTemplateWidgetConfiguration';
  id: Scalars['ObjectID']['output'];
  options: Scalars['Object']['output'];
  type: ClientReportTemplateWidgetConfigurationTypes;
};

export type ClientReportTemplateWidgetConfigurationInput = {
  options?: InputMaybe<Scalars['Object']['input']>;
  type: ClientReportTemplateWidgetConfigurationTypes;
};

export enum ClientReportTemplateWidgetConfigurationTypes {
  Accounts = 'ACCOUNTS',
  Fees = 'FEES',
  FreeFormInput = 'FREE_FORM_INPUT',
  Goals = 'GOALS',
  Holdings = 'HOLDINGS',
  Ledger = 'LEDGER',
  MarketValueChart = 'MARKET_VALUE_CHART',
  ProjectedIncomeReport = 'PROJECTED_INCOME_REPORT',
  RateOfReturns = 'RATE_OF_RETURNS',
  SubAccounts = 'SUB_ACCOUNTS'
}

export type ClientReportTemplateWidgetOption = {
  __typename?: 'ClientReportTemplateWidgetOption';
  default: Scalars['Object']['output'];
  info?: Maybe<OrganizationTranslatedString>;
  key: Scalars['String']['output'];
  label: OrganizationTranslatedString;
  optionType: ClientReportTemplateWidgetOptionTypes;
  options?: Maybe<Scalars['Object']['output']>;
  removeFromPages?: Maybe<Array<Maybe<PageConfigurationTypes>>>;
  requiredIf?: Maybe<Scalars['Object']['output']>;
  showBasedOnCustodianConnection?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  showIf?: Maybe<Scalars['Object']['output']>;
  showWith?: Maybe<Scalars['String']['output']>;
};

export enum ClientReportTemplateWidgetOptionTypes {
  Array = 'ARRAY',
  Attachment = 'ATTACHMENT',
  BasicField = 'BASIC_FIELD',
  Boolean = 'BOOLEAN',
  HtmlTemplate = 'HTML_TEMPLATE',
  OptionalTranslatedString = 'OPTIONAL_TRANSLATED_STRING',
  PlainTextField = 'PLAIN_TEXT_FIELD',
  SelectField = 'SELECT_FIELD',
  Table = 'TABLE',
  TranslatedString = 'TRANSLATED_STRING',
  WorkflowSelectField = 'WORKFLOW_SELECT_FIELD'
}

export type ClientReportTemplatesQueryFilter = {
  objectTypes?: InputMaybe<Array<InputMaybe<ClientReportTemplateObjectTypes>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  reportTypes?: InputMaybe<Array<InputMaybe<ClientReportTemplateReportTypes>>>;
  states?: InputMaybe<Array<InputMaybe<ClientReportTemplateStates>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
};

export type ClientReportTriggerRule = {
  __typename?: 'ClientReportTriggerRule';
  comparison?: Maybe<ClientReportComparisonOperators>;
  field?: Maybe<Scalars['SafeString']['output']>;
  value?: Maybe<Scalars['SafeString']['output']>;
};

export type ClientReportTriggerRuleInput = {
  comparison?: InputMaybe<ClientReportComparisonOperators>;
  field?: InputMaybe<Scalars['SafeString']['input']>;
  value?: InputMaybe<Scalars['SafeString']['input']>;
};

export type ClientReportsQueryFilter = {
  clientReportTemplateId?: InputMaybe<Scalars['ObjectID']['input']>;
  entityId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectType?: InputMaybe<ClientReportTemplateObjectTypes>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  referenceDateFrom?: InputMaybe<Scalars['GraphQLDate']['input']>;
  referenceDateTo?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type CloneModelPortfolioInput = {
  modelPortfolioId: Scalars['ObjectID']['input'];
  organizationId: Scalars['ObjectID']['input'];
  translatedName?: InputMaybe<ProductTranslatedStringInput>;
};

export type CloneModelPortfolioResponse = {
  __typename?: 'CloneModelPortfolioResponse';
  modelPortfolio: FinancialProduct;
};

export type CloseAccountInput = {
  accountId: Scalars['ObjectID']['input'];
  inactiveReason: SubAccountInactiveReasons;
};

export type CloseAccountResponse = {
  __typename?: 'CloseAccountResponse';
  account?: Maybe<Account>;
};

export type CloseSubAccountInput = {
  inactiveReason: SubAccountInactiveReasons;
  shouldCloseAccount?: InputMaybe<Scalars['Boolean']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
};

export type CloseSubAccountResponse = {
  __typename?: 'CloseSubAccountResponse';
  subAccount?: Maybe<SubAccount>;
};

export type Collation = {
  locale?: InputMaybe<Locale>;
  strength?: InputMaybe<Scalars['Int']['input']>;
};

export type CompleteGoalInput = {
  goalId: Scalars['ObjectID']['input'];
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
};

export type CompleteGoalResponse = {
  __typename?: 'CompleteGoalResponse';
  goal: Goal;
};

/** Describes if user compliance has been approved, rejected, or is in review.  */
export enum ComplianceStates {
  Approved = 'APPROVED',
  NeedsReview = 'NEEDS_REVIEW',
  Rejected = 'REJECTED'
}

export type ConfigurableSalesTax = {
  __typename?: 'ConfigurableSalesTax';
  enabled: Scalars['Boolean']['output'];
  identity: ConfigurableSalesTaxIdentity;
};

export enum ConfigurableSalesTaxIdentity {
  BcPst = 'BC_PST',
  MbRst = 'MB_RST',
  SkPst = 'SK_PST'
}

export type ConfigurableSalesTaxInput = {
  enabled: Scalars['Boolean']['input'];
  identity: ConfigurableSalesTaxIdentity;
};

export type ConfigurableTablePage = OrganizationExtensionResource & {
  __typename?: 'ConfigurableTablePage';
  columns: Array<ConfigurableTablePageColumn>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  customPageSizes?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  disclaimerText?: Maybe<OrganizationTranslatedString>;
  disclaimerTitle?: Maybe<OrganizationTranslatedString>;
  enableCustomPagination?: Maybe<Scalars['Boolean']['output']>;
  enableDownload?: Maybe<Scalars['Boolean']['output']>;
  endpointUrl: Scalars['String']['output'];
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<Maybe<ConfigurableTablePageFilter>>>;
  id: Scalars['ObjectID']['output'];
  name: OrganizationTranslatedString;
  navigateToPath?: Maybe<ConfigurableTablePagePaths>;
  navigateToPathKey?: Maybe<Scalars['String']['output']>;
  /** Organization with limited attributes that is accessible from sub-organizations. */
  organization?: Maybe<PublicOrganization>;
  paginationType: ConfigurableTablePagePaginationType;
  resourceKey?: Maybe<Scalars['String']['output']>;
  section: ConfigurableTablePageSection;
  state: ConfigurableTablePageStates;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  useTopSearchPanel?: Maybe<Scalars['Boolean']['output']>;
  widgets?: Maybe<Array<ConfigurableTablePageWidget>>;
};


export type ConfigurableTablePageFiltersArgs = {
  input?: InputMaybe<ConfigurableTablePageFiltersInput>;
};

export type ConfigurableTablePageColumn = {
  __typename?: 'ConfigurableTablePageColumn';
  additionalInfo?: Maybe<OrganizationTranslatedString>;
  badgeColorKey?: Maybe<Scalars['String']['output']>;
  badgeMapping?: Maybe<Scalars['Object']['output']>;
  formatter?: Maybe<ConfigurableTablePageColumnFormatters>;
  includeInTotals?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name: OrganizationTranslatedString;
  rowScope: ConfigurableTablePageColumnRowScope;
  sortable?: Maybe<Scalars['Boolean']['output']>;
  type: ConfigurableTablePageColumnTypes;
};

export enum ConfigurableTablePageColumnFormatters {
  CapitalizedText = 'CAPITALIZED_TEXT',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  DivideBy_100 = 'DIVIDE_BY_100',
  MultiplyBy_100 = 'MULTIPLY_BY_100',
  SimpleText = 'SIMPLE_TEXT',
  TranslatedText = 'TRANSLATED_TEXT'
}

export type ConfigurableTablePageColumnInput = {
  additionalInfo?: InputMaybe<OrganizationTranslatedStringInput>;
  badgeColorKey?: InputMaybe<Scalars['String']['input']>;
  badgeMapping?: InputMaybe<Scalars['Object']['input']>;
  formatter?: InputMaybe<ConfigurableTablePageColumnFormatters>;
  includeInTotals?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name: OrganizationTranslatedStringInput;
  rowScope?: InputMaybe<ConfigurableTablePageColumnRowScope>;
  sortable?: InputMaybe<Scalars['Boolean']['input']>;
  type: ConfigurableTablePageColumnTypes;
};

export enum ConfigurableTablePageColumnRowScope {
  Collapsible = 'COLLAPSIBLE',
  Main = 'MAIN'
}

export enum ConfigurableTablePageColumnTypes {
  Badge = 'BADGE',
  Currency = 'CURRENCY',
  Date = 'DATE',
  Number = 'NUMBER',
  Percentage = 'PERCENTAGE',
  Text = 'TEXT'
}

export type ConfigurableTablePageExport = {
  __typename?: 'ConfigurableTablePageExport';
  configurableTablePage: ConfigurableTablePage;
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['Object']['output']>;
  id: Scalars['ObjectID']['output'];
  language?: Maybe<Languages>;
  organizationUser: PublicOrganizationUser;
  pagination?: Maybe<ConfigurableTablePageExportPagination>;
  progress?: Maybe<Scalars['Float']['output']>;
  state: ConfigurableTablePageExportStates;
};

export type ConfigurableTablePageExportPagination = {
  __typename?: 'ConfigurableTablePageExportPagination';
  cursor?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<PaginationCursorDirection>;
  perPage?: Maybe<Scalars['Int']['output']>;
  sortDesc?: Maybe<Scalars['Boolean']['output']>;
  sortField?: Maybe<Scalars['String']['output']>;
};

export type ConfigurableTablePageExportPaginationInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<PaginationCursorDirection>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export enum ConfigurableTablePageExportStates {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING'
}

export type ConfigurableTablePageFilter = {
  __typename?: 'ConfigurableTablePageFilter';
  additionalInfo?: Maybe<OrganizationTranslatedString>;
  default?: Maybe<Scalars['Object']['output']>;
  format: ConfigurableTablePageFilterFormats;
  isTopLevelFilter?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name: OrganizationTranslatedString;
  options?: Maybe<ConfigurableTablePageFilterOptions>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: ConfigurableTablePageFilterTypes;
};

export type ConfigurableTablePageFilterDependsOn = {
  __typename?: 'ConfigurableTablePageFilterDependsOn';
  /** Property name used for that value in the Options URL request filter */
  as: Scalars['String']['output'];
  /** Sibling filter key whose value is sent to the Options URL */
  key: Scalars['String']['output'];
};

export type ConfigurableTablePageFilterDependsOnInput = {
  as: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export enum ConfigurableTablePageFilterFormats {
  Checkbox = 'CHECKBOX',
  Currency = 'CURRENCY',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  DropdownList = 'DROPDOWN_LIST',
  Number = 'NUMBER',
  RadioButton = 'RADIO_BUTTON',
  SimpleText = 'SIMPLE_TEXT',
  ToggleSwitch = 'TOGGLE_SWITCH'
}

export type ConfigurableTablePageFilterInput = {
  additionalInfo?: InputMaybe<OrganizationTranslatedStringInput>;
  default?: InputMaybe<Scalars['Object']['input']>;
  format: ConfigurableTablePageFilterFormats;
  isTopLevelFilter?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name: OrganizationTranslatedStringInput;
  options?: InputMaybe<ConfigurableTablePageFilterOptionsInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: ConfigurableTablePageFilterTypes;
};

export type ConfigurableTablePageFilterOptions = {
  __typename?: 'ConfigurableTablePageFilterOptions';
  dependsOn?: Maybe<Array<ConfigurableTablePageFilterDependsOn>>;
  /** True when populating options from the Options URL failed, so populatedOptions is empty */
  optionsUnavailable?: Maybe<Scalars['Boolean']['output']>;
  optionsUrl?: Maybe<Scalars['String']['output']>;
  populatedOptions?: Maybe<Array<Maybe<ConfigurableTablePageFilterStaticOptions>>>;
  staticOptions?: Maybe<Array<Maybe<ConfigurableTablePageFilterStaticOptions>>>;
};

export type ConfigurableTablePageFilterOptionsInput = {
  dependsOn?: InputMaybe<Array<ConfigurableTablePageFilterDependsOnInput>>;
  optionsUrl?: InputMaybe<Scalars['String']['input']>;
  staticOptions?: InputMaybe<Array<InputMaybe<ConfigurableTablePageFilterStaticOptionsInput>>>;
};

export type ConfigurableTablePageFilterStaticOptions = {
  __typename?: 'ConfigurableTablePageFilterStaticOptions';
  key: Scalars['String']['output'];
  label: OrganizationTranslatedString;
};

export type ConfigurableTablePageFilterStaticOptionsInput = {
  key: Scalars['String']['input'];
  label: OrganizationTranslatedStringInput;
};

export enum ConfigurableTablePageFilterTypes {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Decimal = 'DECIMAL',
  Integer = 'INTEGER',
  MultipleSelect = 'MULTIPLE_SELECT',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT'
}

export type ConfigurableTablePageFiltersInput = {
  pageObjectId?: InputMaybe<Scalars['SafeString']['input']>;
  pageType?: InputMaybe<PageConfigurationTypes>;
  populateFilterOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfigurableTablePagePaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export enum ConfigurableTablePagePaginationType {
  Cursor = 'CURSOR',
  Offset = 'OFFSET'
}

export enum ConfigurableTablePagePaths {
  Accounts = 'ACCOUNTS',
  AccountGroups = 'ACCOUNT_GROUPS',
  Goals = 'GOALS',
  Households = 'HOUSEHOLDS',
  Individuals = 'INDIVIDUALS',
  NonIndividuals = 'NON_INDIVIDUALS',
  SubAccounts = 'SUB_ACCOUNTS'
}

export type ConfigurableTablePageQueryFilter = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<ConfigurableTablePageStates>>>;
};

export type ConfigurableTablePageSection = {
  __typename?: 'ConfigurableTablePageSection';
  icon?: Maybe<Scalars['String']['output']>;
  name: OrganizationTranslatedString;
};

export type ConfigurableTablePageSectionInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  name: OrganizationTranslatedStringInput;
};

export enum ConfigurableTablePageStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum ConfigurableTablePageTransitions {
  Archive = 'archive'
}

export type ConfigurableTablePageWidget = {
  __typename?: 'ConfigurableTablePageWidget';
  options: Scalars['Object']['output'];
  type: ConfigurableTablePageWidgetTypes;
};

export type ConfigurableTablePageWidgetInput = {
  options: Scalars['Object']['input'];
  type: ConfigurableTablePageWidgetTypes;
};

export enum ConfigurableTablePageWidgetTypes {
  FreeFormInput = 'FREE_FORM_INPUT'
}

export enum ContextObjectTypes {
  Account = 'ACCOUNT',
  SubAccount = 'SUB_ACCOUNT',
  User = 'USER'
}

export type CopyFormTemplateInput = {
  formTemplateId: Scalars['ObjectID']['input'];
};

export type CopyFormTemplateResponse = {
  __typename?: 'CopyFormTemplateResponse';
  formTemplate: FormTemplate;
};

export enum CorporateBusinessTypes {
  Corporation = 'CORPORATION',
  Llc = 'LLC',
  Partnership = 'PARTNERSHIP',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP'
}

/** Defines clientGroup by country using ISO 3166 standard   */
export enum CorporateCountries {
  Ca = 'CA',
  Usa = 'USA'
}

export enum CountryCodes {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CountryRisk = {
  __typename?: 'CountryRisk';
  country?: Maybe<Scalars['SafeString']['output']>;
  countryCode?: Maybe<Scalars['SafeString']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  riskRating?: Maybe<RiskRatings>;
};

export type CreateAccountGroupInput = {
  accountIds: Array<Scalars['ObjectID']['input']>;
  householdClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  translatedName: AccountTranslatedStringInput;
  type: AccountGroupTypes;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CreateAccountGroupResponse = {
  __typename?: 'CreateAccountGroupResponse';
  accountGroup: AccountGroup;
};

export type CreateAccountInput = {
  applyForGovFunds?: InputMaybe<Array<InputMaybe<ApplyForGovFunds>>>;
  availableCurrencies?: InputMaybe<Array<InputMaybe<AccountCurrencyTypes>>>;
  baseCurrency?: InputMaybe<AccountCurrencyTypes>;
  /** @deprecated Use the updateEntityFeeSetting mutation instead. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** @deprecated Use householdClientGroupId or corporationClientGroupId instead. */
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  corporationClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  custodianAccountName?: InputMaybe<Scalars['SafeString']['input']>;
  custodianAccountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  custodianConnectionId?: InputMaybe<Scalars['ObjectID']['input']>;
  custodianSortingOrderPriority?: InputMaybe<Scalars['Int']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  dealerAccountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  dealerCode?: InputMaybe<Scalars['SafeString']['input']>;
  dealerName?: InputMaybe<Scalars['SafeString']['input']>;
  eligibleForDisabilityTaxCredit?: InputMaybe<Scalars['Boolean']['input']>;
  externalSourceType?: InputMaybe<ExternalSourceTypes>;
  /** @deprecated Use the updateEntityFeeSetting mutation instead. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  forceOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group Employer. Only allowed for GRSP accounts. */
  groupEmployer?: InputMaybe<Scalars['SafeString']['input']>;
  /** Group Number. Only allowed for GRSP accounts. */
  groupNumber?: InputMaybe<Scalars['SafeString']['input']>;
  householdClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountIntegrationInput>>>;
  /**
   * For RESP accounts, indicates the plan was transferred in from another institution.
   * When true, the beneficiary age (under 21) restriction is lifted.
   */
  isTransferredFromAnotherInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction?: InputMaybe<Jurisdiction>;
  /** @deprecated nickName is deprecated. Use translatedNickName instead. */
  nickName?: InputMaybe<Scalars['SafeString']['input']>;
  overrideTaxRank?: InputMaybe<Scalars['Int']['input']>;
  repCode?: InputMaybe<Scalars['SafeString']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  respAllBeneficiariesAreInBc?: InputMaybe<Scalars['Boolean']['input']>;
  rightOfSurvivorship?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOfFunds?: InputMaybe<SourceOfFunds>;
  sourceType?: InputMaybe<SourceTypes>;
  tlhEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  translatedNickName?: InputMaybe<AccountTranslatedStringInput>;
  type: AccountTypes;
  userId: Scalars['ObjectID']['input'];
};

export type CreateAccountResponse = {
  __typename?: 'CreateAccountResponse';
  account: Account;
};

export type CreateAccountStatementInput = {
  accountId: Scalars['String']['input'];
  fileName: Scalars['SafeString']['input'];
  mediaType: Scalars['String']['input'];
  referenceDate: Scalars['GraphQLDate']['input'];
  s3Path: Scalars['SafeString']['input'];
  sourceType: StatementSourceType;
  type: StatementTypes;
};

export type CreateAccountStatementResponse = {
  __typename?: 'CreateAccountStatementResponse';
  accountStatement?: Maybe<AccountStatement>;
};

export type CreateAdjustmentTransactionInput = {
  currency?: InputMaybe<Currencies>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  date: Scalars['GraphQLDate']['input'];
  description?: InputMaybe<Scalars['SafeString']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  valueCents: Scalars['Float']['input'];
};

export type CreateAdjustmentTransactionResponse = {
  __typename?: 'CreateAdjustmentTransactionResponse';
  transaction: Transaction;
};

export type CreateAdjustmentTransferInput = {
  /** Adjustment reason. */
  adjustmentReason: Scalars['SafeString']['input'];
  /** Transfer amount in cents. Maximum $1 (100) */
  amountCents: Scalars['Long']['input'];
  currency?: InputMaybe<Currencies>;
  fiscalYear?: InputMaybe<Scalars['Int']['input']>;
  /** This an ID created by the partner, that is submitted with an transfer request and unique to each request. */
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Account that transfer is to be processed in. */
  subAccountId: Scalars['ObjectID']['input'];
  /** Type of transfer */
  type: TransferType;
};

export type CreateAdvisorContactInput = {
  address?: InputMaybe<AdvisorContactAddressInput>;
  displayRoleId?: InputMaybe<Scalars['ObjectID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExtension?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdvisorContactResponse = {
  __typename?: 'CreateAdvisorContactResponse';
  advisorContact: AdvisorContact;
};

/** Input type for creating an affiliate only user */
export type CreateAffiliateInput = {
  /** User's citizenships */
  citizenships?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /** Defines if User is a close associate of a politically exposed person (PEP).  */
  closeAssociateOfPEP?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of company at which the user is employed */
  companyType?: InputMaybe<Scalars['SafeString']['input']>;
  countryOfRegistration?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's date of birth in YYYY-MM-DD (ISO 8601 format). */
  dateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Decedent's date of death in YYYY-MM-DD (ISO 8601 format). Used for estate planning and account management. */
  dateOfDeath?: InputMaybe<Scalars['GraphQLDate']['input']>;
  employerCompanyAddress?: InputMaybe<PhysicalAddressInput>;
  employerName?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's employment status */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  entityName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date entity was established in YYYY-MM-DD (ISO 8601 format).  */
  establishedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** First name of user.  */
  firstName: Scalars['SafeString']['input'];
  /** The tax information provided by the affiliate if the he pays tax to a foreign country */
  foreignTaxInformation?: InputMaybe<Array<InputMaybe<ForeignTaxInformationInput>>>;
  /** User's gender: MALE, FEMALE or OTHER */
  gender?: InputMaybe<Scalars['SafeString']['input']>;
  /** Is/Was the User the head of an international organization? */
  headOfInternationalOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date affiliate became a resident of current province/state in YYYY-MM-DD (ISO 8601 format). Determines provincial tax residency and compliance requirements.  */
  inProvinceSince?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /**
   * Is the user a member of IIROC?
   * IIROC:Investment Industry Regulatory Organization of Canada
   */
  isMemberOfIiroc?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the user a high-level management executive of a public company? */
  isOfficerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the user the owner of a public company? */
  isOwnerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  issuerExchange?: InputMaybe<Scalars['SafeString']['input']>;
  issuerName?: InputMaybe<Scalars['SafeString']['input']>;
  issuerTicker?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's job title, if user is employed */
  jobTitle?: InputMaybe<Scalars['SafeString']['input']>;
  /** Last name of user.  */
  lastName: Scalars['SafeString']['input'];
  /** Describes marital status of affiliate.  */
  maritalStatus?: InputMaybe<MaritalStatus>;
  /** Middle name of user.  */
  middleName?: InputMaybe<Scalars['SafeString']['input']>;
  /** What the organization should be set to for the new user */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  parentCompanyName?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated use foreignTaxInformation */
  payTaxesOutsideCanada?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone number that contains 7-15 digits, including country code (E.164 format). */
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's address */
  physicalAddress?: InputMaybe<PhysicalAddressInput>;
  /** Defines if User is a politically exposed person (PEP).  */
  politicallyExposedDomesticPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is a politically exposed person (PEP) in a foreign country. */
  politicallyExposedForeignPerson?: InputMaybe<Scalars['Boolean']['input']>;
  positionAtEntity?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: InputMaybe<Scalars['SafeString']['input']>;
  registrationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /**
   * Relation of the creator (JWT holder) to the new affiliate entity.
   * When an advisor creates a beneficiary, pass ADVISOR so the advisor is not assigned OWNER.
   */
  relationToCreator?: InputMaybe<OrganizationUserEntityRelationTypes>;
  /** Unique requestID created by partner for each request to create a new user */
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  /**
   * User's Social Insurance Number
   * @deprecated use taxIdType=SIN and taxId instead
   */
  sin?: InputMaybe<Scalars['SafeString']['input']>;
  studentAreaOfStudy?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's Tax ID: SIN/BN (Canada), SSN/ITIN/EIN (United States). See taxIdType. */
  taxId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Type of taxId value */
  taxIdType?: InputMaybe<TaxIdTypes>;
};

/** Type definition for creating an "affiliate only" user */
export type CreateAffiliateResponse = {
  __typename?: 'CreateAffiliateResponse';
  /** User object */
  user: User;
};

export type CreateAlertBannerInput = {
  actionButton?: InputMaybe<ActionButtonInput>;
  bannerCopy?: InputMaybe<OrganizationTranslatedStringInput>;
  bannerType?: InputMaybe<BannerType>;
  configuration?: InputMaybe<AlertConfigurationInput>;
  endDate?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  persistenceBehaviour?: InputMaybe<PersistenceBehaviour>;
  roleProfiles?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  startDate?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  state?: InputMaybe<AlertState>;
};

export type CreateAlertBannerResponse = {
  __typename?: 'CreateAlertBannerResponse';
  alertBanner: AlertBanner;
};

export type CreateApiTokenInput = {
  name: Scalars['SafeString']['input'];
  organizationId: Scalars['ObjectID']['input'];
  permissions: Array<Scalars['SafeString']['input']>;
  whitelistAddresses?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
};

export type CreateApiTokenResponse = {
  __typename?: 'CreateApiTokenResponse';
  apiToken: ApiToken;
};

export type CreateArticleInput = {
  articleUrl: Scalars['SafeString']['input'];
  organizationId: Scalars['ObjectID']['input'];
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName: OrganizationTranslatedStringInput;
  /** Roles of the article's organization to show it to. Empty means every role. */
  visibleToRoleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type CreateArticleResponse = {
  __typename?: 'CreateArticleResponse';
  article?: Maybe<Article>;
};

export type CreateAssetClassInput = {
  includeCash?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['SafeString']['input'];
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  translatedDescription?: InputMaybe<ProductTranslatedStringInput>;
  translatedName: ProductTranslatedStringInput;
};

export type CreateAssetClassResponse = {
  __typename?: 'CreateAssetClassResponse';
  assetClass: AssetClass;
};

export type CreateBankAccountInput = {
  bankAccountHolderName?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's bank account number. 7-12 digits */
  bankAccountNumber: Scalars['SafeString']['input'];
  /** User's bank's account transit Physical address */
  bankAccountTransitPhysicalAddress?: InputMaybe<BankAccountTransitPhysicalAddressInput>;
  currency?: InputMaybe<BankAccountCurrencyTypes>;
  /** User's bank account institution number. 3 digits */
  institutionNumber?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<BankAccountIntegrationInput>>>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's bank account routing number for USA bank accounts. 9 digits */
  routingNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's bank account transit number. 5 digits */
  transitNumber?: InputMaybe<Scalars['SafeString']['input']>;
  userId: Scalars['ObjectID']['input'];
};

export type CreateBankAccountResponse = {
  __typename?: 'CreateBankAccountResponse';
  bankAccount: BankAccount;
};

export type CreateBankConnectionInput = {
  bankAccountRefId?: InputMaybe<Scalars['String']['input']>;
  loginId: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ObjectID']['input'];
};

export type CreateBankConnectionResponse = {
  __typename?: 'CreateBankConnectionResponse';
  bankConnection: BankConnection;
};

export type CreateBeneficiaryInput = {
  accountId: Scalars['ObjectID']['input'];
  allocation: Scalars['Float']['input'];
  name: Scalars['SafeString']['input'];
  relation: BeneficiaryRelation;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  successorAddress?: InputMaybe<SuccessorPhysicalAddressInput>;
  type: BeneficiaryType;
};

export type CreateBeneficiaryResponse = {
  __typename?: 'CreateBeneficiaryResponse';
  beneficiary: Beneficiary;
};

export type CreateBillingScheduleInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  frequency: BillingScheduleFrequencies;
  nextBillingDate: Scalars['GraphQLDate']['input'];
  nextCalculationDate: Scalars['GraphQLDate']['input'];
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type CreateBillingScheduleResponse = {
  __typename?: 'CreateBillingScheduleResponse';
  billingSchedule: BillingSchedule;
};

export type CreateBulkImportInput = {
  name?: InputMaybe<Scalars['SafeString']['input']>;
  organizationId: Scalars['ObjectID']['input'];
};

export type CreateBulkImportResponse = {
  __typename?: 'CreateBulkImportResponse';
  bulkImport?: Maybe<BulkImport>;
};

export type CreateBulkTradeRequestInput = {
  source: BulkTradeRequestSourceInput;
  sourceId: Scalars['ObjectID']['input'];
};

export type CreateBulkTradeRequestResponse = {
  __typename?: 'CreateBulkTradeRequestResponse';
  bulkTradeRequest: BulkTradeRequest;
};

export type CreateChequeTransferInput = {
  amountCents: Scalars['Long']['input'];
  currency?: InputMaybe<Currencies>;
  fiscalYear?: InputMaybe<Scalars['Int']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  type: TransferType;
};

export type CreateChequeTransferResponse = {
  __typename?: 'CreateChequeTransferResponse';
  transfer: Transfer;
};

/** Available fields that describe newly created clientGroup. */
export type CreateClientGroupInput = {
  accountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  businessIsMemberOfIiroc?: InputMaybe<Scalars['Boolean']['input']>;
  /** Coporate Business Type */
  businessType?: InputMaybe<CorporateBusinessTypes>;
  corporationCountry?: InputMaybe<CorporateCountries>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  /** Date entity was established in YYYY-MM-DD (ISO 8601 format).  */
  establishedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  incorporationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<UserIntegrationInput>>>;
  name: Scalars['SafeString']['input'];
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Phone number that contains 7-15 digits, including country code (E.164 format). */
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  physicalAddress?: InputMaybe<PhysicalAddressInput>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: InputMaybe<Scalars['SafeString']['input']>;
  /** Defines the clientGroup's primary User. It needs to be in the relationship list. */
  primaryUserId: Scalars['ObjectID']['input'];
  /** An array that describes different Users in a clientGroup, including their userIDs ('user'), the relationship type relative to the primary account holder ('type'), and the accessTypes.  */
  relationships?: InputMaybe<Array<RelationshipInput>>;
  taxNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** Defines if new clientGroup is HOUSEHOLD or BUSINESS.  */
  type: ClientGroupTypes;
};

/** ClientGroup Response */
export type CreateClientGroupResponse = {
  __typename?: 'CreateClientGroupResponse';
  /** clientGroup object */
  clientGroup?: Maybe<ClientGroup>;
};

export type CreateClientReportTemplateInput = {
  condition?: InputMaybe<ClientReportTemplateConditionInput>;
  isStatementOfType?: InputMaybe<StatementTypes>;
  objectType: ClientReportTemplateObjectTypes;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  reportType: ClientReportTemplateReportTypes;
  s3key?: InputMaybe<StatementTranslatedStringInput>;
  schedulerDayOfMonthOrWeek: Scalars['Int']['input'];
  schedulerEnableNotification?: InputMaybe<Scalars['Boolean']['input']>;
  schedulerFrequency: ClientReportFrequencies;
  schedulerOneTimeDateEnd?: InputMaybe<Scalars['GraphQLDate']['input']>;
  schedulerOneTimeDateStart?: InputMaybe<Scalars['GraphQLDate']['input']>;
  schedulerTriggerRules?: InputMaybe<Array<ClientReportTriggerRuleInput>>;
  settings?: InputMaybe<ClientReportTemplateSettingsInput>;
  templateParameters: Array<InputMaybe<Scalars['SafeString']['input']>>;
  translatedDescription: StatementTranslatedStringInput;
  translatedName: StatementTranslatedStringInput;
  type?: InputMaybe<Scalars['SafeString']['input']>;
};

export type CreateClientReportTemplatePageConfigurationInput = {
  clientReportTemplateId: Scalars['ObjectID']['input'];
  options?: InputMaybe<Scalars['Object']['input']>;
  type: ClientReportTemplatePageConfigurationTypes;
  widgets: Array<ClientReportTemplateWidgetConfigurationInput>;
};

export type CreateClientReportTemplatePageConfigurationResponse = {
  __typename?: 'CreateClientReportTemplatePageConfigurationResponse';
  clientReportTemplatePageConfiguration?: Maybe<ClientReportTemplatePageConfiguration>;
};

export type CreateConfigurableTablePageInput = {
  columns: Array<ConfigurableTablePageColumnInput>;
  customPageSizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  disclaimerText?: InputMaybe<OrganizationTranslatedStringInput>;
  disclaimerTitle?: InputMaybe<OrganizationTranslatedStringInput>;
  enableCustomPagination?: InputMaybe<Scalars['Boolean']['input']>;
  enableDownload?: InputMaybe<Scalars['Boolean']['input']>;
  endpointUrl: Scalars['String']['input'];
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<ConfigurableTablePageFilterInput>>>;
  name: OrganizationTranslatedStringInput;
  navigateToPath?: InputMaybe<ConfigurableTablePagePaths>;
  navigateToPathKey?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  paginationType?: InputMaybe<ConfigurableTablePagePaginationType>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  section: ConfigurableTablePageSectionInput;
  useTopSearchPanel?: InputMaybe<Scalars['Boolean']['input']>;
  widgets?: InputMaybe<Array<InputMaybe<ConfigurableTablePageWidgetInput>>>;
};

export type CreateConfigurableTablePageResponse = {
  __typename?: 'CreateConfigurableTablePageResponse';
  configurableTablePage: ConfigurableTablePage;
};

export type CreateCountryRiskInput = {
  country: Scalars['SafeString']['input'];
  countryCode: Scalars['SafeString']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  riskRating: RiskRatings;
};

export type CreateCountryRiskResponse = {
  __typename?: 'CreateCountryRiskResponse';
  countryRisk: CountryRisk;
};

export type CreateCustodianConnectionInput = {
  accountOpeningSubmissionType?: InputMaybe<CustodianAccountOpeningTypes>;
  accountTypeSettings?: InputMaybe<Array<InputMaybe<AccountTypeSettingsInput>>>;
  allowCashAsDepositTarget?: InputMaybe<Scalars['Boolean']['input']>;
  allowFractionalTrading?: InputMaybe<Scalars['Boolean']['input']>;
  allowTransactionCreation?: InputMaybe<Scalars['Boolean']['input']>;
  baseCurrency?: InputMaybe<CustodianConnectionCurrencyTypes>;
  bulkTradeAllowedExchanges?: InputMaybe<Array<InputMaybe<Exchanges>>>;
  ciRepNumber?: InputMaybe<Scalars['SafeString']['input']>;
  config?: InputMaybe<Scalars['Object']['input']>;
  custodianActivityImportFilePaths?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  custodianSnapshotImportFilePaths?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  custodianUsersImportFilePath?: InputMaybe<Scalars['SafeString']['input']>;
  customerName?: InputMaybe<Scalars['SafeString']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  disableCorpInventoryAccount?: InputMaybe<Scalars['Boolean']['input']>;
  disabledFlagTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableAccountOpeningSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoReconcileActivities?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoReconcilePositions?: InputMaybe<Scalars['Boolean']['input']>;
  enableCancelCustodianDepositTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  enableChallengedCustodianDepositTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  enableCreateCustodianDepositTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianAccountImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianActivityImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianCredentialsManager?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianInvestmentFundsImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianOrganizationImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianOrganizationUserImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianSnapshotImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianUserImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianAffiliates?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianBankAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianProjectedIncome?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianSnapshotHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianStatements?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianSuitability?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianUpcomingTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  enableSaveInternalRecordsOfCustodianDepositTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransferSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  fetchLivePrices?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<CustodianCustomFieldInput>>>;
  name: Scalars['SafeString']['input'];
  notificationEmails?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  organizationId: Scalars['ObjectID']['input'];
  reconciliationType?: InputMaybe<CustodianReconciliationTypes>;
  repCode?: InputMaybe<Scalars['SafeString']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  sftpCredentials?: InputMaybe<CreateSftpCredentialsInput>;
  transferSubmissionType?: InputMaybe<CustodianTransferSubmissionTypes>;
  type: CustodianConnectionTypes;
};

export type CreateCustodianConnectionResponse = {
  __typename?: 'CreateCustodianConnectionResponse';
  custodianConnection: CustodianConnection;
};

export type CreateCustodianDepositTransferBankAccountInput = {
  accountNumber: Scalars['String']['input'];
  institutionNumber: Scalars['String']['input'];
  transitNumber: Scalars['String']['input'];
};

export type CreateCustodianDepositTransferInput = {
  accountId: Scalars['ObjectID']['input'];
  amount: Scalars['Long']['input'];
  bankAccount: CreateCustodianDepositTransferBankAccountInput;
  frequency?: InputMaybe<CustodianFrequency>;
  fund: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateCustodianDepositTransferResponse = {
  __typename?: 'CreateCustodianDepositTransferResponse';
  action?: Maybe<CustodianDepositTransferAction>;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateCustodianInput = {
  customerName?: InputMaybe<Scalars['SafeString']['input']>;
  name: Scalars['SafeString']['input'];
  notificationEmails?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  organizationId: Scalars['ObjectID']['input'];
  repCode?: InputMaybe<Scalars['SafeString']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  sftpInBucket?: InputMaybe<Scalars['SafeString']['input']>;
  sftpOutBucket?: InputMaybe<Scalars['SafeString']['input']>;
  type: CustodianTypes;
};

export type CreateCustodianResponse = {
  __typename?: 'CreateCustodianResponse';
  custodian: Custodian;
};

export type CreateCustomAttributeLabelInput = {
  attributeName: CustomAttributeLabelNames;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  objectType: CustomAttributeLabelObjectTypes;
  options: Array<CustomAttributeLabelOptionInput>;
  organizationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomAttributeLabelResponse = {
  __typename?: 'CreateCustomAttributeLabelResponse';
  customAttributeLabel: CustomAttributeLabel;
};

export type CreateCustomFieldInput = {
  conditionalRules?: InputMaybe<Array<InputMaybe<CustomFieldConditionalRuleInput>>>;
  enableAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  enablePositiveNegativeSign?: InputMaybe<Scalars['Boolean']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  externalField?: InputMaybe<CustomFieldSource>;
  format?: InputMaybe<CustomFieldFormats>;
  key: Scalars['SafeString']['input'];
  objectType: CustomFieldObjectTypes;
  organizationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  selectOptions?: InputMaybe<Array<InputMaybe<CustomFieldSelectOptionInput>>>;
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName: OrganizationTranslatedStringInput;
  type: CustomFieldTypes;
  workflowStep?: InputMaybe<CustomFieldWorkflowSteps>;
};

export type CreateCustomFieldResponse = {
  __typename?: 'CreateCustomFieldResponse';
  customField?: Maybe<CustomField>;
};

export type CreateDepositTransferInput = {
  amountCents: Scalars['Long']['input'];
  /** Required if externalBankAccountId is not provided */
  bankAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  currency?: InputMaybe<Currencies>;
  externalBankAccountId?: InputMaybe<Scalars['SafeString']['input']>;
  fiscalYear?: InputMaybe<Scalars['Int']['input']>;
  /**
   * instantInvest skips the holding period before the amount is invested
   * Only available to partners with the certainty of deposits that do not bounce
   */
  instantInvest?: InputMaybe<Scalars['Boolean']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<HoldingIntegrationInput>>>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
};

export type CreateDisplayRoleInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['ObjectID']['input'];
};

export type CreateDisplayRoleResponse = {
  __typename?: 'CreateDisplayRoleResponse';
  displayRole: DisplayRole;
};

export type CreateDowntimeScheduleInput = {
  endTime?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  excludeRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  helpLink?: InputMaybe<Scalars['URLString']['input']>;
  name: Scalars['SafeString']['input'];
  /** @deprecated no longer using note string. Use translatedNote with OrganizationTranslatedStringInput instead. */
  note?: InputMaybe<Scalars['SafeString']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  platforms?: InputMaybe<Array<InputMaybe<Platforms>>>;
  startTime: Scalars['GraphQLDateTime']['input'];
  state?: InputMaybe<DowntimeScheduleState>;
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedNote?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedTitle: OrganizationTranslatedStringInput;
};

export type CreateDowntimeScheduleResponse = {
  __typename?: 'CreateDowntimeScheduleResponse';
  downtimeSchedule: DowntimeSchedule;
};

export type CreateExternalAccountStatementInput = {
  accountId: Scalars['ObjectID']['input'];
  fileName: Scalars['SafeString']['input'];
  referenceDate: Scalars['GraphQLDate']['input'];
  s3Key: Scalars['SafeString']['input'];
  state: AccountStatementStates;
  translatedFileName?: InputMaybe<StatementTranslatedStringInput>;
  type: StatementTypes;
};

export type CreateExternalAccountStatementResponse = {
  __typename?: 'CreateExternalAccountStatementResponse';
  accountStatementId: Scalars['ObjectID']['output'];
};

export type CreateExternalTransferInput = {
  /** ManualProcess's transfer Amount. */
  amountCents: Scalars['Int']['input'];
  /** ManualProcess's transfer bct esg Amount. */
  bctesgAmountCents?: InputMaybe<Scalars['Int']['input']>;
  /** ManualProcess's transfer clb Amount. */
  clbAmountCents?: InputMaybe<Scalars['Int']['input']>;
  /** The createdByUserId will be the transfer creating user */
  createdByUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** ManualProcess's intitution. */
  institution?: InputMaybe<CreateExternalTransferInstitutionInput>;
  /** USA Tansfers specific attribute */
  participantNumber?: InputMaybe<Scalars['String']['input']>;
  /** The Requesters IP Address */
  requestIpAddress?: InputMaybe<Scalars['SafeString']['input']>;
  /** ManualProcess's subAccount. */
  subAccountId: Scalars['ID']['input'];
  /** ManualProcess's transfer Account type. */
  transferAccount?: InputMaybe<ManualServiceAccountTypes>;
  /** ManualProcess's transfer Account number. */
  transferAccountNumber: Scalars['SafeString']['input'];
  /** ManualProcess's transferType. */
  transferMethod: ExternalTransferTypes;
};

export type CreateExternalTransferInstitutionInput = {
  /** Institution id */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Institution name */
  name?: InputMaybe<Scalars['SafeString']['input']>;
  /** Institution physical address */
  physicalAddress?: InputMaybe<InstitutionPhysicalAddressInput>;
};

export type CreateExternalTransferResponse = {
  __typename?: 'CreateExternalTransferResponse';
  manualProcess: ManualProcess;
};

export type CreateFeeTierInput = {
  blendedGrid?: InputMaybe<Scalars['Boolean']['input']>;
  chargeForCash?: InputMaybe<Scalars['Boolean']['input']>;
  chargeForCashOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  flatAnnualFeeBps?: InputMaybe<Scalars['Float']['input']>;
  grid?: InputMaybe<Array<InputMaybe<FeeTierGridInput>>>;
  gridScopeType?: InputMaybe<FeeGridScopeTypes>;
  name: Scalars['SafeString']['input'];
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFeeTierResponse = {
  __typename?: 'CreateFeeTierResponse';
  feeTier: FeeTier;
};

export type CreateFileDocumentInput = {
  applicableDocumentId?: InputMaybe<Scalars['SafeString']['input']>;
  fileName: Scalars['SafeString']['input'];
  mediaType?: InputMaybe<Scalars['SafeString']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  objectId: Scalars['ObjectID']['input'];
  objectType: FileDocumentObjectTypes;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  permissionType: FileDocumentPermissionTypes;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  requestIpAddress?: InputMaybe<Scalars['SafeString']['input']>;
  s3Path?: InputMaybe<Scalars['SafeString']['input']>;
  sharedClient?: InputMaybe<Scalars['Boolean']['input']>;
  sharedCustodian?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithRoleProfiles?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
  sourceType?: InputMaybe<Scalars['SafeString']['input']>;
  timestamp?: InputMaybe<Scalars['Long']['input']>;
  type: FileDocumentTypes;
  uploadedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

/** File Types */
export type CreateFileDocumentResponse = {
  __typename?: 'CreateFileDocumentResponse';
  fileDocument?: Maybe<FileDocument>;
};

export type CreateFinancialProductInput = {
  /** Auto updates prices using data partner? */
  autoUpdatePrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** The currency that this Financial product trades in. */
  currency?: InputMaybe<Currencies>;
  currentPriceCents?: InputMaybe<Scalars['Float']['input']>;
  cusip?: InputMaybe<Scalars['String']['input']>;
  /** The Stock Exchange that this Financial product trades in. */
  exchange?: InputMaybe<Scalars['String']['input']>;
  exchangeMic?: InputMaybe<Scalars['SafeString']['input']>;
  fundSeries?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<FinancialProductIntegrationInput>>>;
  /**
   * When true, allowed to allocate fractional trades.
   *
   * Defaults to true.
   */
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  isin?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The original (not converted) currency that this Financial product trades in. */
  originalCurrency?: InputMaybe<Currencies>;
  originalCurrentPriceCents?: InputMaybe<Scalars['Float']['input']>;
  /** Primary AssetClass of the product */
  primaryAssetClassId?: InputMaybe<Scalars['ObjectID']['input']>;
  ric?: InputMaybe<Scalars['String']['input']>;
  riskProfileDescription?: InputMaybe<ProductTranslatedStringInput>;
  riskProfileName?: InputMaybe<ProductTranslatedStringInput>;
  /** financialProduct scheduleID */
  scheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Secondary AssetClass of the product */
  secondaryAssetClassId?: InputMaybe<Scalars['ObjectID']['input']>;
  settlementDays?: InputMaybe<Scalars['Int']['input']>;
  /** The Strategy of the Financial product. */
  strategy?: InputMaybe<FinancialProductStrategy>;
  /** Optional substitute Financial product (used for Tax-Loss Harvesting). */
  substituteFinancialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The tax rank of the financial product, to be used for portfolio optimization */
  taxRank?: InputMaybe<Scalars['Int']['input']>;
  /** Tertiary AssetClass of the product */
  tertiaryAssetClassId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The trading ticker for this Financial product. */
  ticker?: InputMaybe<Scalars['SafeString']['input']>;
  /** The translated names of the Financial product. */
  translatedName: ProductTranslatedStringInput;
  translatedUrl?: InputMaybe<ProductTranslatedStringInput>;
  /** Type of Security. */
  type?: InputMaybe<SecurityTypes>;
  /** @deprecated url is deprecated, use translatedUrl instead */
  url?: InputMaybe<Scalars['String']['input']>;
  volatile?: InputMaybe<Scalars['Boolean']['input']>;
  /** A discount percentage applied to the corresponding holding amount during fee calculation (0 - 100%). */
  waivedFeePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateFinancialProductResponse = {
  __typename?: 'CreateFinancialProductResponse';
  /** The Financial product. */
  financialProduct: FinancialProduct;
  /** Warning messages for the operation. */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type CreateFormCompletionInput = {
  formDefinitionKey?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  requiredSignatures?: InputMaybe<Array<RequiredSignatureInput>>;
  signatures?: InputMaybe<Array<SignatureInput>>;
  signingType: FormDefinitionSigningTypes;
  state?: InputMaybe<FormCompletionStates>;
  templateType: FormDefinitionTemplateTypes;
  translatedDescription?: InputMaybe<TranslatedStringInput>;
  translatedName: TranslatedStringInput;
  userId: Scalars['ObjectID']['input'];
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type CreateFormCompletionResponse = {
  __typename?: 'CreateFormCompletionResponse';
  formCompletion: FormCompletion;
};

export type CreateFormDefinitionInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  fillingType?: InputMaybe<FormDefinitionFillingType>;
  integrations?: InputMaybe<Array<InputMaybe<FormDefinitionIntegrationInput>>>;
  key: Scalars['String']['input'];
  mappingWebhook?: InputMaybe<WebhookInput>;
  objectType: FormDefinitionObjectTypes;
  organizationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  signerMapping?: InputMaybe<Array<SignerMappingInput>>;
  signingType: FormDefinitionSigningTypes;
  templateType: FormDefinitionTemplateTypes;
  translatedDescription?: InputMaybe<TranslatedStringInput>;
  translatedName: TranslatedStringInput;
  translatedPdfFileName?: InputMaybe<TranslatedStringInput>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFormDefinitionResponse = {
  __typename?: 'CreateFormDefinitionResponse';
  formDefinition: FormDefinition;
};

export type CreateFormMapInput = {
  fields: Array<FormMapFieldInput>;
  formDefinitionId: Scalars['ObjectID']['input'];
  language: FormLanguageCode;
  removePdfMaxLength?: InputMaybe<Scalars['Boolean']['input']>;
  signaturePageNumberBase?: InputMaybe<SignaturePageNumberBase>;
  templateS3Key?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFormMapResponse = {
  __typename?: 'CreateFormMapResponse';
  formMap: FormMap;
};

export type CreateFormTemplateInput = {
  digitalSignatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  formType: FormTypes;
  minVersion?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  translatedMarkdown?: InputMaybe<TranslatedStringInput>;
};

export type CreateFormTemplateResponse = {
  __typename?: 'CreateFormTemplateResponse';
  formTemplate: FormTemplate;
};

export type CreateGoalInput = {
  /** @deprecated Use householdClientGroupId instead. */
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  expectedAnnualIncomeCents?: InputMaybe<Scalars['Int']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountIntegrationInput>>>;
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  retirementAge?: InputMaybe<Scalars['Int']['input']>;
  riskQuestion1: GoalRiskLevels;
  targetAmountCents?: InputMaybe<Scalars['Long']['input']>;
  targetDate?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  taxOptimized?: InputMaybe<Scalars['Boolean']['input']>;
  timeHorizon: GoalTimeHorizons;
  tradingProcess?: InputMaybe<PortfolioTradingProcesses>;
  type: GoalTypes;
  userId: Scalars['ObjectID']['input'];
};

export type CreateGoalResponse = {
  __typename?: 'CreateGoalResponse';
  goal: Goal;
};

export type CreateHomePageConfigurationInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['Object']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  translatedName: OrganizationTranslatedStringInput;
  widgets?: InputMaybe<Array<HomePageWidgetConfigurationInput>>;
};

export type CreateHomePageConfigurationResponse = {
  __typename?: 'CreateHomePageConfigurationResponse';
  homePageConfiguration?: Maybe<HomePageConfiguration>;
};

export type CreateInstitutionInput = {
  /** Institution isDraft */
  isDraft: Scalars['Boolean']['input'];
  /** Institution name */
  name: Scalars['SafeString']['input'];
  /** Institution Address */
  physicalAddress?: InputMaybe<InstitutionPhysicalAddressInput>;
};

export type CreateInstitutionResponse = {
  __typename?: 'CreateInstitutionResponse';
  institution: Institution;
};

export type CreateIntegrationFormAgreementInput = {
  config: FormAgreementIntegrationProviderConfigInput;
  documents?: InputMaybe<Array<InputMaybe<ESignDocumentInput>>>;
  metaData?: InputMaybe<Scalars['Object']['input']>;
  provider: FormAgreementIntegrationProviders;
  template: FormAgreementIntegrationTemplateInput;
  userId: Scalars['String']['input'];
};

export type CreateIntegrationFormAgreementResponse = {
  __typename?: 'CreateIntegrationFormAgreementResponse';
  formAgreement: FormAgreement;
};

export type CreateIntegrationFormPackInput = {
  /** @deprecated Using the user's organization instead */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  signerMapping: Array<IntegrationSignerMapping>;
  userId: Scalars['ObjectID']['input'];
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type CreateIntegrationFormPackResponse = {
  __typename?: 'CreateIntegrationFormPackResponse';
  integrationFormPack: IntegrationFormPack;
};

export type CreateIntegrationInput = {
  configuration?: InputMaybe<Scalars['Object']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  passthroughApiPrivateSecretName?: InputMaybe<Scalars['SafeString']['input']>;
  passthroughApiUrl?: InputMaybe<Scalars['URLString']['input']>;
  provider?: InputMaybe<IntegrationProviders>;
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supportedCountries?: InputMaybe<Array<CountryCodes>>;
  type: IntegrationTypes;
};

export type CreateIntegrationRequestPayloadInput = {
  integrationFormPackId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrations: Array<IntegrationRequestPayloadIntegrationInput>;
  organizationId: Scalars['ObjectID']['input'];
  requestFileDocumentId: Scalars['ObjectID']['input'];
  userId: Scalars['ObjectID']['input'];
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type CreateIntegrationRequestPayloadResponse = {
  __typename?: 'CreateIntegrationRequestPayloadResponse';
  integrationRequestPayload: IntegrationRequestPayload;
};

export type CreateIntegrationResponse = {
  __typename?: 'CreateIntegrationResponse';
  integration?: Maybe<Integration>;
};

export type CreateJobTitleRiskInput = {
  companyType: Scalars['SafeString']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle: Scalars['SafeString']['input'];
  riskRating: RiskRatings;
};

export type CreateJobTitleRiskResponse = {
  __typename?: 'CreateJobTitleRiskResponse';
  jobTitleRisk: JobTitleRisk;
};

export type CreateLinkTokenInput = {
  androidPackageName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Plaid client and secret are fetched internally */
  clientId?: InputMaybe<Scalars['String']['input']>;
  configType?: InputMaybe<LinkTokenConfig>;
  /** @deprecated Plaid client and secret are fetched internally */
  plaidSecret?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CreateLinkTokenResponse = {
  __typename?: 'CreateLinkTokenResponse';
  linkToken?: Maybe<Scalars['String']['output']>;
};

export type CreateLocalizationResponse = {
  __typename?: 'CreateLocalizationResponse';
  localization?: Maybe<Localization>;
};

export type CreateModelChangeProposalInput = {
  /**
   * Caller-supplied snapshot of the household's current live allocations.
   * Optional on DRAFT creation; required before submitting for signature.
   */
  currentAllocations?: InputMaybe<Array<ModelChangeAllocationInput>>;
  /** Snapshot of the current (live) asset-class group weights, for the compare view. */
  currentAssetClassBranches?: InputMaybe<Array<ModelChangeAssetClassBranchInput>>;
  /** Snapshot of the current (live) asset-class min/max threshold bands, for the compare view. */
  currentAssetClassThresholds?: InputMaybe<Array<TargetAllocationInput>>;
  /** Snapshot of the current (live) IPS/details narrative, for the compare view. */
  currentModelDetails?: InputMaybe<ModelChangeModelDetailsInput>;
  /**
   * The base/master model portfolio (FinancialProduct) being changed. For an
   * entity-scoped change this is the org shelf template; the proposal is written
   * against a private clone of it, not the master itself.
   */
  financialProductId: Scalars['ObjectID']['input'];
  /** The bound entity id (e.g. the household ClientGroup id). Required. */
  objectId?: InputMaybe<Scalars['ObjectID']['input']>;
  /**
   * Entity scope. Required — every proposal is scoped to one entity: an
   * entity-bound clone of the master is minted/reused and the proposal targets
   * that clone (the entity is repointed to it on MODEL_CHANGE_COMPLETED). A
   * missing or half-set scope is rejected with VALIDATION.
   */
  objectType?: InputMaybe<BoundObjectType>;
  /**
   * The organization that owns the bound entity (e.g. the household's
   * organization id — NOT the advisor's currently selected / active org, and
   * NOT the JWT caller org when those differ). The clone is minted/reused in
   * this org so there is one live clone per entity. The shelf master is still
   * resolved via org inheritance. Must be the caller's organization or one
   * below it in the hierarchy.
   */
  organizationId: Scalars['ObjectID']['input'];
  /**
   * The ACM's requested new allocation targets.
   * Required to be non-empty and summing to 100% before submitting.
   */
  proposedAllocations: Array<ModelChangeAllocationInput>;
  /** Proposed asset-class group weights (ASSET_CLASS proposals; branches sum to 100). */
  proposedAssetClassBranches?: InputMaybe<Array<ModelChangeAssetClassBranchInput>>;
  /** Proposed asset-class min/max threshold bands. Optional and independent of allocations. */
  proposedAssetClassThresholds?: InputMaybe<Array<TargetAllocationInput>>;
  /** Proposed IPS/details narrative. Optional and independent of allocations. */
  proposedModelDetails?: InputMaybe<ModelChangeModelDetailsInput>;
  /**
   * When true, archive an existing live clone from a different shelf master and
   * mint a fresh clone from financialProductId, as setupEntityBoundModel does.
   */
  replaceExistingBase?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateModelChangeProposalResponse = {
  __typename?: 'CreateModelChangeProposalResponse';
  modelChangeProposal: ModelChangeProposal;
};

export type CreateModelPortfolioInput = {
  /** Asset class branch allocations for ASSET_CLASS strategy portfolios */
  assetClassBranches?: InputMaybe<Array<AssetClassBranchInput>>;
  /** Asset class level for ASSET_CLASS strategy portfolios */
  assetClassLevel?: InputMaybe<AssetClassLevel>;
  /** Allocation branches */
  children?: InputMaybe<Array<InputMaybe<BranchInput>>>;
  /** Null means inherit the organization default. Tolerance must be 5-20. */
  driftCalculationMethod?: InputMaybe<DriftCalculationMethod>;
  driftTolerancePercent?: InputMaybe<Scalars['Int']['input']>;
  forecastedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  forecastedStandardDeviation?: InputMaybe<Scalars['Float']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<FinancialProductIntegrationInput>>>;
  /** Low threshold score for allowing access */
  lowThresholdScore?: InputMaybe<Scalars['Float']['input']>;
  /** The organization to link to the financial product to. */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  riskProfileName?: InputMaybe<ProductTranslatedStringInput>;
  riskReturnLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Optional schedule (used for illiquid portfolios). */
  scheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The Strategy of the Financial product. */
  strategy?: InputMaybe<FinancialProductStrategy>;
  /** Is this Financial product suggestable? */
  suggestable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum suitability score to have access to this Financial product. */
  suggestedMaxScore?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum suitability score to have access to this Financial product. */
  suggestedMinScore?: InputMaybe<Scalars['Float']['input']>;
  /** All Target Allocations */
  targetAllocations?: InputMaybe<Array<InputMaybe<TargetAllocationInput>>>;
  /** ID for the theme assigned */
  themeId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The translated investment objectives of the portfolio */
  translatedInvestmentObjective?: InputMaybe<ProductTranslatedStringInput>;
  /** The translated liquidity of the portfolio */
  translatedLiquidity?: InputMaybe<ProductTranslatedStringInput>;
  /** The translated names of the Financial product. */
  translatedName: ProductTranslatedStringInput;
  /** The translated descriptions of the portfolio */
  translatedPortfolioDescription?: InputMaybe<ProductTranslatedStringInput>;
  /** The translated disclaimers of the portfolio */
  translatedPortfolioDisclaimer?: InputMaybe<ProductRichTextTranslatedStringInput>;
  translatedUrl?: InputMaybe<ProductTranslatedStringInput>;
  /** @deprecated url is deprecated, use translatedUrl instead */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Whether the financial product is zero percent cash */
  zeroPercentCash?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateModelPortfolioResponse = {
  __typename?: 'CreateModelPortfolioResponse';
  /** The Financial product. */
  modelPortfolio: FinancialProduct;
};

export type CreateNoteInput = {
  content?: InputMaybe<Scalars['SafeString']['input']>;
  objectId: Scalars['ObjectID']['input'];
  objectType: NoteObjectTypes;
  type?: InputMaybe<NoteTypes>;
};

export type CreateNoteResponse = {
  __typename?: 'CreateNoteResponse';
  note?: Maybe<Note>;
};

export type CreateNotificationDefinitionInput = {
  bodyTemplate: NotificationTranslatedStringInput;
  linkTemplate?: InputMaybe<Scalars['SafeString']['input']>;
  linkText?: InputMaybe<NotificationTranslatedStringInput>;
  name: Scalars['SafeString']['input'];
  notificationChannels: Array<NotificationChannelInput>;
  notificationGroupId: Scalars['ObjectID']['input'];
  organizationId: Scalars['ObjectID']['input'];
  organizationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  roleProfileIds: Array<Scalars['ObjectID']['input']>;
  titleTemplate: NotificationTranslatedStringInput;
  triggerEventType?: InputMaybe<Scalars['String']['input']>;
  triggerObjectType: Scalars['String']['input'];
};

export type CreateNotificationGroupInput = {
  description?: InputMaybe<NotificationTranslatedStringInput>;
  name: NotificationTranslatedStringInput;
  notificationChannels: Array<NotificationChannelInput>;
  organizationId: Scalars['ObjectID']['input'];
};

export type CreateNotificationGroupResponse = {
  __typename?: 'CreateNotificationGroupResponse';
  notificationGroup: NotificationGroup;
};

export type CreateNotificationInput = {
  body: NotificationTranslatedStringInput;
  integrations?: InputMaybe<Array<NotificationIntegrationInput>>;
  link?: InputMaybe<Scalars['SafeString']['input']>;
  linkText?: InputMaybe<NotificationTranslatedStringInput>;
  notificationChannels: Array<NotificationChannelInput>;
  notificationGroupId: Scalars['ObjectID']['input'];
  organizationUserId: Scalars['ObjectID']['input'];
  title: NotificationTranslatedStringInput;
};

export type CreateNotificationResponse = {
  __typename?: 'CreateNotificationResponse';
  notification: Notification;
};

export type CreateOrganizationDashboardInput = {
  /** Extension key for identifying this resource as part of an extension. */
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  /** Version of the extension resource. */
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  /** Optional. When omitted, the dashboard is created with no global filters. */
  globalFilters?: InputMaybe<Array<DashboardGlobalFilterInput>>;
  /** @deprecated name is deprecated, use translatedName field instead */
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  /** Resource key for unique identification within an extension. */
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
  /** Widgets to add to the dashboard. */
  widgets: Array<WidgetInputType>;
};

export type CreateOrganizationDashboardResponse = {
  __typename?: 'CreateOrganizationDashboardResponse';
  dashboard?: Maybe<Dashboard>;
};

export type CreateOrganizationInput = {
  accountGroupAutoArchiveCustomFieldKey?: InputMaybe<Scalars['String']['input']>;
  accountGroupAutoArchiveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  accountTypeTaxRanks?: InputMaybe<Array<InputMaybe<AccountTypeTaxRankInput>>>;
  additionalAutoReconciliationTransactionTypes?: InputMaybe<Array<InputMaybe<AutoReconciliationTransactionTypeInput>>>;
  allowAccessToSubOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  allowChargePST?: InputMaybe<Scalars['Boolean']['input']>;
  allowDirectCommunication?: InputMaybe<Scalars['Boolean']['input']>;
  allowInstantInvest?: InputMaybe<Scalars['Boolean']['input']>;
  allowLogout?: InputMaybe<Scalars['Boolean']['input']>;
  allowPendingTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  allowPostOptimizationEditing?: InputMaybe<Scalars['Boolean']['input']>;
  analyticsIdentifier?: InputMaybe<Scalars['String']['input']>;
  auth0DisplayName?: InputMaybe<Scalars['SafeString']['input']>;
  autoInviteImportedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  autoLogoutAfterInactivity?: InputMaybe<Scalars['Boolean']['input']>;
  baseCurrency?: InputMaybe<CurrencyCodes>;
  blockSuspiciousTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  browserTabTitle?: InputMaybe<Scalars['String']['input']>;
  bulkTradingProcess?: InputMaybe<OrgBulkTradingProcesses>;
  cancelTransferCutoffDays?: InputMaybe<Scalars['Int']['input']>;
  cashOnHoldToTradeDays?: InputMaybe<Scalars['Int']['input']>;
  cashOnHoldToWithdrawDays?: InputMaybe<Scalars['Int']['input']>;
  clientHostedLoginClientId?: InputMaybe<Scalars['String']['input']>;
  clientHostedLoginRedirectUri?: InputMaybe<Scalars['String']['input']>;
  clientHostedLoginScope?: InputMaybe<Scalars['String']['input']>;
  clientHostedLoginURL?: InputMaybe<Scalars['String']['input']>;
  databaseAuthConnectionId?: InputMaybe<Scalars['SafeString']['input']>;
  databaseAuthConnectionName?: InputMaybe<Scalars['SafeString']['input']>;
  defaultAuthenticationConnection?: InputMaybe<AuthenticationConnections>;
  defaultDriftCalculationMethod?: InputMaybe<DriftCalculationMethod>;
  defaultDriftTolerancePercent?: InputMaybe<Scalars['Int']['input']>;
  defaultTradingProcess?: InputMaybe<OrgSubAccountTradingProcesses>;
  disableRebalanceReport?: InputMaybe<Scalars['Boolean']['input']>;
  disableStatsUpdateBasedOnTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  displayCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  displayMenuBar?: InputMaybe<Scalars['Boolean']['input']>;
  enableAllInKindTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoUpdateExchangeRates?: InputMaybe<Scalars['Boolean']['input']>;
  enableContactSupport?: InputMaybe<Scalars['Boolean']['input']>;
  enableEmailFrenchTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  enableFullCashTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  enableInactivityTimeOut?: InputMaybe<Scalars['Boolean']['input']>;
  enableLoginSettings?: InputMaybe<Scalars['Boolean']['input']>;
  enableManualUpdateExchangeRates?: InputMaybe<Scalars['Boolean']['input']>;
  enableMultiFactorAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  enablePartialCashTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  enableRemeberBrowser?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourcesAndArticles?: InputMaybe<Scalars['Boolean']['input']>;
  enableSingleLogout?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated entityName is deprecated, use translatedEntityName instead */
  entityName?: InputMaybe<Scalars['SafeString']['input']>;
  excludeAdminFeesFromClients?: InputMaybe<Scalars['Boolean']['input']>;
  externalClientTokenEmailKey?: InputMaybe<Scalars['SafeString']['input']>;
  externalClientTokenIntegrationIdKey?: InputMaybe<Scalars['SafeString']['input']>;
  faviconLink?: InputMaybe<Scalars['String']['input']>;
  fetchCurrentPricesOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated helpCentreUrl is deprecated, use translatedHelpCentreUrl instead */
  helpCentreUrl?: InputMaybe<Scalars['URLString']['input']>;
  hideAutoUpdatePrices?: InputMaybe<Scalars['Boolean']['input']>;
  historicalSnapshotsCutOffDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  historicalSnapshotsFrequency?: InputMaybe<HistoricalSnapshotsFrequency>;
  inactivityTimeoutInMinutes?: InputMaybe<Scalars['Int']['input']>;
  includeExternalClientTokenIntoContext?: InputMaybe<Scalars['Boolean']['input']>;
  invitationRedirectUrl?: InputMaybe<Scalars['URLString']['input']>;
  isReferral?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdictions?: InputMaybe<EnabledJurisdictionsInput>;
  jwtKeyUrl?: InputMaybe<Scalars['SafeString']['input']>;
  localizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  loginSettingsTitle?: InputMaybe<OrganizationTranslatedStringInput>;
  loginUrl?: InputMaybe<Scalars['URLString']['input']>;
  logoutRedirectUrl?: InputMaybe<Scalars['URLString']['input']>;
  marketValueDipThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  minInitialDepositCents?: InputMaybe<Scalars['Int']['input']>;
  minInvestAmountCents?: InputMaybe<Scalars['Int']['input']>;
  minRecurringDepositCents?: InputMaybe<Scalars['Int']['input']>;
  multiFactorAuthenticationOptions?: InputMaybe<Array<InputMaybe<MultiFactorAuthenticationOptions>>>;
  /** @deprecated name is deprecated, use translatedName instead */
  name?: InputMaybe<Scalars['SafeString']['input']>;
  optimizerProcess?: InputMaybe<OrgOptimizerProcesses>;
  parentId: Scalars['ObjectID']['input'];
  permissions?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  productShelfCurrencies?: InputMaybe<Array<InputMaybe<CurrencyCodes>>>;
  profileReviewTimeInMonths?: InputMaybe<Scalars['Int']['input']>;
  repCode?: InputMaybe<Scalars['SafeString']['input']>;
  requireManualAccountApproval?: InputMaybe<Scalars['Boolean']['input']>;
  reviewTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  subdomain: Scalars['SafeString']['input'];
  /** @deprecated supportUrl is deprecated, use translatedSupportUrl instead */
  supportUrl?: InputMaybe<Scalars['URLString']['input']>;
  /** @deprecated termsAndConditionsUrl is deprecated, use translatedTermsAndConditionsUrl instead */
  termsAndConditionsUrl?: InputMaybe<Scalars['URLString']['input']>;
  theme?: InputMaybe<OrganizationThemeInput>;
  themeTokens?: InputMaybe<Scalars['Object']['input']>;
  tokenExchangeValidationType?: InputMaybe<TokenExchangeValidationTypes>;
  translatedEntityName?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedHelpCentreUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedSupportUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedTermsAndConditionsUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  /** @deprecated no longer using a separate Client Auth0 */
  useClientOrgAuth0?: InputMaybe<Scalars['Boolean']['input']>;
  useParentAdvisorContacts?: InputMaybe<Scalars['Boolean']['input']>;
  useParentAlertBanners?: InputMaybe<Scalars['Boolean']['input']>;
  useParentArticles?: InputMaybe<Scalars['Boolean']['input']>;
  useParentAssetClasses?: InputMaybe<Scalars['Boolean']['input']>;
  useParentBillingSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  useParentClientReportTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  useParentConfigurableTablePages?: InputMaybe<Scalars['Boolean']['input']>;
  useParentCustodianConnections?: InputMaybe<Scalars['Boolean']['input']>;
  useParentCustomAttributeLabels?: InputMaybe<Scalars['Boolean']['input']>;
  useParentCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  useParentDashboards?: InputMaybe<Scalars['Boolean']['input']>;
  useParentDisplayRoles?: InputMaybe<Scalars['Boolean']['input']>;
  useParentDowntimeSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  useParentFeeTiers?: InputMaybe<Scalars['Boolean']['input']>;
  useParentFormDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  useParentFormTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  useParentHomePageConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentIntegrations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentLocalizations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentModelPortfolios?: InputMaybe<Scalars['Boolean']['input']>;
  useParentNotificationDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  useParentNotificationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  useParentPageConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentPortfolioTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  useParentProductShelf?: InputMaybe<Scalars['Boolean']['input']>;
  useParentRepCodes?: InputMaybe<Scalars['Boolean']['input']>;
  useParentRoleProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  useParentSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  useParentSignerTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useParentStaticPageWidgetConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentThemeTokens?: InputMaybe<Scalars['Boolean']['input']>;
  useParentThemes?: InputMaybe<Scalars['Boolean']['input']>;
  useParentWebhooks?: InputMaybe<Scalars['Boolean']['input']>;
  useParentWorkflows?: InputMaybe<Scalars['Boolean']['input']>;
  validateUniquenessForSubOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrganizationResponse = {
  __typename?: 'CreateOrganizationResponse';
  organization?: Maybe<Organization>;
};

export type CreateOrganizationUserInput = {
  accessType?: InputMaybe<OrganizationUserAccessTypes>;
  /** Automatically sends invitation to the new user (Default to true) */
  autoInviteUser?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['SafeString']['input']>;
  email: Scalars['SafeString']['input'];
  entities?: InputMaybe<Array<OrganizationUserEntityInput>>;
  firstName: Scalars['SafeString']['input'];
  language?: InputMaybe<Languages>;
  lastName: Scalars['SafeString']['input'];
  organizationId: Scalars['ObjectID']['input'];
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  repCodes?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  roleId: Scalars['ObjectID']['input'];
  viewFullClientGroup?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrganizationUserResponse = {
  __typename?: 'CreateOrganizationUserResponse';
  organizationUser?: Maybe<OrganizationUser>;
};

export type CreatePageConfigurationInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Scalars['Object']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  tabs?: InputMaybe<Array<TabConfigurationInput>>;
  type: PageConfigurationTypes;
};

export type CreatePageConfigurationResponse = {
  __typename?: 'CreatePageConfigurationResponse';
  pageConfiguration?: Maybe<PageConfiguration>;
};

export type CreatePortfolioTemplateInput = {
  /** The name of the template */
  name: Scalars['SafeString']['input'];
  /** The organization this template belongs to */
  organizationId: Scalars['ObjectID']['input'];
  /** The translated name of the template */
  translatedName: ProductTranslatedStringInput;
  /** The translated description of the template */
  translatedTemplateDescription?: InputMaybe<ProductTranslatedStringInput>;
};

export type CreatePortfolioTemplateResponse = {
  __typename?: 'CreatePortfolioTemplateResponse';
  portfolioTemplate: PortfolioTemplate;
};

export type CreateRepCodeInput = {
  code: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ObjectID']['input'];
};

export type CreateRepCodeResponse = {
  __typename?: 'CreateRepCodeResponse';
  repCode?: Maybe<RepCode>;
};

export type CreateReportInput = {
  accessType: ReportAccessType;
  columns: Array<Scalars['SafeString']['input']>;
  filters: Array<ReportFilterInput>;
  name: Scalars['SafeString']['input'];
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  sortDesc: Scalars['Boolean']['input'];
  sortField: Scalars['SafeString']['input'];
  type: ReportType;
};

export type CreateReportResponse = {
  __typename?: 'CreateReportResponse';
  report: DataReport;
};

export type CreateRestWebhookInput = {
  /** Any custom headers that may need to be set to be sent with the mutation to the assigned url. */
  customHeaders?: InputMaybe<Scalars['Object']['input']>;
  /** Any custom payload that may need to be sent on the body along with the fetched data. If informed, the fetched data will be sent as an object in the 'payload' attribute. */
  customPayloadAttributes?: InputMaybe<Scalars['Object']['input']>;
  /** The event type on the object that gets actioned to then send off the webhook. */
  eventType: Scalars['String']['input'];
  /** The graphql query string that would be used to query the OneVest partner gateway usually. The variable of '$id' is used for the actioned object. */
  gql: Scalars['String']['input'];
  /** The type of object you want to listen to, to receive a webhook on. */
  objectType: EventObject;
  /** Organization to which the crated webhook will be linked. If not informed, the organization of the context user will be considered. */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Any custom header through which the signed JWT may need to be sent. If not informed, the signed JWT will be sent in the 'OneVest-Authorization' header. */
  signedJwtHeader?: InputMaybe<Scalars['String']['input']>;
  /** GraphQL URL in which the webhook will hit. */
  url: Scalars['String']['input'];
};

export type CreateRoleInput = {
  accessiblePages?: InputMaybe<Array<Pages>>;
  accountGroupPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountGroupTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  configurableTablePageIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  dashboards?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  defaultAccessType?: InputMaybe<OrganizationUserAccessTypes>;
  defaultAuthenticationConnection?: InputMaybe<AuthenticationConnections>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  externalRoleId?: InputMaybe<Scalars['SafeString']['input']>;
  goalPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  homePageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  individualPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  individualTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  makeHouseholdDefaultView?: InputMaybe<Scalars['Boolean']['input']>;
  navigationStyle?: InputMaybe<NavigationStyles>;
  nonIndividualPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  nonIndividualTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  permissions?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  roleProfileId?: InputMaybe<Scalars['ObjectID']['input']>;
  roleType?: InputMaybe<RoleTypes>;
  subAccountPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  translatedDescription: OrganizationTranslatedStringInput;
  translatedName: OrganizationTranslatedStringInput;
};

export type CreateRoleProfileInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<RoleProfileTemplateInput>;
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
};

export type CreateRoleProfileResponse = {
  __typename?: 'CreateRoleProfileResponse';
  roleProfile?: Maybe<RoleProfile>;
};

export type CreateRoleResponse = {
  __typename?: 'CreateRoleResponse';
  role?: Maybe<Role>;
};

export type CreateSalesTaxConfigurationRevisionInput = {
  configurableTaxes: Array<ConfigurableSalesTaxInput>;
  effectiveFrom: Scalars['GraphQLDate']['input'];
  /** The organization the revision is written for: the caller's own organization or any descendant of it. Ancestors and unrelated organizations return NOT_ACCESSIBLE. The caller's own organization is recorded separately on the revision as createdBy.initiatorOrganizationReferenceId. */
  organizationId: Scalars['ObjectID']['input'];
  /** Optional idempotency key, unique across all organizations. Retrying with the same key and identical input returns the original revision. Reusing a key with different input, or for a different target organization, is rejected. Use a distinct key per target organization. */
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  supersedesRevisionId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CreateSalesTaxConfigurationRevisionResponse = {
  __typename?: 'CreateSalesTaxConfigurationRevisionResponse';
  salesTaxConfigurationRevision: SalesTaxConfigurationRevision;
};

export type CreateScheduleInput = {
  dates?: InputMaybe<Array<Scalars['GraphQLDate']['input']>>;
  name: Scalars['SafeString']['input'];
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CreateScheduleResponse = {
  __typename?: 'CreateScheduleResponse';
  schedule: Schedule;
};

export type CreateScheduledDepositTransferInput = {
  amountCents: Scalars['Long']['input'];
  /** Required if externalBankAccountId is not provided */
  bankAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  currency?: InputMaybe<Currencies>;
  endDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  externalBankAccountId?: InputMaybe<Scalars['SafeString']['input']>;
  fiscalYear?: InputMaybe<Scalars['Int']['input']>;
  frequency: Frequency;
  /**
   * instantInvest skips the holding period before the amount is invested
   * Only available to partners with the certainty of deposits that do not bounce
   */
  instantInvest?: InputMaybe<Scalars['Boolean']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  scheduledDate: Scalars['GraphQLDate']['input'];
  subAccountId: Scalars['ObjectID']['input'];
};

export type CreateScheduledIncomeFundTransferInput = {
  amountPayableType?: InputMaybe<AmountPayableType>;
  annualAmountCents?: InputMaybe<Scalars['Long']['input']>;
  bankAccountId: Scalars['ObjectID']['input'];
  currency?: InputMaybe<Currencies>;
  dateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  frequency: IncomeFundFrequency;
  scheduledDate: Scalars['GraphQLDate']['input'];
  specialTaxRate?: InputMaybe<Scalars['Float']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  taxOption?: InputMaybe<TaxOptionType>;
  totalWithdrawalAmountOption?: InputMaybe<TotalWithdrawalAmountOption>;
  transferredAmountCents?: InputMaybe<Scalars['Long']['input']>;
};

export type CreateScheduledIncomeFundTransferResponse = {
  __typename?: 'CreateScheduledIncomeFundTransferResponse';
  scheduledIncomeFundTransfer: ScheduledIncomeFundTransfer;
};

export type CreateScheduledTransferBetweenSubAccountsInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Currencies>;
  frequency: Frequency;
  fromSubAccountId: Scalars['ObjectID']['input'];
  scheduledDate: Scalars['GraphQLDate']['input'];
  toSubAccountId: Scalars['ObjectID']['input'];
  transferAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateScheduledTransferResponse = {
  __typename?: 'CreateScheduledTransferResponse';
  scheduledTransfer: ScheduledTransfer;
};

export type CreateScheduledWithdrawTransferInput = {
  amountCents: Scalars['Long']['input'];
  bankAccountId: Scalars['ObjectID']['input'];
  currency?: InputMaybe<Currencies>;
  endDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  frequency: Frequency;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  scheduledDate: Scalars['GraphQLDate']['input'];
  subAccountId: Scalars['ObjectID']['input'];
  usaFederalTaxWithholdingPercentage?: InputMaybe<Scalars['Float']['input']>;
  usaStateTaxWithholdingPercentage?: InputMaybe<Scalars['Float']['input']>;
  withdrawalReason?: InputMaybe<WithdrawalReason>;
  withdrawalReasonDescription?: InputMaybe<Scalars['SafeString']['input']>;
};

export type CreateSftpCredentialsInput = {
  sftpInAuthenticationType?: InputMaybe<Scalars['String']['input']>;
  sftpInBucket?: InputMaybe<Scalars['String']['input']>;
  sftpInBucketVariableName?: InputMaybe<Scalars['String']['input']>;
  sftpInDownloadFile?: InputMaybe<Scalars['Boolean']['input']>;
  sftpInHost?: InputMaybe<Scalars['String']['input']>;
  sftpInPassphrase?: InputMaybe<Scalars['String']['input']>;
  sftpInPassword?: InputMaybe<Scalars['String']['input']>;
  sftpInPort?: InputMaybe<Scalars['String']['input']>;
  sftpInPrivateKey?: InputMaybe<Scalars['String']['input']>;
  sftpInServerHostKey?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sftpInSourceDir?: InputMaybe<Scalars['String']['input']>;
  sftpInTargetPrefix?: InputMaybe<Scalars['String']['input']>;
  sftpInUsername?: InputMaybe<Scalars['String']['input']>;
  sftpOutAuthenticationType?: InputMaybe<Scalars['String']['input']>;
  sftpOutBucket?: InputMaybe<Scalars['String']['input']>;
  sftpOutBucketVariableName?: InputMaybe<Scalars['String']['input']>;
  sftpOutHost?: InputMaybe<Scalars['String']['input']>;
  sftpOutPassphrase?: InputMaybe<Scalars['String']['input']>;
  sftpOutPassword?: InputMaybe<Scalars['String']['input']>;
  sftpOutPort?: InputMaybe<Scalars['String']['input']>;
  sftpOutPrivateKey?: InputMaybe<Scalars['String']['input']>;
  sftpOutServerHostKey?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sftpOutTargetDir?: InputMaybe<Scalars['String']['input']>;
  sftpOutUsername?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSiemFeedInput = {
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  maxWindowMinutes?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ObjectID']['input'];
  whitelistAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateSiemFeedResponse = {
  __typename?: 'CreateSiemFeedResponse';
  jwtToken: Scalars['String']['output'];
  siemFeed: SiemFeed;
};

export type CreateSignerTypeInput = {
  defaultSigningOrder?: InputMaybe<Scalars['Int']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  organizationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  roleProfiles?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  translatedName: TranslatedStringInput;
};

export type CreateSignerTypeResponse = {
  __typename?: 'CreateSignerTypeResponse';
  signerType: SignerType;
};

export type CreateStaticPageWidgetConfigurationInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  widget: StaticWidgetConfigurationInput;
};

export type CreateStaticPageWidgetConfigurationResponse = {
  __typename?: 'CreateStaticPageWidgetConfigurationResponse';
  staticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
};

export type CreateStepInput = {
  branches?: InputMaybe<Array<WorkflowStepBranchInput>>;
  endNodePosition?: InputMaybe<NodePositionInput>;
  name: TranslatedStringInput;
  startNodePosition?: InputMaybe<NodePositionInput>;
  subSteps: Array<CreateSubStepInput>;
};

export type CreateSubAccountInput = {
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  accountType: AccountTypes;
  allowClientDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use the updateEntityFeeSetting mutation instead. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  /** @deprecated Use the updateEntityFeeSetting mutation instead. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  goalId?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountIntegrationInput>>>;
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Deprecated. Schedule will be inherited from given FinancialProduct */
  scheduleId?: InputMaybe<Scalars['SafeString']['input']>;
  skipIPS?: InputMaybe<Scalars['Boolean']['input']>;
  suitabilityScore?: InputMaybe<Scalars['Int']['input']>;
  themeId?: InputMaybe<Scalars['SafeString']['input']>;
  userId: Scalars['SafeString']['input'];
};

export type CreateSubAccountResponse = {
  __typename?: 'CreateSubAccountResponse';
  subAccount: SubAccount;
};

export type CreateSubStepInput = {
  branches?: InputMaybe<Array<WorkflowStepBranchInput>>;
  canGoBack: Scalars['Boolean']['input'];
  completeableBy: Array<SubStepCompleteableBys>;
  key?: InputMaybe<Scalars['String']['input']>;
  nodePosition?: InputMaybe<NodePositionInput>;
  options?: InputMaybe<Scalars['Object']['input']>;
  rolesCompleteableBy?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  skippable: Scalars['Boolean']['input'];
  type: SubStepTypes;
};

export type CreateSubTradeRequestInput = {
  actualQuantity?: InputMaybe<Scalars['Float']['input']>;
  actualTradePriceCents?: InputMaybe<Scalars['Float']['input']>;
  bulkTradeRequestId: Scalars['ObjectID']['input'];
  expectedQuantity?: InputMaybe<Scalars['Float']['input']>;
  expectedTradePriceCents?: InputMaybe<Scalars['Float']['input']>;
  financialProductId: Scalars['ObjectID']['input'];
  isSellAll?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
  moneyAllocatedCents: Scalars['Float']['input'];
  subAccountId: Scalars['ObjectID']['input'];
  type: SubTradeRequestTypes;
};

export type CreateSubTradeRequestInputV2 = {
  actualQuantity?: InputMaybe<Scalars['Float']['input']>;
  actualTradePriceCents?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currencies>;
  expectedQuantity?: InputMaybe<Scalars['Float']['input']>;
  expectedTradePriceCents?: InputMaybe<Scalars['Float']['input']>;
  financialProductId: Scalars['ObjectID']['input'];
  isSellAll?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
  moneyAllocatedCents?: InputMaybe<Scalars['Float']['input']>;
  portfolioReportId?: InputMaybe<Scalars['ObjectID']['input']>;
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  type: SubTradeRequestTypes;
};

export type CreateSubTradeRequestResponse = {
  __typename?: 'CreateSubTradeRequestResponse';
  subTradeRequest: SubTradeRequest;
};

export type CreateSubTradeRequestsInput = {
  /**
   *  @deprecated Not needed anymore, will be removed in the future
   * @deprecated Field no longer supported
   */
  bulkTradeRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Not needed anymore, will be removed in the future */
  source?: InputMaybe<SubTradeRequestSources>;
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
  subTradeRequests: Array<CreateSubTradeRequestInputV2>;
};

export type CreateTaxLotInput = {
  accountId: Scalars['ObjectID']['input'];
  date: Scalars['GraphQLDate']['input'];
  financialProductId: Scalars['ObjectID']['input'];
  priceCents: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type CreateTaxLotResponse = {
  __typename?: 'CreateTaxLotResponse';
  taxLot: TaxLot;
};

export type CreateThemeInput = {
  core?: InputMaybe<Scalars['Boolean']['input']>;
  iconKey?: InputMaybe<Scalars['SafeString']['input']>;
  key: Scalars['SafeString']['input'];
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  translatedDescription?: InputMaybe<ProductTranslatedStringInput>;
  translatedName: ProductTranslatedStringInput;
  translatedShortDescription?: InputMaybe<ProductTranslatedStringInput>;
};

export type CreateThemeResponse = {
  __typename?: 'CreateThemeResponse';
  theme: Theme;
};

export type CreateTradeInput = {
  actualQuantity: Scalars['Float']['input'];
  actualTradePriceCents: Scalars['Float']['input'];
  /** If createExternalTransfer is true and effectiveDate is informed, a matching EXTERNAL_TRANSFER (IN or OUT) will be created with the same amount (quantity x price) and date. */
  createExternalTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Currencies>;
  description?: InputMaybe<Scalars['SafeString']['input']>;
  /**
   * If effectiveDate is informed, the trade will be created as RECONCILED on the informed date.
   * Otherwise, the trade will be created as INITIATED.
   */
  effectiveDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  financialProductId: Scalars['ObjectID']['input'];
  subAccountId: Scalars['ObjectID']['input'];
  type: TradeType;
};

export type CreateTradeResponse = {
  __typename?: 'CreateTradeResponse';
  trade: Trade;
};

export type CreateTransactionInput = {
  additionalCashCents?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Execution order for transactions on the same date. Used to ensure correct ACB/Book Value calculations.
   * Example: For same-fund crystallizations, SWO should be 0 (sell first) and SWI should be 1 (buy second).
   * For corporate actions, set order to ensure removals process before additions.
   */
  adjustedCostBaseExecutionOrder?: InputMaybe<Scalars['Int']['input']>;
  bookCostCents?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currencies>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  date: Scalars['GraphQLDate']['input'];
  description?: InputMaybe<Scalars['SafeString']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  journalType?: InputMaybe<JournalTypes>;
  objectId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectType: TransactionObjectTypes;
  priceCents?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  toSubAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  type: TransactionTypes;
  valueCents: Scalars['Float']['input'];
};

export type CreateTransactionOptionsInput = {
  refreshSnapshotsSync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTransactionResponse = {
  __typename?: 'CreateTransactionResponse';
  pairedTransaction?: Maybe<Transaction>;
  transaction: Transaction;
};

export type CreateTransferResponse = {
  __typename?: 'CreateTransferResponse';
  transfer: Transfer;
};

/** Input type for creating a user's IdVerification */
export type CreateUserIdVerificationInformationInput = {
  address?: InputMaybe<PhysicalAddressInput>;
  creditFileSource?: InputMaybe<Scalars['SafeString']['input']>;
  /** The expiry date of the document in YYYY-MM-DD (ISO 8601 format). Required for DIGITAL_DOCUMENT_CHECK method.  */
  documentExpiryDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** The unique identifying number of the document used (Required for DIGITAL_DOCUMENT_CHECK method) */
  documentID?: InputMaybe<Scalars['SafeString']['input']>;
  /** The jurisdiction (province or state) and country of issue of the document (Required for DIGITAL_DOCUMENT_CHECK method) */
  documentIssuingJurisdication?: InputMaybe<Scalars['SafeString']['input']>;
  /** Type of the document used in the ID Verification (Required for DIGITAL_DOCUMENT_CHECK method) */
  documentType?: InputMaybe<IdDocumentTypes>;
  /** Method used for ID verification */
  methodOfIDVerification: IdVerificationMethods;
  /** Unique requestID created by partner for each request to create a new userIDVerification request. */
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date of birth on secondary document in YYYY-MM-DD (ISO 8601 format). Used in verification process.  */
  secondaryDocumentDateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Secondary document expiry date in YYYY-MM-DD (ISO 8601 format).  */
  secondaryDocumentExpiryDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  secondaryDocumentID?: InputMaybe<Scalars['SafeString']['input']>;
  secondaryDocumentIssuingJurisdication?: InputMaybe<Scalars['SafeString']['input']>;
  secondaryDocumentType?: InputMaybe<IdDocumentTypes>;
  secondaryDocumentUserName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date secondary document was verified in YYYY-MM-DD (ISO 8601 format).   */
  secondaryDocumentVerifiedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** UserID */
  userId: Scalars['ObjectID']['input'];
  /** The person's name on the document (Required for DIGITAL_DOCUMENT_CHECK method) */
  userName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date of ID verification in YYYY-MM-DD (ISO 8601 format). Required for DIGITAL_DOCUMENT_CHECK method.  */
  verifiedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

/** Input type for creating a user */
export type CreateUserInput = {
  /** Whether the user has advisor interest */
  advisorInterest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Advisor interest details */
  advisorInterestDetail?: InputMaybe<Scalars['String']['input']>;
  /** Optional field. Describes alternate address distinct from primary physical address.  */
  alternateAddress?: InputMaybe<AlternatePhysicalAddressInput>;
  /** Value of total amount User pays toward debts annually in amount cents. Used to determine risk suitability score. */
  annualDebtPaymentsCents?: InputMaybe<Scalars['Long']['input']>;
  /** Gross or net annual income in amount cents.  */
  annualIncomeCents?: InputMaybe<Scalars['Long']['input']>;
  /** Gross or net annual income in non-numeric form (range, category, etc).  */
  annualIncomeStr?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkAccountOpening?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use isMemberOfIiroc instead */
  businessIsMemberofIIROC?: InputMaybe<Scalars['Boolean']['input']>;
  /** Corporate contact number for entity types. Must contain 7-15 digits, including country code (E.164 format). */
  businessPhone?: InputMaybe<Scalars['SafeString']['input']>;
  charityRegistrationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's citizenships */
  citizenships?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /** Defines if User is a close associate of a politically exposed person (PEP). */
  closeAssociateOfPEP?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of company at which the user is employed */
  companyType?: InputMaybe<Scalars['SafeString']['input']>;
  complianceIssueSource?: InputMaybe<Scalars['SafeString']['input']>;
  complianceState?: InputMaybe<ComplianceStates>;
  countryOfRegistration?: InputMaybe<Scalars['SafeString']['input']>;
  /** Name of country using two-letter country code format (ISO 3166-1 alpha-2). Required for address validation, tax residency determination, and regulatory compliance. */
  countryOfTaxResidence?: InputMaybe<AddressCountries>;
  /** User's date of birth in YYYY-MM-DD (ISO 8601 format).  */
  dateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Decedent's date of death in YYYY-MM-DD (ISO 8601 format). Used for estate planning and account management. */
  dateOfDeath?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Types of debt associated with User. For example, student loan, mortgage, credit card debt, etc.  */
  debtAssociated?: InputMaybe<Array<InputMaybe<DebtAssociated>>>;
  /** Whether the user has discretion over the account */
  discretionOverAccountGranted?: InputMaybe<Scalars['Boolean']['input']>;
  employerCompanyAddress?: InputMaybe<PhysicalAddressInput>;
  /** Company phone number for User's employer. Must contain 7-15 digits, including country code (E.164 format).  */
  employerCompanyPhone?: InputMaybe<Scalars['SafeString']['input']>;
  employerName?: InputMaybe<Scalars['SafeString']['input']>;
  employmentSituation?: InputMaybe<EmploymentSituation>;
  employmentSituationOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's employment status */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  entityName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date entity was established in YYYY-MM-DD (ISO 8601 format).  */
  establishedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  fatcaStatus?: InputMaybe<FatcaStatus>;
  fatcaStatusOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Current market value of user's fixed, non-liquid assets in amount cents. */
  financialFixedAssetsCents?: InputMaybe<Scalars['Long']['input']>;
  /** User's liquid assets (cash or cash-equivalent investments) in amount cents. */
  financialLiquidAssetsCents?: InputMaybe<Scalars['Long']['input']>;
  firmNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** First name of user. */
  firstName?: InputMaybe<Scalars['SafeString']['input']>;
  /** The tax information provided by the user if the user pays tax to a foreign country */
  foreignTaxInformation?: InputMaybe<Array<InputMaybe<ForeignTaxInformationInput>>>;
  /** User's gender. Accepts MALE, FEMALE or OTHER */
  gender?: InputMaybe<Scalars['SafeString']['input']>;
  /** Whether the user has a guarantor */
  hasGuarantor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is or was the head of an international organization. */
  headOfInternationalOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  iDCheckCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  iDCheckRetrigger?: InputMaybe<Scalars['Boolean']['input']>;
  identificationType?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date user became a resident of current province/state in YYYY-MM-DD (ISO 8601 format). Determines provincial tax residency and compliance requirements.  */
  inProvinceSince?: InputMaybe<Scalars['GraphQLDate']['input']>;
  insiderSymbols?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  instructionsFromFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<UserIntegrationInput>>>;
  /** Whether the user trades with an investment firm */
  investmentFirmTrade?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the firm the user trades with */
  investmentFirmTradeName?: InputMaybe<Scalars['String']['input']>;
  /** Describes User's investment knowledge as one of four values: EXPERT, SOME, LIMITED, or NONE.   */
  investmentKnowledge?: InputMaybe<InvestmentKnowledge>;
  isAFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is an accredited investor. */
  isAccreditedInvestor?: InputMaybe<Scalars['Boolean']['input']>;
  isAffiliateOfFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use isNonProfit instead */
  isEntityForProfit?: InputMaybe<Scalars['Boolean']['input']>;
  isEntityRegulated?: InputMaybe<Scalars['Boolean']['input']>;
  isForThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  isLargeCorporation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is a member of Investment Industry Regulatory Organization of Canada (IIROC). */
  isMemberOfIiroc?: InputMaybe<Scalars['Boolean']['input']>;
  isNonProfit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is a high-level management executive of a public company */
  isOfficerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerOfEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is the owner of a public company */
  isOwnerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicBody?: InputMaybe<Scalars['Boolean']['input']>;
  isRegisteredWithCRA?: InputMaybe<Scalars['Boolean']['input']>;
  isRelatedToAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  isReportingIssuer?: InputMaybe<Scalars['Boolean']['input']>;
  isVulnerablePerson?: InputMaybe<Scalars['Boolean']['input']>;
  issuerExchange?: InputMaybe<Scalars['SafeString']['input']>;
  issuerName?: InputMaybe<Scalars['SafeString']['input']>;
  issuerTicker?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's job title, if user is employed */
  jobTitle?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's preferred language.  */
  language?: InputMaybe<Languages>;
  /** Last name of user. */
  lastName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Optional field. Describes User's mailing address if different from physical address.  */
  mailingAddress?: InputMaybe<PhysicalAddressInput>;
  /** Describes marital status of user.  */
  maritalStatus?: InputMaybe<MaritalStatus>;
  /** Middle name of user. */
  middleName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date of user's next suitability assessment review in YYYY-MM-DD (ISO 8601 format). Triggers Know Your Client (KYC) process.  */
  nextSuitabilityReviewAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Number of dependents associated with User */
  numberOfDependents?: InputMaybe<Scalars['Int']['input']>;
  /** Defines the organization that User should be added to.  */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The names of other persons guaranteeing the account */
  otherPersonGuaranteeNames?: InputMaybe<Scalars['String']['input']>;
  parentCompanyName?: InputMaybe<Scalars['SafeString']['input']>;
  /** User ID on the Partner system that uses the OneVest embedded web-app */
  partnerUserId?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated use foreignTaxInformation */
  payTaxesOutsideCanada?: InputMaybe<Scalars['Boolean']['input']>;
  /** String input that describes why User is a politically exposed person (PEP). */
  pepReason?: InputMaybe<Scalars['String']['input']>;
  /** User's primary phone number. Must contain 7-15 digits, including country code (E.164 format).  */
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's primary, physical address */
  physicalAddress?: InputMaybe<PhysicalAddressInput>;
  /** Defines if User is a politically exposed person (PEP).  */
  politicallyExposedDomesticPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is a politically exposed person (PEP) in a foreign country.  */
  politicallyExposedForeignPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User has appointed a Power of Attorney (POA).  */
  powerOfAttorneyGranted?: InputMaybe<Scalars['Boolean']['input']>;
  preferredMethodOfCommunication?: InputMaybe<MethodOfCommunication>;
  preferredMethodOfCommunicationOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: InputMaybe<Scalars['SafeString']['input']>;
  readyToSignAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  receivesDonationsFromPublic?: InputMaybe<Scalars['Boolean']['input']>;
  registrationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  regulatorName?: InputMaybe<Scalars['SafeString']['input']>;
  relatedEntities?: InputMaybe<Array<InputMaybe<RelatedEntityInput>>>;
  relationToCreator?: InputMaybe<OrganizationUserEntityRelationTypes>;
  /** Unique requestID that captures a single request for creating a new user */
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Expected age User wishes to retire. */
  retirementAge?: InputMaybe<Scalars['Int']['input']>;
  /** Answer to the first risk question. Used to generate user suitability score.  */
  riskQuestion1?: InputMaybe<RiskLevels>;
  /** Answer to the second risk question. Used to generate user suitability score. */
  riskQuestion2?: InputMaybe<RiskLevels>;
  riskScore?: InputMaybe<Scalars['Int']['input']>;
  /**
   * User's Social Insurance Number
   * @deprecated use taxIdType=SIN and taxId instead
   */
  sin?: InputMaybe<Scalars['SafeString']['input']>;
  sourceOfFunds?: InputMaybe<Array<InputMaybe<UserSourceOfFunds>>>;
  sourceOfFundsOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  sourceOfWealth?: InputMaybe<Array<InputMaybe<UserSourceOfWealth>>>;
  sourceOfWealthOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  spouseAddress?: InputMaybe<PhysicalAddressInput>;
  /** Gross or net annual income in amount cents of user's spouse. */
  spouseAnnualIncomeCents?: InputMaybe<Scalars['Long']['input']>;
  /** Gross or net annual income in non-numeric form (range, category, etc) of user's spouse. */
  spouseAnnualIncomeStr?: InputMaybe<Scalars['SafeString']['input']>;
  spouseAreaOfStudy?: InputMaybe<Scalars['SafeString']['input']>;
  /** Describes's spouse company type, if employed */
  spouseCompanyType?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date of birth for user's spouse in YYYY-MM-DD (ISO 8601 format). */
  spouseDateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  spouseEmail?: InputMaybe<Scalars['String']['input']>;
  spouseEmployerCompanyAddress?: InputMaybe<PhysicalAddressInput>;
  /** Company phone number for spouse's employer. Must contain 7-15 digits, including country code (E.164 format). */
  spouseEmployerCompanyPhone?: InputMaybe<Scalars['SafeString']['input']>;
  spouseEmployerName?: InputMaybe<Scalars['SafeString']['input']>;
  spouseEmploymentStatus?: InputMaybe<EmploymentStatus>;
  /** @deprecated Field no longer supported */
  spouseEmploymentType?: InputMaybe<Scalars['SafeString']['input']>;
  /** First name of user's spouse.  */
  spouseFirstName?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's spouse job title */
  spouseJobTitle?: InputMaybe<Scalars['SafeString']['input']>;
  /** Last name of user's spouse.  */
  spouseLastName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Middle name of user's spouse.  */
  spouseMiddleName?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated use spouseTaxId instead */
  spouseSin?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's spouse Tax identification number: SIN/BN (Canada), SSN/ITIN/EIN (United States). */
  spouseTaxId?: InputMaybe<Scalars['String']['input']>;
  spouseTaxIdType?: InputMaybe<TaxIdTypes>;
  /** User's spouse's title */
  spouseTitle?: InputMaybe<SpouseTitle>;
  ssSymbols?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /** Area of study, if user is a student */
  studentAreaOfStudy?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's Tax ID: SIN/BN (Canada), SSN/ITIN/EIN (United States). See taxIdType. */
  taxId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Type of taxId value */
  taxIdType?: InputMaybe<TaxIdTypes>;
  taxNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** The name of the third party for whom the user is acting */
  thirdPartyName?: InputMaybe<Scalars['String']['input']>;
  /** Timezone in IANA format (AREA/LOCATION). */
  timezone?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's title */
  title?: InputMaybe<UserTitle>;
  /** Total debt in amount cents. */
  totalDebtCents?: InputMaybe<Scalars['Long']['input']>;
  /** The name of the person with trading authority */
  tradingAuthorityName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user has trading authority over the account */
  tradingAuthorityOverAccountGranted?: InputMaybe<Scalars['Boolean']['input']>;
  /** User's trusted contact person details  */
  trustedContactPerson?: InputMaybe<TrustedContactPersonInput>;
  type?: InputMaybe<EntityTypes>;
  typeOfTrust?: InputMaybe<TrustTypes>;
  uniqueCircumstances?: InputMaybe<Scalars['SafeString']['input']>;
  /** Whether the user uses borrowed money for investments */
  useBorrowedMoney?: InputMaybe<Scalars['Boolean']['input']>;
  /** Entity's fiscal year end date in YYYY-MM-DD (ISO 8601 format). Used for financial reporting and tax purposes.  */
  yearEnd?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

/** Type definition for creating a user */
export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  /** User object */
  user: User;
};

export type CreateWebhookInput = {
  /** Any custom headers that may need to be set to be sent with the mutation to the assigned url. */
  customHeaders?: InputMaybe<Scalars['Object']['input']>;
  /** The event type on the object that gets actioned to then send off the webhook. */
  eventType: Scalars['String']['input'];
  /** The graphql query string that would be used to query the OneVest partner gateway usually. The variable of '$id' is used for the actioned object. */
  gql: Scalars['String']['input'];
  /** The name of the input that the webhook will pass, it will always pass as variable 'input'. */
  mutationInputName: Scalars['String']['input'];
  /** The name of the mutation that the webhook will hit. */
  mutationName: Scalars['String']['input'];
  /** The type of object you want to listen to, to receive a webhook on. */
  objectType: EventObject;
  /** Organization to which the crated webhook will be linked. If not informed, the organization of the context user will be considered. */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** GraphQL URL in which the webhook will hit. */
  url: Scalars['String']['input'];
};

export type CreateWebhookResponse = {
  __typename?: 'CreateWebhookResponse';
  webhook: Webhook;
};

export type CreateWithdrawTransferInput = {
  /** Transfer amount in cents. Minimum $100 (10000) */
  amountCents: Scalars['Long']['input'];
  /** User' Bank Account ID. */
  bankAccountId: Scalars['ObjectID']['input'];
  currency?: InputMaybe<Currencies>;
  integrations?: InputMaybe<Array<InputMaybe<HoldingIntegrationInput>>>;
  /** This an ID created by the partner, that is submitted with an transfer request and unique to each request. */
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Account that transfer is to be processed in. */
  subAccountId: Scalars['ObjectID']['input'];
  /** Federal tax withholding percentage */
  usaFederalTaxWithholdingPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** State tax withholding percentage */
  usaStateTaxWithholdingPercentage?: InputMaybe<Scalars['Float']['input']>;
  withdrawalMode?: InputMaybe<WithdrawalMode>;
  /** Withdrawal reason. */
  withdrawalReason?: InputMaybe<WithdrawalReason>;
  withdrawalReasonDescription?: InputMaybe<Scalars['SafeString']['input']>;
};

export type CreateWorkflowCompletionInput = {
  context?: InputMaybe<Scalars['Object']['input']>;
  objectId: Scalars['String']['input'];
  objectType: WorkflowObjectTypes;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  parentWorkflowCompletionId?: InputMaybe<Scalars['ObjectID']['input']>;
  workflowId: Scalars['ObjectID']['input'];
};

export type CreateWorkflowCompletionResponse = {
  __typename?: 'CreateWorkflowCompletionResponse';
  workflowCompletion: WorkflowCompletion;
};

export type CreateWorkflowInput = {
  applicableRoleProfileIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  complex?: InputMaybe<Scalars['Boolean']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  name: TranslatedStringInput;
  objectType: WorkflowObjectTypes;
  organizationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<WorkflowSettingsInput>;
  steps: Array<CreateStepInput>;
  triggerRules?: InputMaybe<Array<InputMaybe<TriggerRuleInput>>>;
  triggerType?: InputMaybe<TriggerTypes>;
};

export type CreateWorkflowResponse = {
  __typename?: 'CreateWorkflowResponse';
  workflow: Workflow;
};

export type CreationNotificationDefintionResponse = {
  __typename?: 'CreationNotificationDefintionResponse';
  notificationDefinition: NotificationDefinition;
};

export enum Currencies {
  Cad = 'CAD',
  Usd = 'USD'
}

export enum CurrencyCodes {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sle = 'SLE',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uyw = 'UYW',
  Uzs = 'UZS',
  Ved = 'VED',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}

export type CurrencyFallbackConversion = {
  from: Currencies;
  rate: Scalars['Float']['input'];
  to: Currencies;
};

/** Per-currency price map. Each field is the price expressed in the corresponding currency, in cents. */
export type CurrencyPriceCents = {
  __typename?: 'CurrencyPriceCents';
  CAD?: Maybe<Scalars['Float']['output']>;
  USD?: Maybe<Scalars['Float']['output']>;
};

export type CurrencyPriceCentsInput = {
  CAD?: InputMaybe<Scalars['Float']['input']>;
  USD?: InputMaybe<Scalars['Float']['input']>;
};

export type Custodian = {
  __typename?: 'Custodian';
  customerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  inventoryAccount?: Maybe<Account>;
  moneyAccount?: Maybe<Account>;
  name: Scalars['String']['output'];
  notificationEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organization: Organization;
  repCode?: Maybe<Scalars['String']['output']>;
  sftpInBucket?: Maybe<Scalars['String']['output']>;
  sftpOutBucket?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CustodianTypes>;
};

export enum CustodianAccountOpeningTypes {
  Batch = 'BATCH',
  Event = 'EVENT'
}

export enum CustodianAccountStatementStates {
  AwaitingReview = 'AWAITING_REVIEW',
  Failed = 'FAILED',
  Reconciled = 'RECONCILED'
}

export type CustodianAccountsDaily = {
  __typename?: 'CustodianAccountsDaily';
  account: Account;
  date: Scalars['GraphQLDateTime']['output'];
  holdings: Array<Holding>;
  id: Scalars['ObjectID']['output'];
  marketValueCents: Scalars['Int']['output'];
  moneyAvailableCents: Scalars['Int']['output'];
};

export type CustodianActivity = {
  __typename?: 'CustodianActivity';
  account?: Maybe<Account>;
  accruedInterest?: Maybe<Scalars['String']['output']>;
  amountValueCents?: Maybe<Scalars['Float']['output']>;
  bookValueAmountCents?: Maybe<Scalars['Float']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  cusip?: Maybe<Scalars['String']['output']>;
  custodianAccountNumber?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['GraphQLDate']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  forceReconciledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  isCancel?: Maybe<Scalars['Boolean']['output']>;
  notes: Array<CustodianActivityNote>;
  priceCents?: Maybe<Scalars['Float']['output']>;
  processDate?: Maybe<Scalars['GraphQLDate']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  reconcileMethod?: Maybe<ReconcileMethod>;
  reconciledAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  securityType?: Maybe<Scalars['String']['output']>;
  settleDate?: Maybe<Scalars['GraphQLDate']['output']>;
  state: CustodianActivityStates;
  subTransactionId?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  tradeCurrency?: Maybe<Scalars['String']['output']>;
  transactionDesc?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionType: Scalars['String']['output'];
};

/** Age bands for the pending backlog, by calendar-day age of processDate (UTC). */
export enum CustodianActivityChartBand {
  Age_0_1 = 'AGE_0_1',
  Age_1_3 = 'AGE_1_3',
  Age_3_7 = 'AGE_3_7',
  Age_7Plus = 'AGE_7_PLUS'
}

export type CustodianActivityChartBandBucket = {
  __typename?: 'CustodianActivityChartBandBucket';
  band: CustodianActivityChartBand;
  count: Scalars['Int']['output'];
};

/** End-of-day pending pile for one UTC day, plus that day's inflow/outflow. */
export type CustodianActivityChartDayPoint = {
  __typename?: 'CustodianActivityChartDayPoint';
  bands: Array<CustodianActivityChartBandBucket>;
  date: Scalars['GraphQLDate']['output'];
  inflowCount: Scalars['Int']['output'];
  outflowCount: Scalars['Int']['output'];
};

export type CustodianActivityChartTodayResult = {
  __typename?: 'CustodianActivityChartTodayResult';
  asOf: Scalars['GraphQLDateTime']['output'];
  /** Always all 4 bands, zero-filled. */
  bands: Array<CustodianActivityChartBandBucket>;
};

export enum CustodianActivityChartTrendRange {
  SevenDays = 'SEVEN_DAYS',
  ThirtyDays = 'THIRTY_DAYS'
}

export type CustodianActivityChartTrendResult = {
  __typename?: 'CustodianActivityChartTrendResult';
  asOf: Scalars['GraphQLDateTime']['output'];
  /** One point per UTC day in the range, zero-filled, ascending. */
  points: Array<CustodianActivityChartDayPoint>;
};

export type CustodianActivityMetrics = {
  __typename?: 'CustodianActivityMetrics';
  /** CREATED with processDate <= today − N days (UTC, BE-computed) — Aging tile. */
  agingPendingCount: Scalars['Int']['output'];
  /** All-time CREATED — Created tile. */
  createdCount: Scalars['Int']['output'];
  /** Any state, processDate within today (UTC, BE-computed) — Occurring Today tile. */
  occurringTodayCount: Scalars['Int']['output'];
  /** reconciledAt within today (UTC, BE-computed) — Reconciled Today tile. */
  reconciledTodayCount: Scalars['Int']['output'];
};

export type CustodianActivityNote = {
  __typename?: 'CustodianActivityNote';
  author: Scalars['String']['output'];
  authorId: Scalars['String']['output'];
  createdAt: Scalars['GraphQLDateTime']['output'];
  text: Scalars['String']['output'];
};

export enum CustodianActivityStates {
  Created = 'CREATED',
  Reconciled = 'RECONCILED'
}

export type CustodianActivityTaxInput = {
  taxAmountCents: Scalars['Float']['input'];
  type: Scalars['SafeString']['input'];
};

export enum CustodianActivityTransactionTypes {
  Acr = 'ACR',
  Adj = 'ADJ',
  Bor = 'BOR',
  Buy = 'BUY',
  Bva = 'BVA',
  Chq = 'CHQ',
  Clb = 'CLB',
  Com = 'COM',
  Cst = 'CST',
  Cxlbuy = 'CXLBUY',
  Cxlchq = 'CXLCHQ',
  Cxldep = 'CXLDEP',
  Cxldiv = 'CXLDIV',
  CxldscFee = 'CXLDSC_FEE',
  Cxleap = 'CXLEAP',
  Cxleft = 'CXLEFT',
  Cxlfee = 'CXLFEE',
  Cxlhst = 'CXLHST',
  Cxlint = 'CXLINT',
  Cxlmfv = 'CXLMFV',
  Cxlmgt = 'CXLMGT',
  Cxlpse = 'CXLPSE',
  Cxlreb = 'CXLREB',
  Cxlsell = 'CXLSELL',
  Cxltfi = 'CXLTFI',
  Cxltfo = 'CXLTFO',
  Cxltfr = 'CXLTFR',
  Dap = 'DAP',
  Dep = 'DEP',
  Dis = 'DIS',
  Div = 'DIV',
  Drf = 'DRF',
  DscFee = 'DSC_FEE',
  Eap = 'EAP',
  Eft = 'EFT',
  Egt = 'EGT',
  Fee = 'FEE',
  Grt = 'GRT',
  Gst = 'GST',
  Hbp = 'HBP',
  Hpb = 'HPB',
  Hst = 'HST',
  Int = 'INT',
  Lcg = 'LCG',
  Llp = 'LLP',
  Mdr = 'MDR',
  Mfq = 'MFQ',
  Mfv = 'MFV',
  Mgt = 'MGT',
  Ncw = 'NCW',
  Pse = 'PSE',
  Reb = 'REB',
  Red = 'RED',
  Ref = 'REF',
  Roc = 'ROC',
  Scg = 'SCG',
  Sell = 'SELL',
  Swi = 'SWI',
  Swo = 'SWO',
  Tfi = 'TFI',
  Tfo = 'TFO',
  Tfr = 'TFR',
  Wdh = 'WDH',
  Wdl = 'WDL',
  Whq = 'WHQ',
  Wir = 'WIR',
  Wof = 'WOF'
}

export type CustodianAffiliate = {
  __typename?: 'CustodianAffiliate';
  allocation?: Maybe<Scalars['Float']['output']>;
  contributionAmount?: Maybe<Scalars['Float']['output']>;
  grantAmount?: Maybe<Scalars['Float']['output']>;
  relation?: Maybe<CustodianAffiliationRelations>;
  type?: Maybe<CustodianAffiliationTypes>;
  user?: Maybe<CustodianUser>;
};

export enum CustodianAffiliationRelations {
  Child = 'CHILD',
  CommonLaw = 'COMMON_LAW',
  Grandchild = 'GRANDCHILD',
  Grandparent = 'GRANDPARENT',
  Guardian = 'GUARDIAN',
  NephewNiece = 'NEPHEW_NIECE',
  Other = 'OTHER',
  Parent = 'PARENT',
  PrimaryCaregiver = 'PRIMARY_CAREGIVER',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE'
}

export enum CustodianAffiliationTypes {
  AuthorizedIndividual = 'AUTHORIZED_INDIVIDUAL',
  BeneficialOwner = 'BENEFICIAL_OWNER',
  ContingentBeneficiary = 'CONTINGENT_BENEFICIARY',
  Contributor = 'CONTRIBUTOR',
  Director = 'DIRECTOR',
  Grantor = 'GRANTOR',
  Joint = 'JOINT',
  Other = 'OTHER',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  PrimaryBeneficiary = 'PRIMARY_BENEFICIARY',
  Protector = 'PROTECTOR',
  Settlor = 'SETTLOR',
  Successor = 'SUCCESSOR',
  ThirdParty = 'THIRD_PARTY',
  Trustee = 'TRUSTEE'
}

export type CustodianAssetClass = {
  __typename?: 'CustodianAssetClass';
  riskLevel?: Maybe<Scalars['Int']['output']>;
  translatedDescription?: Maybe<CustodianTranslatedString>;
  translatedName?: Maybe<CustodianTranslatedString>;
};

export type CustodianBankAccount = {
  __typename?: 'CustodianBankAccount';
  bankAccountNumber: Scalars['String']['output'];
  bankAccountNumberDisclosed?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  institutionNumber: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  transitNumber: Scalars['String']['output'];
  transitNumberDisclosed?: Maybe<Scalars['String']['output']>;
};

export type CustodianConnection = {
  __typename?: 'CustodianConnection';
  accountOpeningSubmissionType?: Maybe<CustodianAccountOpeningTypes>;
  accountTypeSettings?: Maybe<Array<Maybe<AccountTypeSettings>>>;
  allowCashAsDepositTarget?: Maybe<Scalars['Boolean']['output']>;
  allowFractionalTrading?: Maybe<Scalars['Boolean']['output']>;
  allowTransactionCreation?: Maybe<Scalars['Boolean']['output']>;
  baseCurrency?: Maybe<CustodianConnectionCurrencyTypes>;
  bulkTradeAllowedExchanges?: Maybe<Array<Maybe<Exchanges>>>;
  ciRepNumber?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['Object']['output']>;
  custodianActivityImportFilePaths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  custodianSnapshotImportFilePaths?: Maybe<Array<Maybe<Scalars['SafeString']['output']>>>;
  custodianUsersImportFilePath?: Maybe<Scalars['SafeString']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  disableCorpInventoryAccount?: Maybe<Scalars['Boolean']['output']>;
  disabledFlagTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enableAccountOpeningSubmission?: Maybe<Scalars['Boolean']['output']>;
  enableAutoReconcileActivities?: Maybe<Scalars['Boolean']['output']>;
  enableAutoReconcilePositions?: Maybe<Scalars['Boolean']['output']>;
  enableCancelCustodianDepositTransfer?: Maybe<Scalars['Boolean']['output']>;
  enableChallengedCustodianDepositTransfer?: Maybe<Scalars['Boolean']['output']>;
  enableCreateCustodianDepositTransfer?: Maybe<Scalars['Boolean']['output']>;
  enableCustodianAccountImport?: Maybe<Scalars['Boolean']['output']>;
  enableCustodianActivityImport?: Maybe<Scalars['Boolean']['output']>;
  enableCustodianCredentialsManager?: Maybe<Scalars['Boolean']['output']>;
  enableCustodianInvestmentFundsImport?: Maybe<Scalars['Boolean']['output']>;
  enableCustodianOrganizationImport?: Maybe<Scalars['Boolean']['output']>;
  enableCustodianOrganizationUserImport?: Maybe<Scalars['Boolean']['output']>;
  enableCustodianSnapshotImport?: Maybe<Scalars['Boolean']['output']>;
  enableCustodianUserImport?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianAffiliates?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianBankAccounts?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianCustomFields?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianNotifications?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianProjectedIncome?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianSnapshotHistory?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianStatements?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianStatistics?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianSuitability?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianTransactions?: Maybe<Scalars['Boolean']['output']>;
  enableFetchCustodianUpcomingTransactions?: Maybe<Scalars['Boolean']['output']>;
  enableSaveInternalRecordsOfCustodianDepositTransfers?: Maybe<Scalars['Boolean']['output']>;
  enableTransferSubmission?: Maybe<Scalars['Boolean']['output']>;
  fetchLivePrices?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  inventoryAccount?: Maybe<Account>;
  metadata?: Maybe<Array<Maybe<CustodianCustomField>>>;
  moneyAccount?: Maybe<Account>;
  name: Scalars['String']['output'];
  notificationEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organization?: Maybe<PublicOrganization>;
  reconciliationType?: Maybe<CustodianReconciliationTypes>;
  repCode?: Maybe<Scalars['String']['output']>;
  sftpCredentials?: Maybe<SftpCredentials>;
  transferSubmissionType?: Maybe<CustodianTransferSubmissionTypes>;
  type?: Maybe<CustodianConnectionTypes>;
};

export enum CustodianConnectionAccountTypes {
  CashJoint = 'CASH_JOINT',
  CorporateCash = 'CORPORATE_CASH',
  CorporateCharity = 'CORPORATE_CHARITY',
  CorporateEstate = 'CORPORATE_ESTATE',
  CorporateTrust = 'CORPORATE_TRUST',
  Dbpp = 'DBPP',
  Dpsp = 'DPSP',
  External = 'EXTERNAL',
  Fhsa = 'FHSA',
  Grsp = 'GRSP',
  GrspSpousal = 'GRSP_SPOUSAL',
  InformalTrust = 'INFORMAL_TRUST',
  InformalTrustJoint = 'INFORMAL_TRUST_JOINT',
  Investment = 'INVESTMENT',
  Ipp = 'IPP',
  Lif = 'LIF',
  Lira = 'LIRA',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  Margin = 'MARGIN',
  MarginJoint = 'MARGIN_JOINT',
  PensionPlan = 'PENSION_PLAN',
  Personal = 'PERSONAL',
  Prif = 'PRIF',
  Rdsp = 'RDSP',
  RdspJoint = 'RDSP_JOINT',
  Resp = 'RESP',
  RespAdult = 'RESP_ADULT',
  RespFamily = 'RESP_FAMILY',
  RespFamilyJoint = 'RESP_FAMILY_JOINT',
  RespSingle = 'RESP_SINGLE',
  RespSingleJoint = 'RESP_SINGLE_JOINT',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  Rlsp = 'RLSP',
  Rpp = 'RPP',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  Tfsa = 'TFSA',
  UkBrokerage = 'UK_BROKERAGE',
  UkCashIsa = 'UK_CASH_ISA',
  UkJisa = 'UK_JISA',
  UkPersonalPension = 'UK_PERSONAL_PENSION',
  UkSsIsa = 'UK_SS_ISA',
  Usa_401K = 'USA_401K',
  Usa_529 = 'USA_529',
  UsaBrokerage = 'USA_BROKERAGE',
  UsaCorporate = 'USA_CORPORATE',
  UsaCra = 'USA_CRA',
  UsaCustodial = 'USA_CUSTODIAL',
  UsaDaf = 'USA_DAF',
  UsaDbp = 'USA_DBP',
  UsaEsa = 'USA_ESA',
  UsaEstate = 'USA_ESTATE',
  UsaInhIra = 'USA_INH_IRA',
  UsaInhRtIra = 'USA_INH_RT_IRA',
  UsaIra = 'USA_IRA',
  UsaIraCustodial = 'USA_IRA_CUSTODIAL',
  UsaJtCp = 'USA_JT_CP',
  UsaJtCpMargin = 'USA_JT_CP_MARGIN',
  UsaJtJtbe = 'USA_JT_JTBE',
  UsaJtJtbeMargin = 'USA_JT_JTBE_MARGIN',
  UsaJtTic = 'USA_JT_TIC',
  UsaJtTicMargin = 'USA_JT_TIC_MARGIN',
  UsaJtWros = 'USA_JT_WROS',
  UsaJtWrosMargin = 'USA_JT_WROS_MARGIN',
  UsaKeogh = 'USA_KEOGH',
  UsaMargin = 'USA_MARGIN',
  UsaRoIra = 'USA_RO_IRA',
  UsaRtIra = 'USA_RT_IRA',
  UsaSepIra = 'USA_SEP_IRA',
  UsaSimpleIra = 'USA_SIMPLE_IRA',
  UsaSolo_401K = 'USA_SOLO_401K',
  UsaTod = 'USA_TOD',
  UsaTrust = 'USA_TRUST'
}

export type CustodianConnectionAffiliateSettings = {
  __typename?: 'CustodianConnectionAffiliateSettings';
  affiliateType?: Maybe<CustodianConnectionAffiliationTypes>;
  description?: Maybe<Scalars['String']['output']>;
  optionalFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requiredFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum CustodianConnectionAffiliationTypes {
  AuthorizedIndividual = 'AUTHORIZED_INDIVIDUAL',
  BeneficialOwner = 'BENEFICIAL_OWNER',
  ContingentBeneficiary = 'CONTINGENT_BENEFICIARY',
  Contributor = 'CONTRIBUTOR',
  Director = 'DIRECTOR',
  Grantor = 'GRANTOR',
  Guardian = 'GUARDIAN',
  Joint = 'JOINT',
  Other = 'OTHER',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  PrimaryBeneficiary = 'PRIMARY_BENEFICIARY',
  PrimaryCaregiver = 'PRIMARY_CAREGIVER',
  Protector = 'PROTECTOR',
  SeniorOfficer = 'SENIOR_OFFICER',
  Settlor = 'SETTLOR',
  Successor = 'SUCCESSOR',
  ThirdParty = 'THIRD_PARTY',
  Trustee = 'TRUSTEE'
}

export enum CustodianConnectionCurrencyTypes {
  Cad = 'CAD',
  Usd = 'USD'
}

export enum CustodianConnectionTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Mackenzie = 'MACKENZIE',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Schwab = 'SCHWAB'
}

export type CustodianConnectionsPaginationAndSorting = {
  additionalSortFields?: InputMaybe<Array<InputMaybe<AdditionalSortFieldInput>>>;
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type CustodianConnectionsQueryFilter = {
  accountTypes?: InputMaybe<Array<InputMaybe<CustodianConnectionAccountTypes>>>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryAccount?: InputMaybe<Scalars['ObjectID']['input']>;
  moneyAccount?: InputMaybe<Scalars['ObjectID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Custom Fields processing steps. */
export type CustodianCustomField = {
  __typename?: 'CustodianCustomField';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustodianCustomFieldInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustodianDepositTransferAction = {
  __typename?: 'CustodianDepositTransferAction';
  details?: Maybe<Array<Maybe<CustodianCustomField>>>;
  type: Scalars['String']['output'];
};

export enum CustodianExternalTransferTypes {
  AllInCash = 'ALL_IN_CASH',
  AllInKind = 'ALL_IN_KIND',
  PartialCash = 'PARTIAL_CASH'
}

export type CustodianFinancialProduct = {
  __typename?: 'CustodianFinancialProduct';
  cusip?: Maybe<Scalars['String']['output']>;
  exchangeMic?: Maybe<Scalars['String']['output']>;
  isCash?: Maybe<Scalars['Boolean']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  primaryAssetClass?: Maybe<CustodianAssetClass>;
  ric?: Maybe<Scalars['String']['output']>;
  secondaryAssetClass?: Maybe<CustodianAssetClass>;
  tertiaryAssetClass?: Maybe<CustodianAssetClass>;
  ticker?: Maybe<Scalars['String']['output']>;
  translatedName?: Maybe<CustodianTranslatedString>;
  translatedNickName?: Maybe<CustodianTranslatedString>;
  type?: Maybe<SecurityTypes>;
};

export enum CustodianFrequency {
  Annually = 'ANNUALLY',
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  SemiMonthly = 'SEMI_MONTHLY',
  Weekly = 'WEEKLY'
}

export type CustodianInstitution = {
  __typename?: 'CustodianInstitution';
  name: Scalars['String']['output'];
};

export type CustodianNotification = {
  __typename?: 'CustodianNotification';
  body?: Maybe<CustodianTranslatedString>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<CustodianTranslatedString>;
  read?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<CustodianTranslatedString>;
};

export enum CustodianNotificationChannelTypes {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Push = 'PUSH',
  Webhook = 'WEBHOOK'
}

export type CustodianProjectedIncome = {
  __typename?: 'CustodianProjectedIncome';
  amountCents: Scalars['Long']['output'];
  currency?: Maybe<CustodianStatisticsCurrencyTypes>;
  date: Scalars['String']['output'];
  financialProduct: CustodianFinancialProduct;
  foreignExchangeRates?: Maybe<Array<Maybe<CustodianStatisticsForeignExchangeRate>>>;
};

export enum CustodianReconciliationTypes {
  Full = 'FULL',
  Hybrid = 'HYBRID',
  ReadOnly = 'READ_ONLY'
}

export type CustodianSnapshotHistory = {
  __typename?: 'CustodianSnapshotHistory';
  currency?: Maybe<CustodianStatisticsCurrencyTypes>;
  date: Scalars['Date']['output'];
  foreignExchangeRates?: Maybe<Array<Maybe<CustodianStatisticsForeignExchangeRate>>>;
  integrationId: Scalars['String']['output'];
  marketValueCents?: Maybe<Scalars['Long']['output']>;
  moneyAvailableCents?: Maybe<Scalars['Long']['output']>;
  netContributionCents?: Maybe<Scalars['Long']['output']>;
  objectId: Scalars['ObjectID']['output'];
  objectType: Scalars['String']['output'];
};

export enum CustodianStatementTypes {
  AdministrativeFeesAnnualReport = 'ADMINISTRATIVE_FEES_ANNUAL_REPORT',
  AnnualAccountStatements = 'ANNUAL_ACCOUNT_STATEMENTS',
  AnnualPerformanceReport = 'ANNUAL_PERFORMANCE_REPORT',
  ConsolidatedMonthlyAccountStatements = 'CONSOLIDATED_MONTHLY_ACCOUNT_STATEMENTS',
  ManagementFeesAnnualReport = 'MANAGEMENT_FEES_ANNUAL_REPORT',
  MonthlyAccountStatements = 'MONTHLY_ACCOUNT_STATEMENTS',
  OvMonthlyAccountStatements = 'OV_MONTHLY_ACCOUNT_STATEMENTS',
  QuarterlyAccountStatements = 'QUARTERLY_ACCOUNT_STATEMENTS',
  TaxSlips_1099R = 'TAX_SLIPS_1099R',
  TaxSlipsConsolidated_1099 = 'TAX_SLIPS_CONSOLIDATED_1099',
  TaxSlipsFirst_60Days = 'TAX_SLIPS_FIRST_60_DAYS',
  TaxSlipsForm_480_6A = 'TAX_SLIPS_FORM_480_6A',
  TaxSlipsForm_480_6B = 'TAX_SLIPS_FORM_480_6B',
  TaxSlipsForm_1042S = 'TAX_SLIPS_FORM_1042_S',
  TaxSlipsForm_1099Q = 'TAX_SLIPS_FORM_1099_Q',
  TaxSlipsForm_1099R = 'TAX_SLIPS_FORM_1099_R',
  TaxSlipsForm_2439 = 'TAX_SLIPS_FORM_2439',
  TaxSlipsForm_5498 = 'TAX_SLIPS_FORM_5498',
  TaxSlipsLast_10Months = 'TAX_SLIPS_LAST_10_MONTHS',
  TaxSlipsNr4 = 'TAX_SLIPS_NR4',
  TaxSlipsT3Breakdown = 'TAX_SLIPS_T3_BREAKDOWN',
  TaxSlipsT3Rl16 = 'TAX_SLIPS_T3_RL16',
  TaxSlipsT4ARl1 = 'TAX_SLIPS_T4A_RL1',
  TaxSlipsT4RifRl2 = 'TAX_SLIPS_T4RIF_RL2',
  TaxSlipsT4RspRl2 = 'TAX_SLIPS_T4RSP_RL2',
  TaxSlipsT4Fhsa = 'TAX_SLIPS_T4_FHSA',
  TaxSlipsT5Rl3 = 'TAX_SLIPS_T5_RL3',
  TaxSlipsT5008 = 'TAX_SLIPS_T5008',
  TaxSlipsT5013Rl15 = 'TAX_SLIPS_T5013_RL15',
  TaxSlipsTradingSummary = 'TAX_SLIPS_TRADING_SUMMARY',
  TaxSlipGeneral = 'TAX_SLIP_GENERAL',
  TradeConfirmation = 'TRADE_CONFIRMATION'
}

export type CustodianStatements = {
  __typename?: 'CustodianStatements';
  account: Account;
  clientId?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  fetchExternalDocument?: Maybe<Scalars['Boolean']['output']>;
  fileName: Scalars['String']['output'];
  referenceDate?: Maybe<Scalars['DateTime']['output']>;
  s3key: Scalars['String']['output'];
  signedUrl?: Maybe<Scalars['String']['output']>;
  signedUrlFormat?: Maybe<SignedUrlDocumentFormat>;
  translatedFileName?: Maybe<CustodianTranslatedString>;
  type: CustodianStatementTypes;
  viewId?: Maybe<Scalars['String']['output']>;
};

export enum CustodianStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Requested = 'REQUESTED'
}

export type CustodianStatistics = {
  __typename?: 'CustodianStatistics';
  currency?: Maybe<CustodianStatisticsCurrencyTypes>;
  depositContributionCents?: Maybe<Scalars['Float']['output']>;
  eodMarketValueCents?: Maybe<Scalars['Long']['output']>;
  foreignExchangeRates?: Maybe<Array<Maybe<CustodianStatisticsForeignExchangeRate>>>;
  holdings?: Maybe<Array<Maybe<CustodianStatisticsHolding>>>;
  holdingsMissingRate?: Maybe<Array<Maybe<CustodianStatisticsHolding>>>;
  integrationId: Scalars['String']['output'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  marketValueCents: Scalars['Long']['output'];
  maxWithdrawalCents?: Maybe<Scalars['Float']['output']>;
  minWithdrawalCents?: Maybe<Scalars['Float']['output']>;
  moneyAvailableCents?: Maybe<Scalars['Long']['output']>;
  moneyWeightedReturn?: Maybe<Scalars['Float']['output']>;
  netContributionCents?: Maybe<Scalars['Long']['output']>;
  objectId: Scalars['ObjectID']['output'];
  objectType: Scalars['String']['output'];
  originalCurrencies?: Maybe<Array<Maybe<CustodianStatisticsOriginalCurrency>>>;
  originalCurrenciesMissingRate?: Maybe<Array<Maybe<CustodianStatisticsOriginalCurrency>>>;
  projectedIncome?: Maybe<Array<Maybe<CustodianProjectedIncome>>>;
  simpleReturnAmountCents?: Maybe<Scalars['Long']['output']>;
  simpleReturnPercent?: Maybe<Scalars['Float']['output']>;
  timeWeightedReturn?: Maybe<Scalars['Float']['output']>;
  withdrawContributionCents?: Maybe<Scalars['Float']['output']>;
};


export type CustodianStatisticsProjectedIncomeArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum CustodianStatisticsCurrencyTypes {
  Cad = 'CAD',
  Usd = 'USD'
}

export type CustodianStatisticsForeignExchangeRate = {
  __typename?: 'CustodianStatisticsForeignExchangeRate';
  date?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<CustodianStatisticsCurrencyTypes>;
  rate?: Maybe<Scalars['Long']['output']>;
  to?: Maybe<CustodianStatisticsCurrencyTypes>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustodianStatisticsHolding = {
  __typename?: 'CustodianStatisticsHolding';
  adjustedCostBaseCents?: Maybe<Scalars['Long']['output']>;
  currency?: Maybe<CustodianStatisticsCurrencyTypes>;
  currentPriceCents?: Maybe<Scalars['Long']['output']>;
  eodPriceCents?: Maybe<Scalars['Long']['output']>;
  eodTotalCents?: Maybe<Scalars['Long']['output']>;
  financialProduct: CustodianFinancialProduct;
  foreignExchangeRate?: Maybe<CustodianStatisticsForeignExchangeRate>;
  lastEodPriceUpdatedAt?: Maybe<Scalars['Date']['output']>;
  lastPriceUpdatedAt?: Maybe<Scalars['Date']['output']>;
  originalCurrency?: Maybe<CustodianStatisticsHoldingOriginalCurrency>;
  quantity: Scalars['Long']['output'];
  rateOfReturn?: Maybe<Scalars['Float']['output']>;
  totalCents: Scalars['Long']['output'];
};

export type CustodianStatisticsHoldingOriginalCurrency = {
  __typename?: 'CustodianStatisticsHoldingOriginalCurrency';
  adjustedCostBaseCents?: Maybe<Scalars['Long']['output']>;
  currency?: Maybe<CustodianStatisticsCurrencyTypes>;
  currentPriceCents?: Maybe<Scalars['Long']['output']>;
  eodPriceCents?: Maybe<Scalars['Long']['output']>;
  totalCents?: Maybe<Scalars['Long']['output']>;
};

export type CustodianStatisticsInput = {
  currency?: InputMaybe<CustodianStatisticsCurrencyTypes>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CustodianStatisticsOriginalCurrency = {
  __typename?: 'CustodianStatisticsOriginalCurrency';
  currency?: Maybe<CustodianStatisticsCurrencyTypes>;
  marketValueCents?: Maybe<Scalars['Long']['output']>;
  moneyAvailableCents?: Maybe<Scalars['Long']['output']>;
  netContributionCents?: Maybe<Scalars['Long']['output']>;
  simpleReturnAmountCents?: Maybe<Scalars['Long']['output']>;
};

export type CustodianTransaction = {
  __typename?: 'CustodianTransaction';
  account: Account;
  bookValueCents?: Maybe<Scalars['Float']['output']>;
  cashBalance?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currencies>;
  custodianTransactionType?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  financialProduct?: Maybe<CustodianFinancialProduct>;
  priceCents?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  settleDate: Scalars['Date']['output'];
  type: CustodianTransactionTypes;
  valueCents: Scalars['Float']['output'];
};

export enum CustodianTransactionTypes {
  AddCadEduSavingGrant = 'ADD_CAD_EDU_SAVING_GRANT',
  Adjustment = 'ADJUSTMENT',
  BorrowFee = 'BORROW_FEE',
  Buy = 'BUY',
  CanadaLearningBond = 'CANADA_LEARNING_BOND',
  CancelBuy = 'CANCEL_BUY',
  CancelCorporateAction = 'CANCEL_CORPORATE_ACTION',
  CancelEft = 'CANCEL_EFT',
  CancelManagementFee = 'CANCEL_MANAGEMENT_FEE',
  CancelSell = 'CANCEL_SELL',
  CancelSwitchIn = 'CANCEL_SWITCH_IN',
  CancelSwitchOut = 'CANCEL_SWITCH_OUT',
  CancelTransfer = 'CANCEL_TRANSFER',
  Cheque = 'CHEQUE',
  Contribution = 'CONTRIBUTION',
  CorporateAction = 'CORPORATE_ACTION',
  CustodyFee = 'CUSTODY_FEE',
  Deposit = 'DEPOSIT',
  DepositBuy = 'DEPOSIT_BUY',
  DeregistrationFee = 'DEREGISTRATION_FEE',
  DeregistrationTax = 'DEREGISTRATION_TAX',
  DisabilityAssistancePayment = 'DISABILITY_ASSISTANCE_PAYMENT',
  Distribution = 'DISTRIBUTION',
  DistributionReinvestment = 'DISTRIBUTION_REINVESTMENT',
  Dividend = 'DIVIDEND',
  Eft = 'EFT',
  Expense = 'EXPENSE',
  ExternalTransferIn = 'EXTERNAL_TRANSFER_IN',
  ExternalTransferInSecurity = 'EXTERNAL_TRANSFER_IN_SECURITY',
  ExternalTransferOut = 'EXTERNAL_TRANSFER_OUT',
  FederalTax = 'FEDERAL_TAX',
  GovContributions = 'GOV_CONTRIBUTIONS',
  Gst = 'GST',
  HomeBuyerPlan = 'HOME_BUYER_PLAN',
  Hst = 'HST',
  Income = 'INCOME',
  IncomeFundTransfer = 'INCOME_FUND_TRANSFER',
  Interest = 'INTEREST',
  LifeLearningPlan = 'LIFE_LEARNING_PLAN',
  LongTermGainLoss = 'LONG_TERM_GAIN_LOSS',
  ManagementFee = 'MANAGEMENT_FEE',
  NonEduCapitalWithdrawal = 'NON_EDU_CAPITAL_WITHDRAWAL',
  Other = 'OTHER',
  Rebate = 'REBATE',
  Redemption = 'REDEMPTION',
  ReturnOfCapital = 'RETURN_OF_CAPITAL',
  RiskExposureFee = 'RISK_EXPOSURE_FEE',
  Sell = 'SELL',
  ShortTermGainLoss = 'SHORT_TERM_GAIN_LOSS',
  SwiCost = 'SWI_COST',
  SwiMarket = 'SWI_MARKET',
  SwoCost = 'SWO_COST',
  SwoMarket = 'SWO_MARKET',
  TransferIn = 'TRANSFER_IN',
  TransferInSecurity = 'TRANSFER_IN_SECURITY',
  TransferOut = 'TRANSFER_OUT',
  Withdrawal = 'WITHDRAWAL',
  WithholdingTax = 'WITHHOLDING_TAX',
  WriteOff = 'WRITE_OFF'
}

export type CustodianTransfer = {
  __typename?: 'CustodianTransfer';
  account?: Maybe<Account>;
  amountCents: Scalars['Long']['output'];
  bankAccount?: Maybe<CustodianBankAccount>;
  createdAt: Scalars['DateTime']['output'];
  financialProduct?: Maybe<CustodianFinancialProduct>;
  frequency?: Maybe<CustodianFrequency>;
  scheduledDate: Scalars['DateTime']['output'];
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CustodianTransferState>;
  type: CustodianTransferType;
};

/** Transfer processing steps. */
export enum CustodianTransferState {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Inactive = 'INACTIVE',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Reconciled = 'RECONCILED',
  Requested = 'REQUESTED',
  Reviewing = 'REVIEWING'
}

export enum CustodianTransferSubmissionTypes {
  Batch = 'BATCH',
  Event = 'EVENT'
}

/** Supported Transfer types. */
export enum CustodianTransferType {
  Deposit = 'DEPOSIT',
  Withdraw = 'WITHDRAW'
}

export type CustodianTranslatedString = {
  __typename?: 'CustodianTranslatedString';
  en: Scalars['String']['output'];
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export enum CustodianTypes {
  Apex = 'APEX',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Mackenzie = 'MACKENZIE',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Schwab = 'SCHWAB'
}

export type CustodianUpcomingTransactionsResponse = {
  __typename?: 'CustodianUpcomingTransactionsResponse';
  totalTransfersCount?: Maybe<Scalars['Int']['output']>;
  upcomingTransactions?: Maybe<Array<Maybe<CustodianTransfer>>>;
};

export type CustodianUser = {
  __typename?: 'CustodianUser';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type CustomAttributeLabel = OrganizationExtensionResource & {
  __typename?: 'CustomAttributeLabel';
  attributeName: CustomAttributeLabelNames;
  createdAt: Scalars['GraphQLDateTime']['output'];
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  objectType: CustomAttributeLabelObjectTypes;
  options?: Maybe<Array<CustomAttributeLabelOption>>;
  organization: PublicOrganization;
  resourceKey?: Maybe<Scalars['String']['output']>;
  state: CustomAttributeLabelStates;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export enum CustomAttributeLabelNames {
  GoalRiskQuestion_1 = 'GOAL_RISK_QUESTION_1',
  InvestmentKnowledge = 'INVESTMENT_KNOWLEDGE',
  RiskQuestion_1 = 'RISK_QUESTION_1',
  RiskQuestion_2 = 'RISK_QUESTION_2',
  TimeHorizon = 'TIME_HORIZON'
}

export enum CustomAttributeLabelObjectTypes {
  Goal = 'GOAL',
  User = 'USER'
}

export type CustomAttributeLabelOption = {
  __typename?: 'CustomAttributeLabelOption';
  description?: Maybe<OrganizationTranslatedString>;
  label: OrganizationTranslatedString;
  value: Scalars['String']['output'];
};

export type CustomAttributeLabelOptionInput = {
  description?: InputMaybe<OrganizationTranslatedStringInput>;
  label: OrganizationTranslatedStringInput;
  value: Scalars['String']['input'];
};

export type CustomAttributeLabelPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type CustomAttributeLabelQueryFilter = {
  attributeName?: InputMaybe<CustomAttributeLabelNames>;
  objectType?: InputMaybe<CustomAttributeLabelObjectTypes>;
  organizationId: Scalars['ObjectID']['input'];
  state?: InputMaybe<Array<InputMaybe<CustomAttributeLabelStates>>>;
};

export enum CustomAttributeLabelStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export enum CustomAttributeLabelTransitions {
  Activate = 'activate',
  Archive = 'archive',
  Deactivate = 'deactivate'
}

export type CustomField = OrganizationExtensionResource & {
  __typename?: 'CustomField';
  conditionalRules?: Maybe<Array<Maybe<CustomFieldConditionalRule>>>;
  enableAggregation?: Maybe<Scalars['Boolean']['output']>;
  enablePositiveNegativeSign?: Maybe<Scalars['Boolean']['output']>;
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  externalField?: Maybe<CustomFieldSource>;
  format?: Maybe<CustomFieldFormats>;
  id: Scalars['ObjectID']['output'];
  key: Scalars['String']['output'];
  objectType: CustomFieldObjectTypes;
  organization?: Maybe<PublicOrganization>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  selectOptions?: Maybe<Array<Maybe<CustomFieldSelectOption>>>;
  state?: Maybe<CustomFieldStates>;
  translatedDescription?: Maybe<OrganizationTranslatedString>;
  translatedName: OrganizationTranslatedString;
  type: CustomFieldTypes;
  workflowStep?: Maybe<CustomFieldWorkflowSteps>;
};

export type CustomFieldConditionalRule = {
  __typename?: 'CustomFieldConditionalRule';
  comparison: CustomFieldConditionalRulesComparisonTypes;
  field: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomFieldConditionalRuleInput = {
  comparison: CustomFieldConditionalRulesComparisonTypes;
  field: Scalars['SafeString']['input'];
  value: Scalars['SafeString']['input'];
};

export enum CustomFieldConditionalRulesComparisonTypes {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanAgo = 'GREATER_THAN_AGO',
  In = 'IN',
  Includes = 'INCLUDES',
  LessThan = 'LESS_THAN',
  LessThanAgo = 'LESS_THAN_AGO',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN',
  NotIncludes = 'NOT_INCLUDES'
}

export enum CustomFieldFormats {
  BankAccount = 'BANK_ACCOUNT',
  Checkbox = 'CHECKBOX',
  Currency = 'CURRENCY',
  Custom = 'CUSTOM',
  CustomAgreements = 'CUSTOM_AGREEMENTS',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  DropdownList = 'DROPDOWN_LIST',
  Email = 'EMAIL',
  Number = 'NUMBER',
  Phone = 'PHONE',
  PhysicalAddress = 'PHYSICAL_ADDRESS',
  RadioButton = 'RADIO_BUTTON',
  SearchList = 'SEARCH_LIST',
  SimpleText = 'SIMPLE_TEXT',
  TextArea = 'TEXT_AREA',
  ToggleSwitch = 'TOGGLE_SWITCH'
}

export type CustomFieldInput = {
  key: Scalars['SafeString']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum CustomFieldObjectTypes {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  Entity = 'ENTITY',
  Goal = 'GOAL',
  Holding = 'HOLDING',
  Household = 'HOUSEHOLD',
  ScheduledTransfer = 'SCHEDULED_TRANSFER',
  SubAccount = 'SUB_ACCOUNT',
  Transaction = 'TRANSACTION',
  Transfer = 'TRANSFER'
}

export type CustomFieldQueryFilter = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectType?: InputMaybe<CustomFieldObjectTypes>;
  objectTypes?: InputMaybe<Array<CustomFieldObjectTypes>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomFieldTypes>;
  workflowStep?: InputMaybe<CustomFieldWorkflowSteps>;
};

export type CustomFieldSelectOption = {
  __typename?: 'CustomFieldSelectOption';
  displayText?: Maybe<OrganizationTranslatedString>;
  value: Scalars['JSON']['output'];
};

export type CustomFieldSelectOptionInput = {
  displayText?: InputMaybe<OrganizationTranslatedStringInput>;
  value: Scalars['JSON']['input'];
};

export enum CustomFieldSource {
  Custodian = 'CUSTODIAN',
  Internal = 'INTERNAL'
}

export enum CustomFieldStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum CustomFieldTransitions {
  Archive = 'archive'
}

export enum CustomFieldTypes {
  Boolean = 'BOOLEAN',
  CustomObject = 'CUSTOM_OBJECT',
  Date = 'DATE',
  Decimal = 'DECIMAL',
  Integer = 'INTEGER',
  MultipleSelect = 'MULTIPLE_SELECT',
  OrganizationUser = 'ORGANIZATION_USER',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT'
}

export enum CustomFieldWorkflowSteps {
  Approval = 'APPROVAL',
  Documents = 'DOCUMENTS',
  EditAccount = 'EDIT_ACCOUNT',
  EditGoal = 'EDIT_GOAL',
  EmploymentInformation = 'EMPLOYMENT_INFORMATION',
  Household = 'HOUSEHOLD',
  IncomeAssetsAndDebts = 'INCOME_ASSETS_AND_DEBTS',
  InvestmentKnowledge = 'INVESTMENT_KNOWLEDGE',
  NonIndividualInformation = 'NON_INDIVIDUAL_INFORMATION',
  PersonalInformation = 'PERSONAL_INFORMATION',
  PersonsOfInterest = 'PERSONS_OF_INTEREST',
  RelationshipInformation = 'RELATIONSHIP_INFORMATION',
  ResidencyInformation = 'RESIDENCY_INFORMATION',
  ReviewAllocations = 'REVIEW_ALLOCATIONS'
}

/**
 * How far a CUSTOMIZED household's signed account targets, blended at current
 * account values, sit from its model. Optimizer V2 rebalances each account to
 * its signed targets either way; past the tolerance the household as a whole
 * stays off the model after rebalancing.
 */
export type CustomizedMixGap = {
  __typename?: 'CustomizedMixGap';
  /** True when gapFraction > toleranceFraction. Advisory only; V2 still rebalances to the signed targets. */
  exceedsTolerance: Scalars['Boolean']['output'];
  /** The product with the largest gap. */
  financialProductId: Scalars['ObjectID']['output'];
  /** Largest per-product gap as a FRACTION of household investable value (market value minus expected cash; 0.0095 = 0.95pp). */
  gapFraction: Scalars['Float']['output'];
  /** Ticker of financialProductId. */
  ticker: Scalars['String']['output'];
  /** Gap above which the household is flagged, as a FRACTION. */
  toleranceFraction: Scalars['Float']['output'];
};

export type DailySnapshot = {
  __typename?: 'DailySnapshot';
  cashOnHoldToTradeCents?: Maybe<Scalars['Long']['output']>;
  cashOnHoldToWithdrawCents?: Maybe<Scalars['Long']['output']>;
  cashValueCents: Scalars['Long']['output'];
  currency?: Maybe<StatisticsCurrencyTypes>;
  date: Scalars['GraphQLDate']['output'];
  foreignExchangeRates?: Maybe<Array<Maybe<SnapshotForeignExchangeRate>>>;
  holdings: Array<SnapshotHolding>;
  holdingsMissingRate?: Maybe<Array<Maybe<SnapshotHolding>>>;
  id: Scalars['ObjectID']['output'];
  marketValueCents: Scalars['Long']['output'];
  moneyAvailableCents: Scalars['Long']['output'];
  netContributionCents: Scalars['Long']['output'];
  newContributionCents?: Maybe<Scalars['Long']['output']>;
  objectType: Scalars['String']['output'];
  originalCurrencies?: Maybe<Array<Maybe<DailySnapshotOriginalCurrency>>>;
  originalCurrenciesMissingRate?: Maybe<Array<Maybe<DailySnapshotOriginalCurrency>>>;
  snapshotAt: Scalars['GraphQLDateTime']['output'];
};

export type DailySnapshotOriginalCurrency = {
  __typename?: 'DailySnapshotOriginalCurrency';
  cashOnHoldToTradeCents?: Maybe<Scalars['Long']['output']>;
  cashOnHoldToWithdrawCents?: Maybe<Scalars['Long']['output']>;
  currency?: Maybe<StatisticsCurrencyTypes>;
  marketValueCents: Scalars['Long']['output'];
  moneyAvailableCents?: Maybe<Scalars['Long']['output']>;
  netContributionCents?: Maybe<Scalars['Long']['output']>;
  newContributionCents?: Maybe<Scalars['Long']['output']>;
};

export enum DailyStatsTypes {
  AccountsDaily = 'ACCOUNTS_DAILY',
  AccountGroupsDaily = 'ACCOUNT_GROUPS_DAILY',
  ClientGroupsDaily = 'CLIENT_GROUPS_DAILY',
  GoalsDaily = 'GOALS_DAILY',
  SubAccountsDaily = 'SUB_ACCOUNTS_DAILY',
  UsersDaily = 'USERS_DAILY'
}

export type Dashboard = OrganizationExtensionResource & {
  __typename?: 'Dashboard';
  /** @deprecated Use state field instead */
  archived: Scalars['Boolean']['output'];
  /** Extension key for identifying this resource as part of an extension. */
  extensionKey?: Maybe<Scalars['String']['output']>;
  /** Version of the extension resource. */
  extensionVersion?: Maybe<Scalars['String']['output']>;
  /** Filters applied to every widget on this dashboard that uses the same report type. Defaults to an empty list when none are set. */
  globalFilters: Array<DashboardGlobalFilter>;
  id: Scalars['ObjectID']['output'];
  /** @deprecated name is deprecated, use translatedName instead */
  name?: Maybe<Scalars['String']['output']>;
  /** Organization that owns this dashboard. Returns a limited set of fields available to sub-organizations. */
  organization: PublicOrganization;
  /** Resource key for unique identification within an extension. */
  resourceKey?: Maybe<Scalars['String']['output']>;
  /** Current state of the dashboard. Prefer this over archived. */
  state: DashboardStates;
  translatedName?: Maybe<OrganizationTranslatedString>;
  /** Widgets on this dashboard. Each widget has a report type and its own filters. */
  widgets: Array<Widget>;
};

/**
 * A filter applied to every widget on the dashboard that uses the same report type.
 * Separate from a widget's own filters.
 */
export type DashboardGlobalFilter = {
  __typename?: 'DashboardGlobalFilter';
  /** How the field is compared to the value. */
  comparison: WidgetFilterComparisonTypes;
  /** Field to filter on (for example, state or type). */
  field: Scalars['String']['output'];
  /** Report type this filter applies to. Only widgets with the same report type use it. */
  reportType: WidgetReportTypes;
  /** Value to compare against. */
  value: Scalars['String']['output'];
};

/**
 * A filter applied to every widget on the dashboard that uses the same report type.
 * Separate from a widget's own filters.
 */
export type DashboardGlobalFilterInput = {
  /** How the field is compared to the value. */
  comparison: WidgetFilterComparisonTypes;
  /** Field to filter on (for example, state or type). */
  field: Scalars['String']['input'];
  /** Report type this filter applies to. Only widgets with the same report type use it. */
  reportType: WidgetReportTypes;
  /** Value to compare against. */
  value: Scalars['String']['input'];
};

export type DashboardPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardQueryFilter = {
  /** Deprecated. Prefer states. When set, it is applied in addition to any state filter. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to dashboards from this extension. */
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  /** Organization to list dashboards for. When omitted, uses the authenticated user's organization. Results may include dashboards inherited from parent organizations. */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Filter to this resource within an extension. */
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  /** Filter by dashboard state. When omitted (and archived is also omitted), only active dashboards are returned. */
  states?: InputMaybe<Array<InputMaybe<DashboardStates>>>;
};

export enum DashboardStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum DashboardTransitions {
  Archive = 'archive'
}

export type DataApiExport = {
  __typename?: 'DataApiExport';
  columns: Array<DataApiExportColumn>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  datasetPath?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filter: Scalars['Object']['output'];
  id: Scalars['ObjectID']['output'];
  organization?: Maybe<PublicOrganization>;
  organizationUser: PublicOrganizationUser;
  perPage?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  queryPath?: Maybe<Scalars['String']['output']>;
  sortDesc?: Maybe<Scalars['Boolean']['output']>;
  sortField?: Maybe<Scalars['String']['output']>;
  state: DataExportStates;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type DataApiExportColumn = {
  __typename?: 'DataApiExportColumn';
  formatter?: Maybe<ApiExportFormatters>;
  gqlAlias: Scalars['String']['output'];
  header?: Maybe<Scalars['String']['output']>;
};

export type DataExport = {
  __typename?: 'DataExport';
  columns: Array<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filters: Array<ReportFilter>;
  id: Scalars['ObjectID']['output'];
  organizationUser: PublicOrganizationUser;
  sortDesc: Scalars['Boolean']['output'];
  sortField: Scalars['String']['output'];
  state: DataExportStates;
  type: ReportType;
};

export enum DataExportStates {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING'
}

export type DataMaskInput = {
  mask: Scalars['String']['input'];
  optionValue: Scalars['String']['input'];
};

export type DataMaskOutput = {
  __typename?: 'DataMaskOutput';
  mask: Scalars['String']['output'];
  optionValue: Scalars['String']['output'];
};

export type DataReport = {
  __typename?: 'DataReport';
  accessType: ReportAccessType;
  author: PublicOrganizationUser;
  columns: Array<Scalars['String']['output']>;
  filters: Array<ReportFilter>;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  organization: PublicOrganization;
  sortDesc: Scalars['Boolean']['output'];
  sortField: Scalars['String']['output'];
  type: ReportType;
};

/** Types of debt associated with User. For example, student loan, mortgage, credit card debt, etc.  */
export enum DebtAssociated {
  CreditCard = 'CREDIT_CARD',
  Mortgage = 'MORTGAGE',
  StudentLoan = 'STUDENT_LOAN'
}

export type DecisionSummaryInput = {
  impact: Scalars['String']['input'];
  stage: Scalars['String']['input'];
  summary: Scalars['String']['input'];
};

export type DeleteAccountStatementResponse = {
  __typename?: 'DeleteAccountStatementResponse';
  accountStatement?: Maybe<AccountStatement>;
  message?: Maybe<Scalars['SafeString']['output']>;
};

export type DeleteAlertBannerInput = {
  alertBannerId: Scalars['ObjectID']['input'];
};

export type DeleteAlertBannerResponse = {
  __typename?: 'DeleteAlertBannerResponse';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteArticleImageInput = {
  articleId: Scalars['ObjectID']['input'];
};

export type DeleteArticleImageResponse = {
  __typename?: 'DeleteArticleImageResponse';
  article?: Maybe<Article>;
};

export type DeleteArticleResponse = {
  __typename?: 'DeleteArticleResponse';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBankAccountResponse = {
  __typename?: 'DeleteBankAccountResponse';
  bankAccount: BankAccount;
};

export type DeleteFileDocumentInput = {
  /** fileDocumentId associated with the note which is updating */
  fileDocumentId: Scalars['ObjectID']['input'];
};

export type DeleteFileDocumentResponse = {
  __typename?: 'DeleteFileDocumentResponse';
  fileDocument?: Maybe<FileDocument>;
};

export type DeleteImportFileInput = {
  importFileId: Scalars['ObjectID']['input'];
};

export type DeleteImportFileResponse = {
  __typename?: 'DeleteImportFileResponse';
  importFile?: Maybe<ImportFile>;
};

export type DeleteInstitutionInput = {
  /** This an ID created by the partner, that is submitted with a request to create a new Institution and unique to each request. */
  id: Scalars['ID']['input'];
};

export type DeleteInstitutionResponse = {
  __typename?: 'DeleteInstitutionResponse';
  institution: Institution;
};

export type DeleteIntegrationStatefulDataInput = {
  integrationId: Scalars['ObjectID']['input'];
  key: Scalars['String']['input'];
};

export type DeleteIntegrationStatefulDataResponse = {
  __typename?: 'DeleteIntegrationStatefulDataResponse';
  integrationStatefulData?: Maybe<IntegrationStatefulData>;
};

export type DeleteNotificationDefinitionInput = {
  notificationDefinitionId: Scalars['ObjectID']['input'];
};

export type DeleteNotificationGroupInput = {
  notificationGroupId: Scalars['ObjectID']['input'];
};

export type DeleteOrganizationDashboardInput = {
  dashboardId: Scalars['ObjectID']['input'];
};

export type DeleteOrganizationDashboardResponse = {
  __typename?: 'DeleteOrganizationDashboardResponse';
  dashboard?: Maybe<Dashboard>;
};

export type DeleteOrganizationUserResponse = {
  __typename?: 'DeleteOrganizationUserResponse';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteReportInput = {
  reportId: Scalars['ObjectID']['input'];
};

export type DeleteReportResponse = {
  __typename?: 'DeleteReportResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteRoleResponse = {
  __typename?: 'DeleteRoleResponse';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSiemFeedResponse = {
  __typename?: 'DeleteSiemFeedResponse';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteTaxLotInput = {
  accountId: Scalars['ObjectID']['input'];
  financialProductId: Scalars['ObjectID']['input'];
  taxLotId: Scalars['ObjectID']['input'];
};

export type DeleteTaxLotResponse = {
  __typename?: 'DeleteTaxLotResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteTransactionOptionsInput = {
  refreshSnapshotsSync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteTransactionResponse = {
  __typename?: 'DeleteTransactionResponse';
  pairedTransaction?: Maybe<Transaction>;
  transaction: Transaction;
};

export type DeleteWebhookResponse = {
  __typename?: 'DeleteWebhookResponse';
  message: Scalars['String']['output'];
  webhook: Webhook;
};

export type DisplayRole = {
  __typename?: 'DisplayRole';
  advisorContactCount: Scalars['Int']['output'];
  createdAt: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  isInherited?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  organization: PublicOrganization;
  organizationUserCount: Scalars['Int']['output'];
  state: DisplayRoleStates;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type DisplayRoleQueryFilter = {
  state?: InputMaybe<Array<InputMaybe<DisplayRoleStates>>>;
};

export enum DisplayRoleStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum DisplayRoleTransitions {
  Archive = 'archive'
}

export type DownloadAccountStatementsInput = {
  accountStatementIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  objectId: Scalars['ObjectID']['input'];
  objectType: AccountStatementObjectTypes;
  type: StatementTypes;
};

export type DownloadAccountStatementsResponse = {
  __typename?: 'DownloadAccountStatementsResponse';
  failureCount: Scalars['Int']['output'];
  signedUrl: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalFiles: Scalars['Int']['output'];
};

export type DownloadFileDocumentsInput = {
  fileDocumentIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  objectId: Scalars['ObjectID']['input'];
  objectType: FileDocumentObjectTypes;
};

export type DownloadFileDocumentsResponse = {
  __typename?: 'DownloadFileDocumentsResponse';
  failureCount: Scalars['Int']['output'];
  signedUrl: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
  totalFiles: Scalars['Int']['output'];
};

export type DowntimeSchedule = {
  __typename?: 'DowntimeSchedule';
  endTime?: Maybe<Scalars['GraphQLDateTime']['output']>;
  excludeRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  helpLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated no longer using note string. Use translatedNote with OrganizationTranslatedStringInput instead */
  note?: Maybe<Scalars['String']['output']>;
  organization: PublicOrganization;
  platforms?: Maybe<Array<Maybe<Platforms>>>;
  startTime: Scalars['GraphQLDateTime']['output'];
  state?: Maybe<DowntimeScheduleState>;
  translatedDescription: OrganizationTranslatedString;
  translatedNote?: Maybe<OrganizationTranslatedString>;
  translatedTitle: OrganizationTranslatedString;
};

export type DowntimeSchedulePaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type DowntimeScheduleQueryFilter = {
  applyRoleExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Scalars['ObjectID']['input']>;
  platforms?: InputMaybe<Array<InputMaybe<Platforms>>>;
  state?: InputMaybe<DowntimeScheduleState>;
};

export enum DowntimeScheduleState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export enum DowntimeScheduleTransitionStates {
  Activate = 'activate',
  Archive = 'archive',
  Deactivate = 'deactivate'
}

export enum DriftCalculationMethod {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE'
}

export enum DriftRecalculationOutcomes {
  NothingToRecalculate = 'NOTHING_TO_RECALCULATE',
  Recalculated = 'RECALCULATED'
}

export enum DriftRecalculationStates {
  Idle = 'IDLE',
  Recalculating = 'RECALCULATING'
}

export type ESignDocumentInput = {
  fileDocumentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  signatures?: InputMaybe<Array<InputMaybe<ESignDocumentSignatureInput>>>;
};

export type ESignDocumentSignatureFieldInput = {
  /** 'DOCUMENT' or 'PACKAGE' */
  binding: Scalars['String']['input'];
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  page: Scalars['Int']['input'];
  /** 'FULLNAME' or 'INITIALS */
  subtype: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  /** always 'SIGNATURE */
  type: Scalars['String']['input'];
  width: Scalars['Float']['input'];
};

export type ESignDocumentSignatureInput = {
  enforceCaptureSignature?: InputMaybe<Scalars['Boolean']['input']>;
  fields: Array<InputMaybe<ESignDocumentSignatureFieldInput>>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  role: Scalars['String']['input'];
};

export enum ESignProvider {
  Docusign = 'DOCUSIGN',
  Onespan = 'ONESPAN'
}

export type EffectiveFlagPolicy = {
  __typename?: 'EffectiveFlagPolicy';
  enabled: Scalars['Boolean']['output'];
  flagType: FlagTypes;
  percentThreshold?: Maybe<Scalars['Float']['output']>;
  policySource: PolicySource;
  policySourceOrganizationId?: Maybe<Scalars['ID']['output']>;
  priority: FlagPriority;
  thresholdCents?: Maybe<Scalars['Int']['output']>;
  thresholdSource: PolicySource;
  thresholdSourceOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export type EffectiveReconTolerancePolicy = {
  __typename?: 'EffectiveReconTolerancePolicy';
  breakType: ReconToleranceBreakType;
  /** Per account per UTC day, all currencies in one total. 0 under PLATFORM_DEFAULT. */
  dailyCapCents: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  notifyOnReconcile: Scalars['Boolean']['output'];
  /** SELF: set here. INHERITED: from the closest ancestor. PLATFORM_DEFAULT: no row in the chain. */
  policySource: ReconTolerancePolicySource;
  /** Org the winning row came from. Null under PLATFORM_DEFAULT. */
  policySourceOrganizationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Nominal cents, no FX. 0 under PLATFORM_DEFAULT. */
  thresholdCents: Scalars['Int']['output'];
};

export type EffectiveSalesTaxConfiguration = {
  __typename?: 'EffectiveSalesTaxConfiguration';
  configurableTaxes: Array<ConfigurableSalesTax>;
  configurationOwner?: Maybe<PublicOrganization>;
  inherited: Scalars['Boolean']['output'];
  legacyFallbackSource?: Maybe<PublicOrganization>;
  revision?: Maybe<SalesTaxConfigurationRevision>;
  source: SalesTaxConfigurationSource;
};

/** Describes user's employment or unemployment status, and whether they're seeking new employment.  */
export enum EmploymentSituation {
  Other = 'OTHER',
  SomewhatStable = 'SOMEWHAT_STABLE',
  StableAndSecure = 'STABLE_AND_SECURE',
  StableButMayChangeInFuture = 'STABLE_BUT_MAY_CHANGE_IN_FUTURE',
  UnemployedButLooking = 'UNEMPLOYED_BUT_LOOKING'
}

/** Supported employment statuses. */
export enum EmploymentStatus {
  Employed = 'EMPLOYED',
  Retired = 'RETIRED',
  SelfEmployed = 'SELF_EMPLOYED',
  StayAtHomeParent = 'STAY_AT_HOME_PARENT',
  Student = 'STUDENT',
  Unemployed = 'UNEMPLOYED'
}

export type EnabledJurisdictions = {
  __typename?: 'EnabledJurisdictions';
  /** If set, all jurisdictions are enabled, the "only" attribute does not apply. */
  all?: Maybe<Scalars['Boolean']['output']>;
  /**
   * List of enabled jurisdictions. Applicable when all=false.
   * Example: [CA_AB, CA_BC] or [US_WY] (ISO 3166-2 Subdivision Codes).
   */
  only?: Maybe<Array<JurisdictionCodes>>;
};

export type EnabledJurisdictionsInput = {
  /** If set, all jurisdictions are enabled, the "only" attribute does not apply. */
  all?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * List of enabled jurisdictions. Applicable when all=false.
   * Example: [CA_AB, CA_BC] or [US_WY] (ISO 3166-2 Subdivision Codes).
   */
  only?: InputMaybe<Array<JurisdictionCodes>>;
};

export type EndLiquidationInput = {
  subAccountId: Scalars['ObjectID']['input'];
};

export type EndLiquidationResponse = {
  __typename?: 'EndLiquidationResponse';
  subAccount?: Maybe<SubAccount>;
};

export type EntityFeeSetting = {
  __typename?: 'EntityFeeSetting';
  account?: Maybe<Account>;
  accountGroup?: Maybe<AccountGroup>;
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  applicableFeeTier?: Maybe<FeeTier>;
  billingSchedule?: Maybe<BillingSchedule>;
  clientGroup?: Maybe<ClientGroup>;
  feeTier?: Maybe<FeeTier>;
  id: Scalars['ObjectID']['output'];
  subAccount?: Maybe<SubAccount>;
  user?: Maybe<User>;
};

export type EntityFeeSettingsQueryFilter = {
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type EntityOrganizationUser = {
  __typename?: 'EntityOrganizationUser';
  accounts?: Maybe<Array<Maybe<Account>>>;
  displayOptions?: Maybe<EntityOrganizationUserDisplayOptions>;
  organizationUser: PublicOrganizationUser;
  readOnly: Scalars['Boolean']['output'];
  relation?: Maybe<OrganizationUserEntityRelationTypes>;
  role?: Maybe<PublicRole>;
};

export type EntityOrganizationUserDisplayOptions = {
  __typename?: 'EntityOrganizationUserDisplayOptions';
  hide?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export enum EntityTypes {
  Individual = 'INDIVIDUAL',
  InvestmentFund = 'INVESTMENT_FUND',
  Other = 'OTHER',
  Partnership = 'PARTNERSHIP',
  PrivateCompany = 'PRIVATE_COMPANY',
  PubliclyListedEntity = 'PUBLICLY_LISTED_ENTITY',
  RegulatedEntity = 'REGULATED_ENTITY',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
  Trust = 'TRUST'
}

export type EodFile = {
  __typename?: 'EodFile';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Event = {
  __typename?: 'Event';
  /** The date the Event was created. */
  createdAt: Scalars['GraphQLDateTime']['output'];
  /** The type of the Event. */
  eventType: EventType;
  extraData?: Maybe<Scalars['String']['output']>;
  /** The webhooks that failed when this event was created and actioned. */
  failedWebhooks?: Maybe<Array<Webhook>>;
  /** This is the Event ID and it is auto-generated by OneVest for each Event. */
  id: Scalars['ObjectID']['output'];
  /** The ID of the Account, User, Transfer or Order related to this Event. */
  objectId: Scalars['ObjectID']['output'];
  /** Custom payload */
  objectPayload?: Maybe<Scalars['JSON']['output']>;
  /** The object of the Event. Account, User, Transfer or Order. */
  objectType: EventObject;
  /** The organization this Event belongs to. */
  organization?: Maybe<Organization>;
};

/** Possible objects of an Event. */
export enum EventObject {
  Account = 'Account',
  AccountStatement = 'AccountStatement',
  AdministrativeAnnualFeeReport = 'AdministrativeAnnualFeeReport',
  Allocation = 'Allocation',
  AnnualPerformanceReport = 'AnnualPerformanceReport',
  BankAccount = 'BankAccount',
  BeneficiarySignForm = 'BeneficiarySignForm',
  BulkTradeRun = 'BulkTradeRun',
  ClientGroup = 'ClientGroup',
  CoporateAccountNotification = 'CoporateAccountNotification',
  ExternalTransfer = 'ExternalTransfer',
  ExternalTransferNotification = 'ExternalTransferNotification',
  FeeFile = 'FeeFile',
  Goal = 'Goal',
  InternalTransfer = 'InternalTransfer',
  Job = 'Job',
  ManagementAnnualFeeReport = 'ManagementAnnualFeeReport',
  MonthlyAccountStatement = 'MonthlyAccountStatement',
  OrganizationUser = 'OrganizationUser',
  QuarterlyAccountStatement = 'QuarterlyAccountStatement',
  RespBeneficiaryQcResident = 'RESPBeneficiaryQCResident',
  RespFormUpload = 'RESPFormUpload',
  RiflifPaymentInstructionsUpload = 'RIFLIFPaymentInstructionsUpload',
  RrspWithdrawTransfer = 'RRSPWithdrawTransfer',
  ScheduledTransfer = 'ScheduledTransfer',
  SubAccount = 'SubAccount',
  TaxSlip = 'TaxSlip',
  Transfer = 'Transfer',
  User = 'User',
  UserProfileUpdate = 'UserProfileUpdate'
}

export type EventObjectType = {
  __typename?: 'EventObjectType';
  key: PublicEventObject;
};

export type EventPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

/** Possible Event types. */
export enum EventType {
  Active = 'ACTIVE',
  AllocationsRequested = 'ALLOCATIONS_REQUESTED',
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  AuthLinked = 'AUTH_LINKED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  AwaitingReview = 'AWAITING_REVIEW',
  BulkTradesRequested = 'BULK_TRADES_REQUESTED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Frozen = 'FROZEN',
  Inactive = 'INACTIVE',
  Initiated = 'INITIATED',
  IntegrationFormCreated = 'INTEGRATION_FORM_CREATED',
  IntegrationUpdate = 'INTEGRATION_UPDATE',
  LoggedIn = 'LOGGED_IN',
  LoginCredentialsUpdated = 'LOGIN_CREDENTIALS_UPDATED',
  Other = 'OTHER',
  PersonalAccountInformationUpdated = 'PERSONAL_ACCOUNT_INFORMATION_UPDATED',
  PersonalInformationUpdated = 'PERSONAL_INFORMATION_UPDATED',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Reconciled = 'RECONCILED',
  Reconciliation = 'RECONCILIATION',
  Requested = 'REQUESTED',
  Resigned = 'RESIGNED',
  Reviewing = 'REVIEWING',
  Signed = 'SIGNED',
  Submitted = 'SUBMITTED',
  SuitabilityReviewDue = 'SUITABILITY_REVIEW_DUE',
  SuitabilityScoreUpdated = 'SUITABILITY_SCORE_UPDATED',
  Updated = 'UPDATED',
  UserIdCheckUpdated = 'USER_ID_CHECK_UPDATED'
}

export type EventsQueryFilter = {
  createdAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  eventType?: InputMaybe<EventType>;
  objectId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectType?: InputMaybe<EventObject>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  payloadStatus?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  webhookId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type ExchangeClientTokenInput = {
  externalClientRefreshToken?: InputMaybe<Scalars['SafeString']['input']>;
  externalClientToken: Scalars['SafeString']['input'];
  forceCacheUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization ID or subdomain */
  organizationId: Scalars['SafeString']['input'];
  sessionId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type ExchangeClientTokenResponse = {
  __typename?: 'ExchangeClientTokenResponse';
  accessToken?: Maybe<Scalars['String']['output']>;
};

export enum Exchanges {
  Cannex = 'CANNEX',
  Cboe = 'CBOE',
  CboeCad = 'CBOE_CAD',
  Chx = 'CHX',
  Cme = 'CME',
  Fundserv = 'FUNDSERV',
  Ise = 'ISE',
  Ms4X = 'MS4X',
  Nasdaq = 'NASDAQ',
  Nyse = 'NYSE',
  Phlx = 'PHLX',
  PrivateSecurity = 'PRIVATE_SECURITY',
  Ptf = 'PTF',
  Tsx = 'TSX',
  TsxV = 'TSX_V'
}

export type ExpectedPrimaryAssetClassHoldings = {
  __typename?: 'ExpectedPrimaryAssetClassHoldings';
  /** This is the primary asset class of the model portfolio */
  assetClass?: Maybe<AssetClass>;
  /** This is the secondary asset class list of this primary asset class */
  expectedSecondaryAssetClassHoldings?: Maybe<Array<ExpectedSecondaryAssetClassHoldings>>;
  /** This is the primary asset class percentage */
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type ExpectedSecondaryAssetClassHoldings = {
  __typename?: 'ExpectedSecondaryAssetClassHoldings';
  /** This is the secondary asset class of a certain primary asset class */
  assetClass?: Maybe<AssetClass>;
  /** This is the security holdings list of this secondary asset class */
  expectedSecurityHoldings?: Maybe<Array<Maybe<ExpectedSecurityHoldings>>>;
  /** This is the secondary asset class percentage */
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type ExpectedSecurityHoldings = {
  __typename?: 'ExpectedSecurityHoldings';
  /** This is the financial product related to this security holding */
  financialProduct?: Maybe<FinancialProduct>;
  /** This is the percentage allocated to this security holding */
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type ExportApiReportColumnInput = {
  formatter?: InputMaybe<ApiExportFormatters>;
  gqlAlias: Scalars['SafeString']['input'];
  header?: InputMaybe<Scalars['SafeString']['input']>;
  /** indicates if the column is a custom field, if true, the gqlAlias will be the key of the custom field */
  isCustomField?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportApiReportInput = {
  columns: Array<ExportApiReportColumnInput>;
  datasetPath: Scalars['SafeString']['input'];
  fileName?: InputMaybe<Scalars['SafeString']['input']>;
  filter: Scalars['Object']['input'];
  gql: Scalars['SafeString']['input'];
  language?: InputMaybe<LanguageCodes>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  queryPath: Scalars['SafeString']['input'];
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['SafeString']['input']>;
};

export type ExportApiReportResponse = {
  __typename?: 'ExportApiReportResponse';
  apiExport: DataApiExport;
};

export type ExportConfigurableTablePageReportInput = {
  configurableTablePageId: Scalars['ObjectID']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['Object']['input']>;
  language?: InputMaybe<Languages>;
  pageObjectId?: InputMaybe<Scalars['SafeString']['input']>;
  pageType?: InputMaybe<PageConfigurationTypes>;
  pagination?: InputMaybe<ConfigurableTablePageExportPaginationInput>;
};

export type ExportConfigurableTablePageReportResponse = {
  __typename?: 'ExportConfigurableTablePageReportResponse';
  configurableTablePageExport: ConfigurableTablePageExport;
};

export type ExportReportInput = {
  columns: Array<Scalars['SafeString']['input']>;
  filters: Array<ReportFilterInput>;
  sortDesc: Scalars['Boolean']['input'];
  sortField: Scalars['SafeString']['input'];
  type: ReportType;
};

export type ExportReportResponse = {
  __typename?: 'ExportReportResponse';
  export: DataExport;
};

export type ExportSubTradeRequestsInput = {
  bulkTradeRequestId: Scalars['ObjectID']['input'];
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type ExternalClientSecret = {
  __typename?: 'ExternalClientSecret';
  key: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  value: Scalars['String']['output'];
};

export type ExternalProvider = {
  __typename?: 'ExternalProvider';
  bankingConnectorProvider?: Maybe<BankingConnectorProvider>;
  id: Scalars['ObjectID']['output'];
  idVerificationProvider?: Maybe<IdVerificationProvider>;
  organization?: Maybe<Organization>;
};

export enum ExternalProviderType {
  BankAccountCheck = 'BANK_ACCOUNT_CHECK',
  CreditFileCheck = 'CREDIT_FILE_CHECK',
  IdCheck = 'ID_CHECK'
}

export enum ExternalProviders {
  Flinks = 'FLINKS',
  Persona = 'PERSONA'
}

export enum ExternalSourceTypes {
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  ExternalInvestmentAccount = 'EXTERNAL_INVESTMENT_ACCOUNT',
  Loans = 'LOANS',
  Mortgage = 'MORTGAGE',
  OtherAsset = 'OTHER_ASSET',
  OtherLiability = 'OTHER_LIABILITY',
  RealEstate = 'REAL_ESTATE',
  Valuables = 'VALUABLES',
  Vehicles = 'VEHICLES'
}

export enum ExternalTransferTypes {
  AllInCash = 'ALL_IN_CASH',
  AllInKind = 'ALL_IN_KIND',
  PartialCash = 'PARTIAL_CASH'
}

export type ExternalVendorUsage = {
  __typename?: 'ExternalVendorUsage';
  id: Scalars['ObjectID']['output'];
  /** Organization that the user belongs to */
  organization: Organization;
  /** External API provider */
  provider?: Maybe<ExternalProviders>;
  /** Type of usage */
  type?: Maybe<ExternalProviderType>;
};

export type ExternalVendorUsageFilter = {
  /** Organization ID that you would to filter users under */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** External API provider */
  provider?: InputMaybe<ExternalProviders>;
  /** External api usage type */
  type?: InputMaybe<ExternalProviderType>;
};

export type ExternalVendorUsageFilterPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

/** Defines legal status of user assets under Foreign Account Tax Compliance Act (FACTA). */
export enum FatcaStatus {
  ActiveNffe = 'ACTIVE_NFFE',
  CentralBank = 'CENTRAL_BANK',
  Government = 'GOVERNMENT',
  InternationalOrganization = 'INTERNATIONAL_ORGANIZATION',
  Other = 'OTHER',
  PassiveNffe = 'PASSIVE_NFFE',
  PubliclyTradedNffe = 'PUBLICLY_TRADED_NFFE'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  group: FeatureFlagGroupTypes;
  translatedDescription: OrganizationTranslatedString;
  value: FeatureFlagTypes;
};

export enum FeatureFlagGroupTypes {
  AccountManagement = 'ACCOUNT_MANAGEMENT',
  AccountTypes = 'ACCOUNT_TYPES',
  AccountTypesUk = 'ACCOUNT_TYPES_UK',
  AccountTypesUsa = 'ACCOUNT_TYPES_USA',
  DocumentsAndStatements = 'DOCUMENTS_AND_STATEMENTS',
  Profile = 'PROFILE',
  TemporaryFlags = 'TEMPORARY_FLAGS',
  Trading = 'TRADING',
  Transfers = 'TRANSFERS'
}

export type FeatureFlagOption = {
  __typename?: 'FeatureFlagOption';
  enabled: Scalars['Boolean']['output'];
  type: FeatureFlagTypes;
};

export type FeatureFlagOptionInput = {
  enabled: Scalars['Boolean']['input'];
  type: FeatureFlagTypes;
};

export enum FeatureFlagTypes {
  AccountGroups = 'ACCOUNT_GROUPS',
  AccountToAccountDeposit = 'ACCOUNT_TO_ACCOUNT_DEPOSIT',
  AddAccountCurrency = 'ADD_ACCOUNT_CURRENCY',
  AddInstitutionsManuallyInUce = 'ADD_INSTITUTIONS_MANUALLY_IN_UCE',
  AdvisorApprovalRequiredForClientsToSignAgreements = 'ADVISOR_APPROVAL_REQUIRED_FOR_CLIENTS_TO_SIGN_AGREEMENTS',
  AffiliateConversionConfigurations = 'AFFILIATE_CONVERSION_CONFIGURATIONS',
  AllowAddingANewProfile = 'ALLOW_ADDING_A_NEW_PROFILE',
  AllowPublishClosedAccountFlag = 'ALLOW_PUBLISH_CLOSED_ACCOUNT_FLAG',
  AllAccountEditInReview = 'ALL_ACCOUNT_EDIT_IN_REVIEW',
  AnnualInformationUpdate = 'ANNUAL_INFORMATION_UPDATE',
  AssetClasses = 'ASSET_CLASSES',
  AuthorizedAccountAccess = 'AUTHORIZED_ACCOUNT_ACCESS',
  AutomatedBankAccountLinking = 'AUTOMATED_BANK_ACCOUNT_LINKING',
  AutomaticNetWorthLinking = 'AUTOMATIC_NET_WORTH_LINKING',
  AutoInvestments = 'AUTO_INVESTMENTS',
  AutoInvite = 'AUTO_INVITE',
  AutoReconcileBvaActivities = 'AUTO_RECONCILE_BVA_ACTIVITIES',
  AutoReconcileSwitchActivities = 'AUTO_RECONCILE_SWITCH_ACTIVITIES',
  AutoReconcileTfiActivities = 'AUTO_RECONCILE_TFI_ACTIVITIES',
  AutoReconcileTfrActivities = 'AUTO_RECONCILE_TFR_ACTIVITIES',
  BlockClientOnboardingMobileApp = 'BLOCK_CLIENT_ONBOARDING_MOBILE_APP',
  BlockClientSignUp = 'BLOCK_CLIENT_SIGN_UP',
  BypassIdVerification = 'BYPASS_ID_VERIFICATION',
  BypassStandardValidationRules = 'BYPASS_STANDARD_VALIDATION_RULES',
  CancelWorkflow = 'CANCEL_WORKFLOW',
  CashJoint = 'CASH_JOINT',
  CloseAccount = 'CLOSE_ACCOUNT',
  CloseGoal = 'CLOSE_GOAL',
  CloseSubAccount = 'CLOSE_SUB_ACCOUNT',
  ConfigurableClientReports = 'CONFIGURABLE_CLIENT_REPORTS',
  ConfigurableDocumentsIdVerification = 'CONFIGURABLE_DOCUMENTS_ID_VERIFICATION',
  ConfigurableHomePages = 'CONFIGURABLE_HOME_PAGES',
  CorporateAccounts = 'CORPORATE_ACCOUNTS',
  CreateAccountOrSubAccountConfig = 'CREATE_ACCOUNT_OR_SUB_ACCOUNT_CONFIG',
  CreateNewGoals = 'CREATE_NEW_GOALS',
  CreateNewSubAccounts = 'CREATE_NEW_SUB_ACCOUNTS',
  CustodianStatement = 'CUSTODIAN_STATEMENT',
  Dbpp = 'DBPP',
  Deposits = 'DEPOSITS',
  DepositWorkflow = 'DEPOSIT_WORKFLOW',
  DisableBackendAffiliateValidation = 'DISABLE_BACKEND_AFFILIATE_VALIDATION',
  Documents = 'DOCUMENTS',
  DocumentsWidgetEnhancements = 'DOCUMENTS_WIDGET_ENHANCEMENTS',
  Dpsp = 'DPSP',
  DriftCalculationMethodEnabled = 'DRIFT_CALCULATION_METHOD_ENABLED',
  DriftToleranceEnabled = 'DRIFT_TOLERANCE_ENABLED',
  EnableJointAffiliationsFlow = 'ENABLE_JOINT_AFFILIATIONS_FLOW',
  EnableOnevestAgreements = 'ENABLE_ONEVEST_AGREEMENTS',
  EnableOnevestAgreementsIndividualOnly = 'ENABLE_ONEVEST_AGREEMENTS_INDIVIDUAL_ONLY',
  Fhsa = 'FHSA',
  FixTrading = 'FIX_TRADING',
  GoalCreationMethod = 'GOAL_CREATION_METHOD',
  Grsp = 'GRSP',
  Household = 'HOUSEHOLD',
  IdVerification = 'ID_VERIFICATION',
  IndexBasedPerformanceCalculation = 'INDEX_BASED_PERFORMANCE_CALCULATION',
  InformalTrust = 'INFORMAL_TRUST',
  InformalTrustJoint = 'INFORMAL_TRUST_JOINT',
  InKindTransfers = 'IN_KIND_TRANSFERS',
  Ipp = 'IPP',
  JointAccountAgreementPdf = 'JOINT_ACCOUNT_AGREEMENT_PDF',
  JointAffiliateConfigurations = 'JOINT_AFFILIATE_CONFIGURATIONS',
  Lif = 'LIF',
  Lira = 'LIRA',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  ManuallyAddBankAccount = 'MANUALLY_ADD_BANK_ACCOUNT',
  ManualNetWorthLinking = 'MANUAL_NET_WORTH_LINKING',
  Margin = 'MARGIN',
  MarginJoint = 'MARGIN_JOINT',
  ModelPortfoliosV2 = 'MODEL_PORTFOLIOS_V2',
  MultipleBankingIntegrations = 'MULTIPLE_BANKING_INTEGRATIONS',
  MultiCurrencyDepositTransfers = 'MULTI_CURRENCY_DEPOSIT_TRANSFERS',
  MultiCurrencyWithdrawTransfers = 'MULTI_CURRENCY_WITHDRAW_TRANSFERS',
  NewAccountTypes_2025 = 'NEW_ACCOUNT_TYPES_2025',
  OnboardingWithoutGoals = 'ONBOARDING_WITHOUT_GOALS',
  OnevestStatement = 'ONEVEST_STATEMENT',
  PadAgreements = 'PAD_AGREEMENTS',
  PageConfigurationEnhancements = 'PAGE_CONFIGURATION_ENHANCEMENTS',
  Personal = 'PERSONAL',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  Prif = 'PRIF',
  Rdsp = 'RDSP',
  RdspJoint = 'RDSP_JOINT',
  RebalanceReportV2 = 'REBALANCE_REPORT_V2',
  ReconcileTradesWithAdditionalChecks = 'RECONCILE_TRADES_WITH_ADDITIONAL_CHECKS',
  Resp = 'RESP',
  RespAdult = 'RESP_ADULT',
  RespAffiliationsEnhancements = 'RESP_AFFILIATIONS_ENHANCEMENTS',
  RespFamily = 'RESP_FAMILY',
  RespFamilyJoint = 'RESP_FAMILY_JOINT',
  RespGrantsBctesg = 'RESP_GRANTS_BCTESG',
  RespGrantsQesi = 'RESP_GRANTS_QESI',
  RespSingle = 'RESP_SINGLE',
  RespSingleJoint = 'RESP_SINGLE_JOINT',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  Rlsp = 'RLSP',
  Rpp = 'RPP',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  StagingEnablePersonalUniquenessCheck = 'STAGING_ENABLE_PERSONAL_UNIQUENESS_CHECK',
  SuitabilityReviewDueNotifications = 'SUITABILITY_REVIEW_DUE_NOTIFICATIONS',
  SuitabilityReviewOverdueBlockTransfers = 'SUITABILITY_REVIEW_OVERDUE_BLOCK_TRANSFERS',
  TaxLossHarvesting = 'TAX_LOSS_HARVESTING',
  TcpSpouseLookup = 'TCP_SPOUSE_LOOKUP',
  Tfsa = 'TFSA',
  TranslatedAttributes = 'TRANSLATED_ATTRIBUTES',
  UkBrokerage = 'UK_BROKERAGE',
  UkCashIsa = 'UK_CASH_ISA',
  UkJisa = 'UK_JISA',
  UkPersonalPension = 'UK_PERSONAL_PENSION',
  UkSsIsa = 'UK_SS_ISA',
  UpdateGoal = 'UPDATE_GOAL',
  UpdatePersonalDetails = 'UPDATE_PERSONAL_DETAILS',
  UpdateSubAccount = 'UPDATE_SUB_ACCOUNT',
  Usa_401K = 'USA_401K',
  Usa_529 = 'USA_529',
  UsaBrokerage = 'USA_BROKERAGE',
  UsaCorporate = 'USA_CORPORATE',
  UsaCra = 'USA_CRA',
  UsaCustodial = 'USA_CUSTODIAL',
  UsaDaf = 'USA_DAF',
  UsaDbp = 'USA_DBP',
  UsaEsa = 'USA_ESA',
  UsaEstate = 'USA_ESTATE',
  UsaInhIra = 'USA_INH_IRA',
  UsaInhRtIra = 'USA_INH_RT_IRA',
  UsaIra = 'USA_IRA',
  UsaIraCustodial = 'USA_IRA_CUSTODIAL',
  UsaJtCp = 'USA_JT_CP',
  UsaJtCpMargin = 'USA_JT_CP_MARGIN',
  UsaJtJtbe = 'USA_JT_JTBE',
  UsaJtJtbeMargin = 'USA_JT_JTBE_MARGIN',
  UsaJtTic = 'USA_JT_TIC',
  UsaJtTicMargin = 'USA_JT_TIC_MARGIN',
  UsaJtWros = 'USA_JT_WROS',
  UsaJtWrosMargin = 'USA_JT_WROS_MARGIN',
  UsaKeogh = 'USA_KEOGH',
  UsaMargin = 'USA_MARGIN',
  UsaRoIra = 'USA_RO_IRA',
  UsaRtIra = 'USA_RT_IRA',
  UsaSepIra = 'USA_SEP_IRA',
  UsaSimpleIra = 'USA_SIMPLE_IRA',
  UsaSolo_401K = 'USA_SOLO_401K',
  UsaTod = 'USA_TOD',
  UsaTrust = 'USA_TRUST',
  UserQcJurisdictionAgreements = 'USER_QC_JURISDICTION_AGREEMENTS',
  UserRelationshipsEnhancements = 'USER_RELATIONSHIPS_ENHANCEMENTS',
  UsTransferFlow = 'US_TRANSFER_FLOW',
  ViewAgreements = 'VIEW_AGREEMENTS',
  ViewHelpCenter = 'VIEW_HELP_CENTER',
  ViewStatements = 'VIEW_STATEMENTS',
  ViewTaxDocuments = 'VIEW_TAX_DOCUMENTS',
  Withdrawals = 'WITHDRAWALS',
  WithdrawWorkflow = 'WITHDRAW_WORKFLOW',
  WorkflowEnhancements = 'WORKFLOW_ENHANCEMENTS'
}

export enum FeeEntity {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  ClientGroup = 'CLIENT_GROUP',
  SubAccount = 'SUB_ACCOUNT',
  User = 'USER'
}

export type FeeEntityIdentifier = {
  entityId: Scalars['ObjectID']['input'];
  entityType: FeeEntity;
};

export type FeeGrid = {
  __typename?: 'FeeGrid';
  /** This is the annual BPS, which means the daily BPS will be calculated and applied on each day of the billing frequency. */
  annualFeeBps?: Maybe<Scalars['Float']['output']>;
  /** This is a fixed fee amount cents that would applied for this grid range. If annualFeeBps is defined, the annualFeeCents will be added to the annualFeeBps calculated fee. */
  annualFeeCents?: Maybe<Scalars['Long']['output']>;
  /** Minimum value for the total marketValueCents to be considered in this grid range. The maximum value will be defined by the next minMarketValueCents in the grid list. */
  minMarketValueCents?: Maybe<Scalars['Long']['output']>;
};

export enum FeeGridScopeTypes {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  ClientGroup = 'CLIENT_GROUP',
  SubAccount = 'SUB_ACCOUNT',
  User = 'USER'
}

export type FeePagination = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type FeeSetting = {
  __typename?: 'FeeSetting';
  createdAt: Scalars['GraphQLDateTime']['output'];
  defaultBillingSchedule?: Maybe<BillingSchedule>;
  defaultFeeTier?: Maybe<FeeTier>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  organization: Scalars['ObjectID']['output'];
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type FeeStateMachineChanges = {
  __typename?: 'FeeStateMachineChanges';
  createdAt: Scalars['GraphQLDateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

/**
 * FeeTier defines how the subAccount fee should be calculated.
 * It is defined at the Organization level, but can be applied to specific SubAccounts, Accounts, Users, or ClientGroups.
 * The fee calculation will identify the first FeeTier applicable for the subAccount following this hierarchical order: SubAccount -> Account -> User -> ClientGroup -> Organization.
 */
export type FeeTier = {
  __typename?: 'FeeTier';
  /** When a grid is blended the total fee will be a combination of each rate applied to its range. Otherwise, the corresponding rate will be applied to the total amount. */
  blendedGrid?: Maybe<Scalars['Boolean']['output']>;
  chargeForCash?: Maybe<Scalars['Boolean']['output']>;
  chargeForCashOnHold?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /**
   * It defines whether this is the default FeeTier within its organization.
   * The default FeeTier will be used in case there is no specific FeeTier assigned to the subAccount, Account, User, or ClientGroup.
   * If the organization does not inherit parent FeeTiers, there must be one default FeeTier, otherwise the default FeeTier of the next parent organization will be considered.
   */
  default: Scalars['Boolean']['output'];
  /**
   * A discount percentage applied to the calculated fee (0 - 100%).
   * If this FeeTier does not have a grid or a flatAnnualFeeBps configuration, this discount will be applied on top of the calculated fee based on the next FeeTier in the hierarchical order.
   */
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  /** The key identifying the extension that manages this resource. */
  extensionKey?: Maybe<Scalars['String']['output']>;
  /** The version of the extension schema used. */
  extensionVersion?: Maybe<Scalars['String']['output']>;
  /**
   * A flat fee that will be applied regardless of the total marketValueCents. It can not be defined when the grid is defined.
   * This is the annual BPS, which means the daily BPS will be calculated and applied on each day of the billing frequency.
   */
  flatAnnualFeeBps?: Maybe<Scalars['Float']['output']>;
  grid?: Maybe<Array<Maybe<FeeGrid>>>;
  /** It defines the scope in which the marketValueCents will be accumulated to identify the applicable fee grid. */
  gridScopeType?: Maybe<FeeGridScopeTypes>;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<PublicOrganization>;
  requestId?: Maybe<Scalars['String']['output']>;
  /** The unique key for this resource within its extension. */
  resourceKey?: Maybe<Scalars['String']['output']>;
  state: FeeTierStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<FeeStateMachineChanges>>>;
  type?: Maybe<FeeTierTypes>;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type FeeTierGridInput = {
  annualFeeBps?: InputMaybe<Scalars['Float']['input']>;
  annualFeeCents?: InputMaybe<Scalars['Long']['input']>;
  minMarketValueCents: Scalars['Long']['input'];
};

export type FeeTierQueryFilter = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  gridScopeTypes?: InputMaybe<Array<InputMaybe<FeeGridScopeTypes>>>;
  hasDiscountPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  hasFlatAnnualFeeBps?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrid?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<InputMaybe<FeeTierStates>>>;
};

export enum FeeTierSource {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  ClientGroup = 'CLIENT_GROUP',
  Organization = 'ORGANIZATION',
  ParentOrganization = 'PARENT_ORGANIZATION',
  SubAccount = 'SUB_ACCOUNT',
  User = 'USER'
}

export enum FeeTierStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export enum FeeTierTransition {
  Activate = 'activate',
  Archive = 'archive',
  Deactivate = 'deactivate'
}

export enum FeeTierTypes {
  Flat = 'FLAT',
  Tiered = 'TIERED'
}

export type FetchAccountBulkUpsertItemResponse = {
  __typename?: 'FetchAccountBulkUpsertItemResponse';
  bulkUpsertItem: AccountBulkUpsertItem;
};

export type FetchAccountBulkUpsertItemsInput = {
  filter: AccountBulkUpsertItemQueryFilter;
  pagination?: InputMaybe<BulkUpsertPaginationAndSorting>;
};

export type FetchAccountBulkUpsertItemsResponse = {
  __typename?: 'FetchAccountBulkUpsertItemsResponse';
  bulkUpsertItems: Array<AccountBulkUpsertItem>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAccountFeeResponse = {
  __typename?: 'FetchAccountFeeResponse';
  accountFee: AccountFee;
};

export type FetchAccountFeesInput = {
  filter?: InputMaybe<AccountFeesQueryFilter>;
  pagination?: InputMaybe<AccountFeesPaginationAndSorting>;
};

export type FetchAccountFeesResponse = {
  __typename?: 'FetchAccountFeesResponse';
  accountFees: Array<AccountFee>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAccountGroupBulkUpsertItemResponse = {
  __typename?: 'FetchAccountGroupBulkUpsertItemResponse';
  bulkUpsertItem: AccountGroupBulkUpsertItem;
};

export type FetchAccountGroupBulkUpsertItemsInput = {
  filter: AccountGroupBulkUpsertItemQueryFilter;
  pagination?: InputMaybe<BulkUpsertPaginationAndSorting>;
};

export type FetchAccountGroupBulkUpsertItemsResponse = {
  __typename?: 'FetchAccountGroupBulkUpsertItemsResponse';
  bulkUpsertItems: Array<AccountGroupBulkUpsertItem>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAccountGroupResponse = {
  __typename?: 'FetchAccountGroupResponse';
  accountGroup: AccountGroup;
};

export type FetchAccountGroupsInput = {
  filter?: InputMaybe<AccountGroupsQueryFilter>;
  pagination?: InputMaybe<AccountGroupsPaginationAndSorting>;
};

export type FetchAccountGroupsResponse = {
  __typename?: 'FetchAccountGroupsResponse';
  accountGroups: Array<AccountGroup>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAccountInput = {
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  custodianAccountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  options?: InputMaybe<FetchAccountOptions>;
};

export type FetchAccountOptions = {
  /** Read MongoDB directly instead of the passthrough API integration. Honoured only for API-token callers; ignored for user tokens. */
  skipPassthroughApi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FetchAccountReconciliationSnapshotResponse = {
  __typename?: 'FetchAccountReconciliationSnapshotResponse';
  accountReconciliationSnapshot: AccountReconciliationSnapshot;
};

export type FetchAccountReconciliationSnapshotsInput = {
  filter?: InputMaybe<AccountReconciliationSnapshotQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchAccountReconciliationSnapshotsResponse = {
  __typename?: 'FetchAccountReconciliationSnapshotsResponse';
  accountReconciliationSnapshots: Array<AccountReconciliationSnapshot>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAccountResponse = {
  __typename?: 'FetchAccountResponse';
  account: Account;
};

export type FetchAccountStatementAccountsResponse = {
  __typename?: 'FetchAccountStatementAccountsResponse';
  accounts: Array<AccountStatementAccount>;
};

export type FetchAccountStatementDocumentFilter = {
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  accountStatementId: Scalars['SafeString']['input'];
  documentDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  objectId?: InputMaybe<Scalars['SafeString']['input']>;
  objectType?: InputMaybe<AccountStatementObjectTypes>;
  type?: InputMaybe<StatementTypes>;
};

export type FetchAccountStatementDocumentResponse = {
  __typename?: 'FetchAccountStatementDocumentResponse';
  contentBase64?: Maybe<Scalars['String']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type FetchAccountStatementResponse = {
  __typename?: 'FetchAccountStatementResponse';
  accountStatement?: Maybe<AccountStatement>;
};

export type FetchAccountStatementTypesResponse = {
  __typename?: 'FetchAccountStatementTypesResponse';
  types: Array<StatementTypes>;
};

export type FetchAccountStatementsCursor = {
  __typename?: 'FetchAccountStatementsCursor';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

export type FetchAccountStatementsInput = {
  filter?: InputMaybe<StatementQueryFilter>;
  pagination?: InputMaybe<StatementPaginationAndSorting>;
};

export type FetchAccountStatementsResponse = {
  __typename?: 'FetchAccountStatementsResponse';
  accountStatements: Array<AccountStatement>;
  cursor?: Maybe<FetchAccountStatementsCursor>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FetchAccountTypesInput = {
  filter?: InputMaybe<FetchAccountTypesQueryFilter>;
};

export type FetchAccountTypesQueryFilter = {
  country?: InputMaybe<AddressCountries>;
  entityId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchAccountTypesResponse = {
  __typename?: 'FetchAccountTypesResponse';
  accountTypes: Array<AccountType>;
};

export type FetchAccountsInput = {
  filter?: InputMaybe<AccountsQueryFilter>;
  options?: InputMaybe<FetchAccountsOptions>;
  pagination?: InputMaybe<AccountsPaginationAndSorting>;
};

export type FetchAccountsOptions = {
  /** Read MongoDB directly instead of the passthrough API integration. Honoured only for API-token callers; ignored for user tokens. */
  skipPassthroughApi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FetchAccountsResponse = {
  __typename?: 'FetchAccountsResponse';
  accounts: Array<Account>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAdvisorContactResponse = {
  __typename?: 'FetchAdvisorContactResponse';
  advisorContact: AdvisorContact;
};

export type FetchAdvisorContactsInput = {
  filter?: InputMaybe<AdvisorContactQueryFilter>;
  organizationId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<AdvisorContactPaginationAndSorting>;
};

export type FetchAdvisorContactsResponse = {
  __typename?: 'FetchAdvisorContactsResponse';
  advisorContacts: Array<AdvisorContact>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAlertBannerResponse = {
  __typename?: 'FetchAlertBannerResponse';
  alertBanner: AlertBanner;
};

export type FetchAlertBannersInput = {
  filter?: InputMaybe<AlertBannerQueryFilter>;
  pagination?: InputMaybe<AlertBannerPaginationAndSorting>;
};

export type FetchAlertBannersResponse = {
  __typename?: 'FetchAlertBannersResponse';
  alertBanners: Array<AlertBanner>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAlertReportInput = {
  reportId?: InputMaybe<Scalars['ObjectID']['input']>;
  transferId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchAlertReportResponse = {
  __typename?: 'FetchAlertReportResponse';
  report: Report;
};

export type FetchAlertReportsInput = {
  filter?: InputMaybe<AlertReportQueryFilter>;
  pagination?: InputMaybe<AlertReportPaginationAndSorting>;
};

export type FetchAlertReportsResponse = {
  __typename?: 'FetchAlertReportsResponse';
  reports?: Maybe<Array<Report>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FetchAncestorInheritedAssignmentsInput = {
  objectType: AncestorInheritedObjectType;
  organizationId: Scalars['ObjectID']['input'];
};

export type FetchAncestorInheritedAssignmentsResponse = {
  __typename?: 'FetchAncestorInheritedAssignmentsResponse';
  assignments: Array<AncestorInheritedAssignment>;
};

export type FetchApiExportInput = {
  apiExportId: Scalars['ObjectID']['input'];
};

export type FetchApiExportResponse = {
  __typename?: 'FetchApiExportResponse';
  apiExport: DataApiExport;
};

export type FetchApiExportsFilterInput = {
  datasetPath?: InputMaybe<Scalars['SafeString']['input']>;
  /**
   * Match stored ApiExport.filter: flat key/value map only (string, number, boolean, or null).
   * Nested objects and arrays are rejected.
   */
  filter?: InputMaybe<Scalars['Object']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  queryPath?: InputMaybe<Scalars['SafeString']['input']>;
  state?: InputMaybe<DataExportStates>;
};

export type FetchApiExportsInput = {
  filter: FetchApiExportsFilterInput;
  pagination?: InputMaybe<FetchReportsPaginationInput>;
};

export type FetchApiExportsResponse = {
  __typename?: 'FetchApiExportsResponse';
  apiExports: Array<DataApiExport>;
  totalCount: Scalars['Int']['output'];
};

export type FetchApplicableDowntimeScheduleResponse = {
  __typename?: 'FetchApplicableDowntimeScheduleResponse';
  downtimeSchedule?: Maybe<DowntimeSchedule>;
};

export type FetchArticleResponse = {
  __typename?: 'FetchArticleResponse';
  article: Article;
};

export type FetchArticlesInput = {
  filter?: InputMaybe<ArticleQueryFilter>;
  pagination?: InputMaybe<ArticlePaginationAndSorting>;
};

export type FetchArticlesResponse = {
  __typename?: 'FetchArticlesResponse';
  articles: Array<Article>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAssetClassesInput = {
  filter?: InputMaybe<AssetClassFilterQuery>;
  pagination?: InputMaybe<AssetClassPaginationAndSorting>;
};

export type FetchAssetClassesResponse = {
  __typename?: 'FetchAssetClassesResponse';
  assetClasses: Array<AssetClass>;
  totalCount: Scalars['Int']['output'];
};

export type FetchAssignedCountsByFinancialProductInput = {
  financialProductIds: Array<Scalars['ObjectID']['input']>;
};

export type FetchAvailableReportVariablesInput = {
  objectType: ClientReportTemplateObjectTypes;
};

export type FetchAvailableReportVariablesResponse = {
  __typename?: 'FetchAvailableReportVariablesResponse';
  availableVariables?: Maybe<Array<Maybe<ReportVariableMeta>>>;
};

export type FetchAvailableThemesInput = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  suitabilityScore: Scalars['Int']['input'];
};

export type FetchAvailableThemesResponse = {
  __typename?: 'FetchAvailableThemesResponse';
  themes: Array<Theme>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBankAccountBulkUpsertItemResponse = {
  __typename?: 'FetchBankAccountBulkUpsertItemResponse';
  bulkUpsertItem: BankAccountBulkUpsertItem;
};

export type FetchBankAccountBulkUpsertItemsInput = {
  filter: BankAccountBulkUpsertItemQueryFilter;
  pagination?: InputMaybe<BulkUpsertPaginationAndSorting>;
};

export type FetchBankAccountBulkUpsertItemsResponse = {
  __typename?: 'FetchBankAccountBulkUpsertItemsResponse';
  bulkUpsertItems: Array<BankAccountBulkUpsertItem>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBankAccountInput = {
  bankAccountId: Scalars['SafeString']['input'];
};

export type FetchBankAccountResponse = {
  __typename?: 'FetchBankAccountResponse';
  bankAccount: BankAccount;
};

export type FetchBankAccountsInput = {
  filter?: InputMaybe<BankAccountQueryFilter>;
  pagination?: InputMaybe<BankAccountPaginationAndSorting>;
};

export type FetchBankAccountsResponse = {
  __typename?: 'FetchBankAccountsResponse';
  bankAccounts: Array<BankAccount>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBankConnectionsInput = {
  filter?: InputMaybe<BankConnectionQueryFilter>;
  pagination?: InputMaybe<BankConnectionPaginationAndSorting>;
};

export type FetchBankConnectionsResponse = {
  __typename?: 'FetchBankConnectionsResponse';
  bankConnections: Array<BankConnection>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBeneficiariesInput = {
  filter?: InputMaybe<BeneficiaryQueryFilter>;
  pagination?: InputMaybe<BeneficiaryPaginationAndSorting>;
};

export type FetchBeneficiariesResponse = {
  __typename?: 'FetchBeneficiariesResponse';
  beneficiaries: Array<Beneficiary>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBeneficiaryResponse = {
  __typename?: 'FetchBeneficiaryResponse';
  beneficiary: Beneficiary;
};

export type FetchBillingCycleResponse = {
  __typename?: 'FetchBillingCycleResponse';
  billingCycle: BillingCycle;
};

export type FetchBillingCyclesInput = {
  filter?: InputMaybe<BillingCycleQueryFilter>;
  pagination?: InputMaybe<AccountFeesPaginationAndSorting>;
};

export type FetchBillingCyclesResponse = {
  __typename?: 'FetchBillingCyclesResponse';
  billingCycles: Array<BillingCycle>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBillingScheduleResponse = {
  __typename?: 'FetchBillingScheduleResponse';
  billingSchedule: BillingSchedule;
};

export type FetchBillingSchedulesInput = {
  filter?: InputMaybe<BillingScheduleQueryFilter>;
  pagination?: InputMaybe<AccountFeesPaginationAndSorting>;
};

export type FetchBillingSchedulesResponse = {
  __typename?: 'FetchBillingSchedulesResponse';
  billingSchedules: Array<BillingSchedule>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBulkImportResponse = {
  __typename?: 'FetchBulkImportResponse';
  bulkImport: BulkImport;
};

export type FetchBulkImportsInput = {
  filter?: InputMaybe<BulkImportQueryFilter>;
  pagination?: InputMaybe<FileDocumentPaginationAndSorting>;
};

export type FetchBulkImportsResponse = {
  __typename?: 'FetchBulkImportsResponse';
  bulkImports: Array<BulkImport>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBulkTradeRequestResponse = {
  __typename?: 'FetchBulkTradeRequestResponse';
  bulkTradeRequest: BulkTradeRequest;
};

export type FetchBulkTradeRequestsInput = {
  filter?: InputMaybe<BulkTradeRequestQueryFilter>;
  pagination?: InputMaybe<BulkTradePaginationAndSorting>;
};

export type FetchBulkTradeRequestsResponse = {
  __typename?: 'FetchBulkTradeRequestsResponse';
  bulkTradeRequests: Array<BulkTradeRequest>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBulkTradeRunAllocationsInput = {
  filter: BulkTradeRunAllocationsFilter;
  pagination?: InputMaybe<BulkTradeRunAllocationsPagination>;
};

export type FetchBulkTradeRunAllocationsResponse = {
  __typename?: 'FetchBulkTradeRunAllocationsResponse';
  bulkTradeRunAllocations: Array<BulkTradeRunAllocation>;
  id: Scalars['ObjectID']['output'];
  totalCount: Scalars['Int']['output'];
};

export type FetchBulkTradeRunResponse = {
  __typename?: 'FetchBulkTradeRunResponse';
  bulkTradeRun: BulkTradeRun;
};

export type FetchBulkTradeRunsInput = {
  filter?: InputMaybe<BulkTradeRunQueryFilter>;
  pagination?: InputMaybe<BulkTradeRunPaginationAndSorting>;
};

export type FetchBulkTradeRunsResponse = {
  __typename?: 'FetchBulkTradeRunsResponse';
  bulkTradeRuns: Array<BulkTradeRun>;
  totalCount: Scalars['Int']['output'];
};

export type FetchBulkUpsertRequestResponse = {
  __typename?: 'FetchBulkUpsertRequestResponse';
  bulkUpsertRequest?: Maybe<BulkUpsertRequest>;
};

export type FetchBulkUpsertRequestsInput = {
  filter?: InputMaybe<BulkUpsertRequestQueryFilter>;
  pagination?: InputMaybe<RolePaginationAndSorting>;
};

export type FetchBulkUpsertRequestsResponse = {
  __typename?: 'FetchBulkUpsertRequestsResponse';
  bulkUpsertRequests: Array<BulkUpsertRequest>;
  totalCount: Scalars['Int']['output'];
};

export type FetchClientAdvisorVisibilityInput = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type FetchClientAdvisorVisibilityResponse = {
  __typename?: 'FetchClientAdvisorVisibilityResponse';
  visibilityEntries: Array<ClientAdvisorVisibilityEntry>;
};

export type FetchClientGroupInput = {
  clientGroupId: Scalars['SafeString']['input'];
  /** Options that change how the clientGroup is fetched */
  options?: InputMaybe<FetchClientGroupsOptions>;
};

/** ClientGroup Response */
export type FetchClientGroupResponse = {
  __typename?: 'FetchClientGroupResponse';
  /** clientGroup object */
  clientGroup?: Maybe<ClientGroup>;
};

/** Input type for fetching ClientGroups */
export type FetchClientGroupsInput = {
  /** To filter the clientGroups */
  filter?: InputMaybe<ClientGroupQueryFilter>;
  /** Options that change how the clientGroups are fetched */
  options?: InputMaybe<FetchClientGroupsOptions>;
  /** To organize the response as per the pagination fields */
  pagination?: InputMaybe<UserPaginationAndSorting>;
};

/** Options for fetching clientGroups */
export type FetchClientGroupsOptions = {
  /** When true, skips the passthrough API integration and reads clientGroups from OneVest only. Only honoured for API-token callers; ignored for other users */
  skipPassthroughApi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Type definition for fetching clientGroups */
export type FetchClientGroupsResponse = {
  __typename?: 'FetchClientGroupsResponse';
  /** Returns an array of clientGroup objects */
  clientGroups: Array<ClientGroup>;
  /** Total number of the clientGroup records that satisfies a specified filter */
  totalCount: Scalars['Int']['output'];
};

export type FetchClientReportResponse = {
  __typename?: 'FetchClientReportResponse';
  clientReport?: Maybe<ClientReport>;
};

export type FetchClientReportTemplateResponse = {
  __typename?: 'FetchClientReportTemplateResponse';
  clientReportTemplate?: Maybe<ClientReportTemplate>;
};

export type FetchClientReportTemplateWidgetOptionsResponse = {
  __typename?: 'FetchClientReportTemplateWidgetOptionsResponse';
  widgetOptions: Array<ClientReportTemplateWidgetOption>;
};

export type FetchClientReportTemplatesInput = {
  filter?: InputMaybe<ClientReportTemplatesQueryFilter>;
  pagination?: InputMaybe<StatementPaginationAndSorting>;
};

export type FetchClientReportTemplatesResponse = {
  __typename?: 'FetchClientReportTemplatesResponse';
  clientReportTemplates: Array<ClientReportTemplate>;
  totalCount: Scalars['Int']['output'];
};

export type FetchClientReportsInput = {
  filter?: InputMaybe<ClientReportsQueryFilter>;
  pagination?: InputMaybe<StatementPaginationAndSorting>;
};

export type FetchClientReportsResponse = {
  __typename?: 'FetchClientReportsResponse';
  clientReports: Array<ClientReport>;
  totalCount: Scalars['Int']['output'];
};

export type FetchConfigurableTableFilterOptionsInput = {
  configurableTablePageId: Scalars['ObjectID']['input'];
  /** Current filter values, keyed by filter key */
  filter: Scalars['Object']['input'];
  /** Key of the dependent filter whose options are refreshed */
  filterKey: Scalars['String']['input'];
  pageObjectId?: InputMaybe<Scalars['SafeString']['input']>;
  pageType?: InputMaybe<PageConfigurationTypes>;
};

export type FetchConfigurableTableFilterOptionsResponse = {
  __typename?: 'FetchConfigurableTableFilterOptionsResponse';
  key: Scalars['String']['output'];
  populatedOptions: Array<ConfigurableTablePageFilterStaticOptions>;
};

export type FetchConfigurableTablePageReportResponse = {
  __typename?: 'FetchConfigurableTablePageReportResponse';
  configurableTablePageExport: ConfigurableTablePageExport;
};

export type FetchConfigurableTablePageResponse = {
  __typename?: 'FetchConfigurableTablePageResponse';
  configurableTablePage: ConfigurableTablePage;
};

export type FetchConfigurableTablePageWidgetOptionsResponse = {
  __typename?: 'FetchConfigurableTablePageWidgetOptionsResponse';
  widgetOptions: Array<WidgetOption>;
};

export type FetchConfigurableTablePagesInput = {
  filter?: InputMaybe<ConfigurableTablePageQueryFilter>;
  pagination?: InputMaybe<ConfigurableTablePagePaginationAndSorting>;
};

export type FetchConfigurableTablePagesResponse = {
  __typename?: 'FetchConfigurableTablePagesResponse';
  configurableTablePages: Array<ConfigurableTablePage>;
  totalCount: Scalars['Int']['output'];
};

export type FetchCountryRiskInput = {
  countryRiskId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchCountryRiskResponse = {
  __typename?: 'FetchCountryRiskResponse';
  countryRisk: CountryRisk;
};

export type FetchCustodianActivitiesFilter = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  custodianAccountNumber?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  state?: InputMaybe<CustodianActivityStates>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

export type FetchCustodianActivitiesFilterForGrid = {
  /** Optional child-org narrower -> organizationParents. */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Aging filter cutoff (processDate <= value); frontend-driven (Any/1+/3+/7+). */
  processDateBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Unified $or over clientName, custodianAccountNumber, symbol. */
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<CustodianActivityStates>;
  /** EXACT match on the enum value (not a regex). */
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

export type FetchCustodianActivitiesInput = {
  filter?: InputMaybe<FetchCustodianActivitiesFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchCustodianActivitiesInputForGrid = {
  filter?: InputMaybe<FetchCustodianActivitiesFilterForGrid>;
  pagination?: InputMaybe<FetchCustodianActivitiesPaginationForGrid>;
};

export type FetchCustodianActivitiesPaginationForGrid = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type FetchCustodianActivitiesResponse = {
  __typename?: 'FetchCustodianActivitiesResponse';
  custodianActivities: Array<CustodianActivity>;
  totalCount: Scalars['Int']['output'];
};

export type FetchCustodianActivityChartTodayInput = {
  /** Optional child-org narrower (organizationParents); boundary is always the caller org. */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchCustodianActivityChartTodayResponse = {
  __typename?: 'FetchCustodianActivityChartTodayResponse';
  result: CustodianActivityChartTodayResult;
};

export type FetchCustodianActivityChartTrendInput = {
  /** Optional child-org narrower (organizationParents); boundary is always the caller org. */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Fixed preset — the server derives [rangeStart, rangeEnd] from it; never client dates. */
  range?: InputMaybe<CustodianActivityChartTrendRange>;
};

export type FetchCustodianActivityChartTrendResponse = {
  __typename?: 'FetchCustodianActivityChartTrendResponse';
  result: CustodianActivityChartTrendResult;
};

export type FetchCustodianActivityMetricsInput = {
  /** Optional child-org narrower (organizationParents); boundary is always the caller org. */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchCustodianActivityMetricsResponse = {
  __typename?: 'FetchCustodianActivityMetricsResponse';
  metrics: CustodianActivityMetrics;
};

export type FetchCustodianBankAccountsInput = {
  filter: FetchCustodianBankAccountsInputFilter;
};

export type FetchCustodianBankAccountsInputFilter = {
  userId: Scalars['ObjectID']['input'];
};

export type FetchCustodianBankAccountsResponse = {
  __typename?: 'FetchCustodianBankAccountsResponse';
  custodianBankAccounts?: Maybe<Array<Maybe<CustodianBankAccount>>>;
};

export type FetchCustodianConnectionResponse = {
  __typename?: 'FetchCustodianConnectionResponse';
  custodianConnection: CustodianConnection;
};

export type FetchCustodianConnectionsInput = {
  filter?: InputMaybe<CustodianConnectionsQueryFilter>;
  pagination?: InputMaybe<CustodianConnectionsPaginationAndSorting>;
};

export type FetchCustodianConnectionsResponse = {
  __typename?: 'FetchCustodianConnectionsResponse';
  custodianConnections: Array<CustodianConnection>;
  totalCount: Scalars['Int']['output'];
};

export type FetchCustodianExternalDocument = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  dateAfter?: InputMaybe<Scalars['Date']['input']>;
  dateBefore?: InputMaybe<Scalars['Date']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<CustodianAccountStatementStates>;
  types?: InputMaybe<Array<InputMaybe<CustodianStatementTypes>>>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  viewId?: InputMaybe<Scalars['String']['input']>;
};

export type FetchCustodianExternalDocumentInput = {
  filter?: InputMaybe<FetchCustodianExternalDocument>;
};

export type FetchCustodianExternalDocumentResponse = {
  __typename?: 'FetchCustodianExternalDocumentResponse';
  document?: Maybe<Scalars['String']['output']>;
  signedUrlFormat?: Maybe<SignedUrlDocumentFormat>;
};

export type FetchCustodianNotificationsFilter = {
  notificationChannelTypes?: InputMaybe<Array<InputMaybe<CustodianNotificationChannelTypes>>>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchCustodianNotificationsInput = {
  filter?: InputMaybe<FetchCustodianNotificationsFilter>;
  pagination?: InputMaybe<FetchCustodianNotificationsPagination>;
};

export type FetchCustodianNotificationsPagination = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FetchCustodianNotificationsResponse = {
  __typename?: 'FetchCustodianNotificationsResponse';
  notifications: Array<CustodianNotification>;
  totalCount: Scalars['Int']['output'];
};

export type FetchCustodianResponse = {
  __typename?: 'FetchCustodianResponse';
  custodian: Custodian;
};

export type FetchCustodianStatementsFilter = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  dateAfter?: InputMaybe<Scalars['Date']['input']>;
  dateBefore?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<CustodianAccountStatementStates>;
  types?: InputMaybe<Array<InputMaybe<CustodianStatementTypes>>>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchCustodianStatementsInput = {
  filter?: InputMaybe<FetchCustodianStatementsFilter>;
  pagination?: InputMaybe<FetchCustodianStatementsPagination>;
};

export type FetchCustodianStatementsPagination = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FetchCustodianStatementsResponse = {
  __typename?: 'FetchCustodianStatementsResponse';
  statements: Array<CustodianStatements>;
  totalCount: Scalars['Int']['output'];
};

export type FetchCustodianTransactionTypesInput = {
  filter?: InputMaybe<FetchCustodianTransactionsFilter>;
};

export type FetchCustodianTransactionsFilter = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  accountType?: InputMaybe<CustodianConnectionAccountTypes>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateAfter?: InputMaybe<Scalars['Date']['input']>;
  dateBefore?: InputMaybe<Scalars['Date']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  types?: InputMaybe<Array<InputMaybe<CustodianTransactionTypes>>>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchCustodianTransactionsInput = {
  filter?: InputMaybe<FetchCustodianTransactionsFilter>;
  pagination?: InputMaybe<FetchCustodianTransactionsPagination>;
};

export type FetchCustodianTransactionsPagination = {
  additionalSortFields?: InputMaybe<Array<InputMaybe<AdditionalSortFieldInput>>>;
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FetchCustodianTransactionsResponse = {
  __typename?: 'FetchCustodianTransactionsResponse';
  totalCount: Scalars['Int']['output'];
  transactions: Array<CustodianTransaction>;
};

export type FetchCustodianUpcomingTransactionsFilter = {
  accountId: Scalars['ObjectID']['input'];
};

export type FetchCustodianUpcomingTransactionsInput = {
  filter: FetchCustodianUpcomingTransactionsFilter;
  pagination?: InputMaybe<FetchCustodianUpcomingTransactionsPagination>;
};

export type FetchCustodianUpcomingTransactionsPagination = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type FetchCustodianUpcomingTransactionsResponse = {
  __typename?: 'FetchCustodianUpcomingTransactionsResponse';
  totalCount: Scalars['Int']['output'];
  upcomingTransactions: Array<CustodianTransfer>;
};

export type FetchCustomAttributeLabelResponse = {
  __typename?: 'FetchCustomAttributeLabelResponse';
  customAttributeLabel: CustomAttributeLabel;
};

export type FetchCustomAttributeLabelsInput = {
  filter: CustomAttributeLabelQueryFilter;
  pagination?: InputMaybe<CustomAttributeLabelPaginationAndSorting>;
};

export type FetchCustomAttributeLabelsResponse = {
  __typename?: 'FetchCustomAttributeLabelsResponse';
  customAttributeLabels: Array<CustomAttributeLabel>;
  totalCount: Scalars['Int']['output'];
};

export type FetchCustomFieldResponse = {
  __typename?: 'FetchCustomFieldResponse';
  customField: CustomField;
};

export type FetchCustomFieldsInput = {
  filter?: InputMaybe<CustomFieldQueryFilter>;
  pagination?: InputMaybe<RolePaginationAndSorting>;
};

export type FetchCustomFieldsResponse = {
  __typename?: 'FetchCustomFieldsResponse';
  customFields: Array<CustomField>;
  totalCount: Scalars['Int']['output'];
};

export type FetchDashboardsResponse = {
  __typename?: 'FetchDashboardsResponse';
  dashboards: Array<Dashboard>;
};

export type FetchDisplayRoleResponse = {
  __typename?: 'FetchDisplayRoleResponse';
  displayRole: DisplayRole;
};

export type FetchDisplayRolesInput = {
  filter?: InputMaybe<DisplayRoleQueryFilter>;
  organizationId: Scalars['ObjectID']['input'];
};

export type FetchDisplayRolesResponse = {
  __typename?: 'FetchDisplayRolesResponse';
  displayRoles: Array<DisplayRole>;
  totalCount: Scalars['Int']['output'];
};

export type FetchDowntimeScheduleResponse = {
  __typename?: 'FetchDowntimeScheduleResponse';
  downtimeSchedule: DowntimeSchedule;
};

export type FetchDowntimeSchedulesInput = {
  filter?: InputMaybe<DowntimeScheduleQueryFilter>;
  pagination?: InputMaybe<DowntimeSchedulePaginationAndSorting>;
};

export type FetchDowntimeSchedulesResponse = {
  __typename?: 'FetchDowntimeSchedulesResponse';
  downtimeSchedules: Array<DowntimeSchedule>;
  totalCount: Scalars['Int']['output'];
};

export type FetchEntityFeeSettingsInput = {
  filter?: InputMaybe<EntityFeeSettingsQueryFilter>;
  pagination?: InputMaybe<AccountFeesPaginationAndSorting>;
};

export type FetchEntityFeeSettingsResponse = {
  __typename?: 'FetchEntityFeeSettingsResponse';
  entityFeeSettings: Array<EntityFeeSetting>;
  totalCount: Scalars['Int']['output'];
};

export type FetchEodFilesInput = {
  lastKey?: InputMaybe<Scalars['String']['input']>;
};

export type FetchEodFilesResponse = {
  __typename?: 'FetchEodFilesResponse';
  eodFiles?: Maybe<Array<Maybe<EodFile>>>;
};

export type FetchEventObjectTypeResponse = {
  __typename?: 'FetchEventObjectTypeResponse';
  objectTypes: Array<EventObjectType>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FetchEventsInput = {
  filter?: InputMaybe<EventsQueryFilter>;
  pagination?: InputMaybe<EventPaginationAndSorting>;
};

export type FetchEventsResponse = {
  __typename?: 'FetchEventsResponse';
  events: Array<Event>;
  totalCount: Scalars['Int']['output'];
};

export type FetchExportInput = {
  exportId: Scalars['ObjectID']['input'];
};

export type FetchExportResponse = {
  __typename?: 'FetchExportResponse';
  export: DataExport;
};

export type FetchExternalVendorUsageInput = {
  filter?: InputMaybe<ExternalVendorUsageFilter>;
  pagination?: InputMaybe<ExternalVendorUsageFilterPaginationAndSorting>;
};

export type FetchExternalVendorUsagesResponse = {
  __typename?: 'FetchExternalVendorUsagesResponse';
  externalVendorUsages?: Maybe<Array<Maybe<ExternalVendorUsage>>>;
  totalCount: Scalars['Int']['output'];
};

export type FetchFeatureFlagsResponse = {
  __typename?: 'FetchFeatureFlagsResponse';
  featureFlags: Array<FeatureFlag>;
};

export type FetchFeeSettingInput = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchFeeSettingResponse = {
  __typename?: 'FetchFeeSettingResponse';
  feeSetting?: Maybe<FeeSetting>;
};

export type FetchFeeTierResponse = {
  __typename?: 'FetchFeeTierResponse';
  feeTier: FeeTier;
};

export type FetchFeeTiersInput = {
  filter?: InputMaybe<FeeTierQueryFilter>;
  pagination?: InputMaybe<AccountFeesPaginationAndSorting>;
};

export type FetchFeeTiersResponse = {
  __typename?: 'FetchFeeTiersResponse';
  feeTiers: Array<FeeTier>;
  totalCount: Scalars['Int']['output'];
};

export type FetchFileDocumentResponse = {
  __typename?: 'FetchFileDocumentResponse';
  fileDocument: FileDocument;
};

/** Input type for fetching fileDocuments */
export type FetchFileDocumentsInput = {
  /** To filter the fileDocuments */
  filter?: InputMaybe<FileDocumentQueryFilter>;
  /** To organize the response as per the pagination fields */
  pagination?: InputMaybe<FileDocumentPaginationAndSorting>;
};

/** Type definition for fetching fileDocuments */
export type FetchFileDocumentsResponse = {
  __typename?: 'FetchFileDocumentsResponse';
  /** Returns an array of fileDocuments objects */
  fileDocuments: Array<FileDocument>;
  /** Total number of the fileDocuments records that satisfies a specified filter */
  totalCount: Scalars['Int']['output'];
};

export type FetchFileUploadUrlInput = {
  fileName: Scalars['String']['input'];
  generateUniqueFileName?: InputMaybe<Scalars['Boolean']['input']>;
  objectId: Scalars['ObjectID']['input'];
  objectType: FileDocumentObjectTypes;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  type: FileDocumentTypes;
  /** @deprecated userId is derived from objectId */
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchFileUploadUrlResponse = {
  __typename?: 'FetchFileUploadUrlResponse';
  s3Path?: Maybe<Scalars['String']['output']>;
  temporarySignedURL?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Long']['output']>;
};

export type FetchFillTemplateInput = {
  currency?: InputMaybe<CurrencyCodes>;
  encoded?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<TemplateLanguages>;
  objectId: Scalars['SafeString']['input'];
  objectType: ObjectTypes;
  template: Scalars['String']['input'];
};

export type FetchFillTemplateResponse = {
  __typename?: 'FetchFillTemplateResponse';
  template: Scalars['String']['output'];
};

export type FetchFinancialProductBulkUpsertItemResponse = {
  __typename?: 'FetchFinancialProductBulkUpsertItemResponse';
  bulkUpsertItem: FinancialProductBulkUpsertItem;
};

export type FetchFinancialProductBulkUpsertItemsInput = {
  filter: FinancialProductBulkUpsertItemQueryFilter;
  pagination?: InputMaybe<BulkUpsertPaginationAndSorting>;
};

export type FetchFinancialProductBulkUpsertItemsResponse = {
  __typename?: 'FetchFinancialProductBulkUpsertItemsResponse';
  bulkUpsertItems: Array<FinancialProductBulkUpsertItem>;
  totalCount: Scalars['Int']['output'];
};

export type FetchFinancialProductInput = {
  /** This is the financialProductId and it is auto-generated by OneVest for each Financial Product. */
  financialProductId: Scalars['SafeString']['input'];
};

export type FetchFinancialProductResponse = {
  __typename?: 'FetchFinancialProductResponse';
  /** The Financial product. */
  financialProduct: FinancialProduct;
};

export type FetchFinancialProductsInput = {
  filter?: InputMaybe<FinancialProductQueryFilter>;
  pagination?: InputMaybe<FinancialProductPaginationAndSorting>;
};

export type FetchFinancialProductsResponse = {
  __typename?: 'FetchFinancialProductsResponse';
  /** The Financial products. */
  financialProducts: Array<FinancialProduct>;
  /** The number of financial products. */
  totalCount: Scalars['Int']['output'];
};

export type FetchFlagResponse = {
  __typename?: 'FetchFlagResponse';
  flag: Flag;
};

export type FetchFlagsForActivityInput = {
  /**
   * Activity id — matches Flag.details._id (a string, not an ObjectID).
   * Trimmed; blank or whitespace-only is rejected.
   */
  detailsId: Scalars['String']['input'];
  pagination?: InputMaybe<FlagPaginationForGrid>;
};

export type FetchFlagsInput = {
  filter?: InputMaybe<FlagQueryFilter>;
  pagination?: InputMaybe<FlagPaginationAndSorting>;
};

export type FetchFlagsInputForGrid = {
  filter?: InputMaybe<FlagQueryFilterForGrid>;
  pagination?: InputMaybe<FlagPaginationForGrid>;
};

export type FetchFlagsResponse = {
  __typename?: 'FetchFlagsResponse';
  flags: Array<Flag>;
  totalCount: Scalars['Int']['output'];
};

export type FetchForeignExchangeRateInput = {
  from: Currencies;
  inheritFromParents?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  to: Currencies;
};

export type FetchForeignExchangeRateResponse = {
  __typename?: 'FetchForeignExchangeRateResponse';
  rate: Scalars['Float']['output'];
};

export type FetchForeignExchangeSnapshotsInput = {
  filter?: InputMaybe<ForeignExchangeSnapshotQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchForeignExchangeSnapshotsResponse = {
  __typename?: 'FetchForeignExchangeSnapshotsResponse';
  foreignExchangeSnapshots: Array<ForeignExchangeSnapshot>;
  totalCount: Scalars['Int']['output'];
};

export type FetchFormAgreementInput = {
  formAgreementId?: InputMaybe<Scalars['ObjectID']['input']>;
  iid?: InputMaybe<Scalars['String']['input']>;
};

export type FetchFormCompletionsInput = {
  filter?: InputMaybe<FormCompletionsQueryFilter>;
  pagination?: InputMaybe<FormCompletionsPaginationAndSorting>;
};

export type FetchFormCompletionsResponse = {
  __typename?: 'FetchFormCompletionsResponse';
  formCompletions: Array<FormCompletion>;
  totalCount: Scalars['Int']['output'];
};

export type FetchFormDefinitionsInput = {
  filter?: InputMaybe<FormDefinitionsQueryFilter>;
  pagination?: InputMaybe<FormDefinitionsPaginationAndSorting>;
};

export type FetchFormDefinitionsResponse = {
  __typename?: 'FetchFormDefinitionsResponse';
  formDefinitions: Array<FormDefinition>;
  totalCount: Scalars['Int']['output'];
};

export type FetchFormMapContextInput = {
  formMap: FormMapInput;
  objectId: Scalars['ID']['input'];
};

export type FetchFormMapContextPayload = {
  __typename?: 'FetchFormMapContextPayload';
  context: Scalars['Object']['output'];
  objectType: FormMapObjectType;
};

export type FetchFormTemplateInput = {
  formTemplateId?: InputMaybe<Scalars['ObjectID']['input']>;
  type?: InputMaybe<FormTypes>;
};

export type FetchFormTemplatesInput = {
  filter?: InputMaybe<FormTemplatesQueryFilter>;
  pagination?: InputMaybe<FormTemplatesPaginationAndSorting>;
};

export type FetchFormTemplatesResponse = {
  __typename?: 'FetchFormTemplatesResponse';
  formTemplates: Array<FormTemplate>;
  totalCount: Scalars['Int']['output'];
};

export type FetchFraudRiskInput = {
  fraudRiskId?: InputMaybe<Scalars['ObjectID']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchFraudRiskResponse = {
  __typename?: 'FetchFraudRiskResponse';
  fraudRisk: FraudRisk;
};

export type FetchGoalResponse = {
  __typename?: 'FetchGoalResponse';
  goal: Goal;
};

export type FetchGoalUpdatesInput = {
  goalId: Scalars['ObjectID']['input'];
  pagination?: InputMaybe<GoalUpdatePaginationAndSorting>;
};

export type FetchGoalUpdatesResponse = {
  __typename?: 'FetchGoalUpdatesResponse';
  goalUpdates: Array<GoalUpdate>;
  totalCount: Scalars['Int']['output'];
};

export type FetchGoalsInput = {
  filter?: InputMaybe<GoalQueryFilter>;
  pagination?: InputMaybe<GoalPaginationAndSorting>;
};

export type FetchGoalsResponse = {
  __typename?: 'FetchGoalsResponse';
  goals: Array<Goal>;
  totalCount: Scalars['Int']['output'];
};

export type FetchGroupedBillingsInput = {
  filter?: InputMaybe<SubAccountBillingQueryFilter>;
  pagination?: InputMaybe<FeePagination>;
};

export type FetchGroupedBillingsResponse = {
  __typename?: 'FetchGroupedBillingsResponse';
  groupedBillings: Array<GroupedBilling>;
  totalCount: Scalars['Int']['output'];
};

export type FetchHistoryBulkUpsertItemResponse = {
  __typename?: 'FetchHistoryBulkUpsertItemResponse';
  bulkUpsertItem: HistoryBulkUpsertItem;
};

export type FetchHistoryBulkUpsertItemsInput = {
  filter: HistoryBulkUpsertItemQueryFilter;
  pagination?: InputMaybe<BulkUpsertPaginationAndSorting>;
};

export type FetchHistoryBulkUpsertItemsResponse = {
  __typename?: 'FetchHistoryBulkUpsertItemsResponse';
  bulkUpsertItems: Array<HistoryBulkUpsertItem>;
  totalCount: Scalars['Int']['output'];
};

export type FetchHistoryInput = {
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ObjectID']['input'];
  type: DailyStatsTypes;
};

export type FetchHistoryResponse = {
  __typename?: 'FetchHistoryResponse';
  history: Array<HistoryResponse>;
};

export type FetchHoldingBulkUpsertItemResponse = {
  __typename?: 'FetchHoldingBulkUpsertItemResponse';
  bulkUpsertItem: HoldingBulkUpsertItem;
};

export type FetchHoldingBulkUpsertItemsInput = {
  filter: HoldingBulkUpsertItemQueryFilter;
  pagination?: InputMaybe<BulkUpsertPaginationAndSorting>;
};

export type FetchHoldingBulkUpsertItemsResponse = {
  __typename?: 'FetchHoldingBulkUpsertItemsResponse';
  bulkUpsertItems: Array<HoldingBulkUpsertItem>;
  totalCount: Scalars['Int']['output'];
};

export type FetchHoldingProductSummariesInput = {
  filter: HoldingProductSummaryQueryFilter;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchHoldingProductSummariesResponse = {
  __typename?: 'FetchHoldingProductSummariesResponse';
  holdingProductSummaries: Array<HoldingProductSummary>;
  totalAumCents: Scalars['Long']['output'];
  totalCount: Scalars['Int']['output'];
};

export type FetchHoldingsFilter = {
  currency?: InputMaybe<StatisticsCurrencyTypes>;
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  forUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectId: Scalars['SafeString']['input'];
  objectType: HoldingsObjectType;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};

export type FetchHoldingsInput = {
  filter: FetchHoldingsFilter;
  pagination?: InputMaybe<FetchHoldingsPaginationAndSorting>;
};

export type FetchHoldingsPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FetchHoldingsResponse = {
  __typename?: 'FetchHoldingsResponse';
  holdings: Array<StatisticHolding>;
  totalCount: Scalars['Int']['output'];
};

export type FetchHomePageConfigurationResponse = {
  __typename?: 'FetchHomePageConfigurationResponse';
  homePageConfiguration: HomePageConfiguration;
};

export type FetchHomePageConfigurationsInput = {
  filter?: InputMaybe<HomePageConfigurationQueryFilter>;
  pagination?: InputMaybe<RolePaginationAndSorting>;
};

export type FetchHomePageConfigurationsResponse = {
  __typename?: 'FetchHomePageConfigurationsResponse';
  homePageConfigurations: Array<HomePageConfiguration>;
  totalCount: Scalars['Int']['output'];
};

export type FetchHomePageWidgetOptionsResponse = {
  __typename?: 'FetchHomePageWidgetOptionsResponse';
  widgetOptions: Array<HomePageWidgetOption>;
};

export type FetchImportFileLineItemResponse = {
  __typename?: 'FetchImportFileLineItemResponse';
  importFileLineItem: ImportFileLineItem;
};

export type FetchImportFileLineItemsInput = {
  filter: ImportFileLineItemQueryFilter;
  pagination?: InputMaybe<FileDocumentPaginationAndSorting>;
};

export type FetchImportFileLineItemsResponse = {
  __typename?: 'FetchImportFileLineItemsResponse';
  importFileLineItems: Array<ImportFileLineItem>;
  totalCount: Scalars['Int']['output'];
};

export type FetchImportFileResponse = {
  __typename?: 'FetchImportFileResponse';
  importFile: ImportFile;
};

export type FetchImportFileTemplateResponse = {
  __typename?: 'FetchImportFileTemplateResponse';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  type: ImportFileTypes;
};

export type FetchImportFilesInput = {
  filter?: InputMaybe<ImportFileQueryFilter>;
  pagination?: InputMaybe<FileDocumentPaginationAndSorting>;
};

export type FetchImportFilesResponse = {
  __typename?: 'FetchImportFilesResponse';
  importFiles: Array<ImportFile>;
  totalCount: Scalars['Int']['output'];
};

export type FetchInstitutionResponse = {
  __typename?: 'FetchInstitutionResponse';
  institution: Institution;
};

export type FetchInstitutionsInput = {
  filter?: InputMaybe<InstitutionQueryFilter>;
  pagination?: InputMaybe<InstitutionPaginationAndSorting>;
};

export type FetchInstitutionsResponse = {
  __typename?: 'FetchInstitutionsResponse';
  institutions: Array<Institution>;
  totalCount: Scalars['Int']['output'];
};

export type FetchIntegrationFormPackSigningViewUrlInput = {
  integrationFormPackId: Scalars['ObjectID']['input'];
  /** HTTPS URL where DocuSign redirects after signing completes or is cancelled (required by Recipient View). */
  returnUrl: Scalars['String']['input'];
  /** Signer role key from the pack's signer mapping (e.g. primary). */
  signerKey: Scalars['String']['input'];
};

export type FetchIntegrationFormPackSigningViewUrlResponse = {
  __typename?: 'FetchIntegrationFormPackSigningViewUrlResponse';
  /** Short-lived DocuSign Recipient View URL for the requested signer. DocuSign only. */
  signingViewUrl?: Maybe<Scalars['String']['output']>;
};

export type FetchIntegrationFormPacksInput = {
  filter?: InputMaybe<IntegrationFormPacksQueryFilter>;
  pagination?: InputMaybe<IntegrationFormPacksPaginationAndSorting>;
};

export type FetchIntegrationFormPacksResponse = {
  __typename?: 'FetchIntegrationFormPacksResponse';
  integrationFormPacks: Array<IntegrationFormPack>;
  totalCount: Scalars['Int']['output'];
};

export type FetchIntegrationRequestPayloadsInput = {
  filter?: InputMaybe<IntegrationRequestPayloadQueryFilter>;
  pagination?: InputMaybe<IntegrationRequestPayloadsPaginationAndSorting>;
};

export type FetchIntegrationRequestPayloadsResponse = {
  __typename?: 'FetchIntegrationRequestPayloadsResponse';
  integrationRequestPayloads: Array<IntegrationRequestPayload>;
  totalCount: Scalars['Int']['output'];
};

export type FetchIntegrationResponse = {
  __typename?: 'FetchIntegrationResponse';
  integration: Integration;
};

export type FetchIntegrationStatefulDataInput = {
  filter?: InputMaybe<IntegrationStatefulDataFilter>;
  integrationId: Scalars['ObjectID']['input'];
};

export type FetchIntegrationStatefulDataResponse = {
  __typename?: 'FetchIntegrationStatefulDataResponse';
  integrationStatefulData: Array<IntegrationStatefulData>;
};

export type FetchIntegrationsInput = {
  filter?: InputMaybe<IntegrationQueryFilter>;
  pagination?: InputMaybe<RolePaginationAndSorting>;
};

export type FetchIntegrationsResponse = {
  __typename?: 'FetchIntegrationsResponse';
  integrations: Array<Integration>;
  totalCount: Scalars['Int']['output'];
};

export type FetchJobTitleRiskInput = {
  jobTitleRiskId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchJobTitleRiskResponse = {
  __typename?: 'FetchJobTitleRiskResponse';
  jobTitleRisk: JobTitleRisk;
};

export type FetchLocalizationResponse = {
  __typename?: 'FetchLocalizationResponse';
  localization?: Maybe<Localization>;
};

export type FetchLocalizationsInput = {
  filter?: InputMaybe<LocalizationQueryFilter>;
  pagination?: InputMaybe<LocalizationPaginationAndSorting>;
};

export type FetchLocalizationsResponse = {
  __typename?: 'FetchLocalizationsResponse';
  localizations: Array<Localization>;
  totalCount: Scalars['Int']['output'];
};

export type FetchLogResponse = {
  __typename?: 'FetchLogResponse';
  log: Log;
};

/** Input type for fetching logs */
export type FetchLogsInput = {
  /** To filter the logs */
  filter?: InputMaybe<LogQueryFilter>;
  /** To organize the response as per the pagination fields */
  pagination?: InputMaybe<LogPaginationAndSorting>;
};

/** Type definition for fetching logs */
export type FetchLogsResponse = {
  __typename?: 'FetchLogsResponse';
  /** Returns an array of logs objects */
  logs: Array<Log>;
  /** Total number of the logs records that satisfies a specified filter */
  totalCount: Scalars['Int']['output'];
};

export type FetchLsegSamlRequestInput = {
  organizationId: Scalars['ObjectID']['input'];
};

export type FetchLsegSamlRequestResponse = {
  __typename?: 'FetchLsegSamlRequestResponse';
  samlRequest?: Maybe<Scalars['String']['output']>;
};

export type FetchManualProcessResponse = {
  __typename?: 'FetchManualProcessResponse';
  manualProcess: ManualProcess;
};

export type FetchManualProcessesInput = {
  filter: ManualProcessesQueryFilter;
  pagination?: InputMaybe<ManualProcessesPaginationAndSorting>;
};

export type FetchMarketDataFromProviderInput = {
  organizationId: Scalars['ObjectID']['input'];
  tickers: Array<Scalars['String']['input']>;
};

export type FetchMarketDataFromProviderResponse = {
  __typename?: 'FetchMarketDataFromProviderResponse';
  marketData: Array<MarketData>;
};

export type FetchModelChangeProposalInput = {
  modelChangeProposalId: Scalars['ObjectID']['input'];
};

export type FetchModelChangeProposalResponse = {
  __typename?: 'FetchModelChangeProposalResponse';
  modelChangeProposal: ModelChangeProposal;
};

export type FetchModelChangeProposalsInput = {
  filter?: InputMaybe<ModelChangeProposalQueryFilter>;
  pagination?: InputMaybe<ModelChangeProposalPaginationAndSorting>;
};

export type FetchModelChangeProposalsResponse = {
  __typename?: 'FetchModelChangeProposalsResponse';
  modelChangeProposals: Array<ModelChangeProposal>;
  totalCount: Scalars['Int']['output'];
};

export type FetchModelPortfolioChildrenInput = {
  filter?: InputMaybe<ModelPortfolioChildrenQueryFilter>;
  pagination?: InputMaybe<ModelPortfolioChildrenPaginationAndSorting>;
};

export type FetchModelPortfolioChildrenResponse = {
  __typename?: 'FetchModelPortfolioChildrenResponse';
  children: Array<Branch>;
  totalCount: Scalars['Int']['output'];
};

export type FetchModelPortfolioInput = {
  /** This is the financialProductId and it is auto-generated by OneVest for each Financial Product. */
  modelPortfolioId: Scalars['ObjectID']['input'];
};

export type FetchModelPortfolioResponse = {
  __typename?: 'FetchModelPortfolioResponse';
  /** The Financial product. */
  modelPortfolio: FinancialProduct;
};

export type FetchModelPortfoliosInput = {
  filter?: InputMaybe<ModelPortfolioQueryFilter>;
  pagination?: InputMaybe<ModelPortfolioPaginationAndSorting>;
};

export type FetchModelPortfoliosResponse = {
  __typename?: 'FetchModelPortfoliosResponse';
  /** The Financial products. */
  modelPortfolios: Array<FinancialProduct>;
  /** The number of financial products. */
  totalCount: Scalars['Int']['output'];
};

export type FetchNoteResponse = {
  __typename?: 'FetchNoteResponse';
  note: Note;
};

/** Input type for fetching notes */
export type FetchNotesInput = {
  /** To filter the notes */
  filter?: InputMaybe<NoteQueryFilter>;
  /** To organize the response as per the pagination fields */
  pagination?: InputMaybe<NotePaginationAndSorting>;
};

/** Type definition for fetching notes */
export type FetchNotesResponse = {
  __typename?: 'FetchNotesResponse';
  /** Returns an array of notes objects */
  notes: Array<Note>;
  /** Total number of the notes records that satisfies a specified filter */
  totalCount: Scalars['Int']['output'];
};

export type FetchNotificationDefinitionResponse = {
  __typename?: 'FetchNotificationDefinitionResponse';
  notificationDefinition: NotificationDefinition;
};

export type FetchNotificationDefinitionsInput = {
  filter?: InputMaybe<NotificationDefinitionQueryFilter>;
  pagination?: InputMaybe<NotificationDefinitionPaginationAndSorting>;
};

export type FetchNotificationDefinitionsResponse = {
  __typename?: 'FetchNotificationDefinitionsResponse';
  notificationDefinitions: Array<NotificationDefinition>;
  totalCount: Scalars['Int']['output'];
};

export type FetchNotificationGroupResponse = {
  __typename?: 'FetchNotificationGroupResponse';
  notificationGroup: NotificationGroup;
};

export type FetchNotificationGroupsInput = {
  filter?: InputMaybe<NotificationGroupQueryFilter>;
  pagination?: InputMaybe<NotificationGroupPaginationAndSorting>;
};

export type FetchNotificationGroupsResponse = {
  __typename?: 'FetchNotificationGroupsResponse';
  notificationGroups: Array<NotificationGroup>;
  totalCount: Scalars['Int']['output'];
};

export type FetchNotificationsInput = {
  filter?: InputMaybe<NotificationQueryFilter>;
  pagination?: InputMaybe<NotificationPaginationAndSorting>;
};

export type FetchNotificationsResponse = {
  __typename?: 'FetchNotificationsResponse';
  notifications: Array<Notification>;
  totalCount: Scalars['Int']['output'];
};

export type FetchOptimalPortfolioInput = {
  optimalPortfolioId: Scalars['ObjectID']['input'];
};

export type FetchOptimalPortfolioResponse = {
  __typename?: 'FetchOptimalPortfolioResponse';
  optimalPortfolio: OptimalPortfolio;
};

export type FetchOptimizedPortfolioReportsInput = {
  organizationId: Scalars['ObjectID']['input'];
  pagination: PortfolioReportsPagination;
  portfolioOptimizerId: Scalars['ObjectID']['input'];
};

export type FetchOptimizedPortfolioReportsResponse = {
  __typename?: 'FetchOptimizedPortfolioReportsResponse';
  portfolioReports: Array<PortfolioReport>;
  totalCount: Scalars['Int']['output'];
};

export type FetchOptimizerAuditsV2Input = {
  optimizerRunId: Scalars['ObjectID']['input'];
};

export type FetchOptimizerAuditsV2Response = {
  __typename?: 'FetchOptimizerAuditsV2Response';
  audits: Array<OptimizerAuditV2>;
};

export type FetchOptimizerRunV2Input = {
  optimizerRunId: Scalars['ObjectID']['input'];
};

export type FetchOptimizerRunV2Response = {
  __typename?: 'FetchOptimizerRunV2Response';
  optimizerRun: OptimizerRunV2;
};

export type FetchOptimizerRunsV2Input = {
  filter?: InputMaybe<OptimizerRunV2QueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchOptimizerRunsV2Response = {
  __typename?: 'FetchOptimizerRunsV2Response';
  optimizerRuns: Array<OptimizerRunV2>;
  totalCount: Scalars['Int']['output'];
};

export type FetchOrganizationBulkUpsertItemResponse = {
  __typename?: 'FetchOrganizationBulkUpsertItemResponse';
  bulkUpsertItem: OrganizationBulkUpsertItem;
};

export type FetchOrganizationBulkUpsertItemsInput = {
  filter: OrganizationBulkUpsertItemQueryFilter;
  pagination?: InputMaybe<BulkUpsertPaginationAndSorting>;
};

export type FetchOrganizationBulkUpsertItemsResponse = {
  __typename?: 'FetchOrganizationBulkUpsertItemsResponse';
  bulkUpsertItems: Array<OrganizationBulkUpsertItem>;
  totalCount: Scalars['Int']['output'];
};

export type FetchOrganizationDashboardResponse = {
  __typename?: 'FetchOrganizationDashboardResponse';
  dashboard: Dashboard;
};

export type FetchOrganizationDashboardsInput = {
  filter?: InputMaybe<DashboardQueryFilter>;
  pagination?: InputMaybe<DashboardPaginationAndSorting>;
};

export type FetchOrganizationDashboardsResponse = {
  __typename?: 'FetchOrganizationDashboardsResponse';
  dashboards: Array<Dashboard>;
  totalCount: Scalars['Int']['output'];
};

export type FetchOrganizationFeatureFlagResponse = {
  __typename?: 'FetchOrganizationFeatureFlagResponse';
  organizationFeatureFlag: OrganizationFeatureFlag;
};

export type FetchOrganizationPublicSettingsInput = {
  customUrl?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

export type FetchOrganizationPublicSettingsResponse = {
  __typename?: 'FetchOrganizationPublicSettingsResponse';
  /** Specific Authentication option based on the customUrl input */
  authenticationType?: Maybe<AuthenticationConnections>;
  browserTabTitle?: Maybe<Scalars['String']['output']>;
  clientHostedLoginClientId?: Maybe<Scalars['String']['output']>;
  clientHostedLoginScope?: Maybe<Scalars['String']['output']>;
  clientHostedLoginURL?: Maybe<Scalars['String']['output']>;
  /** Identify whether single logout (SLO) is enabled for the organization */
  enableSingleLogout?: Maybe<Scalars['Boolean']['output']>;
  /** Specific Enterprise connection based on the customUrl input */
  enterpriseConnectionName?: Maybe<Scalars['String']['output']>;
  faviconLink?: Maybe<Scalars['String']['output']>;
  /**
   * URL the user is redirected to after signing up in Auth0.
   * Uses this organization's invitationRedirectUrl when set. Otherwise uses the value from
   * the closest ancestor with allowAccessToSubOrganizations enabled, when that ancestor defines one.
   */
  invitationRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** Identify what the URL should use to redirect on logout */
  logoutUrl?: Maybe<Scalars['String']['output']>;
  subdomain?: Maybe<Scalars['String']['output']>;
  /** Identify whether the customUrl should use the Hosted Login solution */
  useHostedLogin?: Maybe<Scalars['Boolean']['output']>;
};

export type FetchOrganizationResponse = {
  __typename?: 'FetchOrganizationResponse';
  organization: Organization;
};

export type FetchOrganizationSubdomainInput = {
  customUrl: Scalars['String']['input'];
};

export type FetchOrganizationSubdomainResponse = {
  __typename?: 'FetchOrganizationSubdomainResponse';
  subdomain?: Maybe<Scalars['String']['output']>;
};

export type FetchOrganizationUserByEmailInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchOrganizationUserByReferenceIdInput = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  referenceId: Scalars['SafeString']['input'];
};

export type FetchOrganizationUserResponse = {
  __typename?: 'FetchOrganizationUserResponse';
  organizationUser: OrganizationUser;
};

export type FetchOrganizationUsersInput = {
  filter?: InputMaybe<OrganizationUserQueryFilter>;
  pagination?: InputMaybe<OrganizationUserPaginationAndSorting>;
};

export type FetchOrganizationUsersResponse = {
  __typename?: 'FetchOrganizationUsersResponse';
  organizationUsers: Array<OrganizationUser>;
  totalCount: Scalars['Int']['output'];
};

export type FetchOrganizationsInput = {
  filter?: InputMaybe<OrganizationQueryFilter>;
  pagination?: InputMaybe<OrganizationPaginationAndSorting>;
};

export type FetchOrganizationsResponse = {
  __typename?: 'FetchOrganizationsResponse';
  organizations: Array<Organization>;
  totalCount: Scalars['Int']['output'];
};

export type FetchPageConfigurationResponse = {
  __typename?: 'FetchPageConfigurationResponse';
  pageConfiguration: PageConfiguration;
};

export type FetchPageConfigurationsInput = {
  filter?: InputMaybe<PageConfigurationQueryFilter>;
  pagination?: InputMaybe<RolePaginationAndSorting>;
};

export type FetchPageConfigurationsResponse = {
  __typename?: 'FetchPageConfigurationsResponse';
  pageConfigurations: Array<PageConfiguration>;
  totalCount: Scalars['Int']['output'];
};

export type FetchPermissionsResponse = {
  __typename?: 'FetchPermissionsResponse';
  permissions: Array<Permission>;
};

/** Input for fetching full address details */
export type FetchPhysicalAddressInput = {
  /** The ID of the selected address (place_id for Google, Id for Canada Post) */
  addressId: Scalars['String']['input'];
  /** Integration ID for the address provider */
  integrationId: Scalars['ObjectID']['input'];
  /** Language preference */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID for fetching integration */
  organizationId: Scalars['ObjectID']['input'];
};

export type FetchPhysicalAddressResponse = {
  __typename?: 'FetchPhysicalAddressResponse';
  addressDetails: AddressDetails;
};

export type FetchPortfolioOptimizerInput = {
  portfolioOptimizerId: Scalars['ObjectID']['input'];
};

export type FetchPortfolioOptimizerResponse = {
  __typename?: 'FetchPortfolioOptimizerResponse';
  portfolioOptimizer: PortfolioOptimizer;
};

export type FetchPortfolioOptimizersInput = {
  filter?: InputMaybe<PortfolioOptimizerQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchPortfolioOptimizersResponse = {
  __typename?: 'FetchPortfolioOptimizersResponse';
  portfolioOptimizers: Array<PortfolioOptimizer>;
  totalCount: Scalars['Int']['output'];
};

export type FetchPortfolioReportsByHoldingProductInput = {
  filter: PortfolioReportsByHoldingProductQueryFilter;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchPortfolioReportsByHoldingProductResponse = {
  __typename?: 'FetchPortfolioReportsByHoldingProductResponse';
  portfolioReports: Array<PortfolioReport>;
  totalCount: Scalars['Int']['output'];
};

export type FetchPortfolioReportsInput = {
  filter?: InputMaybe<PortfolioReportQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchPortfolioReportsResponse = {
  __typename?: 'FetchPortfolioReportsResponse';
  portfolioReports: Array<PortfolioReport>;
  totalCount: Scalars['Int']['output'];
};

export type FetchPortfolioTemplateInput = {
  portfolioTemplateId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FetchPortfolioTemplateResponse = {
  __typename?: 'FetchPortfolioTemplateResponse';
  portfolioTemplate: PortfolioTemplate;
};

export type FetchPortfolioTemplatesInput = {
  filter?: InputMaybe<PortfolioTemplateQueryFilter>;
  pagination?: InputMaybe<PortfolioTemplatePaginationAndSorting>;
};

export type FetchPortfolioTemplatesResponse = {
  __typename?: 'FetchPortfolioTemplatesResponse';
  portfolioTemplates: Array<PortfolioTemplate>;
  totalCount: Scalars['Int']['output'];
};

export type FetchProductAumExposureFilter = {
  currency?: InputMaybe<StatisticsCurrencyTypes>;
  financialProductId: Scalars['ObjectID']['input'];
  objectType: ProductAumExposureObjectType;
  organizationId: Scalars['ObjectID']['input'];
};

export type FetchProductAumExposureInput = {
  filter: FetchProductAumExposureFilter;
  pagination?: InputMaybe<FetchHoldingsPaginationAndSorting>;
};

export type FetchProductAumExposureResponse = {
  __typename?: 'FetchProductAumExposureResponse';
  exposures: Array<ProductAumExposureRow>;
  totalCount: Scalars['Int']['output'];
  totalMarketValueCents: Scalars['Long']['output'];
};

export type FetchPublicOrganizationsInput = {
  filter?: InputMaybe<PublicOrganizationQueryFilter>;
  pagination?: InputMaybe<OrganizationPaginationAndSorting>;
};

export type FetchPublicOrganizationsResponse = {
  __typename?: 'FetchPublicOrganizationsResponse';
  organizations: Array<PublicOrganization>;
  totalCount: Scalars['Int']['output'];
};

export type FetchRebalanceHoldingReportsInput = {
  filter?: InputMaybe<RebalanceHoldingReportQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchRebalanceHoldingReportsResponse = {
  __typename?: 'FetchRebalanceHoldingReportsResponse';
  rebalanceHoldingReports: Array<RebalanceHoldingReport>;
  totalCount: Scalars['Int']['output'];
};

export type FetchRebalanceMetricsInput = {
  rebalanceMetricsId: Scalars['ObjectID']['input'];
};

export type FetchRebalanceMetricsResponse = {
  __typename?: 'FetchRebalanceMetricsResponse';
  rebalanceMetrics: RebalanceMetrics;
};

export type FetchRebalanceReportsInput = {
  filter?: InputMaybe<RebalanceReportQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchRebalanceReportsResponse = {
  __typename?: 'FetchRebalanceReportsResponse';
  rebalanceReports: Array<RebalanceReport>;
  totalCount: Scalars['Int']['output'];
};

export type FetchRebalanceResponse = {
  __typename?: 'FetchRebalanceResponse';
  rebalance: Rebalance;
};

export type FetchRebalancesInput = {
  filter?: InputMaybe<RebalanceQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchRebalancesResponse = {
  __typename?: 'FetchRebalancesResponse';
  rebalances: Array<Rebalance>;
  totalCount: Scalars['Int']['output'];
};

export type FetchRepCodeResponse = {
  __typename?: 'FetchRepCodeResponse';
  repCode: RepCode;
};

export type FetchRepCodesInput = {
  filter?: InputMaybe<RepCodeQueryFilter>;
  pagination?: InputMaybe<RolePaginationAndSorting>;
};

export type FetchRepCodesResponse = {
  __typename?: 'FetchRepCodesResponse';
  repCodes: Array<RepCode>;
  totalCount: Scalars['Int']['output'];
};

export type FetchReportInput = {
  organizationId: Scalars['ObjectID']['input'];
  reportId: Scalars['ObjectID']['input'];
};

export type FetchReportOptionsInput = {
  type: ReportType;
};

export type FetchReportOptionsResponse = {
  __typename?: 'FetchReportOptionsResponse';
  columns: Array<Scalars['String']['output']>;
  filters: Array<ReportFilterOptions>;
};

export type FetchReportResponse = {
  __typename?: 'FetchReportResponse';
  report: DataReport;
};

export type FetchReportsFilterInput = {
  organizationId: Scalars['ObjectID']['input'];
  type?: InputMaybe<ReportType>;
};

export type FetchReportsInput = {
  filter: FetchReportsFilterInput;
  pagination?: InputMaybe<FetchReportsPaginationInput>;
};

export type FetchReportsPaginationInput = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FetchReportsResponse = {
  __typename?: 'FetchReportsResponse';
  reports: Array<DataReport>;
  totalCount: Scalars['Int']['output'];
};

export type FetchRequiredFormsInput = {
  accountType: FormAccountTypes;
  hasBeneficiaries: Scalars['Boolean']['input'];
  isUSPerson: Scalars['Boolean']['input'];
};

export type FetchRequiredFormsResponse = {
  __typename?: 'FetchRequiredFormsResponse';
  forms: Array<Maybe<FormTemplate>>;
};

export type FetchResolvedAdvisorContactsInput = {
  /**
   * Narrow to one account for account-scoped resolution and visibility.
   * Omit with multiple userIds to apply household compile visibility.
   */
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The clients to resolve. For a household, every member's id. */
  userIds: Array<Scalars['ObjectID']['input']>;
};

export type FetchResolvedAdvisorContactsResponse = {
  __typename?: 'FetchResolvedAdvisorContactsResponse';
  resolvedAdvisorContacts: Array<ResolvedAdvisorContact>;
};

export type FetchRoleProfileResponse = {
  __typename?: 'FetchRoleProfileResponse';
  roleProfile: RoleProfile;
};

export type FetchRoleProfilesInput = {
  filter?: InputMaybe<RoleProfileQueryFilter>;
  pagination?: InputMaybe<RolePaginationAndSorting>;
};

export type FetchRoleProfilesResponse = {
  __typename?: 'FetchRoleProfilesResponse';
  roleProfiles: Array<RoleProfile>;
  totalCount: Scalars['Int']['output'];
};

export type FetchRoleResponse = {
  __typename?: 'FetchRoleResponse';
  role: Role;
};

export type FetchRolesInput = {
  filter?: InputMaybe<RoleQueryFilter>;
  pagination?: InputMaybe<RolePaginationAndSorting>;
};

export type FetchRolesResponse = {
  __typename?: 'FetchRolesResponse';
  roles: Array<Role>;
  totalCount: Scalars['Int']['output'];
};

export type FetchSalesTaxConfigurationInput = {
  applicableDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  organizationId: Scalars['ObjectID']['input'];
};

export type FetchSalesTaxConfigurationResponse = {
  __typename?: 'FetchSalesTaxConfigurationResponse';
  salesTaxConfiguration: SalesTaxConfiguration;
};

export type FetchScheduleResponse = {
  __typename?: 'FetchScheduleResponse';
  /** The Schedule. */
  schedule: Schedule;
};

export type FetchScheduledTransferResponse = {
  __typename?: 'FetchScheduledTransferResponse';
  scheduledTransfer: ScheduledTransfer;
};

export type FetchScheduledTransfersInput = {
  filter?: InputMaybe<ScheduledTransferQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchScheduledTransfersResponse = {
  __typename?: 'FetchScheduledTransfersResponse';
  scheduledTransfers: Array<ScheduledTransfer>;
  totalCount: Scalars['Int']['output'];
};

export type FetchSchedulesInput = {
  filter?: InputMaybe<ScheduleFilterQuery>;
  pagination?: InputMaybe<ThemePaginationAndSorting>;
};

export type FetchSchedulesResponse = {
  __typename?: 'FetchSchedulesResponse';
  schedules: Array<Schedule>;
  totalCount: Scalars['Int']['output'];
};

export type FetchSiemFeedResponse = {
  __typename?: 'FetchSiemFeedResponse';
  siemFeed: SiemFeed;
};

export type FetchSiemFeedsInput = {
  filter?: InputMaybe<SiemFeedQueryFilter>;
};

export type FetchSiemFeedsResponse = {
  __typename?: 'FetchSiemFeedsResponse';
  siemFeeds: Array<SiemFeed>;
};

export type FetchSignerTypesInput = {
  filter?: InputMaybe<SignerTypesQueryFilter>;
  pagination?: InputMaybe<SignerTypesPaginationAndSorting>;
};

export type FetchSignerTypesResponse = {
  __typename?: 'FetchSignerTypesResponse';
  signerTypes: Array<SignerType>;
  totalCount: Scalars['Int']['output'];
};

export type FetchStatementUploadUrlInput = {
  accountId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  objectId: Scalars['ObjectID']['input'];
  objectType: AccountStatementObjectTypes;
  type: StatementTypes;
};

export type FetchStatementUploadUrlResponse = {
  __typename?: 'FetchStatementUploadUrlResponse';
  s3Path?: Maybe<Scalars['String']['output']>;
  temporarySignedURL?: Maybe<Scalars['String']['output']>;
};

export type FetchStaticPageWidgetConfigurationResponse = {
  __typename?: 'FetchStaticPageWidgetConfigurationResponse';
  staticPageWidgetConfiguration: StaticPageWidgetConfiguration;
};

export type FetchStaticPageWidgetConfigurationsInput = {
  filter?: InputMaybe<StaticPageWidgetConfigurationQueryFilter>;
  pagination?: InputMaybe<RolePaginationAndSorting>;
};

export type FetchStaticPageWidgetConfigurationsResponse = {
  __typename?: 'FetchStaticPageWidgetConfigurationsResponse';
  staticPageWidgetConfigurations: Array<StaticPageWidgetConfiguration>;
  totalCount: Scalars['Int']['output'];
};

export type FetchStaticWidgetOptionsResponse = {
  __typename?: 'FetchStaticWidgetOptionsResponse';
  widgetOptions: Array<StaticWidgetOption>;
};

export type FetchStatsHistoryFilter = {
  accountType?: InputMaybe<HistoryAccountType>;
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
  includeAllHouseholds?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Not used anymore. */
  includeHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  modelPortfolioId?: InputMaybe<Scalars['ObjectID']['input']>;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type FetchStatsHistoryInput = {
  currency?: InputMaybe<StatisticsCurrencyTypes>;
  filter?: InputMaybe<FetchStatsHistoryFilter>;
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  id: Scalars['SafeString']['input'];
  pagination?: InputMaybe<PaginationAndSorting>;
  sourceType?: InputMaybe<SourceTypesFilter>;
  type: DailyStatsTypes;
};

export type FetchStatsHistoryResponse = {
  __typename?: 'FetchStatsHistoryResponse';
  snapshots: Array<DailySnapshot>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FetchSubAccountBillingResponse = {
  __typename?: 'FetchSubAccountBillingResponse';
  subAccountBilling: SubAccountBilling;
};

export type FetchSubAccountBillingsInput = {
  filter?: InputMaybe<SubAccountBillingQueryFilter>;
  pagination?: InputMaybe<AccountFeesPaginationAndSorting>;
};

export type FetchSubAccountBillingsResponse = {
  __typename?: 'FetchSubAccountBillingsResponse';
  subAccountBillings: Array<SubAccountBilling>;
  totalCount: Scalars['Int']['output'];
};

export type FetchSubAccountDailyFeeResponse = {
  __typename?: 'FetchSubAccountDailyFeeResponse';
  subAccountDailyFee: SubAccountDailyFee;
};

export type FetchSubAccountDailyFeesInput = {
  filter?: InputMaybe<SubAccountDailyFeeQueryFilter>;
  pagination?: InputMaybe<AccountFeesPaginationAndSorting>;
};

export type FetchSubAccountDailyFeesResponse = {
  __typename?: 'FetchSubAccountDailyFeesResponse';
  subAccountDailyFees: Array<SubAccountDailyFee>;
  totalCount: Scalars['Int']['output'];
};

export type FetchSubAccountResponse = {
  __typename?: 'FetchSubAccountResponse';
  subAccount: SubAccount;
};

export type FetchSubAccountUpdatesInput = {
  pagination?: InputMaybe<SubAccountUpdatePaginationAndSorting>;
  subAccountId: Scalars['ObjectID']['input'];
};

export type FetchSubAccountUpdatesResponse = {
  __typename?: 'FetchSubAccountUpdatesResponse';
  subAccountUpdates: Array<SubAccountUpdate>;
  totalCount: Scalars['Int']['output'];
};

export type FetchSubAccountsInput = {
  filter?: InputMaybe<SubAccountQueryFilter>;
  pagination?: InputMaybe<SubAccountPaginationAndSorting>;
};

export type FetchSubAccountsResponse = {
  __typename?: 'FetchSubAccountsResponse';
  subAccounts: Array<SubAccount>;
  totalCount: Scalars['Int']['output'];
};

export type FetchSubStepOptionsResponse = {
  __typename?: 'FetchSubStepOptionsResponse';
  subStepOptions: Array<SubStepOption>;
};

export type FetchSubTradeRequestResponse = {
  __typename?: 'FetchSubTradeRequestResponse';
  subTradeRequest: SubTradeRequest;
};

export type FetchSubTradeRequestsInput = {
  filter?: InputMaybe<SubTradeRequestQueryFilter>;
  pagination?: InputMaybe<SubTradeRequestPaginationAndSorting>;
};

export type FetchSubTradeRequestsResponse = {
  __typename?: 'FetchSubTradeRequestsResponse';
  subTradeRequests: Array<SubTradeRequest>;
  totalCount: Scalars['Int']['output'];
};

export type FetchSubTradesInput = {
  filter?: InputMaybe<SubTradeQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchSubTradesResponse = {
  __typename?: 'FetchSubTradesResponse';
  subTrades: Array<SubTrade>;
  totalCount: Scalars['Int']['output'];
};

export type FetchTableExternalDataInput = {
  configurableTablePageId: Scalars['ObjectID']['input'];
  filter?: InputMaybe<Scalars['Object']['input']>;
  language?: InputMaybe<Languages>;
  pageObjectId?: InputMaybe<Scalars['SafeString']['input']>;
  pageType?: InputMaybe<PageConfigurationTypes>;
  pagination?: InputMaybe<TableExternalDataPaginationAndSorting>;
};

export type FetchTableExternalDataResponse = {
  __typename?: 'FetchTableExternalDataResponse';
  cursor?: Maybe<FetchTableExternalDataResponseCursor>;
  tableExternalData?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalValues?: Maybe<Scalars['Object']['output']>;
  widgets: Array<ConfigurableTablePageWidget>;
};

export type FetchTableExternalDataResponseCursor = {
  __typename?: 'FetchTableExternalDataResponseCursor';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

export type FetchThemeResponse = {
  __typename?: 'FetchThemeResponse';
  theme: Theme;
};

export type FetchThemesInput = {
  filter?: InputMaybe<ThemeQueryFilter>;
  pagination?: InputMaybe<ThemePaginationAndSorting>;
};

export type FetchThemesResponse = {
  __typename?: 'FetchThemesResponse';
  themes: Array<Theme>;
  totalCount: Scalars['Int']['output'];
};

export type FetchTradeRequestResponse = {
  __typename?: 'FetchTradeRequestResponse';
  tradeRequest: TradeRequest;
};

export type FetchTradeRequestsInput = {
  filter?: InputMaybe<TradeRequestQueryFilter>;
  pagination?: InputMaybe<TradeRequestPaginationAndSorting>;
};

export type FetchTradeRequestsResponse = {
  __typename?: 'FetchTradeRequestsResponse';
  totalCount: Scalars['Int']['output'];
  tradeRequests: Array<TradeRequest>;
};

export type FetchTradesInput = {
  filter?: InputMaybe<TradeQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchTradesResponse = {
  __typename?: 'FetchTradesResponse';
  totalCount: Scalars['Int']['output'];
  trades: Array<Trade>;
};

export type FetchTransactionCustodianTypesResponse = {
  __typename?: 'FetchTransactionCustodianTypesResponse';
  custodianTypes: Array<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type FetchTransactionResponse = {
  __typename?: 'FetchTransactionResponse';
  transaction: Transaction;
};

export type FetchTransactionsInput = {
  filter?: InputMaybe<TransactionQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchTransactionsResponse = {
  __typename?: 'FetchTransactionsResponse';
  cursor?: Maybe<FetchTransactionsResponseCursor>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  transactions: Array<Transaction>;
};

export type FetchTransactionsResponseCursor = {
  __typename?: 'FetchTransactionsResponseCursor';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

export type FetchTransactionsTypesInput = {
  filter?: InputMaybe<TransactionQueryFilter>;
};

export type FetchTransactionsTypesResponse = {
  __typename?: 'FetchTransactionsTypesResponse';
  totalCount: Scalars['Int']['output'];
  types: Array<TransactionTypes>;
};

export type FetchTransferResponse = {
  __typename?: 'FetchTransferResponse';
  transfer: Transfer;
};

export type FetchTransfersInput = {
  filter?: InputMaybe<QueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchTransfersResponse = {
  __typename?: 'FetchTransfersResponse';
  totalCount: Scalars['Int']['output'];
  transfers: Array<Transfer>;
};

export type FetchUpcomingTransfersInput = {
  filter?: InputMaybe<UpcomingTransferQueryFilter>;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FetchUpcomingTransfersResponse = {
  __typename?: 'FetchUpcomingTransfersResponse';
  totalCount: Scalars['Int']['output'];
  upcomingTransfers: Array<UpcomingTransfer>;
};

export type FetchUserBulkUpsertItemResponse = {
  __typename?: 'FetchUserBulkUpsertItemResponse';
  bulkUpsertItem: UserBulkUpsertItem;
};

export type FetchUserBulkUpsertItemsInput = {
  filter: UserBulkUpsertItemQueryFilter;
  pagination?: InputMaybe<BulkUpsertPaginationAndSorting>;
};

export type FetchUserBulkUpsertItemsResponse = {
  __typename?: 'FetchUserBulkUpsertItemsResponse';
  bulkUpsertItems: Array<UserBulkUpsertItem>;
  totalCount: Scalars['Int']['output'];
};

/** Input type for fetching userIdVerifications */
export type FetchUserIdVerificationsInput = {
  /** To filter the userIds */
  filter: UserIdVerificationQueryFilter;
  /** To organize the response as per the pagination fields */
  pagination?: InputMaybe<UserIdVerificationPaginationAndSorting>;
};

/** Type definition for fetching userIdVerifications */
export type FetchUserIdVerificationsResponse = {
  __typename?: 'FetchUserIdVerificationsResponse';
  /** Returns an array of objects for idVerifications */
  idVerifications: Array<IdVerification>;
  /**
   * Total number of the records that satisfies a specified filter; for example,
   * a filter is set for methodOfIdVerification, then it will return a number of verifiedIds
   * associated to that methodOfIdVerification
   */
  totalCount: Scalars['Int']['output'];
};

export type FetchUserInput = {
  userId: Scalars['SafeString']['input'];
};

/** Type definition for fetching a user */
export type FetchUserResponse = {
  __typename?: 'FetchUserResponse';
  /** Returns a user object */
  user: User;
};

export type FetchUserUpdatesInput = {
  pagination?: InputMaybe<UserUpdatePaginationAndSorting>;
  userId: Scalars['ObjectID']['input'];
};

export type FetchUserUpdatesResponse = {
  __typename?: 'FetchUserUpdatesResponse';
  totalCount: Scalars['Int']['output'];
  userUpdates: Array<UserUpdate>;
};

/** Input type for fetching Users */
export type FetchUsersInput = {
  /** To filter the Users */
  filter?: InputMaybe<UserQueryFilter>;
  /** To organize the response as per the pagination fields */
  pagination?: InputMaybe<UserPaginationAndSorting>;
};

/** Type definition for fetching users */
export type FetchUsersResponse = {
  __typename?: 'FetchUsersResponse';
  /**
   * Total number of the records that satisfies a specified filter; for example,
   * a filter is set for an verifiedAtAfter, then it will return a number of users
   * associated to that filter
   */
  totalCount: Scalars['Int']['output'];
  /** Returns an array of objects for users */
  users: Array<User>;
};

export type FetchVisibleAlertBannersInput = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  platform: AlertBannerPlatform;
};

export type FetchVisibleAlertBannersResponse = {
  __typename?: 'FetchVisibleAlertBannersResponse';
  totalCount: Scalars['Int']['output'];
  visibleAlertBanners: Array<AlertBanner>;
};

export type FetchWebhookResponse = {
  __typename?: 'FetchWebhookResponse';
  webhook: Webhook;
};

export type FetchWebhooksInput = {
  filter?: InputMaybe<WebhookQueryFilter>;
  pagination?: InputMaybe<EventPaginationAndSorting>;
};

export type FetchWebhooksResponse = {
  __typename?: 'FetchWebhooksResponse';
  totalCount: Scalars['Int']['output'];
  webhooks: Array<Webhook>;
};

export type FetchWidgetOptionsResponse = {
  __typename?: 'FetchWidgetOptionsResponse';
  widgetOptions: Array<WidgetOption>;
};

export type FetchWorkflowCompletionResponse = {
  __typename?: 'FetchWorkflowCompletionResponse';
  workflowCompletion: WorkflowCompletion;
};

export type FetchWorkflowCompletionsInput = {
  filter?: InputMaybe<WorkflowCompletionQueryFilter>;
  pagination?: InputMaybe<WorkflowCompletionPaginationAndSorting>;
};

export type FetchWorkflowCompletionsResponse = {
  __typename?: 'FetchWorkflowCompletionsResponse';
  totalCount: Scalars['Int']['output'];
  workflowCompletions: Array<WorkflowCompletion>;
};

export type FetchWorkflowResponse = {
  __typename?: 'FetchWorkflowResponse';
  workflow: Workflow;
};

export type FetchWorkflowsInput = {
  filter?: InputMaybe<WorkflowQueryFilter>;
  pagination?: InputMaybe<WorkflowPaginationAndSorting>;
};

export type FetchWorkflowsResponse = {
  __typename?: 'FetchWorkflowsResponse';
  totalCount: Scalars['Int']['output'];
  workflows: Array<Workflow>;
};

/** Input type for filtering logs by a specific field */
export type FieldMatch = {
  field: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export enum FieldSources {
  Blank = 'BLANK',
  Curated = 'CURATED',
  LinkedUser = 'LINKED_USER',
  RoleTranslatedName = 'ROLE_TRANSLATED_NAME'
}

/** File type */
export type FileDocument = {
  __typename?: 'FileDocument';
  /** Optional: The unique identifying number of the document used which is used to upload this document */
  applicableDocumentId?: Maybe<Scalars['String']['output']>;
  /** The date and time this File was created */
  createdAt: Scalars['GraphQLDateTime']['output'];
  /** OrganizationUser is the author of the File */
  creator?: Maybe<PublicOrganizationUser>;
  /** Organization of the Files creator */
  creatorOrganization?: Maybe<PublicOrganization>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Operating System file name as uploaded, ie. "the statement scan (1).png" */
  fileName: Scalars['String']['output'];
  /** Unique identifier, a 24 character hexadecimal string */
  id: Scalars['ObjectID']['output'];
  /** A media type (also known as MIME type) according to RFC6838, ie. "image/png" */
  mediaType?: Maybe<Scalars['String']['output']>;
  /** User editable file name, free text, ie. "Greg's RBC bank statement Jun 2026" */
  name?: Maybe<Scalars['String']['output']>;
  /** objectId of the designated documentType */
  objectId: Scalars['ObjectID']['output'];
  /** FileDocumentObjectTypes derived from the ENUM */
  objectType: FileDocumentObjectTypes;
  /** Organization belongs to the document file */
  organization?: Maybe<Organization>;
  /** permissionType derived from the ENUM */
  permissionType: FileDocumentPermissionTypes;
  /** requestId of fileDocument */
  requestId?: Maybe<Scalars['String']['output']>;
  requestIpAddress?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  sharedClient?: Maybe<Scalars['Boolean']['output']>;
  sharedCustodian?: Maybe<Scalars['Boolean']['output']>;
  sharedWithRoleProfiles?: Maybe<Array<Maybe<RoleProfile>>>;
  signed?: Maybe<Scalars['Boolean']['output']>;
  /** File Type SourceId */
  sourceId?: Maybe<Scalars['ObjectID']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  /** FileDocumentTypes derived from the ENUM */
  type: FileDocumentTypes;
  /** The date and time this File's information was last updated */
  updatedAt: Scalars['GraphQLDateTime']['output'];
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** The date and time this File was uploaded */
  uploadedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** Optional destination user  from organization */
  user?: Maybe<User>;
};

/** File ENUMS */
export enum FileDocumentObjectTypes {
  Account = 'ACCOUNT',
  Article = 'ARTICLE',
  BulkImport = 'BULK_IMPORT',
  Clientgroup = 'CLIENTGROUP',
  FormCompletionSigned = 'FORM_COMPLETION_SIGNED',
  FormCompletionUnsigned = 'FORM_COMPLETION_UNSIGNED',
  FormDefinition = 'FORM_DEFINITION',
  Goal = 'GOAL',
  Organization = 'ORGANIZATION',
  OrganizationUser = 'ORGANIZATION_USER',
  ScheduledTransfer = 'SCHEDULED_TRANSFER',
  Subaccount = 'SUBACCOUNT',
  User = 'USER'
}

/** Input fields options to manage pagination and sorting for fileDocument Object */
export type FileDocumentPaginationAndSorting = {
  /**
   * The number of records to skip per page from the
   * beginning of the elements per page
   */
  offSet?: InputMaybe<Scalars['Int']['input']>;
  /** Elements per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** To sort in descending order or not */
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  /** To sort the list by the fields for the fileDocument Object */
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export enum FileDocumentPermissionTypes {
  Organizational = 'ORGANIZATIONAL',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** Input type for filtering FileDocuments */
export type FileDocumentQueryFilter = {
  createdAtEnd?: InputMaybe<Scalars['GraphQLDate']['input']>;
  createdAtStart?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** objectId for filter FileDocuments */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  /** FileDocumentObjectTypes derived from the ENUM */
  objectTypes?: InputMaybe<Array<InputMaybe<FileDocumentObjectTypes>>>;
  /** organizationId for filter FileDocuments */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  /** type  of the FileDocument */
  types?: InputMaybe<Array<InputMaybe<FileDocumentTypes>>>;
  /** userId for filter FileDocuments */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export enum FileDocumentTypes {
  Article = 'ARTICLE',
  Avatar = 'AVATAR',
  Banking = 'BANKING',
  BulkImport = 'BULK_IMPORT',
  ClientReport = 'CLIENT_REPORT',
  ClientReportTemplate = 'CLIENT_REPORT_TEMPLATE',
  ErrorPageBackgroundImage = 'ERROR_PAGE_BACKGROUND_IMAGE',
  Form = 'FORM',
  IdVerification = 'ID_VERIFICATION',
  Invoice = 'INVOICE',
  Logo = 'LOGO',
  Notes = 'NOTES',
  Other = 'OTHER',
  Statement = 'STATEMENT',
  Template = 'TEMPLATE',
  Workflow = 'WORKFLOW'
}

export type FillFormMapToPdfInput = {
  context?: InputMaybe<Scalars['Object']['input']>;
  flattenPdf?: InputMaybe<Scalars['Boolean']['input']>;
  formMap: FormMapInput;
  objectId: Scalars['ID']['input'];
  pdfTemplateBase64: Scalars['String']['input'];
};

export type FillFormMapToPdfOutput = {
  __typename?: 'FillFormMapToPdfOutput';
  errors: Array<FormMapError>;
  filledPdfBase64: Scalars['String']['output'];
  signatureFieldLocations: Array<SignatureFieldLocation>;
};

export type FilledPdfPayload = {
  __typename?: 'FilledPdfPayload';
  base64?: Maybe<Scalars['String']['output']>;
  errors: Array<FormMapError>;
  signatureFieldLocations: Array<SignatureFieldLocation>;
};


export type FilledPdfPayloadSignatureFieldLocationsArgs = {
  eSignProvider?: InputMaybe<ESignProvider>;
};

export type FinancialProduct = {
  __typename?: 'FinancialProduct';
  /** Asset class branch allocations for ASSET_CLASS strategy portfolios */
  assetClassBranches?: Maybe<Array<AssetClassBranch>>;
  /** Asset class level used for ASSET_CLASS strategy portfolios */
  assetClassLevel?: Maybe<AssetClassLevel>;
  /** Is this Financial product assignable? */
  assignable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Number of assignments currently referencing this product (counts
   * sub-accounts and goals; households as upstream extends). Currently only
   * populated by model-portfolio queries on the SPA; on a tradeable security
   * this still hits the upstream and will return 0.
   *
   * Nullable: returns null when the upstream usage-count service is
   * unavailable, so callers can distinguish "could not determine" from a
   * real zero. Treat null as "unknown" - do NOT enable destructive actions
   * (e.g. archive) when null.
   */
  assignedCount?: Maybe<Scalars['Int']['output']>;
  /** Auto updates prices using data partner? */
  autoUpdatePrices?: Maybe<Scalars['Boolean']['output']>;
  /** The entity this clone is privately bound to. Set together with boundObjectType. */
  boundObjectId?: Maybe<Scalars['ObjectID']['output']>;
  /** When set, this clone is privately bound to this entity (household/goal/sub-account). */
  boundObjectType?: Maybe<BoundObjectType>;
  /** The branches of this Financial product. */
  children: Array<Branch>;
  /** The financial product that this financial product is a clone of */
  cloneOf?: Maybe<Scalars['ObjectID']['output']>;
  /** The currency that this Financial product trades in. */
  currency?: Maybe<Currencies>;
  /** The current price of the stock in each of the organization's supported currencies, in cents. */
  currencyCurrentPriceCents?: Maybe<CurrencyPriceCents>;
  /** The current price of the stock */
  currentPriceCents?: Maybe<Scalars['Float']['output']>;
  cusip?: Maybe<Scalars['String']['output']>;
  /**
   * Null means inherit the organization default. Resolved at calculation time,
   * never stamped onto the model.
   */
  driftCalculationMethod?: Maybe<DriftCalculationMethod>;
  /**
   * When the last drift policy change for this model was dealt with, whether it
   * was recalculated or skipped. RECALCULATING is a window a client can poll
   * straight past, so a client waits for this to advance past the value it
   * read before its own edit rather than trying to catch the window.
   */
  driftRecalculationSettledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * What settling the last change meant. RECALCULATED when portfolios were
   * re-screened, NOTHING_TO_RECALCULATE when the change needed no run at all.
   * Null until this model has settled a change.
   */
  driftRecalculationSettledOutcome?: Maybe<DriftRecalculationOutcomes>;
  /**
   * Timestamp when the current RECALCULATING window started. Null when the
   * model is IDLE. Used to detect stale locks (>20 min) and to investigate
   * stuck recalcs.
   */
  driftRecalculationStartedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Current state of the per-model drift recalculation pipeline. Owned by
   * holding-service (OVT-6781). IDLE is the steady state; the backend
   * transitions to RECALCULATING when this model's own driftCalculationMethod
   * or driftTolerancePercent changes. Falls back to IDLE for products that
   * pre-date the feature, and for products that are not model portfolios.
   */
  driftRecalculationState: DriftRecalculationStates;
  driftTolerancePercent?: Maybe<Scalars['Int']['output']>;
  /**
   * The values actually used, after the model -> organization -> system cascade.
   * Each field resolves independently.
   */
  effectiveDriftCalculationMethod?: Maybe<DriftCalculationMethod>;
  effectiveDriftTolerancePercent?: Maybe<Scalars['Int']['output']>;
  /** The Stock Exchange that this Financial product trades in. */
  exchange?: Maybe<Scalars['String']['output']>;
  exchangeMic?: Maybe<Scalars['String']['output']>;
  /** This is the primary asset class holdings list of this financial product */
  expectedPrimaryAssetClassHoldings?: Maybe<Array<ExpectedPrimaryAssetClassHoldings>>;
  /** The forecasted rate of return for this product */
  forecastedRateOfReturn?: Maybe<Scalars['Float']['output']>;
  /** The forecasted standard deviation for this product */
  forecastedStandardDeviation?: Maybe<Scalars['Float']['output']>;
  foreignExchangeRate?: Maybe<Scalars['Float']['output']>;
  fundSeries?: Maybe<Scalars['String']['output']>;
  /** This is the financialProductId and it is auto-generated by OneVest for each Financial Product. */
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<FinancialProductIntegration>>>;
  /** Objective of the portfolio */
  investmentObjective?: Maybe<Scalars['String']['output']>;
  /** Denotes if this financial product is cash */
  isCash?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When true, allowed to allocate fractional trades.
   *
   * Defaults to true.
   */
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  /** Low threshold score for allowing access */
  lowThresholdScore?: Maybe<Scalars['Float']['output']>;
  modelPortfolioLogs: LogsResponse;
  /**
   * Category of this model portfolio template (e.g. HOUSEHOLD). Null for standard model portfolios.
   * Set during bulk upsert to allow filtering by type in fetchModelPortfolios.
   */
  modelPortfolioType?: Maybe<ModelPortfolioTypes>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  /** Name of the Financial product. */
  name: Scalars['String']['output'];
  organization?: Maybe<PublicOrganization>;
  /** The original (not converted) currency that this Financial product trades in. */
  originalCurrency?: Maybe<Currencies>;
  /** The original (not converted) current price of the stock */
  originalCurrentPriceCents?: Maybe<Scalars['Float']['output']>;
  /**
   * True when a recalculation is queued but not yet running — either it lost
   * the acquire race or it was requested mid-run. Distinct from IDLE, which
   * means no work is outstanding.
   */
  pendingDriftRecalc: Scalars['Boolean']['output'];
  /** Description of the portfolio */
  portfolioDescription?: Maybe<Scalars['String']['output']>;
  /** Disclaimer of the portfolio */
  portfolioDisclaimer?: Maybe<Scalars['String']['output']>;
  /** The template to update the model portfolio from */
  portfolioTemplate?: Maybe<PortfolioTemplate>;
  /** URL to download a csv containing the Financial Product's historical prices. */
  priceHistoryUrl?: Maybe<Scalars['String']['output']>;
  /** Primary Asset Class of the product */
  primaryAssetClass?: Maybe<AssetClass>;
  /**
   * This will be used to describe why form agreements need to be re-signed when a portfolio's
   * secondaryAssetClass, description, and/or targetAllocations have changed.
   * @deprecated Will be removed from the FinancialProduct
   */
  reasonForUpdate?: Maybe<Scalars['String']['output']>;
  ric?: Maybe<Scalars['String']['output']>;
  riskProfileDescription?: Maybe<ProductTranslatedString>;
  riskProfileName?: Maybe<ProductTranslatedString>;
  riskReturnLevel?: Maybe<Scalars['Int']['output']>;
  /** Optional schedule (used for illiquid portfolios). */
  schedule?: Maybe<Schedule>;
  /** Secondary Asset Class of the product */
  secondaryAssetClass?: Maybe<AssetClass>;
  settlementDays?: Maybe<Scalars['Int']['output']>;
  /** State of the Financial product. */
  state: FinancialProductState;
  /** Type of strategy for the financial product */
  strategy?: Maybe<FinancialProductStrategy>;
  /** Financial Product's ID returned as string. It can either be the OneVest ID or an External ID from a Passthrough API. */
  stringId: Scalars['String']['output'];
  /** Optional substitute Financial product (used for Tax-Loss Harvesting). */
  substituteFinancialProduct?: Maybe<FinancialProduct>;
  /** Is this Financial product suggestable? */
  suggestable?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum suitability score to have access to this Financial product. */
  suggestedMaxScore?: Maybe<Scalars['Float']['output']>;
  /** Minimum suitability score to have access to this Financial product. */
  suggestedMinScore?: Maybe<Scalars['Float']['output']>;
  /** All Target Allocations */
  targetAllocations?: Maybe<Array<TargetAllocation>>;
  /** The tax rank of the financial product, to be used for portfolio optimization */
  taxRank?: Maybe<Scalars['Int']['output']>;
  /** Tertiary Asset Class of the product */
  tertiaryAssetClass?: Maybe<AssetClass>;
  /** The theme of the product */
  theme?: Maybe<Theme>;
  /** The trading ticker for this Financial product. */
  ticker?: Maybe<Scalars['String']['output']>;
  /** Is this Financial product tradeable? */
  tradeable?: Maybe<Scalars['Boolean']['output']>;
  /** The translated investment objectives of the portfolio */
  translatedInvestmentObjective?: Maybe<ProductTranslatedString>;
  /** The translated liquidity of the portfolio */
  translatedLiquidity?: Maybe<ProductTranslatedString>;
  /** Translated name of the Financial product. */
  translatedName: ProductTranslatedString;
  /** The translated descriptions of the portfolio */
  translatedPortfolioDescription?: Maybe<ProductTranslatedString>;
  /** The translated disclaimers of the portfolio */
  translatedPortfolioDisclaimer?: Maybe<ProductTranslatedString>;
  /**
   * This will be used to describe translated reason why form agreements need to be re-signed when a portfolio's
   * secondaryAssetClass, description, and/or targetAllocations have changed.
   * @deprecated Will be removed from the FinancialProduct
   */
  translatedReasonForUpdate?: Maybe<ProductTranslatedString>;
  /** The translated name of the theme of the product, if the product is a model portfolio */
  translatedThemeName?: Maybe<ProductTranslatedString>;
  translatedUrl?: Maybe<ProductTranslatedString>;
  /** Security Type */
  type?: Maybe<SecurityTypes>;
  /** The last time the product was updated */
  updatedAt: Scalars['GraphQLDateTime']['output'];
  /**
   * A URL to an external site for more details on the product
   * @deprecated url is deprecated, use translatedUrl instead
   */
  url?: Maybe<Scalars['String']['output']>;
  volatile?: Maybe<Scalars['Boolean']['output']>;
  /** A discount percentage applied to the corresponding holding amount during fee calculation (0 - 100%). */
  waivedFeePercentage?: Maybe<Scalars['Float']['output']>;
  /** Whether the financial product is zero percent cash */
  zeroPercentCash?: Maybe<Scalars['Boolean']['output']>;
};


export type FinancialProductModelPortfolioLogsArgs = {
  input?: InputMaybe<ModelPortfolioLogsInput>;
};

export type FinancialProductBulkUpsertItem = {
  __typename?: 'FinancialProductBulkUpsertItem';
  batchId?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertIntegration?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertRequest?: Maybe<BulkUpsertRequest>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<FinancialProductIntegration>>>;
  oneVestId?: Maybe<Scalars['ObjectID']['output']>;
  outputErrors?: Maybe<Array<Maybe<FinancialProductBulkUpsertItemOutputError>>>;
  rawData?: Maybe<Scalars['Object']['output']>;
  state?: Maybe<FinancialProductBulkUpsertItemStates>;
};

export type FinancialProductBulkUpsertItemOutputError = {
  __typename?: 'FinancialProductBulkUpsertItemOutputError';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
};

export type FinancialProductBulkUpsertItemQueryFilter = {
  batchId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertIntegrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  oneVestId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<FinancialProductBulkUpsertItemStates>;
};

export enum FinancialProductBulkUpsertItemStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Queued = 'QUEUED'
}

export enum FinancialProductBulkUpsertItemTransition {
  Fail = 'fail',
  Process = 'process',
  Retry = 'retry'
}

export enum FinancialProductBulkUpsertRequestTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  PartiallyFail = 'partiallyFail',
  Process = 'process'
}

/** The integration enum and unique integration id  */
export type FinancialProductIntegration = {
  __typename?: 'FinancialProductIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<FinancialProductIntegrationTypes>;
};

/** Input type for integrations field */
export type FinancialProductIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<FinancialProductIntegrationTypes>;
};

/** Integrations for FinancialProduct */
export enum FinancialProductIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export type FinancialProductOrgHistory = {
  __typename?: 'FinancialProductOrgHistory';
  date: Scalars['GraphQLDate']['output'];
  financialProductId: Scalars['ObjectID']['output'];
  quantity: Scalars['Float']['output'];
  ticker: Scalars['String']['output'];
  totalCents: Scalars['Long']['output'];
};

export type FinancialProductPaginationAndSorting = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialProductPriceHistory = {
  __typename?: 'FinancialProductPriceHistory';
  /** Price per currency. Absent on snapshots written before per-currency pricing. */
  currencyPriceCents?: Maybe<CurrencyPriceCents>;
  date: Scalars['GraphQLDate']['output'];
  financialProduct: FinancialProduct;
  financialProductId: Scalars['ObjectID']['output'];
  orgHistory?: Maybe<FinancialProductOrgHistory>;
  organizationId: Scalars['ObjectID']['output'];
  /**
   * Whichever currency the snapshot upsert wrote last, since a snapshot is unique
   * per (financialProduct, date). Prefer currencyPriceCents when valuing anything
   * in a known currency.
   */
  priceCents: Scalars['Float']['output'];
};

export type FinancialProductPriceHistoryFilter = {
  endDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  excludeFinancialProductIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  financialProductIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type FinancialProductPriceHistoryInput = {
  filter: FinancialProductPriceHistoryFilter;
  pagination?: InputMaybe<HoldingPaginationAndSorting>;
};

export type FinancialProductPriceHistoryResponse = {
  __typename?: 'FinancialProductPriceHistoryResponse';
  priceHistory: Array<FinancialProductPriceHistory>;
  totalCount: Scalars['Int']['output'];
};

export type FinancialProductQueryFilter = {
  autoUpdatePrices?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Currencies>;
  exchange?: InputMaybe<Scalars['String']['input']>;
  financialProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSubstituteProduct?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  primaryAssetClassId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  secondaryAssetClassId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<FinancialProductState>;
  states?: InputMaybe<Array<FinancialProductState>>;
  tertiaryAssetClassId?: InputMaybe<Scalars['String']['input']>;
  themeId?: InputMaybe<Scalars['ObjectID']['input']>;
  ticker?: InputMaybe<Scalars['String']['input']>;
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FinancialProductState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum FinancialProductStrategy {
  AssetClass = 'ASSET_CLASS',
  Sma = 'SMA',
  Standard = 'STANDARD',
  SubModel = 'SUB_MODEL'
}

export enum FinancialProductTransitions {
  Activate = 'activate',
  Archive = 'archive',
  Draft = 'draft'
}

export type FinancialProductUpsertIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type Flag = {
  __typename?: 'Flag';
  account?: Maybe<Account>;
  /** Timestamp the flag transitioned to ARCHIVED. Null while active. */
  archivedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  category: FlagCategory;
  createdAt: Scalars['GraphQLDateTime']['output'];
  custodian?: Maybe<Custodian>;
  details?: Maybe<Scalars['Object']['output']>;
  /** First time this issue was observed. Preserved across re-emissions; basis for the grid Age filter. */
  firstSeenAt: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** Investigation notes for this flag, newest first. */
  notes: Array<FlagNote>;
  objectId?: Maybe<Scalars['ObjectID']['output']>;
  objectType?: Maybe<FlagObjects>;
  organization?: Maybe<Organization>;
  /** Prior archived flag this active flag supersedes, when one exists. */
  previousFlagId?: Maybe<Scalars['ObjectID']['output']>;
  priority: FlagPriority;
  state: FlagStates;
  type: FlagTypes;
};

/**
 * Axis a flag type's amount threshold is expressed on. Null for
 * non-thresholdable types (mirrors FlagTypeMetadata.axis).
 */
export enum FlagAmountAxis {
  Cents = 'CENTS',
  PercentOnly = 'PERCENT_ONLY'
}

export type FlagAmountThreshold = {
  __typename?: 'FlagAmountThreshold';
  flagType: FlagTypes;
  percentThreshold?: Maybe<Scalars['Float']['output']>;
  thresholdCents?: Maybe<Scalars['Int']['output']>;
};

export type FlagAmountThresholdInput = {
  flagType: FlagTypes;
  percentThreshold?: InputMaybe<Scalars['Float']['input']>;
  thresholdCents?: InputMaybe<Scalars['Int']['input']>;
};

export enum FlagCategory {
  Account = 'ACCOUNT',
  Activity = 'ACTIVITY',
  CashHoldings = 'CASH_HOLDINGS',
  Product = 'PRODUCT',
  Snapshot = 'SNAPSHOT',
  Transfer = 'TRANSFER',
  /** Runtime fallback only — see FlagPriority.UNKNOWN. */
  Unknown = 'UNKNOWN',
  Warning = 'WARNING'
}

/** One glossary row — static metadata plus inherited and effective policy. */
export type FlagGlossaryEntry = {
  __typename?: 'FlagGlossaryEntry';
  /** Effective policy after merging this org's own rows. */
  actual: FlagGlossaryPolicyValues;
  axis?: Maybe<FlagAmountAxis>;
  category: FlagCategory;
  flagType: FlagTypes;
  /** Policy from ancestors and platform defaults, excluding this org's rows. */
  inherited: FlagGlossaryPolicyValues;
  isActive: Scalars['Boolean']['output'];
  isAmountThresholdable: Scalars['Boolean']['output'];
  isOperationallyCritical: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

/** Priority/threshold values for glossary inherited or actual columns. */
export type FlagGlossaryPolicyValues = {
  __typename?: 'FlagGlossaryPolicyValues';
  percentThreshold?: Maybe<Scalars['Float']['output']>;
  priority: FlagPriority;
  thresholdCents?: Maybe<Scalars['Int']['output']>;
};

export type FlagKpIs = {
  __typename?: 'FlagKPIs';
  totalFlags: Scalars['Int']['output'];
  typeCounts: Array<FlagTypeCount>;
  /**
   * Count of FLAGGED flags whose firstSeenAt is at or before the unresolved
   * cutoff (the 'unresolvedBefore' arg, or now - 3d by default).
   * firstSeenAt is preserved across re-emissions.
   */
  unresolvedOverThreeDays: Scalars['Int']['output'];
};

/** One investigation note snapshot; newest entries appear first on Flag.notes. */
export type FlagNote = {
  __typename?: 'FlagNote';
  /** Display name snapshot provided when the note was saved. */
  author: Scalars['String']['output'];
  /** Stable org-user reference for who saved this note (JWT sub). */
  authorId: Scalars['String']['output'];
  /** When this note text was saved. */
  createdAt: Scalars['GraphQLDateTime']['output'];
  /** Note text saved by an operator. */
  text: Scalars['String']['output'];
};

export enum FlagObjects {
  Account = 'Account',
  AccountStatement = 'AccountStatement',
  Activity = 'Activity',
  Cash = 'Cash',
  Dividend = 'Dividend',
  Fee = 'Fee',
  FinancialProduct = 'FinancialProduct',
  Holding = 'Holding',
  Product = 'Product',
  ScheduledIncomeFundTransfer = 'ScheduledIncomeFundTransfer',
  ScheduledTransfer = 'ScheduledTransfer',
  SubAccount = 'SubAccount',
  SubAccountDailyStats = 'SubAccountDailyStats',
  Trade = 'Trade',
  Transfer = 'Transfer'
}

export type FlagPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FlagPaginationForGrid = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export enum FlagPriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  /**
   * Runtime fallback only. Returned when a persisted Flag.type is not in the
   * server-side priority map (e.g. the type was removed from the FlagTypes
   * enum). NOT an operator-facing tier; not surfaced in priority filters.
   */
  Unknown = 'UNKNOWN'
}

export type FlagQueryFilter = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  custodianId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FlagTypes>;
};

export type FlagQueryFilterForGrid = {
  accountIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  category?: InputMaybe<FlagCategory>;
  custodianId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Inclusive lower bound on firstSeenAt (Age filter). */
  firstSeenAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  /** Inclusive upper bound on firstSeenAt (Age filter). */
  firstSeenAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  priority?: InputMaybe<FlagPriority>;
  state?: InputMaybe<FlagStates>;
  type?: InputMaybe<FlagTypes>;
};

export enum FlagStates {
  /** Terminal historical state. Hidden from queries by default; opt in with state: ARCHIVED. */
  Archived = 'ARCHIVED',
  Fixed = 'FIXED',
  Flagged = 'FLAGGED',
  Trivial = 'TRIVIAL'
}

export enum FlagTransition {
  Fixed = 'fixed',
  Trivial = 'trivial'
}

export type FlagTypeCount = {
  __typename?: 'FlagTypeCount';
  count: Scalars['Int']['output'];
  flagType: FlagTypes;
};

/**
 * Static, request-independent catalog row describing a flag type. Derived
 * once from the server-side priority map, the shared amount-threshold axis map,
 * and the operationally-critical hint set. Drives the admin policy-config UI.
 */
export type FlagTypeMetadata = {
  __typename?: 'FlagTypeMetadata';
  /** Null when isAmountThresholdable is false. */
  axis?: Maybe<FlagAmountAxis>;
  defaultPriority: FlagPriority;
  flagType: FlagTypes;
  isAmountThresholdable: Scalars['Boolean']['output'];
  /** UI-only hint; the backend never refuses a write based on it. */
  isOperationallyCritical: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type FlagTypePolicy = {
  __typename?: 'FlagTypePolicy';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  flagType: FlagTypes;
  priority?: Maybe<FlagPriority>;
};

export type FlagTypePolicyInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  flagType: FlagTypes;
  priority?: InputMaybe<FlagPriority>;
};

export enum FlagTypes {
  AccountClosed = 'ACCOUNT_CLOSED',
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  CashNotFound = 'CASH_NOT_FOUND',
  CurrencyIsNotAvailable = 'CURRENCY_IS_NOT_AVAILABLE',
  DifferentBookvalue = 'DIFFERENT_BOOKVALUE',
  DifferentHoldings = 'DIFFERENT_HOLDINGS',
  DifferentHoldingsV2 = 'DIFFERENT_HOLDINGS_V2',
  EftActivityNotFound = 'EFT_ACTIVITY_NOT_FOUND',
  ExternalTransferInKind = 'EXTERNAL_TRANSFER_IN_KIND',
  FailedAccount = 'FAILED_ACCOUNT',
  FailedCustodianAccountOpening = 'FAILED_CUSTODIAN_ACCOUNT_OPENING',
  FailedCustodianOpening = 'FAILED_CUSTODIAN_OPENING',
  FeeAmountDifferent = 'FEE_AMOUNT_DIFFERENT',
  FeeNotFound = 'FEE_NOT_FOUND',
  FinancialProductNotFound = 'FINANCIAL_PRODUCT_NOT_FOUND',
  HbpWithdrawTransferNotFound = 'HBP_WITHDRAW_TRANSFER_NOT_FOUND',
  HoldingNotFound = 'HOLDING_NOT_FOUND',
  HoldingNotFoundInCustodian = 'HOLDING_NOT_FOUND_IN_CUSTODIAN',
  InvalidBookValueAmount = 'INVALID_BOOK_VALUE_AMOUNT',
  MappingActualHoldings = 'MAPPING_ACTUAL_HOLDINGS',
  MappingFileHoldings = 'MAPPING_FILE_HOLDINGS',
  MoneyAvailableValueIncorrect = 'MONEY_AVAILABLE_VALUE_INCORRECT',
  MoneyAvailableValueIncorrectV2 = 'MONEY_AVAILABLE_VALUE_INCORRECT_V2',
  NegativeCash = 'NEGATIVE_CASH',
  NegativeHolding = 'NEGATIVE_HOLDING',
  NotCorporateAccount = 'NOT_CORPORATE_ACCOUNT',
  NotEnoughMoneyAvailableInAccount = 'NOT_ENOUGH_MONEY_AVAILABLE_IN_ACCOUNT',
  NoSnapshotsReceived = 'NO_SNAPSHOTS_RECEIVED',
  NsfRebookingDetected = 'NSF_REBOOKING_DETECTED',
  PendingTransactionDifferentHoldings = 'PENDING_TRANSACTION_DIFFERENT_HOLDINGS',
  PendingTransactionMoneyAvailableValueIncorrect = 'PENDING_TRANSACTION_MONEY_AVAILABLE_VALUE_INCORRECT',
  ProductSymbolDifferent = 'PRODUCT_SYMBOL_DIFFERENT',
  PublishingDiffHoldings = 'PUBLISHING_DIFF_HOLDINGS',
  RiskyDifferentHoldingMfSellAll = 'RISKY_DIFFERENT_HOLDING_MF_SELL_ALL',
  RiskyDifferentHoldingUsdEtf = 'RISKY_DIFFERENT_HOLDING_USD_ETF',
  ScheduledIncomeFundTransferSkipped = 'SCHEDULED_INCOME_FUND_TRANSFER_SKIPPED',
  ScheduledTransferSkipped = 'SCHEDULED_TRANSFER_SKIPPED',
  SnapshotAnomaly = 'SNAPSHOT_ANOMALY',
  SnapshotMissing = 'SNAPSHOT_MISSING',
  SnapshotPriceNotFound = 'SNAPSHOT_PRICE_NOT_FOUND',
  StatementNotFound = 'STATEMENT_NOT_FOUND',
  SubaccountNotFound = 'SUBACCOUNT_NOT_FOUND',
  TooManyExternalTransferInCandidatesFound = 'TOO_MANY_EXTERNAL_TRANSFER_IN_CANDIDATES_FOUND',
  TotalMarketValueIncorrect = 'TOTAL_MARKET_VALUE_INCORRECT',
  TradeNotFound = 'TRADE_NOT_FOUND',
  TransferAmountDifferent = 'TRANSFER_AMOUNT_DIFFERENT',
  TransferImportFailed = 'TRANSFER_IMPORT_FAILED',
  TransferNotFound = 'TRANSFER_NOT_FOUND',
  TransferStuckInitiated = 'TRANSFER_STUCK_INITIATED',
  TransferStuckProcessing = 'TRANSFER_STUCK_PROCESSING',
  TransferStuckReady = 'TRANSFER_STUCK_READY',
  UnknownActivityType = 'UNKNOWN_ACTIVITY_TYPE'
}

export type ForceCompleteIntegrationFormPackInput = {
  integrationFormPackId: Scalars['ObjectID']['input'];
};

export type ForceCompleteIntegrationFormPackResponse = {
  __typename?: 'ForceCompleteIntegrationFormPackResponse';
  integrationFormPack: IntegrationFormPack;
};

export type ForceReconcileCustodianActivityResponse = {
  __typename?: 'ForceReconcileCustodianActivityResponse';
  custodianActivity: CustodianActivity;
};

export type ForeignExchangeSnapshot = {
  __typename?: 'ForeignExchangeSnapshot';
  date: Scalars['GraphQLDate']['output'];
  from: Currencies;
  id: Scalars['ObjectID']['output'];
  rate: Scalars['Float']['output'];
  to: Currencies;
};

export type ForeignExchangeSnapshotQueryFilter = {
  dateAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  dateBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  from?: InputMaybe<Currencies>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  to?: InputMaybe<Currencies>;
};

/** Type detail for user's foreignTaxInformation */
export type ForeignTaxInformation = {
  __typename?: 'ForeignTaxInformation';
  /** Foreign Country for Tax */
  foreignTaxCountry: Scalars['String']['output'];
  /** Redacted Foreign Tax Number */
  foreignTaxNumber?: Maybe<Scalars['String']['output']>;
  /** Disclosed Foreign Tax Number */
  foreignTaxNumberDisclosed?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
};

/** Input Type for  User's foreignTaxInformation */
export type ForeignTaxInformationInput = {
  /** Foreign Tax Country */
  foreignTaxCountry: Scalars['SafeString']['input'];
  /** Foreign Tax Number */
  foreignTaxNumber?: InputMaybe<Scalars['SafeString']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum FormAccountTypes {
  CashJoint = 'CASH_JOINT',
  CorporateCash = 'CORPORATE_CASH',
  CorporateCharity = 'CORPORATE_CHARITY',
  CorporateEstate = 'CORPORATE_ESTATE',
  CorporateTrust = 'CORPORATE_TRUST',
  Dbpp = 'DBPP',
  Dpsp = 'DPSP',
  External = 'EXTERNAL',
  Fhsa = 'FHSA',
  Grsp = 'GRSP',
  GrspSpousal = 'GRSP_SPOUSAL',
  InformalTrust = 'INFORMAL_TRUST',
  InformalTrustJoint = 'INFORMAL_TRUST_JOINT',
  Investment = 'INVESTMENT',
  Ipp = 'IPP',
  Lif = 'LIF',
  Lira = 'LIRA',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  Margin = 'MARGIN',
  MarginJoint = 'MARGIN_JOINT',
  PensionPlan = 'PENSION_PLAN',
  Personal = 'PERSONAL',
  Prif = 'PRIF',
  Rdsp = 'RDSP',
  RdspJoint = 'RDSP_JOINT',
  Resp = 'RESP',
  RespAdult = 'RESP_ADULT',
  RespFamily = 'RESP_FAMILY',
  RespFamilyJoint = 'RESP_FAMILY_JOINT',
  RespSingle = 'RESP_SINGLE',
  RespSingleJoint = 'RESP_SINGLE_JOINT',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  Rlsp = 'RLSP',
  Rpp = 'RPP',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  Tfsa = 'TFSA',
  UkBrokerage = 'UK_BROKERAGE',
  UkCashIsa = 'UK_CASH_ISA',
  UkJisa = 'UK_JISA',
  UkPersonalPension = 'UK_PERSONAL_PENSION',
  UkSsIsa = 'UK_SS_ISA',
  Usa_401K = 'USA_401K',
  Usa_529 = 'USA_529',
  UsaBrokerage = 'USA_BROKERAGE',
  UsaCorporate = 'USA_CORPORATE',
  UsaCra = 'USA_CRA',
  UsaCustodial = 'USA_CUSTODIAL',
  UsaDaf = 'USA_DAF',
  UsaDbp = 'USA_DBP',
  UsaEsa = 'USA_ESA',
  UsaEstate = 'USA_ESTATE',
  UsaInhIra = 'USA_INH_IRA',
  UsaInhRtIra = 'USA_INH_RT_IRA',
  UsaIra = 'USA_IRA',
  UsaIraCustodial = 'USA_IRA_CUSTODIAL',
  UsaJtCp = 'USA_JT_CP',
  UsaJtCpMargin = 'USA_JT_CP_MARGIN',
  UsaJtJtbe = 'USA_JT_JTBE',
  UsaJtJtbeMargin = 'USA_JT_JTBE_MARGIN',
  UsaJtTic = 'USA_JT_TIC',
  UsaJtTicMargin = 'USA_JT_TIC_MARGIN',
  UsaJtWros = 'USA_JT_WROS',
  UsaJtWrosMargin = 'USA_JT_WROS_MARGIN',
  UsaKeogh = 'USA_KEOGH',
  UsaMargin = 'USA_MARGIN',
  UsaRoIra = 'USA_RO_IRA',
  UsaRtIra = 'USA_RT_IRA',
  UsaSepIra = 'USA_SEP_IRA',
  UsaSimpleIra = 'USA_SIMPLE_IRA',
  UsaSolo_401K = 'USA_SOLO_401K',
  UsaTod = 'USA_TOD',
  UsaTrust = 'USA_TRUST'
}

export type FormAgreement = {
  __typename?: 'FormAgreement';
  account?: Maybe<Account>;
  allUsersSignedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  canUploadNewVersion: Scalars['Boolean']['output'];
  clientGroup?: Maybe<ClientGroup>;
  displayName?: Maybe<Scalars['String']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  goal?: Maybe<Goal>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<FormAgreementIntegration>>>;
  language?: Maybe<Language>;
  scheduledTransfer?: Maybe<ScheduledTransfer>;
  signedAt: Scalars['GraphQLDateTime']['output'];
  signedUrl?: Maybe<Scalars['String']['output']>;
  subAccount?: Maybe<SubAccount>;
  templateUrl?: Maybe<Scalars['String']['output']>;
  translatedDisplayName?: Maybe<FormTranslatedString>;
  type: FormTypes;
  user?: Maybe<User>;
  usersRequiredToSign?: Maybe<Array<Maybe<UserRequiredToSign>>>;
  version: Scalars['Int']['output'];
};

export type FormAgreementInput = {
  type: FormTypes;
  version: Scalars['Int']['input'];
};

/** The integration enum and unique integration id  */
export type FormAgreementIntegration = {
  __typename?: 'FormAgreementIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<FormAgreementIntegrationTypes>;
};

export type FormAgreementIntegrationDocumentInput = {
  documentId: Scalars['String']['input'];
  documentName: Scalars['String']['input'];
  mappingObject: Scalars['Object']['input'];
};

/** Input type for integrations field */
export type FormAgreementIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<FormAgreementIntegrationTypes>;
};

export type FormAgreementIntegrationProviderConfigInput = {
  apiKey: Scalars['String']['input'];
  baseUrl: Scalars['String']['input'];
};

export enum FormAgreementIntegrationProviders {
  Onespan = 'ONESPAN'
}

export type FormAgreementIntegrationSignerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
  roleName: Scalars['String']['input'];
  roleType: Scalars['String']['input'];
};

export type FormAgreementIntegrationTemplateInput = {
  documents: Array<InputMaybe<FormAgreementIntegrationDocumentInput>>;
  templateId: Scalars['String']['input'];
};

/** Integrations for FormAgreement */
export enum FormAgreementIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export enum FormAgreementStates {
  Archived = 'ARCHIVED',
  Declined = 'DECLINED',
  InviteExpired = 'INVITE_EXPIRED',
  InviteSent = 'INVITE_SENT',
  PartiallySigned = 'PARTIALLY_SIGNED',
  Pending = 'PENDING',
  Signed = 'SIGNED',
  Unsigned = 'UNSIGNED'
}

export type FormCompletion = {
  __typename?: 'FormCompletion';
  createdAt: Scalars['GraphQLDateTime']['output'];
  formDefinition?: Maybe<FormDefinition>;
  id: Scalars['ObjectID']['output'];
  integrationFormPack?: Maybe<IntegrationFormPack>;
  jsonS3Path?: Maybe<Scalars['String']['output']>;
  /** The id of the object that this form completion is associated with. */
  objectId?: Maybe<Scalars['ObjectID']['output']>;
  /** The type of the object that this form completion is associated with. */
  objectType?: Maybe<FormDefinitionObjectTypes>;
  organization: PublicOrganization;
  requiredSignatures: Array<RequiredSignature>;
  resolvedPdfFileName?: Maybe<FormTranslatedString>;
  signatures: Array<Signature>;
  signedDocuments?: Maybe<Array<Maybe<FileDocument>>>;
  signedS3Paths: Array<Scalars['String']['output']>;
  signedUrls: Array<Scalars['String']['output']>;
  signingType: FormDefinitionSigningTypes;
  state: FormCompletionStates;
  templateType: FormDefinitionTemplateTypes;
  translatedDescription?: Maybe<FormTranslatedString>;
  translatedName: FormTranslatedString;
  unsignedDocument?: Maybe<FileDocument>;
  unsignedUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  user: User;
  workflowCompletion: WorkflowCompletion;
};


export type FormCompletionSignedUrlsArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


export type FormCompletionUnsignedUrlArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};

export enum FormCompletionStates {
  Archived = 'ARCHIVED',
  Signed = 'SIGNED',
  Unsigned = 'UNSIGNED'
}

export type FormCompletionsPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FormCompletionsQueryFilter = {
  objectId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectTypes?: InputMaybe<Array<FormDefinitionObjectTypes>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<FormCompletionStates>>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  workflowCompletionId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type FormDefinition = FormExtensionResource & {
  __typename?: 'FormDefinition';
  createdAt: Scalars['GraphQLDateTime']['output'];
  document?: Maybe<FileDocument>;
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  fillingType: FormDefinitionFillingType;
  formMaps: Array<FormMap>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<FormDefinitionIntegration>>>;
  key: Scalars['String']['output'];
  mappingWebhook?: Maybe<FormDefinitionWebhook>;
  objectType: FormDefinitionObjectTypes;
  organization: PublicOrganization;
  resourceKey?: Maybe<Scalars['String']['output']>;
  s3Url?: Maybe<Scalars['String']['output']>;
  signerMapping: Array<SignerMapping>;
  signingType: FormDefinitionSigningTypes;
  state: FormDefinitionStates;
  templateType: FormDefinitionTemplateTypes;
  translatedDescription?: Maybe<FormTranslatedString>;
  translatedName: FormTranslatedString;
  translatedPdfFileName?: Maybe<FormTranslatedString>;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  version: Scalars['Int']['output'];
};

export enum FormDefinitionFillingType {
  FormMap = 'FORM_MAP',
  None = 'NONE',
  Static = 'STATIC',
  Webhook = 'WEBHOOK'
}

/** The integration enum and unique integration id  */
export type FormDefinitionIntegration = {
  __typename?: 'FormDefinitionIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<FormDefinitionIntegrationTypes>;
};

/** Input type for integrations field */
export type FormDefinitionIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<FormDefinitionIntegrationTypes>;
};

/** Integrations for FormDefinition */
export enum FormDefinitionIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export enum FormDefinitionObjectTypes {
  Account = 'ACCOUNT',
  Entity = 'ENTITY',
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  SubAccount = 'SUB_ACCOUNT'
}

export enum FormDefinitionSigningTypes {
  Integration = 'INTEGRATION',
  InApp = 'IN_APP',
  Upload = 'UPLOAD'
}

export enum FormDefinitionStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum FormDefinitionTemplateTypes {
  Html = 'HTML',
  None = 'NONE',
  Pdf = 'PDF'
}

export enum FormDefinitionTransition {
  Activate = 'activate',
  Archive = 'archive',
  Draft = 'draft'
}

export type FormDefinitionWebhook = {
  __typename?: 'FormDefinitionWebhook';
  apiToken?: Maybe<Scalars['String']['output']>;
  type: WebhookAuthenticationTypes;
  url: Scalars['String']['output'];
};

export type FormDefinitionsPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FormDefinitionsQueryFilter = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<FormDefinitionStates>>;
};

/** Represents a resource that can be managed as part of an extension. */
export type FormExtensionResource = {
  /** A unique key identifying the extension this resource belongs to. */
  extensionKey?: Maybe<Scalars['String']['output']>;
  /** The version of the extension when this resource was installed. */
  extensionVersion?: Maybe<Scalars['String']['output']>;
  /** A unique key for the resource within the scope of the extension. */
  resourceKey?: Maybe<Scalars['String']['output']>;
};

export enum FormLanguageCode {
  En = 'en',
  Es = 'es',
  Fr = 'fr'
}

export type FormMap = {
  __typename?: 'FormMap';
  createdAt: Scalars['GraphQLDateTime']['output'];
  fields: Array<FormMapFieldOutput>;
  formDefinition: FormDefinition;
  id: Scalars['ObjectID']['output'];
  language: FormLanguageCode;
  objectType?: Maybe<FormMapObjectType>;
  removePdfMaxLength: Scalars['Boolean']['output'];
  signaturePageNumberBase: SignaturePageNumberBase;
  state: FormMapState;
  templateS3Key?: Maybe<Scalars['String']['output']>;
  templateUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type FormMapContextPayload = {
  __typename?: 'FormMapContextPayload';
  errors: Array<FormMapError>;
  value?: Maybe<Scalars['Object']['output']>;
};

export type FormMapContextQueryInput = {
  formMap: FormMapInput;
};

export type FormMapContextQueryPayload = {
  __typename?: 'FormMapContextQueryPayload';
  objectType: FormMapObjectType;
  query: Scalars['String']['output'];
};

export type FormMapError = {
  __typename?: 'FormMapError';
  code: FormMapErrorCode;
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum FormMapErrorCode {
  CustomFuncError = 'CUSTOM_FUNC_ERROR',
  FormatterError = 'FORMATTER_ERROR',
  GatewayError = 'GATEWAY_ERROR',
  NotAccessible = 'NOT_ACCESSIBLE',
  PdfParseError = 'PDF_PARSE_ERROR',
  TemplateResolutionFailed = 'TEMPLATE_RESOLUTION_FAILED'
}

export type FormMapFieldInput = {
  customFunc?: InputMaybe<Scalars['String']['input']>;
  customFuncContextKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  dataMasks?: InputMaybe<Array<DataMaskInput>>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  errorWhenEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  formatter?: InputMaybe<FormMapFormatter>;
  signerKey?: InputMaybe<Scalars['String']['input']>;
  templateLabel: Scalars['String']['input'];
  type: FormMapFieldType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormMapFieldOutput = {
  __typename?: 'FormMapFieldOutput';
  customFunc?: Maybe<Scalars['String']['output']>;
  customFuncContextKeys?: Maybe<Array<Scalars['String']['output']>>;
  dataMasks?: Maybe<Array<DataMaskOutput>>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  errorWhenEmpty?: Maybe<Scalars['Boolean']['output']>;
  formatter?: Maybe<FormMapFormatter>;
  signerKey?: Maybe<Scalars['String']['output']>;
  templateLabel: Scalars['String']['output'];
  type: FormMapFieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export enum FormMapFieldType {
  CheckBox = 'CheckBox',
  Dropdown = 'Dropdown',
  RadioGroup = 'RadioGroup',
  SignatureField = 'SignatureField',
  TextField = 'TextField'
}

export enum FormMapFormatter {
  AddressFull = 'ADDRESS_FULL',
  AddressStreet = 'ADDRESS_STREET',
  CapitalizeFirst = 'CAPITALIZE_FIRST',
  ConstantsArray = 'CONSTANTS_ARRAY',
  CountryCode_3Char = 'COUNTRY_CODE_3_CHAR',
  DateDd = 'DATE_DD',
  DateMmDdYyyy = 'DATE_MM_DD_YYYY',
  DateYyyymmdd = 'DATE_YYYYMMDD',
  DateYyyyMmDd = 'DATE_YYYY_MM_DD',
  DateYyyyMmDdSlash = 'DATE_YYYY_MM_DD_SLASH',
  DollarAmount = 'DOLLAR_AMOUNT',
  Initials = 'INITIALS',
  PhoneNumber = 'PHONE_NUMBER',
  ProvinceCode = 'PROVINCE_CODE',
  Sin = 'SIN',
  UnderscoreToTitleCase = 'UNDERSCORE_TO_TITLE_CASE'
}

export type FormMapInput = {
  fields: Array<FormMapFieldInput>;
  formDefinitionId: Scalars['String']['input'];
  objectType: FormMapObjectType;
  removePdfMaxLength?: InputMaybe<Scalars['Boolean']['input']>;
  signaturePageNumberBase?: InputMaybe<SignaturePageNumberBase>;
};

export enum FormMapObjectType {
  Account = 'Account',
  ClientGroup = 'ClientGroup',
  Goal = 'Goal',
  SubAccount = 'SubAccount',
  User = 'User'
}

export type FormMapResultInput = {
  applyDataMasking?: InputMaybe<Scalars['Boolean']['input']>;
  context?: InputMaybe<Scalars['Object']['input']>;
  formMap: FormMapInput;
  objectId: Scalars['ID']['input'];
  objectType?: InputMaybe<Scalars['String']['input']>;
};

export type FormMapResultPayload = {
  __typename?: 'FormMapResultPayload';
  context: FormMapContextPayload;
  pdf: FilledPdfPayload;
  resolvedFormMap: ResolvedFormMapPayload;
};


export type FormMapResultPayloadPdfArgs = {
  flattenPdf?: InputMaybe<Scalars['Boolean']['input']>;
  pdfTemplateBase64: Scalars['String']['input'];
};

export enum FormMapState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type FormMapping = {
  formDefinitionKey: Scalars['String']['input'];
  objectId: Scalars['ObjectID']['input'];
  objectType: FormDefinitionObjectTypes;
};

export type FormStateMachineChanges = {
  __typename?: 'FormStateMachineChanges';
  createdAt: Scalars['GraphQLDateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type FormTemplate = {
  __typename?: 'FormTemplate';
  digitalSignatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  minVersion: Scalars['Int']['output'];
  organization?: Maybe<PublicOrganization>;
  state?: Maybe<FormTemplateStates>;
  stateMachineChanges?: Maybe<Array<Maybe<FormStateMachineChanges>>>;
  templateUrl?: Maybe<Scalars['String']['output']>;
  textType: TextTypes;
  translatedDisplayName?: Maybe<FormTranslatedString>;
  translatedHtml?: Maybe<FormTranslatedString>;
  translatedMarkdown?: Maybe<FormTranslatedString>;
  type: FormTypes;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  uploadedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum FormTemplateStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum FormTemplateTransition {
  Activate = 'activate',
  Archive = 'archive',
  Draft = 'draft'
}

export type FormTemplatesPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type FormTemplatesQueryFilter = {
  formType?: InputMaybe<FormTypes>;
  minVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<FormTemplateStates>>;
};

export type FormTranslatedString = {
  __typename?: 'FormTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export enum FormTypes {
  ArticlesOfIncorporationOrEquivalent = 'ARTICLES_OF_INCORPORATION_OR_EQUIVALENT',
  BeneficiaryDesignationForm = 'BENEFICIARY_DESIGNATION_FORM',
  /** @deprecated Use BENEFICIARY_DESIGNATION_FORM instead. */
  BeneficiaryRrsp = 'BENEFICIARY_RRSP',
  /** @deprecated Use BENEFICIARY_DESIGNATION_FORM instead. */
  BeneficiaryTfsa = 'BENEFICIARY_TFSA',
  ClbForAdults = 'CLB_FOR_ADULTS',
  ClientAccountAgreement = 'CLIENT_ACCOUNT_AGREEMENT',
  CorporateAccountAgreement = 'CORPORATE_ACCOUNT_AGREEMENT',
  CorporateResolution = 'CORPORATE_RESOLUTION',
  DeathCertificate = 'DEATH_CERTIFICATE',
  DeclarationOfTaxDisclosure = 'DECLARATION_OF_TAX_DISCLOSURE',
  DeclarationOfTaxDisclosureE = 'DECLARATION_OF_TAX_DISCLOSURE_E',
  DiscretionaryManagementAgreement = 'DISCRETIONARY_MANAGEMENT_AGREEMENT',
  EducationSavingsGrantsApplication = 'EDUCATION_SAVINGS_GRANTS_APPLICATION',
  ElectronicDeliveryAgreement = 'ELECTRONIC_DELIVERY_AGREEMENT',
  ExternalAgreement = 'EXTERNAL_AGREEMENT',
  ExternalTransferToNonRegisteredAccounts = 'EXTERNAL_TRANSFER_TO_NON_REGISTERED_ACCOUNTS',
  ExternalTransferToRegisteredAccounts = 'EXTERNAL_TRANSFER_TO_REGISTERED_ACCOUNTS',
  FeeRedirection = 'FEE_REDIRECTION',
  Fhsa = 'FHSA',
  GoalInvestmentPolicyStatement = 'GOAL_INVESTMENT_POLICY_STATEMENT',
  Integration = 'INTEGRATION',
  InvestmentPolicyStatement = 'INVESTMENT_POLICY_STATEMENT',
  JointClientAccountAgreement = 'JOINT_CLIENT_ACCOUNT_AGREEMENT',
  LastWill = 'LAST_WILL',
  LetterOfDirection = 'LETTER_OF_DIRECTION',
  Lif = 'LIF',
  LifAddendum = 'LIF_ADDENDUM',
  Lira = 'LIRA',
  LiraAddendum = 'LIRA_ADDENDUM',
  LodQesi = 'LOD_QESI',
  Lrif = 'LRIF',
  LrifAddendum = 'LRIF_ADDENDUM',
  Lrsp = 'LRSP',
  LrspAddendum = 'LRSP_ADDENDUM',
  NonIndividualEntityAccountAgreement = 'NON_INDIVIDUAL_ENTITY_ACCOUNT_AGREEMENT',
  OnevestRelationshipDisclosureBrochure = 'ONEVEST_RELATIONSHIP_DISCLOSURE_BROCHURE',
  PadAgreement = 'PAD_AGREEMENT',
  Prif = 'PRIF',
  PrifAddendum = 'PRIF_ADDENDUM',
  RdspApplication = 'RDSP_APPLICATION',
  RdspBondOrGrantApplication = 'RDSP_BOND_OR_GRANT_APPLICATION',
  RdspBondOrGrantApplicationAnnexA = 'RDSP_BOND_OR_GRANT_APPLICATION_ANNEX_A',
  RdspBondOrGrantApplicationAnnexB = 'RDSP_BOND_OR_GRANT_APPLICATION_ANNEX_B',
  RespCaregiverOrParentOrGuardianAnnexB = 'RESP_CAREGIVER_OR_PARENT_OR_GUARDIAN_ANNEX_B',
  RespFamilyPlan = 'RESP_FAMILY_PLAN',
  RespSinglePlan = 'RESP_SINGLE_PLAN',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  RlifAddendum = 'RLIF_ADDENDUM',
  Rlsp = 'RLSP',
  RlspAddendum = 'RLSP_ADDENDUM',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  SwpAgreement = 'SWP_AGREEMENT',
  Tfsa = 'TFSA',
  TrustAgreement = 'TRUST_AGREEMENT',
  TrustDeed = 'TRUST_DEED',
  TrustParticipantIdentificationForm = 'TRUST_PARTICIPANT_IDENTIFICATION_FORM',
  W8Ben = 'W8BEN',
  W9 = 'W9',
  WaiverOfConfidentiality = 'WAIVER_OF_CONFIDENTIALITY',
  W_8BenE = 'W_8BEN_E',
  W_8Imy = 'W_8IMY'
}

export type FraudRisk = {
  __typename?: 'FraudRisk';
  id: Scalars['ObjectID']['output'];
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  riskReasons?: Maybe<Array<Maybe<RiskReason>>>;
  score?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export enum Frequency {
  BiWeekly = 'BI_WEEKLY',
  Daily = 'DAILY',
  LastDayOfTheMonth = 'LAST_DAY_OF_THE_MONTH',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Quarterly = 'QUARTERLY',
  SemiMonthly = 'SEMI_MONTHLY',
  Weekly = 'WEEKLY'
}

export type FxRate = {
  __typename?: 'FxRate';
  from: Currencies;
  rate: Scalars['Float']['output'];
  to: Currencies;
};

export type GenerateAnnualPerformanceReportInput = {
  accountId: Scalars['ObjectID']['input'];
  referenceDate: Scalars['GraphQLDate']['input'];
  regenerateData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenerateAnnualPerformanceReportResponse = {
  __typename?: 'GenerateAnnualPerformanceReportResponse';
  accountId?: Maybe<Scalars['ObjectID']['output']>;
  accountStatementId?: Maybe<Scalars['ObjectID']['output']>;
  annualPerformanceReportId?: Maybe<Scalars['ObjectID']['output']>;
};

export type GenerateBulkTradesInput = {
  autoFillActualQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  forceActualQuantityFUNDSERV?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  portfolioOptimizerId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type GenerateBulkTradesResponse = {
  __typename?: 'GenerateBulkTradesResponse';
  bulkTradeRun: BulkTradeRun;
};

export type GenerateClientReportInput = {
  objectId: Scalars['ObjectID']['input'];
  referenceDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  templateId: Scalars['ObjectID']['input'];
};

export type GenerateClientReportResponse = {
  __typename?: 'GenerateClientReportResponse';
  clientReport?: Maybe<ClientReport>;
};

export type GenerateFlinksAuthorizeTokenInput = {
  userId: Scalars['String']['input'];
};

export type GenerateFlinksAuthorizeTokenResponse = {
  __typename?: 'GenerateFlinksAuthorizeTokenResponse';
  authorizeToken?: Maybe<Scalars['String']['output']>;
};

export type GenerateMonthlyAccountStatementInput = {
  accountId: Scalars['ObjectID']['input'];
  referenceDate: Scalars['GraphQLDate']['input'];
  regenerateData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenerateMonthlyAccountStatementResponse = {
  __typename?: 'GenerateMonthlyAccountStatementResponse';
  accountId?: Maybe<Scalars['ObjectID']['output']>;
  accountStatementId?: Maybe<Scalars['ObjectID']['output']>;
  monthlyAccountStatementId?: Maybe<Scalars['ObjectID']['output']>;
};

export type GenerateNextBestActionsInput = {
  objectId: Scalars['ObjectID']['input'];
  objectType: ObjectTypes;
};

export type GenerateNextBestActionsResponse = {
  __typename?: 'GenerateNextBestActionsResponse';
  response: Scalars['String']['output'];
};

export type GenerateRebalanceInsightNarrativeInput = {
  context: RebalanceInsightAiContextInput;
  optimizerRunId: Scalars['ObjectID']['input'];
  portfolioReportId?: InputMaybe<Scalars['ObjectID']['input']>;
  scope: RebalanceInsightNarrativeScope;
};

export type GenerateRebalanceInsightNarrativeResponse = {
  __typename?: 'GenerateRebalanceInsightNarrativeResponse';
  response: Scalars['String']['output'];
};

export type GenerateReportInput = {
  columns: Array<Scalars['String']['input']>;
  filters: Array<ReportFilterInput>;
  grouping?: InputMaybe<ReportGroupingInput>;
  pagination: ReportPaginationInput;
  sorting: ReportSortingInput;
  type?: InputMaybe<ReportType>;
};

export type GenerateReportResponse = {
  __typename?: 'GenerateReportResponse';
  columns: Array<Scalars['String']['output']>;
  data: Array<Array<Scalars['String']['output']>>;
  grouping?: Maybe<Scalars['Object']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type GoToSubStepInput = {
  subStepId: Scalars['ObjectID']['input'];
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type GoToSubStepResponse = {
  __typename?: 'GoToSubStepResponse';
  workflowCompletion: WorkflowCompletion;
};

export type Goal = {
  __typename?: 'Goal';
  activeWorkflowCompletions: Array<WorkflowCompletion>;
  availableFinancialProducts?: Maybe<Array<FinancialProduct>>;
  availableThemes?: Maybe<Array<Theme>>;
  /** The lower of the user and goal suitability score. */
  calculatedSuitabilityScore?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use householdClientGroup instead. */
  clientGroup?: Maybe<ClientGroup>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  custodianSnapshotHistory?: Maybe<Array<Maybe<CustodianSnapshotHistory>>>;
  custodianStatistics?: Maybe<CustodianStatistics>;
  custodianSuitabilityScore?: Maybe<Scalars['Float']['output']>;
  customFields?: Maybe<Array<Maybe<AccountCustomFieldValue>>>;
  expectedAnnualIncomeCents?: Maybe<Scalars['Long']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  /** Custom label for the goal's risk question based on organization settings. */
  goalRiskQuestionLabel?: Maybe<AccountTranslatedString>;
  householdClientGroup?: Maybe<ClientGroup>;
  id: Scalars['ObjectID']['output'];
  /** Lists remaining forms to be signed for this goal. */
  incompleteFormAgreements?: Maybe<Array<Maybe<IncompleteFormAgreement>>>;
  integrations?: Maybe<Array<Maybe<AccountIntegration>>>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  /** Lists latest signed forms for this goal. */
  latestFormAgreements?: Maybe<Array<Maybe<FormAgreement>>>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  /** Indicates whether there is a pending agreement to be signed. */
  pendingAgreementSignature?: Maybe<Scalars['Boolean']['output']>;
  retirementAge?: Maybe<Scalars['Int']['output']>;
  riskQuestion1?: Maybe<GoalRiskLevels>;
  state: GoalStates;
  stateMachineChanges?: Maybe<Array<Maybe<AccountStateMachineChanges>>>;
  statistics?: Maybe<Statistics>;
  subAccounts?: Maybe<Array<SubAccount>>;
  suggestedFinancialProduct?: Maybe<FinancialProduct>;
  suitabilityScore?: Maybe<Scalars['Int']['output']>;
  targetAmountCents?: Maybe<Scalars['Long']['output']>;
  targetDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  taxOptimized?: Maybe<Scalars['Boolean']['output']>;
  timeHorizon?: Maybe<GoalTimeHorizons>;
  /** Custom label for the goal's time horizon based on organization settings. */
  timeHorizonLabel?: Maybe<AccountTranslatedString>;
  tradingProcess?: Maybe<PortfolioTradingProcesses>;
  type?: Maybe<GoalTypes>;
  user: User;
};


export type GoalCustodianSnapshotHistoryArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<CustodianStatisticsInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type GoalCustodianStatisticsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<CustodianStatisticsInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type GoalCustomFieldsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GoalStatisticsArgs = {
  forUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  input?: InputMaybe<StatisticsInput>;
};


export type GoalSuggestedFinancialProductArgs = {
  themeId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type GoalPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type GoalQueryFilter = {
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  includeHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  riskQuestion1?: InputMaybe<GoalRiskLevels>;
  state?: InputMaybe<GoalStates>;
  states?: InputMaybe<Array<GoalStates>>;
  targetDateAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  targetDateBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  timeHorizon?: InputMaybe<GoalTimeHorizons>;
  type?: InputMaybe<GoalTypes>;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
};

export enum GoalRiskLevels {
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2',
  Level_3 = 'LEVEL_3',
  Level_4 = 'LEVEL_4',
  Level_5 = 'LEVEL_5'
}

export enum GoalStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED'
}

export enum GoalTimeHorizons {
  LongTerm = 'LONG_TERM',
  MidTerm = 'MID_TERM',
  ShortTerm = 'SHORT_TERM',
  VeryLongTerm = 'VERY_LONG_TERM',
  VeryShortTerm = 'VERY_SHORT_TERM'
}

export enum GoalTypes {
  BuildWealth = 'BUILD_WEALTH',
  Car = 'CAR',
  CashReserve = 'CASH_RESERVE',
  Education = 'EDUCATION',
  Group = 'GROUP',
  House = 'HOUSE',
  Legacy = 'LEGACY',
  MajorPurchase = 'MAJOR_PURCHASE',
  Other = 'OTHER',
  ParentalLeave = 'PARENTAL_LEAVE',
  Retirement = 'RETIREMENT',
  RetirementIncome = 'RETIREMENT_INCOME',
  SafetyNet = 'SAFETY_NET',
  StartABusiness = 'START_A_BUSINESS',
  Vacation = 'VACATION',
  Wedding = 'WEDDING'
}

export type GoalUpdate = {
  __typename?: 'GoalUpdate';
  d?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  o: Scalars['String']['output'];
  t: Scalars['GraphQLDateTime']['output'];
};

export type GoalUpdatePaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

/** @deprecated(reason: "Not used anymore.") */
export type GoalsDaily = {
  __typename?: 'GoalsDaily';
  date: Scalars['GraphQLDateTime']['output'];
  goal: Goal;
  holdings: Array<Holding>;
  id: Scalars['ObjectID']['output'];
  marketValueCents: Scalars['Long']['output'];
  moneyAvailableCents: Scalars['Long']['output'];
  netContributionCents: Scalars['Long']['output'];
  newContributionCents: Scalars['Long']['output'];
};

export type GroupedBilling = {
  __typename?: 'GroupedBilling';
  accounts?: Maybe<Array<Maybe<AccountBilling>>>;
  billingCycleId?: Maybe<Scalars['ObjectID']['output']>;
  clientGroup?: Maybe<ClientGroup>;
  id: Scalars['ObjectID']['output'];
  total: GroupedBillingTotal;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<UserBilling>>>;
};

export type GroupedBillingTotal = {
  __typename?: 'GroupedBillingTotal';
  accountGroups: Array<AccountGroup>;
  baseCurrency: Scalars['String']['output'];
  chargeableMarketValueCentsOnLastDay: Scalars['Float']['output'];
  feeCents: Scalars['Float']['output'];
  marketValueCentsOnLastDay: Scalars['Float']['output'];
  organizationBaseCurrencyFxRate?: Maybe<Scalars['Float']['output']>;
  projectedFeeAndTaxCents: Scalars['Float']['output'];
  salesTax?: Maybe<SubAccountBillingSalesTaxes>;
  salesTaxCents: Scalars['Float']['output'];
};

export enum GroupingInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum GroupingType {
  Date = 'DATE',
  FirstDateInInterval = 'FIRST_DATE_IN_INTERVAL',
  Grouping = 'GROUPING',
  SingleValue = 'SINGLE_VALUE'
}

export enum GroupingValueAggregation {
  Avg = 'AVG',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM',
  ValueCount = 'VALUE_COUNT'
}

export enum HistoricalSnapshotsFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export enum HistoryAccountType {
  CashJoint = 'CASH_JOINT',
  CorporateCash = 'CORPORATE_CASH',
  CorporateCharity = 'CORPORATE_CHARITY',
  CorporateEstate = 'CORPORATE_ESTATE',
  CorporateTrust = 'CORPORATE_TRUST',
  Dbpp = 'DBPP',
  Dpsp = 'DPSP',
  External = 'EXTERNAL',
  Fhsa = 'FHSA',
  Grsp = 'GRSP',
  GrspSpousal = 'GRSP_SPOUSAL',
  InformalTrust = 'INFORMAL_TRUST',
  InformalTrustJoint = 'INFORMAL_TRUST_JOINT',
  Investment = 'INVESTMENT',
  Ipp = 'IPP',
  Lif = 'LIF',
  Lira = 'LIRA',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  Margin = 'MARGIN',
  MarginJoint = 'MARGIN_JOINT',
  PensionPlan = 'PENSION_PLAN',
  Personal = 'PERSONAL',
  Prif = 'PRIF',
  Rdsp = 'RDSP',
  RdspJoint = 'RDSP_JOINT',
  Resp = 'RESP',
  RespAdult = 'RESP_ADULT',
  RespFamily = 'RESP_FAMILY',
  RespFamilyJoint = 'RESP_FAMILY_JOINT',
  RespSingle = 'RESP_SINGLE',
  RespSingleJoint = 'RESP_SINGLE_JOINT',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  Rlsp = 'RLSP',
  Rpp = 'RPP',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  Tfsa = 'TFSA',
  UkBrokerage = 'UK_BROKERAGE',
  UkCashIsa = 'UK_CASH_ISA',
  UkJisa = 'UK_JISA',
  UkPersonalPension = 'UK_PERSONAL_PENSION',
  UkSsIsa = 'UK_SS_ISA',
  Usa_401K = 'USA_401K',
  Usa_529 = 'USA_529',
  UsaBrokerage = 'USA_BROKERAGE',
  UsaCorporate = 'USA_CORPORATE',
  UsaCra = 'USA_CRA',
  UsaCustodial = 'USA_CUSTODIAL',
  UsaDaf = 'USA_DAF',
  UsaDbp = 'USA_DBP',
  UsaEsa = 'USA_ESA',
  UsaEstate = 'USA_ESTATE',
  UsaInhIra = 'USA_INH_IRA',
  UsaInhRtIra = 'USA_INH_RT_IRA',
  UsaIra = 'USA_IRA',
  UsaIraCustodial = 'USA_IRA_CUSTODIAL',
  UsaJtCp = 'USA_JT_CP',
  UsaJtCpMargin = 'USA_JT_CP_MARGIN',
  UsaJtJtbe = 'USA_JT_JTBE',
  UsaJtJtbeMargin = 'USA_JT_JTBE_MARGIN',
  UsaJtTic = 'USA_JT_TIC',
  UsaJtTicMargin = 'USA_JT_TIC_MARGIN',
  UsaJtWros = 'USA_JT_WROS',
  UsaJtWrosMargin = 'USA_JT_WROS_MARGIN',
  UsaKeogh = 'USA_KEOGH',
  UsaMargin = 'USA_MARGIN',
  UsaRoIra = 'USA_RO_IRA',
  UsaRtIra = 'USA_RT_IRA',
  UsaSepIra = 'USA_SEP_IRA',
  UsaSimpleIra = 'USA_SIMPLE_IRA',
  UsaSolo_401K = 'USA_SOLO_401K',
  UsaTod = 'USA_TOD',
  UsaTrust = 'USA_TRUST'
}

export type HistoryBulkUpsertItem = {
  __typename?: 'HistoryBulkUpsertItem';
  batchId?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertIntegration?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertRequest?: Maybe<BulkUpsertRequest>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<HistoryIntegration>>>;
  oneVestId?: Maybe<Scalars['ObjectID']['output']>;
  outputErrors?: Maybe<Array<Maybe<HistoryBulkUpsertItemOutputError>>>;
  rawData?: Maybe<Scalars['Object']['output']>;
  state?: Maybe<HistoryBulkUpsertItemStates>;
};

export type HistoryBulkUpsertItemOutputError = {
  __typename?: 'HistoryBulkUpsertItemOutputError';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
};

export type HistoryBulkUpsertItemQueryFilter = {
  batchId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertIntegrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  oneVestId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<HistoryBulkUpsertItemStates>;
};

export enum HistoryBulkUpsertItemStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Queued = 'QUEUED'
}

export enum HistoryBulkUpsertItemTransition {
  Fail = 'fail',
  Process = 'process',
  Retry = 'retry'
}

export enum HistoryBulkUpsertRequestTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  PartiallyFail = 'partiallyFail',
  Process = 'process'
}

export enum HistoryCurrencies {
  Cad = 'CAD',
  Usd = 'USD'
}

/** The integration enum and unique integration id  */
export type HistoryIntegration = {
  __typename?: 'HistoryIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<HistoryIntegrationTypes>;
};

/** Input type for integrations field */
export type HistoryIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<HistoryIntegrationTypes>;
};

/** Integrations for History */
export enum HistoryIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export type HistoryResponse = AccountsDaily | GoalsDaily | SubAccountsDaily | UsersDaily;

export type HistoryUpsertIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type Holding = {
  __typename?: 'Holding';
  currentPriceCents: Scalars['Int']['output'];
  financialProduct: FinancialProduct;
  id: Scalars['ObjectID']['output'];
  quantity: Scalars['Float']['output'];
};

export enum HoldingAccountTypes {
  CashJoint = 'CASH_JOINT',
  CorporateCash = 'CORPORATE_CASH',
  CorporateCharity = 'CORPORATE_CHARITY',
  CorporateEstate = 'CORPORATE_ESTATE',
  CorporateTrust = 'CORPORATE_TRUST',
  Dbpp = 'DBPP',
  Dpsp = 'DPSP',
  External = 'EXTERNAL',
  Fhsa = 'FHSA',
  Grsp = 'GRSP',
  GrspSpousal = 'GRSP_SPOUSAL',
  InformalTrust = 'INFORMAL_TRUST',
  InformalTrustJoint = 'INFORMAL_TRUST_JOINT',
  Investment = 'INVESTMENT',
  Ipp = 'IPP',
  Lif = 'LIF',
  Lira = 'LIRA',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  Margin = 'MARGIN',
  MarginJoint = 'MARGIN_JOINT',
  PensionPlan = 'PENSION_PLAN',
  Personal = 'PERSONAL',
  Prif = 'PRIF',
  Rdsp = 'RDSP',
  RdspJoint = 'RDSP_JOINT',
  Resp = 'RESP',
  RespAdult = 'RESP_ADULT',
  RespFamily = 'RESP_FAMILY',
  RespFamilyJoint = 'RESP_FAMILY_JOINT',
  RespSingle = 'RESP_SINGLE',
  RespSingleJoint = 'RESP_SINGLE_JOINT',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  Rlsp = 'RLSP',
  Rpp = 'RPP',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  Tfsa = 'TFSA',
  UkBrokerage = 'UK_BROKERAGE',
  UkCashIsa = 'UK_CASH_ISA',
  UkJisa = 'UK_JISA',
  UkPersonalPension = 'UK_PERSONAL_PENSION',
  UkSsIsa = 'UK_SS_ISA',
  Usa_401K = 'USA_401K',
  Usa_529 = 'USA_529',
  UsaBrokerage = 'USA_BROKERAGE',
  UsaCorporate = 'USA_CORPORATE',
  UsaCra = 'USA_CRA',
  UsaCustodial = 'USA_CUSTODIAL',
  UsaDaf = 'USA_DAF',
  UsaDbp = 'USA_DBP',
  UsaEsa = 'USA_ESA',
  UsaEstate = 'USA_ESTATE',
  UsaInhIra = 'USA_INH_IRA',
  UsaInhRtIra = 'USA_INH_RT_IRA',
  UsaIra = 'USA_IRA',
  UsaIraCustodial = 'USA_IRA_CUSTODIAL',
  UsaJtCp = 'USA_JT_CP',
  UsaJtCpMargin = 'USA_JT_CP_MARGIN',
  UsaJtJtbe = 'USA_JT_JTBE',
  UsaJtJtbeMargin = 'USA_JT_JTBE_MARGIN',
  UsaJtTic = 'USA_JT_TIC',
  UsaJtTicMargin = 'USA_JT_TIC_MARGIN',
  UsaJtWros = 'USA_JT_WROS',
  UsaJtWrosMargin = 'USA_JT_WROS_MARGIN',
  UsaKeogh = 'USA_KEOGH',
  UsaMargin = 'USA_MARGIN',
  UsaRoIra = 'USA_RO_IRA',
  UsaRtIra = 'USA_RT_IRA',
  UsaSepIra = 'USA_SEP_IRA',
  UsaSimpleIra = 'USA_SIMPLE_IRA',
  UsaSolo_401K = 'USA_SOLO_401K',
  UsaTod = 'USA_TOD',
  UsaTrust = 'USA_TRUST'
}

export type HoldingBulkUpsertItem = {
  __typename?: 'HoldingBulkUpsertItem';
  batchId?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertIntegration?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertRequest?: Maybe<BulkUpsertRequest>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<HoldingIntegration>>>;
  oneVestId?: Maybe<Scalars['ObjectID']['output']>;
  outputErrors?: Maybe<Array<Maybe<HoldingBulkUpsertItemOutputError>>>;
  rawData?: Maybe<Scalars['Object']['output']>;
  state?: Maybe<HoldingBulkUpsertItemStates>;
};

export type HoldingBulkUpsertItemOutputError = {
  __typename?: 'HoldingBulkUpsertItemOutputError';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
};

export type HoldingBulkUpsertItemQueryFilter = {
  batchId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertIntegrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  oneVestId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<HoldingBulkUpsertItemStates>;
};

export enum HoldingBulkUpsertItemStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Queued = 'QUEUED'
}

export enum HoldingBulkUpsertItemTransition {
  Fail = 'fail',
  Process = 'process',
  Retry = 'retry'
}

export enum HoldingBulkUpsertRequestTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  PartiallyFail = 'partiallyFail',
  Process = 'process'
}

export type HoldingCustomExpectedPercentageInput = {
  customExpectedPercentage: Scalars['Float']['input'];
  financialProductId: Scalars['ObjectID']['input'];
};

/** Filter a custom field by key. Provide exactly one of value or valueIn. */
export type HoldingCustomFieldQueryFilter = {
  /** Custom field key to filter on. */
  key: Scalars['SafeString']['input'];
  /**
   * Exact match — the stored custom field value must equal this value.
   * Mutually exclusive with valueIn.
   */
  value?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Match any — the stored custom field value must equal one of these values (OR / IN).
   * Mutually exclusive with value.
   */
  valueIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type HoldingCustomFieldSelectedOption = {
  __typename?: 'HoldingCustomFieldSelectedOption';
  displayText?: Maybe<HoldingTranslatedString>;
  value: Scalars['JSON']['output'];
};

export type HoldingCustomFieldValue = {
  __typename?: 'HoldingCustomFieldValue';
  customField?: Maybe<CustomField>;
  key: Scalars['String']['output'];
  selectedOptions?: Maybe<Array<Maybe<HoldingCustomFieldSelectedOption>>>;
  value?: Maybe<Scalars['JSON']['output']>;
};

/** The integration enum and unique integration id  */
export type HoldingIntegration = {
  __typename?: 'HoldingIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<HoldingIntegrationTypes>;
};

/** Input type for integrations field */
export type HoldingIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<HoldingIntegrationTypes>;
};

/** Integrations for Holding */
export enum HoldingIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export type HoldingOneDayChange = {
  __typename?: 'HoldingOneDayChange';
  oneDayChangeCents?: Maybe<Scalars['Float']['output']>;
  oneDayChangePercentage?: Maybe<Scalars['Float']['output']>;
};

export type HoldingPaginationAndSorting = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<PaginationCursorDirection>;
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type HoldingProductSummary = {
  __typename?: 'HoldingProductSummary';
  aumPercentage?: Maybe<Scalars['Float']['output']>;
  currency: Currencies;
  financialProduct: FinancialProduct;
  /** Funded portfolios with non-zero settled or pending exposure in this sleeve. */
  portfolioCount: Scalars['Int']['output'];
  ticker: Scalars['String']['output'];
  /** Settled value converted to the portfolio base currency (excludes pending). */
  totalBaseValueCents: Scalars['Float']['output'];
  /** Settled quantity in the holding currency sleeve (excludes pendingQuantity). */
  totalQuantity: Scalars['Float']['output'];
  /** Settled value in the holding currency sleeve (excludes pendingValueCents). */
  totalValueCents: Scalars['Long']['output'];
};

export type HoldingProductSummaryQueryFilter = {
  organizationId: Scalars['ObjectID']['input'];
};

export type HoldingReport = {
  __typename?: 'HoldingReport';
  actualPercentage: Scalars['Float']['output'];
  adjustedCostBaseCents?: Maybe<Scalars['Float']['output']>;
  assetClass?: Maybe<AssetClass>;
  assetClassGroupPercentage?: Maybe<Scalars['Float']['output']>;
  assetClassPercentage?: Maybe<Scalars['Float']['output']>;
  /**
   * Share of this holding's own drift band consumed, as a FRACTION: 1 is the
   * band, and the value can exceed it. At or above 1 the engine has flagged the
   * holding.
   *
   * Exposed so a client can rank positions by drift without re-deriving the
   * numerator, the RELATIVE/ABSOLUTE denominator swap or the asset-class group
   * override. Recomputing those client-side is how a rendered figure comes to
   * disagree with driftRebalanceRequired on the same row.
   *
   * Not a percentage despite the name — it matches PortfolioReport.
   * bandConsumedPercentage, of which this is the per-holding input.
   */
  bandConsumedPercentage?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currencies>;
  customExpectedPercentage?: Maybe<Scalars['Float']['output']>;
  driftRebalanceRequired?: Maybe<Scalars['Boolean']['output']>;
  expectedPercentage: Scalars['Float']['output'];
  expectedValueCents: Scalars['Long']['output'];
  financialProduct: FinancialProduct;
  internalDriftDetected?: Maybe<Scalars['Boolean']['output']>;
  internalExpectedValueCents?: Maybe<Scalars['Long']['output']>;
  isCashEquivalent?: Maybe<Scalars['Boolean']['output']>;
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  liquidateRebalanceRequired?: Maybe<Scalars['Boolean']['output']>;
  originalValues?: Maybe<Array<HoldingReportOriginalValue>>;
  pendingQuantity?: Maybe<Scalars['Float']['output']>;
  pendingValueCents?: Maybe<Scalars['Long']['output']>;
  quantity: Scalars['Float']['output'];
  subAccounts?: Maybe<Array<Scalars['ObjectID']['output']>>;
  taxRank?: Maybe<Scalars['Int']['output']>;
  ticker: Scalars['String']['output'];
  valueCents: Scalars['Long']['output'];
};

export type HoldingReportOriginalValue = {
  __typename?: 'HoldingReportOriginalValue';
  currency: Currencies;
  expectedPercentage: Scalars['Float']['output'];
  expectedValueCents: Scalars['Long']['output'];
  pendingQuantity?: Maybe<Scalars['Float']['output']>;
  pendingValueCents: Scalars['Long']['output'];
  quantity: Scalars['Float']['output'];
  valueCents: Scalars['Long']['output'];
};

export type HoldingStateMachineChanges = {
  __typename?: 'HoldingStateMachineChanges';
  createdAt: Scalars['GraphQLDateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type HoldingTranslatedString = {
  __typename?: 'HoldingTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type HoldingTranslatedStringInput = {
  en?: InputMaybe<Scalars['SafeString']['input']>;
  es?: InputMaybe<Scalars['SafeString']['input']>;
  fr?: InputMaybe<Scalars['SafeString']['input']>;
};

export type HoldingUnrealizedGainLoss = {
  __typename?: 'HoldingUnrealizedGainLoss';
  unrealizedGainsAndLossCents?: Maybe<Scalars['Float']['output']>;
  unrealizedGainsAndLossPercentage?: Maybe<Scalars['Float']['output']>;
};

export type HoldingUpsertIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum HoldingsObjectType {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  ClientGroup = 'CLIENT_GROUP',
  Goal = 'GOAL',
  OrganizationUser = 'ORGANIZATION_USER',
  SubAccount = 'SUB_ACCOUNT',
  User = 'USER'
}

export type HomePageConfiguration = OrganizationExtensionResource & {
  __typename?: 'HomePageConfiguration';
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  options?: Maybe<Scalars['Object']['output']>;
  organization?: Maybe<Organization>;
  /** Organization with limited attributes that is accessible from sub-organizations. */
  publicOrganization?: Maybe<PublicOrganization>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  state: HomePageConfigurationStates;
  translatedName: OrganizationTranslatedString;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  widgets: Array<HomePageWidgetConfiguration>;
};

export type HomePageConfigurationQueryFilter = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<HomePageConfigurationStates>>>;
};

export enum HomePageConfigurationStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum HomePageConfigurationTransitions {
  Archive = 'archive'
}

export type HomePageWidgetConfiguration = {
  __typename?: 'HomePageWidgetConfiguration';
  id: Scalars['ObjectID']['output'];
  options: Scalars['Object']['output'];
  type: HomePageWidgetConfigurationTypes;
};

export type HomePageWidgetConfigurationInput = {
  options?: InputMaybe<Scalars['Object']['input']>;
  type: HomePageWidgetConfigurationTypes;
};

export enum HomePageWidgetConfigurationTypes {
  AumExplorer = 'AUM_EXPLORER',
  FeesAndRevenue = 'FEES_AND_REVENUE',
  FreeFormInput = 'FREE_FORM_INPUT',
  MarketDataTicker = 'MARKET_DATA_TICKER',
  Netflows = 'NETFLOWS',
  OpenWorkflows = 'OPEN_WORKFLOWS',
  PendingTransactions = 'PENDING_TRANSACTIONS',
  PracticeOverview = 'PRACTICE_OVERVIEW',
  ProductAumExposure = 'PRODUCT_AUM_EXPOSURE',
  QuickLinks = 'QUICK_LINKS',
  Report = 'REPORT'
}

export type HomePageWidgetOption = {
  __typename?: 'HomePageWidgetOption';
  default: Scalars['Object']['output'];
  disabledIf?: Maybe<Scalars['Object']['output']>;
  info?: Maybe<OrganizationTranslatedString>;
  key: Scalars['String']['output'];
  label?: Maybe<OrganizationTranslatedString>;
  optionType: HomePageWidgetOptionTypes;
  options?: Maybe<Scalars['Object']['output']>;
  requiredIf?: Maybe<Scalars['Object']['output']>;
  showIf?: Maybe<Scalars['Object']['output']>;
  showWith?: Maybe<Scalars['String']['output']>;
};

export enum HomePageWidgetOptionTypes {
  Array = 'ARRAY',
  Attachment = 'ATTACHMENT',
  AutomatedBankingSelected = 'AUTOMATED_BANKING_SELECTED',
  BasicField = 'BASIC_FIELD',
  BasicOrSelectField = 'BASIC_OR_SELECT_FIELD',
  Boolean = 'BOOLEAN',
  Checkbox = 'CHECKBOX',
  CombinedFields = 'COMBINED_FIELDS',
  CountrySpecificTaxId = 'COUNTRY_SPECIFIC_TAX_ID',
  HtmlTemplate = 'HTML_TEMPLATE',
  OptionalTranslatedString = 'OPTIONAL_TRANSLATED_STRING',
  PlainTextField = 'PLAIN_TEXT_FIELD',
  RoleSelectField = 'ROLE_SELECT_FIELD',
  SelectField = 'SELECT_FIELD',
  Table = 'TABLE',
  TitleField = 'TITLE_FIELD',
  TranslatedString = 'TRANSLATED_STRING',
  ValidatedTextField = 'VALIDATED_TEXT_FIELD',
  WorkflowSelectField = 'WORKFLOW_SELECT_FIELD'
}

/** Indicates the Document type for the DIGITAL_DOCUMENT_CHECK method */
export enum IdDocumentTypes {
  BankStatement = 'BANK_STATEMENT',
  BenefitsStatement = 'BENEFITS_STATEMENT',
  BirthCertificate = 'BIRTH_CERTIFICATE',
  CadCreditBureauProduct = 'CAD_CREDIT_BUREAU_PRODUCT',
  Canada_411 = 'CANADA_411',
  CitizenshipCard = 'CITIZENSHIP_CARD',
  CitizenshipCertificate = 'CITIZENSHIP_CERTIFICATE',
  ConfirmationFromFinancialEntity = 'CONFIRMATION_FROM_FINANCIAL_ENTITY',
  CreditBureau = 'CREDIT_BUREAU',
  CreditCardStatement = 'CREDIT_CARD_STATEMENT',
  CreditFile = 'CREDIT_FILE',
  DivorceDocumentation = 'DIVORCE_DOCUMENTATION',
  DriversLicense = 'DRIVERS_LICENSE',
  GlobalEntryCard = 'GLOBAL_ENTRY_CARD',
  GovIssuedCppStatement = 'GOV_ISSUED_CPP_STATEMENT',
  GovIssuedVehicleRegistration = 'GOV_ISSUED_VEHICLE_REGISTRATION',
  HealthCard = 'HEALTH_CARD',
  Id = 'ID',
  IndianStatusCard = 'INDIAN_STATUS_CARD',
  InsuranceDocument = 'INSURANCE_DOCUMENT',
  InvestmentAccountStatement = 'INVESTMENT_ACCOUNT_STATEMENT',
  LoanAccountStatement = 'LOAN_ACCOUNT_STATEMENT',
  MarriageLicence = 'MARRIAGE_LICENCE',
  MicroDeposit = 'MICRO_DEPOSIT',
  MilitaryId = 'MILITARY_ID',
  Nexus = 'NEXUS',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  PermanentResidentCard = 'PERMANENT_RESIDENT_CARD',
  ProcessedCheque = 'PROCESSED_CHEQUE',
  PropertyTaxAssessment = 'PROPERTY_TAX_ASSESSMENT',
  ProvincialId = 'PROVINCIAL_ID',
  RecordOfEmployment = 'RECORD_OF_EMPLOYMENT',
  SchoolDocument = 'SCHOOL_DOCUMENT',
  SocialSecurityCard = 'SOCIAL_SECURITY_CARD',
  StateId = 'STATE_ID',
  TravelVisa = 'TRAVEL_VISA',
  UtilityStatement = 'UTILITY_STATEMENT'
}

/** Type definition for user ID verification */
export type IdVerification = {
  __typename?: 'IdVerification';
  address?: Maybe<PhysicalAddress>;
  creditFileSource?: Maybe<Scalars['SafeString']['output']>;
  /** The expiry date of the document in YYYY-MM-DD (ISO 8601 format). Required for DIGITAL_DOCUMENT_CHECK method.  */
  documentExpiryDate?: Maybe<Scalars['GraphQLDate']['output']>;
  /** The unique identifying number of the document used */
  documentID?: Maybe<Scalars['String']['output']>;
  /** The jurisdiction (province or state) and country of issue of the document */
  documentIssuingJurisdication?: Maybe<Scalars['String']['output']>;
  /** Type of the document used in the ID Verification */
  documentType?: Maybe<IdDocumentTypes>;
  /** Internal Id of the ID verification record */
  id: Scalars['ObjectID']['output'];
  /** Method used for ID verification */
  methodOfIDVerification: IdVerificationMethods;
  /** Date of birth on secondary document in YYYY-MM-DD (ISO 8601 format). Used in verification process.  */
  secondaryDocumentDateOfBirth?: Maybe<Scalars['GraphQLDate']['output']>;
  /** Secondary document expiry date in YYYY-MM-DD (ISO 8601 format).  */
  secondaryDocumentExpiryDate?: Maybe<Scalars['GraphQLDate']['output']>;
  secondaryDocumentID?: Maybe<Scalars['String']['output']>;
  secondaryDocumentIssuingJurisdication?: Maybe<Scalars['String']['output']>;
  secondaryDocumentType?: Maybe<IdDocumentTypes>;
  secondaryDocumentUserName?: Maybe<Scalars['SafeString']['output']>;
  /** Date secondary document was verified in YYYY-MM-DD (ISO 8601 format).   */
  secondaryDocumentVerifiedDate?: Maybe<Scalars['GraphQLDate']['output']>;
  state?: Maybe<IdVerificationStates>;
  /** User object */
  user: User;
  /** The person's name on the document */
  userName?: Maybe<Scalars['String']['output']>;
  /** Date of ID verification in YYYY-MM-DD (ISO 8601 format). Required for DIGITAL_DOCUMENT_CHECK method.  */
  verifiedDate?: Maybe<Scalars['GraphQLDate']['output']>;
};

/** Supported methods of ID verification */
export enum IdVerificationMethods {
  ConfirmationOfExistence = 'CONFIRMATION_OF_EXISTENCE',
  CreditCheck = 'CREDIT_CHECK',
  DigitalDocumentCheck = 'DIGITAL_DOCUMENT_CHECK',
  DualMethod = 'DUAL_METHOD',
  InPersonValidation = 'IN_PERSON_VALIDATION'
}

export type IdVerificationProvider = {
  __typename?: 'IdVerificationProvider';
  templateId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<IdVerificationVendors>;
};

export type IdVerificationProviderInput = {
  templateId?: InputMaybe<Scalars['SafeString']['input']>;
  vendor?: InputMaybe<IdVerificationVendors>;
};

/** ID verification States */
export enum IdVerificationStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

/** Transition states for user's idVerification */
export enum IdVerificationTransition {
  Archive = 'archive'
}

export enum IdVerificationVendors {
  Persona = 'PERSONA'
}

export type ImportFile = {
  __typename?: 'ImportFile';
  bulkImport: BulkImport;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  failedLineItemsCount: Scalars['Int']['output'];
  fileDocument?: Maybe<FileDocument>;
  id: Scalars['ObjectID']['output'];
  order: Scalars['Int']['output'];
  organization?: Maybe<PublicOrganization>;
  processedLineItemsCount: Scalars['Int']['output'];
  queuedLineItemsCount: Scalars['Int']['output'];
  state: ImportFileStates;
  type: ImportFileTypes;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type ImportFileLineItem = {
  __typename?: 'ImportFileLineItem';
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  importFile: ImportFile;
  oneVestId?: Maybe<Scalars['ObjectID']['output']>;
  outputErrors?: Maybe<Array<Maybe<ImportOutputError>>>;
  rawData?: Maybe<Scalars['Object']['output']>;
  state?: Maybe<ImportFileLineItemStates>;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type ImportFileLineItemQueryFilter = {
  errorCode?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  importFileId: Scalars['ObjectID']['input'];
  oneVestId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<InputMaybe<ImportFileLineItemStates>>>;
};

export enum ImportFileLineItemStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Queued = 'QUEUED'
}

export enum ImportFileLineItemTransition {
  Fail = 'fail',
  Process = 'process',
  Retry = 'retry'
}

export type ImportFileQueryFilter = {
  bulkImportId?: InputMaybe<Scalars['ObjectID']['input']>;
  createdAtAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<InputMaybe<ImportFileStates>>>;
  types?: InputMaybe<Array<InputMaybe<ImportFileTypes>>>;
};

export enum ImportFileStates {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  PartiallyFailed = 'PARTIALLY_FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

export enum ImportFileTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  PartiallyFail = 'partiallyFail',
  Process = 'process'
}

export enum ImportFileTypes {
  Account = 'ACCOUNT',
  AccountAffiliate = 'ACCOUNT_AFFILIATE',
  ForeignExchangeRate = 'FOREIGN_EXCHANGE_RATE',
  Goal = 'GOAL',
  PortfolioSecurities = 'PORTFOLIO_SECURITIES',
  ProductShelf = 'PRODUCT_SHELF',
  SecurityPrice = 'SECURITY_PRICE',
  Transaction = 'TRANSACTION',
  User = 'USER'
}

export type ImportOutputError = {
  __typename?: 'ImportOutputError';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
};

/** Scheduled Income Fund Transfer Frequency. */
export enum IncomeFundFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY'
}

export type IncompleteAffiliation = {
  __typename?: 'IncompleteAffiliation';
  id?: Maybe<Scalars['ObjectID']['output']>;
  incompleteFields: Array<Scalars['String']['output']>;
  relation: AffiliationRelations;
  type: AffiliationTypes;
  user: User;
};

export type IncompleteFormAgreement = {
  __typename?: 'IncompleteFormAgreement';
  account?: Maybe<Account>;
  changeReason?: Maybe<Scalars['String']['output']>;
  changeType: ChangeTypes;
  clientGroup?: Maybe<ClientGroup>;
  digitalSignatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  goal?: Maybe<Goal>;
  hasPdfTemplate?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  isPrefilledPdfEnabled?: Maybe<Scalars['Boolean']['output']>;
  minVersion: Scalars['Int']['output'];
  scheduledTransfer?: Maybe<ScheduledTransfer>;
  subAccount?: Maybe<SubAccount>;
  templateUrl?: Maybe<Scalars['String']['output']>;
  translatedChangeReason?: Maybe<FormTranslatedString>;
  translatedDisplayName?: Maybe<FormTranslatedString>;
  type: FormTypes;
  user?: Maybe<User>;
  usersRequiredToSign?: Maybe<Array<Maybe<UserRequiredToSign>>>;
};

export enum Initiator {
  ApiToken = 'API_TOKEN',
  Client = 'CLIENT',
  OrganizationUser = 'ORGANIZATION_USER',
  Partner = 'PARTNER',
  System = 'SYSTEM'
}

export type Institution = {
  __typename?: 'Institution';
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** Institution ID */
  id: Scalars['ObjectID']['output'];
  /** institution isDraft or not */
  isDraft: Scalars['String']['output'];
  /** institution name */
  name: Scalars['String']['output'];
  /** The institution address  */
  physicalAddress?: Maybe<InstitutionPhysicalAddress>;
  state?: Maybe<InstitutionStates>;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<ManualStateMachineChanges>>>;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type InstitutionPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionPhysicalAddress = {
  __typename?: 'InstitutionPhysicalAddress';
  city: Scalars['String']['output'];
  country?: Maybe<AddressCountries>;
  houseNumber: Scalars['String']['output'];
  jurisdiction?: Maybe<AddressJurisdiction>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal: Scalars['String']['output'];
  /** @deprecated use jurisdiction instead */
  province?: Maybe<AddressProvince>;
  streetName: Scalars['String']['output'];
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type InstitutionPhysicalAddressInput = {
  city: Scalars['SafeString']['input'];
  country: AddressCountries;
  houseNumber: Scalars['SafeString']['input'];
  jurisdiction?: InputMaybe<AddressJurisdiction>;
  neighborhood?: InputMaybe<Scalars['SafeString']['input']>;
  postal: Scalars['SafeString']['input'];
  province?: InputMaybe<AddressProvince>;
  streetName: Scalars['SafeString']['input'];
  unitNumber?: InputMaybe<Scalars['SafeString']['input']>;
};

export type InstitutionPhysicalAddressUpdateInput = {
  city?: InputMaybe<Scalars['SafeString']['input']>;
  country?: InputMaybe<AddressCountries>;
  houseNumber?: InputMaybe<Scalars['SafeString']['input']>;
  jurisdiction?: InputMaybe<AddressJurisdiction>;
  neighborhood?: InputMaybe<Scalars['SafeString']['input']>;
  postal?: InputMaybe<Scalars['SafeString']['input']>;
  province?: InputMaybe<AddressProvince>;
  streetName?: InputMaybe<Scalars['SafeString']['input']>;
  unitNumber?: InputMaybe<Scalars['SafeString']['input']>;
};

export type InstitutionQueryFilter = {
  countries?: InputMaybe<Array<InputMaybe<AddressCountries>>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<InstitutionStates>;
};

/** Transfer processing steps. */
export enum InstitutionStates {
  Approved = 'APPROVED',
  AwaitingReview = 'AWAITING_REVIEW',
  Rejected = 'REJECTED'
}

export enum InstitutionTransition {
  Approve = 'approve',
  Reject = 'reject'
}

export type Integration = {
  __typename?: 'Integration';
  /** Configuration */
  configuration?: Maybe<Scalars['Object']['output']>;
  id: Scalars['ObjectID']['output'];
  /** Organization with limited attributes that is accessible from sub-organizations. */
  organization?: Maybe<PublicOrganization>;
  /** Name of the secret variable configured by the OneVest that should be used to the generate the OneVest-Authorization token in the PASSTHROUGH_API integration type */
  passthroughApiPrivateSecretName?: Maybe<Scalars['String']['output']>;
  /** URL of the external API used in the PASSTHROUGH_API integration type */
  passthroughApiUrl?: Maybe<Scalars['String']['output']>;
  /** Integration provides */
  provider?: Maybe<IntegrationProviders>;
  /** Scope of Integration (objectType (eg.: ACCOUNT) or attribute (eg.: statistics.timeWeightedReturn)) */
  scope?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Integration State */
  state: IntegrationStates;
  /** Mutable operational key/value state for this integration. Omit filter to return all rows; pass filter.key to filter to a single key. */
  statefulData: Array<IntegrationStatefulData>;
  /** ISO 3166-1 alpha-2 countries available for address lookup. Only used by the ADDRESS CANADA_POST integration; empty means CA only */
  supportedCountries?: Maybe<Array<CountryCodes>>;
  /** Integration types */
  type: IntegrationTypes;
};


export type IntegrationStatefulDataArgs = {
  filter?: InputMaybe<IntegrationStatefulDataFilter>;
};

export type IntegrationFormPack = {
  __typename?: 'IntegrationFormPack';
  createdAt: Scalars['GraphQLDateTime']['output'];
  expiredAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  formCompletions: Array<FormCompletion>;
  id: Scalars['ObjectID']['output'];
  jsonS3Path?: Maybe<Scalars['String']['output']>;
  lastResentAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  organization: PublicOrganization;
  resendCount?: Maybe<Scalars['Int']['output']>;
  state: IntegrationFormPackStates;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  user: User;
  workflowCompletion: WorkflowCompletion;
};

export enum IntegrationFormPackStates {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  OptedOut = 'OPTED_OUT',
  Sent = 'SENT'
}

export type IntegrationFormPacksPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationFormPacksQueryFilter = {
  integrationFormPackIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<IntegrationFormPackStates>>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  workflowCompletionId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum IntegrationProviders {
  Atb = 'ATB',
  CanadaPost = 'CANADA_POST',
  Docusign = 'DOCUSIGN',
  Envestnet = 'ENVESTNET',
  Firebase = 'FIREBASE',
  Flinks = 'FLINKS',
  Google = 'GOOGLE',
  IexCloud = 'IEX_CLOUD',
  Lseg = 'LSEG',
  Mixpanel = 'MIXPANEL',
  Nbin = 'NBIN',
  Onespan = 'ONESPAN',
  Persona = 'PERSONA',
  Plaid = 'PLAID',
  QuoteMedia = 'QUOTE_MEDIA',
  Schwab = 'SCHWAB',
  Simility = 'SIMILITY',
  Zendesk = 'ZENDESK'
}

export type IntegrationQueryFilter = {
  includeSubOrgIntegrations?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  provider?: InputMaybe<IntegrationProviders>;
  state?: InputMaybe<IntegrationStates>;
  type?: InputMaybe<IntegrationTypes>;
};

export type IntegrationRequestPayload = {
  __typename?: 'IntegrationRequestPayload';
  createdAt: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  integrationFormPack?: Maybe<IntegrationFormPack>;
  integrations: Array<IntegrationRequestPayloadIntegration>;
  organization: PublicOrganization;
  requestFileDocument: FileDocument;
  responseFileDocument?: Maybe<FileDocument>;
  state: IntegrationRequestPayloadStates;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  user: User;
  workflowCompletion: WorkflowCompletion;
};

/** The integration enum and unique integration id  */
export type IntegrationRequestPayloadIntegration = {
  __typename?: 'IntegrationRequestPayloadIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<IntegrationRequestPayloadIntegrationTypes>;
};

/** Input type for integrations field */
export type IntegrationRequestPayloadIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<IntegrationRequestPayloadIntegrationTypes>;
};

/** Integrations for IntegrationRequestPayload */
export enum IntegrationRequestPayloadIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export type IntegrationRequestPayloadQueryFilter = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  integrationFormPackId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<IntegrationRequestPayloadStates>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  workflowCompletionId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum IntegrationRequestPayloadStates {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Error = 'ERROR',
  Failed = 'FAILED',
  PartialError = 'PARTIAL_ERROR',
  Sent = 'SENT'
}

export enum IntegrationRequestPayloadTransition {
  Approved = 'APPROVED',
  Error = 'ERROR',
  Failed = 'FAILED',
  PartialError = 'PARTIAL_ERROR',
  Sent = 'SENT'
}

export type IntegrationRequestPayloadsPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationSignerMapping = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  signerKey: Scalars['String']['input'];
  signingOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationStatefulData = {
  __typename?: 'IntegrationStatefulData';
  id: Scalars['ObjectID']['output'];
  integration: Scalars['ObjectID']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['Object']['output']>;
  valueHash: Scalars['String']['output'];
};

export type IntegrationStatefulDataFilter = {
  key?: InputMaybe<Scalars['String']['input']>;
};

export enum IntegrationStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export enum IntegrationTransitionStates {
  Activate = 'activate',
  Archive = 'archive',
  Deactivate = 'deactivate'
}

export enum IntegrationTypes {
  AccountDetails = 'ACCOUNT_DETAILS',
  AccountOpening = 'ACCOUNT_OPENING',
  Address = 'ADDRESS',
  Analytics = 'ANALYTICS',
  Banking = 'BANKING',
  ChatAgent = 'CHAT_AGENT',
  DataIngestion = 'DATA_INGESTION',
  FinancialDataWidgets = 'FINANCIAL_DATA_WIDGETS',
  Form = 'FORM',
  FraudDetection = 'FRAUD_DETECTION',
  IdVerification = 'ID_VERIFICATION',
  MarketData = 'MARKET_DATA',
  PassthroughApi = 'PASSTHROUGH_API',
  Statistics = 'STATISTICS'
}

/** Investment knowledge level for user. */
export enum InvestmentKnowledge {
  Expert = 'EXPERT',
  Limited = 'LIMITED',
  None = 'NONE',
  Some = 'SOME'
}

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Failed = 'FAILED',
  NoInvite = 'NO_INVITE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Sent = 'SENT'
}

export type InviteOrganizationUsersInput = {
  organizationId: Scalars['ObjectID']['input'];
  organizationUserId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type InviteOrganizationUsersResponse = {
  __typename?: 'InviteOrganizationUsersResponse';
  success: Scalars['Boolean']['output'];
};

export type JobTitleRisk = {
  __typename?: 'JobTitleRisk';
  companyType?: Maybe<Scalars['SafeString']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  jobTitle?: Maybe<Scalars['SafeString']['output']>;
  riskRating?: Maybe<RiskRatings>;
};

export enum JournalTypes {
  Both = 'BOTH',
  Cash = 'CASH',
  Security = 'SECURITY'
}

export enum Jurisdiction {
  Ab = 'AB',
  Bc = 'BC',
  Federal = 'FEDERAL',
  Mb = 'MB',
  Nb = 'NB',
  Nl = 'NL',
  Ns = 'NS',
  On = 'ON',
  Pe = 'PE',
  Qc = 'QC',
  Sk = 'SK'
}

export enum JurisdictionCodes {
  CaAb = 'CA_AB',
  CaBc = 'CA_BC',
  CaMb = 'CA_MB',
  CaNb = 'CA_NB',
  CaNl = 'CA_NL',
  CaNs = 'CA_NS',
  CaNt = 'CA_NT',
  CaNu = 'CA_NU',
  CaOn = 'CA_ON',
  CaPe = 'CA_PE',
  CaQc = 'CA_QC',
  CaSk = 'CA_SK',
  CaYt = 'CA_YT',
  GbEng = 'GB_ENG',
  GbNir = 'GB_NIR',
  GbSct = 'GB_SCT',
  UsAk = 'US_AK',
  UsAl = 'US_AL',
  UsAr = 'US_AR',
  UsAs = 'US_AS',
  UsAz = 'US_AZ',
  UsCa = 'US_CA',
  UsCo = 'US_CO',
  UsCt = 'US_CT',
  UsDc = 'US_DC',
  UsDe = 'US_DE',
  UsFl = 'US_FL',
  UsGa = 'US_GA',
  UsGu = 'US_GU',
  UsHi = 'US_HI',
  UsIa = 'US_IA',
  UsId = 'US_ID',
  UsIl = 'US_IL',
  UsIn = 'US_IN',
  UsKs = 'US_KS',
  UsKy = 'US_KY',
  UsLa = 'US_LA',
  UsMa = 'US_MA',
  UsMd = 'US_MD',
  UsMe = 'US_ME',
  UsMi = 'US_MI',
  UsMn = 'US_MN',
  UsMo = 'US_MO',
  UsMp = 'US_MP',
  UsMs = 'US_MS',
  UsMt = 'US_MT',
  UsNc = 'US_NC',
  UsNd = 'US_ND',
  UsNe = 'US_NE',
  UsNh = 'US_NH',
  UsNj = 'US_NJ',
  UsNm = 'US_NM',
  UsNv = 'US_NV',
  UsNy = 'US_NY',
  UsOh = 'US_OH',
  UsOk = 'US_OK',
  UsOr = 'US_OR',
  UsPa = 'US_PA',
  UsPr = 'US_PR',
  UsRi = 'US_RI',
  UsSc = 'US_SC',
  UsSd = 'US_SD',
  UsTn = 'US_TN',
  UsTx = 'US_TX',
  UsUm = 'US_UM',
  UsUt = 'US_UT',
  UsVa = 'US_VA',
  UsVi = 'US_VI',
  UsVt = 'US_VT',
  UsWa = 'US_WA',
  UsWi = 'US_WI',
  UsWv = 'US_WV',
  UsWy = 'US_WY'
}

export enum Language {
  En = 'EN',
  Es = 'ES',
  Fr = 'FR'
}

export enum LanguageCodes {
  En = 'en',
  Es = 'es',
  Fr = 'fr'
}

/** Supported languages. */
export enum Languages {
  English = 'ENGLISH',
  French = 'FRENCH',
  Spanish = 'SPANISH'
}

export enum LinkTokenConfig {
  Baseline = 'baseline',
  NetWorth = 'net_worth'
}

export enum Locale {
  En = 'en',
  EnUs = 'en_US',
  Es = 'es',
  Fr = 'fr',
  FrCa = 'fr_CA'
}

export type Localization = OrganizationExtensionResource & {
  __typename?: 'Localization';
  countries?: Maybe<Array<Maybe<CountryCodes>>>;
  dateFormat?: Maybe<Scalars['String']['output']>;
  defaultCurrency?: Maybe<CurrencyCodes>;
  defaultLanguage?: Maybe<LocalizationLanguages>;
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  languages?: Maybe<Array<Maybe<LocalizationLanguages>>>;
  name: Scalars['String']['output'];
  organization: PublicOrganization;
  phoneNumberCountryCodes?: Maybe<Array<Maybe<CountryCodes>>>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  state?: Maybe<LocalizationStates>;
};

export type LocalizationInput = {
  countries?: InputMaybe<Array<InputMaybe<CountryCodes>>>;
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  defaultCurrency?: InputMaybe<CurrencyCodes>;
  defaultLanguage?: InputMaybe<LocalizationLanguages>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<LocalizationLanguages>>>;
  name: Scalars['String']['input'];
  phoneNumberCountryCodes?: InputMaybe<Array<InputMaybe<CountryCodes>>>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
};

export enum LocalizationLanguages {
  En = 'en',
  Es = 'es',
  Fr = 'fr'
}

export type LocalizationPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizationQueryFilter = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum LocalizationStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum LocalizationTransitions {
  Archive = 'archive'
}

export type Log = {
  __typename?: 'Log';
  account?: Maybe<Account>;
  apiToken?: Maybe<ApiToken>;
  changedByEmail?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Scalars['Object']['output']>;
  clientGroup?: Maybe<ClientGroup>;
  /** FinancialProduct ref when objectType is FinancialProduct (federated). */
  financialProduct?: Maybe<FinancialProduct>;
  id: Scalars['ObjectID']['output'];
  initiator: Initiator;
  newDocument?: Maybe<Scalars['Object']['output']>;
  objectId: Scalars['String']['output'];
  objectType: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationUser?: Maybe<PublicOrganizationUser>;
  originalDocument?: Maybe<Scalars['Object']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  subAccount?: Maybe<SubAccount>;
  timestamp: Scalars['GraphQLDateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: LogTypes;
  user?: Maybe<User>;
  workflowContext?: Maybe<LogWorkflowContext>;
};

/** Input fields options to manage pagination and sorting for log Object */
export type LogPaginationAndSorting = {
  /**
   * The number of records to skip per page from the
   * beginning of the elements per page
   */
  offSet?: InputMaybe<Scalars['Int']['input']>;
  /** Elements per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** To sort in descending order or not */
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  /** To sort the list by the fields for the log Object */
  sortField?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for filtering Logs */
export type LogQueryFilter = {
  /** account for filter logs */
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  /**
   * Filter logs where 'changes' object contains a specific field and the old/new value for that field.
   * For example: { field: "email", oldValue: "test123@gmail.com", newValue: "test@gmail.com" } will match if changes.email is ["test123@gmail.com", "test@gmail.com"]
   */
  changesFieldMatch?: InputMaybe<ChangesFieldMatch>;
  /** clientGroup for filter logs */
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** initiator for filter logs */
  initiator?: InputMaybe<Initiator>;
  /** initiatorId for filter logs */
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  /** initiatorIds: match any initiator id (staff referenceId or API token id); if non-empty, overrides initiatorId. */
  initiatorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** initiators: match any initiator enum (e.g. SYSTEM, CLIENT); if non-empty, overrides initiator. */
  initiators?: InputMaybe<Array<Initiator>>;
  /**
   * Filter logs where newDocument[field] === value.
   * For example: { field: "primaryEmail", value: "foo@bar.com" }
   */
  newDocumentFieldMatch?: InputMaybe<FieldMatch>;
  /** objectId for filter logs */
  objectId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** objectIds: match any id; if non-empty, overrides objectId. */
  objectIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** objectType for filter logs */
  objectType?: InputMaybe<Scalars['String']['input']>;
  /** objectTypes: match any objectType; if non-empty, overrides objectType. */
  objectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** organizationId for filter Logs */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Field name in originalDocument to use for filtering (e.g., "primaryEmail" will match originalDocument.primaryEmail) */
  originalDocumentFieldMatch?: InputMaybe<FieldMatch>;
  /** subAccount for filter logs */
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** timestamp after for filter logs */
  timestampAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  /** timestamp before for filter logs */
  timestampBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  /** traceId for filter logs */
  traceId?: InputMaybe<Scalars['String']['input']>;
  /** log type for filter logs */
  type?: InputMaybe<LogTypes>;
  /** types: match any log type; if non-empty, overrides type. */
  types?: InputMaybe<Array<LogTypes>>;
  /** user for filter logs */
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** userIds: match any user reference; if non-empty, overrides userId. */
  userIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /**
   * Filter logs where 'workflowContext' object contains a specific field and the value for that field.
   * For example: { field: "workflowCompletionId", value: "1234567890" } will match if workflowContext.workflowCompletionId is "1234567890"
   */
  workflowCompletionId?: InputMaybe<Scalars['ObjectID']['input']>;
  workflowStepId?: InputMaybe<Scalars['ObjectID']['input']>;
  workflowSubStepId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum LogTypes {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type LogWorkflowContext = {
  __typename?: 'LogWorkflowContext';
  /** Step ID */
  stepId?: Maybe<Scalars['ObjectID']['output']>;
  /** Sub step ID */
  subStepId?: Maybe<Scalars['ObjectID']['output']>;
  /** Workflow completion ID */
  workflowCompletionId?: Maybe<Scalars['ObjectID']['output']>;
};

export type LogsResponse = {
  __typename?: 'LogsResponse';
  logs: Array<Log>;
  totalCount: Scalars['Int']['output'];
};

export type ManagementFees = {
  __typename?: 'ManagementFees';
  feeCents: Scalars['Int']['output'];
  salesTaxCents: Scalars['Float']['output'];
  /** totalFeeCents = feeCents + salesTaxCents */
  totalFeeCents: Scalars['Float']['output'];
};

export type ManualProcess = {
  __typename?: 'ManualProcess';
  account: Account;
  createdAt: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  institution?: Maybe<Institution>;
  participantNumber?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ManualProcessStates>;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<ManualStateMachineChanges>>>;
  subAccount: SubAccount;
  transferAccount?: Maybe<ManualServiceAccountTypes>;
  transferAccountNumber?: Maybe<Scalars['String']['output']>;
  transferAccountNumberDisclosed?: Maybe<Scalars['String']['output']>;
  transferMethod?: Maybe<ExternalTransferTypes>;
  type: ManualProcessTypes;
  user: User;
};

/** Transfer processing steps. */
export enum ManualProcessStates {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING',
  Reconciled = 'RECONCILED'
}

export enum ManualProcessTransition {
  Cancel = 'cancel',
  Fail = 'fail',
  Process = 'process',
  Reconcile = 'reconcile'
}

export enum ManualProcessTypes {
  CloseAccount = 'CLOSE_ACCOUNT',
  TransferFromOutsideAccount = 'TRANSFER_FROM_OUTSIDE_ACCOUNT'
}

export type ManualProcessesPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ManualProcessesQueryFilter = {
  id?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export enum ManualServiceAccountTypes {
  CashJoint = 'CASH_JOINT',
  CorporateCash = 'CORPORATE_CASH',
  CorporateCharity = 'CORPORATE_CHARITY',
  CorporateEstate = 'CORPORATE_ESTATE',
  CorporateTrust = 'CORPORATE_TRUST',
  Dbpp = 'DBPP',
  Dpsp = 'DPSP',
  External = 'EXTERNAL',
  Fhsa = 'FHSA',
  Grsp = 'GRSP',
  GrspSpousal = 'GRSP_SPOUSAL',
  InformalTrust = 'INFORMAL_TRUST',
  InformalTrustJoint = 'INFORMAL_TRUST_JOINT',
  Investment = 'INVESTMENT',
  Ipp = 'IPP',
  Lif = 'LIF',
  Lira = 'LIRA',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  Margin = 'MARGIN',
  MarginJoint = 'MARGIN_JOINT',
  PensionPlan = 'PENSION_PLAN',
  Personal = 'PERSONAL',
  Prif = 'PRIF',
  Rdsp = 'RDSP',
  RdspJoint = 'RDSP_JOINT',
  Resp = 'RESP',
  RespAdult = 'RESP_ADULT',
  RespFamily = 'RESP_FAMILY',
  RespFamilyJoint = 'RESP_FAMILY_JOINT',
  RespSingle = 'RESP_SINGLE',
  RespSingleJoint = 'RESP_SINGLE_JOINT',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  Rlsp = 'RLSP',
  Rpp = 'RPP',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  Tfsa = 'TFSA',
  UkBrokerage = 'UK_BROKERAGE',
  UkCashIsa = 'UK_CASH_ISA',
  UkJisa = 'UK_JISA',
  UkPersonalPension = 'UK_PERSONAL_PENSION',
  UkSsIsa = 'UK_SS_ISA',
  Usa_401K = 'USA_401K',
  Usa_529 = 'USA_529',
  UsaBrokerage = 'USA_BROKERAGE',
  UsaCorporate = 'USA_CORPORATE',
  UsaCra = 'USA_CRA',
  UsaCustodial = 'USA_CUSTODIAL',
  UsaDaf = 'USA_DAF',
  UsaDbp = 'USA_DBP',
  UsaEsa = 'USA_ESA',
  UsaEstate = 'USA_ESTATE',
  UsaInhIra = 'USA_INH_IRA',
  UsaInhRtIra = 'USA_INH_RT_IRA',
  UsaIra = 'USA_IRA',
  UsaIraCustodial = 'USA_IRA_CUSTODIAL',
  UsaJtCp = 'USA_JT_CP',
  UsaJtCpMargin = 'USA_JT_CP_MARGIN',
  UsaJtJtbe = 'USA_JT_JTBE',
  UsaJtJtbeMargin = 'USA_JT_JTBE_MARGIN',
  UsaJtTic = 'USA_JT_TIC',
  UsaJtTicMargin = 'USA_JT_TIC_MARGIN',
  UsaJtWros = 'USA_JT_WROS',
  UsaJtWrosMargin = 'USA_JT_WROS_MARGIN',
  UsaKeogh = 'USA_KEOGH',
  UsaMargin = 'USA_MARGIN',
  UsaRoIra = 'USA_RO_IRA',
  UsaRtIra = 'USA_RT_IRA',
  UsaSepIra = 'USA_SEP_IRA',
  UsaSimpleIra = 'USA_SIMPLE_IRA',
  UsaSolo_401K = 'USA_SOLO_401K',
  UsaTod = 'USA_TOD',
  UsaTrust = 'USA_TRUST'
}

export type ManualStateMachineChanges = {
  __typename?: 'ManualStateMachineChanges';
  createdAt: Scalars['GraphQLDateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

/** Describes marital status of user. */
export enum MaritalStatus {
  CivilUnion = 'CIVIL_UNION',
  CommonLaw = 'COMMON_LAW',
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Separated = 'SEPARATED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export type MarkNotificationAsReadInput = {
  notificationId: Scalars['ObjectID']['input'];
};

export type MarketData = {
  __typename?: 'MarketData';
  currency: Currencies;
  exchange: Scalars['String']['output'];
  longName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  statistics?: Maybe<MarketDataStatistics>;
  ticker: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MarketDataStatistics = {
  __typename?: 'MarketDataStatistics';
  askCents?: Maybe<Scalars['Float']['output']>;
  bidCents?: Maybe<Scalars['Float']['output']>;
  changeCents?: Maybe<Scalars['Float']['output']>;
  changePercent?: Maybe<Scalars['Float']['output']>;
  highCents?: Maybe<Scalars['Float']['output']>;
  lastCents?: Maybe<Scalars['Float']['output']>;
  lowCents?: Maybe<Scalars['Float']['output']>;
  openCents?: Maybe<Scalars['Float']['output']>;
  previousCloseCents?: Maybe<Scalars['Float']['output']>;
};

export enum MethodOfCommunication {
  Email = 'EMAIL',
  Other = 'OTHER',
  Phone = 'PHONE',
  Text = 'TEXT'
}

export type ModelChangeAllocation = {
  __typename?: 'ModelChangeAllocation';
  /**
   * For ASSET_CLASS proposals: the asset-class group this security belongs to
   * (percentage is then group-relative). Absent on flat proposals.
   */
  assetClassId?: Maybe<Scalars['ObjectID']['output']>;
  /**
   * Portfolio-wide weight. Equal to percentage on flat models. On ASSET_CLASS,
   * percentage × (that side's matching branch targetPercentage / 100). Null when
   * the proposal is grouped and this side's snapshot is missing/empty or the
   * sleeve has no matching group.
   * Read-only — writes still send percentage (group-relative on ASSET_CLASS).
   */
  effectivePercentage?: Maybe<Scalars['Float']['output']>;
  /**
   * The allocated security, resolved from financialProductId. Document
   * templates need the fund's name/ticker alongside the percentage.
   */
  financialProduct?: Maybe<FinancialProduct>;
  financialProductId: Scalars['ObjectID']['output'];
  isCashEquivalent?: Maybe<Scalars['Boolean']['output']>;
  percentage: Scalars['Float']['output'];
};

export type ModelChangeAllocationInput = {
  /**
   * For ASSET_CLASS proposals: the asset-class group this security belongs to.
   * The percentage is then group-relative (each group's securities sum to 100).
   * Omit for flat proposals.
   */
  assetClassId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** ID of the FinancialProduct this allocation targets. */
  financialProductId: Scalars['ObjectID']['input'];
  /**
   * Optional. Designates this allocation as the cash-equivalent sleeve of the
   * resulting model. Only meaningful for entity-scoped (household clone) changes
   * that add/remove securities in a zeroPercentCash model; at most one allocation
   * may set it.
   */
  isCashEquivalent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Percentage assigned to this allocation (0–100). */
  percentage: Scalars['Float']['input'];
};

/** Group-weight snapshot entry for an ASSET_CLASS proposal (branches sum to 100). */
export type ModelChangeAssetClassBranch = {
  __typename?: 'ModelChangeAssetClassBranch';
  assetClassId: Scalars['ObjectID']['output'];
  targetPercentage: Scalars['Float']['output'];
};

/** Group-weight entry for an ASSET_CLASS proposal (branches sum to 100). */
export type ModelChangeAssetClassBranchInput = {
  assetClassId: Scalars['ObjectID']['input'];
  targetPercentage: Scalars['Float']['input'];
};

/** Asset-class min/max threshold band (per secondary asset class) carried on a proposal. */
export type ModelChangeAssetClassThreshold = {
  __typename?: 'ModelChangeAssetClassThreshold';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  secondaryAssetClassId: Scalars['ObjectID']['output'];
};

/**
 * IPS/details narrative snapshot for a proposal — the model's translated strings
 * mirrored without the 'translated' prefix. Paired as current/proposed so the FE
 * can render a compare view. Independent of allocations.
 */
export type ModelChangeModelDetails = {
  __typename?: 'ModelChangeModelDetails';
  investmentObjective?: Maybe<ProductTranslatedString>;
  liquidity?: Maybe<ProductTranslatedString>;
  name?: Maybe<ProductTranslatedString>;
  portfolioDescription?: Maybe<ProductTranslatedString>;
  portfolioDisclaimer?: Maybe<ProductTranslatedString>;
  themeName?: Maybe<ProductTranslatedString>;
};

/** IPS/details narrative payload for a proposal */
export type ModelChangeModelDetailsInput = {
  investmentObjective?: InputMaybe<ProductTranslatedStringInput>;
  liquidity?: InputMaybe<ProductTranslatedStringInput>;
  name?: InputMaybe<ProductTranslatedStringInput>;
  portfolioDescription?: InputMaybe<ProductTranslatedStringInput>;
  portfolioDisclaimer?: InputMaybe<ProductRichTextTranslatedStringInput>;
  themeName?: InputMaybe<ProductTranslatedStringInput>;
};

export type ModelChangeProposal = {
  __typename?: 'ModelChangeProposal';
  /** How the decision was made (e.g. OFFLINE_SIGNATURE, WORKFLOW_DECLINED), from the approval-relay lineage. */
  approvalMethod?: Maybe<Scalars['String']['output']>;
  /** Identifier (e.g. advisor user id) of who approved or declined this proposal, from the approval-relay lineage. */
  approvedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  currentAllocations: Array<ModelChangeAllocation>;
  currentAssetClassBranches?: Maybe<Array<ModelChangeAssetClassBranch>>;
  currentAssetClassThresholds?: Maybe<Array<ModelChangeAssetClassThreshold>>;
  currentModelDetails?: Maybe<ModelChangeModelDetails>;
  financialProductId: Scalars['ObjectID']['output'];
  id: Scalars['ObjectID']['output'];
  objectId?: Maybe<Scalars['ObjectID']['output']>;
  /** Entity scope. When set, the proposal targets a private clone bound to this entity. */
  objectType?: Maybe<BoundObjectType>;
  proposedAllocations: Array<ModelChangeAllocation>;
  proposedAssetClassBranches?: Maybe<Array<ModelChangeAssetClassBranch>>;
  proposedAssetClassThresholds?: Maybe<Array<ModelChangeAssetClassThreshold>>;
  proposedModelDetails?: Maybe<ModelChangeModelDetails>;
  state: ModelChangeProposalState;
  targetStrategy?: Maybe<FinancialProductStrategy>;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  /** The workflow-service WorkflowCompletion that produced this proposal's decision, from the approval-relay lineage. */
  workflowCompletionId?: Maybe<Scalars['String']['output']>;
};

export type ModelChangeProposalPaginationAndSorting = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelChangeProposalQueryFilter = {
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectType?: InputMaybe<BoundObjectType>;
  state?: InputMaybe<ModelChangeProposalState>;
  states?: InputMaybe<Array<ModelChangeProposalState>>;
};

export enum ModelChangeProposalState {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  PendingSignature = 'PENDING_SIGNATURE',
  Signed = 'SIGNED'
}

export enum ModelChangeProposalTransitions {
  Cancel = 'cancel',
  Sign = 'sign',
  Submit = 'submit'
}

export type ModelPortfolioChildrenPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ModelPortfolioChildrenQueryFilter = {
  modelPortfolioId: Scalars['ObjectID']['input'];
};

export type ModelPortfolioLogsInput = {
  filter?: InputMaybe<ModelPortfolioLogsQueryFilter>;
  pagination?: InputMaybe<PaginationAndSorting>;
};

export type ModelPortfolioLogsQueryFilter = {
  after?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  before?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type ModelPortfolioPaginationAndSorting = {
  collation?: InputMaybe<Collation>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ModelPortfolioQueryFilter = {
  modelPortfolioType?: InputMaybe<ModelPortfolioTypes>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<FinancialProductState>;
  states?: InputMaybe<Array<FinancialProductState>>;
  suggestable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use themeIds */
  themeId?: InputMaybe<Scalars['ObjectID']['input']>;
  themeIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

/** Type of model portfolio template. Extend as new template categories are introduced. */
export enum ModelPortfolioTypes {
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  SubAccount = 'SUB_ACCOUNT'
}

export enum MultiFactorAuthenticationOptions {
  Authenticator = 'AUTHENTICATOR',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type Mutation = {
  __typename?: 'Mutation';
  addAffiliation: AddAffiliationResponse;
  addEntityToOrganizationUser: AddEntityToOrganizationUserResponse;
  addImportFile: AddImportFileResponse;
  annualSuitabilityCompleted: AnnualSuitabilityCompletedResponse;
  archiveEntityBoundModel: ArchiveEntityBoundModelResponse;
  archiveFormCompletion: ArchiveFormCompletionResponse;
  archiveFormMap: UpdateFormMapResponse;
  archiveGoal: ArchiveGoalResponse;
  bucketSubTradeRequests?: Maybe<Scalars['Boolean']['output']>;
  /** Force reconcile multiple custodian activities in bulk */
  bulkForceReconcileActivities: BulkForceReconcileActivitiesResponse;
  /**
   * Allow bulk state transition on multiple account fees
   * @deprecated AccountFee is deprecated; use SubAccountBilling endpoints instead
   */
  bulkTransitionAccountFees: BulkTransitionAccountFeesResponse;
  bulkTransitionFlags: BulkTransitionFlagsResponse;
  bulkTransitionFlagsForGrid: BulkTransitionFlagsForGridResponse;
  bulkUpsertAccountGroups: BulkUpsertAccountGroupsResponse;
  bulkUpsertAccounts: BulkUpsertAccountsResponse;
  bulkUpsertAdvisorContacts: BulkUpsertAdvisorContactsResponse;
  bulkUpsertAssetClasses: BulkUpsertAssetClassesResponse;
  /** Bulk upsert bank accounts */
  bulkUpsertBankAccounts: BulkUpsertBankAccountResponse;
  bulkUpsertCashAndHoldings: BulkUpsertCashAndHoldingsResponse;
  bulkUpsertClientGroups: BulkUpsertClientGroupsResponse;
  bulkUpsertCustodianActivities: BulkUpsertCustodianActivitiesResponse;
  bulkUpsertCustodianCashAndHoldings: BulkUpsertCustodianCashAndHoldingsResponse;
  bulkUpsertFinancialProductSnapshots: BulkUpsertFinancialProductSnapshotsResponse;
  bulkUpsertFinancialProducts: BulkUpsertFinancialProductsResponse;
  bulkUpsertGoals: BulkUpsertGoalsResponse;
  bulkUpsertOrganizationUsers: BulkUpsertOrganizationUsersResponse;
  bulkUpsertOrganizations: BulkUpsertOrganizationsResponse;
  bulkUpsertPerformanceSnapshots: BulkUpsertPerformanceSnapshotsResponse;
  bulkUpsertScheduledTransfer: BulkUpsertScheduledTransferResponse;
  bulkUpsertStatsSnapshots: BulkUpsertStatsSnapshotsResponse;
  bulkUpsertSubAccounts: BulkUpsertSubAccountsResponse;
  bulkUpsertTrades: BulkUpsertTradesResponse;
  bulkUpsertTransactions: BulkUpsertTransactionsResponse;
  bulkUpsertUsers: BulkUpsertUsersResponse;
  calculatePostRebalanceMetrics: CalculatePostRebalanceMetricsResponse;
  calculatePreRebalanceMetrics: CalculatePreRebalanceMetricsResponse;
  /** @deprecated Use updateTradeRequestFills instead */
  calculateTradeRequestFills: CalculateTradeRequestFillsResponse;
  cancelCustodianDepositTransfer: CreateCustodianDepositTransferResponse;
  /** Cancels a deposit transfer */
  cancelDepositTransfer: CancelTransferResponse;
  cancelIntegrationFormPack: CancelIntegrationFormPackResponse;
  /** Cancels scheduled transfer, either deposit or withdrawal transfer. */
  cancelScheduledTransfer: CancelScheduledTransferResponse;
  cancelSubTradeRequests: Scalars['Int']['output'];
  cancelSubTradeRequestsById: Scalars['Int']['output'];
  cloneModelPortfolio: CloneModelPortfolioResponse;
  /** Close account. */
  closeAccount: CloseAccountResponse;
  /** Close subAccount. */
  closeSubAccount: CloseSubAccountResponse;
  /** @deprecated Use the addAffiliation mutation instead. */
  completeGoal: CompleteGoalResponse;
  copyFormTemplate: CopyFormTemplateResponse;
  createAccount: CreateAccountResponse;
  createAccountGroup: CreateAccountGroupResponse;
  /** Create an accountStatement. Call the 'fetchStatementUploadUrl' first, then upload the statement to S3, then call this. */
  createAccountStatement: CreateAccountStatementResponse;
  createAdjustmentTransaction: CreateAdjustmentTransactionResponse;
  /** Creates a Adjustment Transfer request to deposit $ from the specified source. */
  createAdjustmentTransfer: AdjustmentTransferResponse;
  createAdvisorContact: CreateAdvisorContactResponse;
  /** Creates an "affiliate only" user */
  createAffiliate: CreateAffiliateResponse;
  createAlertBanner: CreateAlertBannerResponse;
  /** Create an API token */
  createApiToken: CreateApiTokenResponse;
  /** Create an article */
  createArticle: CreateArticleResponse;
  createAssetClass: CreateAssetClassResponse;
  /** Creates the bankAccount information. */
  createBankAccount: CreateBankAccountResponse;
  /** Creates the bankConnection and the linked bankAccounts. */
  createBankConnection: CreateBankConnectionResponse;
  /** @deprecated Use the removeAffiliation mutation instead. */
  createBeneficiary: CreateBeneficiaryResponse;
  createBillingSchedule: CreateBillingScheduleResponse;
  createBulkImport: CreateBulkImportResponse;
  createBulkTradeRequest: CreateBulkTradeRequestResponse;
  createChequeTransfer: CreateChequeTransferResponse;
  /** Creates a ClientGroup */
  createClientGroup: CreateClientGroupResponse;
  createClientReportTemplate: ClientReportTemplateResponse;
  createClientReportTemplatePageConfiguration: CreateClientReportTemplatePageConfigurationResponse;
  createConfigurableTablePage: CreateConfigurableTablePageResponse;
  createCountryRisk: CreateCountryRiskResponse;
  createCustodian: CreateCustodianResponse;
  createCustodianConnection: CreateCustodianConnectionResponse;
  createCustodianDepositTransfer: CreateCustodianDepositTransferResponse;
  /** Create a custom attribute label */
  createCustomAttributeLabel: CreateCustomAttributeLabelResponse;
  createCustomField: CreateCustomFieldResponse;
  /** Creates an Transfer request to deposit $ from the account holder's bank account and use the $ to **buy** units into the user's subAccount. */
  createDepositTransfer: CreateTransferResponse;
  createDisplayRole: CreateDisplayRoleResponse;
  createDowntimeSchedule: CreateDowntimeScheduleResponse;
  /** Allow publish request for external account statements */
  createExternalAccountStatement: CreateExternalAccountStatementResponse;
  /** Creates a ManualProcess. */
  createExternalTransfer: CreateExternalTransferResponse;
  createFeeTier: CreateFeeTierResponse;
  /** Create an a documentFile. Call the 'fetchFileUploadUrl' first, then upload the document to S3, then call this. */
  createFileDocument: CreateFileDocumentResponse;
  createFinancialProduct: CreateFinancialProductResponse;
  createFormCompletion: CreateFormCompletionResponse;
  createFormDefinition: CreateFormDefinitionResponse;
  createFormMap: CreateFormMapResponse;
  createFormTemplate: CreateFormTemplateResponse;
  createGoal: CreateGoalResponse;
  createHomePageConfiguration: CreateHomePageConfigurationResponse;
  /** Creates a Institution. */
  createInstitution: CreateInstitutionResponse;
  /** Create new integration */
  createIntegration: CreateIntegrationResponse;
  createIntegrationFormAgreement: CreateIntegrationFormAgreementResponse;
  createIntegrationFormPack: CreateIntegrationFormPackResponse;
  createIntegrationRequestPayload: CreateIntegrationRequestPayloadResponse;
  createJobTitleRisk: CreateJobTitleRiskResponse;
  /** Creates the link token for Plaid */
  createLinkToken: CreateLinkTokenResponse;
  createLocalization: CreateLocalizationResponse;
  createModelChangeProposal: CreateModelChangeProposalResponse;
  createModelPortfolio: CreateModelPortfolioResponse;
  /** Create an a note */
  createNote: CreateNoteResponse;
  createNotification: CreateNotificationResponse;
  createNotificationDefinition: CreationNotificationDefintionResponse;
  createNotificationGroup: CreateNotificationGroupResponse;
  /** Create a new organization */
  createOrganization: CreateOrganizationResponse;
  /** Create a new dashboard */
  createOrganizationDashboard: CreateOrganizationDashboardResponse;
  /** Create a new organization user */
  createOrganizationUser: CreateOrganizationUserResponse;
  createPageConfiguration: CreatePageConfigurationResponse;
  createPortfolioTemplate: CreatePortfolioTemplateResponse;
  createRepCode: CreateRepCodeResponse;
  createReport: CreateReportResponse;
  createRestWebhook: CreateWebhookResponse;
  /** Create a new role */
  createRole: CreateRoleResponse;
  createRoleProfile: CreateRoleProfileResponse;
  /** Append an immutable sales tax configuration revision for the context organization or a descendant. A parent organization may write for a descendant. */
  createSalesTaxConfigurationRevision: CreateSalesTaxConfigurationRevisionResponse;
  createSchedule: CreateScheduleResponse;
  /** Creates a deposit scheduled transfer */
  createScheduledDepositTransfer: CreateScheduledTransferResponse;
  /** Creates a scheduled income fund transfer */
  createScheduledIncomeFundTransfer: CreateScheduledIncomeFundTransferResponse;
  /** Creates a scheduled transfer between subAccounts associated with the same account. */
  createScheduledTransferBetweenSubAccounts: CreateScheduledTransferResponse;
  /** Creates a withdraw scheduled transfer */
  createScheduledWithdrawTransfer: CreateScheduledTransferResponse;
  /** Create a SIEM feed for Auth0 security event export */
  createSiemFeed: CreateSiemFeedResponse;
  createSignerType: CreateSignerTypeResponse;
  createStaticPageWidgetConfiguration: CreateStaticPageWidgetConfigurationResponse;
  createSubAccount: CreateSubAccountResponse;
  /** @deprecated Use createSubTradeRequests (plural) instead */
  createSubTradeRequest: CreateSubTradeRequestResponse;
  createSubTradeRequests: Scalars['Int']['output'];
  /** Creates a new tax lot */
  createTaxLot: CreateTaxLotResponse;
  createTheme: CreateThemeResponse;
  createTrade: CreateTradeResponse;
  createTransaction: CreateTransactionResponse;
  /** Creates a User */
  createUser: CreateUserResponse;
  /** Creates ID verification details for a user */
  createUserIDVerificationInformation: UserIdVerificationResponse;
  createWebhook: CreateWebhookResponse;
  /** Creates an Transfer request to **sell** units of the user's subAccount and deposit the resulting $ into the account holder's bank account. */
  createWithdrawTransfer: CreateTransferResponse;
  createWorkflow: CreateWorkflowResponse;
  createWorkflowCompletion: CreateWorkflowCompletionResponse;
  /** Allow deletion of account statement */
  deleteAccountStatement: DeleteAccountStatementResponse;
  deleteAlertBanner: DeleteAlertBannerResponse;
  /** Delete an existing article */
  deleteArticle: DeleteArticleResponse;
  deleteArticleImage: DeleteArticleImageResponse;
  /** Deletes the bankAccount information. */
  deleteBankAccount: DeleteBankAccountResponse;
  /** Delete documentFile */
  deleteFileDocument: DeleteFileDocumentResponse;
  deleteImportFile: DeleteImportFileResponse;
  /** Delete a Institution. */
  deleteInstitution: DeleteInstitutionResponse;
  /** Delete integration stateful data by key */
  deleteIntegrationStatefulData: DeleteIntegrationStatefulDataResponse;
  deleteLocalization?: Maybe<Scalars['Boolean']['output']>;
  deleteNotificationDefinition: Scalars['Boolean']['output'];
  deleteNotificationGroup: Scalars['Boolean']['output'];
  /** Mark a dashboard as archived */
  deleteOrganizationDashboard: DeleteOrganizationDashboardResponse;
  /** Delete an existing organization user */
  deleteOrganizationUser: DeleteOrganizationUserResponse;
  deleteReport: DeleteReportResponse;
  /** Delete an existing role */
  deleteRole: DeleteRoleResponse;
  /** Permanently delete an inactive SIEM feed */
  deleteSiemFeed: DeleteSiemFeedResponse;
  /** Deletes a tax lot */
  deleteTaxLot: DeleteTaxLotResponse;
  deleteTransaction: DeleteTransactionResponse;
  deleteWebhook: DeleteWebhookResponse;
  /** Switches subAccount liquidated state from Yes to No and cancels the pending withdraw all transfer */
  endLiquidation: EndLiquidationResponse;
  /** Perform token exchange for SSO integration */
  exchangeClientToken: ExchangeClientTokenResponse;
  exportApiReport: ExportApiReportResponse;
  /** Export configurable table page data to CSV */
  exportConfigurableTablePageReport: ExportConfigurableTablePageReportResponse;
  exportReport: ExportReportResponse;
  forceCompleteIntegrationFormPack: ForceCompleteIntegrationFormPackResponse;
  forceReconcileCustodianActivity: ForceReconcileCustodianActivityResponse;
  /** Allow publish request for annual performance report generating */
  generateAnnualPerformanceReport: GenerateAnnualPerformanceReportResponse;
  generateBulkTrades: GenerateBulkTradesResponse;
  generateClientReport?: Maybe<GenerateClientReportResponse>;
  /**
   * Generates a Flinks authorizeToken for integrations that require one to
   * be passed to the Flinks Connect iframe on init.
   */
  generateFlinksAuthorizeToken: GenerateFlinksAuthorizeTokenResponse;
  /** Allow publish request for monthlyAccountStatements generating */
  generateMonthlyAccountStatement: GenerateMonthlyAccountStatementResponse;
  goToSubStep: GoToSubStepResponse;
  /** Send invitation to existing organization users */
  inviteOrganizationUsers: InviteOrganizationUsersResponse;
  markAllNotificationsAsRead: Scalars['Boolean']['output'];
  markNotificationAsRead: Scalars['Boolean']['output'];
  nextSubStep: NextSubStepResponse;
  overrideAccountsTaxRanks: Scalars['Int']['output'];
  pairSubTradeRequests?: Maybe<Scalars['Boolean']['output']>;
  prepareFormCompletion: PrepareFormCompletionResponse;
  prepareFormCompletions: PrepareFormCompletionsResponse;
  previousSubStep: PreviousSubStepResponse;
  /** Print a pdf version of a client report based on the template */
  printClientReportTemplate: PrintClientReportTemplateResponse;
  /** Run publishHistory job manually     */
  publishHistory: Scalars['Boolean']['output'];
  publishPendingSubTradeRequestTotals?: Maybe<Scalars['Boolean']['output']>;
  reAssessFraudRisk: ReAssessFraudRiskResponse;
  reactivateGoal: ReactivateGoalResponse;
  /** Rebalance subAccounts. */
  rebalanceSubAccounts: RebalanceSubAccountsResponse;
  reconcileCustodianActivity: ReconcileCustodianActivityResponse;
  /**
   * Reconcile PROCESSING bulk trades in an organization tree.
   * organizationId defaults to the caller and must be the caller or a descendant.
   * settlementBefore defaults to the exclusive end of the next America/Toronto business day.
   * Does not write ledger transactions.
   */
  reconcileProcessingBulkTrades: ReconcileProcessingBulkTradesResponse;
  refreshPortfolioReport: RefreshPortfolioReportResponse;
  refreshSubAccountBillingTotals: RefreshSubAccountBillingTotalsResponse;
  refreshSubAccountDailyFee: Scalars['Boolean']['output'];
  regenerateExternalTransferPdf: RegenerateExternalTransferPdfResponse;
  regenerateHtml: RegenerateHtmlResponse;
  regeneratePdf: RegeneratePdfResponse;
  removeAffiliation: RemoveAffiliationResponse;
  removeBulkTrade: RemoveBulkTradeResponse;
  removeEntityFromOrganizationUser: RemoveEntityFromOrganizationUserResponse;
  reorderDisplayRoles: ReorderDisplayRolesResponse;
  repairSnapshots: RepairSnapshotsResponse;
  replaceAccountGroupAccounts: ReplaceAccountGroupAccountsResponse;
  resendIntegrationFormPack: ResendIntegrationFormPackResponse;
  /** Reset organization user multifactor. This will be scoped to the context user unless the write:organization_user is granted. */
  resetOrganizationUserMultifactor: ResetOrganizationUserMultifactorResponse;
  /** Retry the failed webhooks of the given event. */
  retryFailedWebhooks: RetryFailedWebhooksResponse;
  /** Revoke invitation for an organization user */
  revokeOrganizationUserInvitation: RevokeOrganizationUserInvitationResponse;
  /** Revoke a grace-period SIEM feed credential by UUID */
  revokeSiemFeedCredential: RevokeSiemFeedCredentialResponse;
  /** Rotate the SIEM feed credential and return a new JWT */
  rotateSiemFeedCredential: RotateSiemFeedCredentialResponse;
  runPortfolioOptimizer: RunPortfolioOptimizerResponse;
  runPortfolioOptimizerV2: RunPortfolioOptimizerV2Response;
  /** Run reconcile job manually */
  runReconciliation: Scalars['Boolean']['output'];
  runWorkflowSubStepAction: RunWorkflowSubStepActionResponse;
  saveForeignExchangeRates: SaveForeignExchangeRatesResponse;
  screenPortfolios: ScreenPortfoliosResponse;
  sendIntegrationFormAgreement: SendIntegrationFormAgreementResponse;
  sendIntegrationFormPack: SendIntegrationFormPackResponse;
  setAdvisorContactDesignations: SetAdvisorContactDesignationsResponse;
  setAllocationMethodology: SetAllocationMethodologyResponse;
  setCustomExpectedPercentages: SetCustomExpectedPercentagesResponse;
  setUserNotificationPreferences: SetUserNotificationPreferencesResponse;
  setupEntityBoundModel: SetupEntityBoundModelResponse;
  signFormAgreements: SignFormAgreementsResponse;
  signFormCompletion: SignFormCompletionResponse;
  submitCustodianAccountOpening: SubmitCustodianAccountOpeningResponse;
  /** Switches out a subAccount holding at cost and replaces it the given financial product. */
  switchEquitiesAtCost: SwitchEquitiesAtCostResponse;
  /** Switch out a holding in a subAccount, at market, for another holding. */
  switchEquitiesAtMarket: SwitchEquitiesAtMarketResponse;
  /** Transfer all funds between subAccounts associated with the same account. */
  transferAllBetweenSubAccounts: TransferAllBetweenSubAccountsResponse;
  /** Transfer funds between subAccounts associated with the same account. */
  transferBetweenSubAccounts: TransferBetweenSubAccountsResponse;
  transferEquityBetweenSubAccounts: TransferEquityBetweenSubAccountsResponse;
  transitionAccount: TransitionAccountResponse;
  transitionAccountBulkUpsertItem: TransitionAccountBulkUpsertItemResponse;
  transitionAccountBulkUpsertRequest: TransitionAccountBulkUpsertRequestResponse;
  /**
   * Allow state transition on account fees
   * @deprecated AccountFee is deprecated; use SubAccountBilling endpoints instead
   */
  transitionAccountFee: TransitionAccountFeeResponse;
  transitionAccountGroup: TransitionAccountGroupResponse;
  transitionAccountGroupBulkUpsertItem: TransitionAccountGroupBulkUpsertItemResponse;
  transitionAccountGroupBulkUpsertRequest: TransitionAccountGroupBulkUpsertRequestResponse;
  /** Allow state transition on account statements */
  transitionAccountStatement: TransitionAccountStatementResponse;
  /** Allow state transition on multiple account statements */
  transitionAccountStatements: TransitionAccountStatementsResponse;
  transitionAdvisorContact: TransitionAdvisorContactResponse;
  transitionAlertBanner: TransitionAlertBannerResponse;
  transitionAlertBannerInteraction: TransitionAlertBannerInteractionResponse;
  /** Transition an API token */
  transitionApiToken: TransitionApiTokenResponse;
  /** Transition an article */
  transitionArticle: TransitionArticleResponse;
  transitionAssetClass: TransitionAssetClassResponse;
  /** Allows the Bank Account transitioned through its states */
  transitionBankAccount: TransitionBankAccountResponse;
  transitionBankAccountBulkUpsertItem: TransitionBankAccountBulkUpsertItemResponse;
  transitionBankAccountBulkUpsertRequest: TransitionBankAccountBulkUpsertRequestResponse;
  transitionBillingCycle: TransitionBillingCycleResponse;
  transitionBillingSchedule: TransitionBillingScheduleResponse;
  transitionBulkImport: TransitionBulkImportResponse;
  transitionBulkTradeRequest: TransitionBulkTradeRequestResponse;
  transitionBulkTradeRun: TransitionBulkTradeRunResponse;
  /** Allows to soft-delete a clientGroup */
  transitionClientGroup: TransitionClientGroupResponse;
  transitionClientReportTemplate: ClientReportTemplateResponse;
  transitionConfigurableTablePage: TransitionConfigurableTablePageResponse;
  /** Transition a custom attribute label state (archive/activate) */
  transitionCustomAttributeLabel: TransitionCustomAttributeLabelResponse;
  transitionCustomField: TransitionCustomFieldResponse;
  transitionDisplayRole: TransitionDisplayRoleResponse;
  transitionDowntimeSchedule: TransitionDowntimeScheduleResponse;
  transitionFeeTier: TransitionFeeTierResponse;
  transitionFinancialProduct: TransitionFinancialProductResponse;
  transitionFinancialProductBulkUpsertItem: TransitionFinancialProductBulkUpsertItemResponse;
  transitionFinancialProductBulkUpsertRequest: TransitionFinancialProductBulkUpsertRequestResponse;
  transitionFlag: TransitionFlagResponse;
  transitionFormDefinition: TransitionFormDefinitionResponse;
  transitionFormTemplate: TransitionFormTemplateResponse;
  transitionHistoryBulkUpsertItem: TransitionHistoryBulkUpsertItemResponse;
  transitionHistoryBulkUpsertRequest: TransitionHistoryBulkUpsertRequestResponse;
  transitionHoldingBulkUpsertItem: TransitionHoldingBulkUpsertItemResponse;
  transitionHoldingBulkUpsertRequest: TransitionHoldingBulkUpsertRequestResponse;
  transitionHomePageConfiguration: TransitionHomePageConfigurationResponse;
  transitionImportFile: TransitionImportFileResponse;
  /** Allows an Institution transitioned through its states */
  transitionInstitution: TransitionInstitutionResponse;
  /** Delete an integration */
  transitionIntegration: TransitionIntegrationResponse;
  transitionIntegrationRequestPayload: TransitionIntegrationRequestPayloadResponse;
  /** Transition localization state */
  transitionLocalization: TransitionLocalizationResponse;
  /** Allows the manualProcess to be forcefully transitioned through its states */
  transitionManualProcess: TransitionManualProcessResponse;
  transitionModelChangeProposal: TransitionModelChangeProposalResponse;
  transitionModelPortfolio: TransitionModelPortfolioResponse;
  /** Transition Note state */
  transitionNote: TransitionNoteResponse;
  transitionOrganizationBulkUpsertItem: TransitionOrganizationBulkUpsertItemResponse;
  transitionOrganizationBulkUpsertRequest: TransitionOrganizationBulkUpsertRequestResponse;
  transitionOrganizationDashboard: TransitionOrganizationDashboardResponse;
  transitionPageConfiguration: TransitionPageConfigurationResponse;
  transitionPortfolioOptimizer: TransitionPortfolioOptimizerResponse;
  transitionPortfolioTemplate: TransitionPortfolioTemplateResponse;
  transitionRebalance: TransitionRebalanceResponse;
  transitionRepCode: TransitionRepCodeResponse;
  transitionReport: TransitionReportResponse;
  transitionRoleProfile: TransitionRoleProfileResponse;
  /** Allows the ScheduledIncomeFundTransfer to be forcifully transitioned through its states */
  transitionScheduledIncomeFundTransfer: TransitionScheduledIncomeFundTransferResponse;
  /** Transition a SIEM feed between active and inactive states */
  transitionSiemFeed: TransitionSiemFeedResponse;
  transitionSignerType: TransitionSignerTypeResponse;
  transitionStaticPageWidgetConfiguration: TransitionStaticPageWidgetConfigurationResponse;
  transitionSubAccount: TransitionSubAccountResponse;
  transitionSubTradeRequest: TransitionSubTradeRequestResponse;
  transitionTheme: TransitionThemeResponse;
  transitionTrade: TransitionTradeResponse;
  /** Allows the Transfer to be forcifully transitioned through its states */
  transitionTransfer: TransitionTransferResponse;
  /** Transitions a user's profile status */
  transitionUser: TransitionUserResponse;
  transitionUserBulkUpsertItem: TransitionUserBulkUpsertItemResponse;
  transitionUserBulkUpsertRequest: TransitionUserBulkUpsertRequestResponse;
  /** Allows the IdVerification to be forcifully transitioned through its states */
  transitionUserIdVerification: TransitionUserIdVerificationResponse;
  transitionWorkflow: TransitionWorkflowResponse;
  transitionWorkflowCompletion: TransitionWorkflowCompletionResponse;
  /** Trigger auto bulk trade message */
  triggerAutoBulkTrades: TriggerAutoBulkTradesResponse;
  triggerModelPortfolioResign: Scalars['Boolean']['output'];
  triggerSynchronousIntegration: TriggerSynchronousIntegrationResponse;
  /** Unlink phone multifactor authentication */
  unlinkPhoneMultifactor: UnlinkPhoneMultifactorResponse;
  updateAccount: UpdateAccountResponse;
  updateAccountGroup: UpdateAccountGroupResponse;
  updateAccountStatement: UpdateAccountStatementResponse;
  updateAdvisorContact: UpdateAdvisorContactResponse;
  /** Updates an "affiliate only" user */
  updateAffiliate: UpdateAffiliateResponse;
  updateAffiliations: UpdateAffiliationsResponse;
  updateAlertBanner: UpdateAlertBannerResponse;
  updateAllHoldingsAndCash: UpdateAllHoldingsAndCashResponse;
  /** Update an API token */
  updateApiToken: UpdateApiTokenResponse;
  /** Update an existing role */
  updateArticle: UpdateArticleResponse;
  updateAssetClass: UpdateAssetClassResponse;
  /** Update bank account name */
  updateBankAccount: UpdateBankAccountResponse;
  updateBeneficiary: UpdateBeneficiaryResponse;
  updateBillingSchedule: UpdateBillingScheduleResponse;
  updateBulkImport: UpdateBulkImportResponse;
  updateBulkTradeRequest: UpdateBulkTradeRequestResponse;
  /** Updated ClientGroup */
  updateClientGroup: UpdateClientGroupResponse;
  /** Move a clientGroup to a different organization */
  updateClientGroupOrganization: UpdateClientGroupOrganizationResponse;
  updateClientGroupPortfolio: UpdateClientGroupPortfolioResponse;
  updateClientReportTemplate: ClientReportTemplateResponse;
  updateClientReportTemplatePageConfiguration: UpdateClientReportTemplatePageConfigurationResponse;
  updateConfigurableTablePage: UpdateConfigurableTablePageResponse;
  updateCountryRisk: UpdateCountryRiskResponse;
  updateCustodian: UpdateCustodianResponse;
  /** Append an investigation note to a custodian activity (append-only history; newest first). */
  updateCustodianActivityNotes: UpdateCustodianActivityNotesResponse;
  updateCustodianConnection: UpdateCustodianConnectionResponse;
  updateCustodianCustomFields: UpdateCustodianCustomFieldsResponse;
  /** Update a custom attribute label */
  updateCustomAttributeLabel: UpdateCustomAttributeLabelResponse;
  updateCustomField: UpdateCustomFieldResponse;
  updateDisplayRole: UpdateDisplayRoleResponse;
  updateDowntimeSchedule: UpdateDowntimeScheduleResponse;
  /** @deprecated Use updateEntityFeeSetting instead */
  updateEntityFee: UpdateEntityFeeResponse;
  updateEntityFeeSetting: UpdateEntityFeeResponse;
  /** Update organizationProviders */
  updateExternalProvider: UpdateExternalProvidersResponse;
  updateFeeSetting: UpdateFeeSettingResponse;
  updateFeeTier: UpdateFeeTierResponse;
  /** Updated documentFile */
  updateFileDocument: UpdateFileDocumentResponse;
  updateFinancialProduct: UpdateFinancialProductResponse;
  updateFlagNotes: FetchFlagResponse;
  updateFormDefinition: UpdateFormDefinitionResponse;
  updateFormMap: UpdateFormMapResponse;
  updateFormTemplate: UpdateFormTemplateResponse;
  updateFraudRisk: UpdateFraudRiskResponse;
  updateGoal: UpdateGoalResponse;
  updateHomePageConfiguration: UpdateHomePageConfigurationResponse;
  updateImportFileLineItem: UpdateImportFileLineItemResponse;
  /** Update a Institution. */
  updateInstitution: UpdateInstitutionResponse;
  /** Update an existing integration */
  updateIntegration: UpdateIntegrationResponse;
  updateIntegrationFormAgreement: UpdateIntegrationFormAgreementResponse;
  /** Update integration stateful data atomically */
  updateIntegrationStatefulData: UpdateIntegrationStatefulDataResponse;
  updateJobTitleRisk: UpdateJobTitleRiskResponse;
  updateLocalization: UpdateLocalizationResponse;
  updateModelChangeProposal: UpdateModelChangeProposalResponse;
  updateModelPortfolio: UpdateModelPortfolioResponse;
  /** Updated Note */
  updateNote: UpdateNoteResponse;
  updateNotificationDefinition: UpdateNotificationDefintionResponse;
  updateNotificationGroup: UpdateNotificationGroupResponse;
  updateOrgFlagPolicy: UpdateOrgFlagPolicyResponse;
  updateOrgReconTolerancePolicy: Organization;
  /** Update an existing organization */
  updateOrganization: UpdateOrganizationResponse;
  /** Update an existing dashboard */
  updateOrganizationDashboard: UpdateOrganizationDashboardResponse;
  /** Update the organization feature flag settings */
  updateOrganizationFeatureFlag: UpdateOrganizationFeatureFlagResponse;
  /** Update an existing organization user */
  updateOrganizationUser: UpdateOrganizationUserResponse;
  /** Update context user profile. The email can be updated only if the write:organization_user_authentication permission is granted. */
  updateOrganizationUserProfile: UpdateOrganizationUserProfileResponse;
  updatePageConfiguration: UpdatePageConfigurationResponse;
  updatePortfolioTemplate: UpdatePortfolioTemplateResponse;
  /** Update the actual price and quantity of bulk trades */
  updatePriceAndQuantity: UpdatePriceAndQuantityResponse;
  updateRepCode: UpdateRepCodeResponse;
  updateReport: UpdateReportResponse;
  /** Update an existing role */
  updateRole: UpdateRoleResponse;
  updateRoleProfile: UpdateRoleProfileResponse;
  updateSchedule: UpdateScheduleResponse;
  /** Update scheduledIncomeFundTransfer information */
  updateScheduledIncomeFundTransfer: UpdateScheduledIncomeFundTransferResponse;
  /** Update scheduledTransfer information */
  updateScheduledTransfer: UpdateScheduledTransferResponse;
  /** Update an existing SIEM feed configuration */
  updateSiemFeed: UpdateSiemFeedResponse;
  updateSignerType: UpdateSignerTypeResponse;
  updateStaticPageWidgetConfiguration: UpdateStaticPageWidgetConfigurationResponse;
  updateSubAccount: UpdateSubAccountResponse;
  updateSubAccountBilling: UpdateSubAccountBillingResponse;
  updateSubTradeRequest: UpdateSubTradeRequestResponse;
  updateSubTradeRequests: Scalars['Int']['output'];
  /** Updates an existing tax lot */
  updateTaxLot: UpdateTaxLotResponse;
  updateTheme: UpdateThemeResponse;
  updateTradeRequestFills: UpdateTradeRequestFillsResponse;
  updateTransaction: UpdateTransactionResponse;
  updateTransfer: UpdateTransferResponse;
  /** Updates a user's information for the userId provided as input */
  updateUser: UpdateUserResponse;
  /** Updated ID verification details for a user */
  updateUserIDVerificationInformation: UserIdVerificationResponse;
  /** Move user to a different organization */
  updateUserOrganization: UpdateUserOrganizationResponse;
  /** Update display options for a user */
  updateUserOrganizationUserDisplayOptions: UpdateUserOrganizationUserDisplayOptionsResponse;
  updateWebhook: UpdateWebhookResponse;
  updateWorkflow: UpdateWorkflowResponse;
  updateWorkflowCompletion: UpdateWorkflowCompletionResponse;
  upsertAlertBannerInteractions: UpsertAlertBannerInteractionsResponse;
  upsertBulkTradeRunAllocationFiles: UpdateBulkTradeRunAllocationFilesResponse;
  upsertBulkTradeRunBulkTradeFiles: UpsertBulkTradeRunBulkTradeFilesResponse;
  /** Create or update the role an organization must have, materializing it from its role profile */
  upsertOrganizationRole: UpsertOrganizationRoleResponse;
  upsertRepCode: UpsertRepCodeResponse;
  verifySubTradeRequests: Scalars['Int']['output'];
  /** Verify User */
  verifyUserAndAddToAccount: VerifyUserAndAddToAccountResponse;
  withdrawAllFromAccount: WithdrawAllAccountResponse;
  withdrawAllFromSubAccount: WithdrawAllSubAccountResponse;
};


export type MutationAddAffiliationArgs = {
  input: AddAffiliationInput;
};


export type MutationAddEntityToOrganizationUserArgs = {
  input: AddEntityToOrganizationUserInput;
};


export type MutationAddImportFileArgs = {
  input: AddImportFileInput;
};


export type MutationAnnualSuitabilityCompletedArgs = {
  userId: Scalars['ObjectID']['input'];
};


export type MutationArchiveEntityBoundModelArgs = {
  input: ArchiveEntityBoundModelInput;
};


export type MutationArchiveFormCompletionArgs = {
  input: ArchiveFormCompletionInput;
};


export type MutationArchiveFormMapArgs = {
  formMapId: Scalars['ObjectID']['input'];
};


export type MutationArchiveGoalArgs = {
  input: ArchiveGoalInput;
};


export type MutationBucketSubTradeRequestsArgs = {
  input: BucketSubTradeRequestsInput;
};


export type MutationBulkForceReconcileActivitiesArgs = {
  input: BulkForceReconcileActivitiesInput;
};


export type MutationBulkTransitionAccountFeesArgs = {
  input: BulkTransitionAccountFeesInput;
};


export type MutationBulkTransitionFlagsArgs = {
  input: BulkTransitionFlagsInput;
};


export type MutationBulkTransitionFlagsForGridArgs = {
  input: BulkTransitionFlagsInput;
};


export type MutationBulkUpsertAccountGroupsArgs = {
  input: BulkUpsertAccountGroupsInput;
};


export type MutationBulkUpsertAccountsArgs = {
  input: BulkUpsertAccountsInput;
};


export type MutationBulkUpsertAdvisorContactsArgs = {
  input: BulkUpsertAdvisorContactsInput;
};


export type MutationBulkUpsertAssetClassesArgs = {
  input: BulkUpsertAssetClassesInput;
};


export type MutationBulkUpsertBankAccountsArgs = {
  input: BulkUpsertBankAccountsInput;
};


export type MutationBulkUpsertCashAndHoldingsArgs = {
  input: BulkUpsertCashAndHoldingsInput;
};


export type MutationBulkUpsertClientGroupsArgs = {
  input: BulkUpsertClientGroupsInput;
};


export type MutationBulkUpsertCustodianActivitiesArgs = {
  input: BulkUpsertCustodianActivitiesInput;
};


export type MutationBulkUpsertCustodianCashAndHoldingsArgs = {
  input: BulkUpsertCustodianCashAndHoldingsInput;
};


export type MutationBulkUpsertFinancialProductSnapshotsArgs = {
  input: BulkUpsertFinancialProductSnapshotsInput;
};


export type MutationBulkUpsertFinancialProductsArgs = {
  input: BulkUpsertFinancialProductsInput;
};


export type MutationBulkUpsertGoalsArgs = {
  input: BulkUpsertGoalsInput;
};


export type MutationBulkUpsertOrganizationUsersArgs = {
  input: BulkUpsertOrganizationUsersInput;
};


export type MutationBulkUpsertOrganizationsArgs = {
  input: BulkUpsertOrganizationsInput;
};


export type MutationBulkUpsertPerformanceSnapshotsArgs = {
  input: BulkUpsertPerformanceSnapshotsInput;
};


export type MutationBulkUpsertScheduledTransferArgs = {
  input: BulkUpsertScheduledTransferInput;
};


export type MutationBulkUpsertStatsSnapshotsArgs = {
  input: BulkUpsertStatsSnapshotsInput;
};


export type MutationBulkUpsertSubAccountsArgs = {
  input: BulkUpsertSubAccountsInput;
};


export type MutationBulkUpsertTradesArgs = {
  input: BulkUpsertTradesInput;
};


export type MutationBulkUpsertTransactionsArgs = {
  input: BulkUpsertTransactionsInput;
};


export type MutationBulkUpsertUsersArgs = {
  input: BulkUpsertUsersInput;
};


export type MutationCalculatePostRebalanceMetricsArgs = {
  input: CalculatePostRebalanceMetricsInput;
};


export type MutationCalculatePreRebalanceMetricsArgs = {
  input: CalculatePreRebalanceMetricsInput;
};


export type MutationCalculateTradeRequestFillsArgs = {
  input: CalculateTradeRequestFillsInput;
};


export type MutationCancelCustodianDepositTransferArgs = {
  input: CancelCustodianDepositTransferInput;
};


export type MutationCancelDepositTransferArgs = {
  transferId: Scalars['ObjectID']['input'];
};


export type MutationCancelIntegrationFormPackArgs = {
  input: CancelIntegrationFormPackInput;
};


export type MutationCancelScheduledTransferArgs = {
  scheduledTransferId: Scalars['ObjectID']['input'];
};


export type MutationCancelSubTradeRequestsArgs = {
  input: CancelSubTradeRequestsInput;
};


export type MutationCancelSubTradeRequestsByIdArgs = {
  input: CancelSubTradeRequestsByIdInput;
};


export type MutationCloneModelPortfolioArgs = {
  input: CloneModelPortfolioInput;
};


export type MutationCloseAccountArgs = {
  input: CloseAccountInput;
};


export type MutationCloseSubAccountArgs = {
  input: CloseSubAccountInput;
};


export type MutationCompleteGoalArgs = {
  input: CompleteGoalInput;
};


export type MutationCopyFormTemplateArgs = {
  input: CopyFormTemplateInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateAccountGroupArgs = {
  input: CreateAccountGroupInput;
};


export type MutationCreateAccountStatementArgs = {
  input: CreateAccountStatementInput;
};


export type MutationCreateAdjustmentTransactionArgs = {
  input: CreateAdjustmentTransactionInput;
  options?: InputMaybe<CreateTransactionOptionsInput>;
};


export type MutationCreateAdjustmentTransferArgs = {
  input: CreateAdjustmentTransferInput;
};


export type MutationCreateAdvisorContactArgs = {
  input: CreateAdvisorContactInput;
};


export type MutationCreateAffiliateArgs = {
  input: CreateAffiliateInput;
};


export type MutationCreateAlertBannerArgs = {
  input: CreateAlertBannerInput;
};


export type MutationCreateApiTokenArgs = {
  input: CreateApiTokenInput;
};


export type MutationCreateArticleArgs = {
  input: CreateArticleInput;
};


export type MutationCreateAssetClassArgs = {
  input: CreateAssetClassInput;
};


export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput;
};


export type MutationCreateBankConnectionArgs = {
  input: CreateBankConnectionInput;
};


export type MutationCreateBeneficiaryArgs = {
  input: CreateBeneficiaryInput;
};


export type MutationCreateBillingScheduleArgs = {
  input: CreateBillingScheduleInput;
};


export type MutationCreateBulkImportArgs = {
  input: CreateBulkImportInput;
};


export type MutationCreateBulkTradeRequestArgs = {
  input: CreateBulkTradeRequestInput;
};


export type MutationCreateChequeTransferArgs = {
  input: CreateChequeTransferInput;
};


export type MutationCreateClientGroupArgs = {
  input: CreateClientGroupInput;
};


export type MutationCreateClientReportTemplateArgs = {
  input: CreateClientReportTemplateInput;
};


export type MutationCreateClientReportTemplatePageConfigurationArgs = {
  input: CreateClientReportTemplatePageConfigurationInput;
};


export type MutationCreateConfigurableTablePageArgs = {
  input: CreateConfigurableTablePageInput;
};


export type MutationCreateCountryRiskArgs = {
  input: CreateCountryRiskInput;
};


export type MutationCreateCustodianArgs = {
  input: CreateCustodianInput;
};


export type MutationCreateCustodianConnectionArgs = {
  input: CreateCustodianConnectionInput;
};


export type MutationCreateCustodianDepositTransferArgs = {
  input: CreateCustodianDepositTransferInput;
};


export type MutationCreateCustomAttributeLabelArgs = {
  input: CreateCustomAttributeLabelInput;
};


export type MutationCreateCustomFieldArgs = {
  input: CreateCustomFieldInput;
};


export type MutationCreateDepositTransferArgs = {
  input: CreateDepositTransferInput;
};


export type MutationCreateDisplayRoleArgs = {
  input: CreateDisplayRoleInput;
};


export type MutationCreateDowntimeScheduleArgs = {
  input: CreateDowntimeScheduleInput;
};


export type MutationCreateExternalAccountStatementArgs = {
  input: CreateExternalAccountStatementInput;
};


export type MutationCreateExternalTransferArgs = {
  input: CreateExternalTransferInput;
};


export type MutationCreateFeeTierArgs = {
  input: CreateFeeTierInput;
};


export type MutationCreateFileDocumentArgs = {
  input: CreateFileDocumentInput;
};


export type MutationCreateFinancialProductArgs = {
  input: CreateFinancialProductInput;
};


export type MutationCreateFormCompletionArgs = {
  input: CreateFormCompletionInput;
};


export type MutationCreateFormDefinitionArgs = {
  input: CreateFormDefinitionInput;
};


export type MutationCreateFormMapArgs = {
  input: CreateFormMapInput;
};


export type MutationCreateFormTemplateArgs = {
  input: CreateFormTemplateInput;
};


export type MutationCreateGoalArgs = {
  input: CreateGoalInput;
};


export type MutationCreateHomePageConfigurationArgs = {
  input: CreateHomePageConfigurationInput;
};


export type MutationCreateInstitutionArgs = {
  input: CreateInstitutionInput;
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationCreateIntegrationFormAgreementArgs = {
  input: CreateIntegrationFormAgreementInput;
};


export type MutationCreateIntegrationFormPackArgs = {
  input: CreateIntegrationFormPackInput;
};


export type MutationCreateIntegrationRequestPayloadArgs = {
  input: CreateIntegrationRequestPayloadInput;
};


export type MutationCreateJobTitleRiskArgs = {
  input: CreateJobTitleRiskInput;
};


export type MutationCreateLinkTokenArgs = {
  input: CreateLinkTokenInput;
};


export type MutationCreateLocalizationArgs = {
  localization: LocalizationInput;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type MutationCreateModelChangeProposalArgs = {
  input: CreateModelChangeProposalInput;
};


export type MutationCreateModelPortfolioArgs = {
  input: CreateModelPortfolioInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateNotificationDefinitionArgs = {
  input: CreateNotificationDefinitionInput;
};


export type MutationCreateNotificationGroupArgs = {
  input: CreateNotificationGroupInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationDashboardArgs = {
  input: CreateOrganizationDashboardInput;
};


export type MutationCreateOrganizationUserArgs = {
  input: CreateOrganizationUserInput;
};


export type MutationCreatePageConfigurationArgs = {
  input: CreatePageConfigurationInput;
};


export type MutationCreatePortfolioTemplateArgs = {
  input: CreatePortfolioTemplateInput;
};


export type MutationCreateRepCodeArgs = {
  input: CreateRepCodeInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateRestWebhookArgs = {
  input: CreateRestWebhookInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateRoleProfileArgs = {
  input: CreateRoleProfileInput;
};


export type MutationCreateSalesTaxConfigurationRevisionArgs = {
  input: CreateSalesTaxConfigurationRevisionInput;
};


export type MutationCreateScheduleArgs = {
  input: CreateScheduleInput;
};


export type MutationCreateScheduledDepositTransferArgs = {
  input: CreateScheduledDepositTransferInput;
};


export type MutationCreateScheduledIncomeFundTransferArgs = {
  input: CreateScheduledIncomeFundTransferInput;
};


export type MutationCreateScheduledTransferBetweenSubAccountsArgs = {
  input: CreateScheduledTransferBetweenSubAccountsInput;
};


export type MutationCreateScheduledWithdrawTransferArgs = {
  input: CreateScheduledWithdrawTransferInput;
};


export type MutationCreateSiemFeedArgs = {
  input: CreateSiemFeedInput;
};


export type MutationCreateSignerTypeArgs = {
  input: CreateSignerTypeInput;
};


export type MutationCreateStaticPageWidgetConfigurationArgs = {
  input: CreateStaticPageWidgetConfigurationInput;
};


export type MutationCreateSubAccountArgs = {
  input: CreateSubAccountInput;
};


export type MutationCreateSubTradeRequestArgs = {
  input: CreateSubTradeRequestInput;
};


export type MutationCreateSubTradeRequestsArgs = {
  input: CreateSubTradeRequestsInput;
};


export type MutationCreateTaxLotArgs = {
  input: CreateTaxLotInput;
};


export type MutationCreateThemeArgs = {
  input: CreateThemeInput;
};


export type MutationCreateTradeArgs = {
  input: CreateTradeInput;
};


export type MutationCreateTransactionArgs = {
  input: CreateTransactionInput;
  options?: InputMaybe<CreateTransactionOptionsInput>;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserIdVerificationInformationArgs = {
  input: CreateUserIdVerificationInformationInput;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationCreateWithdrawTransferArgs = {
  input: CreateWithdrawTransferInput;
};


export type MutationCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};


export type MutationCreateWorkflowCompletionArgs = {
  input: CreateWorkflowCompletionInput;
};


export type MutationDeleteAccountStatementArgs = {
  accountStatementId: Scalars['ObjectID']['input'];
};


export type MutationDeleteAlertBannerArgs = {
  input: DeleteAlertBannerInput;
};


export type MutationDeleteArticleArgs = {
  articleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteArticleImageArgs = {
  input: DeleteArticleImageInput;
};


export type MutationDeleteBankAccountArgs = {
  bankAccountId: Scalars['ObjectID']['input'];
};


export type MutationDeleteFileDocumentArgs = {
  input: DeleteFileDocumentInput;
};


export type MutationDeleteImportFileArgs = {
  input: DeleteImportFileInput;
};


export type MutationDeleteInstitutionArgs = {
  input: DeleteInstitutionInput;
};


export type MutationDeleteIntegrationStatefulDataArgs = {
  input: DeleteIntegrationStatefulDataInput;
};


export type MutationDeleteLocalizationArgs = {
  localizationId: Scalars['ObjectID']['input'];
};


export type MutationDeleteNotificationDefinitionArgs = {
  input: DeleteNotificationDefinitionInput;
};


export type MutationDeleteNotificationGroupArgs = {
  input: DeleteNotificationGroupInput;
};


export type MutationDeleteOrganizationDashboardArgs = {
  input: DeleteOrganizationDashboardInput;
};


export type MutationDeleteOrganizationUserArgs = {
  organizationUserId: Scalars['ObjectID']['input'];
};


export type MutationDeleteReportArgs = {
  input: DeleteReportInput;
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['ObjectID']['input'];
};


export type MutationDeleteSiemFeedArgs = {
  siemFeedId: Scalars['ObjectID']['input'];
};


export type MutationDeleteTaxLotArgs = {
  input: DeleteTaxLotInput;
};


export type MutationDeleteTransactionArgs = {
  options?: InputMaybe<DeleteTransactionOptionsInput>;
  transactionId: Scalars['ObjectID']['input'];
};


export type MutationDeleteWebhookArgs = {
  webhookId: Scalars['String']['input'];
};


export type MutationEndLiquidationArgs = {
  input: EndLiquidationInput;
};


export type MutationExchangeClientTokenArgs = {
  input: ExchangeClientTokenInput;
};


export type MutationExportApiReportArgs = {
  input: ExportApiReportInput;
};


export type MutationExportConfigurableTablePageReportArgs = {
  input: ExportConfigurableTablePageReportInput;
};


export type MutationExportReportArgs = {
  input: ExportReportInput;
};


export type MutationForceCompleteIntegrationFormPackArgs = {
  input: ForceCompleteIntegrationFormPackInput;
};


export type MutationForceReconcileCustodianActivityArgs = {
  custodianActivityId: Scalars['ObjectID']['input'];
};


export type MutationGenerateAnnualPerformanceReportArgs = {
  input: GenerateAnnualPerformanceReportInput;
};


export type MutationGenerateBulkTradesArgs = {
  input: GenerateBulkTradesInput;
};


export type MutationGenerateClientReportArgs = {
  input: GenerateClientReportInput;
};


export type MutationGenerateFlinksAuthorizeTokenArgs = {
  input: GenerateFlinksAuthorizeTokenInput;
};


export type MutationGenerateMonthlyAccountStatementArgs = {
  input: GenerateMonthlyAccountStatementInput;
};


export type MutationGoToSubStepArgs = {
  input: GoToSubStepInput;
};


export type MutationInviteOrganizationUsersArgs = {
  input: InviteOrganizationUsersInput;
};


export type MutationMarkNotificationAsReadArgs = {
  input: MarkNotificationAsReadInput;
};


export type MutationNextSubStepArgs = {
  input: NextSubStepInput;
};


export type MutationOverrideAccountsTaxRanksArgs = {
  input: OverrideAccountsTaxRanksInput;
};


export type MutationPairSubTradeRequestsArgs = {
  input: PairSubTradeRequestsInput;
};


export type MutationPrepareFormCompletionArgs = {
  input: PrepareFormCompletionInput;
};


export type MutationPrepareFormCompletionsArgs = {
  input: PrepareFormCompletionsInput;
};


export type MutationPreviousSubStepArgs = {
  input: PreviousSubStepInput;
};


export type MutationPrintClientReportTemplateArgs = {
  input: PrintClientReportTemplateInput;
};


export type MutationPublishHistoryArgs = {
  input: PublishHistoryInput;
};


export type MutationPublishPendingSubTradeRequestTotalsArgs = {
  input: PublishPendingSubTradeRequestTotalsInput;
};


export type MutationReAssessFraudRiskArgs = {
  input: ReAssessFraudRiskInput;
};


export type MutationReactivateGoalArgs = {
  input: ReactivateGoalInput;
};


export type MutationRebalanceSubAccountsArgs = {
  input?: InputMaybe<RebalanceSubAccountsInput>;
};


export type MutationReconcileCustodianActivityArgs = {
  custodianActivityId: Scalars['ObjectID']['input'];
};


export type MutationReconcileProcessingBulkTradesArgs = {
  input: ReconcileProcessingBulkTradesInput;
};


export type MutationRefreshPortfolioReportArgs = {
  input: RefreshPortfolioReportInput;
};


export type MutationRefreshSubAccountBillingTotalsArgs = {
  input: RefreshSubAccountBillingTotalsInput;
};


export type MutationRefreshSubAccountDailyFeeArgs = {
  input: RefreshSubAccountDailyFeeInput;
};


export type MutationRegenerateExternalTransferPdfArgs = {
  input: RegenerateExternalTransferPdfInput;
};


export type MutationRegenerateHtmlArgs = {
  input: RegenerateHtmlInput;
};


export type MutationRegeneratePdfArgs = {
  input: RegeneratePdfInput;
};


export type MutationRemoveAffiliationArgs = {
  input: RemoveAffiliationInput;
};


export type MutationRemoveBulkTradeArgs = {
  tradeRequestId: Scalars['ObjectID']['input'];
};


export type MutationRemoveEntityFromOrganizationUserArgs = {
  input: RemoveEntityFromOrganizationUserInput;
};


export type MutationReorderDisplayRolesArgs = {
  input: ReorderDisplayRolesInput;
};


export type MutationRepairSnapshotsArgs = {
  input: RepairSnapshotsInput;
};


export type MutationReplaceAccountGroupAccountsArgs = {
  input: ReplaceAccountGroupAccountsInput;
};


export type MutationResendIntegrationFormPackArgs = {
  input: ResendIntegrationFormPackInput;
};


export type MutationResetOrganizationUserMultifactorArgs = {
  input: ResetOrganizationUserMultifactorInput;
};


export type MutationRetryFailedWebhooksArgs = {
  input: RetryFailedWebhooksInput;
};


export type MutationRevokeOrganizationUserInvitationArgs = {
  organizationUserId: Scalars['ObjectID']['input'];
};


export type MutationRevokeSiemFeedCredentialArgs = {
  input: RevokeSiemFeedCredentialInput;
};


export type MutationRotateSiemFeedCredentialArgs = {
  input: RotateSiemFeedCredentialInput;
};


export type MutationRunPortfolioOptimizerArgs = {
  input: RunPortfolioOptimizerInput;
};


export type MutationRunPortfolioOptimizerV2Args = {
  input: RunPortfolioOptimizerV2Input;
};


export type MutationRunReconciliationArgs = {
  input?: InputMaybe<RunReconciliationInput>;
};


export type MutationRunWorkflowSubStepActionArgs = {
  input: RunWorkflowSubStepActionInput;
};


export type MutationSaveForeignExchangeRatesArgs = {
  input: SaveForeignExchangeRatesInput;
};


export type MutationScreenPortfoliosArgs = {
  input: ScreenPortfoliosInput;
};


export type MutationSendIntegrationFormAgreementArgs = {
  input: SendIntegrationFormAgreementInput;
};


export type MutationSendIntegrationFormPackArgs = {
  input: SendIntegrationFormPackInput;
};


export type MutationSetAdvisorContactDesignationsArgs = {
  input: SetAdvisorContactDesignationsInput;
};


export type MutationSetAllocationMethodologyArgs = {
  input: SetAllocationMethodologyInput;
};


export type MutationSetCustomExpectedPercentagesArgs = {
  input: SetCustomExpectedPercentagesInput;
};


export type MutationSetUserNotificationPreferencesArgs = {
  input: SetUserNotificationPreferencesInput;
};


export type MutationSetupEntityBoundModelArgs = {
  input: SetupEntityBoundModelInput;
};


export type MutationSignFormAgreementsArgs = {
  input: SignFormAgreementsInput;
};


export type MutationSignFormCompletionArgs = {
  input: SignFormCompletionInput;
};


export type MutationSubmitCustodianAccountOpeningArgs = {
  input: SubmitCustodianAccountOpeningInput;
};


export type MutationSwitchEquitiesAtCostArgs = {
  input: SwitchEquitiesAtCostInput;
};


export type MutationSwitchEquitiesAtMarketArgs = {
  input: SwitchEquitiesAtMarketInput;
};


export type MutationTransferAllBetweenSubAccountsArgs = {
  input: TransferAllBetweenSubAccountsInput;
};


export type MutationTransferBetweenSubAccountsArgs = {
  input: TransferBetweenSubAccountsInput;
};


export type MutationTransferEquityBetweenSubAccountsArgs = {
  input: TransferEquityBetweenSubAccountsInput;
};


export type MutationTransitionAccountArgs = {
  input: TransitionAccountInput;
};


export type MutationTransitionAccountBulkUpsertItemArgs = {
  input: TransitionAccountBulkUpsertItemInput;
};


export type MutationTransitionAccountBulkUpsertRequestArgs = {
  input: TransitionAccountBulkUpsertRequestInput;
};


export type MutationTransitionAccountFeeArgs = {
  input: TransitionAccountFeeInput;
};


export type MutationTransitionAccountGroupArgs = {
  input: TransitionAccountGroupInput;
};


export type MutationTransitionAccountGroupBulkUpsertItemArgs = {
  input: TransitionAccountGroupBulkUpsertItemInput;
};


export type MutationTransitionAccountGroupBulkUpsertRequestArgs = {
  input: TransitionAccountGroupBulkUpsertRequestInput;
};


export type MutationTransitionAccountStatementArgs = {
  input: TransitionAccountStatementInput;
};


export type MutationTransitionAccountStatementsArgs = {
  input: TransitionAccountStatementsInput;
};


export type MutationTransitionAdvisorContactArgs = {
  input: TransitionAdvisorContactInput;
};


export type MutationTransitionAlertBannerArgs = {
  input: TransitionAlertBannerInput;
};


export type MutationTransitionAlertBannerInteractionArgs = {
  input: TransitionAlertBannerInteractionInput;
};


export type MutationTransitionApiTokenArgs = {
  input: TransitionApiTokenInput;
};


export type MutationTransitionArticleArgs = {
  input: TransitionArticleInput;
};


export type MutationTransitionAssetClassArgs = {
  input: TransitionAssetClassInput;
};


export type MutationTransitionBankAccountArgs = {
  input: TransitionBankAccountInput;
};


export type MutationTransitionBankAccountBulkUpsertItemArgs = {
  input: TransitionBankAccountBulkUpsertItemInput;
};


export type MutationTransitionBankAccountBulkUpsertRequestArgs = {
  input: TransitionBankAccountBulkUpsertRequestInput;
};


export type MutationTransitionBillingCycleArgs = {
  input: TransitionBillingCycleInput;
};


export type MutationTransitionBillingScheduleArgs = {
  input: TransitionBillingScheduleInput;
};


export type MutationTransitionBulkImportArgs = {
  input: TransitionBulkImportInput;
};


export type MutationTransitionBulkTradeRequestArgs = {
  input: TransitionBulkTradeRequestInput;
};


export type MutationTransitionBulkTradeRunArgs = {
  input: TransitionBulkTradeRunInput;
};


export type MutationTransitionClientGroupArgs = {
  input: TransitionClientGroupInput;
};


export type MutationTransitionClientReportTemplateArgs = {
  clientReportTemplateId: Scalars['ObjectID']['input'];
  transition: ClientReportTemplateTransitions;
};


export type MutationTransitionConfigurableTablePageArgs = {
  input: TransitionConfigurableTablePageInput;
};


export type MutationTransitionCustomAttributeLabelArgs = {
  input: TransitionCustomAttributeLabelInput;
};


export type MutationTransitionCustomFieldArgs = {
  input: TransitionCustomFieldInput;
};


export type MutationTransitionDisplayRoleArgs = {
  input: TransitionDisplayRoleInput;
};


export type MutationTransitionDowntimeScheduleArgs = {
  input: TransitionDowntimeScheduleInput;
};


export type MutationTransitionFeeTierArgs = {
  input: TransitionFeeTierInput;
};


export type MutationTransitionFinancialProductArgs = {
  input: TransitionFinancialProductInput;
};


export type MutationTransitionFinancialProductBulkUpsertItemArgs = {
  input: TransitionFinancialProductBulkUpsertItemInput;
};


export type MutationTransitionFinancialProductBulkUpsertRequestArgs = {
  input: TransitionFinancialProductBulkUpsertRequestInput;
};


export type MutationTransitionFlagArgs = {
  input: TransitionFlagInput;
};


export type MutationTransitionFormDefinitionArgs = {
  input: TransitionFormDefinitionInput;
};


export type MutationTransitionFormTemplateArgs = {
  input: TransitionFormTemplateInput;
};


export type MutationTransitionHistoryBulkUpsertItemArgs = {
  input: TransitionHistoryBulkUpsertItemInput;
};


export type MutationTransitionHistoryBulkUpsertRequestArgs = {
  input: TransitionHistoryBulkUpsertRequestInput;
};


export type MutationTransitionHoldingBulkUpsertItemArgs = {
  input: TransitionHoldingBulkUpsertItemInput;
};


export type MutationTransitionHoldingBulkUpsertRequestArgs = {
  input: TransitionHoldingBulkUpsertRequestInput;
};


export type MutationTransitionHomePageConfigurationArgs = {
  input: TransitionHomePageConfigurationInput;
};


export type MutationTransitionImportFileArgs = {
  input: TransitionImportFileInput;
};


export type MutationTransitionInstitutionArgs = {
  input: TransitionInstitutionInput;
};


export type MutationTransitionIntegrationArgs = {
  input: TransitionIntegrationInput;
};


export type MutationTransitionIntegrationRequestPayloadArgs = {
  input: TransitionIntegrationRequestPayloadInput;
};


export type MutationTransitionLocalizationArgs = {
  input: TransitionLocalizationInput;
};


export type MutationTransitionManualProcessArgs = {
  input: TransitionManualProcessInput;
};


export type MutationTransitionModelChangeProposalArgs = {
  input: TransitionModelChangeProposalInput;
};


export type MutationTransitionModelPortfolioArgs = {
  input: TransitionModelPortfolioInput;
};


export type MutationTransitionNoteArgs = {
  input: TransitionNoteInput;
};


export type MutationTransitionOrganizationBulkUpsertItemArgs = {
  input: TransitionOrganizationBulkUpsertItemInput;
};


export type MutationTransitionOrganizationBulkUpsertRequestArgs = {
  input: TransitionOrganizationBulkUpsertRequestInput;
};


export type MutationTransitionOrganizationDashboardArgs = {
  input: TransitionOrganizationDashboardInput;
};


export type MutationTransitionPageConfigurationArgs = {
  input: TransitionPageConfigurationInput;
};


export type MutationTransitionPortfolioOptimizerArgs = {
  input: TransitionPortfolioOptimizerInput;
};


export type MutationTransitionPortfolioTemplateArgs = {
  input: TransitionPortfolioTemplateInput;
};


export type MutationTransitionRebalanceArgs = {
  input: TransitionRebalanceInput;
};


export type MutationTransitionRepCodeArgs = {
  input: TransitionRepCodeInput;
};


export type MutationTransitionReportArgs = {
  input: TransitionReportInput;
};


export type MutationTransitionRoleProfileArgs = {
  input: TransitionRoleProfileInput;
};


export type MutationTransitionScheduledIncomeFundTransferArgs = {
  input: TransitionScheduledIncomeFundTransferInput;
};


export type MutationTransitionSiemFeedArgs = {
  input: TransitionSiemFeedInput;
};


export type MutationTransitionSignerTypeArgs = {
  input: TransitionSignerTypeInput;
};


export type MutationTransitionStaticPageWidgetConfigurationArgs = {
  input: TransitionStaticPageWidgetConfigurationInput;
};


export type MutationTransitionSubAccountArgs = {
  input: TransitionSubAccountInput;
};


export type MutationTransitionSubTradeRequestArgs = {
  input: TransitionSubTradeRequestInput;
};


export type MutationTransitionThemeArgs = {
  input: TransitionThemeInput;
};


export type MutationTransitionTradeArgs = {
  input: TransitionTradeInput;
};


export type MutationTransitionTransferArgs = {
  input: TransitionTransferInput;
};


export type MutationTransitionUserArgs = {
  input: TransitionUserInput;
};


export type MutationTransitionUserBulkUpsertItemArgs = {
  input: TransitionUserBulkUpsertItemInput;
};


export type MutationTransitionUserBulkUpsertRequestArgs = {
  input: TransitionUserBulkUpsertRequestInput;
};


export type MutationTransitionUserIdVerificationArgs = {
  input: TransitionUserIdVerificationInput;
};


export type MutationTransitionWorkflowArgs = {
  input: TransitionWorkflowInput;
};


export type MutationTransitionWorkflowCompletionArgs = {
  input: TransitionWorkflowCompletionInput;
};


export type MutationTriggerAutoBulkTradesArgs = {
  input: TriggerAutoBulkTradesInput;
};


export type MutationTriggerModelPortfolioResignArgs = {
  input: TriggerModelPortfolioResignInput;
};


export type MutationTriggerSynchronousIntegrationArgs = {
  input: TriggerSynchronousIntegrationInput;
};


export type MutationUnlinkPhoneMultifactorArgs = {
  userId: Scalars['ObjectID']['input'];
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAccountGroupArgs = {
  input: UpdateAccountGroupInput;
};


export type MutationUpdateAccountStatementArgs = {
  input: UpdateAccountStatementInput;
};


export type MutationUpdateAdvisorContactArgs = {
  input: UpdateAdvisorContactInput;
};


export type MutationUpdateAffiliateArgs = {
  input: UpdateAffiliateInput;
};


export type MutationUpdateAffiliationsArgs = {
  input: UpdateAffiliationsInput;
};


export type MutationUpdateAlertBannerArgs = {
  input: UpdateAlertBannerInput;
};


export type MutationUpdateAllHoldingsAndCashArgs = {
  input: UpdateAllHoldingsAndCashInput;
};


export type MutationUpdateApiTokenArgs = {
  input: UpdateApiTokenInput;
};


export type MutationUpdateArticleArgs = {
  input: UpdateArticleInput;
};


export type MutationUpdateAssetClassArgs = {
  input: UpdateAssetClassInput;
};


export type MutationUpdateBankAccountArgs = {
  input: UpdateBankAccountInput;
};


export type MutationUpdateBeneficiaryArgs = {
  input: UpdateBeneficiaryInput;
};


export type MutationUpdateBillingScheduleArgs = {
  input: UpdateBillingScheduleInput;
};


export type MutationUpdateBulkImportArgs = {
  input: UpdateBulkImportInput;
};


export type MutationUpdateBulkTradeRequestArgs = {
  input: UpdateBulkTradeRequestInput;
};


export type MutationUpdateClientGroupArgs = {
  input: UpdateClientGroupInput;
};


export type MutationUpdateClientGroupOrganizationArgs = {
  input: UpdateClientGroupOrganizationInput;
};


export type MutationUpdateClientGroupPortfolioArgs = {
  input: UpdateClientGroupPortfolioInput;
};


export type MutationUpdateClientReportTemplateArgs = {
  clientReportTemplateId: Scalars['ObjectID']['input'];
  input: UpdateClientReportTemplateInput;
};


export type MutationUpdateClientReportTemplatePageConfigurationArgs = {
  input: UpdateClientReportTemplatePageConfigurationInput;
};


export type MutationUpdateConfigurableTablePageArgs = {
  input: UpdateConfigurableTablePageInput;
};


export type MutationUpdateCountryRiskArgs = {
  input: UpdateCountryRiskInput;
};


export type MutationUpdateCustodianArgs = {
  input: UpdateCustodianInput;
};


export type MutationUpdateCustodianActivityNotesArgs = {
  input: UpdateCustodianActivityNotesInput;
};


export type MutationUpdateCustodianConnectionArgs = {
  input: UpdateCustodianConnectionInput;
};


export type MutationUpdateCustodianCustomFieldsArgs = {
  input: UpdateCustodianCustomFieldsInput;
};


export type MutationUpdateCustomAttributeLabelArgs = {
  input: UpdateCustomAttributeLabelInput;
};


export type MutationUpdateCustomFieldArgs = {
  input: UpdateCustomFieldInput;
};


export type MutationUpdateDisplayRoleArgs = {
  input: UpdateDisplayRoleInput;
};


export type MutationUpdateDowntimeScheduleArgs = {
  input: UpdateDowntimeScheduleInput;
};


export type MutationUpdateEntityFeeArgs = {
  entity: FeeEntityIdentifier;
  input: UpdateEntityFeeInput;
};


export type MutationUpdateEntityFeeSettingArgs = {
  entity: FeeEntityIdentifier;
  input: UpdateEntityFeeInput;
};


export type MutationUpdateExternalProviderArgs = {
  input: UpdateExternalProvidersInput;
};


export type MutationUpdateFeeSettingArgs = {
  input: UpdateFeeSettingInput;
};


export type MutationUpdateFeeTierArgs = {
  input: UpdateFeeTierInput;
};


export type MutationUpdateFileDocumentArgs = {
  input: UpdateFileDocumentInput;
};


export type MutationUpdateFinancialProductArgs = {
  input: UpdateFinancialProductInput;
};


export type MutationUpdateFlagNotesArgs = {
  input: UpdateFlagNotesInput;
};


export type MutationUpdateFormDefinitionArgs = {
  input: UpdateFormDefinitionInput;
};


export type MutationUpdateFormMapArgs = {
  input: UpdateFormMapInput;
};


export type MutationUpdateFormTemplateArgs = {
  input: UpdateFormTemplateInput;
};


export type MutationUpdateFraudRiskArgs = {
  input: UpdateFraudRiskInput;
};


export type MutationUpdateGoalArgs = {
  input: UpdateGoalInput;
};


export type MutationUpdateHomePageConfigurationArgs = {
  input: UpdateHomePageConfigurationInput;
};


export type MutationUpdateImportFileLineItemArgs = {
  input: UpdateImportFileLineItemInput;
};


export type MutationUpdateInstitutionArgs = {
  input: UpdateInstitutionInput;
};


export type MutationUpdateIntegrationArgs = {
  input: UpdateIntegrationInput;
};


export type MutationUpdateIntegrationFormAgreementArgs = {
  input: UpdateIntegrationFormAgreementInput;
};


export type MutationUpdateIntegrationStatefulDataArgs = {
  input: UpdateIntegrationStatefulDataInput;
};


export type MutationUpdateJobTitleRiskArgs = {
  input: UpdateJobTitleRiskInput;
};


export type MutationUpdateLocalizationArgs = {
  localization: LocalizationInput;
  localizationId: Scalars['ObjectID']['input'];
};


export type MutationUpdateModelChangeProposalArgs = {
  input: UpdateModelChangeProposalInput;
};


export type MutationUpdateModelPortfolioArgs = {
  input: UpdateModelPortfolioInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateNotificationDefinitionArgs = {
  input: UpdateNotificationDefinitionInput;
};


export type MutationUpdateNotificationGroupArgs = {
  input: UpdateNotificationGroupInput;
};


export type MutationUpdateOrgFlagPolicyArgs = {
  input: UpdateOrgFlagPolicyInput;
};


export type MutationUpdateOrgReconTolerancePolicyArgs = {
  input: UpdateOrgReconTolerancePolicyInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationDashboardArgs = {
  input: UpdateOrganizationDashboardInput;
};


export type MutationUpdateOrganizationFeatureFlagArgs = {
  input: UpdateOrganizationFeatureFlagInput;
};


export type MutationUpdateOrganizationUserArgs = {
  input: UpdateOrganizationUserInput;
};


export type MutationUpdateOrganizationUserProfileArgs = {
  input: UpdateOrganizationUserProfileInput;
};


export type MutationUpdatePageConfigurationArgs = {
  input: UpdatePageConfigurationInput;
};


export type MutationUpdatePortfolioTemplateArgs = {
  input: UpdatePortfolioTemplateInput;
};


export type MutationUpdatePriceAndQuantityArgs = {
  input: UpdatePriceAndQuantityInput;
};


export type MutationUpdateRepCodeArgs = {
  input: UpdateRepCodeInput;
};


export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateRoleProfileArgs = {
  input: UpdateRoleProfileInput;
};


export type MutationUpdateScheduleArgs = {
  input: UpdateScheduleInput;
};


export type MutationUpdateScheduledIncomeFundTransferArgs = {
  input: UpdateScheduledIncomeFundTransferInput;
};


export type MutationUpdateScheduledTransferArgs = {
  input: UpdateScheduledTransferInput;
};


export type MutationUpdateSiemFeedArgs = {
  input: UpdateSiemFeedInput;
};


export type MutationUpdateSignerTypeArgs = {
  input: UpdateSignerTypeInput;
};


export type MutationUpdateStaticPageWidgetConfigurationArgs = {
  input: UpdateStaticPageWidgetConfigurationInput;
};


export type MutationUpdateSubAccountArgs = {
  input: UpdateSubAccountInput;
};


export type MutationUpdateSubAccountBillingArgs = {
  input: UpdateSubAccountBillingInput;
};


export type MutationUpdateSubTradeRequestArgs = {
  input: UpdateSubTradeRequestInput;
};


export type MutationUpdateSubTradeRequestsArgs = {
  input: UpdateSubTradeRequestsInput;
};


export type MutationUpdateTaxLotArgs = {
  input: UpdateTaxLotInput;
};


export type MutationUpdateThemeArgs = {
  input: UpdateThemeInput;
};


export type MutationUpdateTradeRequestFillsArgs = {
  input: UpdateTradeRequestFillsInput;
};


export type MutationUpdateTransactionArgs = {
  input: UpdateTransactionInput;
  options?: InputMaybe<UpdateTransactionOptionsInput>;
};


export type MutationUpdateTransferArgs = {
  input: UpdateTransferInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserIdVerificationInformationArgs = {
  input: UpdateUserIdVerificationInformationInput;
};


export type MutationUpdateUserOrganizationArgs = {
  input: UpdateUserOrganizationInput;
};


export type MutationUpdateUserOrganizationUserDisplayOptionsArgs = {
  input: UpdateUserOrganizationUserDisplayOptionsInput;
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type MutationUpdateWorkflowArgs = {
  input: UpdateWorkflowInput;
};


export type MutationUpdateWorkflowCompletionArgs = {
  input: UpdateWorkflowCompletionInput;
};


export type MutationUpsertAlertBannerInteractionsArgs = {
  input: UpsertAlertBannerInteractionsInput;
};


export type MutationUpsertBulkTradeRunAllocationFilesArgs = {
  input: UpdateBulkTradeRunAllocationFilesInput;
};


export type MutationUpsertBulkTradeRunBulkTradeFilesArgs = {
  input: UpdateBulkTradeRunBulkTradeFilesInput;
};


export type MutationUpsertOrganizationRoleArgs = {
  input: UpsertOrganizationRoleInput;
};


export type MutationUpsertRepCodeArgs = {
  input: UpsertRepCodeInput;
};


export type MutationVerifySubTradeRequestsArgs = {
  input: VerifySubTradeRequestsInput;
};


export type MutationVerifyUserAndAddToAccountArgs = {
  input: VerifyUserAndAddToAccountInput;
};


export type MutationWithdrawAllFromAccountArgs = {
  input: WithdrawAllAccountInput;
};


export type MutationWithdrawAllFromSubAccountArgs = {
  input: WithdrawAllSubAccountInput;
};

export enum NavigationStyles {
  Full = 'FULL',
  Simple = 'SIMPLE'
}

export type NextSubStepInput = {
  fromKey?: InputMaybe<Scalars['String']['input']>;
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type NextSubStepResponse = {
  __typename?: 'NextSubStepResponse';
  workflowCompletion: WorkflowCompletion;
};

export type NodePosition = {
  __typename?: 'NodePosition';
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type NodePositionInput = {
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

/** Note type */
export type Note = {
  __typename?: 'Note';
  /** OrganizationUser is the author of the note */
  author: PublicOrganizationUser;
  content?: Maybe<Scalars['String']['output']>;
  /** The date and time this Note was created */
  createdAt: Scalars['GraphQLDateTime']['output'];
  /** NoteId */
  id: Scalars['ObjectID']['output'];
  /** User is the designated note user */
  objectId: Scalars['ObjectID']['output'];
  /** NoteObjectTypes derived from the ENUM */
  objectType: NoteObjectTypes;
  /** Organization of the notes creator */
  organization: PublicOrganization;
  /** NoteStates derived from the ENUM */
  state: NoteStates;
  /** NoteTypes derived from the ENUM */
  type: NoteTypes;
  /** The date and time this Note's information was last updated */
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

/** Note Types */
export enum NoteObjectTypes {
  ClientGroup = 'CLIENT_GROUP',
  User = 'USER'
}

/** Input fields options to manage pagination and sorting for note Object */
export type NotePaginationAndSorting = {
  /**
   * The number of records to skip per page from the
   * beginning of the elements per page
   */
  offSet?: InputMaybe<Scalars['Int']['input']>;
  /** Elements per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** To sort in descending order or not */
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  /** To sort the list by the fields for the note Object */
  sortField?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for filtering Notes */
export type NoteQueryFilter = {
  /** One Id of an object of given type, see objectType */
  objectId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** A list of Id's of the objects of given type, see objectType */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  /** noteObjectType for filter notes */
  objectType?: InputMaybe<NoteObjectTypes>;
  /** organizationId for filter clientGroups */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** state of the Note */
  state?: InputMaybe<NoteStates>;
  /** type of the note */
  type?: InputMaybe<NoteTypes>;
};

export enum NoteStates {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum NoteTransition {
  Delete = 'delete',
  Publish = 'publish'
}

export enum NoteTypes {
  Organizational = 'ORGANIZATIONAL',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Notification = {
  __typename?: 'Notification';
  body: NotificationTranslatedString;
  createdAt: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<NotificationIntegration>>>;
  link?: Maybe<Scalars['SafeString']['output']>;
  linkText?: Maybe<NotificationTranslatedString>;
  notificationChannels: Array<NotificationChannel>;
  notificationGroup: NotificationGroup;
  organizationUser: OrganizationUser;
  read: Scalars['Boolean']['output'];
  title: NotificationTranslatedString;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type NotificationChannel = {
  __typename?: 'NotificationChannel';
  allowEditByClient?: Maybe<Scalars['Boolean']['output']>;
  setDefaultState?: Maybe<Scalars['Boolean']['output']>;
  type: NotificationChannelType;
  value: Scalars['Boolean']['output'];
};

export type NotificationChannelInput = {
  allowEditByClient?: InputMaybe<Scalars['Boolean']['input']>;
  setDefaultState?: InputMaybe<Scalars['Boolean']['input']>;
  type: NotificationChannelType;
  value: Scalars['Boolean']['input'];
};

export enum NotificationChannelType {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Push = 'PUSH',
  Webhook = 'WEBHOOK'
}

export type NotificationDefinition = {
  __typename?: 'NotificationDefinition';
  bodyTemplate: NotificationTranslatedString;
  createdAt: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  linkTemplate?: Maybe<Scalars['SafeString']['output']>;
  linkText?: Maybe<NotificationTranslatedString>;
  name: Scalars['SafeString']['output'];
  notificationChannels: Array<NotificationChannel>;
  notificationGroup: NotificationGroup;
  organization: PublicOrganization;
  organizationOnly?: Maybe<Scalars['Boolean']['output']>;
  roleProfiles: Array<PublicRoleProfile>;
  titleTemplate: NotificationTranslatedString;
  triggerEventType?: Maybe<Scalars['SafeString']['output']>;
  triggerObjectType?: Maybe<TriggerObjectTypes>;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type NotificationDefinitionPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationDefinitionQueryFilter = {
  notificationChannelTypes?: InputMaybe<Array<InputMaybe<NotificationChannelType>>>;
  notificationGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type NotificationGroup = {
  __typename?: 'NotificationGroup';
  description?: Maybe<NotificationTranslatedString>;
  id: Scalars['ObjectID']['output'];
  name: NotificationTranslatedString;
  notificationChannels: Array<NotificationChannel>;
};

export type NotificationGroupPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationGroupQueryFilter = {
  notificationChannelTypes?: InputMaybe<Array<InputMaybe<NotificationChannelType>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type NotificationIntegration = {
  __typename?: 'NotificationIntegration';
  externalId: Scalars['String']['output'];
  iid: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NotificationIntegrationInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  iid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  enableEmail?: Maybe<Scalars['Boolean']['output']>;
  enableInApp?: Maybe<Scalars['Boolean']['output']>;
  enablePush?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationPreferenceInput = {
  enableEmail?: InputMaybe<Scalars['Boolean']['input']>;
  enableInApp?: InputMaybe<Scalars['Boolean']['input']>;
  enablePush?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationQueryFilter = {
  externalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  integrationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  notificationChannelTypes?: InputMaybe<Array<InputMaybe<NotificationChannelType>>>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationTranslatedString = {
  __typename?: 'NotificationTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type NotificationTranslatedStringInput = {
  en?: InputMaybe<Scalars['SafeString']['input']>;
  es?: InputMaybe<Scalars['SafeString']['input']>;
  fr?: InputMaybe<Scalars['SafeString']['input']>;
};

export enum ObjectTypes {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  Individual = 'INDIVIDUAL',
  NonIndividual = 'NON_INDIVIDUAL',
  SubAccount = 'SUB_ACCOUNT'
}

export type OptimalHolding = {
  __typename?: 'OptimalHolding';
  expectedValueCents: Scalars['Float']['output'];
  financialProduct: Scalars['ObjectID']['output'];
  index: Scalars['Int']['output'];
  taxRank: Scalars['Int']['output'];
  valueCents: Scalars['Float']['output'];
};

export type OptimalPortfolio = {
  __typename?: 'OptimalPortfolio';
  expectedCashCents: Scalars['Float']['output'];
  expectedCashPercentage: Scalars['Float']['output'];
  id: Scalars['ObjectID']['output'];
  lastOptimizedBy?: Maybe<Scalars['ObjectID']['output']>;
  modelPortfolio: Scalars['ObjectID']['output'];
  modelPortfolioType: ModelPortfolioTypes;
  optimalHoldings: Array<OptimalHolding>;
  optimizerRun?: Maybe<Scalars['ObjectID']['output']>;
  preTradeHoldings: Array<PreTradeHolding>;
  subAccounts: Array<OptimalSubAccount>;
};

export type OptimalSubAccount = {
  __typename?: 'OptimalSubAccount';
  account: Scalars['ObjectID']['output'];
  cashCentsDeviation: Scalars['Float']['output'];
  cashCentsToInvest: Scalars['Float']['output'];
  currentHoldingAllocations: Array<Scalars['Float']['output']>;
  currentHoldingQuantities: Array<Scalars['Float']['output']>;
  expectedCashCents: Scalars['Float']['output'];
  goal: Scalars['ObjectID']['output'];
  index: Scalars['Int']['output'];
  marketValueCents: Scalars['Float']['output'];
  optimalHoldings: Array<OptimalHolding>;
  preTradeHoldingAllocations: Array<Scalars['Float']['output']>;
  preTradeHoldingPurchaseAllocations: Array<Scalars['Float']['output']>;
  subAccount: Scalars['ObjectID']['output'];
  taxRank: Scalars['Int']['output'];
  taxable: Scalars['Boolean']['output'];
  user: Scalars['ObjectID']['output'];
};

export type OptimizerAuditV2 = {
  __typename?: 'OptimizerAuditV2';
  decisions?: Maybe<Array<OptimizerAuditV2DecisionRecord>>;
  durationMs?: Maybe<Scalars['Float']['output']>;
  effectiveRebalanceMode?: Maybe<RebalanceModeV2>;
  id: Scalars['ObjectID']['output'];
  optimizerRun: Scalars['ObjectID']['output'];
  passed?: Maybe<Scalars['Boolean']['output']>;
  portfolioReportId?: Maybe<Scalars['ObjectID']['output']>;
  rebalanceMode?: Maybe<RebalanceModeV2>;
  solver?: Maybe<OptimizerAuditV2SolverSnapshot>;
  subAccountResults?: Maybe<Array<OptimizerAuditV2SubAccountResult>>;
  targetWeights?: Maybe<Array<OptimizerAuditV2TargetWeight>>;
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export enum OptimizerAuditV2DecisionImpact {
  Blocking = 'BLOCKING',
  Material = 'MATERIAL',
  Minor = 'MINOR',
  None = 'NONE'
}

export type OptimizerAuditV2DecisionRecord = {
  __typename?: 'OptimizerAuditV2DecisionRecord';
  action: Scalars['String']['output'];
  financialProductId?: Maybe<Scalars['ObjectID']['output']>;
  impact?: Maybe<OptimizerAuditV2DecisionImpact>;
  stage: OptimizerAuditV2DecisionStage;
  subAccountId?: Maybe<Scalars['ObjectID']['output']>;
};

export enum OptimizerAuditV2DecisionStage {
  ConstraintCompile = 'CONSTRAINT_COMPILE',
  Covariance = 'COVARIANCE',
  FundingSegregation = 'FUNDING_SEGREGATION',
  FxCost = 'FX_COST',
  FxDetection = 'FX_DETECTION',
  HarvestScan = 'HARVEST_SCAN',
  InvariantCheck = 'INVARIANT_CHECK',
  Liquidation = 'LIQUIDATION',
  QpSolve = 'QP_SOLVE',
  RebalanceMode = 'REBALANCE_MODE',
  ReturnsFetch = 'RETURNS_FETCH',
  Rounding = 'ROUNDING',
  SwitchDetection = 'SWITCH_DETECTION',
  TaxLocation = 'TAX_LOCATION',
  TaxLotSelection = 'TAX_LOT_SELECTION',
  TradeGeneration = 'TRADE_GENERATION',
  TransactionCost = 'TRANSACTION_COST',
  Turnover = 'TURNOVER',
  Validation = 'VALIDATION',
  WashSaleCheck = 'WASH_SALE_CHECK'
}

export type OptimizerAuditV2SolverSnapshot = {
  __typename?: 'OptimizerAuditV2SolverSnapshot';
  durationMs?: Maybe<Scalars['Float']['output']>;
  iterations?: Maybe<Scalars['Int']['output']>;
  objectiveValue?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type OptimizerAuditV2SubAccountResult = {
  __typename?: 'OptimizerAuditV2SubAccountResult';
  accountType?: Maybe<Scalars['String']['output']>;
  inputCashCents?: Maybe<Scalars['Float']['output']>;
  inputMarketValueCents?: Maybe<Scalars['Float']['output']>;
  netCashImpactCents?: Maybe<Scalars['Float']['output']>;
  subAccountId: Scalars['ObjectID']['output'];
  totalBuyCents?: Maybe<Scalars['Float']['output']>;
  totalSellCents?: Maybe<Scalars['Float']['output']>;
  tradeCount?: Maybe<Scalars['Int']['output']>;
  weightDiffs?: Maybe<Array<OptimizerAuditV2WeightDiff>>;
};

export type OptimizerAuditV2TargetWeight = {
  __typename?: 'OptimizerAuditV2TargetWeight';
  financialProductId: Scalars['ObjectID']['output'];
  targetWeight: Scalars['Float']['output'];
};

export type OptimizerAuditV2WeightDiff = {
  __typename?: 'OptimizerAuditV2WeightDiff';
  currentWeight: Scalars['Float']['output'];
  deltaCents?: Maybe<Scalars['Float']['output']>;
  deltaWeight: Scalars['Float']['output'];
  financialProductId: Scalars['ObjectID']['output'];
  inputAdjustedCostBaseCents?: Maybe<Scalars['Float']['output']>;
  inputPositionValueCents?: Maybe<Scalars['Float']['output']>;
  inputQuantity?: Maybe<Scalars['Float']['output']>;
  proposedWeight: Scalars['Float']['output'];
};

export type OptimizerRunV2 = {
  __typename?: 'OptimizerRunV2';
  createdAt: Scalars['GraphQLDateTime']['output'];
  createdBy?: Maybe<PublicOrganizationUser>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  mode: OptimizerRunV2Mode;
  organization?: Maybe<PublicOrganization>;
  portfolioSummary?: Maybe<OptimizerRunV2PortfolioSummary>;
  preset: OptimizerV2Preset;
  solverVersion: Scalars['String']['output'];
  state: OptimizerRunV2State;
  type: OptimizerRunV2Type;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export enum OptimizerRunV2Mode {
  DryRun = 'DRY_RUN',
  Live = 'LIVE'
}

export type OptimizerRunV2PortfolioSummary = {
  __typename?: 'OptimizerRunV2PortfolioSummary';
  failed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  succeeded: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OptimizerRunV2QueryFilter = {
  createdAt?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  mode?: InputMaybe<OptimizerRunV2Mode>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  preset?: InputMaybe<OptimizerV2Preset>;
  state?: InputMaybe<OptimizerRunV2State>;
  type?: InputMaybe<OptimizerRunV2Type>;
};

export enum OptimizerRunV2State {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Optimizing = 'OPTIMIZING',
  Publishing = 'PUBLISHING',
  Validating = 'VALIDATING'
}

export enum OptimizerRunV2Type {
  AllEligible = 'ALL_ELIGIBLE',
  Drift = 'DRIFT',
  Transfer = 'TRANSFER'
}

export enum OptimizerV2Preset {
  RiskAware = 'RISK_AWARE',
  V1Compatible = 'V1_COMPATIBLE'
}

export enum OrgBulkTradingProcesses {
  Bucket = 'BUCKET',
  Pair = 'PAIR'
}

export enum OrgOptimizerProcesses {
  PortfolioOptimizerV1 = 'PORTFOLIO_OPTIMIZER_V1',
  PortfolioOptimizerV2 = 'PORTFOLIO_OPTIMIZER_V2'
}

export enum OrgSubAccountTradingProcesses {
  InheritedFromParent = 'INHERITED_FROM_PARENT',
  NoAutomation = 'NO_AUTOMATION',
  PortfolioOptimizer = 'PORTFOLIO_OPTIMIZER',
  RebalanceV1 = 'REBALANCE_V1',
  RebalanceV2 = 'REBALANCE_V2'
}

export type Organization = {
  __typename?: 'Organization';
  accountGroupAutoArchiveCustomFieldKey?: Maybe<Scalars['String']['output']>;
  accountGroupAutoArchiveEnabled?: Maybe<Scalars['Boolean']['output']>;
  accountTypeTaxRanks?: Maybe<Array<Maybe<AccountTypeTaxRank>>>;
  additionalAutoReconciliationTransactionTypes?: Maybe<Array<Maybe<AutoReconciliationTransactionType>>>;
  allowAccessToSubOrganizations?: Maybe<Scalars['Boolean']['output']>;
  allowChargePST?: Maybe<Scalars['Boolean']['output']>;
  allowDirectCommunication?: Maybe<Scalars['Boolean']['output']>;
  allowInactiveUserAdjustments?: Maybe<Scalars['Boolean']['output']>;
  allowInactiveUserFeeCalculation?: Maybe<Scalars['Boolean']['output']>;
  allowInactiveUserRebalancing?: Maybe<Scalars['Boolean']['output']>;
  allowInstantInvest?: Maybe<Scalars['Boolean']['output']>;
  allowLogout?: Maybe<Scalars['Boolean']['output']>;
  allowPendingTransactions?: Maybe<Scalars['Boolean']['output']>;
  allowPortfolioPerGoal?: Maybe<Scalars['Boolean']['output']>;
  allowPortfolioPerHousehold?: Maybe<Scalars['Boolean']['output']>;
  allowPostOptimizationEditing?: Maybe<Scalars['Boolean']['output']>;
  allowViewSubTradeRequestPairs?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Analytics identifier for tracking organizations across parent and sub-orgs.
   * If not set, it will inherit from parent organizations up the tree.
   */
  analyticsIdentifier?: Maybe<Scalars['String']['output']>;
  /** Applicable analytics identifier (this org or inherited from parent orgs up the tree) */
  applicableAnalyticsIdentifier?: Maybe<Scalars['String']['output']>;
  /** Applicable list of jurisdictions (may be inherited from parent orgs). */
  applicableJurisdictions?: Maybe<EnabledJurisdictions>;
  /** Applicable localization settings (this org or inherited from parent orgs) */
  applicableLocalization?: Maybe<Localization>;
  auth0DisplayName?: Maybe<Scalars['String']['output']>;
  authenticationDomains?: Maybe<Array<Maybe<OrganizationAuthenticationDomain>>>;
  /** When true, imported users will be automatically invited to the platform */
  autoInviteImportedUsers?: Maybe<Scalars['Boolean']['output']>;
  autoLogoutAfterInactivity?: Maybe<Scalars['Boolean']['output']>;
  availableFeatureFlags: Array<FeatureFlagTypes>;
  baseCurrency?: Maybe<CurrencyCodes>;
  blockSuspiciousTransactions?: Maybe<Scalars['Boolean']['output']>;
  /** The browserTabTitle of the organization used as website title */
  browserTabTitle?: Maybe<Scalars['String']['output']>;
  bulkTradingProcess?: Maybe<OrgBulkTradingProcesses>;
  cancelTransferCutoffDays?: Maybe<Scalars['Int']['output']>;
  cashOnHoldToTradeDays?: Maybe<Scalars['Int']['output']>;
  cashOnHoldToWithdrawDays?: Maybe<Scalars['Int']['output']>;
  /** All children directly related to the organization */
  children: Array<Organization>;
  /** Client Host Login ClientId */
  clientHostedLoginClientId?: Maybe<Scalars['String']['output']>;
  /** Client Hosted Login Redirect URL */
  clientHostedLoginRedirectUri?: Maybe<Scalars['String']['output']>;
  /** Client Hosted Login Scope */
  clientHostedLoginScope?: Maybe<Scalars['String']['output']>;
  /** Client Host Login URL to generate token */
  clientHostedLoginURL?: Maybe<Scalars['String']['output']>;
  custodian: Custodian;
  /** List of active custom attribute labels for this organization (includes inherited from parent if enabled) */
  customAttributeLabels: Array<CustomAttributeLabel>;
  customUrl?: Maybe<Scalars['String']['output']>;
  databaseAuthConnectionId?: Maybe<Scalars['String']['output']>;
  databaseAuthConnectionName?: Maybe<Scalars['String']['output']>;
  defaultAccountTypeTaxRanks?: Maybe<Array<Maybe<AccountTypeTaxRank>>>;
  defaultAdvisorRole?: Maybe<Role>;
  defaultAuthenticationConnection?: Maybe<AuthenticationConnections>;
  /** @deprecated Use feeSetting.defaultBillingSchedule instead */
  defaultBillingSchedule?: Maybe<BillingSchedule>;
  defaultClientRole?: Maybe<Role>;
  defaultCustodianConnection?: Maybe<CustodianConnection>;
  defaultDriftCalculationMethod?: Maybe<DriftCalculationMethod>;
  defaultDriftTolerancePercent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use feeSetting.defaultFeeTier instead */
  defaultFeeTier?: Maybe<FeeTier>;
  defaultSignUpRole?: Maybe<Role>;
  defaultTradingProcess?: Maybe<OrgSubAccountTradingProcesses>;
  disableRebalanceReport?: Maybe<Scalars['Boolean']['output']>;
  disableStatsUpdateBasedOnTransactions?: Maybe<Scalars['Boolean']['output']>;
  displayCurrency?: Maybe<Scalars['Boolean']['output']>;
  displayMenuBar?: Maybe<Scalars['Boolean']['output']>;
  /**
   * When the last drift policy change for this organization was dealt with, whether it
   * was recalculated or skipped. RECALCULATING is a window a client can poll
   * straight past, so a client waits for this to advance past the value it
   * read before its own edit rather than trying to catch the window.
   */
  driftRecalculationSettledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * What settling the last change meant. RECALCULATED when portfolios were
   * re-screened, NOTHING_TO_RECALCULATE when the change needed no run at all.
   * Null until this organization has settled a change.
   */
  driftRecalculationSettledOutcome?: Maybe<DriftRecalculationOutcomes>;
  /**
   * Timestamp when the current RECALCULATING window started. Null when
   * the org is IDLE. Used by clients to detect stale locks (>30 min) and
   * by ops to investigate stuck recalcs.
   */
  driftRecalculationStartedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Current state of the per-org drift-tolerance recalculation pipeline.
   * Owned by holding-service (OVT-5610). IDLE is the steady state; the
   * backend transitions to RECALCULATING when defaultDriftTolerancePercent
   * changes via org-service. Falls back to IDLE for organizations that
   * pre-date the feature.
   */
  driftRecalculationState: DriftRecalculationStates;
  effectiveFlagPolicies: Array<EffectiveFlagPolicy>;
  /** One row per break type: this org's, else the closest ancestor's, else the platform default (disabled, 0/0). */
  effectiveReconTolerancePolicies: Array<EffectiveReconTolerancePolicy>;
  embeddedExperienceLogoUrl?: Maybe<Scalars['String']['output']>;
  enableAllInKindTransfers?: Maybe<Scalars['Boolean']['output']>;
  enableAutoUpdateExchangeRates?: Maybe<Scalars['Boolean']['output']>;
  enableContactSupport?: Maybe<Scalars['Boolean']['output']>;
  enableEmailFrenchTranslation?: Maybe<Scalars['Boolean']['output']>;
  enableFullCashTransfers?: Maybe<Scalars['Boolean']['output']>;
  enableInactivityTimeOut?: Maybe<Scalars['Boolean']['output']>;
  enableLoginSettings?: Maybe<Scalars['Boolean']['output']>;
  enableManualUpdateExchangeRates?: Maybe<Scalars['Boolean']['output']>;
  enableMultiFactorAuthentication?: Maybe<Scalars['Boolean']['output']>;
  enablePartialCashTransfers?: Maybe<Scalars['Boolean']['output']>;
  enableRemeberBrowser?: Maybe<Scalars['Boolean']['output']>;
  enableResourcesAndArticles?: Maybe<Scalars['Boolean']['output']>;
  enableSingleLogout?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated entityName is deprecated, use translatedEntityName instead */
  entityName?: Maybe<Scalars['SafeString']['output']>;
  errorPageBackgroundColor?: Maybe<Scalars['String']['output']>;
  errorPageBackgroundImage?: Maybe<Scalars['String']['output']>;
  errorPageButtonText?: Maybe<OrganizationTranslatedString>;
  errorPageDescription?: Maybe<OrganizationTranslatedString>;
  errorPageMessage?: Maybe<OrganizationTranslatedString>;
  errorPageShowNavbar?: Maybe<Scalars['Boolean']['output']>;
  excludeAdminFeesFromClients?: Maybe<Scalars['Boolean']['output']>;
  externalClientTokenEmailKey?: Maybe<Scalars['SafeString']['output']>;
  externalClientTokenIntegrationIdKey?: Maybe<Scalars['SafeString']['output']>;
  externalProvider?: Maybe<ExternalProvider>;
  /** The faviconLink of the organization will display on the browser tab */
  faviconLink?: Maybe<Scalars['String']['output']>;
  feeSetting?: Maybe<FeeSetting>;
  fetchCurrentPricesOnDemand?: Maybe<Scalars['Boolean']['output']>;
  flagAmountThresholds: Array<FlagAmountThreshold>;
  flagTypePolicies: Array<FlagTypePolicy>;
  /** @deprecated helpCentreUrl is deprecated, use translatedHelpCentreUrl instead */
  helpCentreUrl?: Maybe<Scalars['String']['output']>;
  hideAutoUpdatePrices?: Maybe<Scalars['Boolean']['output']>;
  historicalSnapshotsCutOffDate?: Maybe<Scalars['GraphQLDate']['output']>;
  /** Frequency at which historical snapshots are taken for this organization */
  historicalSnapshotsFrequency?: Maybe<HistoricalSnapshotsFrequency>;
  id: Scalars['ObjectID']['output'];
  inactivityTimeoutInMinutes?: Maybe<Scalars['Int']['output']>;
  includeExternalClientTokenIntoContext?: Maybe<Scalars['Boolean']['output']>;
  integrations?: Maybe<Array<OrganizationIntegration>>;
  /**
   * URL the user is redirected to after signing up in Auth0.
   * When allowAccessToSubOrganizations is enabled, sub-organizations inherit this URL
   * through fetchOrganizationPublicSettings unless they set their own.
   */
  invitationRedirectUrl?: Maybe<Scalars['String']['output']>;
  isReferral?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This organization's enabled jurisdictions settings.
   * If unset (=null), then inheritance apply.
   */
  jurisdictions?: Maybe<EnabledJurisdictions>;
  /** JWK url used to validate the partner-authorization token sent for M2M token exchange (used when tokenExchangeValidationType is JWK) */
  jwtKeyUrl?: Maybe<Scalars['String']['output']>;
  /** This organization's localization settings (countries, languages, currencies, date format) */
  localization?: Maybe<Localization>;
  loginSettingsTitle?: Maybe<OrganizationTranslatedString>;
  loginUrl?: Maybe<Scalars['String']['output']>;
  logoutRedirectUrl?: Maybe<Scalars['String']['output']>;
  logs: LogsResponse;
  /**
   * Threshold (as a decimal, e.g. 0.15 = 15%) for flagging day-over-day market value changes
   * during snapshot reconciliation. Clamped to a 5% minimum floor in the backend.
   */
  marketValueDipThresholdPercentage?: Maybe<Scalars['Float']['output']>;
  minDepositCents?: Maybe<Scalars['Int']['output']>;
  minInitialDepositCents: Scalars['Int']['output'];
  /** Minimum amount needed to invest */
  minInvestAmountCents: Scalars['Int']['output'];
  minRecurringDepositCents?: Maybe<Scalars['Int']['output']>;
  multiFactorAuthenticationOptions?: Maybe<Array<Maybe<MultiFactorAuthenticationOptions>>>;
  /**
   * The name of the organization
   * @deprecated name is deprecated, use translatedName instead
   */
  name?: Maybe<Scalars['String']['output']>;
  optimizerProcess?: Maybe<OrgOptimizerProcesses>;
  /** The parent organization */
  parent?: Maybe<Organization>;
  /** All parent organizations */
  parents: Array<Organization>;
  /**
   * True when a recalculation is queued but not yet running — it lost the
   * acquire race, was requested mid-run, or a run exited with work still
   * outstanding. Distinct from IDLE, which means nothing is outstanding.
   */
  pendingDriftRecalc: Scalars['Boolean']['output'];
  /** Indicates whether there are users that have not been invited yet or with an expired invitation */
  pendingInvitationsCount?: Maybe<Scalars['Int']['output']>;
  /** List of permissions that the organization has access to */
  permissions: Array<Scalars['String']['output']>;
  productShelfCurrencies?: Maybe<Array<Maybe<CurrencyCodes>>>;
  profileReviewTimeInMonths?: Maybe<Scalars['Int']['output']>;
  /** The parent organization with limited attributes that is accessible from sub-organizations. */
  publicParent?: Maybe<PublicOrganization>;
  /**
   * All parent organizations with public information only, going up the full inheritance chain to the top level.
   * This field is not filtered by user permissions and always returns the complete parent lineage.
   */
  publicParents: Array<PublicOrganization>;
  /** This org's own rows only, no inheritance. See effectiveReconTolerancePolicies for what the reconciler applies. */
  reconTolerancePolicies: Array<ReconTolerancePolicy>;
  /** Custodian representative code */
  repCode?: Maybe<Scalars['String']['output']>;
  requireFeeApproval?: Maybe<Scalars['Boolean']['output']>;
  requireManualAccountApproval?: Maybe<Scalars['Boolean']['output']>;
  requireSubTradeRequestApproval?: Maybe<Scalars['Boolean']['output']>;
  reviewTransactions?: Maybe<Scalars['Boolean']['output']>;
  /** The subdomain of the organization used for logging in */
  subdomain: Scalars['String']['output'];
  /** @deprecated supportUrl is deprecated, use translatedSupportUrl instead */
  supportUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated termsAndConditionsUrl is deprecated, use translatedTermsAndConditionsUrl instead */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<OrganizationTheme>;
  themeTokens?: Maybe<Scalars['Object']['output']>;
  tokenExchangeValidationType?: Maybe<TokenExchangeValidationTypes>;
  /**
   * Translated legal/entity name of the organization.
   * If not set, it will inherit from parent organizations up the tree.
   */
  translatedEntityName?: Maybe<OrganizationTranslatedString>;
  translatedHelpCentreUrl?: Maybe<OrganizationTranslatedString>;
  /** The translated name of the organization */
  translatedName?: Maybe<OrganizationTranslatedString>;
  translatedSupportUrl?: Maybe<OrganizationTranslatedString>;
  translatedTermsAndConditionsUrl?: Maybe<OrganizationTranslatedString>;
  /** @deprecated no longer using a separate Client Auth0 */
  useClientOrgAuth0?: Maybe<Scalars['Boolean']['output']>;
  useParentAdvisorContacts: Scalars['Boolean']['output'];
  useParentAlertBanners: Scalars['Boolean']['output'];
  useParentArticles?: Maybe<Scalars['Boolean']['output']>;
  useParentAssetClasses: Scalars['Boolean']['output'];
  useParentBillingSchedules: Scalars['Boolean']['output'];
  useParentClientReportTemplates: Scalars['Boolean']['output'];
  useParentConfigurableTablePages?: Maybe<Scalars['Boolean']['output']>;
  useParentCustodianConnections: Scalars['Boolean']['output'];
  useParentCustomAttributeLabels?: Maybe<Scalars['Boolean']['output']>;
  useParentCustomFields?: Maybe<Scalars['Boolean']['output']>;
  /** Inherit parent organizations dashboards */
  useParentDashboards?: Maybe<Scalars['Boolean']['output']>;
  useParentDisplayRoles: Scalars['Boolean']['output'];
  useParentDowntimeSchedule?: Maybe<Scalars['Boolean']['output']>;
  useParentFeeTiers: Scalars['Boolean']['output'];
  useParentFormDefinitions: Scalars['Boolean']['output'];
  /** Inherit parent organizations form templates */
  useParentFormTemplates?: Maybe<Scalars['Boolean']['output']>;
  useParentHomePageConfigurations: Scalars['Boolean']['output'];
  useParentIntegrations?: Maybe<Scalars['Boolean']['output']>;
  useParentLocalizations?: Maybe<Scalars['Boolean']['output']>;
  useParentModelPortfolios: Scalars['Boolean']['output'];
  useParentNotificationDefinitions: Scalars['Boolean']['output'];
  useParentNotificationGroups: Scalars['Boolean']['output'];
  useParentPageConfigurations: Scalars['Boolean']['output'];
  useParentPortfolioTemplates: Scalars['Boolean']['output'];
  useParentProductShelf: Scalars['Boolean']['output'];
  useParentRepCodes: Scalars['Boolean']['output'];
  useParentRoleProfiles: Scalars['Boolean']['output'];
  useParentSalesTaxConfiguration?: Maybe<Scalars['Boolean']['output']>;
  useParentSchedules: Scalars['Boolean']['output'];
  useParentSignerTypes: Scalars['Boolean']['output'];
  useParentStaticPageWidgetConfigurations: Scalars['Boolean']['output'];
  useParentThemeTokens?: Maybe<Scalars['Boolean']['output']>;
  useParentThemes: Scalars['Boolean']['output'];
  useParentWebhooks?: Maybe<Scalars['Boolean']['output']>;
  useParentWorkflows: Scalars['Boolean']['output'];
  validateUniquenessForSubOrganizations?: Maybe<Scalars['Boolean']['output']>;
};


export type OrganizationLogsArgs = {
  input?: InputMaybe<OrganizationLogsInput>;
};

export type OrganizationAuthenticationDomain = {
  __typename?: 'OrganizationAuthenticationDomain';
  /** Specific Authentication option used by this domain */
  authenticationType?: Maybe<AuthenticationConnections>;
  /** Specific Enterprise connection used by this domain */
  enterpriseConnectionName?: Maybe<Scalars['String']['output']>;
  /** Identify what the URL should use to redirect on logout */
  logoutUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  /** Identify whether this domain should use the Hosted Login solution */
  useHostedLogin?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationAuthenticationDomainInput = {
  /** Specific Authentication option based on the custom URL */
  authenticationType: AuthenticationConnections;
  /** Specific Enterprise connection based on the custom URL */
  enterpriseConnectionName?: InputMaybe<Scalars['String']['input']>;
  /** Identify what the URL should use to redirect on logout */
  logoutUrl?: InputMaybe<Scalars['String']['input']>;
  /** This URL may rely on the CNAME value in our host settings. In this case, mapping needs to be previously done by the CloudOps team. */
  url: Scalars['String']['input'];
  /** Identify whether the customUrl should use the Hosted Login solution */
  useHostedLogin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationAuthenticationTheme = {
  __typename?: 'OrganizationAuthenticationTheme';
  logo?: Maybe<Scalars['String']['output']>;
  pageBackgroundColor?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAuthenticationThemeInput = {
  logo?: InputMaybe<Scalars['SafeString']['input']>;
  pageBackgroundColor?: InputMaybe<Scalars['SafeString']['input']>;
  primaryColor?: InputMaybe<Scalars['SafeString']['input']>;
};

export type OrganizationBulkUpsertItem = {
  __typename?: 'OrganizationBulkUpsertItem';
  batchId?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertIntegration?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertRequest?: Maybe<BulkUpsertRequest>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<OrganizationIntegration>>>;
  oneVestId?: Maybe<Scalars['ObjectID']['output']>;
  outputErrors?: Maybe<Array<Maybe<OrganizationBulkUpsertItemOutputError>>>;
  rawData?: Maybe<Scalars['Object']['output']>;
  state?: Maybe<OrganizationBulkUpsertItemStates>;
};

export type OrganizationBulkUpsertItemOutputError = {
  __typename?: 'OrganizationBulkUpsertItemOutputError';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
};

export type OrganizationBulkUpsertItemQueryFilter = {
  batchId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertIntegrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  oneVestId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<OrganizationBulkUpsertItemStates>;
};

export enum OrganizationBulkUpsertItemStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Queued = 'QUEUED'
}

export enum OrganizationBulkUpsertItemTransition {
  Fail = 'fail',
  Process = 'process',
  Retry = 'retry'
}

export enum OrganizationBulkUpsertRequestTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  PartiallyFail = 'partiallyFail',
  Process = 'process'
}

export enum OrganizationConditionCustomFieldType {
  AccountTypes = 'accountTypes',
  Boolean = 'boolean',
  Date = 'date',
  Jurisdiction = 'jurisdiction',
  MultiSelect = 'multiSelect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

export enum OrganizationConditionObjectType {
  Account = 'ACCOUNT',
  ClientGroup = 'CLIENT_GROUP',
  Goal = 'GOAL',
  SubAccount = 'SUB_ACCOUNT',
  Transfer = 'TRANSFER',
  User = 'USER'
}

/** Represents a resource that can be managed as part of an extension. */
export type OrganizationExtensionResource = {
  /** A unique key identifying the extension this resource belongs to. */
  extensionKey?: Maybe<Scalars['String']['output']>;
  /** The version of the extension when this resource was installed. */
  extensionVersion?: Maybe<Scalars['String']['output']>;
  /** A unique key for the resource within the scope of the extension. */
  resourceKey?: Maybe<Scalars['String']['output']>;
};

export type OrganizationFeatureFlag = {
  __typename?: 'OrganizationFeatureFlag';
  featureFlags: Array<FeatureFlagOption>;
  id: Scalars['ObjectID']['output'];
};

export enum OrganizationInitiator {
  ApiToken = 'API_TOKEN',
  OrganizationUser = 'ORGANIZATION_USER',
  System = 'SYSTEM'
}

/** The integration enum and unique integration id  */
export type OrganizationIntegration = {
  __typename?: 'OrganizationIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<OrganizationIntegrationTypes>;
};

/** Input type for integrations field */
export type OrganizationIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<OrganizationIntegrationTypes>;
};

/** Integrations for Organization */
export enum OrganizationIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export type OrganizationLogsInput = {
  filter?: InputMaybe<OrganizationLogsQueryFilter>;
  pagination?: InputMaybe<PaginationAndSorting>;
};

export type OrganizationLogsQueryFilter = {
  after?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  before?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type OrganizationPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationQueryFilter = {
  /** Organization ID that you would to filter to only organizations under */
  childrenFor?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Text used to search the names of the organizations */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganizationRuleGroupCombinator {
  And = 'and',
  Or = 'or'
}

export enum OrganizationRuleGroupOperator {
  Contains = 'contains',
  EndsWith = 'endsWith',
  Equals = 'equals',
  Exists = 'exists',
  GreaterThan = 'greaterThan',
  GreaterThanOrEquals = 'greaterThanOrEquals',
  In = 'in',
  Includes = 'includes',
  IsAfter = 'isAfter',
  IsBefore = 'isBefore',
  IsEmpty = 'isEmpty',
  IsFalse = 'isFalse',
  IsNotEmpty = 'isNotEmpty',
  IsTrue = 'isTrue',
  LessThan = 'lessThan',
  LessThanOrEquals = 'lessThanOrEquals',
  NotContains = 'notContains',
  NotEquals = 'notEquals',
  NotExist = 'notExist',
  NotIn = 'notIn',
  NotIncludes = 'notIncludes',
  StartsWith = 'startsWith'
}

export type OrganizationTheme = {
  __typename?: 'OrganizationTheme';
  authenticationTheme?: Maybe<OrganizationAuthenticationTheme>;
  embeddedExperienceTheme?: Maybe<Scalars['Object']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  sideBarColor?: Maybe<Scalars['String']['output']>;
};

export type OrganizationThemeInput = {
  authenticationTheme?: InputMaybe<OrganizationAuthenticationThemeInput>;
  embeddedExperienceTheme?: InputMaybe<Scalars['Object']['input']>;
  logo?: InputMaybe<Scalars['SafeString']['input']>;
  sideBarColor?: InputMaybe<Scalars['SafeString']['input']>;
};

export type OrganizationTranslatedString = {
  __typename?: 'OrganizationTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type OrganizationTranslatedStringInput = {
  en?: InputMaybe<Scalars['SafeString']['input']>;
  es?: InputMaybe<Scalars['SafeString']['input']>;
  fr?: InputMaybe<Scalars['SafeString']['input']>;
};

export type OrganizationUpsertIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type OrganizationUser = {
  __typename?: 'OrganizationUser';
  /** Access type */
  accessType?: Maybe<OrganizationUserAccessTypes>;
  /** API Tokens related to the user */
  apiTokens: Array<ApiToken>;
  /** @deprecated Use standalone fetchApplicableDowntimeSchedules endpoint instead */
  applicableDowntimeSchedule?: Maybe<DowntimeSchedule>;
  /** Auth0 Invitation expiration datetime */
  auth0invitationExpiresAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** Auth0 Invitation ID */
  auth0invitationId?: Maybe<Scalars['String']['output']>;
  /**
   * Auth0 Audience type
   * @deprecated no longer using a separate Client Auth0
   */
  authAudience?: Maybe<AuthAudienceTypes>;
  authConnectionId?: Maybe<Scalars['String']['output']>;
  /** Auth0 Connection name */
  authConnectionName?: Maybe<Scalars['String']['output']>;
  /** Auth0 Connection type */
  authConnectionType?: Maybe<AuthenticationConnections>;
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  displayRole?: Maybe<DisplayRole>;
  /** Email of the organization user */
  email?: Maybe<Scalars['String']['output']>;
  /** Accessible entities (when accessType is ENTITY) */
  entities?: Maybe<Array<Maybe<OrganizationUserEntity>>>;
  /** Count of accessible entities (when accessType is ENTITY) */
  entitiesCount?: Maybe<Scalars['Int']['output']>;
  externalClientSecrets?: Maybe<Array<ExternalClientSecret>>;
  /** First Name of the organization user */
  firstName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<OrganizationIntegration>>;
  /** Language of the organization user */
  language?: Maybe<Languages>;
  /** Last time the user has logged in */
  lastLoggedInAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** Last Name of the organization user */
  lastName?: Maybe<Scalars['String']['output']>;
  loginStatus?: Maybe<OrganizationUserLoginStatus>;
  mfaEnrollmentId?: Maybe<Scalars['String']['output']>;
  notificationPreferences?: Maybe<Array<Maybe<UserNotificationPreference>>>;
  /** Organization that the user belongs to */
  organization: Organization;
  /** Accessible entities with pagination (when accessType is ENTITY). Default limit 100. */
  paginatedEntities?: Maybe<PaginatedOrganizationUserEntities>;
  /** List of permissions defined in the role */
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  /** Phone of the organization user (MFA) */
  phone?: Maybe<Scalars['String']['output']>;
  /** Auth0 Reference ID */
  referenceId?: Maybe<Scalars['String']['output']>;
  repCodeEntities: Array<OrganizationUserRepCodeEntities>;
  repCodes?: Maybe<Array<RepCode>>;
  /** Role that the user has */
  role: Role;
  skipAuth0Updates?: Maybe<Scalars['Boolean']['output']>;
  statistics?: Maybe<Statistics>;
  unreadNotificationCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  viewFullClientGroup?: Maybe<Scalars['Boolean']['output']>;
};


export type OrganizationUserApplicableDowntimeScheduleArgs = {
  platform: Platforms;
};


export type OrganizationUserPaginatedEntitiesArgs = {
  input?: InputMaybe<PaginatedEntitiesInput>;
};


export type OrganizationUserStatisticsArgs = {
  input?: InputMaybe<OrganizationUserStatisticsInput>;
};

export enum OrganizationUserAccessTypes {
  Entity = 'ENTITY',
  Organization = 'ORGANIZATION',
  RepCode = 'REP_CODE'
}

/** Default role type used in the BulkUpsertOrganizationUsers to identify the default role set at the organization level */
export enum OrganizationUserDefaultRoleTypes {
  Advisor = 'ADVISOR',
  Client = 'CLIENT'
}

export type OrganizationUserDisplayOptions = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  advisorContactId?: InputMaybe<Scalars['ObjectID']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organizationUserId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type OrganizationUserEntity = {
  __typename?: 'OrganizationUserEntity';
  accounts?: Maybe<Array<Maybe<Account>>>;
  entity: User;
  readOnly: Scalars['Boolean']['output'];
  relation?: Maybe<OrganizationUserEntityRelationTypes>;
  role?: Maybe<PublicRole>;
};

export type OrganizationUserEntityInput = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  entityId: Scalars['ObjectID']['input'];
  readOnly: Scalars['Boolean']['input'];
  relation?: InputMaybe<OrganizationUserEntityRelationTypes>;
  roleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum OrganizationUserEntityRelationTypes {
  Advisor = 'ADVISOR',
  Other = 'OTHER',
  Owner = 'OWNER',
  PowerOfAttorney = 'POWER_OF_ATTORNEY'
}

export enum OrganizationUserLoginStatus {
  InvitationExpired = 'INVITATION_EXPIRED',
  Invited = 'INVITED',
  LoggedIn = 'LOGGED_IN',
  NotInvited = 'NOT_INVITED',
  NotLoggedIn = 'NOT_LOGGED_IN'
}

export type OrganizationUserPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserQueryFilter = {
  accessType?: InputMaybe<OrganizationUserAccessTypes>;
  /** @deprecated no longer using a separate Client Auth0 */
  authAudience?: InputMaybe<AuthAudienceTypes>;
  childrenForOrganizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  displayRoleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Organization ID that you would to filter users under */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  parentForOrganizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  repCodes?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  /** @deprecated Use roleProfileIds instead */
  roleProfileId?: InputMaybe<Scalars['ObjectID']['input']>;
  roleProfileIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** Text used to search the names of the organizations */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRepCodeEntities = {
  __typename?: 'OrganizationUserRepCodeEntities';
  accounts: Array<Maybe<Account>>;
  entity: User;
  repCodes: Array<Maybe<RepCode>>;
};

export enum OrganizationUserStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type OrganizationUserStatisticsInput = {
  currency?: InputMaybe<StatisticsCurrencyTypes>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type OrganizationUserUpsertRelationshipInput = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  entityId: Scalars['SafeString']['input'];
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  relation: OrganizationUserEntityRelationTypes;
  roleId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type OverrideAccountsTaxRanksInput = {
  accountsTaxRanks: Array<AccountsTaxRanksInput>;
};

export type PageConfiguration = OrganizationExtensionResource & {
  __typename?: 'PageConfiguration';
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['Object']['output']>;
  organization?: Maybe<Organization>;
  /** Organization with limited attributes that is accessible from sub-organizations. */
  publicOrganization?: Maybe<PublicOrganization>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  state: PageConfigurationStates;
  tabs: Array<TabConfiguration>;
  type: PageConfigurationTypes;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type PageConfigurationCondition = {
  __typename?: 'PageConfigurationCondition';
  ruleGroup?: Maybe<PageConfigurationRuleGroup>;
};

export type PageConfigurationConditionInput = {
  ruleGroup?: InputMaybe<PageConfigurationRuleGroupInput>;
};

export type PageConfigurationQueryFilter = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<InputMaybe<PageConfigurationStates>>>;
  type?: InputMaybe<PageConfigurationTypes>;
  types?: InputMaybe<Array<InputMaybe<PageConfigurationTypes>>>;
};

export type PageConfigurationRuleGroup = {
  __typename?: 'PageConfigurationRuleGroup';
  combinator?: Maybe<OrganizationRuleGroupCombinator>;
  customFieldKey?: Maybe<Scalars['String']['output']>;
  customFieldType?: Maybe<OrganizationConditionCustomFieldType>;
  field?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<OrganizationConditionObjectType>;
  operator?: Maybe<OrganizationRuleGroupOperator>;
  rules?: Maybe<Array<PageConfigurationRuleGroup>>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type PageConfigurationRuleGroupInput = {
  combinator?: InputMaybe<OrganizationRuleGroupCombinator>;
  customFieldKey?: InputMaybe<Scalars['SafeString']['input']>;
  customFieldType?: InputMaybe<OrganizationConditionCustomFieldType>;
  field?: InputMaybe<Scalars['SafeString']['input']>;
  objectType?: InputMaybe<OrganizationConditionObjectType>;
  operator?: InputMaybe<OrganizationRuleGroupOperator>;
  rules?: InputMaybe<Array<PageConfigurationRuleGroupInput>>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type PageConfigurationSchemaField = {
  __typename?: 'PageConfigurationSchemaField';
  /** GraphQL type of the field with list and non-null wrappers removed. */
  graphQLTypeName: Scalars['String']['output'];
  isNestedRepeatedType: Scalars['Boolean']['output'];
  isTranslatedField: Scalars['Boolean']['output'];
  /** GraphQL type that owns the leaf field of the path. */
  ownerTypeName: Scalars['String']['output'];
  /** Dot-separated path from the root type (e.g. owner.firstName). */
  path: Scalars['String']['output'];
};

/** Flattened, traversable fields of the gateway object type behind a page configuration type. */
export type PageConfigurationSchemaType = {
  __typename?: 'PageConfigurationSchemaType';
  fields: Array<PageConfigurationSchemaField>;
  /** Gateway object type name (e.g. Account, User). */
  name: Scalars['String']['output'];
};

export enum PageConfigurationStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum PageConfigurationTransition {
  Archive = 'archive'
}

export enum PageConfigurationTypes {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  Individual = 'INDIVIDUAL',
  NonIndividual = 'NON_INDIVIDUAL',
  SubAccount = 'SUB_ACCOUNT'
}

export enum Pages {
  Accounts = 'ACCOUNTS',
  AccountsDetail = 'ACCOUNTS_DETAIL',
  AccountsReview = 'ACCOUNTS_REVIEW',
  AccountGroups = 'ACCOUNT_GROUPS',
  AnnualSuitabilityReview = 'ANNUAL_SUITABILITY_REVIEW',
  AssetClasses = 'ASSET_CLASSES',
  BankAccountsToReview = 'BANK_ACCOUNTS_TO_REVIEW',
  BillingManagement = 'BILLING_MANAGEMENT',
  BillingSchedules = 'BILLING_SCHEDULES',
  BuildModels = 'BUILD_MODELS',
  BulkImport = 'BULK_IMPORT',
  BulkTrader = 'BULK_TRADER',
  ComplianceReview = 'COMPLIANCE_REVIEW',
  ConfigureModels = 'CONFIGURE_MODELS',
  DeveloperSettings = 'DEVELOPER_SETTINGS',
  ElderlyClients = 'ELDERLY_CLIENTS',
  FeeGrids = 'FEE_GRIDS',
  FeeReport = 'FEE_REPORT',
  GoalsDetail = 'GOALS_DETAIL',
  Home = 'HOME',
  Households = 'HOUSEHOLDS',
  IncurredFees = 'INCURRED_FEES',
  IndividualClients = 'INDIVIDUAL_CLIENTS',
  InstitutionsToReview = 'INSTITUTIONS_TO_REVIEW',
  ModelPortfolios = 'MODEL_PORTFOLIOS',
  NewsAndInsight = 'NEWS_AND_INSIGHT',
  NonIndividualClients = 'NON_INDIVIDUAL_CLIENTS',
  OrganizationRevenueShare = 'ORGANIZATION_REVENUE_SHARE',
  OrganizationSettings = 'ORGANIZATION_SETTINGS',
  PortfolioModelFamilies = 'PORTFOLIO_MODEL_FAMILIES',
  PortfolioOptimizer = 'PORTFOLIO_OPTIMIZER',
  PortfolioTemplates = 'PORTFOLIO_TEMPLATES',
  ProductShelf = 'PRODUCT_SHELF',
  RebalanceReport = 'REBALANCE_REPORT',
  RebalanceReportV2 = 'REBALANCE_REPORT_V2',
  Rebalancing = 'REBALANCING',
  Reconciliation = 'RECONCILIATION',
  Reports = 'REPORTS',
  Schedules = 'SCHEDULES',
  StatementsReview = 'STATEMENTS_REVIEW',
  SubAccountsDetail = 'SUB_ACCOUNTS_DETAIL',
  SuspiciousTransactions = 'SUSPICIOUS_TRANSACTIONS',
  Transactions = 'TRANSACTIONS',
  Workflows = 'WORKFLOWS'
}

/** Input for paginated entities on OrganizationUser (e.g. in me { paginatedEntities }) */
export type PaginatedEntitiesInput = {
  /** Maximum number of entities to return (default 100, max 500) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of entities to skip (default 0) */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Paginated list of accessible entities (when accessType is ENTITY) */
export type PaginatedOrganizationUserEntities = {
  __typename?: 'PaginatedOrganizationUserEntities';
  items: Array<OrganizationUserEntity>;
  totalCount: Scalars['Int']['output'];
};

export type PaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export enum PaginationCursorDirection {
  Next = 'NEXT',
  Prev = 'PREV'
}

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type PairSubTradeRequestsInput = {
  /**
   *  @deprecated Not needed anymore, will be removed in the future
   * @deprecated Field no longer supported
   */
  bulkTradeRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Not needed anymore, will be removed in the future */
  source?: InputMaybe<SubTradeRequestSources>;
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum PerformanceObjectTypes {
  Account = 'ACCOUNT',
  Entity = 'ENTITY',
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  SubAccount = 'SUB_ACCOUNT'
}

export enum PerformancePeriods {
  AllTime = 'ALL_TIME',
  FiveYears = 'FIVE_YEARS',
  MonthToDate = 'MONTH_TO_DATE',
  OneDay = 'ONE_DAY',
  OneMonth = 'ONE_MONTH',
  OneYear = 'ONE_YEAR',
  QuarterToDate = 'QUARTER_TO_DATE',
  SixMonths = 'SIX_MONTHS',
  ThreeMonths = 'THREE_MONTHS',
  ThreeYears = 'THREE_YEARS',
  YearToDate = 'YEAR_TO_DATE'
}

export type Permission = {
  __typename?: 'Permission';
  /** Whether or not the permission is accessible in the Client App */
  clientEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The description of the permission */
  translatedDescription: OrganizationTranslatedString;
  /** The key of the permissions */
  value: Scalars['String']['output'];
};

export enum PersistenceBehaviour {
  EverySession = 'EVERY_SESSION',
  FirstSession = 'FIRST_SESSION',
  UntilActioned = 'UNTIL_ACTIONED',
  UntilDismissed = 'UNTIL_DISMISSED'
}

/** User's physical address */
export type PhysicalAddress = {
  __typename?: 'PhysicalAddress';
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Name of country using two-letter country code format (ISO 3166-1 alpha-2). Required for address validation, tax residency determination, and regulatory compliance. */
  country: AddressCountries;
  /** House number */
  houseNumber?: Maybe<Scalars['String']['output']>;
  /** Jurisdiction */
  jurisdiction?: Maybe<AddressJurisdiction>;
  /** Neighbourhood */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Postal code string input. */
  postal?: Maybe<Scalars['String']['output']>;
  /**
   * Province; deprecated
   * @deprecated use jurisdiction instead
   */
  province?: Maybe<AddressProvince>;
  /** Street name */
  streetName?: Maybe<Scalars['String']['output']>;
  /** Unit number */
  unitNumber?: Maybe<Scalars['String']['output']>;
};

/** Describes User's primary, physical address */
export type PhysicalAddressInput = {
  /** City */
  city?: InputMaybe<Scalars['SafeString']['input']>;
  /** Name of country using two-letter country code format (ISO 3166-1 alpha-2). Required for address validation, tax residency determination, and regulatory compliance. */
  country: AddressCountries;
  /** House number */
  houseNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** Jurisdiction */
  jurisdiction?: InputMaybe<AddressJurisdiction>;
  /** Neighbourhood */
  neighborhood?: InputMaybe<Scalars['SafeString']['input']>;
  /** Postal code string input. */
  postal?: InputMaybe<Scalars['SafeString']['input']>;
  /**
   * Province
   * @deprecated use jurisdiction instead; fod Canada prepend province name with 'CA_'
   */
  province?: InputMaybe<AddressProvince>;
  /** Street name */
  streetName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Unit number */
  unitNumber?: InputMaybe<Scalars['SafeString']['input']>;
};

export enum Platforms {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export enum PolicySource {
  Inherited = 'INHERITED',
  PlatformDefault = 'PLATFORM_DEFAULT',
  Self = 'SELF'
}

export type PortfolioOptimizer = {
  __typename?: 'PortfolioOptimizer';
  createdAt: Scalars['GraphQLDateTime']['output'];
  expectedTotalSubTradeRequests: Scalars['Int']['output'];
  id: Scalars['ObjectID']['output'];
  numPortfolios: Scalars['Int']['output'];
  organization?: Maybe<PublicOrganization>;
  pauseAt?: Maybe<PortfolioOptimizerPausableStates>;
  state: PortfolioOptimizerStates;
  subTradeRequestsCreated: Scalars['Int']['output'];
  type: PortfolioOptimizerTypes;
};

export enum PortfolioOptimizerPausableStates {
  OptimalPortfoliosGenerated = 'OPTIMAL_PORTFOLIOS_GENERATED',
  PurchasesSolved = 'PURCHASES_SOLVED',
  Rebalanced = 'REBALANCED',
  RedemptionsSolved = 'REDEMPTIONS_SOLVED',
  TaxOptimized = 'TAX_OPTIMIZED'
}

export type PortfolioOptimizerQueryFilter = {
  createdAt?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  numPortfolios?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<PortfolioOptimizerStates>;
  type?: InputMaybe<PortfolioOptimizerTypes>;
};

export enum PortfolioOptimizerStates {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  GeneratingAllocations = 'GENERATING_ALLOCATIONS',
  Initiated = 'INITIATED',
  OptimalPortfoliosGenerated = 'OPTIMAL_PORTFOLIOS_GENERATED',
  OptimalPortfoliosGenerating = 'OPTIMAL_PORTFOLIOS_GENERATING',
  PurchasesSolved = 'PURCHASES_SOLVED',
  Rebalanced = 'REBALANCED',
  Rebalancing = 'REBALANCING',
  RedemptionsSolved = 'REDEMPTIONS_SOLVED',
  SolvingForPurchases = 'SOLVING_FOR_PURCHASES',
  SolvingForRedemptions = 'SOLVING_FOR_REDEMPTIONS',
  TaxOptimized = 'TAX_OPTIMIZED',
  TaxOptimizing = 'TAX_OPTIMIZING'
}

export enum PortfolioOptimizerTransition {
  Cancel = 'cancel',
  Complete = 'complete'
}

export enum PortfolioOptimizerTypes {
  Drift = 'DRIFT',
  Transfer = 'TRANSFER'
}

export type PortfolioReport = {
  __typename?: 'PortfolioReport';
  allocationMethodology: AllocationMethodologies;
  /**
   * Share of its own drift band this report has consumed, as a fraction.
   * At or above 1 exactly when the engine flags the report, so ordering by this
   * can never contradict the drift badge. Sortable via sortField.
   */
  bandConsumedPercentage?: Maybe<Scalars['Float']['output']>;
  baseCurrency: Currencies;
  bulkTradeRunReasons: Array<BulkTradeRunReason>;
  /**
   * The asset class that uninvested cash is attributed to, based on the cash product's asset class field
   * matching the portfolio's assetClassLevel. Null for non-ASSET_CLASS portfolios or when no cash product exists.
   */
  cashAssetClass?: Maybe<AssetClass>;
  /**
   * The asset class group's target share of the total portfolio (0.0–1.0).
   * Example: 0.20 means the Fixed Income group targets 20% of the portfolio.
   * Null when the cash's asset class is not found in the portfolio's assetClassBranches.
   */
  cashAssetClassGroupPercentage?: Maybe<Scalars['Float']['output']>;
  /**
   * Cash's share within its assigned asset class group (0.0–1.0).
   * Example: 0.20 means cash is 20% of the Fixed Income group's target allocation.
   * Null when the group's target is 0% or no matching group is found.
   */
  cashAssetClassPercentage?: Maybe<Scalars['Float']['output']>;
  cashAvailableForTradeCents: Scalars['Long']['output'];
  /**
   * The cash arm of bandConsumedPercentage on its own, as a FRACTION on the
   * same scale — 1 is exactly where the cash comparator flips
   * transferRebalanceRequired.
   * Exposed because bandConsumedPercentage is the worst of the cash and
   * position arms and cannot say which one it came from. The comparator's
   * headroom is the net cash target under RELATIVE and the tradeable base
   * under ABSOLUTE, so re-deriving this client-side means copying that swap
   * and disagreeing with the verdict on the same row.
   */
  cashBandConsumedPercentage?: Maybe<Scalars['Float']['output']>;
  cashCents: Scalars['Long']['output'];
  cashCentsEquivalent?: Maybe<Scalars['Long']['output']>;
  cashOnHoldToTradeCents?: Maybe<Scalars['Long']['output']>;
  /**
   * Household-vs-model gap of the signed account targets, from the same
   * calculation Optimizer V2 records on a run. Null unless the household is
   * CUSTOMIZED with more than one active account and no per-currency funding.
   */
  customizedMixGap?: Maybe<CustomizedMixGap>;
  driftRebalanceRequired: Scalars['Boolean']['output'];
  /**
   * The drift settings this report was screened under, resolved against the
   * HOLDER organization — not the organization that owns the model.
   */
  effectiveDriftCalculationMethod?: Maybe<DriftCalculationMethod>;
  /**
   * Whether the model portfolio supplied at least one half of the effective
   * policy. Decided by the same resolution as the two fields above, so it is
   * false whenever the gates suppress a stored model override.
   */
  effectiveDriftInheritedFromModelPortfolio?: Maybe<Scalars['Boolean']['output']>;
  effectiveDriftTolerancePercent?: Maybe<Scalars['Int']['output']>;
  expectedCashCents: Scalars['Long']['output'];
  expectedCashCentsEquivalent?: Maybe<Scalars['Long']['output']>;
  expectedCashPercentage: Scalars['Float']['output'];
  expectedCashPercentageEquivalent?: Maybe<Scalars['Float']['output']>;
  /**
   * Why this portfolio can't be rebalanced: it holds or targets a product its
   * custodian connection can't bulk trade. Null when nothing blocks it.
   */
  forbiddenHoldingsMessage?: Maybe<Scalars['String']['output']>;
  fxRates?: Maybe<Array<FxRate>>;
  hasCashEquivalent?: Maybe<Scalars['Boolean']['output']>;
  holdings: Array<HoldingReport>;
  id: Scalars['ObjectID']['output'];
  lastOptimizedBy?: Maybe<PortfolioOptimizer>;
  liquidateRebalanceRequired: Scalars['Boolean']['output'];
  marketValueCents: Scalars['Long']['output'];
  modelPortfolio: FinancialProduct;
  modelPortfolioType: ModelPortfolioTypes;
  object: PortfolioReportObject;
  optimizerRun?: Maybe<OptimizerRunV2>;
  originalCurrencies?: Maybe<Array<Currencies>>;
  pendingCashCents?: Maybe<Scalars['Long']['output']>;
  pendingSubTradeRequestAllocations?: Maybe<Scalars['Long']['output']>;
  pendingSubTradeRequests: Scalars['Int']['output'];
  pendingWithdrawCents?: Maybe<Scalars['Long']['output']>;
  refreshState: PortfolioReportRefreshStates;
  state: Scalars['String']['output'];
  subAccounts: Array<SubAccountReport>;
  transferRebalanceRequired: Scalars['Boolean']['output'];
  unverifiedSubTradeRequests: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type PortfolioReportObject = ClientGroup | Goal | SubAccount;

export type PortfolioReportQueryFilter = {
  anyRebalanceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  bulkTradeRequiredReason?: InputMaybe<BulkTradeRunReasons>;
  cashTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  driftRebalanceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  driftTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  internalDriftDetected?: InputMaybe<Scalars['Boolean']['input']>;
  lastOptimizedBy?: InputMaybe<Scalars['ObjectID']['input']>;
  liquidateRebalanceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modelPortfolioId?: InputMaybe<Scalars['ObjectID']['input']>;
  modelPortfolioIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  modelPortfolioType?: InputMaybe<ModelPortfolioTypes>;
  optimizerRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  pendingSubTradeRequests?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  tradeVerificationStatus?: InputMaybe<Scalars['String']['input']>;
  transferRebalanceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum PortfolioReportRefreshStates {
  Recalculating = 'RECALCULATING',
  Updated = 'UPDATED',
  Updating = 'UPDATING'
}

export type PortfolioReportsByHoldingProductQueryFilter = {
  currency: Currencies;
  financialProductId: Scalars['ObjectID']['input'];
  organizationId: Scalars['ObjectID']['input'];
};

export type PortfolioReportsPagination = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PortfolioTemplate = {
  __typename?: 'PortfolioTemplate';
  /** The asset class allocations for this template */
  assetClassBranches: Array<AssetClassBranch>;
  /** When this template was created */
  createdAt: Scalars['GraphQLDateTime']['output'];
  /** Unique identifier for the portfolio template */
  id: Scalars['ObjectID']['output'];
  /** The name of the template */
  name: Scalars['String']['output'];
  /** The organization this template belongs to */
  organization: Organization;
  /** Current state of the template */
  state: PortfolioTemplateState;
  /** The translated name of the template */
  translatedName: ProductTranslatedString;
  /** The translated description of the template */
  translatedTemplateDescription?: Maybe<ProductTranslatedString>;
  /** When this template was last updated */
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type PortfolioTemplatePaginationAndSorting = {
  collation?: InputMaybe<Collation>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioTemplateQueryFilter = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<PortfolioTemplateState>;
  states?: InputMaybe<Array<PortfolioTemplateState>>;
};

export enum PortfolioTemplateState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum PortfolioTemplateTransitions {
  Activate = 'activate',
  Archive = 'archive',
  Draft = 'draft'
}

export enum PortfolioTradingProcesses {
  NoAutomation = 'NO_AUTOMATION',
  PortfolioOptimizer = 'PORTFOLIO_OPTIMIZER'
}

export type PreTradeHolding = {
  __typename?: 'PreTradeHolding';
  diffPercentage: Scalars['Float']['output'];
  diffPercentagePurchasesStage1: Scalars['Float']['output'];
  diffValueCents: Scalars['Float']['output'];
  expectedPercentage: Scalars['Float']['output'];
  financialProduct: Scalars['ObjectID']['output'];
  index: Scalars['Int']['output'];
  moneyAllocatedCents: Scalars['Float']['output'];
  moneyAllocatedCentsPurchases: Scalars['Float']['output'];
  moneyAllocatedCentsRedemptions: Scalars['Float']['output'];
  taxRank?: Maybe<Scalars['Int']['output']>;
};

export type PrepareFormCompletionInput = {
  formMapping: FormMapping;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  userId: Scalars['ObjectID']['input'];
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type PrepareFormCompletionResponse = {
  __typename?: 'PrepareFormCompletionResponse';
  formCompletion: FormCompletion;
};

export type PrepareFormCompletionsInput = {
  /**
   * When true, archives existing unsigned form completions for this workflow and re-prepares them.
   * Defaults to false, in which case the existing prepared form completions are returned unchanged.
   * Use this when the user has gone back in the workflow, made changes, and wants to regenerate the forms.
   */
  forcePrepare?: InputMaybe<Scalars['Boolean']['input']>;
  formMapping: Array<FormMapping>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  userId: Scalars['ObjectID']['input'];
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type PrepareFormCompletionsResponse = {
  __typename?: 'PrepareFormCompletionsResponse';
  formCompletions: Array<FormCompletion>;
};

export type PreviewClientReportResponse = {
  __typename?: 'PreviewClientReportResponse';
  html?: Maybe<Scalars['String']['output']>;
};

export type PreviewFilledPdfInput = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  generatePrefilledPdf?: InputMaybe<Scalars['Boolean']['input']>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  scheduledTransferId?: InputMaybe<Scalars['ObjectID']['input']>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  type: FormTypes;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type PreviewFilledPdfResponse = {
  __typename?: 'PreviewFilledPdfResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type PreviewFormAgreementInput = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  formTemplateId?: InputMaybe<Scalars['ObjectID']['input']>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  language?: InputMaybe<Language>;
  raw?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledTransferId?: InputMaybe<Scalars['ObjectID']['input']>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  type: FormTypes;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type PreviewFormAgreementResponse = {
  __typename?: 'PreviewFormAgreementResponse';
  html?: Maybe<Scalars['String']['output']>;
};

export type PreviousStep = {
  __typename?: 'PreviousStep';
  step: Scalars['ObjectID']['output'];
  subStep: Scalars['ObjectID']['output'];
};

export type PreviousSubStepInput = {
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type PreviousSubStepResponse = {
  __typename?: 'PreviousSubStepResponse';
  workflowCompletion: WorkflowCompletion;
};

export type PrimaryAssetClassHoldings = {
  __typename?: 'PrimaryAssetClassHoldings';
  assetClass?: Maybe<AssetClass>;
  percentage?: Maybe<Scalars['Float']['output']>;
  secondaryAssetClassHoldings?: Maybe<Array<SecondaryAssetClassHoldings>>;
  totalCents?: Maybe<Scalars['Long']['output']>;
};

export type PrintClientReportTemplateInput = {
  objectId: Scalars['ObjectID']['input'];
  objectType: ClientReportTemplateObjectTypes;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  referenceDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  templateId: Scalars['ObjectID']['input'];
  timePeriodEnd?: InputMaybe<Scalars['GraphQLDate']['input']>;
  timePeriodStart?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type PrintClientReportTemplateResponse = {
  __typename?: 'PrintClientReportTemplateResponse';
  s3Key?: Maybe<Scalars['SafeString']['output']>;
};

export enum ProductAumExposureObjectType {
  Account = 'ACCOUNT',
  Entity = 'ENTITY',
  Household = 'HOUSEHOLD'
}

export type ProductAumExposureRow = {
  __typename?: 'ProductAumExposureRow';
  account?: Maybe<Account>;
  household?: Maybe<ClientGroup>;
  marketValueCents: Scalars['Long']['output'];
  rank: Scalars['Int']['output'];
  user?: Maybe<User>;
};

export type ProductMarketData = {
  __typename?: 'ProductMarketData';
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  exchange?: Maybe<Scalars['String']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ric?: Maybe<Scalars['String']['output']>;
  ticker?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * Translated copy that may contain editor HTML (e.g. IPS disclaimer).
 * Uses String rather than SafeString so rich-text markup is accepted.
 */
export type ProductRichTextTranslatedStringInput = {
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
};

export type ProductTranslatedString = {
  __typename?: 'ProductTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type ProductTranslatedStringInput = {
  en?: InputMaybe<Scalars['SafeString']['input']>;
  es?: InputMaybe<Scalars['SafeString']['input']>;
  fr?: InputMaybe<Scalars['SafeString']['input']>;
};

export type ProjectedIncome = {
  __typename?: 'ProjectedIncome';
  amountCents: Scalars['Long']['output'];
  currency?: Maybe<StatisticsCurrencyTypes>;
  date: Scalars['GraphQLDate']['output'];
  financialProduct: FinancialProduct;
  foreignExchangeRates?: Maybe<Array<Maybe<StatisticForeignExchangeRate>>>;
};

export enum ProvinceCode {
  Ab = 'AB',
  Bc = 'BC',
  Foreign = 'FOREIGN',
  Mb = 'MB',
  Nb = 'NB',
  Nl = 'NL',
  Ns = 'NS',
  Nt = 'NT',
  Nu = 'NU',
  On = 'ON',
  Pe = 'PE',
  Qc = 'QC',
  Sk = 'SK',
  Yt = 'YT'
}

export enum PublicEventObject {
  Account = 'Account',
  AccountStatement = 'AccountStatement',
  AdministrativeAnnualFeeReport = 'AdministrativeAnnualFeeReport',
  BankAccount = 'BankAccount',
  BulkTradeRun = 'BulkTradeRun',
  ManagementAnnualFeeReport = 'ManagementAnnualFeeReport',
  OrganizationUser = 'OrganizationUser',
  ScheduledTransfer = 'ScheduledTransfer',
  SubAccount = 'SubAccount',
  TaxSlip = 'TaxSlip',
  Transfer = 'Transfer',
  User = 'User'
}

/** Organization with limited attributes that is accessible from sub-organizations. */
export type PublicOrganization = {
  __typename?: 'PublicOrganization';
  /**
   * Analytics identifier for tracking organizations across parent and sub-orgs.
   * If not set, it will inherit from parent organizations up the tree.
   */
  analyticsIdentifier?: Maybe<Scalars['String']['output']>;
  /** Applicable analytics identifier (this org or inherited from parent orgs up the tree) */
  applicableAnalyticsIdentifier?: Maybe<Scalars['String']['output']>;
  /** The browserTabTitle of the organization used as website title */
  browserTabTitle?: Maybe<Scalars['String']['output']>;
  /** Client Host Login ClientId */
  clientHostedLoginClientId?: Maybe<Scalars['String']['output']>;
  /** Client Hosted Login Scope */
  clientHostedLoginScope?: Maybe<Scalars['String']['output']>;
  /** Client Host Login URL to generate token */
  clientHostedLoginURL?: Maybe<Scalars['String']['output']>;
  /** The faviconLink of the organization will display on the browser tab */
  faviconLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  /**
   * The name of the organization
   * @deprecated name is deprecated, use translatedName instead
   */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent organization */
  parent?: Maybe<PublicOrganization>;
  /** The subdomain of the organization used for logging in */
  subdomain: Scalars['String']['output'];
  theme?: Maybe<OrganizationTheme>;
  /** The translated name of the organization */
  translatedName?: Maybe<OrganizationTranslatedString>;
};

export type PublicOrganizationQueryFilter = {
  /** Organization ID that you would to filter to only organizations under */
  childrenFor?: InputMaybe<Scalars['ObjectID']['input']>;
  /** List of Organization referenceIds */
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Text used to search the names of the organizations */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/** OrganizationUser with limited attributes that is accessible from sub-organizations. */
export type PublicOrganizationUser = {
  __typename?: 'PublicOrganizationUser';
  avatar?: Maybe<Scalars['String']['output']>;
  displayRole?: Maybe<DisplayRole>;
  /** Email of the organization user */
  email?: Maybe<Scalars['String']['output']>;
  /** First Name of the organization user */
  firstName: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  /** Language of the organization user */
  language?: Maybe<Languages>;
  /** Last Name of the organization user */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Organization that the user belongs to */
  organization: PublicOrganization;
  phone?: Maybe<Scalars['String']['output']>;
  /** Auth0 Reference ID */
  referenceId?: Maybe<Scalars['String']['output']>;
  repCodes?: Maybe<Array<RepCode>>;
  /** Role that the user has */
  role: PublicRole;
};

/** Role with limited attributes that is accessible from sub-organizations. */
export type PublicRole = {
  __typename?: 'PublicRole';
  id: Scalars['ObjectID']['output'];
  /** Organization that owns the role */
  organization: PublicOrganization;
  /** Role Profile */
  roleProfile?: Maybe<PublicRoleProfile>;
  /** The description of the role */
  translatedDescription: OrganizationTranslatedString;
  /** The name of the role */
  translatedName: OrganizationTranslatedString;
};

/** RoleProfile with limited attributes that is accessible from sub-organizations. */
export type PublicRoleProfile = {
  __typename?: 'PublicRoleProfile';
  id: Scalars['ObjectID']['output'];
  organization?: Maybe<PublicOrganization>;
  translatedDescription: OrganizationTranslatedString;
  translatedName: OrganizationTranslatedString;
};

export type PublishHistoryInput = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  endDate: Scalars['GraphQLDate']['input'];
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  startDate: Scalars['GraphQLDate']['input'];
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type PublishPendingSubTradeRequestTotalsInput = {
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type Query = {
  __typename?: 'Query';
  calculateGoalSuitabilityScore: Scalars['Int']['output'];
  calculateWithdrawFees: CalculateWithdrawFeesResponse;
  /** Downloads multiple account statements as a zip file and returns a signed URL for download. */
  downloadAccountStatements?: Maybe<DownloadAccountStatementsResponse>;
  /** Downloads multiple file documents as a zip file and returns a signed URL for download. */
  downloadFileDocuments: DownloadFileDocumentsResponse;
  fetchAccount: FetchAccountResponse;
  fetchAccountBulkUpsertItem: FetchAccountBulkUpsertItemResponse;
  fetchAccountBulkUpsertItems: FetchAccountBulkUpsertItemsResponse;
  fetchAccountByIntegrationId: FetchAccountResponse;
  /** @deprecated AccountFee is deprecated; use SubAccountBilling endpoints instead */
  fetchAccountFee: FetchAccountFeeResponse;
  /** @deprecated AccountFee is deprecated; use SubAccountBilling endpoints instead */
  fetchAccountFees: FetchAccountFeesResponse;
  fetchAccountGroup: FetchAccountGroupResponse;
  fetchAccountGroupBulkUpsertItem: FetchAccountGroupBulkUpsertItemResponse;
  fetchAccountGroupBulkUpsertItems: FetchAccountGroupBulkUpsertItemsResponse;
  fetchAccountGroups: FetchAccountGroupsResponse;
  fetchAccountReconciliationSnapshot: FetchAccountReconciliationSnapshotResponse;
  fetchAccountReconciliationSnapshots: FetchAccountReconciliationSnapshotsResponse;
  fetchAccountStatement?: Maybe<FetchAccountStatementResponse>;
  fetchAccountStatementAccounts?: Maybe<FetchAccountStatementAccountsResponse>;
  fetchAccountStatementDocument?: Maybe<FetchAccountStatementDocumentResponse>;
  fetchAccountStatementTypes?: Maybe<FetchAccountStatementTypesResponse>;
  fetchAccountStatements?: Maybe<FetchAccountStatementsResponse>;
  fetchAccountTypes: FetchAccountTypesResponse;
  fetchAccounts: FetchAccountsResponse;
  /** Fetch a single advisor contact by ID */
  fetchAdvisorContact: FetchAdvisorContactResponse;
  /** Fetch a paginated list of advisor contacts for an organization */
  fetchAdvisorContacts: FetchAdvisorContactsResponse;
  /** Fetch a singular alert banner by its id */
  fetchAlertBanner: FetchAlertBannerResponse;
  /** Fetch a paginated list of alert banners */
  fetchAlertBanners: FetchAlertBannersResponse;
  fetchAlertReport: FetchAlertReportResponse;
  fetchAlertReports: FetchAlertReportsResponse;
  /** Roles on the given organization that reference configuration objects owned by a parent organization in the hierarchy. */
  fetchAncestorInheritedAssignments: FetchAncestorInheritedAssignmentsResponse;
  fetchApiExport: FetchApiExportResponse;
  fetchApiExports: FetchApiExportsResponse;
  /** Fetch the currently applicable downtime schedule for the authenticated user */
  fetchApplicableDowntimeSchedule: FetchApplicableDowntimeScheduleResponse;
  /**
   * Fetch a singular article by its id. ignoreRoleTargeting returns it even when
   * it is targeted to roles the viewer does not hold, and is ignored without
   * write:news_and_insights.
   */
  fetchArticle: FetchArticleResponse;
  /** Fetch a paginated list of articles */
  fetchArticles: FetchArticlesResponse;
  fetchAssetClasses: FetchAssetClassesResponse;
  /**
   * Counts how many assignments (sub-accounts at SUB_ACCOUNT level and
   * non-ARCHIVED goals; GOAL/HOUSEHOLD-level subs and household
   * ClientGroup portfolios excluded — see AssignedCountByFinancialProduct)
   * currently reference each financial product. Duplicate input IDs are
   * deduplicated — always returns one entry per unique requested ID,
   * including explicit zero rows. Org-scoped: counts only assignments
   * owned by the caller's organization.
   */
  fetchAssignedCountsByFinancialProduct: Array<AssignedCountByFinancialProduct>;
  fetchAvailableReportVariables?: Maybe<FetchAvailableReportVariablesResponse>;
  fetchAvailableThemes: FetchAvailableThemesResponse;
  fetchBankAccount: FetchBankAccountResponse;
  fetchBankAccountBulkUpsertItem: FetchBankAccountBulkUpsertItemResponse;
  fetchBankAccountBulkUpsertItems: FetchBankAccountBulkUpsertItemsResponse;
  fetchBankAccountByIntegrationId: FetchBankAccountResponse;
  fetchBankAccounts: FetchBankAccountsResponse;
  fetchBankConnections: FetchBankConnectionsResponse;
  /** @deprecated Use Affiliation instead. Find the affiliation in the account object response from the fetchAccount query */
  fetchBeneficiaries: FetchBeneficiariesResponse;
  /** @deprecated Use Affiliation instead. Find the affiliation in the account object response from the fetchAccount query */
  fetchBeneficiary: FetchBeneficiaryResponse;
  fetchBillingCycle: FetchBillingCycleResponse;
  fetchBillingCycles: FetchBillingCyclesResponse;
  fetchBillingSchedule: FetchBillingScheduleResponse;
  fetchBillingSchedules: FetchBillingSchedulesResponse;
  fetchBulkImport: FetchBulkImportResponse;
  fetchBulkImports: FetchBulkImportsResponse;
  fetchBulkTradeRequest: FetchBulkTradeRequestResponse;
  fetchBulkTradeRequests: FetchBulkTradeRequestsResponse;
  fetchBulkTradeRun: FetchBulkTradeRunResponse;
  fetchBulkTradeRunAllocations: FetchBulkTradeRunAllocationsResponse;
  fetchBulkTradeRuns: FetchBulkTradeRunsResponse;
  fetchBulkUpsertRequest?: Maybe<FetchBulkUpsertRequestResponse>;
  fetchBulkUpsertRequests?: Maybe<FetchBulkUpsertRequestsResponse>;
  fetchCashFinancialProduct: FetchFinancialProductResponse;
  /** Admin-only visibility read for reconciling hidden advisors on the Client View tab. */
  fetchClientAdvisorVisibility: FetchClientAdvisorVisibilityResponse;
  fetchClientGroup: FetchClientGroupResponse;
  /** Returns an object for the client group associated with the unique IntegrationId for an integration */
  fetchClientGroupByIntegrationId: FetchClientGroupResponse;
  /** Returns an array of objects for the ClientGroups associated with the provided input details */
  fetchClientGroups: FetchClientGroupsResponse;
  fetchClientReport?: Maybe<FetchClientReportResponse>;
  fetchClientReportTemplate?: Maybe<FetchClientReportTemplateResponse>;
  fetchClientReportTemplateWidgetOptions: FetchClientReportTemplateWidgetOptionsResponse;
  fetchClientReportTemplates?: Maybe<FetchClientReportTemplatesResponse>;
  fetchClientReports?: Maybe<FetchClientReportsResponse>;
  /** Refresh the Options URL options of a filter that depends on other filters */
  fetchConfigurableTableFilterOptions: FetchConfigurableTableFilterOptionsResponse;
  fetchConfigurableTablePage: FetchConfigurableTablePageResponse;
  /** Fetch a configurable table page export by ID */
  fetchConfigurableTablePageReport: FetchConfigurableTablePageReportResponse;
  /** Fetch widget options for configurable table page widgets */
  fetchConfigurableTablePageWidgetOptions: FetchConfigurableTablePageWidgetOptionsResponse;
  fetchConfigurableTablePages: FetchConfigurableTablePagesResponse;
  fetchCountryRisk: FetchCountryRiskResponse;
  fetchCustodian: FetchCustodianResponse;
  fetchCustodianActivities: FetchCustodianActivitiesResponse;
  fetchCustodianActivitiesForGrid: FetchCustodianActivitiesResponse;
  fetchCustodianActivityChartToday: FetchCustodianActivityChartTodayResponse;
  fetchCustodianActivityChartTrend: FetchCustodianActivityChartTrendResponse;
  fetchCustodianActivityMetrics: FetchCustodianActivityMetricsResponse;
  fetchCustodianBankAccounts: FetchCustodianBankAccountsResponse;
  fetchCustodianConnection: FetchCustodianConnectionResponse;
  fetchCustodianConnections: FetchCustodianConnectionsResponse;
  fetchCustodianExternalDocument: FetchCustodianExternalDocumentResponse;
  /** @deprecated Configure and use the notifications webhook instead. */
  fetchCustodianNotifications: FetchCustodianNotificationsResponse;
  fetchCustodianStatements: FetchCustodianStatementsResponse;
  fetchCustodianTransactionTypes: FetchCustodianTransactionTypesResponse;
  fetchCustodianTransactions: FetchCustodianTransactionsResponse;
  fetchCustodianUpcomingTransactions: FetchCustodianUpcomingTransactionsResponse;
  /** Fetch a custom attribute label by ID */
  fetchCustomAttributeLabel: FetchCustomAttributeLabelResponse;
  /** Fetch paginated custom attribute labels */
  fetchCustomAttributeLabels: FetchCustomAttributeLabelsResponse;
  fetchCustomField: FetchCustomFieldResponse;
  fetchCustomFields: FetchCustomFieldsResponse;
  /** All non-archived dashboards, not limited to the authenticated user's organization. Prefer fetchOrganizationDashboards for an organization-scoped list. */
  fetchDashboards: FetchDashboardsResponse;
  /** Fetch a single display role by ID */
  fetchDisplayRole: FetchDisplayRoleResponse;
  /** Fetch the ordered library of display roles for an organization */
  fetchDisplayRoles: FetchDisplayRolesResponse;
  /** Fetch a singular downtimeSchedule by its id */
  fetchDowntimeSchedule: FetchDowntimeScheduleResponse;
  /** Fetch a paginated list of downtime schedules */
  fetchDowntimeSchedules: FetchDowntimeSchedulesResponse;
  fetchEntityFeeSettings: FetchEntityFeeSettingsResponse;
  fetchEodFiles: FetchEodFilesResponse;
  fetchEventObjectTypes: FetchEventObjectTypeResponse;
  fetchEvents: FetchEventsResponse;
  fetchExport: FetchExportResponse;
  /** Fetch paginated external vendor usages */
  fetchExternalVendorUsages?: Maybe<FetchExternalVendorUsagesResponse>;
  /** Fetch feature flags */
  fetchFeatureFlags: FetchFeatureFlagsResponse;
  fetchFeeSetting: FetchFeeSettingResponse;
  fetchFeeTier: FetchFeeTierResponse;
  fetchFeeTiers: FetchFeeTiersResponse;
  /** Fetch a singular fileDocument */
  fetchFileDocument: FetchFileDocumentResponse;
  /** Returns an array of fileDocuments objects for the provided input details */
  fetchFileDocuments: FetchFileDocumentsResponse;
  /** Returns a temporary S3 storage URL for uploading a document. Call this just prior to mutation createFileDocument. */
  fetchFileUploadUrl?: Maybe<FetchFileUploadUrlResponse>;
  fetchFillTemplate: FetchFillTemplateResponse;
  fetchFinancialProduct: FetchFinancialProductResponse;
  fetchFinancialProductBulkUpsertItem: FetchFinancialProductBulkUpsertItemResponse;
  fetchFinancialProductBulkUpsertItems: FetchFinancialProductBulkUpsertItemsResponse;
  fetchFinancialProductByIntegrationId: FetchFinancialProductResponse;
  fetchFinancialProductPriceHistory: FinancialProductPriceHistoryResponse;
  fetchFinancialProducts: FetchFinancialProductsResponse;
  fetchFlag: FetchFlagResponse;
  /** Catalog of all flag types with inherited vs effective policy for an org. */
  fetchFlagGlossary: Array<FlagGlossaryEntry>;
  /**
   * Counts FLAGGED flags. Optional 'organizationId' narrows to a child org
   * via 'organizationParents', mirroring fetchFlagsForGrid. Optional
   * 'unresolvedBefore' is the inclusive firstSeenAt cutoff for the
   * unresolvedOverThreeDays tile; defaults to now - 3d.
   */
  fetchFlagKPIs: FlagKpIs;
  /** Static catalog of every flag type with its derived policy metadata. */
  fetchFlagTypeMetadata: Array<FlagTypeMetadata>;
  fetchFlags: FetchFlagsResponse;
  /**
   * Non-ARCHIVED flags for one activity via Flag.details._id. Fixed
   * firstSeenAt DESC + _id tiebreaker (grid age order; stable paging).
   * Blank detailsId is rejected.
   */
  fetchFlagsForActivity: FetchFlagsResponse;
  fetchFlagsForGrid: FetchFlagsResponse;
  fetchForeignExchangeRate: FetchForeignExchangeRateResponse;
  fetchForeignExchangeSnapshots: FetchForeignExchangeSnapshotsResponse;
  fetchFormAgreement: FormAgreement;
  fetchFormCompletion: FormCompletion;
  fetchFormCompletions: FetchFormCompletionsResponse;
  fetchFormDefinition: FormDefinition;
  fetchFormDefinitions: FetchFormDefinitionsResponse;
  fetchFormMap: FormMap;
  /** @deprecated Use formMapResult and select context. */
  fetchFormMapContext: FetchFormMapContextPayload;
  /** @deprecated Type is deprecated, Use input instead. */
  fetchFormTemplate: FormTemplate;
  fetchFormTemplates: FetchFormTemplatesResponse;
  fetchFraudRisk: FetchFraudRiskResponse;
  fetchGoal: FetchGoalResponse;
  fetchGoalByIntegrationId: FetchGoalResponse;
  fetchGoalUpdates: FetchGoalUpdatesResponse;
  fetchGoals: FetchGoalsResponse;
  fetchGroupedBillings: FetchGroupedBillingsResponse;
  /** @deprecated Please use fetchStatsHistory instead. */
  fetchHistory: FetchHistoryResponse;
  fetchHistoryBulkUpsertItem: FetchHistoryBulkUpsertItemResponse;
  fetchHistoryBulkUpsertItems: FetchHistoryBulkUpsertItemsResponse;
  fetchHoldingBulkUpsertItem: FetchHoldingBulkUpsertItemResponse;
  fetchHoldingBulkUpsertItems: FetchHoldingBulkUpsertItemsResponse;
  fetchHoldingProductSummaries: FetchHoldingProductSummariesResponse;
  fetchHoldings: FetchHoldingsResponse;
  fetchHomePageConfiguration: FetchHomePageConfigurationResponse;
  fetchHomePageConfigurations: FetchHomePageConfigurationsResponse;
  fetchHomePageWidgetOptions: FetchHomePageWidgetOptionsResponse;
  fetchImportFile: FetchImportFileResponse;
  fetchImportFileLineItem: FetchImportFileLineItemResponse;
  fetchImportFileLineItems: FetchImportFileLineItemsResponse;
  fetchImportFileTemplate: FetchImportFileTemplateResponse;
  fetchImportFiles: FetchImportFilesResponse;
  fetchInstitution: FetchInstitutionResponse;
  fetchInstitutions: FetchInstitutionsResponse;
  fetchIntegration: FetchIntegrationResponse;
  fetchIntegrationFormPack: IntegrationFormPack;
  /**
   * Fetches a short-lived DocuSign Recipient View URL for the given signerKey (embedded signing).
   * Requires SENT pack, DocuSign integration, and a pack created after DocuSign signer refs were added at create time.
   */
  fetchIntegrationFormPackSigningViewUrl: FetchIntegrationFormPackSigningViewUrlResponse;
  fetchIntegrationFormPacks: FetchIntegrationFormPacksResponse;
  fetchIntegrationRequestPayload: IntegrationRequestPayload;
  fetchIntegrationRequestPayloads: FetchIntegrationRequestPayloadsResponse;
  fetchIntegrationStatefulData: FetchIntegrationStatefulDataResponse;
  fetchIntegrations: FetchIntegrationsResponse;
  fetchJobTitleRisk: FetchJobTitleRiskResponse;
  fetchLocalization?: Maybe<FetchLocalizationResponse>;
  fetchLocalizations?: Maybe<FetchLocalizationsResponse>;
  /** Fetch a singular log */
  fetchLog: FetchLogResponse;
  /** Returns an array of logs objects for the provided input details */
  fetchLogs: FetchLogsResponse;
  fetchLsegSamlRequest: FetchLsegSamlRequestResponse;
  fetchManualProcess: FetchManualProcessResponse;
  fetchMarketDataFromProvider: FetchMarketDataFromProviderResponse;
  fetchModelChangeProposal: FetchModelChangeProposalResponse;
  fetchModelChangeProposals: FetchModelChangeProposalsResponse;
  fetchModelPortfolio: FetchModelPortfolioResponse;
  fetchModelPortfolioByIntegrationId: FetchModelPortfolioResponse;
  fetchModelPortfolioChildren: FetchModelPortfolioChildrenResponse;
  fetchModelPortfolios: FetchModelPortfoliosResponse;
  /** Fetch a singular note */
  fetchNote: FetchNoteResponse;
  /** Returns an array of notes objects for the provided input details */
  fetchNotes: FetchNotesResponse;
  fetchNotificationDefinition: FetchNotificationDefinitionResponse;
  fetchNotificationDefinitions: FetchNotificationDefinitionsResponse;
  fetchNotificationGroup: FetchNotificationGroupResponse;
  fetchNotificationGroups: FetchNotificationGroupsResponse;
  fetchNotifications: FetchNotificationsResponse;
  fetchOptimalPortfolio: FetchOptimalPortfolioResponse;
  fetchOptimizedPortfolioReports: FetchOptimizedPortfolioReportsResponse;
  fetchOptimizerAuditsV2: FetchOptimizerAuditsV2Response;
  fetchOptimizerRunV2: FetchOptimizerRunV2Response;
  fetchOptimizerRunsV2: FetchOptimizerRunsV2Response;
  /** Fetch a singular organization by its id or subdomain */
  fetchOrganization: FetchOrganizationResponse;
  fetchOrganizationBulkUpsertItem: FetchOrganizationBulkUpsertItemResponse;
  fetchOrganizationBulkUpsertItems: FetchOrganizationBulkUpsertItemsResponse;
  /** Fetch a singular organization by integration id */
  fetchOrganizationByIntegrationId: FetchOrganizationResponse;
  /** A single dashboard by ID, including dashboards inherited from parent organizations. */
  fetchOrganizationDashboard: FetchOrganizationDashboardResponse;
  /** Dashboards for an organization, including any inherited from parent organizations. Returns active dashboards unless states or archived is set. */
  fetchOrganizationDashboards: FetchOrganizationDashboardsResponse;
  /** Fetch the organization feature flag settings */
  fetchOrganizationFeatureFlag: FetchOrganizationFeatureFlagResponse;
  fetchOrganizationPublicSettings: FetchOrganizationPublicSettingsResponse;
  fetchOrganizationSubdomain: FetchOrganizationSubdomainResponse;
  /** Fetch a singular organization user */
  fetchOrganizationUser: FetchOrganizationUserResponse;
  /** Fetch a singular organization user by email */
  fetchOrganizationUserByEmail: FetchOrganizationUserResponse;
  /** Fetch a singular organization user by integration id */
  fetchOrganizationUserByIntegrationId: FetchOrganizationUserResponse;
  /** Fetch a singular organization user by reference id */
  fetchOrganizationUserByReferenceId: FetchOrganizationUserResponse;
  /** Fetch a paginated list of organization users */
  fetchOrganizationUsers: FetchOrganizationUsersResponse;
  /** Fetch a paginated list of organizations */
  fetchOrganizations: FetchOrganizationsResponse;
  fetchPageConfiguration: FetchPageConfigurationResponse;
  /** Flattened fields of the gateway object type mapped to the page type, read through the private gateway for the page configuration field picker. Fails when the gateway does not know the type. */
  fetchPageConfigurationSchemaType: PageConfigurationSchemaType;
  fetchPageConfigurations: FetchPageConfigurationsResponse;
  /** Fetch a all permissions */
  fetchPermissions: FetchPermissionsResponse;
  /**
   * Fetch full address details for a selected suggestion.
   * Pass the integration ID and address ID returned from searchPhysicalAddress.
   */
  fetchPhysicalAddress: FetchPhysicalAddressResponse;
  fetchPortfolioOptimizer: FetchPortfolioOptimizerResponse;
  fetchPortfolioOptimizers: FetchPortfolioOptimizersResponse;
  fetchPortfolioReports: FetchPortfolioReportsResponse;
  fetchPortfolioReportsByHoldingProduct: FetchPortfolioReportsByHoldingProductResponse;
  fetchPortfolioTemplate: FetchPortfolioTemplateResponse;
  fetchPortfolioTemplates: FetchPortfolioTemplatesResponse;
  fetchProductAumExposure: FetchProductAumExposureResponse;
  /** Fetch a paginated list of organizations with limited attributes that is accessible without the read:organizaitons permission */
  fetchPublicOrganizations: FetchPublicOrganizationsResponse;
  fetchRebalance: FetchRebalanceResponse;
  fetchRebalanceHoldingReports: FetchRebalanceHoldingReportsResponse;
  fetchRebalanceMetrics: FetchRebalanceMetricsResponse;
  fetchRebalanceReports: FetchRebalanceReportsResponse;
  fetchRebalances: FetchRebalancesResponse;
  fetchRepCode: FetchRepCodeResponse;
  fetchRepCodes: FetchRepCodesResponse;
  fetchReport: FetchReportResponse;
  fetchReportOptions: FetchReportOptionsResponse;
  fetchReports: FetchReportsResponse;
  fetchRequiredForms: FetchRequiredFormsResponse;
  /** Resolve advisor contacts for client-facing display with curated identity, visibility, and rank sort. */
  fetchResolvedAdvisorContacts: FetchResolvedAdvisorContactsResponse;
  /** Fetch a singular role */
  fetchRole: FetchRoleResponse;
  fetchRoleProfile: FetchRoleProfileResponse;
  fetchRoleProfiles: FetchRoleProfilesResponse;
  /** Fetch a paginated list of roles */
  fetchRoles: FetchRolesResponse;
  fetchSalesTaxConfiguration: FetchSalesTaxConfigurationResponse;
  fetchSchedule: FetchScheduleResponse;
  fetchScheduledTransfer: FetchScheduledTransferResponse;
  fetchScheduledTransfers: FetchScheduledTransfersResponse;
  fetchSchedules: FetchSchedulesResponse;
  /** Fetch SIEM feeds for organizations accessible to the caller */
  fetchSiemFeeds: FetchSiemFeedsResponse;
  fetchSignerTypes: FetchSignerTypesResponse;
  /** Returns a temporary S3 storage URL for uploading an account statement. Call this just prior to mutation createAccountStatement. */
  fetchStatementUploadUrl?: Maybe<FetchStatementUploadUrlResponse>;
  fetchStaticPageWidgetConfiguration: FetchStaticPageWidgetConfigurationResponse;
  fetchStaticPageWidgetConfigurations: FetchStaticPageWidgetConfigurationsResponse;
  fetchStaticWidgetOptions: FetchStaticWidgetOptionsResponse;
  fetchStatsHistory: FetchStatsHistoryResponse;
  fetchSubAccount: FetchSubAccountResponse;
  fetchSubAccountBilling: FetchSubAccountBillingResponse;
  fetchSubAccountBillings: FetchSubAccountBillingsResponse;
  fetchSubAccountDailyFee: FetchSubAccountDailyFeeResponse;
  fetchSubAccountDailyFees: FetchSubAccountDailyFeesResponse;
  fetchSubAccountUpdates: FetchSubAccountUpdatesResponse;
  fetchSubAccounts: FetchSubAccountsResponse;
  fetchSubStepOptions: FetchSubStepOptionsResponse;
  fetchSubTradeRequest: FetchSubTradeRequestResponse;
  fetchSubTradeRequests: FetchSubTradeRequestsResponse;
  fetchSubTrades: FetchSubTradesResponse;
  /** Fetch external table data for a configurable table page */
  fetchTableExternalData: FetchTableExternalDataResponse;
  fetchTheme?: Maybe<FetchThemeResponse>;
  fetchThemes: FetchThemesResponse;
  fetchTradeRequest: FetchTradeRequestResponse;
  fetchTradeRequests: FetchTradeRequestsResponse;
  fetchTrades: FetchTradesResponse;
  fetchTransaction: FetchTransactionResponse;
  fetchTransactionCustodianTypes: FetchTransactionCustodianTypesResponse;
  fetchTransactionTypes: FetchTransactionsTypesResponse;
  fetchTransactions: FetchTransactionsResponse;
  fetchTransfer: FetchTransferResponse;
  fetchTransferByIntegrationId: FetchTransferResponse;
  fetchTransfers: FetchTransfersResponse;
  fetchUpcomingTransfers: FetchUpcomingTransfersResponse;
  /** Returns an object for the user associated with the userID */
  fetchUser: FetchUserResponse;
  fetchUserBulkUpsertItem: FetchUserBulkUpsertItemResponse;
  fetchUserBulkUpsertItems: FetchUserBulkUpsertItemsResponse;
  /** Returns an object for the user associated with the unique IntegrationId for an integration */
  fetchUserByIntegrationId: FetchUserResponse;
  /** Returns an object for the UserIdVerification details associated with the idVerificationID */
  fetchUserIdVerification: UserIdVerificationResponse;
  /** Returns an array of objects for the userIdVerifications associated with the provided input details  */
  fetchUserIdVerifications: FetchUserIdVerificationsResponse;
  /** Returns user updates given a specific user */
  fetchUserUpdates: FetchUserUpdatesResponse;
  /** Returns an array of objects for the Users associated with the provided input details */
  fetchUsers: FetchUsersResponse;
  /** Fetch the visible alert banners for an orgUser */
  fetchVisibleAlertBanners: FetchVisibleAlertBannersResponse;
  fetchWebhook: FetchWebhookResponse;
  fetchWebhooks: FetchWebhooksResponse;
  fetchWidgetOptions: FetchWidgetOptionsResponse;
  fetchWorkflow: FetchWorkflowResponse;
  fetchWorkflowCompletion: FetchWorkflowCompletionResponse;
  fetchWorkflowCompletions: FetchWorkflowCompletionsResponse;
  fetchWorkflows: FetchWorkflowsResponse;
  /** @deprecated Use formMapResult.pdf(pdfTemplateBase64) and select base64, signatureFieldLocations, and errors. */
  fillFormMapToPdf: FillFormMapToPdfOutput;
  /** @deprecated Use formMapResult.context instead. */
  formMapContextQuery: FormMapContextQueryPayload;
  formMapResult: FormMapResultPayload;
  generateNextBestActions: GenerateNextBestActionsResponse;
  generateRebalanceInsightNarrative: GenerateRebalanceInsightNarrativeResponse;
  generateReport: GenerateReportResponse;
  /** Fetches the logged in user */
  me: OrganizationUser;
  previewClientReport?: Maybe<PreviewClientReportResponse>;
  previewFilledPdf: PreviewFilledPdfResponse;
  previewFormAgreement: PreviewFormAgreementResponse;
  renderFormAgreement: RenderFormAgreementResponse;
  /** @deprecated Use formMapResult.resolvedFormMap { value errors }. */
  resolveFormMapValues: ResolveFormMapValuesOutput;
  searchAccounts?: Maybe<AccountSearchResult>;
  /**
   * Search for physical address suggestions using Google or Canada Post integration.
   * Pass the integration ID and search text - the backend will securely retrieve the API key.
   */
  searchPhysicalAddress: SearchPhysicalAddressResponse;
  searchProductsInProvider: SearchProductsInProviderResponse;
  searchUsers?: Maybe<UserSearchResult>;
  suggestFinancialProduct?: Maybe<SuggestFinancialProductResponse>;
  testClientReportTemplate?: Maybe<TestClientReportTemplateResponse>;
  /** Returns whether or not client's age (based on birth date) is above age of majority. Country parameter uses two-letter country code format (ISO 3166-1 alpha-2). */
  validateAgeOfMajority: ValidateAgeOfMajorityResponse;
  /** Returns whether or not given tax id (SIN, SSN, etc.) is syntactically valid */
  validateTaxId: Scalars['Boolean']['output'];
};


export type QueryCalculateGoalSuitabilityScoreArgs = {
  input: CalculateGoalSuitabilityScoreInput;
};


export type QueryCalculateWithdrawFeesArgs = {
  input: CalculateWithdrawFeesInput;
};


export type QueryDownloadAccountStatementsArgs = {
  input: DownloadAccountStatementsInput;
};


export type QueryDownloadFileDocumentsArgs = {
  input: DownloadFileDocumentsInput;
};


export type QueryFetchAccountArgs = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  input?: InputMaybe<FetchAccountInput>;
};


export type QueryFetchAccountBulkUpsertItemArgs = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
};


export type QueryFetchAccountBulkUpsertItemsArgs = {
  input: FetchAccountBulkUpsertItemsInput;
};


export type QueryFetchAccountByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchAccountFeeArgs = {
  accountFeeId: Scalars['ObjectID']['input'];
};


export type QueryFetchAccountFeesArgs = {
  input: FetchAccountFeesInput;
};


export type QueryFetchAccountGroupArgs = {
  accountGroupId: Scalars['ObjectID']['input'];
};


export type QueryFetchAccountGroupBulkUpsertItemArgs = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
};


export type QueryFetchAccountGroupBulkUpsertItemsArgs = {
  input: FetchAccountGroupBulkUpsertItemsInput;
};


export type QueryFetchAccountGroupsArgs = {
  input: FetchAccountGroupsInput;
};


export type QueryFetchAccountReconciliationSnapshotArgs = {
  accountReconciliationSnapshotId: Scalars['ObjectID']['input'];
};


export type QueryFetchAccountReconciliationSnapshotsArgs = {
  input: FetchAccountReconciliationSnapshotsInput;
};


export type QueryFetchAccountStatementArgs = {
  accountStatementId: Scalars['ObjectID']['input'];
};


export type QueryFetchAccountStatementAccountsArgs = {
  input: FetchAccountStatementsInput;
};


export type QueryFetchAccountStatementDocumentArgs = {
  accountStatementId?: InputMaybe<Scalars['SafeString']['input']>;
  documentDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  filter?: InputMaybe<FetchAccountStatementDocumentFilter>;
  objectId?: InputMaybe<Scalars['SafeString']['input']>;
  objectType?: InputMaybe<AccountStatementObjectTypes>;
  type?: InputMaybe<StatementTypes>;
};


export type QueryFetchAccountStatementTypesArgs = {
  input: FetchAccountStatementsInput;
};


export type QueryFetchAccountStatementsArgs = {
  input: FetchAccountStatementsInput;
};


export type QueryFetchAccountTypesArgs = {
  input?: InputMaybe<FetchAccountTypesInput>;
};


export type QueryFetchAccountsArgs = {
  input: FetchAccountsInput;
};


export type QueryFetchAdvisorContactArgs = {
  advisorContactId: Scalars['ObjectID']['input'];
  organizationId: Scalars['ObjectID']['input'];
};


export type QueryFetchAdvisorContactsArgs = {
  input: FetchAdvisorContactsInput;
};


export type QueryFetchAlertBannerArgs = {
  alertBannerId: Scalars['ObjectID']['input'];
};


export type QueryFetchAlertBannersArgs = {
  input: FetchAlertBannersInput;
};


export type QueryFetchAlertReportArgs = {
  input: FetchAlertReportInput;
};


export type QueryFetchAlertReportsArgs = {
  input: FetchAlertReportsInput;
};


export type QueryFetchAncestorInheritedAssignmentsArgs = {
  input: FetchAncestorInheritedAssignmentsInput;
};


export type QueryFetchApiExportArgs = {
  input: FetchApiExportInput;
};


export type QueryFetchApiExportsArgs = {
  input: FetchApiExportsInput;
};


export type QueryFetchApplicableDowntimeScheduleArgs = {
  platform: Platforms;
};


export type QueryFetchArticleArgs = {
  articleId: Scalars['ObjectID']['input'];
  ignoreRoleTargeting?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFetchArticlesArgs = {
  input: FetchArticlesInput;
};


export type QueryFetchAssetClassesArgs = {
  input?: InputMaybe<FetchAssetClassesInput>;
};


export type QueryFetchAssignedCountsByFinancialProductArgs = {
  input: FetchAssignedCountsByFinancialProductInput;
};


export type QueryFetchAvailableReportVariablesArgs = {
  input: FetchAvailableReportVariablesInput;
};


export type QueryFetchAvailableThemesArgs = {
  input: FetchAvailableThemesInput;
};


export type QueryFetchBankAccountArgs = {
  bankAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  input?: InputMaybe<FetchBankAccountInput>;
};


export type QueryFetchBankAccountBulkUpsertItemArgs = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
};


export type QueryFetchBankAccountBulkUpsertItemsArgs = {
  input: FetchBankAccountBulkUpsertItemsInput;
};


export type QueryFetchBankAccountByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchBankAccountsArgs = {
  input: FetchBankAccountsInput;
};


export type QueryFetchBankConnectionsArgs = {
  input: FetchBankConnectionsInput;
};


export type QueryFetchBeneficiariesArgs = {
  input: FetchBeneficiariesInput;
};


export type QueryFetchBeneficiaryArgs = {
  beneficiaryId: Scalars['ObjectID']['input'];
};


export type QueryFetchBillingCycleArgs = {
  billingCycleId: Scalars['ObjectID']['input'];
};


export type QueryFetchBillingCyclesArgs = {
  input: FetchBillingCyclesInput;
};


export type QueryFetchBillingScheduleArgs = {
  billingScheduleId: Scalars['ObjectID']['input'];
};


export type QueryFetchBillingSchedulesArgs = {
  input: FetchBillingSchedulesInput;
};


export type QueryFetchBulkImportArgs = {
  bulkImportId: Scalars['ObjectID']['input'];
};


export type QueryFetchBulkImportsArgs = {
  input: FetchBulkImportsInput;
};


export type QueryFetchBulkTradeRequestArgs = {
  bulkTradeRequestId: Scalars['ObjectID']['input'];
};


export type QueryFetchBulkTradeRequestsArgs = {
  input: FetchBulkTradeRequestsInput;
};


export type QueryFetchBulkTradeRunArgs = {
  bulkTradeRunId: Scalars['ObjectID']['input'];
};


export type QueryFetchBulkTradeRunAllocationsArgs = {
  input: FetchBulkTradeRunAllocationsInput;
};


export type QueryFetchBulkTradeRunsArgs = {
  input: FetchBulkTradeRunsInput;
};


export type QueryFetchBulkUpsertRequestArgs = {
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
};


export type QueryFetchBulkUpsertRequestsArgs = {
  input: FetchBulkUpsertRequestsInput;
};


export type QueryFetchClientAdvisorVisibilityArgs = {
  input: FetchClientAdvisorVisibilityInput;
};


export type QueryFetchClientGroupArgs = {
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  input?: InputMaybe<FetchClientGroupInput>;
};


export type QueryFetchClientGroupByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchClientGroupsArgs = {
  input: FetchClientGroupsInput;
};


export type QueryFetchClientReportArgs = {
  clientReportId: Scalars['ObjectID']['input'];
};


export type QueryFetchClientReportTemplateArgs = {
  clientReportTemplateId: Scalars['ObjectID']['input'];
};


export type QueryFetchClientReportTemplateWidgetOptionsArgs = {
  widgetType: ClientReportTemplateWidgetConfigurationTypes;
};


export type QueryFetchClientReportTemplatesArgs = {
  input: FetchClientReportTemplatesInput;
};


export type QueryFetchClientReportsArgs = {
  input: FetchClientReportsInput;
};


export type QueryFetchConfigurableTableFilterOptionsArgs = {
  input: FetchConfigurableTableFilterOptionsInput;
};


export type QueryFetchConfigurableTablePageArgs = {
  configurableTablePageId: Scalars['ObjectID']['input'];
};


export type QueryFetchConfigurableTablePageReportArgs = {
  configurableTablePageExportId: Scalars['ObjectID']['input'];
};


export type QueryFetchConfigurableTablePageWidgetOptionsArgs = {
  widgetType: ConfigurableTablePageWidgetTypes;
};


export type QueryFetchConfigurableTablePagesArgs = {
  input: FetchConfigurableTablePagesInput;
};


export type QueryFetchCountryRiskArgs = {
  input: FetchCountryRiskInput;
};


export type QueryFetchCustodianArgs = {
  custodianId: Scalars['ObjectID']['input'];
};


export type QueryFetchCustodianActivitiesArgs = {
  input: FetchCustodianActivitiesInput;
};


export type QueryFetchCustodianActivitiesForGridArgs = {
  input: FetchCustodianActivitiesInputForGrid;
};


export type QueryFetchCustodianActivityChartTodayArgs = {
  input: FetchCustodianActivityChartTodayInput;
};


export type QueryFetchCustodianActivityChartTrendArgs = {
  input: FetchCustodianActivityChartTrendInput;
};


export type QueryFetchCustodianActivityMetricsArgs = {
  input: FetchCustodianActivityMetricsInput;
};


export type QueryFetchCustodianBankAccountsArgs = {
  input: FetchCustodianBankAccountsInput;
};


export type QueryFetchCustodianConnectionArgs = {
  custodianConnectionId: Scalars['ObjectID']['input'];
};


export type QueryFetchCustodianConnectionsArgs = {
  input: FetchCustodianConnectionsInput;
};


export type QueryFetchCustodianExternalDocumentArgs = {
  input: FetchCustodianExternalDocumentInput;
};


export type QueryFetchCustodianNotificationsArgs = {
  input: FetchCustodianNotificationsInput;
};


export type QueryFetchCustodianStatementsArgs = {
  input: FetchCustodianStatementsInput;
};


export type QueryFetchCustodianTransactionTypesArgs = {
  input: FetchCustodianTransactionTypesInput;
};


export type QueryFetchCustodianTransactionsArgs = {
  input: FetchCustodianTransactionsInput;
};


export type QueryFetchCustodianUpcomingTransactionsArgs = {
  input: FetchCustodianUpcomingTransactionsInput;
};


export type QueryFetchCustomAttributeLabelArgs = {
  customAttributeLabelId: Scalars['ObjectID']['input'];
  organizationId: Scalars['ObjectID']['input'];
};


export type QueryFetchCustomAttributeLabelsArgs = {
  input: FetchCustomAttributeLabelsInput;
};


export type QueryFetchCustomFieldArgs = {
  customFieldId: Scalars['ObjectID']['input'];
};


export type QueryFetchCustomFieldsArgs = {
  input: FetchCustomFieldsInput;
};


export type QueryFetchDisplayRoleArgs = {
  displayRoleId: Scalars['ObjectID']['input'];
  organizationId: Scalars['ObjectID']['input'];
};


export type QueryFetchDisplayRolesArgs = {
  input: FetchDisplayRolesInput;
};


export type QueryFetchDowntimeScheduleArgs = {
  downtimeScheduleId: Scalars['ObjectID']['input'];
};


export type QueryFetchDowntimeSchedulesArgs = {
  input: FetchDowntimeSchedulesInput;
};


export type QueryFetchEntityFeeSettingsArgs = {
  entityType: FeeEntity;
  input: FetchEntityFeeSettingsInput;
};


export type QueryFetchEodFilesArgs = {
  input: FetchEodFilesInput;
};


export type QueryFetchEventsArgs = {
  input: FetchEventsInput;
};


export type QueryFetchExportArgs = {
  input: FetchExportInput;
};


export type QueryFetchExternalVendorUsagesArgs = {
  input?: InputMaybe<FetchExternalVendorUsageInput>;
};


export type QueryFetchFeeSettingArgs = {
  input?: InputMaybe<FetchFeeSettingInput>;
};


export type QueryFetchFeeTierArgs = {
  feeTierId: Scalars['ObjectID']['input'];
};


export type QueryFetchFeeTiersArgs = {
  input: FetchFeeTiersInput;
};


export type QueryFetchFileDocumentArgs = {
  fileDocumentId: Scalars['ObjectID']['input'];
};


export type QueryFetchFileDocumentsArgs = {
  input: FetchFileDocumentsInput;
};


export type QueryFetchFileUploadUrlArgs = {
  input: FetchFileUploadUrlInput;
};


export type QueryFetchFillTemplateArgs = {
  input: FetchFillTemplateInput;
};


export type QueryFetchFinancialProductArgs = {
  input: FetchFinancialProductInput;
};


export type QueryFetchFinancialProductBulkUpsertItemArgs = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
};


export type QueryFetchFinancialProductBulkUpsertItemsArgs = {
  input: FetchFinancialProductBulkUpsertItemsInput;
};


export type QueryFetchFinancialProductByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchFinancialProductPriceHistoryArgs = {
  input: FinancialProductPriceHistoryInput;
};


export type QueryFetchFinancialProductsArgs = {
  input: FetchFinancialProductsInput;
};


export type QueryFetchFlagArgs = {
  flagId: Scalars['ID']['input'];
};


export type QueryFetchFlagGlossaryArgs = {
  organizationId: Scalars['ObjectID']['input'];
};


export type QueryFetchFlagKpIsArgs = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  unresolvedBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};


export type QueryFetchFlagsArgs = {
  input: FetchFlagsInput;
};


export type QueryFetchFlagsForActivityArgs = {
  input: FetchFlagsForActivityInput;
};


export type QueryFetchFlagsForGridArgs = {
  input: FetchFlagsInputForGrid;
};


export type QueryFetchForeignExchangeRateArgs = {
  input: FetchForeignExchangeRateInput;
};


export type QueryFetchForeignExchangeSnapshotsArgs = {
  input: FetchForeignExchangeSnapshotsInput;
};


export type QueryFetchFormAgreementArgs = {
  input: FetchFormAgreementInput;
};


export type QueryFetchFormCompletionArgs = {
  formCompletionId: Scalars['ObjectID']['input'];
};


export type QueryFetchFormCompletionsArgs = {
  input: FetchFormCompletionsInput;
};


export type QueryFetchFormDefinitionArgs = {
  formDefinitionId: Scalars['ObjectID']['input'];
};


export type QueryFetchFormDefinitionsArgs = {
  input: FetchFormDefinitionsInput;
};


export type QueryFetchFormMapArgs = {
  formMapId: Scalars['ObjectID']['input'];
};


export type QueryFetchFormMapContextArgs = {
  input: FetchFormMapContextInput;
};


export type QueryFetchFormTemplateArgs = {
  input?: InputMaybe<FetchFormTemplateInput>;
  type?: InputMaybe<FormTypes>;
};


export type QueryFetchFormTemplatesArgs = {
  input: FetchFormTemplatesInput;
};


export type QueryFetchFraudRiskArgs = {
  input: FetchFraudRiskInput;
};


export type QueryFetchGoalArgs = {
  goalId: Scalars['ObjectID']['input'];
};


export type QueryFetchGoalByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchGoalUpdatesArgs = {
  input: FetchGoalUpdatesInput;
};


export type QueryFetchGoalsArgs = {
  input: FetchGoalsInput;
};


export type QueryFetchGroupedBillingsArgs = {
  input: FetchGroupedBillingsInput;
};


export type QueryFetchHistoryArgs = {
  input: FetchHistoryInput;
};


export type QueryFetchHistoryBulkUpsertItemArgs = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
};


export type QueryFetchHistoryBulkUpsertItemsArgs = {
  input: FetchHistoryBulkUpsertItemsInput;
};


export type QueryFetchHoldingBulkUpsertItemArgs = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
};


export type QueryFetchHoldingBulkUpsertItemsArgs = {
  input: FetchHoldingBulkUpsertItemsInput;
};


export type QueryFetchHoldingProductSummariesArgs = {
  input: FetchHoldingProductSummariesInput;
};


export type QueryFetchHoldingsArgs = {
  input: FetchHoldingsInput;
};


export type QueryFetchHomePageConfigurationArgs = {
  homePageConfigurationId: Scalars['ObjectID']['input'];
};


export type QueryFetchHomePageConfigurationsArgs = {
  input: FetchHomePageConfigurationsInput;
};


export type QueryFetchHomePageWidgetOptionsArgs = {
  widgetType: HomePageWidgetConfigurationTypes;
};


export type QueryFetchImportFileArgs = {
  importFileId: Scalars['ObjectID']['input'];
};


export type QueryFetchImportFileLineItemArgs = {
  importFileLineItemId: Scalars['ObjectID']['input'];
};


export type QueryFetchImportFileLineItemsArgs = {
  input: FetchImportFileLineItemsInput;
};


export type QueryFetchImportFileTemplateArgs = {
  importFileType: ImportFileTypes;
};


export type QueryFetchImportFilesArgs = {
  input: FetchImportFilesInput;
};


export type QueryFetchInstitutionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFetchInstitutionsArgs = {
  input: FetchInstitutionsInput;
};


export type QueryFetchIntegrationArgs = {
  integrationId: Scalars['ObjectID']['input'];
};


export type QueryFetchIntegrationFormPackArgs = {
  integrationFormPackId: Scalars['ObjectID']['input'];
};


export type QueryFetchIntegrationFormPackSigningViewUrlArgs = {
  input: FetchIntegrationFormPackSigningViewUrlInput;
};


export type QueryFetchIntegrationFormPacksArgs = {
  input: FetchIntegrationFormPacksInput;
};


export type QueryFetchIntegrationRequestPayloadArgs = {
  integrationRequestPayloadId: Scalars['ObjectID']['input'];
};


export type QueryFetchIntegrationRequestPayloadsArgs = {
  input: FetchIntegrationRequestPayloadsInput;
};


export type QueryFetchIntegrationStatefulDataArgs = {
  input: FetchIntegrationStatefulDataInput;
};


export type QueryFetchIntegrationsArgs = {
  input: FetchIntegrationsInput;
};


export type QueryFetchJobTitleRiskArgs = {
  input: FetchJobTitleRiskInput;
};


export type QueryFetchLocalizationArgs = {
  localizationId: Scalars['ObjectID']['input'];
};


export type QueryFetchLocalizationsArgs = {
  input: FetchLocalizationsInput;
};


export type QueryFetchLogArgs = {
  logId: Scalars['ObjectID']['input'];
};


export type QueryFetchLogsArgs = {
  input: FetchLogsInput;
};


export type QueryFetchLsegSamlRequestArgs = {
  input: FetchLsegSamlRequestInput;
};


export type QueryFetchManualProcessArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFetchMarketDataFromProviderArgs = {
  input: FetchMarketDataFromProviderInput;
};


export type QueryFetchModelChangeProposalArgs = {
  input: FetchModelChangeProposalInput;
};


export type QueryFetchModelChangeProposalsArgs = {
  input: FetchModelChangeProposalsInput;
};


export type QueryFetchModelPortfolioArgs = {
  input: FetchModelPortfolioInput;
};


export type QueryFetchModelPortfolioByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchModelPortfolioChildrenArgs = {
  input: FetchModelPortfolioChildrenInput;
};


export type QueryFetchModelPortfoliosArgs = {
  input: FetchModelPortfoliosInput;
};


export type QueryFetchNoteArgs = {
  noteId: Scalars['ObjectID']['input'];
};


export type QueryFetchNotesArgs = {
  input: FetchNotesInput;
};


export type QueryFetchNotificationDefinitionArgs = {
  notificationDefinitionId: Scalars['ObjectID']['input'];
};


export type QueryFetchNotificationDefinitionsArgs = {
  input: FetchNotificationDefinitionsInput;
};


export type QueryFetchNotificationGroupArgs = {
  notificationGroupId: Scalars['ObjectID']['input'];
};


export type QueryFetchNotificationGroupsArgs = {
  input: FetchNotificationGroupsInput;
};


export type QueryFetchNotificationsArgs = {
  input: FetchNotificationsInput;
};


export type QueryFetchOptimalPortfolioArgs = {
  input: FetchOptimalPortfolioInput;
};


export type QueryFetchOptimizedPortfolioReportsArgs = {
  input: FetchOptimizedPortfolioReportsInput;
};


export type QueryFetchOptimizerAuditsV2Args = {
  input: FetchOptimizerAuditsV2Input;
};


export type QueryFetchOptimizerRunV2Args = {
  input: FetchOptimizerRunV2Input;
};


export type QueryFetchOptimizerRunsV2Args = {
  input: FetchOptimizerRunsV2Input;
};


export type QueryFetchOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryFetchOrganizationBulkUpsertItemArgs = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
};


export type QueryFetchOrganizationBulkUpsertItemsArgs = {
  input: FetchOrganizationBulkUpsertItemsInput;
};


export type QueryFetchOrganizationByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchOrganizationDashboardArgs = {
  dashboardId: Scalars['ObjectID']['input'];
};


export type QueryFetchOrganizationDashboardsArgs = {
  input: FetchOrganizationDashboardsInput;
};


export type QueryFetchOrganizationFeatureFlagArgs = {
  organizationId: Scalars['ObjectID']['input'];
};


export type QueryFetchOrganizationPublicSettingsArgs = {
  input: FetchOrganizationPublicSettingsInput;
};


export type QueryFetchOrganizationSubdomainArgs = {
  input: FetchOrganizationSubdomainInput;
};


export type QueryFetchOrganizationUserArgs = {
  organizationUserId: Scalars['ObjectID']['input'];
};


export type QueryFetchOrganizationUserByEmailArgs = {
  input: FetchOrganizationUserByEmailInput;
};


export type QueryFetchOrganizationUserByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchOrganizationUserByReferenceIdArgs = {
  input: FetchOrganizationUserByReferenceIdInput;
};


export type QueryFetchOrganizationUsersArgs = {
  input: FetchOrganizationUsersInput;
};


export type QueryFetchOrganizationsArgs = {
  input: FetchOrganizationsInput;
};


export type QueryFetchPageConfigurationArgs = {
  pageConfigurationId: Scalars['ObjectID']['input'];
};


export type QueryFetchPageConfigurationSchemaTypeArgs = {
  pageType: PageConfigurationTypes;
};


export type QueryFetchPageConfigurationsArgs = {
  input: FetchPageConfigurationsInput;
};


export type QueryFetchPhysicalAddressArgs = {
  input: FetchPhysicalAddressInput;
};


export type QueryFetchPortfolioOptimizerArgs = {
  input: FetchPortfolioOptimizerInput;
};


export type QueryFetchPortfolioOptimizersArgs = {
  input: FetchPortfolioOptimizersInput;
};


export type QueryFetchPortfolioReportsArgs = {
  input: FetchPortfolioReportsInput;
};


export type QueryFetchPortfolioReportsByHoldingProductArgs = {
  input: FetchPortfolioReportsByHoldingProductInput;
};


export type QueryFetchPortfolioTemplateArgs = {
  input: FetchPortfolioTemplateInput;
};


export type QueryFetchPortfolioTemplatesArgs = {
  input: FetchPortfolioTemplatesInput;
};


export type QueryFetchProductAumExposureArgs = {
  input: FetchProductAumExposureInput;
};


export type QueryFetchPublicOrganizationsArgs = {
  input: FetchPublicOrganizationsInput;
};


export type QueryFetchRebalanceArgs = {
  rebalanceId: Scalars['ObjectID']['input'];
};


export type QueryFetchRebalanceHoldingReportsArgs = {
  input: FetchRebalanceHoldingReportsInput;
};


export type QueryFetchRebalanceMetricsArgs = {
  input: FetchRebalanceMetricsInput;
};


export type QueryFetchRebalanceReportsArgs = {
  input: FetchRebalanceReportsInput;
};


export type QueryFetchRebalancesArgs = {
  input: FetchRebalancesInput;
};


export type QueryFetchRepCodeArgs = {
  repCodeId: Scalars['ObjectID']['input'];
};


export type QueryFetchRepCodesArgs = {
  input: FetchRepCodesInput;
};


export type QueryFetchReportArgs = {
  input: FetchReportInput;
};


export type QueryFetchReportOptionsArgs = {
  input: FetchReportOptionsInput;
};


export type QueryFetchReportsArgs = {
  input: FetchReportsInput;
};


export type QueryFetchRequiredFormsArgs = {
  input: FetchRequiredFormsInput;
};


export type QueryFetchResolvedAdvisorContactsArgs = {
  input: FetchResolvedAdvisorContactsInput;
};


export type QueryFetchRoleArgs = {
  roleId: Scalars['ObjectID']['input'];
};


export type QueryFetchRoleProfileArgs = {
  roleProfileId: Scalars['ObjectID']['input'];
};


export type QueryFetchRoleProfilesArgs = {
  input: FetchRoleProfilesInput;
};


export type QueryFetchRolesArgs = {
  input: FetchRolesInput;
};


export type QueryFetchSalesTaxConfigurationArgs = {
  input: FetchSalesTaxConfigurationInput;
};


export type QueryFetchScheduleArgs = {
  scheduleId: Scalars['ObjectID']['input'];
};


export type QueryFetchScheduledTransferArgs = {
  scheduledTransferId: Scalars['ObjectID']['input'];
};


export type QueryFetchScheduledTransfersArgs = {
  input: FetchScheduledTransfersInput;
};


export type QueryFetchSchedulesArgs = {
  input?: InputMaybe<FetchSchedulesInput>;
};


export type QueryFetchSiemFeedsArgs = {
  input?: InputMaybe<FetchSiemFeedsInput>;
};


export type QueryFetchSignerTypesArgs = {
  input: FetchSignerTypesInput;
};


export type QueryFetchStatementUploadUrlArgs = {
  input: FetchStatementUploadUrlInput;
};


export type QueryFetchStaticPageWidgetConfigurationArgs = {
  staticPageWidgetConfigurationId: Scalars['ObjectID']['input'];
};


export type QueryFetchStaticPageWidgetConfigurationsArgs = {
  input: FetchStaticPageWidgetConfigurationsInput;
};


export type QueryFetchStaticWidgetOptionsArgs = {
  widgetType: StaticWidgetConfigurationTypes;
};


export type QueryFetchStatsHistoryArgs = {
  input: FetchStatsHistoryInput;
};


export type QueryFetchSubAccountArgs = {
  subAccountId: Scalars['ObjectID']['input'];
};


export type QueryFetchSubAccountBillingArgs = {
  subAccountBillingId: Scalars['ObjectID']['input'];
};


export type QueryFetchSubAccountBillingsArgs = {
  input: FetchSubAccountBillingsInput;
};


export type QueryFetchSubAccountDailyFeeArgs = {
  subAccountDailyFeeId: Scalars['ObjectID']['input'];
};


export type QueryFetchSubAccountDailyFeesArgs = {
  input: FetchSubAccountDailyFeesInput;
};


export type QueryFetchSubAccountUpdatesArgs = {
  input: FetchSubAccountUpdatesInput;
};


export type QueryFetchSubAccountsArgs = {
  input: FetchSubAccountsInput;
};


export type QueryFetchSubStepOptionsArgs = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  subStepType: SubStepTypes;
};


export type QueryFetchSubTradeRequestArgs = {
  subTradeRequestId: Scalars['ObjectID']['input'];
};


export type QueryFetchSubTradeRequestsArgs = {
  input: FetchSubTradeRequestsInput;
};


export type QueryFetchSubTradesArgs = {
  input: FetchSubTradesInput;
};


export type QueryFetchTableExternalDataArgs = {
  input: FetchTableExternalDataInput;
};


export type QueryFetchThemeArgs = {
  themeId: Scalars['ObjectID']['input'];
};


export type QueryFetchThemesArgs = {
  input: FetchThemesInput;
};


export type QueryFetchTradeRequestArgs = {
  tradeRequestId: Scalars['ObjectID']['input'];
};


export type QueryFetchTradeRequestsArgs = {
  input: FetchTradeRequestsInput;
};


export type QueryFetchTradesArgs = {
  input: FetchTradesInput;
};


export type QueryFetchTransactionArgs = {
  transactionId: Scalars['ObjectID']['input'];
};


export type QueryFetchTransactionCustodianTypesArgs = {
  input: FetchTransactionsTypesInput;
};


export type QueryFetchTransactionTypesArgs = {
  input: FetchTransactionsTypesInput;
};


export type QueryFetchTransactionsArgs = {
  input: FetchTransactionsInput;
};


export type QueryFetchTransferArgs = {
  transferId: Scalars['ObjectID']['input'];
};


export type QueryFetchTransferByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchTransfersArgs = {
  input: FetchTransfersInput;
};


export type QueryFetchUpcomingTransfersArgs = {
  input: FetchUpcomingTransfersInput;
};


export type QueryFetchUserArgs = {
  input?: InputMaybe<FetchUserInput>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type QueryFetchUserBulkUpsertItemArgs = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
};


export type QueryFetchUserBulkUpsertItemsArgs = {
  input: FetchUserBulkUpsertItemsInput;
};


export type QueryFetchUserByIntegrationIdArgs = {
  integrationId: Scalars['SafeString']['input'];
};


export type QueryFetchUserIdVerificationArgs = {
  idVerificationId: Scalars['ObjectID']['input'];
};


export type QueryFetchUserIdVerificationsArgs = {
  input: FetchUserIdVerificationsInput;
};


export type QueryFetchUserUpdatesArgs = {
  input: FetchUserUpdatesInput;
};


export type QueryFetchUsersArgs = {
  input: FetchUsersInput;
};


export type QueryFetchVisibleAlertBannersArgs = {
  input: FetchVisibleAlertBannersInput;
};


export type QueryFetchWebhookArgs = {
  webhookId: Scalars['ObjectID']['input'];
};


export type QueryFetchWebhooksArgs = {
  input: FetchWebhooksInput;
};


export type QueryFetchWidgetOptionsArgs = {
  widgetType: WidgetConfigurationTypes;
};


export type QueryFetchWorkflowArgs = {
  workflowId: Scalars['ObjectID']['input'];
};


export type QueryFetchWorkflowCompletionArgs = {
  workflowCompletionId: Scalars['ObjectID']['input'];
};


export type QueryFetchWorkflowCompletionsArgs = {
  input: FetchWorkflowCompletionsInput;
};


export type QueryFetchWorkflowsArgs = {
  input: FetchWorkflowsInput;
};


export type QueryFillFormMapToPdfArgs = {
  input: FillFormMapToPdfInput;
};


export type QueryFormMapContextQueryArgs = {
  input: FormMapContextQueryInput;
};


export type QueryFormMapResultArgs = {
  input: FormMapResultInput;
};


export type QueryGenerateNextBestActionsArgs = {
  input: GenerateNextBestActionsInput;
};


export type QueryGenerateRebalanceInsightNarrativeArgs = {
  input: GenerateRebalanceInsightNarrativeInput;
};


export type QueryGenerateReportArgs = {
  input: GenerateReportInput;
};


export type QueryPreviewClientReportArgs = {
  input: GenerateClientReportInput;
};


export type QueryPreviewFilledPdfArgs = {
  input: PreviewFilledPdfInput;
};


export type QueryPreviewFormAgreementArgs = {
  input: PreviewFormAgreementInput;
};


export type QueryRenderFormAgreementArgs = {
  input: RenderFormAgreementInput;
};


export type QueryResolveFormMapValuesArgs = {
  input: ResolveFormMapValuesInput;
};


export type QuerySearchAccountsArgs = {
  input: AccountSearchInput;
};


export type QuerySearchPhysicalAddressArgs = {
  input: SearchPhysicalAddressInput;
};


export type QuerySearchProductsInProviderArgs = {
  input: SearchProductsInProviderInput;
};


export type QuerySearchUsersArgs = {
  input: UserSearchInput;
};


export type QuerySuggestFinancialProductArgs = {
  input: SuggestFinancialProductInput;
};


export type QueryTestClientReportTemplateArgs = {
  input: TestClientReportTemplateInput;
};


export type QueryValidateAgeOfMajorityArgs = {
  country: AddressCountries;
  dateOfBirth: Scalars['String']['input'];
  jurisdiction?: InputMaybe<AddressJurisdiction>;
};


export type QueryValidateTaxIdArgs = {
  taxId: Scalars['String']['input'];
  taxIdType: TaxIdTypes;
};

export type QueryFilter = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountType?: InputMaybe<HoldingAccountTypes>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  createdAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  initiatedByRepresentative?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  source?: InputMaybe<TransferSources>;
  sourceIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  sources?: InputMaybe<Array<TransferSources>>;
  state?: InputMaybe<TransferState>;
  states?: InputMaybe<Array<TransferState>>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  transferIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  type?: InputMaybe<TransferType>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export type ReAssessFraudRiskInput = {
  userId: Scalars['ObjectID']['input'];
};

export type ReAssessFraudRiskResponse = {
  __typename?: 'ReAssessFraudRiskResponse';
  fraudRisk: FraudRisk;
};

export type ReactivateGoalInput = {
  goalId: Scalars['ObjectID']['input'];
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
};

export type ReactivateGoalResponse = {
  __typename?: 'ReactivateGoalResponse';
  goal?: Maybe<Goal>;
};

export enum ReasonNames {
  CitizenshipRisk = 'CITIZENSHIP_RISK',
  ForeignPep = 'FOREIGN_PEP',
  ForeignTaxRisk = 'FOREIGN_TAX_RISK',
  IncomeAssetsMismatch = 'INCOME_ASSETS_MISMATCH',
  JobRisk = 'JOB_RISK',
  LargeIncomeToNetworth = 'LARGE_INCOME_TO_NETWORTH',
  LargeNsfs = 'LARGE_NSFS',
  LowIncomeLowAge = 'LOW_INCOME_LOW_AGE',
  NoInvestmentKnowledge = 'NO_INVESTMENT_KNOWLEDGE',
  SeveralNsfs = 'SEVERAL_NSFS',
  SpecialPersons = 'SPECIAL_PERSONS',
  YoungWithLargeIncome = 'YOUNG_WITH_LARGE_INCOME',
  ZeroAssets = 'ZERO_ASSETS'
}

export type Rebalance = {
  __typename?: 'Rebalance';
  /** Will return whether or not all the actualQuantity fields have been set on the trades */
  actualQuantitiesSet: Scalars['Boolean']['output'];
  /** @deprecated Use allocationFileUrls */
  allocationFileUrl?: Maybe<Scalars['String']['output']>;
  allocationFileUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bulkTrades: Array<BulkTradeType>;
  buyBulkTradeFileUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  mutualFundFileUrl?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<PublicOrganization>;
  ptfBulkTradeFileUrl?: Maybe<Scalars['String']['output']>;
  sellBulkTradeFileUrl?: Maybe<Scalars['String']['output']>;
  state: RebalanceStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<HoldingStateMachineChanges>>>;
};

export type RebalanceHoldingReport = {
  __typename?: 'RebalanceHoldingReport';
  account: Account;
  driftRebalanceRequired?: Maybe<Scalars['Boolean']['output']>;
  expectedPercentage: Scalars['Float']['output'];
  expectedValueCents: Scalars['Long']['output'];
  financialProduct: FinancialProduct;
  goal?: Maybe<Goal>;
  id: Scalars['ObjectID']['output'];
  lastReconciledAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  liquidateRebalanceRequired?: Maybe<Scalars['Boolean']['output']>;
  quantity: Scalars['Float']['output'];
  subAccount: SubAccount;
  ticker: Scalars['String']['output'];
  user: User;
  valueCents: Scalars['Long']['output'];
};

export type RebalanceHoldingReportQueryFilter = {
  subAccountId: Scalars['ObjectID']['input'];
};

export type RebalanceInsightAiContextInput = {
  accountTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  advisorNotes?: InputMaybe<Array<Scalars['String']['input']>>;
  attentionHighlights?: InputMaybe<Array<RunAttentionHighlightInput>>;
  cashDeployCents?: InputMaybe<Scalars['Long']['input']>;
  cashRaiseCents?: InputMaybe<Scalars['Long']['input']>;
  cashRunSummary?: InputMaybe<CashRunSummaryInput>;
  decisions?: InputMaybe<Array<DecisionSummaryInput>>;
  effectiveRebalanceMode?: InputMaybe<Scalars['String']['input']>;
  exits?: InputMaybe<Array<Scalars['String']['input']>>;
  failedCount?: InputMaybe<Scalars['Int']['input']>;
  failureReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  largestBuys?: InputMaybe<Array<Scalars['String']['input']>>;
  largestSells?: InputMaybe<Array<Scalars['String']['input']>>;
  newPositions?: InputMaybe<Array<Scalars['String']['input']>>;
  portfolioCount?: InputMaybe<Scalars['Int']['input']>;
  portfolioLabel?: InputMaybe<Scalars['String']['input']>;
  portfoliosWithSells?: InputMaybe<Scalars['Int']['input']>;
  portfoliosWithTaxableSells?: InputMaybe<Scalars['Int']['input']>;
  rebalanceMode?: InputMaybe<Scalars['String']['input']>;
  registeredSellCents?: InputMaybe<Scalars['Long']['input']>;
  runMode?: InputMaybe<Scalars['String']['input']>;
  runRegisteredSellCents?: InputMaybe<Scalars['Long']['input']>;
  runTaxableSellCents?: InputMaybe<Scalars['Long']['input']>;
  runType?: InputMaybe<Scalars['String']['input']>;
  scope: RebalanceInsightNarrativeScope;
  skippedCount?: InputMaybe<Scalars['Int']['input']>;
  succeededCount?: InputMaybe<Scalars['Int']['input']>;
  taxLocationMoves?: InputMaybe<Array<TaxLocationMoveInput>>;
  taxShelteredSellPct?: InputMaybe<Scalars['Float']['input']>;
  taxableSellCents?: InputMaybe<Scalars['Long']['input']>;
  topSituationSummaries?: InputMaybe<Array<RunSituationSummaryInput>>;
  topSituations?: InputMaybe<Array<RunSituationCountInput>>;
  totalBuyCents?: InputMaybe<Scalars['Long']['input']>;
  totalSellCents?: InputMaybe<Scalars['Long']['input']>;
  totalTradeCount?: InputMaybe<Scalars['Int']['input']>;
  triggers?: InputMaybe<Array<Scalars['String']['input']>>;
  turnoverBuyPct?: InputMaybe<Scalars['Float']['input']>;
  turnoverMedianPct?: InputMaybe<Scalars['Float']['input']>;
  turnoverP90Pct?: InputMaybe<Scalars['Float']['input']>;
  turnoverPct?: InputMaybe<Scalars['Float']['input']>;
  turnoverSellPct?: InputMaybe<Scalars['Float']['input']>;
};

export enum RebalanceInsightNarrativeScope {
  Portfolio = 'PORTFOLIO',
  Run = 'RUN'
}

export type RebalanceMetrics = {
  __typename?: 'RebalanceMetrics';
  accounts: Scalars['Int']['output'];
  buyQuantity: Scalars['Float']['output'];
  buyValueCents: Scalars['Long']['output'];
  full: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  screenedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  sellQuantity: Scalars['Float']['output'];
  sellValueCents: Scalars['Long']['output'];
  state: RebalanceMetricsStates;
  subAccounts: Scalars['Int']['output'];
  type: RebalanceMetricsTypes;
  users: Scalars['Int']['output'];
};

export enum RebalanceMetricsStates {
  Completed = 'COMPLETED',
  Generating = 'GENERATING'
}

export enum RebalanceMetricsTypes {
  Post = 'POST',
  Pre = 'PRE'
}

export enum RebalanceModeV2 {
  DeployCash = 'DEPLOY_CASH',
  FullRebalance = 'FULL_REBALANCE',
  RaiseCash = 'RAISE_CASH',
  ScopedCash = 'SCOPED_CASH'
}

export type RebalanceQueryFilter = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<RebalanceStates>;
};

export type RebalanceReport = {
  __typename?: 'RebalanceReport';
  account: Account;
  cashCents: Scalars['Int']['output'];
  cashOnHoldToTradeCents: Scalars['Int']['output'];
  contributionRebalanceRequired?: Maybe<Scalars['Boolean']['output']>;
  driftRebalanceRequired?: Maybe<Scalars['Boolean']['output']>;
  expectedCashCents: Scalars['Int']['output'];
  expectedPercentage: Scalars['Float']['output'];
  goal?: Maybe<Goal>;
  id: Scalars['ObjectID']['output'];
  lastRebalancedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  lastReconciledAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  liquidateRebalanceRequired?: Maybe<Scalars['Boolean']['output']>;
  marketValueCents: Scalars['Int']['output'];
  subAccount: SubAccount;
  user: User;
};

export type RebalanceReportQueryFilter = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  accountType?: InputMaybe<HoldingAccountTypes>;
  contributionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  full?: InputMaybe<Scalars['Boolean']['input']>;
  modelPortfolioIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  rebalanceType?: InputMaybe<RebalanceType>;
  sourceType?: InputMaybe<SourceTypesFilter>;
  subAccountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export enum RebalanceStates {
  AllocationCompleted = 'ALLOCATION_COMPLETED',
  AllocationInitiated = 'ALLOCATION_INITIATED',
  BulkTradeCompleted = 'BULK_TRADE_COMPLETED',
  BulkTradeInitiated = 'BULK_TRADE_INITIATED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  FixTradeCompleted = 'FIX_TRADE_COMPLETED',
  FixTradeInitiated = 'FIX_TRADE_INITIATED',
  Generating = 'GENERATING',
  Initiated = 'INITIATED'
}

export type RebalanceSubAccountsInput = {
  full?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type RebalanceSubAccountsResponse = {
  __typename?: 'RebalanceSubAccountsResponse';
  rebalance?: Maybe<Rebalance>;
};

export enum RebalanceTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  CompleteAllocation = 'completeAllocation',
  CompleteBulkTrade = 'completeBulkTrade',
  InitiateAllocation = 'initiateAllocation',
  InitiateBulkTrade = 'initiateBulkTrade',
  InitiateFixTrade = 'initiateFixTrade'
}

export enum RebalanceType {
  Contribution = 'CONTRIBUTION',
  Drift = 'DRIFT',
  Full = 'FULL'
}

export enum ReconToleranceBreakType {
  Cash = 'CASH'
}

export type ReconTolerancePolicy = {
  __typename?: 'ReconTolerancePolicy';
  breakType: ReconToleranceBreakType;
  /** Ceiling per account per UTC day, all currencies in one total. Max 50,000. Required when enabled. */
  dailyCapCents?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  notifyOnReconcile: Scalars['Boolean']['output'];
  /** Largest break auto-reconciled. Nominal cents, no FX — one value covers CAD and USD. Max 50,000. Required when enabled. */
  thresholdCents?: Maybe<Scalars['Int']['output']>;
};

export type ReconTolerancePolicyInput = {
  breakType: ReconToleranceBreakType;
  /** Ceiling per account per UTC day, all currencies in one total. 0..50,000. Required when enabled. */
  dailyCapCents?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnReconcile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Largest break auto-reconciled. Nominal cents, no FX — one value covers CAD and USD. 0..50,000. Required when enabled. */
  thresholdCents?: InputMaybe<Scalars['Int']['input']>;
};

export enum ReconTolerancePolicySource {
  Inherited = 'INHERITED',
  PlatformDefault = 'PLATFORM_DEFAULT',
  Self = 'SELF'
}

export type ReconcileCustodianActivityResponse = {
  __typename?: 'ReconcileCustodianActivityResponse';
  custodianActivity: CustodianActivity;
  failureMessage?: Maybe<Scalars['String']['output']>;
  failureType?: Maybe<Scalars['String']['output']>;
};

export enum ReconcileMethod {
  AutoMatch = 'AUTO_MATCH',
  Dismissed = 'DISMISSED'
}

export enum ReconcileProcessingBulkTradesEarlyExit {
  NoEligibleTrades = 'NO_ELIGIBLE_TRADES',
  NoOrganizations = 'NO_ORGANIZATIONS',
  NoProcessingTrades = 'NO_PROCESSING_TRADES'
}

export type ReconcileProcessingBulkTradesInput = {
  /**
   * Organization to close. Must be the caller or one of its descendants.
   * When omitted, the caller's organization is used.
   */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /**
   * Exclusive cutoff. PROCESSING bulk trades whose settlementDate is before this instant are reconciled.
   * When omitted, the cutoff is the exclusive end of the next America/Toronto business day.
   */
  settlementBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type ReconcileProcessingBulkTradesResponse = {
  __typename?: 'ReconcileProcessingBulkTradesResponse';
  closedCount: Scalars['Int']['output'];
  earlyExit?: Maybe<ReconcileProcessingBulkTradesEarlyExit>;
  errorCount: Scalars['Int']['output'];
  skippedMissingSettlementDate: Scalars['Int']['output'];
};

export enum ReconcileStages {
  DeferredTradeRequestTransitions = 'DEFERRED_TRADE_REQUEST_TRANSITIONS',
  PublishSnapshots = 'PUBLISH_SNAPSHOTS',
  ReconActivities = 'RECON_ACTIVITIES',
  ReconCashAndHoldings = 'RECON_CASH_AND_HOLDINGS',
  UpdateCashAndHoldings = 'UPDATE_CASH_AND_HOLDINGS'
}

export type ReconciledFees = {
  __typename?: 'ReconciledFees';
  feeCents?: Maybe<Scalars['Float']['output']>;
  salesTaxCents?: Maybe<Scalars['Float']['output']>;
};

export type RefreshPortfolioReportInput = {
  portfolioReportId: Scalars['ObjectID']['input'];
};

export type RefreshPortfolioReportResponse = {
  __typename?: 'RefreshPortfolioReportResponse';
  portfolioReport: PortfolioReport;
};

export type RefreshSubAccountBillingTotalsInput = {
  subAccountBillingId: Scalars['ObjectID']['input'];
};

export type RefreshSubAccountBillingTotalsResponse = {
  __typename?: 'RefreshSubAccountBillingTotalsResponse';
  subAccountBilling: SubAccountBilling;
};

export type RefreshSubAccountDailyFeeInput = {
  endDate: Scalars['GraphQLDate']['input'];
  organizationId: Scalars['ObjectID']['input'];
  startDate: Scalars['GraphQLDate']['input'];
};

export type RegenerateExternalTransferPdfInput = {
  manualProcessId: Scalars['ObjectID']['input'];
};

export type RegenerateExternalTransferPdfResponse = {
  __typename?: 'RegenerateExternalTransferPdfResponse';
  manualProcess?: Maybe<ManualProcess>;
};

export type RegenerateHtmlInput = {
  formAgreementId: Scalars['ObjectID']['input'];
};

export type RegenerateHtmlResponse = {
  __typename?: 'RegenerateHtmlResponse';
  html?: Maybe<Scalars['String']['output']>;
};

export type RegeneratePdfInput = {
  formAgreementId: Scalars['ObjectID']['input'];
};

export type RegeneratePdfResponse = {
  __typename?: 'RegeneratePdfResponse';
  formAgreement?: Maybe<FormAgreement>;
};

/** The integration enum and unique id for that integration to identify this user's profile */
export type RelatedEntity = {
  __typename?: 'RelatedEntity';
  /** User object as an relation entity */
  entity?: Maybe<User>;
  /** Enumeration value from RelatedEntityTypes */
  relation?: Maybe<RelatedEntityTypes>;
};

/** Input type for RelatedEntity field */
export type RelatedEntityInput = {
  /** entity UserId */
  entityId: Scalars['ObjectID']['input'];
  /** RelatedEntity relation ENUM */
  relation: RelatedEntityTypes;
};

/** Related Entity types for a user */
export enum RelatedEntityTypes {
  AuthorizedIndividual = 'AUTHORIZED_INDIVIDUAL',
  BeneficialOwner = 'BENEFICIAL_OWNER',
  Child = 'CHILD',
  Director = 'DIRECTOR',
  Friend = 'FRIEND',
  Grandchild = 'GRANDCHILD',
  Grandparent = 'GRANDPARENT',
  Grantor = 'GRANTOR',
  NieceNephew = 'NIECE_NEPHEW',
  Other = 'OTHER',
  Parent = 'PARENT',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  Protector = 'PROTECTOR',
  SeniorOfficer = 'SENIOR_OFFICER',
  Settlor = 'SETTLOR',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE',
  ThirdParty = 'THIRD_PARTY',
  TrustedContact = 'TRUSTED_CONTACT',
  Trustee = 'TRUSTEE'
}

/** Optional field that describes User's relationship to a primary account holder.   */
export enum Relation {
  Child = 'CHILD',
  Friend = 'FRIEND',
  Grandparent = 'GRANDPARENT',
  Other = 'OTHER',
  Parent = 'PARENT',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE'
}

/** Type details for clientGroup relationship */
export type Relationship = {
  __typename?: 'Relationship';
  /** client access type in the ClientGroup */
  accessType?: Maybe<ClientGroupMemberAccessTypes>;
  /** String input to define the kind of a relationship between users in clientGroup */
  type?: Maybe<Scalars['String']['output']>;
  /** user defined in the relationship object */
  user: User;
};

/** A set of inputs that describe details about User's relationship to another User.  */
export type RelationshipInput = {
  /** Defines the kind of access person has to User's accounts. For example: EDIT, NO_ACCESS, or VIEW.  */
  accessType?: InputMaybe<ClientGroupMemberAccessTypes>;
  /** Defines the kind of relationship between two Users. For example, string inputs like sister, parent, or partner.  */
  type?: InputMaybe<Scalars['SafeString']['input']>;
  /** userID of person who is in a relationship with User.  */
  userId: Scalars['ObjectID']['input'];
};

export type RemoveAffiliationInput = {
  accountId: Scalars['ObjectID']['input'];
  affiliationId: Scalars['ObjectID']['input'];
};

export type RemoveAffiliationResponse = {
  __typename?: 'RemoveAffiliationResponse';
  account: Account;
};

export type RemoveBulkTradeResponse = {
  __typename?: 'RemoveBulkTradeResponse';
  success: Scalars['Boolean']['output'];
};

export type RemoveEntityFromOrganizationUserInput = {
  entityId: Scalars['ObjectID']['input'];
  organizationUserId: Scalars['ObjectID']['input'];
};

export type RemoveEntityFromOrganizationUserResponse = {
  __typename?: 'RemoveEntityFromOrganizationUserResponse';
  organizationUser?: Maybe<OrganizationUser>;
};

export type RenderFormAgreementInput = {
  formAgreementId: Scalars['ObjectID']['input'];
};

export type RenderFormAgreementResponse = {
  __typename?: 'RenderFormAgreementResponse';
  html?: Maybe<Scalars['String']['output']>;
};

export type ReorderDisplayRolesInput = {
  displayRoleIds: Array<Scalars['ObjectID']['input']>;
  organizationId: Scalars['ObjectID']['input'];
};

export type ReorderDisplayRolesResponse = {
  __typename?: 'ReorderDisplayRolesResponse';
  displayRoles: Array<DisplayRole>;
};

export type RepCode = {
  __typename?: 'RepCode';
  archived: Scalars['Boolean']['output'];
  assignedUsers: Array<PublicOrganizationUser>;
  assignedUsersCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  /**
   * Deprecated: use designatedAdvisorContacts. Returns the closest-org contact from
   * that list for one release so already-deployed clients keep validating; remove once
   * onevest-app stops selecting it (cleanup: WLT-1189).
   * @deprecated Use designatedAdvisorContacts
   */
  designatedAdvisorContact?: Maybe<AdvisorContact>;
  /**
   * Every active advisor contact designated for this code across the requesting org's
   * ancestors and its subtree (never siblings), ordered by last then first name.
   * Designation is additive, so a code may have several designated contacts.
   */
  designatedAdvisorContacts: Array<AdvisorContact>;
  id: Scalars['ObjectID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<PublicOrganization>;
  state: RepCodeStates;
};

export type RepCodeQueryFilter = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<RepCodeStates>>>;
};

export enum RepCodeStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum RepCodeTransitions {
  Archive = 'archive'
}

export type RepairSnapshotsInput = {
  endDate: Scalars['GraphQLDate']['input'];
  startDate: Scalars['GraphQLDate']['input'];
  subAccountId: Scalars['ObjectID']['input'];
};

export type RepairSnapshotsResponse = {
  __typename?: 'RepairSnapshotsResponse';
  success: Scalars['Boolean']['output'];
};

export type ReplaceAccountGroupAccountsInput = {
  accountGroupId: Scalars['ObjectID']['input'];
  accountIds: Array<Scalars['ObjectID']['input']>;
};

export type ReplaceAccountGroupAccountsResponse = {
  __typename?: 'ReplaceAccountGroupAccountsResponse';
  accountGroup: AccountGroup;
};

export type Report = {
  __typename?: 'Report';
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Array<Rule>>;
  state: ReportStates;
  transfer?: Maybe<Transfer>;
};

export enum ReportAccessType {
  Organizational = 'ORGANIZATIONAL',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum ReportComparison {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanAgo = 'GREATER_THAN_AGO',
  In = 'IN',
  Includes = 'INCLUDES',
  LessThan = 'LESS_THAN',
  LessThanAgo = 'LESS_THAN_AGO',
  NotEquals = 'NOT_EQUALS',
  NotIncludes = 'NOT_INCLUDES',
  NotTextSearch = 'NOT_TEXT_SEARCH',
  TextSearch = 'TEXT_SEARCH'
}

export type ReportFilter = {
  __typename?: 'ReportFilter';
  /** The comparison for the field */
  comparison: ReportComparison;
  /** The field you are filtering on */
  field: Scalars['String']['output'];
  /** The value to be compared to the field */
  value: Scalars['String']['output'];
};

export type ReportFilterComparisons = {
  __typename?: 'ReportFilterComparisons';
  comparison: ReportComparison;
  options?: Maybe<Array<Scalars['String']['output']>>;
  valueTypes: ReportValueType;
};

/** Structure for a filter for a report */
export type ReportFilterInput = {
  /** The comparison for the field */
  comparison: ReportComparison;
  /** The field you are filtering on */
  field: Scalars['String']['input'];
  /** The value to be compared to the field */
  value: Scalars['String']['input'];
};

export type ReportFilterOptions = {
  __typename?: 'ReportFilterOptions';
  comparisons: Array<ReportFilterComparisons>;
  field: Scalars['String']['output'];
};

export type ReportGroupingInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<GroupingInterval>;
  type: GroupingType;
  valueAggregation: GroupingValueAggregation;
  valueField: Scalars['String']['input'];
};

export type ReportPaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportSortingInput = {
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export enum ReportStates {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Initiated = 'INITIATED',
  Review = 'REVIEW'
}

export enum ReportTransitions {
  Approved = 'approved',
  Denied = 'denied',
  Review = 'review'
}

export enum ReportType {
  Account = 'ACCOUNT',
  ClientGroup = 'CLIENT_GROUP',
  DailyStats = 'DAILY_STATS',
  Goal = 'GOAL',
  SubAccount = 'SUB_ACCOUNT',
  SubTradeRequest = 'SUB_TRADE_REQUEST',
  Trade = 'TRADE',
  Transaction = 'TRANSACTION',
  Transfer = 'TRANSFER',
  User = 'USER'
}

export enum ReportValueType {
  Date = 'DATE',
  Datetime = 'DATETIME',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT'
}

export type ReportVariableMeta = {
  __typename?: 'ReportVariableMeta';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RequiredSignature = {
  __typename?: 'RequiredSignature';
  height?: Maybe<Scalars['Int']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  signerKey: Scalars['String']['output'];
  signerUser?: Maybe<User>;
  signerUserId?: Maybe<Scalars['ObjectID']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type RequiredSignatureInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  signerKey: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Float']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type ResendIntegrationFormPackInput = {
  integrationFormPackId: Scalars['ObjectID']['input'];
};

export type ResendIntegrationFormPackResponse = {
  __typename?: 'ResendIntegrationFormPackResponse';
  integrationFormPack: IntegrationFormPack;
};

export type ResetOrganizationUserMultifactorInput = {
  organizationUserId: Scalars['ObjectID']['input'];
};

export type ResetOrganizationUserMultifactorResponse = {
  __typename?: 'ResetOrganizationUserMultifactorResponse';
  organizationUser?: Maybe<OrganizationUser>;
};

export type ResolutionPath = {
  __typename?: 'ResolutionPath';
  fieldSources: ResolvedFieldSources;
  reason: ResolutionReasons;
  viaRepCode?: Maybe<Scalars['String']['output']>;
};

export enum ResolutionReasons {
  DesignatedForRepCode = 'DESIGNATED_FOR_REP_CODE',
  GrantAccess = 'GRANT_ACCESS',
  RepCodeHolder = 'REP_CODE_HOLDER'
}

export type ResolveFormMapValuesInput = {
  applyDataMasking?: InputMaybe<Scalars['Boolean']['input']>;
  context?: InputMaybe<Scalars['Object']['input']>;
  formMap: FormMapInput;
  objectId: Scalars['ID']['input'];
  objectType?: InputMaybe<FormMapObjectType>;
};

export type ResolveFormMapValuesOutput = {
  __typename?: 'ResolveFormMapValuesOutput';
  errors: Array<FormMapError>;
  resolvedFormMap: ResolvedFormMap;
};

export type ResolvedAdvisorContact = {
  __typename?: 'ResolvedAdvisorContact';
  address?: Maybe<AdvisorContactAddress>;
  advisorContact?: Maybe<AdvisorContact>;
  displayRole?: Maybe<DisplayRole>;
  displayRoleLabel?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationUser?: Maybe<PublicOrganizationUser>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneExtension?: Maybe<Scalars['String']['output']>;
  resolutionPath: ResolutionPath;
  source: ResolvedAdvisorContactSources;
};

export enum ResolvedAdvisorContactSources {
  Curated = 'CURATED',
  Raw = 'RAW'
}

export type ResolvedFieldSources = {
  __typename?: 'ResolvedFieldSources';
  displayRole: FieldSources;
  email: FieldSources;
  firstName: FieldSources;
  lastName: FieldSources;
  phone: FieldSources;
  phoneExtension: FieldSources;
};

export type ResolvedFormMap = {
  __typename?: 'ResolvedFormMap';
  fields: Array<ResolvedFormMapField>;
  formDefinitionId: Scalars['String']['output'];
  objectType?: Maybe<FormMapObjectType>;
};

export type ResolvedFormMapField = {
  __typename?: 'ResolvedFormMapField';
  additionalValue?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  errorWhenEmpty?: Maybe<Scalars['Boolean']['output']>;
  formatter?: Maybe<FormMapFormatter>;
  signerKey?: Maybe<Scalars['String']['output']>;
  templateLabel: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ResolvedFormMapPayload = {
  __typename?: 'ResolvedFormMapPayload';
  errors: Array<FormMapError>;
  value: ResolvedFormMap;
};

export type RetryFailedWebhooksInput = {
  eventId: Scalars['ObjectID']['input'];
};

export type RetryFailedWebhooksResponse = {
  __typename?: 'RetryFailedWebhooksResponse';
  event: Event;
};

export type RevokeOrganizationUserInvitationResponse = {
  __typename?: 'RevokeOrganizationUserInvitationResponse';
  success: Scalars['Boolean']['output'];
};

export type RevokeSiemFeedCredentialInput = {
  credentialUuid: Scalars['String']['input'];
  siemFeedId: Scalars['ObjectID']['input'];
};

export type RevokeSiemFeedCredentialResponse = {
  __typename?: 'RevokeSiemFeedCredentialResponse';
  siemFeed: SiemFeed;
};

/** Risk levels from 1 (LEVEL_1) to 5 (LEVEL_5) as indicated by user, where level 1 is lowest risk tolerance. Used in suitability scores and portfolio recommendations. */
export enum RiskLevels {
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2',
  Level_3 = 'LEVEL_3',
  Level_4 = 'LEVEL_4',
  Level_5 = 'LEVEL_5'
}

export enum RiskRatings {
  High = 'HIGH',
  HighRiskCountryOrOccupation = 'HIGH_RISK_COUNTRY_OR_OCCUPATION',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type RiskReason = {
  __typename?: 'RiskReason';
  countryRisk?: Maybe<CountryRisk>;
  id: Scalars['ObjectID']['output'];
  jobTitleRisk?: Maybe<JobTitleRisk>;
  name?: Maybe<ReasonNames>;
  riskRating?: Maybe<RiskRatings>;
  translatedDescription?: Maybe<TransferMonitoringTranslatedString>;
  translatedDisplayName?: Maybe<TransferMonitoringTranslatedString>;
};

export type RiskReasonInput = {
  name?: InputMaybe<ReasonNames>;
};

export type Role = OrganizationExtensionResource & {
  __typename?: 'Role';
  /** List of accessible pages for the role */
  accessiblePages: Array<Pages>;
  /** Page configuration for account groups */
  accountGroupPageConfiguration?: Maybe<PageConfiguration>;
  /** Static Page Widget configuration for account groups table */
  accountGroupTableStaticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
  /** Page configuration for accounts */
  accountPageConfiguration?: Maybe<PageConfiguration>;
  /**
   * Auth0 Audience type
   * @deprecated no longer using a separate Client Auth0
   */
  authAudience?: Maybe<AuthAudienceTypes>;
  /** List of configurable table pages this role has access to */
  configurableTablePages: Array<ConfigurableTablePage>;
  /** List of dashboards this role has access to */
  dashboards: Array<Dashboard>;
  /** Maps the user's Access Type when creating an account via default sign up role. */
  defaultAccessType?: Maybe<OrganizationUserAccessTypes>;
  defaultAuthenticationConnection?: Maybe<AuthenticationConnections>;
  /** Extension key for tracking this resource across organizations */
  extensionKey?: Maybe<Scalars['String']['output']>;
  /** Version of the extension resource */
  extensionVersion?: Maybe<Scalars['String']['output']>;
  /** Maps the user's role when creating an account via an external connection. */
  externalRoleId?: Maybe<Scalars['String']['output']>;
  /** Page configuration for goals */
  goalPageConfiguration?: Maybe<PageConfiguration>;
  /** Page configuration for home page */
  homePageConfiguration?: Maybe<HomePageConfiguration>;
  /** Page configuration for households */
  householdPageConfiguration?: Maybe<PageConfiguration>;
  /** Static Page Widget configuration for households table */
  householdTableStaticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
  id: Scalars['ObjectID']['output'];
  /** Page configuration for individuals */
  individualPageConfiguration?: Maybe<PageConfiguration>;
  /** Static Page Widget configuration for individuals table */
  individualTableStaticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
  /** Sets household view as default */
  makeHouseholdDefaultView?: Maybe<Scalars['Boolean']['output']>;
  /** Navigation Style option */
  navigationStyle: NavigationStyles;
  /** Page configuration for non-individuals */
  nonIndividualPageConfiguration?: Maybe<PageConfiguration>;
  /** Static Page Widget configuration for non-individuals table */
  nonIndividualTableStaticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
  /** Organization that owns the role */
  organization: Organization;
  /** List of permissions that the role has access to */
  permissions: Array<Scalars['String']['output']>;
  /** Role Profile with limited attributes that is accessible from sub-organizations. */
  publicRoleProfile?: Maybe<PublicRoleProfile>;
  /** Resource key for unique identification within an extension */
  resourceKey?: Maybe<Scalars['String']['output']>;
  /** Role Profile */
  roleProfile?: Maybe<RoleProfile>;
  /** Type of role indicating the category of user */
  roleType?: Maybe<RoleTypes>;
  /** Page configuration for sub accounts */
  subAccountPageConfiguration?: Maybe<PageConfiguration>;
  /** The description of the role */
  translatedDescription: OrganizationTranslatedString;
  /** The name of the role */
  translatedName: OrganizationTranslatedString;
};

export type RolePaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type RoleProfile = OrganizationExtensionResource & {
  __typename?: 'RoleProfile';
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** Extension key for tracking this resource across organizations */
  extensionKey?: Maybe<Scalars['String']['output']>;
  /** Version of the extension resource */
  extensionVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  organization?: Maybe<Organization>;
  /** Organization with limited attributes that is accessible from sub-organizations. */
  publicOrganization?: Maybe<PublicOrganization>;
  /** Resource key for unique identification within an extension */
  resourceKey?: Maybe<Scalars['String']['output']>;
  /** Number of roles using this role profile */
  roleCount?: Maybe<Scalars['Int']['output']>;
  state: RoleProfileStates;
  template?: Maybe<RoleProfileTemplate>;
  translatedDescription: OrganizationTranslatedString;
  translatedName: OrganizationTranslatedString;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type RoleProfileQueryFilter = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
};

export enum RoleProfileStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type RoleProfileTemplate = {
  __typename?: 'RoleProfileTemplate';
  accessiblePages: Array<Pages>;
  /** Page configuration for account groups */
  accountGroupPageConfiguration?: Maybe<PageConfiguration>;
  /** Static Page Widget configuration for account groups table */
  accountGroupTableStaticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
  /** Page configuration for accounts */
  accountPageConfiguration?: Maybe<PageConfiguration>;
  /** List of configurable table pages this role profile template has access to */
  configurableTablePages: Array<ConfigurableTablePage>;
  dashboards: Array<Dashboard>;
  /** Page configuration for goals */
  goalPageConfiguration?: Maybe<PageConfiguration>;
  /** Page configuration for home page */
  homePageConfiguration?: Maybe<HomePageConfiguration>;
  /** Page configuration for households */
  householdPageConfiguration?: Maybe<PageConfiguration>;
  /** Static Page Widget configuration for households table */
  householdTableStaticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
  /** Page configuration for individuals */
  individualPageConfiguration?: Maybe<PageConfiguration>;
  /** Static Page Widget configuration for individuals table */
  individualTableStaticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
  /** Sets household view as default */
  makeHouseholdDefaultView?: Maybe<Scalars['Boolean']['output']>;
  /** Navigation Style option */
  navigationStyle: NavigationStyles;
  /** Page configuration for non-individuals */
  nonIndividualPageConfiguration?: Maybe<PageConfiguration>;
  /** Static Page Widget configuration for non-individuals table */
  nonIndividualTableStaticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
  permissions: Array<Scalars['String']['output']>;
  /** Page configuration for sub accounts */
  subAccountPageConfiguration?: Maybe<PageConfiguration>;
};

export type RoleProfileTemplateInput = {
  accessiblePages?: InputMaybe<Array<Pages>>;
  accountGroupPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountGroupTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  configurableTablePageIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  dashboards?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  goalPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  homePageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  individualPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  individualTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  navigationStyle?: InputMaybe<NavigationStyles>;
  nonIndividualPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  nonIndividualTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  permissions?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  subAccountPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum RoleProfileTransition {
  Archive = 'archive'
}

export type RoleQueryFilter = {
  /** @deprecated no longer using a separate Client Auth0 */
  authAudience?: InputMaybe<AuthAudienceTypes>;
  /** Role ID that you would to filter organization */
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  roleProfileId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Text used to search the names of the roles */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export enum RoleTypes {
  Admin = 'ADMIN',
  Advisor = 'ADVISOR',
  Client = 'CLIENT',
  ClientRepresentative = 'CLIENT_REPRESENTATIVE',
  ClientSupport = 'CLIENT_SUPPORT',
  Operations = 'OPERATIONS',
  Other = 'OTHER'
}

export type RotateSiemFeedCredentialInput = {
  siemFeedId: Scalars['ObjectID']['input'];
};

export type RotateSiemFeedCredentialResponse = {
  __typename?: 'RotateSiemFeedCredentialResponse';
  jwtToken: Scalars['String']['output'];
  siemFeed: SiemFeed;
};

export type Rule = {
  __typename?: 'Rule';
  id: Scalars['ObjectID']['output'];
  translatedDescription?: Maybe<TransferMonitoringTranslatedString>;
  type?: Maybe<RuleTypes>;
};

export enum RuleTypes {
  AboveLiquidity = 'ABOVE_LIQUIDITY',
  AboveNetworth = 'ABOVE_NETWORTH',
  AdverseNews = 'ADVERSE_NEWS',
  DepositInSameTimeframe = 'DEPOSIT_IN_SAME_TIMEFRAME',
  DormantAccount = 'DORMANT_ACCOUNT',
  ForAccountPurpose = 'FOR_ACCOUNT_PURPOSE',
  HasMultipleLargeDeposits = 'HAS_MULTIPLE_LARGE_DEPOSITS',
  HasMultipleLargeWithdrawals = 'HAS_MULTIPLE_LARGE_WITHDRAWALS',
  HighRiskUser = 'HIGH_RISK_USER',
  LargeDeposit = 'LARGE_DEPOSIT',
  LargeExternalTransfer = 'LARGE_EXTERNAL_TRANSFER',
  LargeWithdrawal = 'LARGE_WITHDRAWAL',
  LargeWithdrawInShortTime = 'LARGE_WITHDRAW_IN_SHORT_TIME',
  MultipleDepositInShortTime = 'MULTIPLE_DEPOSIT_IN_SHORT_TIME',
  NamesDoNotMatch = 'NAMES_DO_NOT_MATCH',
  WithdrawalToNewBankAccount = 'WITHDRAWAL_TO_NEW_BANK_ACCOUNT'
}

export type RunAttentionHighlightInput = {
  label: Scalars['String']['input'];
  portfolioCount: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RunPortfolioOptimizerInput = {
  bulkTradeRequiredReason?: InputMaybe<BulkTradeRunReasons>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  modelPortfolio?: InputMaybe<Scalars['ObjectID']['input']>;
  modelPortfolioType?: InputMaybe<ModelPortfolioTypes>;
  organizationId: Scalars['ObjectID']['input'];
  /**
   *  @deprecated This option will be removed in a future release
   * @deprecated This option will be removed in a future release
   */
  pauseAt?: InputMaybe<PortfolioOptimizerPausableStates>;
  pendingSubTradeRequests?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioReportId?: InputMaybe<Scalars['ObjectID']['input']>;
  portfolioReportIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PortfolioOptimizerTypes>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RunPortfolioOptimizerResponse = {
  __typename?: 'RunPortfolioOptimizerResponse';
  portfolioOptimizer: PortfolioOptimizer;
};

export type RunPortfolioOptimizerV2Input = {
  mode?: InputMaybe<OptimizerRunV2Mode>;
  organizationId: Scalars['ObjectID']['input'];
  portfolioReportId?: InputMaybe<Scalars['ObjectID']['input']>;
  preset: OptimizerV2Preset;
  /** When true, cash-only books use scoped deploy/raise allocators instead of full QP. */
  scopedRebalanceModesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type: OptimizerRunV2Type;
};

export type RunPortfolioOptimizerV2Response = {
  __typename?: 'RunPortfolioOptimizerV2Response';
  optimizerRun: OptimizerRunV2;
};

export type RunReconciliationInput = {
  organizationIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  reconcileStages?: InputMaybe<Array<InputMaybe<ReconcileStages>>>;
};

export type RunSituationCountInput = {
  portfolioCount: Scalars['Int']['input'];
  stage: Scalars['String']['input'];
};

export type RunSituationSummaryInput = {
  exampleSummary?: InputMaybe<Scalars['String']['input']>;
  portfolioCount: Scalars['Int']['input'];
  stage: Scalars['String']['input'];
};

export type RunWorkflowSubStepActionInput = {
  actionType?: InputMaybe<WorkflowActionTypes>;
  subStepId: Scalars['ObjectID']['input'];
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type RunWorkflowSubStepActionResponse = {
  __typename?: 'RunWorkflowSubStepActionResponse';
  workflowCompletion: WorkflowCompletion;
};

export type SalesTaxConfiguration = {
  __typename?: 'SalesTaxConfiguration';
  applicableDate: Scalars['GraphQLDate']['output'];
  effectiveConfiguration: EffectiveSalesTaxConfiguration;
  localRevision?: Maybe<SalesTaxConfigurationRevision>;
  organization: PublicOrganization;
};

export type SalesTaxConfigurationRevision = {
  __typename?: 'SalesTaxConfigurationRevision';
  configurableTaxes: Array<ConfigurableSalesTax>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  effectiveFrom: Scalars['GraphQLDate']['output'];
  id: Scalars['ObjectID']['output'];
  organization: PublicOrganization;
  schemaVersion: Scalars['Int']['output'];
};

export enum SalesTaxConfigurationSource {
  LegacyFallback = 'LEGACY_FALLBACK',
  Revision = 'REVISION'
}

export type SaveForeignExchangeRateInput = {
  date?: InputMaybe<Scalars['GraphQLDate']['input']>;
  from: Currencies;
  rate: Scalars['Float']['input'];
  to: Currencies;
};

export type SaveForeignExchangeRatesInput = {
  organizationId: Scalars['ObjectID']['input'];
  rates: Array<SaveForeignExchangeRateInput>;
};

export type SaveForeignExchangeRatesResponse = {
  __typename?: 'SaveForeignExchangeRatesResponse';
  organization: Organization;
  rates: Array<ForeignExchangeSnapshot>;
};

export type Schedule = {
  __typename?: 'Schedule';
  /** attached finanacial products */
  associatedFinancialProductsCount?: Maybe<Scalars['Int']['output']>;
  /** List of scheduled dates in descending order. */
  dates: Array<Maybe<Scalars['GraphQLDate']['output']>>;
  /** This is the scheduleId and it is auto-generated by OneVest for each Schedule. */
  id: Scalars['ObjectID']['output'];
  /** Name of the Schedule. */
  name: Scalars['String']['output'];
  /**
   * Next scheduled date based on list of dates.
   *
   * **UTC and inclusive of today.
   */
  nextDate?: Maybe<Scalars['GraphQLDate']['output']>;
  organization?: Maybe<PublicOrganization>;
};

export type ScheduleFilterQuery = {
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type ScheduledIncomeFundTransfer = {
  __typename?: 'ScheduledIncomeFundTransfer';
  amountPayableType?: Maybe<AmountPayableType>;
  annualAmountCents?: Maybe<Scalars['Long']['output']>;
  bankAccount: BankAccount;
  currency: Currencies;
  dateOfBirth?: Maybe<Scalars['GraphQLDate']['output']>;
  frequency: IncomeFundFrequency;
  /** Auto-generated ID for this Transfer. */
  id: Scalars['ObjectID']['output'];
  /** Why the most recent scheduled run was skipped. */
  lastSkipReason?: Maybe<Scalars['String']['output']>;
  /** When the most recent scheduled run was skipped without creating a transfer. */
  lastSkippedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  minimumAnnualAmountCents?: Maybe<Scalars['Long']['output']>;
  /** Set date to schedule an Transfer for a future date. */
  scheduledDate?: Maybe<Scalars['GraphQLDate']['output']>;
  specialTaxRate?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<ScheduledIncomeFundTransferStates>;
  subAccount: SubAccount;
  taxOption?: Maybe<TaxOptionType>;
  totalWithdrawalAmountOption?: Maybe<TotalWithdrawalAmountOption>;
};

/** Scheduled Income Fund Transfer States. */
export enum ScheduledIncomeFundTransferStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Canceled = 'CANCELED',
  Initiated = 'INITIATED',
  Reviewing = 'REVIEWING'
}

export enum ScheduledIncomeFundTransferTransferTransition {
  Archive = 'archive'
}

export type ScheduledTransfer = {
  __typename?: 'ScheduledTransfer';
  /** Transfer amount in cents. Minimum $100 (10000) */
  amountCents?: Maybe<Scalars['Long']['output']>;
  bankAccount?: Maybe<BankAccount>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  currency: Currencies;
  /** Date on which the scheduled Transfer will end */
  endDate?: Maybe<Scalars['GraphQLDate']['output']>;
  externalBankAccountId?: Maybe<Scalars['String']['output']>;
  fiscalYear?: Maybe<Scalars['Int']['output']>;
  /** Is this a **one_time** Transfer request or **daily**, **weekly**, **semi_monthly** or **monthly** recurring Transfer request? */
  frequency?: Maybe<Frequency>;
  /** Auto-generated ID for this Transfer. */
  id: Scalars['ObjectID']['output'];
  /**
   * instantInvest skips the holding period before the amount is invested
   * Only available to partners with the certainty of deposits that do not bounce
   */
  instantInvest?: Maybe<Scalars['Boolean']['output']>;
  /** Integrations associated with this scheduled transfer */
  integrations?: Maybe<Array<Maybe<HoldingIntegration>>>;
  /** Why the most recent scheduled run was skipped. */
  lastSkipReason?: Maybe<Scalars['String']['output']>;
  /** When the most recent scheduled run was skipped without creating a transfer. */
  lastSkippedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  representative?: Maybe<PublicOrganizationUser>;
  /** This an ID created by the partner, that is submitted with an Transfer request and unique to each request. */
  requestId?: Maybe<Scalars['String']['output']>;
  /** Set date to schedule an Transfer for a future date. */
  scheduledDate?: Maybe<Scalars['GraphQLDate']['output']>;
  state: ScheduledTransferStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<HoldingStateMachineChanges>>>;
  /** Scheduled transfer state in translated form (en, fr). */
  stateTranslated?: Maybe<HoldingTranslatedString>;
  /** Account that Transfer is processed in. For scheduled transfers between portfolios, this is the subAccount from where funds will be transferred. */
  subAccount: SubAccount;
  toSubAccount?: Maybe<SubAccount>;
  transferAll?: Maybe<Scalars['Boolean']['output']>;
  /** Type of Transfer request. DEPOSIT: depositTransfer WITHDRAW: withdrawTransfer */
  type?: Maybe<TransferType>;
  /** Transfer type in translated form (en, fr). */
  typeTranslated?: Maybe<HoldingTranslatedString>;
  withdrawalReason?: Maybe<WithdrawalReason>;
  withdrawalReasonDescription?: Maybe<Scalars['String']['output']>;
};

export type ScheduledTransferQueryFilter = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  bankAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  createdAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  frequency?: InputMaybe<Frequency>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  scheduledDate?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  scheduledDateAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  scheduledDateBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  state?: InputMaybe<ScheduledTransferStates>;
  states?: InputMaybe<Array<InputMaybe<ScheduledTransferStates>>>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  type?: InputMaybe<TransferType>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export enum ScheduledTransferStates {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Draft = 'DRAFT'
}

export type ScreenPortfoliosInput = {
  goalId: Scalars['ObjectID']['input'];
};

export type ScreenPortfoliosResponse = {
  __typename?: 'ScreenPortfoliosResponse';
  portfolioReport: PortfolioReport;
};

export enum SearchAccountStates {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Frozen = 'FROZEN',
  Inactive = 'INACTIVE',
  Initiated = 'INITIATED',
  Ready = 'READY',
  Requested = 'REQUESTED'
}

/** Input for searching physical address suggestions */
export type SearchPhysicalAddressInput = {
  /** ISO 3166-1 alpha-2. Google: filters results. Canada Post: the country to search; must be one of the integration's supportedCountries (defaults to the first one, or CA). */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Integration ID for the address provider (Google or Canada Post) */
  integrationId: Scalars['ObjectID']['input'];
  /** Language preference (e.g., 'en' or 'fr') */
  language?: InputMaybe<Scalars['String']['input']>;
  /**
   * Last ID for drill-down (Canada Post only)
   * Use the 'id' from a container result (where next="Find") to drill into it
   * Note: Canada Post returns 'next' field but expects 'lastId' parameter
   */
  lastId?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of results to return (Canada Post only, default: 8) */
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  /** Organization ID for fetching integration */
  organizationId: Scalars['ObjectID']['input'];
  /** The search query string */
  searchTerm: Scalars['String']['input'];
};

/** Response for physical address search */
export type SearchPhysicalAddressResponse = {
  __typename?: 'SearchPhysicalAddressResponse';
  suggestions: Array<AddressSuggestion>;
};

export type SearchProductsInProviderInput = {
  organizationId: Scalars['ObjectID']['input'];
  searchText: Scalars['String']['input'];
};

export type SearchProductsInProviderResponse = {
  __typename?: 'SearchProductsInProviderResponse';
  searchSuggestions?: Maybe<Array<ProductMarketData>>;
};

export type SecondaryAssetClassHoldings = {
  __typename?: 'SecondaryAssetClassHoldings';
  assetClass?: Maybe<AssetClass>;
  percentage?: Maybe<Scalars['Float']['output']>;
  securityHoldings?: Maybe<Array<Maybe<SecurityHoldings>>>;
  totalCents?: Maybe<Scalars['Long']['output']>;
};

export type SecurityHoldings = {
  __typename?: 'SecurityHoldings';
  financialProduct?: Maybe<FinancialProduct>;
  percentage?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Long']['output']>;
};

export enum SecurityTypes {
  AlternativeInvestments = 'ALTERNATIVE_INVESTMENTS',
  Annuity = 'ANNUITY',
  CashEquivalents = 'CASH_EQUIVALENTS',
  Currency = 'CURRENCY',
  Derivatives = 'DERIVATIVES',
  Equity = 'EQUITY',
  Etf = 'ETF',
  FixedIncome = 'FIXED_INCOME',
  MutualFund = 'MUTUAL_FUND',
  Other = 'OTHER'
}

export type SendIntegrationFormAgreementInput = {
  externalId: Scalars['String']['input'];
  signers: Array<FormAgreementIntegrationSignerInput>;
};

export type SendIntegrationFormAgreementResponse = {
  __typename?: 'SendIntegrationFormAgreementResponse';
  formAgreement: FormAgreement;
};

export type SendIntegrationFormPackInput = {
  integrationFormPackId: Scalars['ObjectID']['input'];
};

export type SendIntegrationFormPackResponse = {
  __typename?: 'SendIntegrationFormPackResponse';
  integrationFormPack: IntegrationFormPack;
};

export type SetAdvisorContactDesignationsInput = {
  advisorContactId: Scalars['ObjectID']['input'];
  codes: Array<Scalars['String']['input']>;
};

export type SetAdvisorContactDesignationsResponse = {
  __typename?: 'SetAdvisorContactDesignationsResponse';
  advisorContact: AdvisorContact;
  /**
   * Deprecated: designation is now additive and never displaces another contact,
   * so this is always empty. Kept for one release so already-deployed clients keep
   * validating; remove once onevest-app stops selecting it (cleanup: WLT-1189).
   * @deprecated Designation is additive; always empty
   */
  previousHolders: Array<AdvisorContactDesignationPreviousHolder>;
};

export type SetAllocationMethodologyInput = {
  allocationMethodology: AllocationMethodologies;
  portfolioReportId: Scalars['ObjectID']['input'];
};

export type SetAllocationMethodologyResponse = {
  __typename?: 'SetAllocationMethodologyResponse';
  portfolioReport: PortfolioReport;
};

/**
 * Persist adviser overrides after Allocate. Send every (subAccount, financialProduct)
 * cell changed in this Save; the backend validates the resulting grid (R5a/R5b) only.
 * Omit unchanged cells. To clear all overrides use setAllocationMethodology(UNIFIED).
 */
export type SetCustomExpectedPercentagesInput = {
  portfolioReportId: Scalars['ObjectID']['input'];
  /**
   * Only for applying an allocation the client has already signed. Skips the household
   * aggregate conservation check, so market moves during the signing window do not reject
   * the signed percentages. Per-sub-account checks still run. Interactive saves omit it.
   */
  skipAggregateConservation?: InputMaybe<Scalars['Boolean']['input']>;
  subAccounts: Array<SubAccountCustomAllocationInput>;
};

export type SetCustomExpectedPercentagesResponse = {
  __typename?: 'SetCustomExpectedPercentagesResponse';
  portfolioReport: PortfolioReport;
};

export type SetupEntityBoundModelInput = {
  /** Asset class branch (group weight) allocations for ASSET_CLASS strategy portfolios. */
  assetClassBranches?: InputMaybe<Array<AssetClassBranchInput>>;
  /** Asset class level for ASSET_CLASS strategy portfolios. */
  assetClassLevel?: InputMaybe<AssetClassLevel>;
  /** The shelf master model portfolio to clone as the entity's private model. */
  baseModelPortfolioId: Scalars['ObjectID']['input'];
  /** The id of the bound entity (e.g. the household ClientGroup id). */
  boundObjectId: Scalars['ObjectID']['input'];
  /** The kind of entity the private model is bound to (HOUSEHOLD in v1). */
  boundObjectType: BoundObjectType;
  /** Allocation branches (per-security weights) overriding the base model. */
  children?: InputMaybe<Array<InputMaybe<BranchInput>>>;
  /**
   * The organization that owns the bound entity (e.g. the household's
   * organization id. The clone is minted/reused in this org.
   * The shelf master is still resolved via org inheritance. Must be
   * the caller's organization or one below it in the hierarchy.
   */
  organizationId: Scalars['ObjectID']['input'];
  /**
   * When true, archive an existing live clone from a different shelf master and
   * mint a fresh clone from baseModelPortfolioId (Change-model flow).
   */
  replaceExistingBase?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Per-entity allocation overrides (e.g. from a CSV upload). When omitted, the
   * entity inherits the base model's allocations unchanged.
   */
  targetAllocations?: InputMaybe<Array<InputMaybe<TargetAllocationInput>>>;
  translatedInvestmentObjective?: InputMaybe<ProductTranslatedStringInput>;
  translatedLiquidity?: InputMaybe<ProductTranslatedStringInput>;
  /** IPS narrative overrides for the entity's private model. */
  translatedName?: InputMaybe<ProductTranslatedStringInput>;
  translatedPortfolioDescription?: InputMaybe<ProductTranslatedStringInput>;
  translatedPortfolioDisclaimer?: InputMaybe<ProductRichTextTranslatedStringInput>;
};

export type SetupEntityBoundModelResponse = {
  __typename?: 'SetupEntityBoundModelResponse';
  /** The entity-bound, ACTIVE private clone of the base model. */
  modelPortfolio: FinancialProduct;
  /** Warning messages surfaced while customizing the clone. */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type SftpCredentials = {
  __typename?: 'SftpCredentials';
  id: Scalars['ObjectID']['output'];
  sftpInAuthenticationType?: Maybe<Scalars['String']['output']>;
  sftpInBucket?: Maybe<Scalars['String']['output']>;
  sftpInBucketVariableName?: Maybe<Scalars['String']['output']>;
  sftpInDownloadFile?: Maybe<Scalars['Boolean']['output']>;
  sftpInHost?: Maybe<Scalars['String']['output']>;
  sftpInPassphrase?: Maybe<Scalars['String']['output']>;
  sftpInPassword?: Maybe<Scalars['String']['output']>;
  sftpInPort?: Maybe<Scalars['String']['output']>;
  sftpInPrivateKey?: Maybe<Scalars['String']['output']>;
  sftpInServerHostKey?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sftpInSourceDir?: Maybe<Scalars['String']['output']>;
  sftpInTargetPrefix?: Maybe<Scalars['String']['output']>;
  sftpInUsername?: Maybe<Scalars['String']['output']>;
  sftpOutAuthenticationType?: Maybe<Scalars['String']['output']>;
  sftpOutBucket?: Maybe<Scalars['String']['output']>;
  sftpOutBucketVariableName?: Maybe<Scalars['String']['output']>;
  sftpOutHost?: Maybe<Scalars['String']['output']>;
  sftpOutPassphrase?: Maybe<Scalars['String']['output']>;
  sftpOutPassword?: Maybe<Scalars['String']['output']>;
  sftpOutPort?: Maybe<Scalars['String']['output']>;
  sftpOutPrivateKey?: Maybe<Scalars['String']['output']>;
  sftpOutServerHostKey?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sftpOutTargetDir?: Maybe<Scalars['String']['output']>;
  sftpOutUsername?: Maybe<Scalars['String']['output']>;
};

export type SiemFeed = {
  __typename?: 'SiemFeed';
  credentialUuid: Scalars['String']['output'];
  eventTypes: Array<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  jwtToken: Scalars['String']['output'];
  lastSuccessfulPollAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  maxWindowMinutes: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organization: PublicOrganization;
  previousCredentials: Array<SiemFeedPreviousCredential>;
  state: SiemFeedStates;
  whitelistAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SiemFeedPreviousCredential = {
  __typename?: 'SiemFeedPreviousCredential';
  credentialUuid: Scalars['String']['output'];
  rotatedAt: Scalars['GraphQLDateTime']['output'];
};

export type SiemFeedQueryFilter = {
  childrenFor?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum SiemFeedStates {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum SiemFeedTransitions {
  Activate = 'activate',
  Deactivate = 'deactivate'
}

export type SignFormAgreementsInput = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  formAgreements?: InputMaybe<Array<InputMaybe<FormAgreementInput>>>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  language?: InputMaybe<Language>;
  requestIpAddress?: InputMaybe<Scalars['SafeString']['input']>;
  scheduledTransferId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** UserId of the client that will be signing the form in case multiple signatures are required */
  signedByUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type SignFormAgreementsResponse = {
  __typename?: 'SignFormAgreementsResponse';
  formAgreements: Array<Maybe<FormAgreement>>;
};

export type SignFormCompletionInput = {
  formCompletionId: Scalars['ObjectID']['input'];
};

export type SignFormCompletionResponse = {
  __typename?: 'SignFormCompletionResponse';
  formCompletion: FormCompletion;
};

export type Signature = {
  __typename?: 'Signature';
  organizationUser?: Maybe<PublicOrganizationUser>;
  requestIpAddress?: Maybe<Scalars['String']['output']>;
  signedAt: Scalars['GraphQLDateTime']['output'];
  signerKey?: Maybe<Scalars['String']['output']>;
};

export type SignatureFieldLocation = {
  __typename?: 'SignatureFieldLocation';
  height: Scalars['Float']['output'];
  pageNumber: Scalars['Int']['output'];
  signerKey: Scalars['String']['output'];
  signerUserId?: Maybe<Scalars['ObjectID']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type SignatureInput = {
  organizationUserId: Scalars['ObjectID']['input'];
  requestIpAddress?: InputMaybe<Scalars['String']['input']>;
  signerKey?: InputMaybe<Scalars['String']['input']>;
};

export enum SignaturePageNumberBase {
  One = 'ONE',
  Zero = 'ZERO'
}

export enum SignedUrlDocumentFormat {
  EncodedPdf = 'ENCODED_PDF'
}

export type SignerMapping = {
  __typename?: 'SignerMapping';
  height?: Maybe<Scalars['Int']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  signerKey: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type SignerMappingInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  signerKey: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type SignerType = FormExtensionResource & {
  __typename?: 'SignerType';
  createdAt: Scalars['GraphQLDateTime']['output'];
  defaultSigningOrder?: Maybe<Scalars['Int']['output']>;
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  resourceKey?: Maybe<Scalars['String']['output']>;
  roleProfiles?: Maybe<Array<RoleProfile>>;
  state: SignerTypeStates;
  translatedName?: Maybe<FormTranslatedString>;
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export enum SignerTypeStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum SignerTypeTransition {
  Archive = 'archive'
}

export type SignerTypesPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type SignerTypesQueryFilter = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
};

export type SnapshotForeignExchangeRate = {
  __typename?: 'SnapshotForeignExchangeRate';
  date?: Maybe<Scalars['GraphQLDate']['output']>;
  from: StatisticsCurrencyTypes;
  organization?: Maybe<Scalars['ObjectID']['output']>;
  rate: Scalars['Float']['output'];
  to: StatisticsCurrencyTypes;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type SnapshotHolding = {
  __typename?: 'SnapshotHolding';
  adjustedCostBaseCents?: Maybe<Scalars['Int']['output']>;
  bookValueCents?: Maybe<Scalars['Int']['output']>;
  currency: StatisticsCurrencyTypes;
  /** Per-unit ACB as reported by custodian (cents). Returns null for SubAccount/Goal. */
  custodianAdjustedCostBaseCents?: Maybe<Scalars['Float']['output']>;
  /** Book value as reported by custodian (cents). Returns null for SubAccount/Goal. */
  custodianBookValueCents?: Maybe<Scalars['Int']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  foreignExchangeRate?: Maybe<SnapshotForeignExchangeRate>;
  id: Scalars['ObjectID']['output'];
  /** Book value in the holding's original/execution currency (cents). */
  localBookValue?: Maybe<Scalars['Int']['output']>;
  /** ACB in the holding's original/execution currency (cents). */
  localCost?: Maybe<Scalars['Float']['output']>;
  /** Book value in the account's base currency (cents). */
  nativeBookValue?: Maybe<Scalars['Int']['output']>;
  /** ACB in the account's base currency (cents). */
  nativeCost?: Maybe<Scalars['Float']['output']>;
  originalCurrency?: Maybe<SnapshotHoldingOriginalCurrency>;
  priceCents?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
  ticker?: Maybe<Scalars['String']['output']>;
  totalCents: Scalars['Long']['output'];
};

export type SnapshotHoldingOriginalCurrency = {
  __typename?: 'SnapshotHoldingOriginalCurrency';
  adjustedCostBaseCents: Scalars['Float']['output'];
  bookValueCents: Scalars['Float']['output'];
  currency: StatisticsCurrencyTypes;
  priceCents?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
  totalCents: Scalars['Float']['output'];
};

export enum SourceOfFunds {
  Self = 'SELF',
  Spouse = 'SPOUSE',
  UsaEmploymentWages = 'USA_EMPLOYMENT_WAGES',
  UsaGift = 'USA_GIFT',
  UsaInheritanceTrust = 'USA_INHERITANCE_TRUST',
  UsaInvestments = 'USA_INVESTMENTS',
  UsaLegalSettlement = 'USA_LEGAL_SETTLEMENT',
  UsaLotteryGaming = 'USA_LOTTERY_GAMING',
  UsaOther = 'USA_OTHER',
  UsaRetirementFunds = 'USA_RETIREMENT_FUNDS',
  UsaSavings = 'USA_SAVINGS',
  UsaSpousalParentalSupport = 'USA_SPOUSAL_PARENTAL_SUPPORT',
  UsaUnemploymentDisability = 'USA_UNEMPLOYMENT_DISABILITY'
}

export enum SourceTypes {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export enum SourceTypesFilter {
  All = 'ALL',
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

/** Spouse's preferred honorific title.  */
export enum SpouseTitle {
  Dr = 'DR',
  Miss = 'MISS',
  Mr = 'MR',
  Mrs = 'MRS',
  Ms = 'MS'
}

export type StateMachineChanges = {
  __typename?: 'StateMachineChanges';
  createdAt: Scalars['GraphQLDateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

export type StatementPaginationAndSorting = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<PaginationCursorDirection>;
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['SafeString']['input']>;
};

export type StatementQueryFilter = {
  accountGroupId?: InputMaybe<Scalars['String']['input']>;
  /** This field will be deprecated, use accountIds instead that can accept multiple entries */
  accountId?: InputMaybe<Scalars['String']['input']>;
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accountType?: InputMaybe<AccountTypesFilters>;
  afterDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  beforeDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  clientGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  portfolioFlag?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<AccountStatementStates>;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
  /** This field will be deprecated, use types instead that can accept multiple entries */
  type?: InputMaybe<StatementTypes>;
  typeGroup?: InputMaybe<TypeGroup>;
  types?: InputMaybe<Array<InputMaybe<StatementTypes>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** AccountStatement sourceType */
export enum StatementSourceType {
  Generated = 'GENERATED',
  Uploaded = 'UPLOADED'
}

export type StatementTranslatedString = {
  __typename?: 'StatementTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type StatementTranslatedStringInput = {
  en?: InputMaybe<Scalars['SafeString']['input']>;
  es?: InputMaybe<Scalars['SafeString']['input']>;
  fr?: InputMaybe<Scalars['SafeString']['input']>;
};

export enum StatementTypes {
  AccountStatement = 'ACCOUNT_STATEMENT',
  AdministrativeFeesAnnualReport = 'ADMINISTRATIVE_FEES_ANNUAL_REPORT',
  AnnualAccountStatements = 'ANNUAL_ACCOUNT_STATEMENTS',
  AnnualPerformanceReport = 'ANNUAL_PERFORMANCE_REPORT',
  ConsolidatedMonthlyAccountStatements = 'CONSOLIDATED_MONTHLY_ACCOUNT_STATEMENTS',
  ManagementFeesAnnualReport = 'MANAGEMENT_FEES_ANNUAL_REPORT',
  MonthlyAccountStatements = 'MONTHLY_ACCOUNT_STATEMENTS',
  OvMonthlyAccountStatements = 'OV_MONTHLY_ACCOUNT_STATEMENTS',
  QuarterlyAccountStatements = 'QUARTERLY_ACCOUNT_STATEMENTS',
  TaxSlips_1099R = 'TAX_SLIPS_1099R',
  TaxSlipsConsolidated_1099 = 'TAX_SLIPS_CONSOLIDATED_1099',
  TaxSlipsFirst_60Days = 'TAX_SLIPS_FIRST_60_DAYS',
  TaxSlipsForm_480_6A = 'TAX_SLIPS_FORM_480_6A',
  TaxSlipsForm_480_6B = 'TAX_SLIPS_FORM_480_6B',
  TaxSlipsForm_1042S = 'TAX_SLIPS_FORM_1042_S',
  TaxSlipsForm_1099Q = 'TAX_SLIPS_FORM_1099_Q',
  TaxSlipsForm_1099R = 'TAX_SLIPS_FORM_1099_R',
  TaxSlipsForm_2439 = 'TAX_SLIPS_FORM_2439',
  TaxSlipsForm_5498 = 'TAX_SLIPS_FORM_5498',
  TaxSlipsLast_10Months = 'TAX_SLIPS_LAST_10_MONTHS',
  TaxSlipsNr4 = 'TAX_SLIPS_NR4',
  TaxSlipsRestOfYear = 'TAX_SLIPS_REST_OF_YEAR',
  TaxSlipsRl2 = 'TAX_SLIPS_RL2',
  TaxSlipsT3 = 'TAX_SLIPS_T3',
  TaxSlipsT3Breakdown = 'TAX_SLIPS_T3_BREAKDOWN',
  TaxSlipsT3Rl16 = 'TAX_SLIPS_T3_RL16',
  TaxSlipsT4A = 'TAX_SLIPS_T4A',
  TaxSlipsT4ARl1 = 'TAX_SLIPS_T4A_RL1',
  TaxSlipsT4Rif = 'TAX_SLIPS_T4RIF',
  TaxSlipsT4RifRl2 = 'TAX_SLIPS_T4RIF_RL2',
  TaxSlipsT4Rsp = 'TAX_SLIPS_T4RSP',
  TaxSlipsT4RspRl2 = 'TAX_SLIPS_T4RSP_RL2',
  TaxSlipsT4Fhsa = 'TAX_SLIPS_T4_FHSA',
  TaxSlipsT5 = 'TAX_SLIPS_T5',
  TaxSlipsT5Rl3 = 'TAX_SLIPS_T5_RL3',
  TaxSlipsT5008 = 'TAX_SLIPS_T5008',
  TaxSlipsT5013Rl15 = 'TAX_SLIPS_T5013_RL15',
  TaxSlipsTradingSummary = 'TAX_SLIPS_TRADING_SUMMARY',
  TaxSlipGeneral = 'TAX_SLIP_GENERAL',
  TradeConfirmation = 'TRADE_CONFIRMATION'
}

export type StaticPageWidgetConfiguration = OrganizationExtensionResource & {
  __typename?: 'StaticPageWidgetConfiguration';
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  /** Organization with limited attributes that is accessible from sub-organizations. */
  publicOrganization?: Maybe<PublicOrganization>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  state: StaticPageWidgetConfigurationStates;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  widget: StaticWidgetConfiguration;
};

export type StaticPageWidgetConfigurationQueryFilter = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<StaticPageWidgetConfigurationStates>>>;
  widgetType?: InputMaybe<StaticWidgetConfigurationTypes>;
};

export enum StaticPageWidgetConfigurationStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum StaticPageWidgetConfigurationTransitions {
  Archive = 'archive'
}

export type StaticWidgetConfiguration = {
  __typename?: 'StaticWidgetConfiguration';
  id: Scalars['ObjectID']['output'];
  options: Scalars['Object']['output'];
  type: StaticWidgetConfigurationTypes;
};

export type StaticWidgetConfigurationInput = {
  options?: InputMaybe<Scalars['Object']['input']>;
  type: StaticWidgetConfigurationTypes;
};

export enum StaticWidgetConfigurationTypes {
  AccountGroupTable = 'ACCOUNT_GROUP_TABLE',
  HouseholdTable = 'HOUSEHOLD_TABLE',
  IndividualTable = 'INDIVIDUAL_TABLE',
  NonIndividualTable = 'NON_INDIVIDUAL_TABLE'
}

export type StaticWidgetOption = {
  __typename?: 'StaticWidgetOption';
  default: Scalars['Object']['output'];
  key: Scalars['String']['output'];
  label: OrganizationTranslatedString;
  optionType: StaticWidgetOptionTypes;
  options?: Maybe<Scalars['Object']['output']>;
};

export enum StaticWidgetOptionTypes {
  Table = 'TABLE'
}

export type StatisticForeignExchangeRate = {
  __typename?: 'StatisticForeignExchangeRate';
  date?: Maybe<Scalars['GraphQLDate']['output']>;
  from: StatisticsCurrencyTypes;
  organization?: Maybe<Scalars['ObjectID']['output']>;
  rate: Scalars['Float']['output'];
  to: StatisticsCurrencyTypes;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type StatisticHolding = {
  __typename?: 'StatisticHolding';
  /** @deprecated Use bookValueCents instead */
  accountBookValue?: Maybe<Scalars['Float']['output']>;
  accountTaxLots?: Maybe<Array<StatisticsTaxLot>>;
  adjustedCostBaseCents?: Maybe<Scalars['Float']['output']>;
  bookCost?: Maybe<Scalars['Float']['output']>;
  bookCostNative?: Maybe<Scalars['Float']['output']>;
  bookValue?: Maybe<Scalars['Float']['output']>;
  bookValueCents?: Maybe<Scalars['Float']['output']>;
  currency: StatisticsCurrencyTypes;
  currentPrice?: Maybe<Scalars['Float']['output']>;
  currentPriceCents?: Maybe<Scalars['Float']['output']>;
  currentPriceNative?: Maybe<Scalars['Float']['output']>;
  currentValue?: Maybe<Scalars['Float']['output']>;
  custodianAdjustedCostBaseCents?: Maybe<Scalars['Float']['output']>;
  custodianBookValueCents?: Maybe<Scalars['Float']['output']>;
  customFields?: Maybe<Array<Maybe<StatsCustomFieldValue>>>;
  eodPriceCents?: Maybe<Scalars['Long']['output']>;
  eodTotalCents?: Maybe<Scalars['Long']['output']>;
  expectedTotalCents?: Maybe<Scalars['Float']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  foreignExchangeRate?: Maybe<StatisticForeignExchangeRate>;
  /** @deprecated Use bookValueCents instead */
  goalBookValue?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use bookValueCents instead */
  householdClientGroupBookValue?: Maybe<Scalars['Float']['output']>;
  isCash?: Maybe<Scalars['Boolean']['output']>;
  /** Book value in the holding's original/execution currency (cents). */
  localBookValue?: Maybe<Scalars['Float']['output']>;
  /** ACB in the holding's original/execution currency (cents). */
  localCost?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  marketValueNative?: Maybe<Scalars['Float']['output']>;
  /** Book value in the account's base currency (cents). */
  nativeBookValue?: Maybe<Scalars['Float']['output']>;
  /** ACB in the account's base currency (cents). */
  nativeCost?: Maybe<Scalars['Float']['output']>;
  objectType: Scalars['String']['output'];
  oneDayChange?: Maybe<HoldingOneDayChange>;
  originalCurrency?: Maybe<StatisticHoldingOriginalCurrency>;
  quantity?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use bookValueCents instead */
  subAccountBookValue?: Maybe<Scalars['Float']['output']>;
  totalCents: Scalars['Float']['output'];
  totalPercentage?: Maybe<Scalars['Float']['output']>;
  unrealizedGainLoss?: Maybe<HoldingUnrealizedGainLoss>;
  /** @deprecated Use bookValueCents instead */
  userBookValue?: Maybe<Scalars['Float']['output']>;
};


export type StatisticHoldingCustomFieldsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StatisticHoldingTotalPercentageArgs = {
  input?: InputMaybe<StatisticHoldingTotalPercentageInput>;
};

export type StatisticHoldingOriginalCurrency = {
  __typename?: 'StatisticHoldingOriginalCurrency';
  adjustedCostBaseCents?: Maybe<Scalars['Float']['output']>;
  bookValueCents?: Maybe<Scalars['Float']['output']>;
  currency: StatisticsCurrencyTypes;
  currentPriceCents?: Maybe<Scalars['Float']['output']>;
  custodianAdjustedCostBaseCents?: Maybe<Scalars['Float']['output']>;
  custodianBookValueCents?: Maybe<Scalars['Float']['output']>;
  eodPriceCents?: Maybe<Scalars['Long']['output']>;
  eodTotalCents?: Maybe<Scalars['Long']['output']>;
  expectedTotalCents?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  totalCents: Scalars['Float']['output'];
};

export type StatisticHoldingTotalPercentageInput = {
  currency?: InputMaybe<StatisticsCurrencyTypes>;
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  forUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectId: Scalars['SafeString']['input'];
  objectType: HoldingsObjectType;
  sourceType?: InputMaybe<SourceTypesFilter>;
};

export type StatisticOriginalCurrency = {
  __typename?: 'StatisticOriginalCurrency';
  availableFundsToWithdrawCents?: Maybe<Scalars['Long']['output']>;
  cashOnHoldToTradeCents?: Maybe<Scalars['Long']['output']>;
  cashOnHoldToWithdrawCents?: Maybe<Scalars['Long']['output']>;
  currency?: Maybe<StatisticsCurrencyTypes>;
  expectedMoneyAvailableCents?: Maybe<Scalars['Long']['output']>;
  moneyAvailableCents?: Maybe<Scalars['Long']['output']>;
  netContributionCents?: Maybe<Scalars['Long']['output']>;
  newContributionCents?: Maybe<Scalars['Long']['output']>;
  pendingCashCents?: Maybe<Scalars['Long']['output']>;
  pendingContributionCents?: Maybe<Scalars['Long']['output']>;
  pendingWithdrawCents?: Maybe<Scalars['Long']['output']>;
};

export type Statistics = {
  __typename?: 'Statistics';
  availableFundsToWithdrawCents?: Maybe<Scalars['Long']['output']>;
  capitalGainsAndLossesHistory: Array<CapitalGainsAndLosses>;
  capitalGainsAndLossesInFiscalYear: Scalars['Long']['output'];
  cashOnHoldToTradeCents?: Maybe<Scalars['Long']['output']>;
  cashOnHoldToWithdrawCents?: Maybe<Scalars['Long']['output']>;
  changeInMarketValueCents?: Maybe<Scalars['Long']['output']>;
  currency?: Maybe<StatisticsCurrencyTypes>;
  depositContributionCents: Scalars['Long']['output'];
  eodMarketValueCents?: Maybe<Scalars['Long']['output']>;
  expectedMoneyAvailableCents?: Maybe<Scalars['Long']['output']>;
  forUserId?: Maybe<Scalars['ObjectID']['output']>;
  foreignExchangeRates?: Maybe<Array<Maybe<StatisticForeignExchangeRate>>>;
  historySnapshot?: Maybe<DailySnapshot>;
  holdings?: Maybe<Array<StatisticHolding>>;
  holdingsMissingRate?: Maybe<Array<Maybe<StatisticHolding>>>;
  id: Scalars['ObjectID']['output'];
  /** Returns true if this object has bulk-ingested performance snapshots, indicating incomplete historical data from inception. */
  isLegacyPerformanceData?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  marketValueCents?: Maybe<Scalars['Long']['output']>;
  moneyAvailableCents?: Maybe<Scalars['Long']['output']>;
  moneyWeightedReturn: Scalars['Float']['output'];
  netContributionCents?: Maybe<Scalars['Long']['output']>;
  /** Net contribution in fiscal year. Only returns the value for statistics object in Account Type. */
  netContributionCentsInFiscalYear: Scalars['Float']['output'];
  newContributionCents?: Maybe<Scalars['Long']['output']>;
  objectType: Scalars['String']['output'];
  originalCurrencies?: Maybe<Array<Maybe<StatisticOriginalCurrency>>>;
  originalCurrenciesMissingRate?: Maybe<Array<Maybe<StatisticOriginalCurrency>>>;
  pendingCashCents?: Maybe<Scalars['Long']['output']>;
  pendingContributionCents?: Maybe<Scalars['Long']['output']>;
  pendingWithdrawCents?: Maybe<Scalars['Long']['output']>;
  primaryAssetClassHoldings?: Maybe<Array<PrimaryAssetClassHoldings>>;
  projectedIncome?: Maybe<Array<Maybe<ProjectedIncome>>>;
  simpleReturnAmount: Scalars['Float']['output'];
  simpleReturnPercent: Scalars['Float']['output'];
  /** Object's ID returned as string. It can either be the OneVest ID or an External ID from a Passthrough API. */
  stringId: Scalars['String']['output'];
  timeWeightedReturn: Scalars['Float']['output'];
  totalBookCostCents?: Maybe<Scalars['Float']['output']>;
  totalPercentage?: Maybe<Scalars['Float']['output']>;
  unrealizedGainsAndLoss?: Maybe<UnrealizedGainsAndLoss>;
  withdrawContributionCents: Scalars['Long']['output'];
};


export type StatisticsCapitalGainsAndLossesInFiscalYearArgs = {
  referenceDate?: InputMaybe<Scalars['Date']['input']>;
};


export type StatisticsChangeInMarketValueCentsArgs = {
  endDate: Scalars['Date']['input'];
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  startDate: Scalars['Date']['input'];
};


export type StatisticsDepositContributionCentsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<TransactionTypes>>>;
  useFiscalDate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StatisticsHistorySnapshotArgs = {
  date: Scalars['Date']['input'];
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
};


export type StatisticsMoneyWeightedReturnArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  period?: InputMaybe<PerformancePeriods>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type StatisticsNetContributionCentsInFiscalYearArgs = {
  referenceDate?: InputMaybe<Scalars['Date']['input']>;
};


export type StatisticsProjectedIncomeArgs = {
  endDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};


export type StatisticsSimpleReturnAmountArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  period?: InputMaybe<PerformancePeriods>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type StatisticsSimpleReturnPercentArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  period?: InputMaybe<PerformancePeriods>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type StatisticsTimeWeightedReturnArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  period?: InputMaybe<PerformancePeriods>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type StatisticsTotalPercentageArgs = {
  input?: InputMaybe<StatisticsTotalPercentageInput>;
};


export type StatisticsWithdrawContributionCentsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<TransactionTypes>>>;
  useFiscalDate?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Both the name and all of its values must match the one from stats-service
 * The reason is because history-service references '@external currency' field from stats-service
 * If the types don't match, we get a EXTERNAL_TYPE_MISMATCH composition error
 */
export enum StatisticsCurrencyTypes {
  Cad = 'CAD',
  Usd = 'USD'
}

export type StatisticsInput = {
  currency?: InputMaybe<StatisticsCurrencyTypes>;
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  forUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  sourceType?: InputMaybe<SourceTypesFilter>;
};

export type StatisticsTaxLot = {
  __typename?: 'StatisticsTaxLot';
  date: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  priceCents: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
};

export type StatisticsTotalPercentageInput = {
  currency?: InputMaybe<StatisticsCurrencyTypes>;
  forHouseholdId?: InputMaybe<Scalars['ObjectID']['input']>;
  forUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectId?: InputMaybe<Scalars['SafeString']['input']>;
  objectType?: InputMaybe<StatisticsTotalPercentageObjectType>;
  sourceType?: InputMaybe<SourceTypesFilter>;
};

export enum StatisticsTotalPercentageObjectType {
  AccountGroup = 'ACCOUNT_GROUP',
  ClientGroup = 'CLIENT_GROUP',
  User = 'USER'
}

/** Filter a custom field by key. Provide exactly one of value or valueIn. */
export type StatsCustomFieldQueryFilter = {
  /** Custom field key to filter on. */
  key: Scalars['SafeString']['input'];
  /**
   * Exact match — the stored custom field value must equal this value.
   * Mutually exclusive with valueIn.
   */
  value?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Match any — the stored custom field value must equal one of these values (OR / IN).
   * Mutually exclusive with value.
   */
  valueIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type StatsCustomFieldSelectedOption = {
  __typename?: 'StatsCustomFieldSelectedOption';
  displayText?: Maybe<StatsTranslatedString>;
  value: Scalars['JSON']['output'];
};

export type StatsCustomFieldValue = {
  __typename?: 'StatsCustomFieldValue';
  customField?: Maybe<CustomField>;
  key: Scalars['String']['output'];
  selectedOptions?: Maybe<Array<Maybe<StatsCustomFieldSelectedOption>>>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type StatsTranslatedString = {
  __typename?: 'StatsTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type Step = {
  __typename?: 'Step';
  branches?: Maybe<Array<WorkflowStepBranch>>;
  endNodePosition?: Maybe<NodePosition>;
  id: Scalars['ObjectID']['output'];
  name: WorkflowTranslatedString;
  startNodePosition?: Maybe<NodePosition>;
  subSteps: Array<SubStep>;
};

export type SubAccount = {
  __typename?: 'SubAccount';
  acceptableFinancialProduct?: Maybe<Scalars['Boolean']['output']>;
  account: Account;
  activeWorkflowCompletions: Array<WorkflowCompletion>;
  /** Lists remaining forms to be signed for this subAccount plus forms for associated account and user. */
  allIncompleteFormAgreements?: Maybe<Array<Maybe<IncompleteFormAgreement>>>;
  /** Lists latest signed forms for this subAccount plus forms for associated account and user. */
  allLatestFormAgreements?: Maybe<Array<Maybe<FormAgreement>>>;
  allowClientDeposits?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use feeSetting.applicableBillingSchedule instead */
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  /** @deprecated Use feeSetting.applicableFeeTier instead */
  applicableFeeTier?: Maybe<FeeTier>;
  approvedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  availableFinancialProducts?: Maybe<Array<FinancialProduct>>;
  availableThemes?: Maybe<Array<Theme>>;
  baseCurrency?: Maybe<AccountCurrencyTypes>;
  /** @deprecated Use feeSetting instead. */
  billingSchedule?: Maybe<BillingSchedule>;
  calculatedSuitabilityScore?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  custodianSuitabilityScore?: Maybe<Scalars['Float']['output']>;
  customFields?: Maybe<Array<Maybe<AccountCustomFieldValue>>>;
  feeSetting?: Maybe<SubAccountFeeSetting>;
  /** @deprecated Use feeSetting instead. */
  feeTier?: Maybe<FeeTier>;
  financialProduct?: Maybe<FinancialProduct>;
  financialProductId?: Maybe<Scalars['ObjectID']['output']>;
  goal?: Maybe<Goal>;
  id: Scalars['ObjectID']['output'];
  incompleteFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Lists remaining forms to be signed for this subAccount. */
  incompleteFormAgreements?: Maybe<Array<Maybe<IncompleteFormAgreement>>>;
  integrations?: Maybe<Array<Maybe<AccountIntegration>>>;
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  /** Lists latest signed forms for this subAccount. */
  latestFormAgreements?: Maybe<Array<Maybe<FormAgreement>>>;
  /** a subAccount is considered 'liquidated' after a withdraw-all transfer is requested and until a client initiated deposit is reconciled */
  liquidated?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  /**
   * @deprecated Use pendingWithdrawAlls instead. This field is maintained for backward compatibility only.
   * Legacy field: Single pending withdraw all transfer (for backward compatibility).
   * @deprecated Use pendingWithdrawAlls instead
   */
  pendingWithdrawAll?: Maybe<Transfer>;
  /**
   * Array of pending withdraw all transfers.
   * For multi-currency accounts with both CAD and USD balances, this will contain multiple transfers.
   */
  pendingWithdrawAlls?: Maybe<Array<Transfer>>;
  schedule?: Maybe<Schedule>;
  signedAllFormsAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  skipIPS?: Maybe<Scalars['Boolean']['output']>;
  sourceType?: Maybe<SourceTypes>;
  state: SubAccountStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<AccountStateMachineChanges>>>;
  statistics?: Maybe<Statistics>;
  suggestedFinancialProduct?: Maybe<FinancialProduct>;
  suitabilityScore?: Maybe<Scalars['Int']['output']>;
  theme?: Maybe<Theme>;
  tradingProcess?: Maybe<SubAccountTradingProcesses>;
  transfers?: Maybe<Array<Transfer>>;
  upcomingTransfers?: Maybe<Array<UpcomingTransfer>>;
};


export type SubAccountCustomFieldsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubAccountStatisticsArgs = {
  input?: InputMaybe<StatisticsInput>;
};


export type SubAccountSuggestedFinancialProductArgs = {
  themeId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type SubAccountBilling = {
  __typename?: 'SubAccountBilling';
  account: Account;
  accountBaseCurrency?: Maybe<Scalars['String']['output']>;
  accountGroup?: Maybe<AccountGroup>;
  accruedFees: Scalars['Float']['output'];
  accruedFeesAndTax: Scalars['Float']['output'];
  adjustedFeeCents?: Maybe<Scalars['Float']['output']>;
  adjustedSalesTaxCents?: Maybe<Scalars['Float']['output']>;
  billingCycle?: Maybe<BillingCycle>;
  billingDate: Scalars['GraphQLDate']['output'];
  billingSchedule: BillingSchedule;
  billingScheduleSource?: Maybe<BillingScheduleSource>;
  calculatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  chargeableMarketValueCentsOnLastDay?: Maybe<Scalars['Float']['output']>;
  clientGroup?: Maybe<ClientGroup>;
  endDate: Scalars['GraphQLDate']['output'];
  feeCents: Scalars['Float']['output'];
  feePaymentAccount?: Maybe<Account>;
  feeTier: FeeTier;
  feeTierSource?: Maybe<FeeTierSource>;
  id: Scalars['ObjectID']['output'];
  marketValueCentsOnLastDay?: Maybe<Scalars['Float']['output']>;
  moneyAvailableCentsOnLastDay?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationBaseCurrency?: Maybe<Scalars['String']['output']>;
  organizationBaseCurrencyFxRate?: Maybe<Scalars['Float']['output']>;
  projectedFeeAndTaxCents?: Maybe<Scalars['Float']['output']>;
  salesTax?: Maybe<SubAccountBillingSalesTaxes>;
  salesTaxCents: Scalars['Float']['output'];
  startDate: Scalars['GraphQLDate']['output'];
  state: SubAccountBillingStates;
  subAccount: SubAccount;
  totalDailyFeeCents?: Maybe<Scalars['Float']['output']>;
  user: User;
  userProvince?: Maybe<ProvinceCode>;
  withdrawAll?: Maybe<Scalars['Boolean']['output']>;
};

export type SubAccountBillingQueryFilter = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  billingCycleIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  billingCycleStates?: InputMaybe<Array<InputMaybe<BillingCycleStates>>>;
  billingDateAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  billingDateBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  billingScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  clientGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  feeTierIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<InputMaybe<SubAccountBillingStates>>>;
  subAccountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export type SubAccountBillingSalesTaxLine = {
  __typename?: 'SubAccountBillingSalesTaxLine';
  amountCents: Scalars['Float']['output'];
  rate: Scalars['Float']['output'];
};

export type SubAccountBillingSalesTaxes = {
  __typename?: 'SubAccountBillingSalesTaxes';
  GST?: Maybe<SubAccountBillingSalesTaxLine>;
  HST?: Maybe<SubAccountBillingSalesTaxLine>;
  PST?: Maybe<SubAccountBillingSalesTaxLine>;
  QST?: Maybe<SubAccountBillingSalesTaxLine>;
};

export enum SubAccountBillingStates {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
  Ready = 'READY',
  Reconciled = 'RECONCILED',
  Requested = 'REQUESTED'
}

export enum SubAccountCustomAllocationErrorCode {
  AggregateConservation = 'AGGREGATE_CONSERVATION',
  AmountSumOutOfRange = 'AMOUNT_SUM_OUT_OF_RANGE',
  CapacityBreach = 'CAPACITY_BREACH',
  NotCustomized = 'NOT_CUSTOMIZED',
  ProductNotHeld = 'PRODUCT_NOT_HELD',
  WeightSumOutOfRange = 'WEIGHT_SUM_OUT_OF_RANGE',
  WrongReportMember = 'WRONG_REPORT_MEMBER'
}

export type SubAccountCustomAllocationInput = {
  overrides: Array<HoldingCustomExpectedPercentageInput>;
  subAccountId: Scalars['ObjectID']['input'];
};

export type SubAccountDailyFee = {
  __typename?: 'SubAccountDailyFee';
  account: Account;
  accountBaseCurrency?: Maybe<Scalars['String']['output']>;
  accountGroup?: Maybe<AccountGroup>;
  annualFeeBps?: Maybe<Scalars['Float']['output']>;
  billingCycle?: Maybe<BillingCycle>;
  billingSchedule?: Maybe<BillingSchedule>;
  billingScheduleSource?: Maybe<BillingScheduleSource>;
  calculatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  cashOnHoldToTradeCents?: Maybe<Scalars['Float']['output']>;
  /** It is the amount considered to calculate fees, which ignores the waived fee percentage from holdings. Depending on the FeeTier chargeForCashOnHold and chargeForCash, it may also ignore cash on hold and/or the cash left in the portfolio. */
  chargeableMarketValueCents?: Maybe<Scalars['Float']['output']>;
  clientGroup?: Maybe<ClientGroup>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  dailyFeeBps?: Maybe<Scalars['Float']['output']>;
  dailyFixedFeeCents?: Maybe<Scalars['Float']['output']>;
  date: Scalars['GraphQLDate']['output'];
  /** A discount percentage applied to the calculated fee (0 - 100%). */
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  feeTier?: Maybe<FeeTier>;
  feeTierSource?: Maybe<FeeTierSource>;
  /** It is the amount considered to identify the fee tier. */
  gridScopeTotalMarketValueCents?: Maybe<Scalars['Float']['output']>;
  /** Grid scope total market value converted to organization base currency (gridScopeTotalMarketValueCents * organizationBaseCurrencyFxRate). */
  gridScopeTotalMarketValueCentsInOrganizationCurrency?: Maybe<Scalars['Float']['output']>;
  gridScopeType?: Maybe<FeeGridScopeTypes>;
  id: Scalars['ObjectID']['output'];
  marketValueCents?: Maybe<Scalars['Float']['output']>;
  moneyAvailableCents?: Maybe<Scalars['Float']['output']>;
  organization?: Maybe<Organization>;
  organizationBaseCurrency?: Maybe<Scalars['String']['output']>;
  organizationBaseCurrencyFxRate?: Maybe<Scalars['Float']['output']>;
  recalculate?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<SubAccountDailyFeeStates>;
  subAccount: SubAccount;
  totalDailyFeeCents?: Maybe<Scalars['Float']['output']>;
  /** Total amount removed from marketValueCents based on the waived fee percentages defined for each FinancialProduct holding. */
  totalWaivedFeeHoldingCents?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  user: User;
};

export type SubAccountDailyFeeQueryFilter = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  billingCycleIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  billingCycleStates?: InputMaybe<Array<InputMaybe<BillingCycleStates>>>;
  billingScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  clientGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  dateAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  dateBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  feeTierIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<SubAccountDailyFeeStates>;
  subAccountBillingIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  subAccountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export enum SubAccountDailyFeeStates {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type SubAccountFeeSetting = {
  __typename?: 'SubAccountFeeSetting';
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  applicableFeeTier?: Maybe<FeeTier>;
  billingSchedule?: Maybe<BillingSchedule>;
  feeTier?: Maybe<FeeTier>;
};

/** Inactive subAccount reasons. */
export enum SubAccountInactiveReasons {
  Car = 'CAR',
  DissatisfiedWithOnevest = 'DISSATISFIED_WITH_ONEVEST',
  Education = 'EDUCATION',
  Emergency = 'EMERGENCY',
  House = 'HOUSE',
  InvestingIsNotForMe = 'INVESTING_IS_NOT_FOR_ME',
  MajorPurchase = 'MAJOR_PURCHASE',
  Other = 'OTHER',
  ParentalLeave = 'PARENTAL_LEAVE',
  PoorReturns = 'POOR_RETURNS',
  RetirementIncome = 'RETIREMENT_INCOME',
  StartABusiness = 'START_A_BUSINESS',
  Vacation = 'VACATION',
  Wedding = 'WEDDING'
}

export type SubAccountPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type SubAccountQueryFilter = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountType?: InputMaybe<AccountTypes>;
  allowClientDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  completedAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  completedAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  complianceState?: InputMaybe<ComplianceStates>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  financialProductId?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** @deprecated Use iDVerified instead. */
  iDCheckCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  iDVerified?: InputMaybe<Scalars['Boolean']['input']>;
  includeHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<SourceTypesFilter>;
  state?: InputMaybe<SubAccountStates>;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type SubAccountReport = {
  __typename?: 'SubAccountReport';
  accountBaseCurrency?: Maybe<Currencies>;
  cashAvailableForTradeCents: Scalars['Long']['output'];
  cashCents: Scalars['Long']['output'];
  cashOnHoldToTradeCents: Scalars['Long']['output'];
  currency?: Maybe<Currencies>;
  expectedCashCents: Scalars['Long']['output'];
  holdings: Array<HoldingReport>;
  id: Scalars['ObjectID']['output'];
  /**
   * False when the sub-account, its account, its user or its goal is inactive.
   * Null on reports not screened since the stamp was introduced.
   */
  isTradeable?: Maybe<Scalars['Boolean']['output']>;
  marketValueCents: Scalars['Long']['output'];
  originalValues?: Maybe<Array<SubAccountReportOriginalValue>>;
  pendingCashCents?: Maybe<Scalars['Long']['output']>;
  pendingContributionCents: Scalars['Long']['output'];
  pendingWithdrawCents: Scalars['Long']['output'];
  subAccount: SubAccount;
};

export type SubAccountReportOriginalValue = {
  __typename?: 'SubAccountReportOriginalValue';
  cashAvailableForTradeCents: Scalars['Long']['output'];
  cashCents: Scalars['Long']['output'];
  cashOnHoldToTradeCents: Scalars['Long']['output'];
  currency: Currencies;
  expectedCashCents: Scalars['Long']['output'];
  marketValueCents: Scalars['Long']['output'];
  pendingCashCents: Scalars['Long']['output'];
  pendingContributionCents: Scalars['Long']['output'];
  pendingWithdrawCents: Scalars['Long']['output'];
};

export enum SubAccountStates {
  Active = 'ACTIVE',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Inactive = 'INACTIVE'
}

export type SubAccountSuggestedFinancialProductInput = {
  subAccountId: Scalars['ObjectID']['input'];
};

export enum SubAccountTradingProcesses {
  NoAutomation = 'NO_AUTOMATION',
  PortfolioOptimizer = 'PORTFOLIO_OPTIMIZER',
  RebalanceV1 = 'REBALANCE_V1',
  RebalanceV2 = 'REBALANCE_V2'
}

export enum SubAccountTransition {
  Activate = 'activate',
  Deactivate = 'deactivate',
  Review = 'review'
}

export type SubAccountUpdate = {
  __typename?: 'SubAccountUpdate';
  d?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  o: Scalars['String']['output'];
  t: Scalars['GraphQLDateTime']['output'];
};

export type SubAccountUpdatePaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

/** @deprecated(reason: "Not used anymore.") */
export type SubAccountsDaily = {
  __typename?: 'SubAccountsDaily';
  date: Scalars['GraphQLDateTime']['output'];
  holdings: Array<Holding>;
  id: Scalars['ObjectID']['output'];
  marketValueCents: Scalars['Long']['output'];
  moneyAvailableCents: Scalars['Long']['output'];
  netContributionCents: Scalars['Long']['output'];
  newContributionCents: Scalars['Long']['output'];
  subAccount: SubAccount;
};

export type SubStep = {
  __typename?: 'SubStep';
  branches?: Maybe<Array<WorkflowStepBranch>>;
  canGoBack: Scalars['Boolean']['output'];
  completeableBy: Array<SubStepCompleteableBys>;
  id: Scalars['ObjectID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  nodePosition?: Maybe<NodePosition>;
  options: Scalars['Object']['output'];
  rolesCompleteableBy: Array<Role>;
  skippable: Scalars['Boolean']['output'];
  type: SubStepTypes;
};

export enum SubStepCompleteableBys {
  OrganizationUser = 'ORGANIZATION_USER',
  User = 'USER'
}

export type SubStepOption = {
  __typename?: 'SubStepOption';
  default: Scalars['Object']['output'];
  hideIf?: Maybe<Scalars['Object']['output']>;
  key: Scalars['String']['output'];
  label: WorkflowTranslatedString;
  optionType: SubStepOptionTypes;
  options?: Maybe<Scalars['Object']['output']>;
  showIf?: Maybe<Scalars['Object']['output']>;
};

export enum SubStepOptionTypes {
  AccountGroupSection = 'ACCOUNT_GROUP_SECTION',
  AccountList = 'ACCOUNT_LIST',
  Attachment = 'ATTACHMENT',
  AutocompleteFieldIdVerification = 'AUTOCOMPLETE_FIELD_ID_VERIFICATION',
  AutomatedBankingSelected = 'AUTOMATED_BANKING_SELECTED',
  BasicField = 'BASIC_FIELD',
  BasicOrSelectField = 'BASIC_OR_SELECT_FIELD',
  Boolean = 'BOOLEAN',
  CountrySpecificTaxId = 'COUNTRY_SPECIFIC_TAX_ID',
  CreateModelPortfolioOptions = 'CREATE_MODEL_PORTFOLIO_OPTIONS',
  DataFields = 'DATA_FIELDS',
  DepositTypeSelectField = 'DEPOSIT_TYPE_SELECT_FIELD',
  DividerWithTitle = 'DIVIDER_WITH_TITLE',
  ExtendedBoolean = 'EXTENDED_BOOLEAN',
  FormDefinitionSelectField = 'FORM_DEFINITION_SELECT_FIELD',
  ImplementationWarning = 'IMPLEMENTATION_WARNING',
  IntegrationMultiSelect = 'INTEGRATION_MULTI_SELECT',
  InvestmentKnowledgeOptions = 'INVESTMENT_KNOWLEDGE_OPTIONS',
  ListTile = 'LIST_TILE',
  NetWorthButton = 'NET_WORTH_BUTTON',
  NumberField = 'NUMBER_FIELD',
  OptionalTranslatedString = 'OPTIONAL_TRANSLATED_STRING',
  RiskQuestionOptions = 'RISK_QUESTION_OPTIONS',
  RoleSelectField = 'ROLE_SELECT_FIELD',
  ScheduleFrequencyOptions = 'SCHEDULE_FREQUENCY_OPTIONS',
  SelectCustomFields = 'SELECT_CUSTOM_FIELDS',
  SelectField = 'SELECT_FIELD',
  TextField = 'TEXT_FIELD',
  TimeHorizonOptions = 'TIME_HORIZON_OPTIONS',
  TransferTypeOptions = 'TRANSFER_TYPE_OPTIONS',
  TranslatedString = 'TRANSLATED_STRING',
  WorkflowSelectField = 'WORKFLOW_SELECT_FIELD'
}

export enum SubStepTypes {
  Accounts = 'ACCOUNTS',
  ActionActivateAllSubAccounts = 'ACTION_ACTIVATE_ALL_SUB_ACCOUNTS',
  ActionAddFormDefinition = 'ACTION_ADD_FORM_DEFINITION',
  ActionAffiliateInvitation = 'ACTION_AFFILIATE_INVITATION',
  ActionIntegration = 'ACTION_INTEGRATION',
  ActionNotify = 'ACTION_NOTIFY',
  ActionTransitionModelChangeProposal = 'ACTION_TRANSITION_MODEL_CHANGE_PROPOSAL',
  ActionUpdateAccount = 'ACTION_UPDATE_ACCOUNT',
  ActionUpdateIntegrationFormagreementSigners = 'ACTION_UPDATE_INTEGRATION_FORMAGREEMENT_SIGNERS',
  ActionUpdateUser = 'ACTION_UPDATE_USER',
  AddModelPortfolioDetails = 'ADD_MODEL_PORTFOLIO_DETAILS',
  AddModelPortfolioDisclaimer = 'ADD_MODEL_PORTFOLIO_DISCLAIMER',
  AddModelPortfolioInvestmentPolicyStatement = 'ADD_MODEL_PORTFOLIO_INVESTMENT_POLICY_STATEMENT',
  AddModelPortfolioSecurityAllocations = 'ADD_MODEL_PORTFOLIO_SECURITY_ALLOCATIONS',
  ApplyAccountAllocations = 'APPLY_ACCOUNT_ALLOCATIONS',
  Approval = 'APPROVAL',
  ArchiveObjects = 'ARCHIVE_OBJECTS',
  AssignPortfolioToSubAccount = 'ASSIGN_PORTFOLIO_TO_SUB_ACCOUNT',
  BankAccountInformation = 'BANK_ACCOUNT_INFORMATION',
  Calculator = 'CALCULATOR',
  CollectSigners = 'COLLECT_SIGNERS',
  CreateAccount = 'CREATE_ACCOUNT',
  CreateAccountForGoal = 'CREATE_ACCOUNT_FOR_GOAL',
  CreateAccountGroup = 'CREATE_ACCOUNT_GROUP',
  CreateGoal = 'CREATE_GOAL',
  CreateIntegrationFormPack = 'CREATE_INTEGRATION_FORM_PACK',
  CreateModelPortfolio = 'CREATE_MODEL_PORTFOLIO',
  DepositForm = 'DEPOSIT_FORM',
  DepositReview = 'DEPOSIT_REVIEW',
  DepositType = 'DEPOSIT_TYPE',
  DetachModelPortfolio = 'DETACH_MODEL_PORTFOLIO',
  Documents = 'DOCUMENTS',
  EditAccount = 'EDIT_ACCOUNT',
  EditAccountAllocations = 'EDIT_ACCOUNT_ALLOCATIONS',
  EditGoal = 'EDIT_GOAL',
  EditHouseholdModelPortfolioIps = 'EDIT_HOUSEHOLD_MODEL_PORTFOLIO_IPS',
  EmploymentInformation = 'EMPLOYMENT_INFORMATION',
  FinancialProjections = 'FINANCIAL_PROJECTIONS',
  Goals = 'GOALS',
  GoalRiskQuestion_1 = 'GOAL_RISK_QUESTION_1',
  Household = 'HOUSEHOLD',
  IdVerification = 'ID_VERIFICATION',
  IncomeAssetsAndDebts = 'INCOME_ASSETS_AND_DEBTS',
  InitializeHouseholdModelPortfolio = 'INITIALIZE_HOUSEHOLD_MODEL_PORTFOLIO',
  InvestmentKnowledge = 'INVESTMENT_KNOWLEDGE',
  ManageFormCompletions = 'MANAGE_FORM_COMPLETIONS',
  ManageSigners = 'MANAGE_SIGNERS',
  MultiPortfolioDeposit = 'MULTI_PORTFOLIO_DEPOSIT',
  NetWorth = 'NET_WORTH',
  NonIndividualInformation = 'NON_INDIVIDUAL_INFORMATION',
  NonIndividualSetup = 'NON_INDIVIDUAL_SETUP',
  PersonalInformation = 'PERSONAL_INFORMATION',
  PersonsOfInterest = 'PERSONS_OF_INTEREST',
  PrepareFormCompletions = 'PREPARE_FORM_COMPLETIONS',
  Projections = 'PROJECTIONS',
  RedirectHandler = 'REDIRECT_HANDLER',
  RelatedEntities = 'RELATED_ENTITIES',
  RelationshipInformation = 'RELATIONSHIP_INFORMATION',
  ResidencyInformation = 'RESIDENCY_INFORMATION',
  Review = 'REVIEW',
  ReviewAccount = 'REVIEW_ACCOUNT',
  ReviewAccountAllocations = 'REVIEW_ACCOUNT_ALLOCATIONS',
  ReviewAllocations = 'REVIEW_ALLOCATIONS',
  ReviewBankAccountInformation = 'REVIEW_BANK_ACCOUNT_INFORMATION',
  ReviewGoal = 'REVIEW_GOAL',
  ReviewIpsSummary = 'REVIEW_IPS_SUMMARY',
  ReviewPortfolioChanges = 'REVIEW_PORTFOLIO_CHANGES',
  RiskProfile = 'RISK_PROFILE',
  RiskQuestion_1 = 'RISK_QUESTION_1',
  RiskQuestion_2 = 'RISK_QUESTION_2',
  SelectHouseholdParentModelPortfolio = 'SELECT_HOUSEHOLD_PARENT_MODEL_PORTFOLIO',
  SelectModelPortfolioEditType = 'SELECT_MODEL_PORTFOLIO_EDIT_TYPE',
  SendIntegrationFormPack = 'SEND_INTEGRATION_FORM_PACK',
  SignFormCompletions = 'SIGN_FORM_COMPLETIONS',
  SubAccounts = 'SUB_ACCOUNTS',
  SynchronousIntegration = 'SYNCHRONOUS_INTEGRATION',
  Transfers = 'TRANSFERS',
  UserVerification = 'USER_VERIFICATION',
  WithdrawForm = 'WITHDRAW_FORM',
  WithdrawReview = 'WITHDRAW_REVIEW',
  WorkflowReview = 'WORKFLOW_REVIEW'
}

export type SubTrade = {
  __typename?: 'SubTrade';
  actualQuantity?: Maybe<Scalars['Float']['output']>;
  actualTradePriceCents?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  currency?: Maybe<Currencies>;
  expectedQuantity?: Maybe<Scalars['Float']['output']>;
  expectedTradePriceCents?: Maybe<Scalars['Float']['output']>;
  failReason?: Maybe<Scalars['String']['output']>;
  financialProduct: FinancialProduct;
  id: Scalars['ObjectID']['output'];
  moneyAllocatedCents: Scalars['Float']['output'];
  percentageFilled?: Maybe<Scalars['Float']['output']>;
  rebalance?: Maybe<Rebalance>;
  reconciledAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  state: TradeStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<HoldingStateMachineChanges>>>;
  subAccount: SubAccount;
  trade?: Maybe<Trade>;
  type: TradeType;
};

export type SubTradeQueryFilter = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  createdAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  financialProductIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  rebalanceId?: InputMaybe<Scalars['ObjectID']['input']>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  subTradeState?: InputMaybe<TradeStates>;
  subTradeStates?: InputMaybe<Array<TradeStates>>;
  tradeId?: InputMaybe<Scalars['ObjectID']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type SubTradeRequest = {
  __typename?: 'SubTradeRequest';
  account: Account;
  actualQuantity?: Maybe<Scalars['Float']['output']>;
  actualTradePriceCents?: Maybe<Scalars['Float']['output']>;
  blockedUntil?: Maybe<Scalars['GraphQLDate']['output']>;
  blockedUntilAccountActive?: Maybe<Scalars['Boolean']['output']>;
  blockedUntilPairActualTradePriceCents?: Maybe<Scalars['Int']['output']>;
  blockedUntilSubAccountActive?: Maybe<Scalars['Boolean']['output']>;
  bulkTradeRequest: BulkTradeRequest;
  bulkTradeRun?: Maybe<BulkTradeRun>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  currency?: Maybe<Currencies>;
  exchange?: Maybe<Scalars['String']['output']>;
  expectedQuantity?: Maybe<Scalars['Float']['output']>;
  expectedTradePriceCents?: Maybe<Scalars['Float']['output']>;
  financialProduct: FinancialProduct;
  id: Scalars['ObjectID']['output'];
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  isProcessedForPair?: Maybe<Scalars['Boolean']['output']>;
  isSellAll?: Maybe<Scalars['Boolean']['output']>;
  isSuggestedByOptimizer?: Maybe<Scalars['Boolean']['output']>;
  logs: LogsResponse;
  maxQuantity?: Maybe<Scalars['Float']['output']>;
  moneyAllocatedCents: Scalars['Float']['output'];
  pair?: Maybe<SubTradeRequest>;
  portfolioReport?: Maybe<Scalars['ObjectID']['output']>;
  preSplitMoneyAllocatedCents?: Maybe<Scalars['Float']['output']>;
  schedule?: Maybe<Schedule>;
  settlementDate?: Maybe<Scalars['GraphQLDate']['output']>;
  settlementDays?: Maybe<Scalars['Int']['output']>;
  sourceId?: Maybe<Scalars['ObjectID']['output']>;
  splitFrom?: Maybe<SubTradeRequest>;
  splitTo?: Maybe<SubTradeRequest>;
  splits: Array<SubTradeRequest>;
  state: SubTradeRequestStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<StateMachineChanges>>>;
  subAccount: SubAccount;
  ticker?: Maybe<Scalars['String']['output']>;
  tradeRequest?: Maybe<TradeRequest>;
  type: SubTradeRequestTypes;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  user: User;
  verifiedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** @deprecated Use verifiedByOrganizationUser instead */
  verifiedBy?: Maybe<Scalars['ObjectID']['output']>;
  verifiedByOrganizationUser?: Maybe<PublicOrganizationUser>;
  volatile?: Maybe<Scalars['Boolean']['output']>;
};


export type SubTradeRequestLogsArgs = {
  input?: InputMaybe<SubTradeRequestLogsInput>;
};

export type SubTradeRequestLogsInput = {
  filter?: InputMaybe<SubTradeRequestLogsQueryFilter>;
  pagination?: InputMaybe<PaginationAndSorting>;
};

export type SubTradeRequestLogsQueryFilter = {
  after?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  before?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type SubTradeRequestPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type SubTradeRequestQueryFilter = {
  bulkTradeRequestId?: InputMaybe<Scalars['ObjectID']['input']>;
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Currencies>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  settlementDateAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  settlementDateAtBefore?: InputMaybe<Scalars['DateTime']['input']>;
  showSplits?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
  /**
   *  @deprecated Use states instead
   * @deprecated Use states instead
   */
  state?: InputMaybe<SubTradeRequestStates>;
  states?: InputMaybe<Array<SubTradeRequestStates>>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  type?: InputMaybe<SubTradeRequestTypes>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum SubTradeRequestSources {
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  SubAccount = 'SUB_ACCOUNT'
}

export enum SubTradeRequestStates {
  Canceled = 'CANCELED',
  Initiated = 'INITIATED',
  Ready = 'READY',
  Reconciled = 'RECONCILED',
  Requested = 'REQUESTED'
}

export enum SubTradeRequestTransition {
  Cancel = 'cancel'
}

export enum SubTradeRequestTypes {
  Buy = 'BUY',
  Sell = 'SELL'
}

export enum SubTradeStates {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING',
  Reconciled = 'RECONCILED'
}

export enum SubTradeType {
  Buy = 'BUY',
  Sell = 'SELL'
}

export type SubmitCustodianAccountOpeningInput = {
  accountId: Scalars['ObjectID']['input'];
};

export type SubmitCustodianAccountOpeningResponse = {
  __typename?: 'SubmitCustodianAccountOpeningResponse';
  custodianAccountId?: Maybe<Scalars['String']['output']>;
  custodianUserId?: Maybe<Scalars['String']['output']>;
  state: CustodianStates;
};

export type SuccessorPhysicalAddress = {
  __typename?: 'SuccessorPhysicalAddress';
  city: Scalars['String']['output'];
  country: AddressCountries;
  houseNumber: Scalars['String']['output'];
  jurisdiction?: Maybe<AddressJurisdiction>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal: Scalars['String']['output'];
  /** @deprecated use jurisdiction instead */
  province?: Maybe<AddressProvince>;
  streetName: Scalars['String']['output'];
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type SuccessorPhysicalAddressInput = {
  city: Scalars['SafeString']['input'];
  country: AddressCountries;
  houseNumber: Scalars['SafeString']['input'];
  jurisdiction?: InputMaybe<AddressJurisdiction>;
  neighborhood?: InputMaybe<Scalars['SafeString']['input']>;
  postal: Scalars['SafeString']['input'];
  province?: InputMaybe<AddressProvince>;
  streetName: Scalars['SafeString']['input'];
  unitNumber?: InputMaybe<Scalars['SafeString']['input']>;
};

export type SuggestFinancialProductInput = {
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  suitabilityScore: Scalars['Int']['input'];
  themeId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type SuggestFinancialProductResponse = {
  __typename?: 'SuggestFinancialProductResponse';
  financialProduct?: Maybe<FinancialProduct>;
};

export type SwitchEquitiesAtCostInput = {
  date?: InputMaybe<Scalars['GraphQLDate']['input']>;
  description?: InputMaybe<Scalars['SafeString']['input']>;
  financialProductInId: Scalars['ObjectID']['input'];
  financialProductOutId: Scalars['ObjectID']['input'];
  isExistingHolding: Scalars['Boolean']['input'];
  priceCents?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  switchInPriceCents?: InputMaybe<Scalars['Float']['input']>;
  valueCents?: InputMaybe<Scalars['Float']['input']>;
};

export type SwitchEquitiesAtCostResponse = {
  __typename?: 'SwitchEquitiesAtCostResponse';
  transactions?: Maybe<Array<Transaction>>;
};

export type SwitchEquitiesAtMarketInput = {
  date?: InputMaybe<Scalars['GraphQLDate']['input']>;
  description?: InputMaybe<Scalars['SafeString']['input']>;
  financialProductInId: Scalars['ObjectID']['input'];
  financialProductOutId: Scalars['ObjectID']['input'];
  isExistingHolding: Scalars['Boolean']['input'];
  priceCents?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  switchInPriceCents?: InputMaybe<Scalars['Float']['input']>;
  valueCents?: InputMaybe<Scalars['Float']['input']>;
};

export type SwitchEquitiesAtMarketResponse = {
  __typename?: 'SwitchEquitiesAtMarketResponse';
  transactions?: Maybe<Array<Transaction>>;
};

export type TabConfiguration = {
  __typename?: 'TabConfiguration';
  condition?: Maybe<PageConfigurationCondition>;
  contextObject?: Maybe<ContextObjectTypes>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  label: OrganizationTranslatedString;
  translatedUrl?: Maybe<OrganizationTranslatedString>;
  /** @deprecated url is deprecated, use translatedUrl instead */
  url?: Maybe<Scalars['String']['output']>;
  widgets: Array<WidgetConfiguration>;
  workflow?: Maybe<Workflow>;
};

export type TabConfigurationInput = {
  condition?: InputMaybe<PageConfigurationConditionInput>;
  contextObject?: InputMaybe<ContextObjectTypes>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: OrganizationTranslatedStringInput;
  translatedUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  /** @deprecated url is deprecated, use translatedUrl instead */
  url?: InputMaybe<Scalars['String']['input']>;
  widgets: Array<WidgetConfigurationInput>;
  workflow?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type TableExternalDataPaginationAndSorting = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<PaginationCursorDirection>;
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type TargetAllocation = {
  __typename?: 'TargetAllocation';
  /** Maximum percentage for this target allocation */
  max: Scalars['Int']['output'];
  /** Minimum percentage for this target allocation */
  min: Scalars['Int']['output'];
  /** Secondary Asset Class associated with the portfolio */
  secondaryAssetClass: AssetClass;
};

export type TargetAllocationInput = {
  /** Maximum percentage for this target allocation */
  max: Scalars['Int']['input'];
  /** Minimum percentage for this target allocation */
  min: Scalars['Int']['input'];
  /** Secondary AssetClass associated with the portfolio */
  secondaryAssetClassId: Scalars['ObjectID']['input'];
};

/** User's tax identification type: SIN/BN (Canada), SSN/ITIN/EIN (United States)..   */
export enum TaxIdTypes {
  Bn = 'BN',
  Ein = 'EIN',
  Generic = 'GENERIC',
  Itin = 'ITIN',
  Sin = 'SIN',
  Ssn = 'SSN'
}

export type TaxLocationMoveInput = {
  amountCents: Scalars['Long']['input'];
  fromAccountLabel: Scalars['String']['input'];
  toAccountLabel: Scalars['String']['input'];
};

export type TaxLot = {
  __typename?: 'TaxLot';
  date: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ObjectID']['output'];
  priceCents: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
};

/** Scheduled Income Fund Transfer tax option. */
export enum TaxOptionType {
  NoTaxOnMinimum = 'NO_TAX_ON_MINIMUM',
  SpecialTaxRate = 'SPECIAL_TAX_RATE',
  TaxOnFull = 'TAX_ON_FULL'
}

export enum TaxRankAccountTypes {
  CashJoint = 'CASH_JOINT',
  CorporateCash = 'CORPORATE_CASH',
  CorporateCharity = 'CORPORATE_CHARITY',
  CorporateEstate = 'CORPORATE_ESTATE',
  CorporateTrust = 'CORPORATE_TRUST',
  Dbpp = 'DBPP',
  Dpsp = 'DPSP',
  Fhsa = 'FHSA',
  Grsp = 'GRSP',
  GrspSpousal = 'GRSP_SPOUSAL',
  InformalTrust = 'INFORMAL_TRUST',
  InformalTrustJoint = 'INFORMAL_TRUST_JOINT',
  Investment = 'INVESTMENT',
  Ipp = 'IPP',
  Lif = 'LIF',
  Lira = 'LIRA',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  Margin = 'MARGIN',
  MarginJoint = 'MARGIN_JOINT',
  PensionPlan = 'PENSION_PLAN',
  Personal = 'PERSONAL',
  Prif = 'PRIF',
  Rdsp = 'RDSP',
  RdspJoint = 'RDSP_JOINT',
  Resp = 'RESP',
  RespAdult = 'RESP_ADULT',
  RespFamily = 'RESP_FAMILY',
  RespFamilyJoint = 'RESP_FAMILY_JOINT',
  RespSingle = 'RESP_SINGLE',
  RespSingleJoint = 'RESP_SINGLE_JOINT',
  RifSpousal = 'RIF_SPOUSAL',
  Rlif = 'RLIF',
  Rlsp = 'RLSP',
  Rpp = 'RPP',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  RrspSpousal = 'RRSP_SPOUSAL',
  Tfsa = 'TFSA',
  UkBrokerage = 'UK_BROKERAGE',
  UkCashIsa = 'UK_CASH_ISA',
  UkJisa = 'UK_JISA',
  UkPersonalPension = 'UK_PERSONAL_PENSION',
  UkSsIsa = 'UK_SS_ISA',
  Usa_401K = 'USA_401K',
  Usa_529 = 'USA_529',
  UsaBrokerage = 'USA_BROKERAGE',
  UsaCorporate = 'USA_CORPORATE',
  UsaCra = 'USA_CRA',
  UsaCustodial = 'USA_CUSTODIAL',
  UsaDaf = 'USA_DAF',
  UsaDbp = 'USA_DBP',
  UsaEsa = 'USA_ESA',
  UsaEstate = 'USA_ESTATE',
  UsaInhIra = 'USA_INH_IRA',
  UsaInhRtIra = 'USA_INH_RT_IRA',
  UsaIra = 'USA_IRA',
  UsaIraCustodial = 'USA_IRA_CUSTODIAL',
  UsaJtCp = 'USA_JT_CP',
  UsaJtCpMargin = 'USA_JT_CP_MARGIN',
  UsaJtJtbe = 'USA_JT_JTBE',
  UsaJtJtbeMargin = 'USA_JT_JTBE_MARGIN',
  UsaJtTic = 'USA_JT_TIC',
  UsaJtTicMargin = 'USA_JT_TIC_MARGIN',
  UsaJtWros = 'USA_JT_WROS',
  UsaJtWrosMargin = 'USA_JT_WROS_MARGIN',
  UsaKeogh = 'USA_KEOGH',
  UsaMargin = 'USA_MARGIN',
  UsaRoIra = 'USA_RO_IRA',
  UsaRtIra = 'USA_RT_IRA',
  UsaSepIra = 'USA_SEP_IRA',
  UsaSimpleIra = 'USA_SIMPLE_IRA',
  UsaSolo_401K = 'USA_SOLO_401K',
  UsaTod = 'USA_TOD',
  UsaTrust = 'USA_TRUST'
}

export enum TemplateLanguages {
  En = 'en',
  Es = 'es',
  Fr = 'fr'
}

export type TemplateParameter = {
  __typename?: 'TemplateParameter';
  key?: Maybe<Scalars['SafeString']['output']>;
  value?: Maybe<Scalars['SafeString']['output']>;
};

export type TestClientReportTemplateInput = {
  frequency?: InputMaybe<ClientReportFrequencies>;
  objectId: Scalars['ObjectID']['input'];
  objectType: ClientReportTemplateObjectTypes;
  referenceDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  templateHtml: Scalars['String']['input'];
};

export type TestClientReportTemplateResponse = {
  __typename?: 'TestClientReportTemplateResponse';
  html: Scalars['String']['output'];
};

export enum TextTypes {
  Html = 'HTML',
  Markdown = 'MARKDOWN'
}

export type Theme = {
  __typename?: 'Theme';
  core?: Maybe<Scalars['Boolean']['output']>;
  /** The description of the Theme. */
  description?: Maybe<Scalars['String']['output']>;
  /** A key to select default Icon from organization assets. */
  iconKey?: Maybe<Scalars['String']['output']>;
  /** This is the ID and it is auto-generated by OneVest for each Theme. */
  id: Scalars['ObjectID']['output'];
  /** A key that can be used by front ends so that the name can change. */
  key: Scalars['String']['output'];
  logs: LogsResponse;
  /** The name of the Theme. */
  name: Scalars['String']['output'];
  /** State of the Theme. */
  state: ThemeState;
  translatedDescription?: Maybe<ProductTranslatedString>;
  translatedName: ProductTranslatedString;
  translatedShortDescription?: Maybe<ProductTranslatedString>;
};


export type ThemeLogsArgs = {
  input?: InputMaybe<ThemeLogsInput>;
};

export type ThemeLogsInput = {
  filter?: InputMaybe<ThemeLogsQueryFilter>;
  pagination?: InputMaybe<PaginationAndSorting>;
};

export type ThemeLogsQueryFilter = {
  after?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  before?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type ThemePaginationAndSorting = {
  collation?: InputMaybe<Collation>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeQueryFilter = {
  core?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  keys?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<ThemeState>;
};

export enum ThemeState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export enum ThemeTransitions {
  Activate = 'activate',
  Archive = 'archive',
  Draft = 'draft'
}

export type TimeValue = {
  __typename?: 'TimeValue';
  amountCents?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export enum TokenExchangeValidationTypes {
  Jwk = 'JWK',
  PingIdentity = 'PING_IDENTITY'
}

export type TotalIncompleteTradeRequests = {
  __typename?: 'TotalIncompleteTradeRequests';
  exchange: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

/** Scheduled Income Fund Transfer total withdrawal amount option. */
export enum TotalWithdrawalAmountOption {
  Custom = 'CUSTOM',
  Maximum = 'MAXIMUM',
  Minimum = 'MINIMUM'
}

export type Trade = {
  __typename?: 'Trade';
  account: Account;
  actualQuantity?: Maybe<Scalars['Float']['output']>;
  actualTradePriceCents?: Maybe<Scalars['Float']['output']>;
  actualTradePriceInCurrencyCents?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  currency?: Maybe<Currencies>;
  description?: Maybe<Scalars['String']['output']>;
  expectedQuantity?: Maybe<Scalars['Float']['output']>;
  expectedTradePriceCents?: Maybe<Scalars['Float']['output']>;
  failReason?: Maybe<Scalars['String']['output']>;
  financialProduct: FinancialProduct;
  id: Scalars['ObjectID']['output'];
  moneyAllocatedCents: Scalars['Float']['output'];
  percentageFilled?: Maybe<Scalars['Float']['output']>;
  rebalance?: Maybe<Rebalance>;
  reconciledAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  settlementDate?: Maybe<Scalars['GraphQLDate']['output']>;
  state: TradeStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<HoldingStateMachineChanges>>>;
  tradeDate?: Maybe<Scalars['GraphQLDate']['output']>;
  type: TradeType;
};

export type TradeQueryFilter = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  createdAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  financialProductIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  rebalanceId?: InputMaybe<Scalars['ObjectID']['input']>;
  tradeState?: InputMaybe<TradeStates>;
  tradeStates?: InputMaybe<Array<TradeStates>>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export type TradeRequest = {
  __typename?: 'TradeRequest';
  account: Account;
  actualQuantity?: Maybe<Scalars['Float']['output']>;
  actualTradePriceCents?: Maybe<Scalars['Float']['output']>;
  bulkTradeRun?: Maybe<BulkTradeRun>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  currency?: Maybe<Currencies>;
  exchange?: Maybe<Scalars['String']['output']>;
  expectedQuantity?: Maybe<Scalars['Float']['output']>;
  expectedTradePriceCents?: Maybe<Scalars['Float']['output']>;
  financialProduct: FinancialProduct;
  hasPairs: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  isSellAll?: Maybe<Scalars['Boolean']['output']>;
  maxQuantity?: Maybe<Scalars['Float']['output']>;
  moneyAllocatedCents: Scalars['Float']['output'];
  settlementDate?: Maybe<Scalars['GraphQLDate']['output']>;
  state: TradeRequestStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<StateMachineChanges>>>;
  ticker?: Maybe<Scalars['String']['output']>;
  type: TradeRequestTypes;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  user: User;
};

export type TradeRequestPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type TradeRequestQueryFilter = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkTradeRunId?: InputMaybe<Scalars['ObjectID']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<TradeRequestStates>;
  type?: InputMaybe<TradeRequestTypes>;
};

export enum TradeRequestStates {
  Canceled = 'CANCELED',
  Initiated = 'INITIATED',
  Ready = 'READY',
  Reconciled = 'RECONCILED',
  Requested = 'REQUESTED'
}

export enum TradeRequestTypes {
  Buy = 'BUY',
  Sell = 'SELL'
}

export enum TradeStates {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING',
  Reconciled = 'RECONCILED'
}

export enum TradeTransition {
  Cancel = 'cancel',
  CancelReconciled = 'cancelReconciled',
  Fail = 'fail',
  ForceCancel = 'forceCancel',
  Process = 'process',
  Reconcile = 'reconcile'
}

export enum TradeType {
  Buy = 'BUY',
  Sell = 'SELL'
}

export type Transaction = {
  __typename?: 'Transaction';
  account: Account;
  /**
   * Execution order for transactions on the same date. Used to ensure correct ACB/Book Value calculations.
   * When multiple transactions occur on the same date, this field determines the processing order.
   * Example: For same-fund crystallizations, SWO should be 0 (sell first) and SWI should be 1 (buy second).
   * For corporate actions, set order to ensure removals process before additions.
   */
  adjustedCostBaseExecutionOrder?: Maybe<Scalars['Int']['output']>;
  bookCostCents?: Maybe<Scalars['Float']['output']>;
  bookValueCents?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currencies>;
  /**
   * Optional field to store and display transaction types as reported by the custodian.
   * Primarily used for display purposes for read-only clients where we are NOT relying on internal transaction roll ups.
   */
  custodianType?: Maybe<Scalars['SafeString']['output']>;
  customFields?: Maybe<Array<Maybe<HoldingCustomFieldValue>>>;
  date: Scalars['GraphQLDate']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The DEPOSIT_BUY and EXTERNAL_TRANSFER_IN_SECURITY transaction types use the endOfDayPriceCents to calculate the valueCents as the priceCents in this case is the book cost (ACB/unit).
   * This value will be automatically set based on the security price snapshots.
   */
  endOfDayPriceCents?: Maybe<Scalars['Float']['output']>;
  financialProduct?: Maybe<FinancialProduct>;
  fiscalDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** FX rate from transaction currency to account's base currency at transaction time. */
  fxRate?: Maybe<Scalars['Float']['output']>;
  goal?: Maybe<Goal>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<TransactionIntegration>>>;
  isSellAll?: Maybe<Scalars['Boolean']['output']>;
  journalFromSubAccount?: Maybe<SubAccount>;
  journalPairTransaction?: Maybe<Transaction>;
  journalToSubAccount?: Maybe<SubAccount>;
  journalType?: Maybe<JournalTypes>;
  /** Alias for valueCents (Local Book Value) */
  localBookValue?: Maybe<Scalars['Float']['output']>;
  /** Alias for priceCents (Local Cost) */
  localCost?: Maybe<Scalars['Float']['output']>;
  /**
   * Total transaction value in the account's base currency.
   * Calculation: valueCents * embeddedFxRates[accountBaseCurrency]
   * For tax: represents 'Proceeds of Sale' (sells) or 'Acquisition Cost' (buys)
   */
  nativeBookValue?: Maybe<Scalars['Float']['output']>;
  /**
   * Price per unit in the account's base currency.
   * Calculation: priceCents * embeddedFxRates[accountBaseCurrency]
   */
  nativeCost?: Maybe<Scalars['Float']['output']>;
  objectId?: Maybe<Scalars['ObjectID']['output']>;
  objectType: TransactionObjectTypes;
  organization: Organization;
  pending?: Maybe<Scalars['Boolean']['output']>;
  priceCents: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  requestId?: Maybe<Scalars['String']['output']>;
  risky?: Maybe<Scalars['Boolean']['output']>;
  settleDate?: Maybe<Scalars['GraphQLDate']['output']>;
  settleDateToWithdraw?: Maybe<Scalars['GraphQLDate']['output']>;
  /** Transaction's ID returned as string. It can either be the OneVest ID or an External ID from a Passthrough API. */
  stringId: Scalars['String']['output'];
  subAccount?: Maybe<SubAccount>;
  type: TransactionTypes;
  user: User;
  valueCents: Scalars['Float']['output'];
};


export type TransactionCustomFieldsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The integration enum and unique integration id  */
export type TransactionIntegration = {
  __typename?: 'TransactionIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<TransactionIntegrationTypes>;
};

/** Input type for integrations field */
export type TransactionIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<TransactionIntegrationTypes>;
};

/** Integrations for Transaction */
export enum TransactionIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export enum TransactionObjectTypes {
  Adjustment = 'Adjustment',
  BulkImport = 'BulkImport',
  BulkUpsert = 'BulkUpsert',
  CustodianActivity = 'CustodianActivity',
  CustodianSnapshot = 'CustodianSnapshot',
  Journal = 'Journal',
  PassthroughApi = 'PassthroughApi',
  SubTrade = 'SubTrade',
  Transfer = 'Transfer'
}

export type TransactionQueryFilter = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  accountType?: InputMaybe<HoldingAccountTypes>;
  clientGroupId?: InputMaybe<Scalars['SafeString']['input']>;
  currency?: InputMaybe<Currencies>;
  custodianTypes?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  dateAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  dateBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
  financialProductIds?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  goalIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  integrationIds?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<SourceTypesFilter>;
  subAccountIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<TransactionTypes>>>;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
};

export type TransactionTotal = {
  __typename?: 'TransactionTotal';
  totalCents: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum TransactionTypes {
  AccruedInterest = 'ACCRUED_INTEREST',
  AddCadEduSavingGrant = 'ADD_CAD_EDU_SAVING_GRANT',
  Adjustment = 'ADJUSTMENT',
  BookValueAdjustment = 'BOOK_VALUE_ADJUSTMENT',
  BorrowFee = 'BORROW_FEE',
  Buy = 'BUY',
  CanadaLearningBond = 'CANADA_LEARNING_BOND',
  CancelAdjustment = 'CANCEL_ADJUSTMENT',
  CancelBorrowFee = 'CANCEL_BORROW_FEE',
  CancelBuy = 'CANCEL_BUY',
  CancelCheque = 'CANCEL_CHEQUE',
  CancelCorporateAction = 'CANCEL_CORPORATE_ACTION',
  CancelDeposit = 'CANCEL_DEPOSIT',
  CancelDscFee = 'CANCEL_DSC_FEE',
  CancelEft = 'CANCEL_EFT',
  CancelFee = 'CANCEL_FEE',
  CancelHst = 'CANCEL_HST',
  CancelInterest = 'CANCEL_INTEREST',
  CancelJournal = 'CANCEL_JOURNAL',
  CancelManagementFee = 'CANCEL_MANAGEMENT_FEE',
  CancelRebate = 'CANCEL_REBATE',
  CancelSell = 'CANCEL_SELL',
  CancelSwitchIn = 'CANCEL_SWITCH_IN',
  CancelSwitchOut = 'CANCEL_SWITCH_OUT',
  CancelTransfer = 'CANCEL_TRANSFER',
  CancelTransferIn = 'CANCEL_TRANSFER_IN',
  CancelTransferOut = 'CANCEL_TRANSFER_OUT',
  Cheque = 'CHEQUE',
  Commission = 'COMMISSION',
  Contribution = 'CONTRIBUTION',
  CorporateAction = 'CORPORATE_ACTION',
  CustodyFee = 'CUSTODY_FEE',
  DepositBuy = 'DEPOSIT_BUY',
  DeregistrationFee = 'DEREGISTRATION_FEE',
  DeregistrationTax = 'DEREGISTRATION_TAX',
  DisabilityAssistancePayment = 'DISABILITY_ASSISTANCE_PAYMENT',
  Distribution = 'DISTRIBUTION',
  DistributionReinvestment = 'DISTRIBUTION_REINVESTMENT',
  Dividend = 'DIVIDEND',
  DscFee = 'DSC_FEE',
  Eft = 'EFT',
  Expense = 'EXPENSE',
  ExternalTransferIn = 'EXTERNAL_TRANSFER_IN',
  ExternalTransferInSecurity = 'EXTERNAL_TRANSFER_IN_SECURITY',
  ExternalTransferOut = 'EXTERNAL_TRANSFER_OUT',
  FederalTax = 'FEDERAL_TAX',
  ForeignTax = 'FOREIGN_TAX',
  GovContributions = 'GOV_CONTRIBUTIONS',
  Gst = 'GST',
  HomeBuyerPlan = 'HOME_BUYER_PLAN',
  Hst = 'HST',
  IncomeFundTransfer = 'INCOME_FUND_TRANSFER',
  Interest = 'INTEREST',
  Journal = 'JOURNAL',
  LifeLearningPlan = 'LIFE_LEARNING_PLAN',
  LongTermGainLoss = 'LONG_TERM_GAIN_LOSS',
  ManagementFee = 'MANAGEMENT_FEE',
  ManagementFeeRedemption = 'MANAGEMENT_FEE_REDEMPTION',
  MarketDrip = 'MARKET_DRIP',
  MiscFee = 'MISC_FEE',
  NonEduCapitalWithdrawal = 'NON_EDU_CAPITAL_WITHDRAWAL',
  Other = 'OTHER',
  Rebate = 'REBATE',
  Redemption = 'REDEMPTION',
  ReturnOfCapital = 'RETURN_OF_CAPITAL',
  RiskExposureFee = 'RISK_EXPOSURE_FEE',
  Sell = 'SELL',
  ShortTermGainLoss = 'SHORT_TERM_GAIN_LOSS',
  StockDrip = 'STOCK_DRIP',
  SwitchIn = 'SWITCH_IN',
  SwitchOut = 'SWITCH_OUT',
  SwiCost = 'SWI_COST',
  SwiMarket = 'SWI_MARKET',
  SwoCost = 'SWO_COST',
  SwoMarket = 'SWO_MARKET',
  TransfersExchanges = 'TRANSFERS_EXCHANGES',
  TransferIn = 'TRANSFER_IN',
  TransferInSecurity = 'TRANSFER_IN_SECURITY',
  TransferOut = 'TRANSFER_OUT',
  TransferOutSecurity = 'TRANSFER_OUT_SECURITY',
  WireTransfer = 'WIRE_TRANSFER',
  WithholdingTax = 'WITHHOLDING_TAX',
  WriteOff = 'WRITE_OFF'
}

export type Transfer = {
  __typename?: 'Transfer';
  /** Account */
  account?: Maybe<Scalars['ObjectID']['output']>;
  alertReport?: Maybe<Report>;
  /** Transfer amount in cents. */
  amountCents: Scalars['Long']['output'];
  bankAccount?: Maybe<BankAccount>;
  /** Reason why the Transfer has been cancelled */
  cancelReason?: Maybe<Scalars['String']['output']>;
  /** Reason why the Transfer has been cancelled after being reconciled */
  cancelReconciledReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  createdBy?: Maybe<PublicOrganizationUser>;
  currency: Currencies;
  /** The financial product the dividend was paid out for */
  dividendFor?: Maybe<FinancialProduct>;
  effectiveDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalBankAccountId?: Maybe<Scalars['String']['output']>;
  /** Reason why the TransitionTransfer has failed */
  failReason?: Maybe<Scalars['String']['output']>;
  fiscalDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** Account that Transfer is processed in. */
  fromSubAccount?: Maybe<SubAccount>;
  /** Auto-generated ID for this Transfer. */
  id: Scalars['ObjectID']['output'];
  initiatedByRepresentative?: Maybe<Scalars['Boolean']['output']>;
  /**
   * instantInvest skips the holding period before the amount is invested
   * Only available to partners with the certainty of deposits that do not bounce
   */
  instantInvest?: Maybe<Scalars['Boolean']['output']>;
  integrations?: Maybe<Array<Maybe<HoldingIntegration>>>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  isSuspicious?: Maybe<Scalars['Boolean']['output']>;
  isWithdrawAll?: Maybe<Scalars['Boolean']['output']>;
  manualProcess?: Maybe<ManualProcess>;
  organization: PublicOrganization;
  /** USA-specific wAPAX required attribute */
  participantNumber?: Maybe<Scalars['String']['output']>;
  reconciledAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** This an ID created by the partner, that is submitted with an Transfer request and unique to each request. */
  requestId?: Maybe<Scalars['String']['output']>;
  /** Source of Transfer. */
  source: TransferSources;
  /** ID of source if exists */
  sourceId?: Maybe<Scalars['ObjectID']['output']>;
  /** Current Transfer processing step that this request is at. */
  state: TransferState;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<HoldingStateMachineChanges>>>;
  /** Transfer state in translated form (en, fr). */
  stateTranslated?: Maybe<HoldingTranslatedString>;
  /** Account that Transfer is processed in. */
  subAccount: SubAccount;
  /** Type of Transfer request. DEPOSIT: depositTransfer WITHDRAW: withdrawTransfer */
  type: TransferType;
  /** Transfer type in translated form (en, fr). */
  typeTranslated?: Maybe<HoldingTranslatedString>;
  /** USA-specific withdrawal and contribution reasons */
  usaContributionType?: Maybe<UsaContributionType>;
  /** Federal tax withholding percentage */
  usaFederalTaxWithholdingPercentage?: Maybe<Scalars['Float']['output']>;
  /** State tax withholding percentage */
  usaStateTaxWithholdingPercentage?: Maybe<Scalars['Float']['output']>;
  usaWithdrawalReason?: Maybe<UsaWithdrawalReason>;
  /** User */
  user?: Maybe<Scalars['ObjectID']['output']>;
  withdrawalMode?: Maybe<WithdrawalMode>;
  /** Internal OneVest Withdrawal Reasons */
  withdrawalReason?: Maybe<WithdrawalReason>;
  withdrawalReasonDescription?: Maybe<Scalars['String']['output']>;
};

export type TransferAllBetweenSubAccountsInput = {
  fiscalYear?: InputMaybe<Scalars['Int']['input']>;
  fromSubAccountId: Scalars['ObjectID']['input'];
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  toSubAccountId: Scalars['ObjectID']['input'];
};

export type TransferAllBetweenSubAccountsResponse = {
  __typename?: 'TransferAllBetweenSubAccountsResponse';
  transfer: Transfer;
};

export type TransferBetweenSubAccountsInput = {
  amountCents: Scalars['Long']['input'];
  currency?: InputMaybe<Currencies>;
  fiscalYear?: InputMaybe<Scalars['Int']['input']>;
  fromSubAccountId: Scalars['ObjectID']['input'];
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  toSubAccountId: Scalars['ObjectID']['input'];
};

export type TransferBetweenSubAccountsResponse = {
  __typename?: 'TransferBetweenSubAccountsResponse';
  transfer: Transfer;
};

export type TransferEquityBetweenSubAccountsInput = {
  financialProductId: Scalars['ObjectID']['input'];
  fromSubAccountId: Scalars['ObjectID']['input'];
  quantity: Scalars['Float']['input'];
  toSubAccountId: Scalars['ObjectID']['input'];
};

export type TransferEquityBetweenSubAccountsResponse = {
  __typename?: 'TransferEquityBetweenSubAccountsResponse';
  buy: SubTrade;
  deposit?: Maybe<Transfer>;
  sell: SubTrade;
  withdraw?: Maybe<Transfer>;
};

export type TransferMonitoringTranslatedString = {
  __typename?: 'TransferMonitoringTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

/** Supported Transfer sources. */
export enum TransferSources {
  Adjustment = 'ADJUSTMENT',
  Cheque = 'CHEQUE',
  CustodianActivity = 'CUSTODIAN_ACTIVITY',
  Deregistration = 'DEREGISTRATION',
  DeregistrationTax = 'DEREGISTRATION_TAX',
  Distribution = 'DISTRIBUTION',
  Dividend = 'DIVIDEND',
  DscFee = 'DSC_FEE',
  ExternalTransferIn = 'EXTERNAL_TRANSFER_IN',
  ExternalTransferOut = 'EXTERNAL_TRANSFER_OUT',
  Fee = 'FEE',
  FromAccount = 'FROM_ACCOUNT',
  FromSubAccount = 'FROM_SUB_ACCOUNT',
  GovContributions = 'GOV_CONTRIBUTIONS',
  IncomeFundTransfer = 'INCOME_FUND_TRANSFER',
  ToAccount = 'TO_ACCOUNT',
  ToSubAccount = 'TO_SUB_ACCOUNT',
  User = 'USER',
  WithholdingTax = 'WITHHOLDING_TAX'
}

/** Transfer processing steps. */
export enum TransferState {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Reconciled = 'RECONCILED',
  Requested = 'REQUESTED',
  Reviewing = 'REVIEWING'
}

export enum TransferTransition {
  Cancel = 'cancel',
  CancelReconciled = 'cancelReconciled',
  Fail = 'fail',
  FlipCancelToReconcile = 'flipCancelToReconcile',
  Initiate = 'initiate',
  Process = 'process',
  Ready = 'ready',
  Reconcile = 'reconcile',
  ReconcileDepositBetweenSubAccounts = 'reconcileDepositBetweenSubAccounts',
  ReconcileWithdrawBetweenSubAccounts = 'reconcileWithdrawBetweenSubAccounts',
  Request = 'request',
  Review = 'review'
}

/** Supported Transfer types. */
export enum TransferType {
  Deposit = 'DEPOSIT',
  Withdraw = 'WITHDRAW'
}

export enum TransferTypes {
  Deposit = 'DEPOSIT',
  Withdraw = 'WITHDRAW'
}

export type TransitionAccountBulkUpsertItemInput = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
  transition: AccountBulkUpsertItemTransition;
};

export type TransitionAccountBulkUpsertItemResponse = {
  __typename?: 'TransitionAccountBulkUpsertItemResponse';
  bulkUpsertItem: AccountBulkUpsertItem;
};

export type TransitionAccountBulkUpsertRequestInput = {
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  transition: AccountBulkUpsertRequestTransition;
};

export type TransitionAccountBulkUpsertRequestResponse = {
  __typename?: 'TransitionAccountBulkUpsertRequestResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type TransitionAccountFeeInput = {
  accountFeeId: Scalars['ObjectID']['input'];
  transition: AccountFeeTransition;
};

export type TransitionAccountFeeResponse = {
  __typename?: 'TransitionAccountFeeResponse';
  accountFee?: Maybe<AccountFee>;
};

export type TransitionAccountGroupBulkUpsertItemInput = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
  transition: AccountGroupBulkUpsertItemTransition;
};

export type TransitionAccountGroupBulkUpsertItemResponse = {
  __typename?: 'TransitionAccountGroupBulkUpsertItemResponse';
  bulkUpsertItem: AccountGroupBulkUpsertItem;
};

export type TransitionAccountGroupBulkUpsertRequestInput = {
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  transition: AccountGroupBulkUpsertRequestTransition;
};

export type TransitionAccountGroupBulkUpsertRequestResponse = {
  __typename?: 'TransitionAccountGroupBulkUpsertRequestResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type TransitionAccountGroupInput = {
  accountGroupId: Scalars['ObjectID']['input'];
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
  transition: AccountGroupTransition;
};

export type TransitionAccountGroupResponse = {
  __typename?: 'TransitionAccountGroupResponse';
  accountGroup: AccountGroup;
};

export type TransitionAccountInput = {
  accountId: Scalars['ObjectID']['input'];
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
  transition?: InputMaybe<AccountTransition>;
};

export type TransitionAccountResponse = {
  __typename?: 'TransitionAccountResponse';
  account?: Maybe<Account>;
};

export type TransitionAccountStatementFilter = {
  accountStatementIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  accountType?: InputMaybe<AccountTypesFilters>;
  afterDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  beforeDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  typeGroup?: InputMaybe<TypeGroup>;
};

export type TransitionAccountStatementInput = {
  accountStatementId: Scalars['ObjectID']['input'];
  transition: AccountStatementTransition;
};

export type TransitionAccountStatementResponse = {
  __typename?: 'TransitionAccountStatementResponse';
  accountStatement?: Maybe<AccountStatement>;
};

export type TransitionAccountStatementsInput = {
  filter: TransitionAccountStatementFilter;
  transition: AccountStatementTransition;
  transitionAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransitionAccountStatementsResponse = {
  __typename?: 'TransitionAccountStatementsResponse';
  message?: Maybe<Scalars['SafeString']['output']>;
};

export type TransitionAdvisorContactInput = {
  advisorContactId: Scalars['ObjectID']['input'];
  transition: AdvisorContactTransitions;
};

export type TransitionAdvisorContactResponse = {
  __typename?: 'TransitionAdvisorContactResponse';
  advisorContact: AdvisorContact;
};

export type TransitionAlertBannerInput = {
  alertBannerId: Scalars['ObjectID']['input'];
  transition: AlertBannerTransitions;
};

export type TransitionAlertBannerInteractionInput = {
  alertBannerInteractionId: Scalars['ObjectID']['input'];
  transition: AlertBannerInteractionTransitions;
};

export type TransitionAlertBannerInteractionResponse = {
  __typename?: 'TransitionAlertBannerInteractionResponse';
  alertBannerInteraction: AlertBannerInteraction;
};

export type TransitionAlertBannerResponse = {
  __typename?: 'TransitionAlertBannerResponse';
  alertBanner: AlertBanner;
};

export type TransitionApiTokenInput = {
  apiTokenId: Scalars['ObjectID']['input'];
  transition: ApiTokenTransitions;
};

export type TransitionApiTokenResponse = {
  __typename?: 'TransitionApiTokenResponse';
  apiToken: ApiToken;
};

export type TransitionArticleInput = {
  articleId: Scalars['ObjectID']['input'];
  transition: ArticleTransition;
};

export type TransitionArticleResponse = {
  __typename?: 'TransitionArticleResponse';
  article: Article;
};

export type TransitionAssetClassInput = {
  assetClassId: Scalars['ObjectID']['input'];
  transition: AssetClassTransitions;
};

export type TransitionAssetClassResponse = {
  __typename?: 'TransitionAssetClassResponse';
  assetClass: AssetClass;
};

export type TransitionBankAccountBulkUpsertItemInput = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
  transition: BankAccountBulkUpsertItemTransition;
};

export type TransitionBankAccountBulkUpsertItemResponse = {
  __typename?: 'TransitionBankAccountBulkUpsertItemResponse';
  bulkUpsertItem: BankAccountBulkUpsertItem;
};

export type TransitionBankAccountBulkUpsertRequestInput = {
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  transition: BankAccountBulkUpsertRequestTransition;
};

export type TransitionBankAccountBulkUpsertRequestResponse = {
  __typename?: 'TransitionBankAccountBulkUpsertRequestResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type TransitionBankAccountInput = {
  bankAccountId: Scalars['ObjectID']['input'];
  transition: BankAccountTransition;
};

export type TransitionBankAccountResponse = {
  __typename?: 'TransitionBankAccountResponse';
  bankAccount?: Maybe<BankAccount>;
};

export type TransitionBillingCycleInput = {
  billingCycleId: Scalars['ObjectID']['input'];
  transition: BillingCycleTransition;
};

export type TransitionBillingCycleResponse = {
  __typename?: 'TransitionBillingCycleResponse';
  billingCycle: BillingCycle;
};

export type TransitionBillingScheduleInput = {
  billingScheduleId: Scalars['ObjectID']['input'];
  transition: FeeTierTransition;
};

export type TransitionBillingScheduleResponse = {
  __typename?: 'TransitionBillingScheduleResponse';
  billingSchedule: BillingSchedule;
};

export type TransitionBulkImportInput = {
  bulkImportId: Scalars['ObjectID']['input'];
  sync?: InputMaybe<Scalars['Boolean']['input']>;
  transition: BulkImportTransition;
};

export type TransitionBulkImportResponse = {
  __typename?: 'TransitionBulkImportResponse';
  bulkImport?: Maybe<BulkImport>;
};

export type TransitionBulkTradeRequestInput = {
  bulkTradeRequestId: Scalars['ObjectID']['input'];
  transition: BulkTradeRequestTransition;
};

export type TransitionBulkTradeRequestResponse = {
  __typename?: 'TransitionBulkTradeRequestResponse';
  bulkTradeRequest: BulkTradeRequest;
};

export type TransitionBulkTradeRunInput = {
  bulkTradeRunId: Scalars['ObjectID']['input'];
  options?: InputMaybe<TransitionBulkTradeRunInputOptions>;
  transition: BulkTradeRunTransition;
};

export type TransitionBulkTradeRunInputOptions = {
  /** Auto reconcile when transit to publishAllocations. */
  autoReconcile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransitionBulkTradeRunResponse = {
  __typename?: 'TransitionBulkTradeRunResponse';
  bulkTradeRun: BulkTradeRun;
};

export type TransitionClientGroupInput = {
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrationId?: InputMaybe<Scalars['SafeString']['input']>;
  transition: ClientGroupTransition;
};

export type TransitionClientGroupResponse = {
  __typename?: 'TransitionClientGroupResponse';
  clientGroup?: Maybe<ClientGroup>;
};

export type TransitionConfigurableTablePageInput = {
  configurableTablePageId: Scalars['ObjectID']['input'];
  transition: ConfigurableTablePageTransitions;
};

export type TransitionConfigurableTablePageResponse = {
  __typename?: 'TransitionConfigurableTablePageResponse';
  configurableTablePage: ConfigurableTablePage;
};

export type TransitionCustomAttributeLabelInput = {
  customAttributeLabelId: Scalars['ObjectID']['input'];
  transition: CustomAttributeLabelTransitions;
};

export type TransitionCustomAttributeLabelResponse = {
  __typename?: 'TransitionCustomAttributeLabelResponse';
  customAttributeLabel: CustomAttributeLabel;
};

export type TransitionCustomFieldInput = {
  customFieldId: Scalars['ObjectID']['input'];
  transition: CustomFieldTransitions;
};

export type TransitionCustomFieldResponse = {
  __typename?: 'TransitionCustomFieldResponse';
  customField?: Maybe<CustomField>;
};

export type TransitionDisplayRoleInput = {
  displayRoleId: Scalars['ObjectID']['input'];
  transition: DisplayRoleTransitions;
};

export type TransitionDisplayRoleResponse = {
  __typename?: 'TransitionDisplayRoleResponse';
  displayRole: DisplayRole;
};

export type TransitionDowntimeScheduleInput = {
  downtimeScheduleId: Scalars['ObjectID']['input'];
  transition: DowntimeScheduleTransitionStates;
};

export type TransitionDowntimeScheduleResponse = {
  __typename?: 'TransitionDowntimeScheduleResponse';
  downtimeSchedule: DowntimeSchedule;
};

export type TransitionFeeTierInput = {
  feeTierId: Scalars['ObjectID']['input'];
  transition: FeeTierTransition;
};

export type TransitionFeeTierResponse = {
  __typename?: 'TransitionFeeTierResponse';
  feeTier: FeeTier;
};

export type TransitionFinancialProductBulkUpsertItemInput = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
  transition: FinancialProductBulkUpsertItemTransition;
};

export type TransitionFinancialProductBulkUpsertItemResponse = {
  __typename?: 'TransitionFinancialProductBulkUpsertItemResponse';
  bulkUpsertItem: FinancialProductBulkUpsertItem;
};

export type TransitionFinancialProductBulkUpsertRequestInput = {
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  transition: FinancialProductBulkUpsertRequestTransition;
};

export type TransitionFinancialProductBulkUpsertRequestResponse = {
  __typename?: 'TransitionFinancialProductBulkUpsertRequestResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type TransitionFinancialProductInput = {
  financialProductId: Scalars['ObjectID']['input'];
  transition: FinancialProductTransitions;
};

export type TransitionFinancialProductResponse = {
  __typename?: 'TransitionFinancialProductResponse';
  financialProduct: FinancialProduct;
};

export type TransitionFlagInput = {
  /**
   * Display name of the operator saving notes alongside this transition.
   * When omitted, falls back to connection metadata on the JWT.
   */
  author?: InputMaybe<Scalars['SafeString']['input']>;
  flagId: Scalars['ObjectID']['input'];
  /**
   * Optional investigation context to persist atomically with the transition.
   * Only honored when the flag is currently FLAGGED. Omit to preserve existing
   * notes; pass an empty string to clear. HTML is rejected.
   */
  notes?: InputMaybe<Scalars['SafeString']['input']>;
  transition: FlagTransition;
};

export type TransitionFlagResponse = {
  __typename?: 'TransitionFlagResponse';
  flag?: Maybe<Flag>;
};

export type TransitionFormDefinitionInput = {
  formDefinitionId: Scalars['ObjectID']['input'];
  transition: FormDefinitionTransition;
};

export type TransitionFormDefinitionResponse = {
  __typename?: 'TransitionFormDefinitionResponse';
  formDefinition: FormDefinition;
};

export type TransitionFormTemplateInput = {
  formTemplateId: Scalars['ObjectID']['input'];
  transition: FormTemplateTransition;
};

export type TransitionFormTemplateResponse = {
  __typename?: 'TransitionFormTemplateResponse';
  formTemplate: FormTemplate;
};

export type TransitionHistoryBulkUpsertItemInput = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
  transition: HistoryBulkUpsertItemTransition;
};

export type TransitionHistoryBulkUpsertItemResponse = {
  __typename?: 'TransitionHistoryBulkUpsertItemResponse';
  bulkUpsertItem: HistoryBulkUpsertItem;
};

export type TransitionHistoryBulkUpsertRequestInput = {
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  transition: HistoryBulkUpsertRequestTransition;
};

export type TransitionHistoryBulkUpsertRequestResponse = {
  __typename?: 'TransitionHistoryBulkUpsertRequestResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type TransitionHoldingBulkUpsertItemInput = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
  transition: HoldingBulkUpsertItemTransition;
};

export type TransitionHoldingBulkUpsertItemResponse = {
  __typename?: 'TransitionHoldingBulkUpsertItemResponse';
  bulkUpsertItem: HoldingBulkUpsertItem;
};

export type TransitionHoldingBulkUpsertRequestInput = {
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  transition: HoldingBulkUpsertRequestTransition;
};

export type TransitionHoldingBulkUpsertRequestResponse = {
  __typename?: 'TransitionHoldingBulkUpsertRequestResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type TransitionHomePageConfigurationInput = {
  homePageConfigurationId: Scalars['ObjectID']['input'];
  transition: HomePageConfigurationTransitions;
};

export type TransitionHomePageConfigurationResponse = {
  __typename?: 'TransitionHomePageConfigurationResponse';
  homePageConfiguration?: Maybe<HomePageConfiguration>;
};

export type TransitionImportFileInput = {
  importFileId: Scalars['ObjectID']['input'];
  sync?: InputMaybe<Scalars['Boolean']['input']>;
  transition: ImportFileTransition;
};

export type TransitionImportFileResponse = {
  __typename?: 'TransitionImportFileResponse';
  importFile?: Maybe<ImportFile>;
};

export type TransitionInstitutionInput = {
  institutionId: Scalars['ObjectID']['input'];
  transition: InstitutionTransition;
};

export type TransitionInstitutionResponse = {
  __typename?: 'TransitionInstitutionResponse';
  institution?: Maybe<Institution>;
};

export type TransitionIntegrationInput = {
  integrationId: Scalars['ObjectID']['input'];
  transition: IntegrationTransitionStates;
};

export type TransitionIntegrationRequestPayloadInput = {
  integrationRequestPayloadId: Scalars['ObjectID']['input'];
  responseFileDocumentId?: InputMaybe<Scalars['ObjectID']['input']>;
  transition: IntegrationRequestPayloadTransition;
};

export type TransitionIntegrationRequestPayloadResponse = {
  __typename?: 'TransitionIntegrationRequestPayloadResponse';
  integrationRequestPayload: IntegrationRequestPayload;
};

export type TransitionIntegrationResponse = {
  __typename?: 'TransitionIntegrationResponse';
  integration?: Maybe<Integration>;
};

export type TransitionLocalizationInput = {
  localizationId: Scalars['ObjectID']['input'];
  transition: LocalizationTransitions;
};

export type TransitionLocalizationResponse = {
  __typename?: 'TransitionLocalizationResponse';
  localization?: Maybe<Localization>;
};

export type TransitionManualProcessInput = {
  manualProcessId: Scalars['ObjectID']['input'];
  transition: ManualProcessTransition;
};

export type TransitionManualProcessResponse = {
  __typename?: 'TransitionManualProcessResponse';
  manualProcess?: Maybe<ManualProcess>;
};

export type TransitionModelChangeProposalInput = {
  modelChangeProposalId: Scalars['ObjectID']['input'];
  transition: ModelChangeProposalTransitions;
};

export type TransitionModelChangeProposalResponse = {
  __typename?: 'TransitionModelChangeProposalResponse';
  modelChangeProposal: ModelChangeProposal;
};

export type TransitionModelPortfolioInput = {
  modelPortfolioId: Scalars['ObjectID']['input'];
  transition: FinancialProductTransitions;
};

export type TransitionModelPortfolioResponse = {
  __typename?: 'TransitionModelPortfolioResponse';
  modelPortfolio: FinancialProduct;
};

export type TransitionNoteInput = {
  noteId: Scalars['ObjectID']['input'];
  transition: NoteTransition;
};

export type TransitionNoteResponse = {
  __typename?: 'TransitionNoteResponse';
  note?: Maybe<Note>;
};

export type TransitionOrganizationBulkUpsertItemInput = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
  transition: OrganizationBulkUpsertItemTransition;
};

export type TransitionOrganizationBulkUpsertItemResponse = {
  __typename?: 'TransitionOrganizationBulkUpsertItemResponse';
  bulkUpsertItem: OrganizationBulkUpsertItem;
};

export type TransitionOrganizationBulkUpsertRequestInput = {
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  transition: OrganizationBulkUpsertRequestTransition;
};

export type TransitionOrganizationBulkUpsertRequestResponse = {
  __typename?: 'TransitionOrganizationBulkUpsertRequestResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

export type TransitionOrganizationDashboardInput = {
  dashboardId: Scalars['ObjectID']['input'];
  transition: DashboardTransitions;
};

export type TransitionOrganizationDashboardResponse = {
  __typename?: 'TransitionOrganizationDashboardResponse';
  dashboard?: Maybe<Dashboard>;
};

export type TransitionPageConfigurationInput = {
  pageConfigurationId: Scalars['ObjectID']['input'];
  transition: PageConfigurationTransition;
};

export type TransitionPageConfigurationResponse = {
  __typename?: 'TransitionPageConfigurationResponse';
  pageConfiguration?: Maybe<PageConfiguration>;
};

export type TransitionPortfolioOptimizerInput = {
  portfolioOptimizerId: Scalars['ObjectID']['input'];
  transition: PortfolioOptimizerTransition;
};

export type TransitionPortfolioOptimizerResponse = {
  __typename?: 'TransitionPortfolioOptimizerResponse';
  portfolioOptimizer: PortfolioOptimizer;
};

export type TransitionPortfolioTemplateInput = {
  portfolioTemplateId: Scalars['ObjectID']['input'];
  transition: PortfolioTemplateTransitions;
};

export type TransitionPortfolioTemplateResponse = {
  __typename?: 'TransitionPortfolioTemplateResponse';
  portfolioTemplate: PortfolioTemplate;
};

export type TransitionRebalanceInput = {
  rebalanceId: Scalars['ObjectID']['input'];
  transition: RebalanceTransition;
};

export type TransitionRebalanceResponse = {
  __typename?: 'TransitionRebalanceResponse';
  rebalance?: Maybe<Rebalance>;
};

export type TransitionRepCodeInput = {
  repCodeId: Scalars['ObjectID']['input'];
  transition: RepCodeTransitions;
};

export type TransitionRepCodeResponse = {
  __typename?: 'TransitionRepCodeResponse';
  repCode?: Maybe<RepCode>;
};

export type TransitionReportInput = {
  reportId: Scalars['ObjectID']['input'];
  transition: ReportTransitions;
};

export type TransitionReportResponse = {
  __typename?: 'TransitionReportResponse';
  report: Report;
};

export type TransitionRoleProfileInput = {
  roleProfileId: Scalars['ObjectID']['input'];
  transition: PageConfigurationTransition;
};

export type TransitionRoleProfileResponse = {
  __typename?: 'TransitionRoleProfileResponse';
  roleProfile?: Maybe<RoleProfile>;
};

export type TransitionScheduledIncomeFundTransferInput = {
  scheduledIncomeFundTransferId: Scalars['ObjectID']['input'];
  transition: ScheduledIncomeFundTransferTransferTransition;
};

export type TransitionScheduledIncomeFundTransferResponse = {
  __typename?: 'TransitionScheduledIncomeFundTransferResponse';
  scheduledIncomeFundTransfer?: Maybe<ScheduledIncomeFundTransfer>;
};

export type TransitionSiemFeedInput = {
  siemFeedId: Scalars['ObjectID']['input'];
  transition: SiemFeedTransitions;
};

export type TransitionSiemFeedResponse = {
  __typename?: 'TransitionSiemFeedResponse';
  siemFeed: SiemFeed;
};

export type TransitionSignerTypeInput = {
  signerTypeId: Scalars['ObjectID']['input'];
  transition: SignerTypeTransition;
};

export type TransitionSignerTypeResponse = {
  __typename?: 'TransitionSignerTypeResponse';
  signerType: SignerType;
};

export type TransitionStaticPageWidgetConfigurationInput = {
  staticPageWidgetConfigurationId: Scalars['ObjectID']['input'];
  transition: StaticPageWidgetConfigurationTransitions;
};

export type TransitionStaticPageWidgetConfigurationResponse = {
  __typename?: 'TransitionStaticPageWidgetConfigurationResponse';
  staticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
};

export type TransitionSubAccountInput = {
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  transition?: InputMaybe<SubAccountTransition>;
};

export type TransitionSubAccountResponse = {
  __typename?: 'TransitionSubAccountResponse';
  subAccount: SubAccount;
};

export type TransitionSubTradeRequestInput = {
  subTradeRequestId: Scalars['ObjectID']['input'];
  transition: SubTradeRequestTransition;
};

export type TransitionSubTradeRequestResponse = {
  __typename?: 'TransitionSubTradeRequestResponse';
  subTradeRequest: SubTradeRequest;
};

export type TransitionThemeInput = {
  themeId: Scalars['ObjectID']['input'];
  transition: ThemeTransitions;
};

export type TransitionThemeResponse = {
  __typename?: 'TransitionThemeResponse';
  theme: Theme;
};

export type TransitionTradeInput = {
  failReason?: InputMaybe<Scalars['SafeString']['input']>;
  tradeId: Scalars['ObjectID']['input'];
  transition: TradeTransition;
};

export type TransitionTradeResponse = {
  __typename?: 'TransitionTradeResponse';
  trade?: Maybe<Trade>;
};

export type TransitionTransferInput = {
  cancelReason?: InputMaybe<Scalars['SafeString']['input']>;
  cancelReconciledReason?: InputMaybe<Scalars['SafeString']['input']>;
  failReason?: InputMaybe<Scalars['SafeString']['input']>;
  transferId: Scalars['ObjectID']['input'];
  transition: TransferTransition;
};

export type TransitionTransferResponse = {
  __typename?: 'TransitionTransferResponse';
  transfer?: Maybe<Transfer>;
};

export type TransitionUserBulkUpsertItemInput = {
  bulkUpsertItemId: Scalars['ObjectID']['input'];
  transition: UserBulkUpsertItemTransition;
};

export type TransitionUserBulkUpsertItemResponse = {
  __typename?: 'TransitionUserBulkUpsertItemResponse';
  bulkUpsertItem: UserBulkUpsertItem;
};

export type TransitionUserBulkUpsertRequestInput = {
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  transition: UserBulkUpsertRequestTransition;
};

export type TransitionUserBulkUpsertRequestResponse = {
  __typename?: 'TransitionUserBulkUpsertRequestResponse';
  bulkUpsertRequestId: Scalars['ObjectID']['output'];
};

/** Transition states for user's idVerification */
export type TransitionUserIdVerificationInput = {
  idVerificationId: Scalars['ObjectID']['input'];
  transition: IdVerificationTransition;
};

export type TransitionUserIdVerificationResponse = {
  __typename?: 'TransitionUserIdVerificationResponse';
  idVerification?: Maybe<IdVerification>;
};

/** Input type for Transitioning a user */
export type TransitionUserInput = {
  /** Integrations */
  integrationId?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's profile transition */
  transition: UserTransition;
  /** UserID */
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

/** Type definition for user's transition */
export type TransitionUserResponse = {
  __typename?: 'TransitionUserResponse';
  /** User object */
  user?: Maybe<User>;
};

export type TransitionWorkflowCompletionInput = {
  transition: WorkflowCompletionTransition;
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type TransitionWorkflowCompletionResponse = {
  __typename?: 'TransitionWorkflowCompletionResponse';
  workflowCompletion: WorkflowCompletion;
};

export type TransitionWorkflowInput = {
  transition: WorkflowTransition;
  workflowId: Scalars['ObjectID']['input'];
};

export type TransitionWorkflowResponse = {
  __typename?: 'TransitionWorkflowResponse';
  workflow: Workflow;
};

export type TranslatedStringInput = {
  en?: InputMaybe<Scalars['SafeString']['input']>;
  es?: InputMaybe<Scalars['SafeString']['input']>;
  fr?: InputMaybe<Scalars['SafeString']['input']>;
};

export type TriggerAutoBulkTradesInput = {
  rebalanceId: Scalars['ObjectID']['input'];
};

export type TriggerAutoBulkTradesResponse = {
  __typename?: 'TriggerAutoBulkTradesResponse';
  rebalance?: Maybe<Rebalance>;
};

export type TriggerModelPortfolioResignInput = {
  modelPortfolioId: Scalars['ObjectID']['input'];
  /**
   * This will be used to describe why form agreements need to be re-signed (e.g. when a portfolio's
   * secondaryAssetClass, description, and/or targetAllocations have changed).
   */
  translatedReasonForUpdate: ProductTranslatedStringInput;
};

export enum TriggerObjectTypes {
  Account = 'Account',
  AccountStatement = 'AccountStatement',
  Goal = 'Goal',
  ScheduledTransfer = 'ScheduledTransfer',
  SubAccount = 'SubAccount',
  Transfer = 'Transfer',
  User = 'User'
}

export type TriggerRule = {
  __typename?: 'TriggerRule';
  comparison: TriggerRuleComparisonTypes;
  field: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum TriggerRuleComparisonTypes {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanAgo = 'GREATER_THAN_AGO',
  In = 'IN',
  Includes = 'INCLUDES',
  LessThan = 'LESS_THAN',
  LessThanAgo = 'LESS_THAN_AGO',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN',
  NotIncludes = 'NOT_INCLUDES'
}

export type TriggerRuleInput = {
  comparison: TriggerRuleComparisonTypes;
  field: Scalars['SafeString']['input'];
  value: Scalars['SafeString']['input'];
};

export type TriggerSynchronousIntegrationInput = {
  persistResponseToContext?: InputMaybe<Scalars['Boolean']['input']>;
  subStepId: Scalars['ObjectID']['input'];
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type TriggerSynchronousIntegrationResponse = {
  __typename?: 'TriggerSynchronousIntegrationResponse';
  workflowCompletion: WorkflowCompletion;
};

export enum TriggerTypes {
  Event = 'EVENT',
  Manual = 'MANUAL'
}

export enum TrustTypes {
  Complex = 'COMPLEX',
  Grantor = 'GRANTOR',
  Simple = 'SIMPLE'
}

/** User's Trusted Contact Person */
export type TrustedContactPerson = {
  __typename?: 'TrustedContactPerson';
  /** Email of trusted contact person. Email addresses must contain alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  email?: Maybe<Scalars['String']['output']>;
  /** Full name of the trusted contact person */
  name?: Maybe<Scalars['String']['output']>;
  /** Trusted contact person's phone number. Must contain 7-15 digits, including country code (E.164 format).. */
  phone?: Maybe<Scalars['String']['output']>;
  physicalAddress?: Maybe<PhysicalAddress>;
  /** The relationship between the user and the trusted contact person */
  relation?: Maybe<Relation>;
  /** Relationship between the user and the trusted contact person in translated form (en, fr, etc..). */
  relationTranslated?: Maybe<UserTranslatedString>;
};

/** Describes user's designated trusted contact person.  */
export type TrustedContactPersonInput = {
  /** Trusted contact person's email */
  email?: InputMaybe<Scalars['SafeString']['input']>;
  /** Trusted contact person's legal full name */
  name?: InputMaybe<Scalars['SafeString']['input']>;
  /** Trusted contact person's phone number. Must contain 7-15 digits, including country code (E.164 format).  */
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  physicalAddress?: InputMaybe<PhysicalAddressInput>;
  /** Optional field that describes relationship to primary account holder.  */
  relation?: InputMaybe<Relation>;
};

export enum TypeGroup {
  ManagementFees = 'MANAGEMENT_FEES',
  Statements = 'STATEMENTS',
  Tax = 'TAX',
  TradeConfirmations = 'TRADE_CONFIRMATIONS'
}

export type UnlinkPhoneMultifactorResponse = {
  __typename?: 'UnlinkPhoneMultifactorResponse';
  user?: Maybe<User>;
};

export type UnrealizedGainsAndLoss = {
  __typename?: 'UnrealizedGainsAndLoss';
  unrealizedGainsAndLossCents?: Maybe<Scalars['Float']['output']>;
  unrealizedGainsAndLossCentsPercentage?: Maybe<Scalars['Float']['output']>;
};

export type UpcomingTransfer = {
  __typename?: 'UpcomingTransfer';
  /** Transfer amount in cents. */
  amountCents: Scalars['Long']['output'];
  bankAccount?: Maybe<BankAccount>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  currency: Currencies;
  /** The financial product the dividend was paid out for */
  dividendFor?: Maybe<FinancialProduct>;
  /** Date on which the scheduled Transfer will end */
  endDate?: Maybe<Scalars['GraphQLDate']['output']>;
  /** Reason why the TransitionTransfer has failed */
  failReason?: Maybe<Scalars['String']['output']>;
  fiscalDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** Is this a **one_time** Transfer request or **daily**, **weekly**, **semi_monthly** or **monthly** recurring Transfer request? */
  frequency?: Maybe<Frequency>;
  /** Account that Transfer is processed in. */
  fromSubAccount?: Maybe<SubAccount>;
  /** Auto-generated ID for this Transfer. */
  id: Scalars['ObjectID']['output'];
  initiatedByRepresentative?: Maybe<Scalars['Boolean']['output']>;
  /**
   * instantInvest skips the holding period before the amount is invested
   * Only available to partners with the certainty of deposits that do not bounce
   */
  instantInvest?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  isWithdrawAll?: Maybe<Scalars['Boolean']['output']>;
  /** Why the most recent scheduled run was skipped. Scheduled transfers only. */
  lastSkipReason?: Maybe<Scalars['String']['output']>;
  /** When the most recent scheduled run was skipped without creating a transfer. Scheduled transfers only. */
  lastSkippedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  manualProcess?: Maybe<ManualProcess>;
  reconciledAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  representative?: Maybe<PublicOrganizationUser>;
  /** This an ID created by the partner, that is submitted with an Transfer request and unique to each request. */
  requestId?: Maybe<Scalars['String']['output']>;
  /** Set date to schedule an Transfer for a future date. */
  scheduledDate?: Maybe<Scalars['GraphQLDate']['output']>;
  /** Source of Transfer. */
  source?: Maybe<TransferSources>;
  /** ID of source if exists */
  sourceId?: Maybe<Scalars['ObjectID']['output']>;
  /** Current Transfer processing step that this request is at. */
  state: UpcomingTransfersStates;
  /** @deprecated Use stateMachineChanges instead. */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<HoldingStateMachineChanges>>>;
  /** Upcoming transfer state in translated form (en, fr). */
  stateTranslated?: Maybe<HoldingTranslatedString>;
  /** Account that Transfer is processed in. */
  subAccount: SubAccount;
  toSubAccount?: Maybe<SubAccount>;
  transferAll?: Maybe<Scalars['Boolean']['output']>;
  /** Type of Transfer request. DEPOSIT: depositTransfer WITHDRAW: withdrawTransfer */
  type: TransferType;
  /** Transfer type in translated form (en, fr). */
  typeTranslated?: Maybe<HoldingTranslatedString>;
  withdrawalMode?: Maybe<WithdrawalMode>;
  /** Withdrawal Reasons */
  withdrawalReason?: Maybe<WithdrawalReason>;
  withdrawalReasonDescription?: Maybe<Scalars['String']['output']>;
};

export type UpcomingTransferQueryFilter = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  createdAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  states?: InputMaybe<Array<InputMaybe<UpcomingTransfersStates>>>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  type?: InputMaybe<TransferType>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export enum UpcomingTransfersStates {
  Active = 'ACTIVE',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Requested = 'REQUESTED',
  Reviewing = 'REVIEWING'
}

export type UpdateAccountGroupInput = {
  accountGroupId: Scalars['ObjectID']['input'];
  appendAccountIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  removeAccountIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  translatedName?: InputMaybe<AccountTranslatedStringInput>;
};

export type UpdateAccountGroupResponse = {
  __typename?: 'UpdateAccountGroupResponse';
  accountGroup: AccountGroup;
};

export type UpdateAccountInput = {
  accountId: Scalars['ObjectID']['input'];
  applyForGovFunds?: InputMaybe<Array<InputMaybe<ApplyForGovFunds>>>;
  availableCurrencies?: InputMaybe<Array<InputMaybe<AccountCurrencyTypes>>>;
  baseCurrency?: InputMaybe<AccountCurrencyTypes>;
  /** @deprecated Use the updateEntityFeeSetting mutation instead. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** @deprecated Use householdClientGroupId or corporationClientGroupId instead. */
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  corporationClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  custodianAccountName?: InputMaybe<Scalars['SafeString']['input']>;
  custodianAccountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  custodianConnectionId?: InputMaybe<Scalars['ObjectID']['input']>;
  custodianSortingOrderPriority?: InputMaybe<Scalars['Int']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  dealerAccountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  dealerCode?: InputMaybe<Scalars['SafeString']['input']>;
  dealerName?: InputMaybe<Scalars['SafeString']['input']>;
  eligibleForDisabilityTaxCredit?: InputMaybe<Scalars['Boolean']['input']>;
  externalSourceType?: InputMaybe<ExternalSourceTypes>;
  feePaymentAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** @deprecated Use the updateEntityFeeSetting mutation instead. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  forceOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group Employer. Only allowed for GRSP accounts. */
  groupEmployer?: InputMaybe<Scalars['SafeString']['input']>;
  /** Group Number. Only allowed for GRSP accounts. */
  groupNumber?: InputMaybe<Scalars['SafeString']['input']>;
  householdClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountIntegrationInput>>>;
  /**
   * For RESP accounts, indicates the plan was transferred in from another institution.
   * When true, the beneficiary age (under 21) restriction is lifted.
   */
  isTransferredFromAnotherInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction?: InputMaybe<Jurisdiction>;
  /** @deprecated nickName is deprecated. Use translatedNickName instead. */
  nickName?: InputMaybe<Scalars['SafeString']['input']>;
  overrideTaxRank?: InputMaybe<Scalars['Int']['input']>;
  repCode?: InputMaybe<Scalars['SafeString']['input']>;
  respAllBeneficiariesAreInBc?: InputMaybe<Scalars['Boolean']['input']>;
  rightOfSurvivorship?: InputMaybe<Scalars['Boolean']['input']>;
  sourceOfFunds?: InputMaybe<SourceOfFunds>;
  /** Enables Tax-Loss Harvesting. Only allowed on PERSONAL, CASH_JOINT and CORPORATE account types. */
  tlhEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  translatedNickName?: InputMaybe<AccountTranslatedStringInput>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdateAccountResponse = {
  __typename?: 'UpdateAccountResponse';
  account: Account;
};

export type UpdateAccountStatementInput = {
  accountStatementId: Scalars['ObjectID']['input'];
  fileName?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpdateAccountStatementResponse = {
  __typename?: 'UpdateAccountStatementResponse';
  accountStatement?: Maybe<AccountStatement>;
};

export type UpdateAdvisorContactInput = {
  address?: InputMaybe<AdvisorContactAddressInput>;
  advisorContactId: Scalars['ObjectID']['input'];
  displayRoleId?: InputMaybe<Scalars['ObjectID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExtension?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdvisorContactResponse = {
  __typename?: 'UpdateAdvisorContactResponse';
  advisorContact: AdvisorContact;
};

/** Input type for updating an affiliate only user */
export type UpdateAffiliateInput = {
  /** User's citizenships */
  citizenships?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /** Defines if User is a close associate of a politically exposed person (PEP). */
  closeAssociateOfPEP?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of company at which the user is employed */
  companyType?: InputMaybe<Scalars['SafeString']['input']>;
  countryOfRegistration?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's date of birth in YYYY-MM-DD (ISO 8601 format). */
  dateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Decedent's date of death in YYYY-MM-DD (ISO 8601 format). Used for estate planning and account management. */
  dateOfDeath?: InputMaybe<Scalars['GraphQLDate']['input']>;
  employerCompanyAddress?: InputMaybe<PhysicalAddressInput>;
  employerName?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's employment status */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  entityName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date entity was established in YYYY-MM-DD (ISO 8601 format).  */
  establishedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** First name of user.  */
  firstName?: InputMaybe<Scalars['SafeString']['input']>;
  /** The tax information provided by the affiliate if the he pays tax to a foreign country */
  foreignTaxInformation?: InputMaybe<Array<InputMaybe<ForeignTaxInformationInput>>>;
  /** User's gender: MALE, FEMALE or OTHER */
  gender?: InputMaybe<Scalars['SafeString']['input']>;
  /** Is/Was the User the head of an international organization? */
  headOfInternationalOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date affiliate became a resident of current province/state in YYYY-MM-DD (ISO 8601 format). Determines provincial tax residency and compliance requirements.  */
  inProvinceSince?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /**
   * Is the user a member of IIROC?
   * IIROC:Investment Industry Regulatory Organization of Canada
   */
  isMemberOfIiroc?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the user a high-level management executive of a public company? */
  isOfficerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the user the owner of a public company? */
  isOwnerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  issuerExchange?: InputMaybe<Scalars['SafeString']['input']>;
  issuerName?: InputMaybe<Scalars['SafeString']['input']>;
  issuerTicker?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's job title, if user is employed */
  jobTitle?: InputMaybe<Scalars['SafeString']['input']>;
  /** Last name of user.  */
  lastName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Describes marital status of user.  */
  maritalStatus?: InputMaybe<MaritalStatus>;
  /** Middle name of user.  */
  middleName?: InputMaybe<Scalars['SafeString']['input']>;
  parentCompanyName?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated use foreignTaxInformation */
  payTaxesOutsideCanada?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone number that contains 7-15 digits, including country code (E.164 format). */
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's address */
  physicalAddress?: InputMaybe<PhysicalAddressInput>;
  /** Defines if User is a politically exposed person (PEP).  */
  politicallyExposedDomesticPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is a politically exposed person (PEP) in a foreign country. */
  politicallyExposedForeignPerson?: InputMaybe<Scalars['Boolean']['input']>;
  positionAtEntity?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: InputMaybe<Scalars['SafeString']['input']>;
  registrationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** Unique requestID created by partner for each request to create a new user */
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  /**
   * User's Social Insurance Number
   * @deprecated use taxIdType=SIN and taxId instead
   */
  sin?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's Tax ID: SIN/BN (Canada), SSN/ITIN/EIN (United States). See taxIdType. */
  taxId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Type of taxId value */
  taxIdType?: InputMaybe<TaxIdTypes>;
  /** UserID associated with the user */
  userId: Scalars['ID']['input'];
};

/** Type definition for updating an "affiliate only" user */
export type UpdateAffiliateResponse = {
  __typename?: 'UpdateAffiliateResponse';
  /** User object */
  user: User;
};

export type UpdateAffiliationsInput = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  affiliations: Array<AffiliationInput>;
  sendInvitation?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAffiliationsResponse = {
  __typename?: 'UpdateAffiliationsResponse';
  account: Account;
  incompleteAffiliations: Array<IncompleteAffiliation>;
};

export type UpdateAlertBannerInput = {
  actionButton?: InputMaybe<ActionButtonInput>;
  alertBannerId: Scalars['ObjectID']['input'];
  bannerCopy?: InputMaybe<OrganizationTranslatedStringInput>;
  bannerType?: InputMaybe<BannerType>;
  configuration?: InputMaybe<AlertConfigurationInput>;
  endDate?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  persistenceBehaviour?: InputMaybe<PersistenceBehaviour>;
  roleProfiles?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  startDate?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type UpdateAlertBannerResponse = {
  __typename?: 'UpdateAlertBannerResponse';
  alertBanner: AlertBanner;
};

export type UpdateAllHoldingsAndCashInput = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdateAllHoldingsAndCashResponse = {
  __typename?: 'UpdateAllHoldingsAndCashResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateApiTokenInput = {
  apiTokenId: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['SafeString']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  whitelistAddresses?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
};

export type UpdateApiTokenResponse = {
  __typename?: 'UpdateApiTokenResponse';
  apiToken: ApiToken;
};

export type UpdateArticleInput = {
  articleId: Scalars['ObjectID']['input'];
  articleUrl: Scalars['SafeString']['input'];
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName: OrganizationTranslatedStringInput;
  /**
   * Roles of the article's organization to show it to. Omit to leave unchanged;
   * empty or null shows it to every role.
   */
  visibleToRoleIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type UpdateArticleResponse = {
  __typename?: 'UpdateArticleResponse';
  article?: Maybe<Article>;
};

export type UpdateAssetClassInput = {
  assetClassId: Scalars['ObjectID']['input'];
  includeCash?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['SafeString']['input']>;
  translatedDescription?: InputMaybe<ProductTranslatedStringInput>;
  translatedName?: InputMaybe<ProductTranslatedStringInput>;
};

export type UpdateAssetClassResponse = {
  __typename?: 'UpdateAssetClassResponse';
  assetClass: AssetClass;
};

export type UpdateBankAccountInput = {
  bankAccountHolderName?: InputMaybe<Scalars['String']['input']>;
  bankAccountId: Scalars['ObjectID']['input'];
  bankAccountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's bank's account transit Physical address */
  bankAccountTransitPhysicalAddress?: InputMaybe<BankAccountTransitPhysicalAddressInput>;
  bankAccountType?: InputMaybe<BankAccountTypes>;
  currency?: InputMaybe<BankAccountCurrencyTypes>;
  institutionNumber?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<BankAccountIntegrationInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['SafeString']['input']>;
  transitNumber?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpdateBankAccountResponse = {
  __typename?: 'UpdateBankAccountResponse';
  bankAccount: BankAccount;
};

export type UpdateBeneficiaryInput = {
  allocation?: InputMaybe<Scalars['Float']['input']>;
  beneficiaryId: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['SafeString']['input']>;
  relation?: InputMaybe<BeneficiaryRelation>;
  successorAddress?: InputMaybe<UpdateSuccessorPhysicalAddressInput>;
  type?: InputMaybe<BeneficiaryType>;
};

export type UpdateBeneficiaryResponse = {
  __typename?: 'UpdateBeneficiaryResponse';
  beneficiary: Beneficiary;
};

export type UpdateBillingScheduleInput = {
  billingScheduleId: Scalars['ObjectID']['input'];
  default?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<BillingScheduleFrequencies>;
  nextBillingDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  nextCalculationDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type UpdateBillingScheduleResponse = {
  __typename?: 'UpdateBillingScheduleResponse';
  billingSchedule: BillingSchedule;
};

export type UpdateBulkImportInput = {
  bulkImportId: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['SafeString']['input']>;
  sequencedImportFiles?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export type UpdateBulkImportResponse = {
  __typename?: 'UpdateBulkImportResponse';
  bulkImport?: Maybe<BulkImport>;
};

export type UpdateBulkTradeRequestInput = {
  bulkTradeRequestId: Scalars['ObjectID']['input'];
  source?: InputMaybe<BulkTradeRequestSourceInput>;
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdateBulkTradeRequestResponse = {
  __typename?: 'UpdateBulkTradeRequestResponse';
  bulkTradeRequest: BulkTradeRequest;
};

export type UpdateBulkTradeRunAllocationFilesInput = {
  bulkTradeRunId: Scalars['String']['input'];
  files: Array<AllocationFileInput>;
};

export type UpdateBulkTradeRunAllocationFilesResponse = {
  __typename?: 'UpdateBulkTradeRunAllocationFilesResponse';
  bulkTradeRun: BulkTradeRun;
};

export type UpdateBulkTradeRunBulkTradeFilesInput = {
  bulkTradeRunId: Scalars['String']['input'];
  files: Array<BulkTradeFileInput>;
};

export type UpdateClientGroupInput = {
  accountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  businessIsMemberOfIiroc?: InputMaybe<Scalars['Boolean']['input']>;
  /** Corporate Business Type */
  businessType?: InputMaybe<CorporateBusinessTypes>;
  /** ClientGroupId associated with the ClientGroup which is updating */
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  corporationCountry?: InputMaybe<CorporateCountries>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  /** Date entity was established in YYYY-MM-DD (ISO 8601 format).  */
  establishedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  incorporationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<UserIntegrationInput>>>;
  /** ClientGroup name to be update */
  name?: InputMaybe<Scalars['SafeString']['input']>;
  /** Phone number that contains 7-15 digits, including country code (E.164 format). */
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  physicalAddress?: InputMaybe<PhysicalAddressInput>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: InputMaybe<Scalars['SafeString']['input']>;
  primaryUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** clientGroup  relationships */
  relationships?: InputMaybe<Array<InputMaybe<RelationshipInput>>>;
  taxNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** ClientGroup type to be update */
  type?: InputMaybe<ClientGroupTypes>;
};

/** Input type for Updating a clientGroup Organization */
export type UpdateClientGroupOrganizationInput = {
  /** ClientGroupID */
  clientGroupId: Scalars['ObjectID']['input'];
  /** New OrganizationID */
  newOrganizationId: Scalars['ObjectID']['input'];
};

export type UpdateClientGroupOrganizationResponse = {
  __typename?: 'UpdateClientGroupOrganizationResponse';
  clientGroup?: Maybe<ClientGroup>;
};

export type UpdateClientGroupPortfolioInput = {
  clientGroupId: Scalars['ObjectID']['input'];
  /** Pass null to clear the household model portfolio. */
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Pass null to clear the household trading process. */
  tradingProcess?: InputMaybe<PortfolioTradingProcesses>;
};

export type UpdateClientGroupPortfolioResponse = {
  __typename?: 'UpdateClientGroupPortfolioResponse';
  clientGroup: ClientGroup;
};

/** UpdateClientGroup Response */
export type UpdateClientGroupResponse = {
  __typename?: 'UpdateClientGroupResponse';
  /** clientGroup object */
  clientGroup?: Maybe<ClientGroup>;
};

export type UpdateClientReportTemplateInput = {
  condition?: InputMaybe<ClientReportTemplateConditionInput>;
  isStatementOfType?: InputMaybe<StatementTypes>;
  objectType?: InputMaybe<ClientReportTemplateObjectTypes>;
  reportType?: InputMaybe<ClientReportTemplateReportTypes>;
  s3key?: InputMaybe<StatementTranslatedStringInput>;
  schedulerDayOfMonthOrWeek?: InputMaybe<Scalars['Int']['input']>;
  schedulerEnableNotification?: InputMaybe<Scalars['Boolean']['input']>;
  schedulerFrequency?: InputMaybe<ClientReportFrequencies>;
  schedulerOneTimeDateEnd?: InputMaybe<Scalars['GraphQLDate']['input']>;
  schedulerOneTimeDateStart?: InputMaybe<Scalars['GraphQLDate']['input']>;
  schedulerTriggerRules?: InputMaybe<Array<ClientReportTriggerRuleInput>>;
  settings?: InputMaybe<ClientReportTemplateSettingsInput>;
  templateParameters?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  translatedDescription?: InputMaybe<StatementTranslatedStringInput>;
  translatedName?: InputMaybe<StatementTranslatedStringInput>;
  type?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpdateClientReportTemplatePageConfigurationInput = {
  clientReportTemplatePageConfigurationId: Scalars['ObjectID']['input'];
  options?: InputMaybe<Scalars['Object']['input']>;
  widgets?: InputMaybe<Array<ClientReportTemplateWidgetConfigurationInput>>;
};

export type UpdateClientReportTemplatePageConfigurationResponse = {
  __typename?: 'UpdateClientReportTemplatePageConfigurationResponse';
  clientReportTemplatePageConfiguration?: Maybe<ClientReportTemplatePageConfiguration>;
};

export type UpdateConfigurableTablePageInput = {
  columns?: InputMaybe<Array<ConfigurableTablePageColumnInput>>;
  configurableTablePageId: Scalars['ObjectID']['input'];
  customPageSizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  disclaimerText?: InputMaybe<OrganizationTranslatedStringInput>;
  disclaimerTitle?: InputMaybe<OrganizationTranslatedStringInput>;
  enableCustomPagination?: InputMaybe<Scalars['Boolean']['input']>;
  enableDownload?: InputMaybe<Scalars['Boolean']['input']>;
  endpointUrl?: InputMaybe<Scalars['String']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<InputMaybe<ConfigurableTablePageFilterInput>>>;
  name?: InputMaybe<OrganizationTranslatedStringInput>;
  navigateToPath?: InputMaybe<ConfigurableTablePagePaths>;
  navigateToPathKey?: InputMaybe<Scalars['String']['input']>;
  paginationType?: InputMaybe<ConfigurableTablePagePaginationType>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<ConfigurableTablePageSectionInput>;
  useTopSearchPanel?: InputMaybe<Scalars['Boolean']['input']>;
  widgets?: InputMaybe<Array<InputMaybe<ConfigurableTablePageWidgetInput>>>;
};

export type UpdateConfigurableTablePageResponse = {
  __typename?: 'UpdateConfigurableTablePageResponse';
  configurableTablePage: ConfigurableTablePage;
};

export type UpdateCountryRiskInput = {
  country?: InputMaybe<Scalars['SafeString']['input']>;
  countryCode?: InputMaybe<Scalars['SafeString']['input']>;
  countryRiskId: Scalars['ObjectID']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  riskRating?: InputMaybe<RiskRatings>;
};

export type UpdateCountryRiskResponse = {
  __typename?: 'UpdateCountryRiskResponse';
  countryRisk: CountryRisk;
};

export type UpdateCustodianActivityNotesInput = {
  custodianActivityId: Scalars['ObjectID']['input'];
  /** The single note text to append. HTML rejected by SafeString; empty string = a cleared entry. */
  notes: Scalars['SafeString']['input'];
};

export type UpdateCustodianActivityNotesResponse = {
  __typename?: 'UpdateCustodianActivityNotesResponse';
  custodianActivity: CustodianActivity;
};

export type UpdateCustodianConnectionInput = {
  accountOpeningSubmissionType?: InputMaybe<CustodianAccountOpeningTypes>;
  accountTypeSettings?: InputMaybe<Array<InputMaybe<AccountTypeSettingsInput>>>;
  allowCashAsDepositTarget?: InputMaybe<Scalars['Boolean']['input']>;
  allowFractionalTrading?: InputMaybe<Scalars['Boolean']['input']>;
  allowTransactionCreation?: InputMaybe<Scalars['Boolean']['input']>;
  baseCurrency?: InputMaybe<CustodianConnectionCurrencyTypes>;
  bulkTradeAllowedExchanges?: InputMaybe<Array<InputMaybe<Exchanges>>>;
  ciRepNumber?: InputMaybe<Scalars['SafeString']['input']>;
  config?: InputMaybe<Scalars['Object']['input']>;
  custodianActivityImportFilePaths?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  custodianConnectionId: Scalars['ObjectID']['input'];
  custodianSnapshotImportFilePaths?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  custodianUsersImportFilePath?: InputMaybe<Scalars['SafeString']['input']>;
  customerName?: InputMaybe<Scalars['SafeString']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  disableCorpInventoryAccount?: InputMaybe<Scalars['Boolean']['input']>;
  disabledFlagTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableAccountOpeningSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoReconcileActivities?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoReconcilePositions?: InputMaybe<Scalars['Boolean']['input']>;
  enableCancelCustodianDepositTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  enableChallengedCustodianDepositTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  enableCreateCustodianDepositTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianAccountImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianActivityImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianCredentialsManager?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianInvestmentFundsImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianOrganizationImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianOrganizationUserImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianSnapshotImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustodianUserImport?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianAffiliates?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianBankAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianProjectedIncome?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianSnapshotHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianStatements?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianSuitability?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  enableFetchCustodianUpcomingTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  enableSaveInternalRecordsOfCustodianDepositTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransferSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  fetchLivePrices?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<CustodianCustomFieldInput>>>;
  moneyAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  notificationEmails?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  reconciliationType?: InputMaybe<CustodianReconciliationTypes>;
  repCode?: InputMaybe<Scalars['SafeString']['input']>;
  sftpCredentials?: InputMaybe<UpdateSftpCredentialsInput>;
  transferSubmissionType?: InputMaybe<CustodianTransferSubmissionTypes>;
};

export type UpdateCustodianConnectionResponse = {
  __typename?: 'UpdateCustodianConnectionResponse';
  custodianConnection: CustodianConnection;
};

export type UpdateCustodianCustomFieldsInput = {
  filter: UpdateCustodianCustomFieldsInputFilter;
};

export type UpdateCustodianCustomFieldsInputFilter = {
  custodianCustomFields?: InputMaybe<Array<InputMaybe<CustodianCustomFieldInput>>>;
  userId: Scalars['ObjectID']['input'];
};

export type UpdateCustodianInput = {
  custodianId: Scalars['ObjectID']['input'];
  customerName?: InputMaybe<Scalars['SafeString']['input']>;
  inventoryAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  moneyAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  notificationEmails?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  repCode?: InputMaybe<Scalars['SafeString']['input']>;
  sftpInBucket?: InputMaybe<Scalars['SafeString']['input']>;
  sftpOutBucket?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpdateCustodianResponse = {
  __typename?: 'UpdateCustodianResponse';
  custodian: Custodian;
};

export type UpdateCustomAttributeLabelInput = {
  attributeName?: InputMaybe<CustomAttributeLabelNames>;
  customAttributeLabelId: Scalars['ObjectID']['input'];
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<CustomAttributeLabelObjectTypes>;
  options?: InputMaybe<Array<CustomAttributeLabelOptionInput>>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomAttributeLabelResponse = {
  __typename?: 'UpdateCustomAttributeLabelResponse';
  customAttributeLabel: CustomAttributeLabel;
};

export type UpdateCustomFieldInput = {
  conditionalRules?: InputMaybe<Array<InputMaybe<CustomFieldConditionalRuleInput>>>;
  customFieldId: Scalars['ObjectID']['input'];
  enableAggregation?: InputMaybe<Scalars['Boolean']['input']>;
  enablePositiveNegativeSign?: InputMaybe<Scalars['Boolean']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<CustomFieldFormats>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  selectOptions?: InputMaybe<Array<InputMaybe<CustomFieldSelectOptionInput>>>;
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName: OrganizationTranslatedStringInput;
  type?: InputMaybe<CustomFieldTypes>;
  workflowStep?: InputMaybe<CustomFieldWorkflowSteps>;
};

export type UpdateCustomFieldResponse = {
  __typename?: 'UpdateCustomFieldResponse';
  customField?: Maybe<CustomField>;
};

export type UpdateDisplayRoleInput = {
  displayRoleId: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDisplayRoleResponse = {
  __typename?: 'UpdateDisplayRoleResponse';
  displayRole: DisplayRole;
};

export type UpdateDowntimeScheduleInput = {
  downtimeScheduleId: Scalars['ObjectID']['input'];
  endTime?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  excludeRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  helpLink?: InputMaybe<Scalars['URLString']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated no longer using note string. Use translatedNote with OrganizationTranslatedStringInput instead. */
  note?: InputMaybe<Scalars['SafeString']['input']>;
  platforms?: InputMaybe<Array<InputMaybe<Platforms>>>;
  startTime?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedNote?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedTitle: OrganizationTranslatedStringInput;
};

export type UpdateDowntimeScheduleResponse = {
  __typename?: 'UpdateDowntimeScheduleResponse';
  downtimeSchedule: DowntimeSchedule;
};

export type UpdateEntityFeeInput = {
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdateEntityFeeResponse = {
  __typename?: 'UpdateEntityFeeResponse';
  account?: Maybe<Account>;
  accountGroup?: Maybe<AccountGroup>;
  clientGroup?: Maybe<ClientGroup>;
  subAccount?: Maybe<SubAccount>;
  user?: Maybe<User>;
};

export type UpdateExternalProvidersInput = {
  bankingConnectorProvider?: InputMaybe<BankingConnectorProviderInput>;
  idVerificationProvider?: InputMaybe<IdVerificationProviderInput>;
  organizationId: Scalars['ObjectID']['input'];
};

export type UpdateExternalProvidersResponse = {
  __typename?: 'UpdateExternalProvidersResponse';
  externalProvider?: Maybe<ExternalProvider>;
};

export type UpdateFeeSettingInput = {
  enabled: Scalars['Boolean']['input'];
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UpdateFeeSettingResponse = {
  __typename?: 'UpdateFeeSettingResponse';
  feeSetting: FeeSetting;
};

export type UpdateFeeTierInput = {
  blendedGrid?: InputMaybe<Scalars['Boolean']['input']>;
  chargeForCash?: InputMaybe<Scalars['Boolean']['input']>;
  chargeForCashOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  feeTierId: Scalars['ObjectID']['input'];
  flatAnnualFeeBps?: InputMaybe<Scalars['Float']['input']>;
  grid?: InputMaybe<Array<InputMaybe<FeeTierGridInput>>>;
  gridScopeType?: InputMaybe<FeeGridScopeTypes>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeeTierResponse = {
  __typename?: 'UpdateFeeTierResponse';
  feeTier: FeeTier;
};

export type UpdateFileDocumentInput = {
  applicableDocumentId?: InputMaybe<Scalars['SafeString']['input']>;
  /** fileDocumentId associated with the note which is updating */
  fileDocumentId: Scalars['ObjectID']['input'];
  name?: InputMaybe<Scalars['SafeString']['input']>;
  permissionType?: InputMaybe<FileDocumentPermissionTypes>;
  sharedClient?: InputMaybe<Scalars['Boolean']['input']>;
  sharedCustodian?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithRoleProfiles?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  uploadedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type UpdateFileDocumentResponse = {
  __typename?: 'UpdateFileDocumentResponse';
  fileDocument?: Maybe<FileDocument>;
};

export type UpdateFinancialProductInput = {
  /** Auto updates prices using data partner? */
  autoUpdatePrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** The currency that this Financial product trades in. */
  currency?: InputMaybe<Currencies>;
  currentPriceCents?: InputMaybe<Scalars['Float']['input']>;
  cusip?: InputMaybe<Scalars['String']['input']>;
  /** The Stock Exchange that this Financial product trades in. */
  exchange?: InputMaybe<Scalars['String']['input']>;
  exchangeMic?: InputMaybe<Scalars['SafeString']['input']>;
  financialProductId: Scalars['ObjectID']['input'];
  fundSeries?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<FinancialProductIntegrationInput>>>;
  /**
   * When true, allowed to allocate fractional trades.
   *
   * Defaults to true.
   */
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  isin?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  /** The original currency of this Financial product. */
  originalCurrency?: InputMaybe<Currencies>;
  originalCurrentPriceCents?: InputMaybe<Scalars['Float']['input']>;
  /** Primary Asset Class of the product */
  primaryAssetClassId?: InputMaybe<Scalars['ObjectID']['input']>;
  ric?: InputMaybe<Scalars['String']['input']>;
  riskProfileDescription?: InputMaybe<ProductTranslatedStringInput>;
  riskProfileName?: InputMaybe<ProductTranslatedStringInput>;
  /** financialProduct scheduleID */
  scheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Secondary Asset Class of the product */
  secondaryAssetClassId?: InputMaybe<Scalars['ObjectID']['input']>;
  settlementDays?: InputMaybe<Scalars['Int']['input']>;
  /** The Strategy of the Financial product. */
  strategy?: InputMaybe<FinancialProductStrategy>;
  /** Optional substitute Financial product (used for Tax-Loss Harvesting). */
  substituteFinancialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The tax rank of the financial product, to be used for portfolio optimization */
  taxRank?: InputMaybe<Scalars['Int']['input']>;
  /** Tertiary Asset Class of the product */
  tertiaryAssetClassId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The trading ticker for this Financial product. */
  ticker?: InputMaybe<Scalars['SafeString']['input']>;
  /** The translated names of the Financial product. */
  translatedName?: InputMaybe<ProductTranslatedStringInput>;
  translatedUrl?: InputMaybe<ProductTranslatedStringInput>;
  /** Type of Security. */
  type?: InputMaybe<SecurityTypes>;
  /** @deprecated url is deprecated, use translatedUrl instead */
  url?: InputMaybe<Scalars['String']['input']>;
  volatile?: InputMaybe<Scalars['Boolean']['input']>;
  /** A discount percentage applied to the corresponding holding amount during fee calculation (0 - 100%). */
  waivedFeePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFinancialProductResponse = {
  __typename?: 'UpdateFinancialProductResponse';
  /** The Financial product. */
  financialProduct: FinancialProduct;
  /** Warning messages for the operation. */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateFlagNotesInput = {
  /**
   * Display name of the operator saving this note. When omitted, falls back to
   * connection metadata on the JWT. When provided, must be non-empty after trimming.
   */
  author?: InputMaybe<Scalars['SafeString']['input']>;
  flagId: Scalars['ObjectID']['input'];
  /**
   * Investigation context for the flag. Empty string clears existing notes.
   * HTML is rejected.
   */
  notes: Scalars['SafeString']['input'];
};

export type UpdateFormDefinitionInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  fillingType?: InputMaybe<FormDefinitionFillingType>;
  formDefinitionId: Scalars['ObjectID']['input'];
  integrations?: InputMaybe<Array<InputMaybe<FormDefinitionIntegrationInput>>>;
  mappingWebhook?: InputMaybe<WebhookInput>;
  objectType?: InputMaybe<FormDefinitionObjectTypes>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  signerMapping?: InputMaybe<Array<SignerMappingInput>>;
  signingType?: InputMaybe<FormDefinitionSigningTypes>;
  state?: InputMaybe<FormDefinitionStates>;
  templateType?: InputMaybe<FormDefinitionTemplateTypes>;
  translatedDescription?: InputMaybe<TranslatedStringInput>;
  translatedName?: InputMaybe<TranslatedStringInput>;
  translatedPdfFileName?: InputMaybe<TranslatedStringInput>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFormDefinitionResponse = {
  __typename?: 'UpdateFormDefinitionResponse';
  formDefinition: FormDefinition;
};

export type UpdateFormMapInput = {
  fields?: InputMaybe<Array<FormMapFieldInput>>;
  formMapId: Scalars['ObjectID']['input'];
  language?: InputMaybe<FormLanguageCode>;
  removePdfMaxLength?: InputMaybe<Scalars['Boolean']['input']>;
  signaturePageNumberBase?: InputMaybe<SignaturePageNumberBase>;
  templateS3Key?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFormMapResponse = {
  __typename?: 'UpdateFormMapResponse';
  formMap: FormMap;
};

export type UpdateFormTemplateInput = {
  digitalSignatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  formTemplateId: Scalars['ObjectID']['input'];
  minVersion?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<FormTemplateStates>;
  translatedDisplayName?: InputMaybe<TranslatedStringInput>;
  translatedHtml?: InputMaybe<TranslatedStringInput>;
  translatedMarkdown?: InputMaybe<TranslatedStringInput>;
};

export type UpdateFormTemplateResponse = {
  __typename?: 'UpdateFormTemplateResponse';
  formTemplate: FormTemplate;
};

export type UpdateFraudRiskInput = {
  fraudRiskId: Scalars['ObjectID']['input'];
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
  notes?: InputMaybe<Scalars['SafeString']['input']>;
  riskReasons?: InputMaybe<Array<InputMaybe<RiskReasonInput>>>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFraudRiskResponse = {
  __typename?: 'UpdateFraudRiskResponse';
  fraudRisk: FraudRisk;
};

export type UpdateGoalInput = {
  /** @deprecated Use householdClientGroupId instead. */
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  expectedAnnualIncomeCents?: InputMaybe<Scalars['Int']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  goalId: Scalars['ObjectID']['input'];
  householdClientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountIntegrationInput>>>;
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  retirementAge?: InputMaybe<Scalars['Int']['input']>;
  riskQuestion1?: InputMaybe<GoalRiskLevels>;
  targetAmountCents?: InputMaybe<Scalars['Long']['input']>;
  targetDate?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  taxOptimized?: InputMaybe<Scalars['Boolean']['input']>;
  timeHorizon?: InputMaybe<GoalTimeHorizons>;
  tradingProcess?: InputMaybe<PortfolioTradingProcesses>;
  type?: InputMaybe<GoalTypes>;
};

export type UpdateGoalResponse = {
  __typename?: 'UpdateGoalResponse';
  goal: Goal;
};

export type UpdateHomePageConfigurationInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  homePageConfigurationId: Scalars['ObjectID']['input'];
  options?: InputMaybe<Scalars['Object']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
  widgets?: InputMaybe<Array<HomePageWidgetConfigurationInput>>;
};

export type UpdateHomePageConfigurationResponse = {
  __typename?: 'UpdateHomePageConfigurationResponse';
  homePageConfiguration?: Maybe<HomePageConfiguration>;
};

export type UpdateImportFileLineItemInput = {
  importFileLineItemId: Scalars['ObjectID']['input'];
  rawData?: InputMaybe<Scalars['Object']['input']>;
};

export type UpdateImportFileLineItemResponse = {
  __typename?: 'UpdateImportFileLineItemResponse';
  importFileLineItem?: Maybe<ImportFileLineItem>;
};

export type UpdateInstitutionInput = {
  /** This an ID created by the partner, that is submitted with a request to create a new Institution and unique to each request. */
  id: Scalars['ID']['input'];
  /** Institution name */
  name?: InputMaybe<Scalars['SafeString']['input']>;
  /** Institution Address */
  physicalAddress?: InputMaybe<InstitutionPhysicalAddressUpdateInput>;
};

export type UpdateInstitutionResponse = {
  __typename?: 'UpdateInstitutionResponse';
  institution: Institution;
};

export type UpdateIntegrationFormAgreementInput = {
  formAgreementId: Scalars['String']['input'];
  state?: InputMaybe<FormAgreementStates>;
};

export type UpdateIntegrationFormAgreementResponse = {
  __typename?: 'UpdateIntegrationFormAgreementResponse';
  formAgreement: FormAgreement;
};

export type UpdateIntegrationInput = {
  configuration?: InputMaybe<Scalars['Object']['input']>;
  integrationId: Scalars['ObjectID']['input'];
  passthroughApiPrivateSecretName?: InputMaybe<Scalars['SafeString']['input']>;
  passthroughApiUrl?: InputMaybe<Scalars['URLString']['input']>;
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supportedCountries?: InputMaybe<Array<CountryCodes>>;
};

export type UpdateIntegrationResponse = {
  __typename?: 'UpdateIntegrationResponse';
  integration?: Maybe<Integration>;
};

export type UpdateIntegrationStatefulDataInput = {
  /**
   * Optional with both set and inc. When provided with set, performs a compare-and-swap update. When omitted with set,
   * the operation is insert-only and will fail if a document already exists for this key.
   */
  expectedHash?: InputMaybe<Scalars['String']['input']>;
  /** Atomic increment operation. Mutually exclusive with set. */
  inc?: InputMaybe<Scalars['Float']['input']>;
  integrationId: Scalars['ObjectID']['input'];
  key: Scalars['String']['input'];
  /**
   * Maximum number of retries for concurrent increment conflicts.
   * Defaults to 10 when omitted. Only applies to inc.
   */
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Atomic set operation. Mutually exclusive with inc. When expectedHash is omitted, inserts a new document
   * (fails if one already exists for this key). When expectedHash is provided, performs a compare-and-swap update.
   */
  set?: InputMaybe<Scalars['Object']['input']>;
};

export type UpdateIntegrationStatefulDataResponse = {
  __typename?: 'UpdateIntegrationStatefulDataResponse';
  integrationStatefulData?: Maybe<IntegrationStatefulData>;
};

export type UpdateJobTitleRiskInput = {
  companyType?: InputMaybe<Scalars['SafeString']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['SafeString']['input']>;
  jobTitleRiskId: Scalars['ObjectID']['input'];
  riskRating?: InputMaybe<RiskRatings>;
};

export type UpdateJobTitleRiskResponse = {
  __typename?: 'UpdateJobTitleRiskResponse';
  jobTitleRisk: JobTitleRisk;
};

export type UpdateLocalizationResponse = {
  __typename?: 'UpdateLocalizationResponse';
  localization?: Maybe<Localization>;
};

export type UpdateModelChangeProposalInput = {
  /** Only accepted while the proposal is in DRAFT state. */
  currentAllocations?: InputMaybe<Array<ModelChangeAllocationInput>>;
  /** Only accepted while the proposal is in DRAFT state. */
  currentAssetClassBranches?: InputMaybe<Array<ModelChangeAssetClassBranchInput>>;
  /** Only accepted while the proposal is in DRAFT state. */
  currentAssetClassThresholds?: InputMaybe<Array<TargetAllocationInput>>;
  /** Only accepted while the proposal is in DRAFT state. */
  currentModelDetails?: InputMaybe<ModelChangeModelDetailsInput>;
  modelChangeProposalId: Scalars['ObjectID']['input'];
  /** Only accepted while the proposal is in DRAFT state. */
  proposedAllocations?: InputMaybe<Array<ModelChangeAllocationInput>>;
  /** Only accepted while the proposal is in DRAFT state. */
  proposedAssetClassBranches?: InputMaybe<Array<ModelChangeAssetClassBranchInput>>;
  /** Only accepted while the proposal is in DRAFT state. */
  proposedAssetClassThresholds?: InputMaybe<Array<TargetAllocationInput>>;
  /** Only accepted while the proposal is in DRAFT state. */
  proposedModelDetails?: InputMaybe<ModelChangeModelDetailsInput>;
};

export type UpdateModelChangeProposalResponse = {
  __typename?: 'UpdateModelChangeProposalResponse';
  modelChangeProposal: ModelChangeProposal;
};

export type UpdateModelPortfolioInput = {
  /** Asset class branch allocations for ASSET_CLASS strategy portfolios */
  assetClassBranches?: InputMaybe<Array<AssetClassBranchInput>>;
  /** Asset class level for ASSET_CLASS strategy portfolios */
  assetClassLevel?: InputMaybe<AssetClassLevel>;
  /** Allocation branches */
  children?: InputMaybe<Array<InputMaybe<BranchInput>>>;
  /** Null means inherit the organization default. Tolerance must be 5-20. */
  driftCalculationMethod?: InputMaybe<DriftCalculationMethod>;
  driftTolerancePercent?: InputMaybe<Scalars['Int']['input']>;
  forecastedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  forecastedStandardDeviation?: InputMaybe<Scalars['Float']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<FinancialProductIntegrationInput>>>;
  /** Low threshold score for allowing access */
  lowThresholdScore?: InputMaybe<Scalars['Float']['input']>;
  modelPortfolioId: Scalars['ObjectID']['input'];
  /** The template to update the model portfolio from */
  portfolioTemplate?: InputMaybe<Scalars['ObjectID']['input']>;
  /** @deprecated Will be removed from the FinancialProduct */
  reasonForUpdate?: InputMaybe<Scalars['SafeString']['input']>;
  riskProfileName?: InputMaybe<ProductTranslatedStringInput>;
  riskReturnLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Optional schedule (used for illiquid portfolios). */
  scheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The Strategy of the Financial product. */
  strategy?: InputMaybe<FinancialProductStrategy>;
  /** Is this Financial product suggestable? */
  suggestable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum suitability score to have access to this Financial product. */
  suggestedMaxScore?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum suitability score to have access to this Financial product. */
  suggestedMinScore?: InputMaybe<Scalars['Float']['input']>;
  /** All Target Allocations */
  targetAllocations?: InputMaybe<Array<InputMaybe<TargetAllocationInput>>>;
  /** ID for the theme assigned */
  themeId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** The translated investment objectives of the portfolio */
  translatedInvestmentObjective?: InputMaybe<ProductTranslatedStringInput>;
  /** The translated liquidity of the portfolio */
  translatedLiquidity?: InputMaybe<ProductTranslatedStringInput>;
  /** The translated names of the Financial product. */
  translatedName?: InputMaybe<ProductTranslatedStringInput>;
  /** The translated descriptions of the portfolio */
  translatedPortfolioDescription?: InputMaybe<ProductTranslatedStringInput>;
  /** The translated disclaimers of the portfolio */
  translatedPortfolioDisclaimer?: InputMaybe<ProductRichTextTranslatedStringInput>;
  translatedUrl?: InputMaybe<ProductTranslatedStringInput>;
  /** @deprecated url is deprecated, use translatedUrl instead */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Whether the financial product is zero percent cash */
  zeroPercentCash?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateModelPortfolioResponse = {
  __typename?: 'UpdateModelPortfolioResponse';
  /** The Financial product. */
  modelPortfolio: FinancialProduct;
};

export type UpdateNoteInput = {
  content?: InputMaybe<Scalars['SafeString']['input']>;
  /** noteId associated with the note which is updating */
  noteId: Scalars['ObjectID']['input'];
  type?: InputMaybe<NoteTypes>;
};

export type UpdateNoteResponse = {
  __typename?: 'UpdateNoteResponse';
  note?: Maybe<Note>;
};

export type UpdateNotificationDefinitionInput = {
  bodyTemplate?: InputMaybe<NotificationTranslatedStringInput>;
  linkTemplate?: InputMaybe<Scalars['SafeString']['input']>;
  linkText?: InputMaybe<NotificationTranslatedStringInput>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  notificationChannels?: InputMaybe<Array<NotificationChannelInput>>;
  notificationDefinitionId: Scalars['ObjectID']['input'];
  notificationGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  roleProfileIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  titleTemplate?: InputMaybe<NotificationTranslatedStringInput>;
  triggerEventType?: InputMaybe<Scalars['String']['input']>;
  triggerObjectType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationDefintionResponse = {
  __typename?: 'UpdateNotificationDefintionResponse';
  notificationDefinition: NotificationDefinition;
};

export type UpdateNotificationGroupInput = {
  description?: InputMaybe<NotificationTranslatedStringInput>;
  name?: InputMaybe<NotificationTranslatedStringInput>;
  notificationChannels?: InputMaybe<Array<NotificationChannelInput>>;
  notificationGroupId: Scalars['ObjectID']['input'];
};

export type UpdateNotificationGroupResponse = {
  __typename?: 'UpdateNotificationGroupResponse';
  notificationGroup: NotificationGroup;
};

export type UpdateOrgFlagPolicyInput = {
  flagAmountThresholds?: InputMaybe<Array<FlagAmountThresholdInput>>;
  flagTypePolicies?: InputMaybe<Array<FlagTypePolicyInput>>;
  organizationId: Scalars['ObjectID']['input'];
  removedFlagTypes?: InputMaybe<Array<FlagTypes>>;
  removedThresholdFlagTypes?: InputMaybe<Array<FlagTypes>>;
};

export type UpdateOrgFlagPolicyResponse = {
  __typename?: 'UpdateOrgFlagPolicyResponse';
  organization: Organization;
};

export type UpdateOrgReconTolerancePolicyInput = {
  organizationId: Scalars['ObjectID']['input'];
  /** Full replace. Omitted/null: unchanged. []: drops overrides, so effective rows inherit the closest ancestor (or the platform default). To disable without inheriting: [{ breakType: CASH, enabled: false }]. */
  reconTolerancePolicies?: InputMaybe<Array<ReconTolerancePolicyInput>>;
};

export type UpdateOrganizationDashboardInput = {
  dashboardId: Scalars['ObjectID']['input'];
  /** Extension key for identifying this resource as part of an extension. */
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  /** Version of the extension resource. */
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  /**
   * Replaces the dashboard's global filters when provided.
   * Omitted: leave existing filters unchanged. Empty list: clear all global filters.
   */
  globalFilters?: InputMaybe<Array<DashboardGlobalFilterInput>>;
  /** @deprecated name is deprecated, use translatedName field instead */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Resource key for unique identification within an extension. */
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
  /**
   * Replaces the full widget list when provided.
   * Omitted: leave existing widgets unchanged.
   */
  widgets?: InputMaybe<Array<InputMaybe<WidgetInputType>>>;
};

export type UpdateOrganizationDashboardResponse = {
  __typename?: 'UpdateOrganizationDashboardResponse';
  dashboard?: Maybe<Dashboard>;
};

export type UpdateOrganizationFeatureFlagInput = {
  featureFlags: Array<FeatureFlagOptionInput>;
  organizationFeatureFlagId: Scalars['ObjectID']['input'];
};

export type UpdateOrganizationFeatureFlagResponse = {
  __typename?: 'UpdateOrganizationFeatureFlagResponse';
  organizationFeatureFlag: OrganizationFeatureFlag;
};

export type UpdateOrganizationInput = {
  accountGroupAutoArchiveCustomFieldKey?: InputMaybe<Scalars['String']['input']>;
  accountGroupAutoArchiveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  accountTypeTaxRanks?: InputMaybe<Array<InputMaybe<AccountTypeTaxRankInput>>>;
  additionalAutoReconciliationTransactionTypes?: InputMaybe<Array<InputMaybe<AutoReconciliationTransactionTypeInput>>>;
  allowAccessToSubOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  allowChargePST?: InputMaybe<Scalars['Boolean']['input']>;
  allowDirectCommunication?: InputMaybe<Scalars['Boolean']['input']>;
  allowInactiveUserAdjustments?: InputMaybe<Scalars['Boolean']['input']>;
  allowInactiveUserFeeCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  allowInactiveUserRebalancing?: InputMaybe<Scalars['Boolean']['input']>;
  allowInstantInvest?: InputMaybe<Scalars['Boolean']['input']>;
  allowLogout?: InputMaybe<Scalars['Boolean']['input']>;
  allowPendingTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  allowPortfolioPerGoal?: InputMaybe<Scalars['Boolean']['input']>;
  allowPortfolioPerHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  allowPostOptimizationEditing?: InputMaybe<Scalars['Boolean']['input']>;
  allowViewSubTradeRequestPairs?: InputMaybe<Scalars['Boolean']['input']>;
  analyticsIdentifier?: InputMaybe<Scalars['String']['input']>;
  auth0DisplayName?: InputMaybe<Scalars['SafeString']['input']>;
  authenticationDomains?: InputMaybe<Array<InputMaybe<OrganizationAuthenticationDomainInput>>>;
  autoInviteImportedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  autoLogoutAfterInactivity?: InputMaybe<Scalars['Boolean']['input']>;
  baseCurrency?: InputMaybe<CurrencyCodes>;
  blockSuspiciousTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  browserTabTitle?: InputMaybe<Scalars['String']['input']>;
  bulkTradingProcess?: InputMaybe<OrgBulkTradingProcesses>;
  cancelTransferCutoffDays?: InputMaybe<Scalars['Int']['input']>;
  cashOnHoldToTradeDays?: InputMaybe<Scalars['Int']['input']>;
  cashOnHoldToWithdrawDays?: InputMaybe<Scalars['Int']['input']>;
  clientHostedLoginClientId?: InputMaybe<Scalars['String']['input']>;
  clientHostedLoginRedirectUri?: InputMaybe<Scalars['String']['input']>;
  clientHostedLoginScope?: InputMaybe<Scalars['String']['input']>;
  clientHostedLoginURL?: InputMaybe<Scalars['String']['input']>;
  /** This field relies on the CNAME value in our host settings. Mapping needs to be previously done by the CloudOps team. */
  customUrl?: InputMaybe<Scalars['String']['input']>;
  databaseAuthConnectionId?: InputMaybe<Scalars['SafeString']['input']>;
  databaseAuthConnectionName?: InputMaybe<Scalars['SafeString']['input']>;
  defaultAdvisorRoleId?: InputMaybe<Scalars['ObjectID']['input']>;
  defaultAuthenticationConnection?: InputMaybe<AuthenticationConnections>;
  defaultClientRoleId?: InputMaybe<Scalars['ObjectID']['input']>;
  defaultDriftCalculationMethod?: InputMaybe<DriftCalculationMethod>;
  defaultDriftTolerancePercent?: InputMaybe<Scalars['Int']['input']>;
  defaultSignUpRoleId?: InputMaybe<Scalars['ObjectID']['input']>;
  defaultTradingProcess?: InputMaybe<OrgSubAccountTradingProcesses>;
  disableRebalanceReport?: InputMaybe<Scalars['Boolean']['input']>;
  disableStatsUpdateBasedOnTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  displayCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  displayMenuBar?: InputMaybe<Scalars['Boolean']['input']>;
  enableAllInKindTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoUpdateExchangeRates?: InputMaybe<Scalars['Boolean']['input']>;
  enableContactSupport?: InputMaybe<Scalars['Boolean']['input']>;
  enableEmailFrenchTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  enableFullCashTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  enableInactivityTimeOut?: InputMaybe<Scalars['Boolean']['input']>;
  enableLoginSettings?: InputMaybe<Scalars['Boolean']['input']>;
  enableManualUpdateExchangeRates?: InputMaybe<Scalars['Boolean']['input']>;
  enableMultiFactorAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  enablePartialCashTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  enableRemeberBrowser?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourcesAndArticles?: InputMaybe<Scalars['Boolean']['input']>;
  enableSingleLogout?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated entityName is deprecated, use translatedEntityName instead */
  entityName?: InputMaybe<Scalars['SafeString']['input']>;
  errorPageBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  errorPageButtonText?: InputMaybe<OrganizationTranslatedStringInput>;
  errorPageDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  errorPageMessage?: InputMaybe<OrganizationTranslatedStringInput>;
  errorPageShowNavbar?: InputMaybe<Scalars['Boolean']['input']>;
  excludeAdminFeesFromClients?: InputMaybe<Scalars['Boolean']['input']>;
  externalClientTokenEmailKey?: InputMaybe<Scalars['SafeString']['input']>;
  externalClientTokenIntegrationIdKey?: InputMaybe<Scalars['SafeString']['input']>;
  faviconLink?: InputMaybe<Scalars['String']['input']>;
  fetchCurrentPricesOnDemand?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated helpCentreUrl is deprecated, use translatedHelpCentreUrl instead */
  helpCentreUrl?: InputMaybe<Scalars['URLString']['input']>;
  hideAutoUpdatePrices?: InputMaybe<Scalars['Boolean']['input']>;
  historicalSnapshotsCutOffDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  historicalSnapshotsFrequency?: InputMaybe<HistoricalSnapshotsFrequency>;
  inactivityTimeoutInMinutes?: InputMaybe<Scalars['Int']['input']>;
  includeExternalClientTokenIntoContext?: InputMaybe<Scalars['Boolean']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<OrganizationIntegrationInput>>>;
  invitationRedirectUrl?: InputMaybe<Scalars['URLString']['input']>;
  isReferral?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdictions?: InputMaybe<EnabledJurisdictionsInput>;
  jwtKeyUrl?: InputMaybe<Scalars['SafeString']['input']>;
  localizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  loginSettingsTitle?: InputMaybe<OrganizationTranslatedStringInput>;
  loginUrl?: InputMaybe<Scalars['URLString']['input']>;
  logoutRedirectUrl?: InputMaybe<Scalars['URLString']['input']>;
  marketValueDipThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  minDepositCents?: InputMaybe<Scalars['Int']['input']>;
  minInitialDepositCents?: InputMaybe<Scalars['Int']['input']>;
  minInvestAmountCents?: InputMaybe<Scalars['Int']['input']>;
  minRecurringDepositCents?: InputMaybe<Scalars['Int']['input']>;
  multiFactorAuthenticationOptions?: InputMaybe<Array<InputMaybe<MultiFactorAuthenticationOptions>>>;
  /** @deprecated name is deprecated, use translatedName instead */
  name?: InputMaybe<Scalars['SafeString']['input']>;
  optimizerProcess?: InputMaybe<OrgOptimizerProcesses>;
  organizationId: Scalars['ObjectID']['input'];
  parentId?: InputMaybe<Scalars['ObjectID']['input']>;
  permissions?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  productShelfCurrencies?: InputMaybe<Array<InputMaybe<CurrencyCodes>>>;
  profileReviewTimeInMonths?: InputMaybe<Scalars['Int']['input']>;
  repCode?: InputMaybe<Scalars['SafeString']['input']>;
  requireFeeApproval?: InputMaybe<Scalars['Boolean']['input']>;
  requireManualAccountApproval?: InputMaybe<Scalars['Boolean']['input']>;
  requireSubTradeRequestApproval?: InputMaybe<Scalars['Boolean']['input']>;
  reviewTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated supportUrl is deprecated, use translatedSupportUrl instead */
  supportUrl?: InputMaybe<Scalars['URLString']['input']>;
  /** @deprecated termsAndConditionsUrl is deprecated, use translatedTermsAndConditionsUrl instead */
  termsAndConditionsUrl?: InputMaybe<Scalars['URLString']['input']>;
  theme?: InputMaybe<OrganizationThemeInput>;
  themeTokens?: InputMaybe<Scalars['Object']['input']>;
  tokenExchangeValidationType?: InputMaybe<TokenExchangeValidationTypes>;
  translatedEntityName?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedHelpCentreUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedSupportUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedTermsAndConditionsUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  /** @deprecated no longer using a separate Client Auth0 */
  useClientOrgAuth0?: InputMaybe<Scalars['Boolean']['input']>;
  useParentAdvisorContacts?: InputMaybe<Scalars['Boolean']['input']>;
  useParentAlertBanners?: InputMaybe<Scalars['Boolean']['input']>;
  useParentArticles?: InputMaybe<Scalars['Boolean']['input']>;
  useParentAssetClasses?: InputMaybe<Scalars['Boolean']['input']>;
  useParentBillingSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  useParentClientReportTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  useParentConfigurableTablePages?: InputMaybe<Scalars['Boolean']['input']>;
  useParentCustodianConnections?: InputMaybe<Scalars['Boolean']['input']>;
  useParentCustomAttributeLabels?: InputMaybe<Scalars['Boolean']['input']>;
  useParentCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  useParentDashboards?: InputMaybe<Scalars['Boolean']['input']>;
  useParentDisplayRoles?: InputMaybe<Scalars['Boolean']['input']>;
  useParentDowntimeSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  useParentFeeTiers?: InputMaybe<Scalars['Boolean']['input']>;
  useParentFormDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  useParentFormTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  useParentHomePageConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentIntegrations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentLocalizations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentModelPortfolios?: InputMaybe<Scalars['Boolean']['input']>;
  useParentNotificationDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  useParentNotificationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  useParentPageConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentPortfolioTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  useParentProductShelf?: InputMaybe<Scalars['Boolean']['input']>;
  useParentRepCodes?: InputMaybe<Scalars['Boolean']['input']>;
  useParentRoleProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  useParentSalesTaxConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  useParentSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  useParentSignerTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useParentStaticPageWidgetConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentThemeTokens?: InputMaybe<Scalars['Boolean']['input']>;
  useParentThemes?: InputMaybe<Scalars['Boolean']['input']>;
  useParentWebhooks?: InputMaybe<Scalars['Boolean']['input']>;
  useParentWorkflows?: InputMaybe<Scalars['Boolean']['input']>;
  validateUniquenessForSubOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationResponse = {
  __typename?: 'UpdateOrganizationResponse';
  organization?: Maybe<Organization>;
};

export type UpdateOrganizationUserInput = {
  accessType?: InputMaybe<OrganizationUserAccessTypes>;
  avatar?: InputMaybe<Scalars['SafeString']['input']>;
  displayRoleId?: InputMaybe<Scalars['ObjectID']['input']>;
  email?: InputMaybe<Scalars['SafeString']['input']>;
  entities?: InputMaybe<Array<OrganizationUserEntityInput>>;
  firstName?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<OrganizationIntegrationInput>>>;
  language?: InputMaybe<Languages>;
  lastName?: InputMaybe<Scalars['SafeString']['input']>;
  organizationUserId: Scalars['ObjectID']['input'];
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  repCodes?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  roleId?: InputMaybe<Scalars['ObjectID']['input']>;
  viewFullClientGroup?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationUserProfileInput = {
  avatar?: InputMaybe<Scalars['SafeString']['input']>;
  email?: InputMaybe<Scalars['SafeString']['input']>;
  firstName?: InputMaybe<Scalars['SafeString']['input']>;
  language?: InputMaybe<Languages>;
  lastName?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpdateOrganizationUserProfileResponse = {
  __typename?: 'UpdateOrganizationUserProfileResponse';
  organizationUser?: Maybe<OrganizationUser>;
};

export type UpdateOrganizationUserResponse = {
  __typename?: 'UpdateOrganizationUserResponse';
  organizationUser?: Maybe<OrganizationUser>;
};

export type UpdatePageConfigurationInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['Object']['input']>;
  pageConfigurationId: Scalars['ObjectID']['input'];
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  tabs?: InputMaybe<Array<TabConfigurationInput>>;
};

export type UpdatePageConfigurationResponse = {
  __typename?: 'UpdatePageConfigurationResponse';
  pageConfiguration?: Maybe<PageConfiguration>;
};

export type UpdatePortfolioTemplateInput = {
  /** The asset class allocations for this template */
  assetClassBranches?: InputMaybe<Array<AssetClassBranchInput>>;
  /** The name of the template */
  name?: InputMaybe<Scalars['SafeString']['input']>;
  /** The ID of the template to update */
  portfolioTemplateId: Scalars['ObjectID']['input'];
  /** The state of the template */
  state?: InputMaybe<PortfolioTemplateState>;
  /** The translated name of the template */
  translatedName?: InputMaybe<ProductTranslatedStringInput>;
  /** The translated description of the template */
  translatedTemplateDescription?: InputMaybe<ProductTranslatedStringInput>;
};

export type UpdatePortfolioTemplateResponse = {
  __typename?: 'UpdatePortfolioTemplateResponse';
  portfolioTemplate: PortfolioTemplate;
};

export type UpdatePriceAndQuantityInput = {
  bulkTrades: Array<BulkTrade>;
  currencyFallbackConversions?: InputMaybe<Array<CurrencyFallbackConversion>>;
  rebalanceId: Scalars['ObjectID']['input'];
  type?: InputMaybe<TradeType>;
};

export type UpdatePriceAndQuantityResponse = {
  __typename?: 'UpdatePriceAndQuantityResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateRepCodeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  repCodeId: Scalars['ObjectID']['input'];
};

export type UpdateRepCodeResponse = {
  __typename?: 'UpdateRepCodeResponse';
  repCode?: Maybe<RepCode>;
};

export type UpdateReportInput = {
  accessType?: InputMaybe<ReportAccessType>;
  columns?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  reportId: Scalars['ObjectID']['input'];
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['SafeString']['input']>;
  type?: InputMaybe<ReportType>;
};

export type UpdateReportResponse = {
  __typename?: 'UpdateReportResponse';
  report: DataReport;
};

export type UpdateRoleInput = {
  accessiblePages?: InputMaybe<Array<Pages>>;
  accountGroupPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountGroupTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  configurableTablePageIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  dashboards?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  defaultAccessType?: InputMaybe<OrganizationUserAccessTypes>;
  defaultAuthenticationConnection?: InputMaybe<AuthenticationConnections>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  externalRoleId?: InputMaybe<Scalars['SafeString']['input']>;
  goalPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  homePageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  individualPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  individualTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  makeHouseholdDefaultView?: InputMaybe<Scalars['Boolean']['input']>;
  navigationStyle?: InputMaybe<NavigationStyles>;
  nonIndividualPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  nonIndividualTableStaticPageWidgetConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  permissions?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['ObjectID']['input'];
  roleProfileId?: InputMaybe<Scalars['ObjectID']['input']>;
  roleType?: InputMaybe<RoleTypes>;
  subAccountPageConfigurationId?: InputMaybe<Scalars['ObjectID']['input']>;
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
};

export type UpdateRoleProfileInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  roleProfileId: Scalars['ObjectID']['input'];
  template?: InputMaybe<RoleProfileTemplateInput>;
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
  updateAllRoles?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRoleProfileResponse = {
  __typename?: 'UpdateRoleProfileResponse';
  roleProfile?: Maybe<RoleProfile>;
};

export type UpdateRoleResponse = {
  __typename?: 'UpdateRoleResponse';
  role?: Maybe<Role>;
};

export type UpdateScheduleInput = {
  dates: Array<Scalars['GraphQLDate']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  scheduleId: Scalars['ObjectID']['input'];
};

export type UpdateScheduleResponse = {
  __typename?: 'UpdateScheduleResponse';
  schedule: Schedule;
};

export type UpdateScheduledIncomeFundTransferInput = {
  amountPayableType?: InputMaybe<AmountPayableType>;
  annualAmountCents?: InputMaybe<Scalars['Long']['input']>;
  bankAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  currency?: InputMaybe<Currencies>;
  dateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  frequency?: InputMaybe<IncomeFundFrequency>;
  minimumAnnualAmountCents?: InputMaybe<Scalars['Long']['input']>;
  scheduledDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  scheduledIncomeFundTransferId: Scalars['ObjectID']['input'];
  specialTaxRate?: InputMaybe<Scalars['Float']['input']>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  taxOption?: InputMaybe<TaxOptionType>;
  totalWithdrawalAmountOption?: InputMaybe<TotalWithdrawalAmountOption>;
  transferredAmountCents?: InputMaybe<Scalars['Long']['input']>;
};

export type UpdateScheduledIncomeFundTransferResponse = {
  __typename?: 'UpdateScheduledIncomeFundTransferResponse';
  scheduledIncomeFundTransfer: ScheduledIncomeFundTransfer;
};

export type UpdateScheduledTransferInput = {
  amountCents?: InputMaybe<Scalars['Long']['input']>;
  bankAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  currency?: InputMaybe<Currencies>;
  frequency?: InputMaybe<Frequency>;
  integrations?: InputMaybe<Array<InputMaybe<HoldingIntegrationInput>>>;
  scheduledDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  scheduledTransferId: Scalars['ObjectID']['input'];
  withdrawalReason?: InputMaybe<WithdrawalReason>;
  withdrawalReasonDescription?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpdateScheduledTransferResponse = {
  __typename?: 'UpdateScheduledTransferResponse';
  scheduledTransfer: ScheduledTransfer;
};

export type UpdateSftpCredentialsInput = {
  sftpInAuthenticationType?: InputMaybe<Scalars['String']['input']>;
  sftpInBucket?: InputMaybe<Scalars['String']['input']>;
  sftpInBucketVariableName?: InputMaybe<Scalars['String']['input']>;
  sftpInDownloadFile?: InputMaybe<Scalars['Boolean']['input']>;
  sftpInHost?: InputMaybe<Scalars['String']['input']>;
  sftpInPassphrase?: InputMaybe<Scalars['String']['input']>;
  sftpInPassword?: InputMaybe<Scalars['String']['input']>;
  sftpInPort?: InputMaybe<Scalars['String']['input']>;
  sftpInPrivateKey?: InputMaybe<Scalars['String']['input']>;
  sftpInServerHostKey?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sftpInSourceDir?: InputMaybe<Scalars['String']['input']>;
  sftpInTargetPrefix?: InputMaybe<Scalars['String']['input']>;
  sftpInUsername?: InputMaybe<Scalars['String']['input']>;
  sftpOutAuthenticationType?: InputMaybe<Scalars['String']['input']>;
  sftpOutBucket?: InputMaybe<Scalars['String']['input']>;
  sftpOutBucketVariableName?: InputMaybe<Scalars['String']['input']>;
  sftpOutHost?: InputMaybe<Scalars['String']['input']>;
  sftpOutPassphrase?: InputMaybe<Scalars['String']['input']>;
  sftpOutPassword?: InputMaybe<Scalars['String']['input']>;
  sftpOutPort?: InputMaybe<Scalars['String']['input']>;
  sftpOutPrivateKey?: InputMaybe<Scalars['String']['input']>;
  sftpOutServerHostKey?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sftpOutTargetDir?: InputMaybe<Scalars['String']['input']>;
  sftpOutUsername?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSiemFeedInput = {
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  maxWindowMinutes?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  siemFeedId: Scalars['ObjectID']['input'];
  whitelistAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateSiemFeedResponse = {
  __typename?: 'UpdateSiemFeedResponse';
  siemFeed: SiemFeed;
};

export type UpdateSignerTypeInput = {
  defaultSigningOrder?: InputMaybe<Scalars['Int']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  roleProfiles?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  signerTypeId: Scalars['ObjectID']['input'];
  translatedName: TranslatedStringInput;
};

export type UpdateSignerTypeResponse = {
  __typename?: 'UpdateSignerTypeResponse';
  signerType: SignerType;
};

export type UpdateStaticPageWidgetConfigurationInput = {
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  staticPageWidgetConfigurationId: Scalars['ObjectID']['input'];
  widget?: InputMaybe<StaticWidgetConfigurationInput>;
};

export type UpdateStaticPageWidgetConfigurationResponse = {
  __typename?: 'UpdateStaticPageWidgetConfigurationResponse';
  staticPageWidgetConfiguration?: Maybe<StaticPageWidgetConfiguration>;
};

export type UpdateStepInput = {
  branches?: InputMaybe<Array<WorkflowStepBranchInput>>;
  endNodePosition?: InputMaybe<NodePositionInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  name: TranslatedStringInput;
  startNodePosition?: InputMaybe<NodePositionInput>;
  subSteps: Array<UpdateSubStepInput>;
};

export type UpdateSubAccountBillingInput = {
  adjustedFeeCents?: InputMaybe<Scalars['Long']['input']>;
  adjustedSalesTaxCents?: InputMaybe<Scalars['Long']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  subAccountBillingId: Scalars['ObjectID']['input'];
};

export type UpdateSubAccountBillingResponse = {
  __typename?: 'UpdateSubAccountBillingResponse';
  subAccountBilling: SubAccountBilling;
};

export type UpdateSubAccountInput = {
  allowClientDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use the updateEntityFeeSetting mutation instead. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  /** @deprecated Use the updateEntityFeeSetting mutation instead. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountIntegrationInput>>>;
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedBy?: InputMaybe<Scalars['SafeString']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  skipIPS?: InputMaybe<Scalars['Boolean']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  suitabilityScore?: InputMaybe<Scalars['Int']['input']>;
  themeId?: InputMaybe<Scalars['ObjectID']['input']>;
  tradingProcess?: InputMaybe<SubAccountTradingProcesses>;
};

export type UpdateSubAccountResponse = {
  __typename?: 'UpdateSubAccountResponse';
  subAccount: SubAccount;
};

export type UpdateSubStepInput = {
  branches?: InputMaybe<Array<WorkflowStepBranchInput>>;
  canGoBack?: InputMaybe<Scalars['Boolean']['input']>;
  completeableBy?: InputMaybe<Array<SubStepCompleteableBys>>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  nodePosition?: InputMaybe<NodePositionInput>;
  options?: InputMaybe<Scalars['Object']['input']>;
  rolesCompleteableBy?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  skippable?: InputMaybe<Scalars['Boolean']['input']>;
  type: SubStepTypes;
};

export type UpdateSubTradeRequestInput = {
  actualQuantity?: InputMaybe<Scalars['Float']['input']>;
  actualTradePriceCents?: InputMaybe<Scalars['Float']['input']>;
  expectedQuantity?: InputMaybe<Scalars['Float']['input']>;
  expectedTradePriceCents?: InputMaybe<Scalars['Float']['input']>;
  isSellAll?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
  moneyAllocatedCents?: InputMaybe<Scalars['Float']['input']>;
  portfolioReportId?: InputMaybe<Scalars['ObjectID']['input']>;
  subTradeRequestId: Scalars['ObjectID']['input'];
  type?: InputMaybe<SubTradeRequestTypes>;
};

export type UpdateSubTradeRequestResponse = {
  __typename?: 'UpdateSubTradeRequestResponse';
  subTradeRequest: SubTradeRequest;
};

export type UpdateSubTradeRequestsInput = {
  subTradeRequests: Array<UpdateSubTradeRequestInput>;
};

export type UpdateSuccessorPhysicalAddressInput = {
  city?: InputMaybe<Scalars['SafeString']['input']>;
  country?: InputMaybe<AddressCountries>;
  houseNumber?: InputMaybe<Scalars['SafeString']['input']>;
  neighborhood?: InputMaybe<Scalars['SafeString']['input']>;
  postal?: InputMaybe<Scalars['SafeString']['input']>;
  province?: InputMaybe<AddressProvince>;
  streetName?: InputMaybe<Scalars['SafeString']['input']>;
  unitNumber?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpdateTaxLotInput = {
  accountId: Scalars['ObjectID']['input'];
  date?: InputMaybe<Scalars['GraphQLDate']['input']>;
  financialProductId: Scalars['ObjectID']['input'];
  priceCents?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  taxLotId: Scalars['ObjectID']['input'];
};

export type UpdateTaxLotResponse = {
  __typename?: 'UpdateTaxLotResponse';
  taxLot: TaxLot;
};

export type UpdateThemeInput = {
  core?: InputMaybe<Scalars['Boolean']['input']>;
  iconKey?: InputMaybe<Scalars['SafeString']['input']>;
  key?: InputMaybe<Scalars['SafeString']['input']>;
  themeId: Scalars['ObjectID']['input'];
  translatedDescription?: InputMaybe<ProductTranslatedStringInput>;
  translatedName?: InputMaybe<ProductTranslatedStringInput>;
  translatedShortDescription?: InputMaybe<ProductTranslatedStringInput>;
};

export type UpdateThemeResponse = {
  __typename?: 'UpdateThemeResponse';
  theme: Theme;
};

export type UpdateTradeRequestFillsInput = {
  bulkTradeRunId: Scalars['ObjectID']['input'];
  bulkTrades: Array<UpdateTradeRequestFillsItem>;
  currencyFallbackConversions?: InputMaybe<Array<CurrencyFallbackConversion>>;
};

export type UpdateTradeRequestFillsItem = {
  actualPriceCents: Scalars['Float']['input'];
  ticker: Scalars['String']['input'];
  totalQuantity: Scalars['Float']['input'];
  type: TradeRequestTypes;
};

export type UpdateTradeRequestFillsResponse = {
  __typename?: 'UpdateTradeRequestFillsResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateTransactionInput = {
  /**
   * Execution order for transactions on the same date. Used to ensure correct ACB/Book Value calculations.
   * Example: For same-fund crystallizations, SWO should be 0 (sell first) and SWI should be 1 (buy second).
   * For corporate actions, set order to ensure removals process before additions.
   */
  adjustedCostBaseExecutionOrder?: InputMaybe<Scalars['Int']['input']>;
  bookCostCents?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currencies>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  date?: InputMaybe<Scalars['GraphQLDate']['input']>;
  description?: InputMaybe<Scalars['SafeString']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  priceCents?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  transactionId: Scalars['ObjectID']['input'];
  valueCents?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTransactionOptionsInput = {
  refreshSnapshotsSync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTransactionResponse = {
  __typename?: 'UpdateTransactionResponse';
  transaction: Transaction;
};

export type UpdateTransferInput = {
  amountCents?: InputMaybe<Scalars['Long']['input']>;
  bankAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  currency?: InputMaybe<Currencies>;
  fiscalYear?: InputMaybe<Scalars['Int']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<HoldingIntegrationInput>>>;
  source?: InputMaybe<TransferSources>;
  sourceId?: InputMaybe<Scalars['ObjectID']['input']>;
  transferId: Scalars['ObjectID']['input'];
  type?: InputMaybe<TransferType>;
  usaContributionType?: InputMaybe<UsaContributionType>;
  usaWithdrawalReason?: InputMaybe<UsaWithdrawalReason>;
};

export type UpdateTransferResponse = {
  __typename?: 'UpdateTransferResponse';
  transfer: Transfer;
};

/** Input type for updating a user's IdVerification */
export type UpdateUserIdVerificationInformationInput = {
  address?: InputMaybe<PhysicalAddressInput>;
  creditFileSource?: InputMaybe<Scalars['SafeString']['input']>;
  /** The expiry date of the document in YYYY-MM-DD (ISO 8601 format). Required for DIGITAL_DOCUMENT_CHECK method.  */
  documentExpiryDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** The unique identifying number of the document used (Required for DIGITAL_DOCUMENT_CHECK method) */
  documentID?: InputMaybe<Scalars['SafeString']['input']>;
  /** The jurisdiction (province or state) and country of issue of the document (Required for DIGITAL_DOCUMENT_CHECK method) */
  documentIssuingJurisdication?: InputMaybe<Scalars['SafeString']['input']>;
  /** Type of the document used in the ID Verification (Required for DIGITAL_DOCUMENT_CHECK method) */
  documentType?: InputMaybe<IdDocumentTypes>;
  /** idVerificationID */
  idVerificationId: Scalars['ObjectID']['input'];
  /** Method used for ID verification. */
  methodOfIDVerification?: InputMaybe<IdVerificationMethods>;
  /** Date of birth on secondary document in YYYY-MM-DD (ISO 8601 format). Used in verification process.  */
  secondaryDocumentDateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Secondary document expiry date in YYYY-MM-DD (ISO 8601 format).  */
  secondaryDocumentExpiryDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  secondaryDocumentID?: InputMaybe<Scalars['SafeString']['input']>;
  secondaryDocumentIssuingJurisdication?: InputMaybe<Scalars['SafeString']['input']>;
  secondaryDocumentType?: InputMaybe<IdDocumentTypes>;
  secondaryDocumentUserName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date secondary document was verified in YYYY-MM-DD (ISO 8601 format).   */
  secondaryDocumentVerifiedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** The person's name on the document (Required for DIGITAL_DOCUMENT_CHECK method) */
  userName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date of ID verification in YYYY-MM-DD (ISO 8601 format). Required for DIGITAL_DOCUMENT_CHECK method.  */
  verifiedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type UpdateUserInput = {
  /** Advisor interest details */
  advisorInterest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Advisor interest details */
  advisorInterestDetail?: InputMaybe<Scalars['String']['input']>;
  /** User satisfies two conditions: is only affiliated with another user and is not directly associated to an account. */
  affiliateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** User's alternate address (optional) */
  alternateAddress?: InputMaybe<AlternatePhysicalAddressInput>;
  /** Value of total amount User pays toward debts annually in amount cents. Used to determine risk suitability score. */
  annualDebtPaymentsCents?: InputMaybe<Scalars['Long']['input']>;
  /** Gross or net annual income in amount cents.  */
  annualIncomeCents?: InputMaybe<Scalars['Long']['input']>;
  /** Gross or net annual income in non-numeric form (range, category, etc).  */
  annualIncomeStr?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkAccountOpening?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use isMemberOfIiroc instead */
  businessIsMemberofIIROC?: InputMaybe<Scalars['Boolean']['input']>;
  /** Valid phone number that contains 7-15 digits, including country code (E.164 format). */
  businessPhone?: InputMaybe<Scalars['SafeString']['input']>;
  charityRegistrationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** Citizenships of the user */
  citizenships?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /** Defines if User is a close associate of a politically exposed person (PEP). */
  closeAssociateOfPEP?: InputMaybe<Scalars['Boolean']['input']>;
  /** If User is employed, string input that describes the type of company where User is employed. For example, a private company, nonprofit, etc.  */
  companyType?: InputMaybe<Scalars['SafeString']['input']>;
  complianceIssueSource?: InputMaybe<Scalars['SafeString']['input']>;
  complianceState?: InputMaybe<ComplianceStates>;
  /** Was the user converted from an affiliate invitation to a full user? */
  convertedFromAffiliateInvitation?: InputMaybe<Scalars['Boolean']['input']>;
  countryOfRegistration?: InputMaybe<Scalars['SafeString']['input']>;
  /** Name of country using two-letter country code format (ISO 3166-1 alpha-2). Required for address validation, tax residency determination, and regulatory compliance. */
  countryOfTaxResidence?: InputMaybe<AddressCountries>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  /** User's date of birth in YYYY-MM-DD (ISO 8601 format). */
  dateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Decedent's date of death in YYYY-MM-DD (ISO 8601 format). Used for estate planning and account management purposes. */
  dateOfDeath?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Types of debt associated with User. For example, student loan, mortgage, credit card debt, etc.  */
  debtAssociated?: InputMaybe<Array<InputMaybe<DebtAssociated>>>;
  /** Defines if User has discretion over the account. */
  discretionOverAccountGranted?: InputMaybe<Scalars['Boolean']['input']>;
  discretionOverAccountGrantedReason?: InputMaybe<Scalars['String']['input']>;
  employerCompanyAddress?: InputMaybe<PhysicalAddressInput>;
  /** Company phone number for User's employer. Must contain 7-15 digits, including country code (E.164 format). */
  employerCompanyPhone?: InputMaybe<Scalars['SafeString']['input']>;
  employerName?: InputMaybe<Scalars['SafeString']['input']>;
  employmentSituation?: InputMaybe<EmploymentSituation>;
  employmentSituationOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's employment status */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  entityName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date entity was established in YYYY-MM-DD (ISO 8601 format).  */
  establishedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  fatcaStatus?: InputMaybe<FatcaStatus>;
  fatcaStatusOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Current market value of user's fixed, non-liquid assets in amount cents. */
  financialFixedAssetsCents?: InputMaybe<Scalars['Long']['input']>;
  /** User's liquid assets (cash or cash-equivalent investments) in amount cents. */
  financialLiquidAssetsCents?: InputMaybe<Scalars['Long']['input']>;
  firmNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** First name of user.  */
  firstName?: InputMaybe<Scalars['SafeString']['input']>;
  /** The tax information provided by the user if the user pays tax to a foreign country */
  foreignTaxInformation?: InputMaybe<Array<InputMaybe<ForeignTaxInformationInput>>>;
  /** User's gender: MALE, FEMALE or OTHER */
  gender?: InputMaybe<Scalars['SafeString']['input']>;
  hasCheckedPolicyAndCondition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User has a guarantor. */
  hasGuarantor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is/Was the User the head of an international organization? */
  headOfInternationalOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  iDCheckCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  iDCheckRetrigger?: InputMaybe<Scalars['Boolean']['input']>;
  identificationType?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date user became a resident of current province/state in YYYY-MM-DD (ISO 8601 format). Determines provincial tax residency and compliance requirements.  */
  inProvinceSince?: InputMaybe<Scalars['GraphQLDate']['input']>;
  insiderSymbols?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  instructionsFromFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<UserIntegrationInput>>>;
  /** Defines if User trades with an investment firm. */
  investmentFirmTrade?: InputMaybe<Scalars['Boolean']['input']>;
  /** Firm name that User trades with */
  investmentFirmTradeName?: InputMaybe<Scalars['String']['input']>;
  /** What is the user's level of investment knowledge? */
  investmentKnowledge?: InputMaybe<InvestmentKnowledge>;
  isAFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the client an accredited investor? */
  isAccreditedInvestor?: InputMaybe<Scalars['Boolean']['input']>;
  isAffiliateOfFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use isNonProfit instead */
  isEntityForProfit?: InputMaybe<Scalars['Boolean']['input']>;
  isEntityRegulated?: InputMaybe<Scalars['Boolean']['input']>;
  isForThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  isLargeCorporation?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Is the user a member of IIROC?
   * IIROC:Investment Industry Regulatory Organization of Canada
   */
  isMemberOfIiroc?: InputMaybe<Scalars['Boolean']['input']>;
  isNonProfit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the user a high-level management executive of a public company? */
  isOfficerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerOfEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the user the owner of a public company? */
  isOwnerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicBody?: InputMaybe<Scalars['Boolean']['input']>;
  isRegisteredWithCRA?: InputMaybe<Scalars['Boolean']['input']>;
  isRelatedToAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  isReportingIssuer?: InputMaybe<Scalars['Boolean']['input']>;
  isVulnerablePerson?: InputMaybe<Scalars['Boolean']['input']>;
  issuerExchange?: InputMaybe<Scalars['SafeString']['input']>;
  issuerName?: InputMaybe<Scalars['SafeString']['input']>;
  issuerTicker?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's job title, if employed */
  jobTitle?: InputMaybe<Scalars['SafeString']['input']>;
  /** Languages the user communicates in */
  language?: InputMaybe<Languages>;
  /** Last name of user.  */
  lastName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date of last suitability review in YYYY-MM-DD (ISO 8601 format).  */
  lastSuitabilityReviewAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** User's mailing address (optional) */
  mailingAddress?: InputMaybe<PhysicalAddressInput>;
  /** User's marital status */
  maritalStatus?: InputMaybe<MaritalStatus>;
  /** Middle name of user.  */
  middleName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date of user's next suitability assessment review in YYYY-MM-DD (ISO 8601 format). Triggers Know Your Client (KYC) process.  */
  nextSuitabilityReviewAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Number of dependents associated with User */
  numberOfDependents?: InputMaybe<Scalars['Int']['input']>;
  /** Names of persons guaranteeing the account. */
  otherPersonGuaranteeNames?: InputMaybe<Scalars['String']['input']>;
  parentCompanyName?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated use foreignTaxInformation */
  payTaxesOutsideCanada?: InputMaybe<Scalars['Boolean']['input']>;
  /** String input that describes why User is a politically exposed person (PEP).  */
  pepReason?: InputMaybe<Scalars['String']['input']>;
  /** Phone number that contains 7-15 digits, including country code (E.164 format). */
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's primary address */
  physicalAddress?: InputMaybe<PhysicalAddressInput>;
  /** Defines if User is a politically exposed person (PEP).  */
  politicallyExposedDomesticPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is a politically exposed person (PEP) in a foreign country.  */
  politicallyExposedForeignPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has the User appointed a Power of Attorney? */
  powerOfAttorneyGranted?: InputMaybe<Scalars['Boolean']['input']>;
  preferredMethodOfCommunication?: InputMaybe<MethodOfCommunication>;
  preferredMethodOfCommunicationOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: InputMaybe<Scalars['SafeString']['input']>;
  readyToSignAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  receivesDonationsFromPublic?: InputMaybe<Scalars['Boolean']['input']>;
  registrationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  regulatorName?: InputMaybe<Scalars['SafeString']['input']>;
  relatedEntities?: InputMaybe<Array<InputMaybe<RelatedEntityInput>>>;
  /** Expected age the user wishes to retire */
  retirementAge?: InputMaybe<Scalars['Int']['input']>;
  /** Answer to the first risk question. Used to generate user suitability score.  */
  riskQuestion1?: InputMaybe<RiskLevels>;
  /** Answer to the second risk question. Used to generate user suitability score. */
  riskQuestion2?: InputMaybe<RiskLevels>;
  riskScore?: InputMaybe<Scalars['Int']['input']>;
  /**
   * User's Social Insurance Number
   * @deprecated use taxIdType=SIN and taxId instead
   */
  sin?: InputMaybe<Scalars['SafeString']['input']>;
  sourceOfFunds?: InputMaybe<Array<InputMaybe<UserSourceOfFunds>>>;
  sourceOfFundsOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  sourceOfWealth?: InputMaybe<Array<InputMaybe<UserSourceOfWealth>>>;
  sourceOfWealthOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  spouseAddress?: InputMaybe<PhysicalAddressInput>;
  /** Gross or net annual income of user's spouse in amount cents.  */
  spouseAnnualIncomeCents?: InputMaybe<Scalars['Long']['input']>;
  /** Gross or net annual income in non-numeric form (range, category, etc) of user's spouse. */
  spouseAnnualIncomeStr?: InputMaybe<Scalars['SafeString']['input']>;
  spouseAreaOfStudy?: InputMaybe<Scalars['SafeString']['input']>;
  /** If spouse is employed, describes the type of company where spouse is employed. For example, a private company, nonprofit, etc.  */
  spouseCompanyType?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's spouse's date of birth in YYYY-MM-DD (ISO 8601 format).  */
  spouseDateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  spouseEmail?: InputMaybe<Scalars['String']['input']>;
  spouseEmployerCompanyAddress?: InputMaybe<PhysicalAddressInput>;
  /** Company phone number for spouse's employer. Must contain 7-15 digits, including country code (E.164 format). */
  spouseEmployerCompanyPhone?: InputMaybe<Scalars['SafeString']['input']>;
  spouseEmployerName?: InputMaybe<Scalars['SafeString']['input']>;
  spouseEmploymentStatus?: InputMaybe<EmploymentStatus>;
  spouseEmploymentType?: InputMaybe<Scalars['SafeString']['input']>;
  /** First name of user's spouse. */
  spouseFirstName?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's spouse's job title */
  spouseJobTitle?: InputMaybe<Scalars['SafeString']['input']>;
  /** Last name of user's spouse.  */
  spouseLastName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Middle name of user's spouse.  */
  spouseMiddleName?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated use spouseTaxId instead */
  spouseSin?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's spouse's tax identification number. For Canada, use SIN/BN. For the United States, use SSN, ITIN, or EIN. */
  spouseTaxId?: InputMaybe<Scalars['String']['input']>;
  spouseTaxIdType?: InputMaybe<TaxIdTypes>;
  /** User's spouse title */
  spouseTitle?: InputMaybe<SpouseTitle>;
  ssSymbols?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /** If User is a student, describes area of study */
  studentAreaOfStudy?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's tax identification number. If Canada, use SIN or BN. If United States, use SSN, ITIN, or EIN. See taxIdType. */
  taxId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Describes the kind of tax ID User has. Accepts values SIN, BN, SSN, ITIN, and EIN.  */
  taxIdType?: InputMaybe<TaxIdTypes>;
  taxNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** The name of the entity  for whom the user is acting */
  thirdPartyName?: InputMaybe<Scalars['String']['input']>;
  /** Timezone in IANA format (AREA/LOCATION).  */
  timezone?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's title */
  title?: InputMaybe<UserTitle>;
  /** Total debt in amount cents.  */
  totalDebtCents?: InputMaybe<Scalars['Long']['input']>;
  /** Name of the person with trading authority. */
  tradingAuthorityName?: InputMaybe<Scalars['String']['input']>;
  /** Defines if User has trading authority over the account. */
  tradingAuthorityOverAccountGranted?: InputMaybe<Scalars['Boolean']['input']>;
  /** User's trusted contact person */
  trustedContactPerson?: InputMaybe<TrustedContactPersonInput>;
  type?: InputMaybe<EntityTypes>;
  typeOfTrust?: InputMaybe<TrustTypes>;
  uniqueCircumstances?: InputMaybe<Scalars['SafeString']['input']>;
  /** Defines if User uses borrowed money for investments. */
  useBorrowedMoney?: InputMaybe<Scalars['Boolean']['input']>;
  /** UserID associated with the user */
  userId: Scalars['ID']['input'];
  /** Entity's fiscal year end date in YYYY-MM-DD (ISO 8601 format). Used for financial reporting and tax purposes.  */
  yearEnd?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

/** Input type for Updating a user Organization */
export type UpdateUserOrganizationInput = {
  /** New OrganizationID */
  newOrganizationId: Scalars['ObjectID']['input'];
  /** UserID */
  userId: Scalars['ObjectID']['input'];
};

export type UpdateUserOrganizationResponse = {
  __typename?: 'UpdateUserOrganizationResponse';
  user?: Maybe<User>;
};

export type UpdateUserOrganizationUserDisplayOptionsInput = {
  displayOptions: Array<OrganizationUserDisplayOptions>;
  userId: Scalars['ObjectID']['input'];
};

export type UpdateUserOrganizationUserDisplayOptionsResponse = {
  __typename?: 'UpdateUserOrganizationUserDisplayOptionsResponse';
  userOrganizationUserDisplayOptions: Array<UserOrganizationUserDisplayOptions>;
};

/** Type definition for updating the user's information */
export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  /** User object */
  user: User;
};

export type UpdateWebhookInput = {
  /** Any custom headers that may need to be set to be sent with the mutation to the assigned url. */
  customHeaders?: InputMaybe<Scalars['Object']['input']>;
  /** Any custom payload that may need to be sent on the body along with the fetched data (REST type only). If informed, the fetched data will be sent as an object in the 'payload' attribute. */
  customPayloadAttributes?: InputMaybe<Scalars['Object']['input']>;
  /** The event type on the object that gets actioned to then send off the webhook. */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** The graphql query string that would be used to query the OneVest partner gateway usually. The variable of '$id' is used for the actioned object. */
  gql?: InputMaybe<Scalars['String']['input']>;
  /** The name of the input that the webhook will pass, it will always pass as variable 'input' (GRAPHQL type only). */
  mutationInputName?: InputMaybe<Scalars['String']['input']>;
  /** The name of the mutation that the webhook will hit (GRAPHQL type only). */
  mutationName?: InputMaybe<Scalars['String']['input']>;
  /** The type of object you want to listen to, to receive a webhook on. */
  objectType?: InputMaybe<EventObject>;
  /** Any custom header through which the signed JWT may need to be sent (REST type only). If not informed, the signed JWT will be sent in the 'OneVest-Authorization' header. */
  signedJwtHeader?: InputMaybe<Scalars['String']['input']>;
  /** GraphQL URL in which the webhook will hit. */
  url?: InputMaybe<Scalars['String']['input']>;
  webhookId: Scalars['ObjectID']['input'];
};

export type UpdateWebhookResponse = {
  __typename?: 'UpdateWebhookResponse';
  webhook: Webhook;
};

export type UpdateWorkflowCompletionInput = {
  context?: InputMaybe<Scalars['Object']['input']>;
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export type UpdateWorkflowCompletionResponse = {
  __typename?: 'UpdateWorkflowCompletionResponse';
  workflowCompletion: WorkflowCompletion;
};

export type UpdateWorkflowInput = {
  applicableRoleProfileIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  complex?: InputMaybe<Scalars['Boolean']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  extensionVersion?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<TranslatedStringInput>;
  objectType?: InputMaybe<WorkflowObjectTypes>;
  resourceKey?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<WorkflowSettingsInput>;
  steps?: InputMaybe<Array<UpdateStepInput>>;
  triggerRules?: InputMaybe<Array<InputMaybe<TriggerRuleInput>>>;
  triggerType?: InputMaybe<TriggerTypes>;
  workflowId: Scalars['ObjectID']['input'];
};

export type UpdateWorkflowResponse = {
  __typename?: 'UpdateWorkflowResponse';
  workflow: Workflow;
};

export type UpsertAccountGroupInput = {
  accountGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  householdClientGroupId?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountUpsertIntegrationInput>>>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<AccountGroupStates>;
  translatedName?: InputMaybe<AccountTranslatedStringInput>;
  type?: InputMaybe<AccountGroupTypes>;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpsertAccountInput = {
  accountId?: InputMaybe<Scalars['ObjectID']['input']>;
  affiliations?: InputMaybe<Array<InputMaybe<AccountUpsertAffiliationInput>>>;
  applyForGovFunds?: InputMaybe<Array<InputMaybe<ApplyForGovFunds>>>;
  availableCurrencies?: InputMaybe<Array<InputMaybe<AccountCurrencyTypes>>>;
  baseCurrency?: InputMaybe<AccountCurrencyTypes>;
  custodianAccountName?: InputMaybe<Scalars['SafeString']['input']>;
  custodianAccountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  custodianConnectionId?: InputMaybe<Scalars['ObjectID']['input']>;
  custodianSortingOrderPriority?: InputMaybe<Scalars['Int']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  dealerAccountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  dealerCode?: InputMaybe<Scalars['SafeString']['input']>;
  dealerName?: InputMaybe<Scalars['SafeString']['input']>;
  externalSourceType?: InputMaybe<ExternalSourceTypes>;
  forceOpen?: InputMaybe<Scalars['Boolean']['input']>;
  groupEmployer?: InputMaybe<Scalars['SafeString']['input']>;
  groupNumber?: InputMaybe<Scalars['SafeString']['input']>;
  householdClientGroupId?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountUpsertIntegrationInput>>>;
  jurisdiction?: InputMaybe<Jurisdiction>;
  overrideTaxRank?: InputMaybe<Scalars['Int']['input']>;
  repCode?: InputMaybe<Scalars['SafeString']['input']>;
  sourceOfFunds?: InputMaybe<SourceOfFunds>;
  sourceType?: InputMaybe<SourceTypes>;
  state?: InputMaybe<AccountStates>;
  translatedNickName?: InputMaybe<AccountTranslatedStringInput>;
  type?: InputMaybe<AccountTypes>;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpsertAlertBannerInteractionsInput = {
  alertBannerIds: Array<Scalars['ObjectID']['input']>;
  organizationId: Scalars['ObjectID']['input'];
};

export type UpsertAlertBannerInteractionsResponse = {
  __typename?: 'UpsertAlertBannerInteractionsResponse';
  alertBannerInteractions: Array<AlertBannerInteraction>;
};

/**
 * Asset class group weight on a model portfolio bulk upsert item.
 * assetClassId is the integration external id (SafeString), not a Mongo ObjectID.
 */
export type UpsertAssetClassBranchInput = {
  assetClassId: Scalars['SafeString']['input'];
  targetPercentage: Scalars['Float']['input'];
};

export type UpsertAssetClassInput = {
  assetClassId?: InputMaybe<Scalars['ObjectID']['input']>;
  includeCash?: InputMaybe<Scalars['Boolean']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<FinancialProductUpsertIntegrationInput>>>;
  key?: InputMaybe<Scalars['SafeString']['input']>;
  organizationId?: InputMaybe<Scalars['SafeString']['input']>;
  state?: InputMaybe<AssetClassState>;
  translatedDescription?: InputMaybe<ProductTranslatedStringInput>;
  translatedName?: InputMaybe<ProductTranslatedStringInput>;
};

export type UpsertBankAccountInput = {
  bankAccountHolderName?: InputMaybe<Scalars['SafeString']['input']>;
  bankAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  bankAccountNumber: Scalars['SafeString']['input'];
  bankAccountTransitPhysicalAddress?: InputMaybe<BankAccountTransitPhysicalAddressInput>;
  currency?: InputMaybe<BankAccountCurrencyTypes>;
  institutionNumber?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<BankAccountUpsertIntegrationInput>>>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  routingNumber?: InputMaybe<Scalars['SafeString']['input']>;
  state?: InputMaybe<BankAccountStates>;
  transitNumber?: InputMaybe<Scalars['SafeString']['input']>;
  userId: Scalars['SafeString']['input'];
};

/**
 * Fund allocation on a model portfolio bulk upsert item.
 * financialProductId is the integration external id (SafeString), not a Mongo ObjectID.
 */
export type UpsertBranchInput = {
  financialProductId: Scalars['SafeString']['input'];
  isCashEquivalent?: InputMaybe<Scalars['Boolean']['input']>;
  percentage: Scalars['Float']['input'];
  taxRank?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertBulkTradeRunBulkTradeFilesResponse = {
  __typename?: 'UpsertBulkTradeRunBulkTradeFilesResponse';
  bulkTradeRun: BulkTradeRun;
};

export type UpsertCashAndHoldingInput = {
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  cashAvailableForTradeCents?: InputMaybe<Scalars['Long']['input']>;
  cashCents: Scalars['Long']['input'];
  cashOnHoldToTradeCents?: InputMaybe<Scalars['Long']['input']>;
  cashOnHoldToWithdrawCents?: InputMaybe<Scalars['Long']['input']>;
  currency: Currencies;
  holdings: Array<UpsertHoldingInput>;
  netContributionCents?: InputMaybe<Scalars['Long']['input']>;
  newContributionCents?: InputMaybe<Scalars['Long']['input']>;
  subAccountId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpsertClientGroupInput = {
  accountNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ObjectID']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<UserUpsertIntegrationInput>>>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  organizationId?: InputMaybe<Scalars['SafeString']['input']>;
  primaryUserId?: InputMaybe<Scalars['SafeString']['input']>;
  relationships?: InputMaybe<Array<InputMaybe<ClientGroupUpsertRelationshipInput>>>;
  state?: InputMaybe<ClientGroupStates>;
};

export type UpsertCustodianActivityInput = {
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  amountValueCents: Scalars['Float']['input'];
  associatedAccountIds?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  bookValueAmountCents?: InputMaybe<Scalars['Float']['input']>;
  clientName?: InputMaybe<Scalars['SafeString']['input']>;
  currency?: InputMaybe<Currencies>;
  custodianActivityId?: InputMaybe<Scalars['ObjectID']['input']>;
  effectiveDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  financialProductId?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<HoldingUpsertIntegrationInput>>>;
  parseDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  priceCents?: InputMaybe<Scalars['Float']['input']>;
  processDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  securityType?: InputMaybe<Scalars['SafeString']['input']>;
  settleDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  state?: InputMaybe<CustodianActivityStates>;
  subTransactionId?: InputMaybe<Scalars['SafeString']['input']>;
  taxes?: InputMaybe<Array<InputMaybe<CustodianActivityTaxInput>>>;
  tradeCurrency?: InputMaybe<Currencies>;
  transactionDesc?: InputMaybe<Scalars['SafeString']['input']>;
  transactionId?: InputMaybe<Scalars['SafeString']['input']>;
  transactionType?: InputMaybe<CustodianActivityTransactionTypes>;
  withholdingTaxAmountCents?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertCustodianCashAndHoldingsInput = {
  accountId: Scalars['SafeString']['input'];
  date: Scalars['GraphQLDate']['input'];
  holdings: Array<UpsertCustodianHoldingInput>;
};

export type UpsertCustodianHoldingInput = {
  bookValueCents?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currencies>;
  eodPriceCents?: InputMaybe<Scalars['Float']['input']>;
  financialProductId?: InputMaybe<Scalars['SafeString']['input']>;
  isCash?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  valueCents?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertFinancialProductInput = {
  assetClassBranches?: InputMaybe<Array<InputMaybe<UpsertAssetClassBranchInput>>>;
  assetClassLevel?: InputMaybe<AssetClassLevel>;
  autoUpdatePrices?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<Array<InputMaybe<UpsertBranchInput>>>;
  currency?: InputMaybe<Currencies>;
  currencyCurrentPriceCents?: InputMaybe<CurrencyPriceCentsInput>;
  currencyEodPriceCents?: InputMaybe<CurrencyPriceCentsInput>;
  currentPriceCents?: InputMaybe<Scalars['Float']['input']>;
  currentPriceCentsUpdatedAt?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  cusip?: InputMaybe<Scalars['SafeString']['input']>;
  eodPriceCents?: InputMaybe<Scalars['Float']['input']>;
  eodPriceCentsUpdatedAt?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  exchange?: InputMaybe<Scalars['String']['input']>;
  exchangeMic?: InputMaybe<Scalars['SafeString']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  forecastedRateOfReturn?: InputMaybe<Scalars['Float']['input']>;
  forecastedStandardDeviation?: InputMaybe<Scalars['Float']['input']>;
  foreignExchangeRate?: InputMaybe<Scalars['Float']['input']>;
  fundSeries?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<FinancialProductUpsertIntegrationInput>>>;
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  isin?: InputMaybe<Scalars['SafeString']['input']>;
  modelPortfolioType?: InputMaybe<ModelPortfolioTypes>;
  organizationId?: InputMaybe<Scalars['SafeString']['input']>;
  originalCurrentPriceCents?: InputMaybe<Scalars['Float']['input']>;
  primaryAssetClassId?: InputMaybe<Scalars['SafeString']['input']>;
  ric?: InputMaybe<Scalars['SafeString']['input']>;
  riskProfileDescription?: InputMaybe<ProductTranslatedStringInput>;
  riskProfileName?: InputMaybe<ProductTranslatedStringInput>;
  riskReturnLevel?: InputMaybe<Scalars['Int']['input']>;
  scheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  secondaryAssetClassId?: InputMaybe<Scalars['SafeString']['input']>;
  settlementDays?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<FinancialProductState>;
  strategy?: InputMaybe<FinancialProductStrategy>;
  targetAllocations?: InputMaybe<Array<InputMaybe<UpsertTargetAllocationInput>>>;
  taxRank?: InputMaybe<Scalars['Int']['input']>;
  tertiaryAssetClassId?: InputMaybe<Scalars['SafeString']['input']>;
  ticker?: InputMaybe<Scalars['SafeString']['input']>;
  translatedInvestmentObjective?: InputMaybe<ProductTranslatedStringInput>;
  translatedLiquidity?: InputMaybe<ProductTranslatedStringInput>;
  translatedName?: InputMaybe<ProductTranslatedStringInput>;
  translatedPortfolioDescription?: InputMaybe<ProductTranslatedStringInput>;
  translatedPortfolioDisclaimer?: InputMaybe<ProductTranslatedStringInput>;
  translatedThemeName?: InputMaybe<ProductTranslatedStringInput>;
  translatedUrl?: InputMaybe<ProductTranslatedStringInput>;
  type?: InputMaybe<SecurityTypes>;
  /** @deprecated url is deprecated, use translatedUrl instead */
  url?: InputMaybe<Scalars['String']['input']>;
  volatile?: InputMaybe<Scalars['Boolean']['input']>;
  waivedFeePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertFinancialProductSnapshotInput = {
  currency?: InputMaybe<Currencies>;
  date: Scalars['GraphQLDate']['input'];
  financialProductId: Scalars['SafeString']['input'];
  priceCents: Scalars['Float']['input'];
};

export type UpsertGoalInput = {
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  expectedAnnualIncomeCents?: InputMaybe<Scalars['Int']['input']>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  goalId?: InputMaybe<Scalars['ObjectID']['input']>;
  householdClientGroupId?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountUpsertIntegrationInput>>>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  retirementAge?: InputMaybe<Scalars['Int']['input']>;
  riskQuestion1?: InputMaybe<GoalRiskLevels>;
  state?: InputMaybe<GoalStates>;
  suitabilityScore?: InputMaybe<Scalars['Int']['input']>;
  targetAmountCents?: InputMaybe<Scalars['Long']['input']>;
  targetDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  taxOptimized?: InputMaybe<Scalars['Boolean']['input']>;
  timeHorizon?: InputMaybe<GoalTimeHorizons>;
  tradingProcess?: InputMaybe<PortfolioTradingProcesses>;
  type?: InputMaybe<GoalTypes>;
  userId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpsertHoldingInput = {
  /** Adjusted cost base at account level (in cents). */
  accountACB?: InputMaybe<Scalars['Float']['input']>;
  /** Book value at account level (in cents). */
  accountBookValue?: InputMaybe<Scalars['Float']['input']>;
  accountTaxLots?: InputMaybe<Array<InputMaybe<UpsertHoldingTaxLotInput>>>;
  adjustedCostBaseCents?: InputMaybe<Scalars['Float']['input']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  /** End of day price for the holding. */
  eodPriceCents?: InputMaybe<Scalars['Float']['input']>;
  financialProductId: Scalars['SafeString']['input'];
  isCashEquivalent?: InputMaybe<Scalars['Boolean']['input']>;
  /** ACB in account base currency (optional; for migration baselines). */
  nativeAccountACB?: InputMaybe<Scalars['Float']['input']>;
  /** Book value in account base currency (optional; for migration baselines). */
  nativeAccountBookValue?: InputMaybe<Scalars['Float']['input']>;
  priceCents: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type UpsertHoldingTaxLotInput = {
  date: Scalars['GraphQLDate']['input'];
  priceCents: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type UpsertOrganizationInput = {
  /**
   * Setting this on an existing organization updates OneVest only; the Auth0
   * organization metadata is refreshed the next time the organization is saved
   * through updateOrganization.
   */
  allowAccessToSubOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  browserTabTitle?: InputMaybe<Scalars['String']['input']>;
  disableStatsUpdateBasedOnTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  displayCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated entityName is deprecated, use translatedEntityName instead */
  entityName?: InputMaybe<Scalars['SafeString']['input']>;
  faviconLink?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated helpCentreUrl is deprecated, use translatedHelpCentreUrl instead */
  helpCentreUrl?: InputMaybe<Scalars['URLString']['input']>;
  hideAutoUpdatePrices?: InputMaybe<Scalars['Boolean']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<OrganizationUpsertIntegrationInput>>>;
  invitationRedirectUrl?: InputMaybe<Scalars['URLString']['input']>;
  /** @deprecated name is deprecated, use translatedName instead */
  name?: InputMaybe<Scalars['SafeString']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  subdomain?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated supportUrl is deprecated, use translatedSupportUrl instead */
  supportUrl?: InputMaybe<Scalars['URLString']['input']>;
  /** @deprecated termsAndConditionsUrl is deprecated, use translatedTermsAndConditionsUrl instead */
  termsAndConditionsUrl?: InputMaybe<Scalars['URLString']['input']>;
  translatedEntityName?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedHelpCentreUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedSupportUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedTermsAndConditionsUrl?: InputMaybe<OrganizationTranslatedStringInput>;
  useParentAdvisorContacts?: InputMaybe<Scalars['Boolean']['input']>;
  useParentAlertBanners?: InputMaybe<Scalars['Boolean']['input']>;
  useParentArticles?: InputMaybe<Scalars['Boolean']['input']>;
  useParentAssetClasses?: InputMaybe<Scalars['Boolean']['input']>;
  useParentBillingSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  useParentClientReportTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  useParentConfigurableTablePages?: InputMaybe<Scalars['Boolean']['input']>;
  useParentCustodianConnections?: InputMaybe<Scalars['Boolean']['input']>;
  useParentCustomAttributeLabels?: InputMaybe<Scalars['Boolean']['input']>;
  useParentCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  useParentDashboards?: InputMaybe<Scalars['Boolean']['input']>;
  useParentDisplayRoles?: InputMaybe<Scalars['Boolean']['input']>;
  useParentDowntimeSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  useParentFeeTiers?: InputMaybe<Scalars['Boolean']['input']>;
  useParentFormDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  useParentFormTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  useParentHomePageConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentIntegrations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentLocalizations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentModelPortfolios?: InputMaybe<Scalars['Boolean']['input']>;
  useParentNotificationDefinitions?: InputMaybe<Scalars['Boolean']['input']>;
  useParentNotificationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  useParentPageConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentPortfolioTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  useParentProductShelf?: InputMaybe<Scalars['Boolean']['input']>;
  useParentRepCodes?: InputMaybe<Scalars['Boolean']['input']>;
  useParentRoleProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  useParentSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  useParentSignerTypes?: InputMaybe<Scalars['Boolean']['input']>;
  useParentStaticPageWidgetConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  useParentThemeTokens?: InputMaybe<Scalars['Boolean']['input']>;
  useParentThemes?: InputMaybe<Scalars['Boolean']['input']>;
  useParentWebhooks?: InputMaybe<Scalars['Boolean']['input']>;
  useParentWorkflows?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertOrganizationRoleInput = {
  defaultAccessType?: InputMaybe<OrganizationUserAccessTypes>;
  externalRoleId?: InputMaybe<Scalars['SafeString']['input']>;
  organizationId: Scalars['ObjectID']['input'];
  roleProfileId: Scalars['ObjectID']['input'];
  roleType?: InputMaybe<RoleTypes>;
  /**
   * Re-applies the role profile template to an existing role. Defaults to false so organization specific
   * adjustments are not overwritten by a recurring sync.
   */
  syncTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  translatedDescription?: InputMaybe<OrganizationTranslatedStringInput>;
  translatedName?: InputMaybe<OrganizationTranslatedStringInput>;
};

export type UpsertOrganizationRoleResponse = {
  __typename?: 'UpsertOrganizationRoleResponse';
  role?: Maybe<Role>;
};

export type UpsertOrganizationUserInput = {
  accessType?: InputMaybe<OrganizationUserAccessTypes>;
  baseCurrency?: InputMaybe<CurrencyCodes>;
  defaultRoleType?: InputMaybe<OrganizationUserDefaultRoleTypes>;
  email?: InputMaybe<Scalars['SafeString']['input']>;
  entities?: InputMaybe<Array<InputMaybe<OrganizationUserUpsertRelationshipInput>>>;
  firstName?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<OrganizationUpsertIntegrationInput>>>;
  language?: InputMaybe<Languages>;
  lastName?: InputMaybe<Scalars['SafeString']['input']>;
  organizationId?: InputMaybe<Scalars['SafeString']['input']>;
  organizationUserId?: InputMaybe<Scalars['ObjectID']['input']>;
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  repCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  roleId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Resolves to the role provisioned from this role profile within the target organization. Ignored when roleId is provided. */
  roleProfileId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<OrganizationUserStates>;
};

export type UpsertPerformancePeriodMetricInput = {
  moneyWeightedReturn?: InputMaybe<Scalars['Float']['input']>;
  period?: InputMaybe<PerformancePeriods>;
  simpleReturnAmount?: InputMaybe<Scalars['Float']['input']>;
  simpleReturnPercent?: InputMaybe<Scalars['Float']['input']>;
  timeWeightedReturn?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertPerformanceSnapshotInput = {
  date: Scalars['GraphQLDate']['input'];
  objectId: Scalars['SafeString']['input'];
  objectType: PerformanceObjectTypes;
  periods: Array<UpsertPerformancePeriodMetricInput>;
  snapshotAt?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type UpsertRepCodeInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ObjectID']['input'];
};

export type UpsertRepCodeResponse = {
  __typename?: 'UpsertRepCodeResponse';
  repCode?: Maybe<RepCode>;
};

export type UpsertScheduledTransferInput = {
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  amountCents: Scalars['Long']['input'];
  bankAccountId: Scalars['SafeString']['input'];
  currency?: InputMaybe<Currencies>;
  endDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  frequency: Frequency;
  instantInvest?: InputMaybe<Scalars['Boolean']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<HoldingUpsertIntegrationInput>>>;
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  scheduledDate: Scalars['GraphQLDate']['input'];
  scheduledTransferId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<ScheduledTransferStates>;
  subAccountId?: InputMaybe<Scalars['SafeString']['input']>;
  type?: InputMaybe<TransferType>;
  withdrawalReason?: InputMaybe<WithdrawalReason>;
  withdrawalReasonDescription?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpsertStatsSnapshotHoldingInput = {
  adjustedCostBaseCents?: InputMaybe<Scalars['Float']['input']>;
  financialProductId: Scalars['SafeString']['input'];
  priceCents: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type UpsertStatsSnapshotInput = {
  accountBaseCurrency?: InputMaybe<HistoryCurrencies>;
  accountBaseCurrencyFxRate?: InputMaybe<Scalars['Float']['input']>;
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  cashOnHoldToTradeCents?: InputMaybe<Scalars['Long']['input']>;
  cashOnHoldToWithdrawCents?: InputMaybe<Scalars['Long']['input']>;
  currency: HistoryCurrencies;
  date: Scalars['GraphQLDate']['input'];
  holdings?: InputMaybe<Array<UpsertStatsSnapshotHoldingInput>>;
  marketValueCents: Scalars['Long']['input'];
  moneyAvailableCents?: InputMaybe<Scalars['Long']['input']>;
  netContributionCents?: InputMaybe<Scalars['Long']['input']>;
  newContributionCents?: InputMaybe<Scalars['Long']['input']>;
  organizationBaseCurrency?: InputMaybe<HistoryCurrencies>;
  organizationBaseCurrencyFxRate?: InputMaybe<Scalars['Float']['input']>;
  snapshotAt?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  subAccountId?: InputMaybe<Scalars['SafeString']['input']>;
};

export type UpsertSubAccountInput = {
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  allowClientDeposits?: InputMaybe<Scalars['Boolean']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  financialProductId?: InputMaybe<Scalars['ObjectID']['input']>;
  goalId?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<AccountUpsertIntegrationInput>>>;
  isPartial?: InputMaybe<Scalars['Boolean']['input']>;
  liquidated?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['SafeString']['input']>;
  skipIPS?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<SubAccountStates>;
  subAccountId?: InputMaybe<Scalars['ObjectID']['input']>;
  themeId?: InputMaybe<Scalars['ObjectID']['input']>;
  tradingProcess?: InputMaybe<SubAccountTradingProcesses>;
};

export type UpsertTargetAllocationInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
  secondaryAssetClassId: Scalars['SafeString']['input'];
};

export type UpsertTradeInput = {
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  actualQuantity?: InputMaybe<Scalars['Float']['input']>;
  actualTradePriceCents?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currencies>;
  description?: InputMaybe<Scalars['SafeString']['input']>;
  expectedQuantity?: InputMaybe<Scalars['Float']['input']>;
  expectedTradePriceCents?: InputMaybe<Scalars['Float']['input']>;
  failReason?: InputMaybe<Scalars['String']['input']>;
  financialProductId?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<HoldingUpsertIntegrationInput>>>;
  moneyAllocatedCents?: InputMaybe<Scalars['Float']['input']>;
  percentageFilled?: InputMaybe<Scalars['Int']['input']>;
  reconciledAt?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  settlementDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  state?: InputMaybe<TradeStates>;
  tradeDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  tradeId?: InputMaybe<Scalars['ObjectID']['input']>;
  type?: InputMaybe<TradeType>;
};

export type UpsertTransactionInput = {
  accountId?: InputMaybe<Scalars['SafeString']['input']>;
  adjustedCostBaseExecutionOrder?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Currencies>;
  custodianType?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<CustomFieldInput>>;
  date?: InputMaybe<Scalars['GraphQLDate']['input']>;
  description?: InputMaybe<Scalars['SafeString']['input']>;
  financialProductId?: InputMaybe<Scalars['SafeString']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<HoldingUpsertIntegrationInput>>>;
  pairId?: InputMaybe<Scalars['SafeString']['input']>;
  priceCents?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  redirectedFromAccountId?: InputMaybe<Scalars['SafeString']['input']>;
  settleDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  settleDateToWithdraw?: InputMaybe<Scalars['GraphQLDate']['input']>;
  subAccountId?: InputMaybe<Scalars['SafeString']['input']>;
  transactionId?: InputMaybe<Scalars['ObjectID']['input']>;
  type?: InputMaybe<TransactionTypes>;
  valueCents?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertUserInput = {
  /** Whether the user has advisor interest */
  advisorInterest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Advisor interest details */
  advisorInterestDetail?: InputMaybe<Scalars['String']['input']>;
  affiliateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Value of total amount User pays toward debts annually in amount cents. Used to determine risk suitability score. */
  annualDebtPaymentsCents?: InputMaybe<Scalars['Long']['input']>;
  /** Gross or net annual income of user's spouse in amount cents. . */
  annualIncomeCents?: InputMaybe<Scalars['Long']['input']>;
  /** Gross or net annual income in non-numeric form (range, category, etc). */
  annualIncomeStr?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  billingScheduleId?: InputMaybe<Scalars['ObjectID']['input']>;
  businessIsMemberofIIROC?: InputMaybe<Scalars['Boolean']['input']>;
  /** Business entity's corporate phone number. Must contain 7-15 digits, including country code (E.164 format).  */
  businessPhone?: InputMaybe<Scalars['SafeString']['input']>;
  charityRegistrationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  citizenships?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  closeAssociateOfPEP?: InputMaybe<Scalars['Boolean']['input']>;
  companyType?: InputMaybe<Scalars['SafeString']['input']>;
  complianceIssueSource?: InputMaybe<Scalars['SafeString']['input']>;
  complianceState?: InputMaybe<ComplianceStates>;
  countryOfRegistration?: InputMaybe<Scalars['SafeString']['input']>;
  /** Name of country using two-letter country code format (ISO 3166-1 alpha-2). Required for address validation, tax residency determination, and regulatory compliance. */
  countryOfTaxResidence?: InputMaybe<AddressCountries>;
  customFields?: InputMaybe<Array<InputMaybe<CustomFieldInput>>>;
  /** User's date of birth in YYYY-MM-DD (ISO 8601 format). */
  dateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Decedent's date of death in YYYY-MM-DD (ISO 8601 format). Used for estate planning and account management. */
  dateOfDeath?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** Types of debt associated with User. For example, student loan, mortgage, credit card debt, etc.  */
  debtAssociated?: InputMaybe<Array<InputMaybe<DebtAssociated>>>;
  discretionOverAccountGrantedReason?: InputMaybe<Scalars['String']['input']>;
  employerCompanyAddress?: InputMaybe<PhysicalAddressInput>;
  employerName?: InputMaybe<Scalars['SafeString']['input']>;
  employmentSituation?: InputMaybe<EmploymentSituation>;
  employmentSituationOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  entityName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date entity was established in YYYY-MM-DD (ISO 8601 format).  */
  establishedDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  fatcaStatus?: InputMaybe<FatcaStatus>;
  fatcaStatusOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated Use updateEntityFeeSetting instead. This field is a no-op. */
  feeTierId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Current market value of user's fixed, non-liquid assets in amount cents. */
  financialFixedAssetsCents?: InputMaybe<Scalars['Long']['input']>;
  /** User's liquid assets (cash or cash-equivalent investments) in amount cents. */
  financialLiquidAssetsCents?: InputMaybe<Scalars['Long']['input']>;
  firmNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** First name of user. */
  firstName?: InputMaybe<Scalars['SafeString']['input']>;
  foreignTaxExists?: InputMaybe<Scalars['Boolean']['input']>;
  foreignTaxInformation?: InputMaybe<Array<InputMaybe<ForeignTaxInformationInput>>>;
  gender?: InputMaybe<Scalars['SafeString']['input']>;
  hasCheckedPolicyAndCondition?: InputMaybe<Scalars['Boolean']['input']>;
  headOfInternationalOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  iDCheckCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  iDCheckRetrigger?: InputMaybe<Scalars['Boolean']['input']>;
  identificationType?: InputMaybe<Scalars['SafeString']['input']>;
  insiderSymbols?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  instructionsFromFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  integrations?: InputMaybe<Array<InputMaybe<UserUpsertIntegrationInput>>>;
  /** Whether the user trades with an investment firm */
  investmentFirmTrade?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the firm the user trades with */
  investmentFirmTradeName?: InputMaybe<Scalars['String']['input']>;
  investmentKnowledge?: InputMaybe<InvestmentKnowledge>;
  isAFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  isAccreditedInvestor?: InputMaybe<Scalars['Boolean']['input']>;
  isAffiliateOfFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  isEntityRegulated?: InputMaybe<Scalars['Boolean']['input']>;
  isForThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  isLargeCorporation?: InputMaybe<Scalars['Boolean']['input']>;
  isMemberOfIiroc?: InputMaybe<Scalars['Boolean']['input']>;
  isNonProfit?: InputMaybe<Scalars['Boolean']['input']>;
  isOfficerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerOfEntity?: InputMaybe<Scalars['Boolean']['input']>;
  isOwnerOfPublicCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicBody?: InputMaybe<Scalars['Boolean']['input']>;
  isRegisteredWithCRA?: InputMaybe<Scalars['Boolean']['input']>;
  isRelatedToAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  isReportingIssuer?: InputMaybe<Scalars['Boolean']['input']>;
  isVulnerablePerson?: InputMaybe<Scalars['Boolean']['input']>;
  issuerExchange?: InputMaybe<Scalars['SafeString']['input']>;
  issuerName?: InputMaybe<Scalars['SafeString']['input']>;
  issuerTicker?: InputMaybe<Scalars['SafeString']['input']>;
  jobTitle?: InputMaybe<Scalars['SafeString']['input']>;
  language?: InputMaybe<Languages>;
  /** Last name of user. */
  lastName?: InputMaybe<Scalars['SafeString']['input']>;
  lastSuitabilityReviewAt?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  /** Middle name of user. */
  middleName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date of user's next suitability assessment review in YYYY-MM-DD (ISO 8601 format). Triggers Know Your Client (KYC) process.  */
  nextSuitabilityReviewAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  numberOfDependents?: InputMaybe<Scalars['Long']['input']>;
  organizationId?: InputMaybe<Scalars['SafeString']['input']>;
  parentCompanyName?: InputMaybe<Scalars['SafeString']['input']>;
  payTaxesOutsideCanada?: InputMaybe<Scalars['Boolean']['input']>;
  /** String input that describes why User is a politically exposed person (PEP).  */
  pepReason?: InputMaybe<Scalars['String']['input']>;
  /** Phone number that contains 7-15 digits, including country code (E.164 format). */
  phone?: InputMaybe<Scalars['SafeString']['input']>;
  physicalAddress?: InputMaybe<PhysicalAddressInput>;
  politicallyExposedDomesticPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Defines if User is a politically exposed person (PEP) in a foreign country.  */
  politicallyExposedForeignPerson?: InputMaybe<Scalars['Boolean']['input']>;
  positionAtEntity?: InputMaybe<Scalars['SafeString']['input']>;
  powerOfAttorneyGranted?: InputMaybe<Scalars['Boolean']['input']>;
  preferredMethodOfCommunication?: InputMaybe<MethodOfCommunication>;
  preferredMethodOfCommunicationOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: InputMaybe<Scalars['SafeString']['input']>;
  readyToSignAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  receivesDonationsFromPublic?: InputMaybe<Scalars['Boolean']['input']>;
  registrationNumber?: InputMaybe<Scalars['SafeString']['input']>;
  regulatorName?: InputMaybe<Scalars['SafeString']['input']>;
  relatedEntities?: InputMaybe<Array<InputMaybe<UserUpsertRelatedEntityInput>>>;
  retirementAge?: InputMaybe<Scalars['Long']['input']>;
  /** Answer to the first risk question. Used to generate user suitability score. */
  riskQuestion1?: InputMaybe<RiskLevels>;
  /** Answer to the second risk question. Used to generate user suitability score. */
  riskQuestion2?: InputMaybe<RiskLevels>;
  riskScore?: InputMaybe<Scalars['Int']['input']>;
  secondaryEmail?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's secondary, alternate phone number. Must contain 7-15 digits, including country code (E.164 format). */
  secondaryPhone?: InputMaybe<Scalars['SafeString']['input']>;
  sin?: InputMaybe<Scalars['SafeString']['input']>;
  sourceOfFunds?: InputMaybe<Array<InputMaybe<UserSourceOfFunds>>>;
  sourceOfFundsOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  sourceOfWealth?: InputMaybe<Array<InputMaybe<UserSourceOfWealth>>>;
  sourceOfWealthOtherDescription?: InputMaybe<Scalars['SafeString']['input']>;
  spouseAddress?: InputMaybe<PhysicalAddressInput>;
  /** Gross or net annual income in amount cents of user's spouse. */
  spouseAnnualIncomeCents?: InputMaybe<Scalars['Long']['input']>;
  spouseCompanyType?: InputMaybe<Scalars['SafeString']['input']>;
  /** Date of birth for user's spouse in YYYY-MM-DD (ISO 8601 format). */
  spouseDateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  spouseEmail?: InputMaybe<Scalars['SafeString']['input']>;
  spouseEmployerName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Employment status of user's spouse */
  spouseEmploymentStatus?: InputMaybe<EmploymentStatus>;
  spouseEmploymentType?: InputMaybe<Scalars['SafeString']['input']>;
  /** First name of user's spouse. */
  spouseFirstName?: InputMaybe<Scalars['SafeString']['input']>;
  spouseJobTitle?: InputMaybe<Scalars['SafeString']['input']>;
  /** Last name of user's spouse. */
  spouseLastName?: InputMaybe<Scalars['SafeString']['input']>;
  /** Middle name of user's spouse. */
  spouseMiddleName?: InputMaybe<Scalars['SafeString']['input']>;
  /** @deprecated use spouseTaxId instead */
  spouseSin?: InputMaybe<Scalars['SafeString']['input']>;
  spouseTaxId?: InputMaybe<Scalars['String']['input']>;
  spouseTaxIdType?: InputMaybe<TaxIdTypes>;
  ssSymbols?: InputMaybe<Array<InputMaybe<Scalars['SafeString']['input']>>>;
  state?: InputMaybe<UserState>;
  studentAreaOfStudy?: InputMaybe<Scalars['SafeString']['input']>;
  suitabilityScore?: InputMaybe<Scalars['Long']['input']>;
  taxId?: InputMaybe<Scalars['SafeString']['input']>;
  taxIdType?: InputMaybe<TaxIdTypes>;
  taxNumber?: InputMaybe<Scalars['SafeString']['input']>;
  /** Timezone in IANA format (AREA/LOCATION).  */
  timezone?: InputMaybe<Scalars['SafeString']['input']>;
  title?: InputMaybe<UserTitle>;
  /** Total debt in amount cents. */
  totalDebtCents?: InputMaybe<Scalars['Long']['input']>;
  /** The name of the person with trading authority */
  tradingAuthorityName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user has granted trading authority over the account */
  tradingAuthorityOverAccountGranted?: InputMaybe<Scalars['Boolean']['input']>;
  trustedContactPerson?: InputMaybe<TrustedContactPersonInput>;
  type?: InputMaybe<EntityTypes>;
  typeOfTrust?: InputMaybe<TrustTypes>;
  uniqueCircumstances?: InputMaybe<Scalars['SafeString']['input']>;
  /** Whether the user uses borrowed money for investments */
  useBorrowedMoney?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Entity's fiscal year end date in YYYY-MM-DD (ISO 8601 format). Used for financial reporting and tax purposes.  */
  yearEnd?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

/** USA-specific withdrawal and contribution reasons */
export enum UsaContributionType {
  Conversion = 'CONVERSION',
  Employee = 'EMPLOYEE',
  Employer = 'EMPLOYER',
  Recharacterization = 'RECHARACTERIZATION',
  Regular = 'REGULAR',
  Repayment = 'REPAYMENT',
  Rollover_60Day = 'ROLLOVER_60_DAY',
  RolloverDirect = 'ROLLOVER_DIRECT',
  Transfer = 'TRANSFER',
  TrusteeFee = 'TRUSTEE_FEE'
}

export enum UsaWithdrawalReason {
  Death = 'DEATH',
  Disability = 'DISABILITY',
  DistributionConversion = 'DISTRIBUTION_CONVERSION',
  DistributionTransfer = 'DISTRIBUTION_TRANSFER',
  ExcessContributionRemovalAfterTaxDeadline = 'EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE',
  ExcessContributionRemovalBeforeTaxDeadline = 'EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE',
  IraDistributionTypeUnknown = 'IRA_DISTRIBUTION_TYPE_UNKNOWN',
  ManagementFee = 'MANAGEMENT_FEE',
  Normal = 'NORMAL',
  NormalRothIraGreaterThan_5Years = 'NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS',
  PlanLoan_401K = 'PLAN_LOAN_401_K',
  Premature = 'PREMATURE',
  PrematureSimpleIraLessThan_2Years = 'PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS',
  RecharacterizationCurrentYear = 'RECHARACTERIZATION_CURRENT_YEAR',
  RecharacterizationPriorYear = 'RECHARACTERIZATION_PRIOR_YEAR',
  RolloverToIra = 'ROLLOVER_TO_IRA',
  RolloverToQualifiedPlan = 'ROLLOVER_TO_QUALIFIED_PLAN',
  Sosepp = 'SOSEPP'
}

/** Type definition for User. */
export type User = {
  __typename?: 'User';
  /** OrganizationUsers allowed to access this entity */
  accessibleBy?: Maybe<Array<Maybe<EntityOrganizationUser>>>;
  accountGroups?: Maybe<Array<AccountGroup>>;
  accounts?: Maybe<Array<Account>>;
  activeWorkflowCompletions: Array<WorkflowCompletion>;
  advisorInterest?: Maybe<Scalars['Boolean']['output']>;
  advisorInterestDetail?: Maybe<Scalars['String']['output']>;
  /** User satisfies two conditions: is only affiliated with another user and is not directly associated to an account.   */
  affiliateOnly?: Maybe<Scalars['Boolean']['output']>;
  allIncompleteFormAgreements?: Maybe<Array<Maybe<IncompleteFormAgreement>>>;
  allLatestFormAgreements?: Maybe<Array<Maybe<FormAgreement>>>;
  /** User's alternate address. */
  alternateAddress?: Maybe<AlternatePhysicalAddress>;
  /** Value of total amount User pays toward debts annually in amount cents. Used to determine risk suitability score.  */
  annualDebtPaymentsCents?: Maybe<Scalars['Long']['output']>;
  /** Gross or net annual income of user's spouse in amount cents.  */
  annualIncomeCents?: Maybe<Scalars['Long']['output']>;
  /** Gross or net annual income in non-numeric form (range, category, etc).   */
  annualIncomeStr?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use feeSetting.applicableBillingSchedule instead */
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  /** @deprecated Use feeSetting.applicableFeeTier instead */
  applicableFeeTier?: Maybe<FeeTier>;
  availableCurrencies?: Maybe<Array<Maybe<AccountCurrencyTypes>>>;
  availableFinancialProducts?: Maybe<Array<FinancialProduct>>;
  bankAccounts?: Maybe<Array<BankAccount>>;
  /** @deprecated Use feeSetting instead */
  billingSchedule?: Maybe<BillingSchedule>;
  bulkAccountOpening?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use isMemberOfIiroc instead */
  businessIsMemberofIIROC?: Maybe<Scalars['Boolean']['output']>;
  /** Business entity's corporate phone number. Must contain 7-15 digits, including country code (E.164 format). */
  businessPhone?: Maybe<Scalars['String']['output']>;
  charityRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Citizenships of the User. */
  citizenships?: Maybe<Array<Scalars['String']['output']>>;
  /** Defines if User is a close associate of a politically exposed person (PEP).  */
  closeAssociateOfPEP?: Maybe<Scalars['Boolean']['output']>;
  /** The type of company at which the User is employed. */
  companyType?: Maybe<Scalars['String']['output']>;
  /** The date and time the user profile was completed. */
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  complianceIssueSource?: Maybe<Scalars['String']['output']>;
  complianceIssueSourceTranslated?: Maybe<UserTranslatedString>;
  complianceState?: Maybe<ComplianceStates>;
  complianceStateTranslated?: Maybe<UserTranslatedString>;
  /** Was the user converted from an affiliate invitation to a full user? */
  convertedFromAffiliateInvitation?: Maybe<Scalars['Boolean']['output']>;
  countryOfRegistration?: Maybe<Scalars['String']['output']>;
  /** Name of country using two-letter country code format (ISO 3166-1 alpha-2). Required for address validation, tax residency determination, and regulatory compliance. */
  countryOfTaxResidence?: Maybe<AddressCountries>;
  /** The date and time this User was created. */
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  custodianCustomFields?: Maybe<Array<Maybe<CustodianCustomField>>>;
  custodianSnapshotHistory?: Maybe<Array<Maybe<CustodianSnapshotHistory>>>;
  custodianStatistics?: Maybe<CustodianStatistics>;
  custodianSuitabilityScore?: Maybe<Scalars['Float']['output']>;
  customFields?: Maybe<Array<Maybe<UserCustomFieldValue>>>;
  /** User's date of birth in YYYY-MM-DD (ISO 8601 format).  */
  dateOfBirth?: Maybe<Scalars['GraphQLDate']['output']>;
  /** Decedent's date of death in YYYY-MM-DD (ISO 8601 format). Used for estate planning and account management purposes. */
  dateOfDeath?: Maybe<Scalars['GraphQLDate']['output']>;
  /** Types of debt associated with User. For example, student loan, mortgage, credit card debt, etc.   */
  debtAssociated?: Maybe<Array<Maybe<DebtAssociated>>>;
  discretionOverAccountGranted?: Maybe<Scalars['Boolean']['output']>;
  discretionOverAccountGrantedReason?: Maybe<Scalars['String']['output']>;
  employerCompanyAddress?: Maybe<PhysicalAddress>;
  /** User's workplace phone number. Must contain 7-15 digits, including country code (E.164 format). */
  employerCompanyPhone?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  employmentSituation?: Maybe<EmploymentSituation>;
  employmentSituationOtherDescription?: Maybe<Scalars['String']['output']>;
  /** User's employment situation in translated form (en, fr, etc..). */
  employmentSituationTranslated?: Maybe<UserTranslatedString>;
  /** User's employment status. */
  employmentStatus?: Maybe<EmploymentStatus>;
  /** User's employment status in translated form (en, fr, etc..). */
  employmentStatusTranslated?: Maybe<UserTranslatedString>;
  entityName?: Maybe<Scalars['String']['output']>;
  /** Date entity was established in YYYY-MM-DD (ISO 8601 format).  */
  establishedDate?: Maybe<Scalars['GraphQLDate']['output']>;
  fatcaStatus?: Maybe<FatcaStatus>;
  fatcaStatusOtherDescription?: Maybe<Scalars['String']['output']>;
  feeSetting?: Maybe<UserFeeSetting>;
  /** @deprecated Use feeSetting instead */
  feeTier?: Maybe<FeeTier>;
  /** Current market value of user's fixed, non-liquid assets in amount cents. */
  financialFixedAssetsCents?: Maybe<Scalars['Long']['output']>;
  /** User's liquid assets (cash or cash-equivalent investments) in amount cents. */
  financialLiquidAssetsCents?: Maybe<Scalars['Long']['output']>;
  firmNumber?: Maybe<Scalars['String']['output']>;
  /** First name of user. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Whether the user is subject to foreign tax */
  foreignTaxExists?: Maybe<Scalars['Boolean']['output']>;
  /** The tax information provided by the user if the user pays tax to a foreign country. */
  foreignTaxInformation?: Maybe<Array<Maybe<ForeignTaxInformation>>>;
  fraudRisk?: Maybe<FraudRisk>;
  /** User's gender: MALE, FEMALE or OTHER. */
  gender?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Array<Goal>>;
  hasCheckedPolicyAndCondition?: Maybe<Scalars['Boolean']['output']>;
  hasGuarantor?: Maybe<Scalars['Boolean']['output']>;
  /** Is/Was the User the head of an international organization? */
  headOfInternationalOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use households instead */
  household?: Maybe<ClientGroup>;
  households?: Maybe<Array<Maybe<ClientGroup>>>;
  iDCheckCompleted?: Maybe<Scalars['Boolean']['output']>;
  iDCheckRetrigger?: Maybe<Scalars['Boolean']['output']>;
  iDVerified?: Maybe<Scalars['Boolean']['output']>;
  /** UserID. */
  id: Scalars['ObjectID']['output'];
  identificationType?: Maybe<Scalars['String']['output']>;
  /** Date user became a resident of current province/state in YYYY-MM-DD (ISO 8601 format). Determines provincial tax residency and compliance requirements.  */
  inProvinceSince?: Maybe<Scalars['GraphQLDate']['output']>;
  /** List of required fields needed to transitionuser profile to a complete UserState. */
  incompleteFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Lists remaining forms to be signed for this user. */
  incompleteFormAgreements?: Maybe<Array<Maybe<IncompleteFormAgreement>>>;
  insiderSymbols: Array<Scalars['String']['output']>;
  instructionsFromFinancialEntity?: Maybe<Scalars['Boolean']['output']>;
  integrations?: Maybe<Array<Maybe<UserIntegration>>>;
  investmentFirmTrade?: Maybe<Scalars['Boolean']['output']>;
  investmentFirmTradeName?: Maybe<Scalars['String']['output']>;
  /** Describes user's investment knowledge. */
  investmentKnowledge?: Maybe<InvestmentKnowledge>;
  /** Custom description for user's investment knowledge. Used to display custom translated value for investment knowledge instead of the default hardcoded values.  */
  investmentKnowledgeDescription?: Maybe<UserTranslatedString>;
  /** Custom label for user's investment knowledge. Used to display custom translated value for investment knowledge instead of the default hardcoded values.  */
  investmentKnowledgeLabel?: Maybe<UserTranslatedString>;
  isAFinancialEntity?: Maybe<Scalars['Boolean']['output']>;
  /** Describes if client is an accredited investor. */
  isAccreditedInvestor?: Maybe<Scalars['Boolean']['output']>;
  isAffiliateOfFinancialEntity?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use isNonProfit instead */
  isEntityForProfit?: Maybe<Scalars['Boolean']['output']>;
  isEntityRegulated?: Maybe<Scalars['Boolean']['output']>;
  isForThirdParty?: Maybe<Scalars['Boolean']['output']>;
  isLargeCorporation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Is the user a member of IIROC?
   * IIROC:Investment Industry Regulatory Organization of Canada
   */
  isMemberOfIiroc?: Maybe<Scalars['Boolean']['output']>;
  isNonProfit?: Maybe<Scalars['Boolean']['output']>;
  /** Is the user a high-level management executive of a public company? */
  isOfficerOfPublicCompany?: Maybe<Scalars['Boolean']['output']>;
  isOwnerOfEntity?: Maybe<Scalars['Boolean']['output']>;
  /** Is the user the owner of a public company? */
  isOwnerOfPublicCompany?: Maybe<Scalars['Boolean']['output']>;
  isPublicBody?: Maybe<Scalars['Boolean']['output']>;
  isRegisteredWithCRA?: Maybe<Scalars['Boolean']['output']>;
  isRelatedToAdvisor?: Maybe<Scalars['Boolean']['output']>;
  isReportingIssuer?: Maybe<Scalars['Boolean']['output']>;
  isVulnerablePerson?: Maybe<Scalars['Boolean']['output']>;
  issuerExchange?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  issuerTicker?: Maybe<Scalars['String']['output']>;
  /** User's job title, if employed. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Language spoken by user.  */
  language?: Maybe<Languages>;
  /** Last name of user. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Date of last suitability review in MM/DD/YYYY format.  */
  lastSuitabilityReviewAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  /** Lists latest signed forms for this user. */
  latestFormAgreements?: Maybe<Array<Maybe<FormAgreement>>>;
  /** User's latest user identification ID. */
  latestIdVerification?: Maybe<IdVerification>;
  latestNsfs?: Maybe<Scalars['Int']['output']>;
  logs: LogsResponse;
  /** User's mailing address. */
  mailingAddress?: Maybe<PhysicalAddress>;
  /** Describes marital status of user.  */
  maritalStatus?: Maybe<MaritalStatus>;
  /** Middle name of user. */
  middleName?: Maybe<Scalars['String']['output']>;
  netWorthCents?: Maybe<Scalars['Long']['output']>;
  /** Date of user's next suitability assessment review in YYYY-MM-DD (ISO 8601 format). Triggers Know Your Client (KYC) process.  */
  nextSuitabilityReviewAt?: Maybe<Scalars['GraphQLDate']['output']>;
  /** Number of dependents associated with User. */
  numberOfDependents?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  otherPersonGuaranteeNames?: Maybe<Scalars['String']['output']>;
  parentCompanyName?: Maybe<Scalars['String']['output']>;
  /** External User Authentication Reference ID (Eg. ATB MembershipId). */
  partnerUserId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use foreignTaxInformation */
  payTaxesOutsideCanada?: Maybe<Scalars['Boolean']['output']>;
  /** String input that describes why User is a politically exposed person (PEP).  */
  pepReason?: Maybe<Scalars['String']['output']>;
  /** Phone number that contains 7-15 digits, including country code (E.164 format). */
  phone?: Maybe<Scalars['String']['output']>;
  /** User's address. */
  physicalAddress?: Maybe<PhysicalAddress>;
  /** Defines if User is a politically exposed person (PEP).  */
  politicallyExposedDomesticPerson?: Maybe<Scalars['Boolean']['output']>;
  /** Defines if User is a politically exposed person (PEP) in a foreign country.  */
  politicallyExposedForeignPerson?: Maybe<Scalars['Boolean']['output']>;
  positionAtEntity?: Maybe<Scalars['String']['output']>;
  /** Describes whether user has appointed a power of attorney (POA). */
  powerOfAttorneyGranted?: Maybe<Scalars['Boolean']['output']>;
  preferredMethodOfCommunication?: Maybe<MethodOfCommunication>;
  preferredMethodOfCommunicationOtherDescription?: Maybe<Scalars['String']['output']>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: Maybe<Scalars['String']['output']>;
  readyToSignAgreement?: Maybe<Scalars['Boolean']['output']>;
  receivesDonationsFromPublic?: Maybe<Scalars['Boolean']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  regulatorName?: Maybe<Scalars['String']['output']>;
  relatedEntities?: Maybe<Array<Maybe<RelatedEntity>>>;
  /** Expected retirement age.  */
  retirementAge?: Maybe<Scalars['Int']['output']>;
  /** Answer to the first risk question. Used to generate user suitability score.  */
  riskQuestion1?: Maybe<RiskLevels>;
  /** Custom label for user's risk question 1 answer. Used to display custom translated value for risk question 1 instead of the default hardcoded values.  */
  riskQuestion1Label?: Maybe<UserTranslatedString>;
  /** Answer to the second risk question. Used to generate user suitability score. */
  riskQuestion2?: Maybe<RiskLevels>;
  /** Custom label for user's risk question 2 answer. Used to display custom translated value for risk question 2 instead of the default hardcoded values.  */
  riskQuestion2Label?: Maybe<UserTranslatedString>;
  riskScore?: Maybe<Scalars['Int']['output']>;
  /**
   * Has the social insurance number (SIN) been informed?
   * @deprecated use taxIdExists instead
   */
  sinExists?: Maybe<Scalars['Boolean']['output']>;
  sourceOfFunds?: Maybe<Array<Maybe<UserSourceOfFunds>>>;
  sourceOfFundsOtherDescription?: Maybe<Scalars['String']['output']>;
  sourceOfWealth?: Maybe<Array<Maybe<UserSourceOfWealth>>>;
  sourceOfWealthOtherDescription?: Maybe<Scalars['String']['output']>;
  spouseAddress?: Maybe<PhysicalAddress>;
  /** Gross or net annual income of user's spouse in amount cents. */
  spouseAnnualIncomeCents?: Maybe<Scalars['Long']['output']>;
  /** Gross or net annual income in non-numeric form (range, category, etc) of user's spouse. */
  spouseAnnualIncomeStr?: Maybe<Scalars['String']['output']>;
  spouseAreaOfStudy?: Maybe<Scalars['String']['output']>;
  /** Legal status of spouse's company type, like LLC, S corps, C corps, etc.  */
  spouseCompanyType?: Maybe<Scalars['String']['output']>;
  /** Date of birth for User's spouse in YYYY-MM-DD (ISO 8601 format).  */
  spouseDateOfBirth?: Maybe<Scalars['GraphQLDate']['output']>;
  /** Spouse's email address. Email addresses must contain alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  spouseEmail?: Maybe<Scalars['String']['output']>;
  spouseEmployerCompanyAddress?: Maybe<PhysicalAddress>;
  /** Spouse's workplace phone number. Must contain 7-15 digits, including country code (E.164 format). */
  spouseEmployerCompanyPhone?: Maybe<Scalars['String']['output']>;
  spouseEmployerName?: Maybe<Scalars['String']['output']>;
  spouseEmploymentStatus?: Maybe<EmploymentStatus>;
  /** @deprecated Field no longer supported */
  spouseEmploymentType?: Maybe<Scalars['String']['output']>;
  /** First name of user's spouse. */
  spouseFirstName?: Maybe<Scalars['String']['output']>;
  /** User's spouse job title, if employed. */
  spouseJobTitle?: Maybe<Scalars['String']['output']>;
  /** Last name of user's spouse. */
  spouseLastName?: Maybe<Scalars['String']['output']>;
  /** Middle name of user's spouse. */
  spouseMiddleName?: Maybe<Scalars['String']['output']>;
  /** @deprecated use spouseTaxId instead */
  spouseSin?: Maybe<Scalars['String']['output']>;
  /** Spouse's tax identification number: SIN/BN (Canada), SSN/ITIN/EIN (United States). */
  spouseTaxId?: Maybe<Scalars['String']['output']>;
  /** Disclosed User's spouse Tax identification number: SIN/BN (Canada), SSN/ITIN/EIN (United States). */
  spouseTaxIdDisclosed?: Maybe<Scalars['String']['output']>;
  /** @deprecated Query actual spouseTaxId instead (redacted with stars) or spouseTaxIdDisclosed, needs read:client_taxid_disclosed permission) */
  spouseTaxIdExists?: Maybe<Scalars['Boolean']['output']>;
  spouseTaxIdType?: Maybe<TaxIdTypes>;
  /** User spouse's title. */
  spouseTitle?: Maybe<SpouseTitle>;
  ssSymbols: Array<Scalars['String']['output']>;
  /**
   * This transitions to COMPLETE if all the required fields for a user profile has been filled in.
   * Check User's "incompleteFields" to see what fields need to be completed
   */
  state: UserState;
  /**
   * List of all state changes.
   * @deprecated Use stateMachineChanges instead.
   */
  stateChanges?: Maybe<Array<Maybe<Scalars['StateChanges']['output']>>>;
  stateMachineChanges?: Maybe<Array<Maybe<UserStateMachineChanges>>>;
  statistics?: Maybe<Statistics>;
  /** Entity's ID returned as string. It can either be the OneVest ID or an External ID from a Passthrough API. */
  stringId: Scalars['String']['output'];
  /** Area of study, if User is a student. */
  studentAreaOfStudy?: Maybe<Scalars['String']['output']>;
  subAccounts?: Maybe<Array<SubAccount>>;
  suggestedFinancialProduct?: Maybe<FinancialProduct>;
  suitabilityReviewOverdue?: Maybe<Scalars['Boolean']['output']>;
  /** User's suitability score. */
  suitabilityScore?: Maybe<Scalars['Int']['output']>;
  /** Tax identification number: SIN/BN (Canada), SSN/ITIN/EIN (United States). See taxIdType. */
  taxId?: Maybe<Scalars['String']['output']>;
  /** Disclosed Tax identification number: SIN/BN (Canada), SSN/ITIN/EIN (United States). See taxIdType. */
  taxIdDisclosed?: Maybe<Scalars['String']['output']>;
  /**
   * Has the taxId been informed?
   * @deprecated Query actual taxId instead (redacted with stars) or taxIdDisclosed, needs read:client_taxid_disclosed permission
   */
  taxIdExists?: Maybe<Scalars['Boolean']['output']>;
  taxIdType?: Maybe<TaxIdTypes>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  thirdPartyName?: Maybe<Scalars['String']['output']>;
  /** Timezone in IANA format (AREA/LOCATION).  */
  timezone?: Maybe<Scalars['String']['output']>;
  /** User's Title. */
  title?: Maybe<UserTitle>;
  totalAssetsCents?: Maybe<Scalars['Long']['output']>;
  /** Total debt in amount cents.   */
  totalDebtCents?: Maybe<Scalars['Long']['output']>;
  tradingAuthorityName?: Maybe<Scalars['String']['output']>;
  tradingAuthorityOverAccountGranted?: Maybe<Scalars['Boolean']['output']>;
  /** User's trusted contact person. */
  trustedContactPerson?: Maybe<TrustedContactPerson>;
  type?: Maybe<EntityTypes>;
  typeOfTrust?: Maybe<Scalars['String']['output']>;
  uniqueCircumstances?: Maybe<Scalars['String']['output']>;
  /** The date and time this User's information was last updated. */
  updatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  useBorrowedMoney?: Maybe<Scalars['Boolean']['output']>;
  /** Entity's fiscal year end date in YYYY-MM-DD (ISO 8601 format). Used for financial reporting and tax purposes.  */
  yearEnd?: Maybe<Scalars['GraphQLDate']['output']>;
};


/** Type definition for User. */
export type UserAccessibleByArgs = {
  input?: InputMaybe<UserAccessibleByInput>;
};


/** Type definition for User. */
export type UserCustodianSnapshotHistoryArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<CustodianStatisticsInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


/** Type definition for User. */
export type UserCustodianStatisticsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<CustodianStatisticsInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


/** Type definition for User. */
export type UserCustomFieldsArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Type definition for User. */
export type UserLogsArgs = {
  input?: InputMaybe<UserLogsInput>;
};


/** Type definition for User. */
export type UserStatisticsArgs = {
  input?: InputMaybe<StatisticsInput>;
};

export type UserAccessibleByInput = {
  entityUserRelations?: InputMaybe<Array<InputMaybe<OrganizationUserEntityRelationTypes>>>;
  excludeEntityUsers?: InputMaybe<Scalars['Boolean']['input']>;
  excludeRepCodeUsers?: InputMaybe<Scalars['Boolean']['input']>;
  roleProfileIds?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
};

export type UserBilling = {
  __typename?: 'UserBilling';
  accounts?: Maybe<Array<AccountBilling>>;
  total: GroupedBillingTotal;
  user: User;
};

export type UserBulkUpsertItem = {
  __typename?: 'UserBulkUpsertItem';
  batchId?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertIntegration?: Maybe<Scalars['ObjectID']['output']>;
  bulkUpsertRequest?: Maybe<BulkUpsertRequest>;
  createdAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  integrations?: Maybe<Array<Maybe<UserIntegration>>>;
  oneVestId?: Maybe<Scalars['ObjectID']['output']>;
  outputErrors?: Maybe<Array<Maybe<UserBulkUpsertItemOutputError>>>;
  rawData?: Maybe<Scalars['Object']['output']>;
  state?: Maybe<UserBulkUpsertItemStates>;
};

export type UserBulkUpsertItemOutputError = {
  __typename?: 'UserBulkUpsertItemOutputError';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
};

export type UserBulkUpsertItemQueryFilter = {
  batchId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertIntegrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  bulkUpsertRequestId: Scalars['ObjectID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  oneVestId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<UserBulkUpsertItemStates>;
};

export enum UserBulkUpsertItemStates {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Queued = 'QUEUED'
}

export enum UserBulkUpsertItemTransition {
  Fail = 'fail',
  Process = 'process',
  Retry = 'retry'
}

export enum UserBulkUpsertRequestTransition {
  Cancel = 'cancel',
  Complete = 'complete',
  Fail = 'fail',
  PartiallyFail = 'partiallyFail',
  Process = 'process'
}

/** Filter a custom field by key. Provide exactly one of value or valueIn. */
export type UserCustomFieldQueryFilter = {
  /** Custom field key to filter on. */
  key: Scalars['SafeString']['input'];
  /**
   * Exact match — the stored custom field value must equal this value.
   * Mutually exclusive with valueIn.
   */
  value?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Match any — the stored custom field value must equal one of these values (OR / IN).
   * Mutually exclusive with value.
   */
  valueIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type UserCustomFieldSelectedOption = {
  __typename?: 'UserCustomFieldSelectedOption';
  displayText?: Maybe<UserTranslatedString>;
  value: Scalars['JSON']['output'];
};

export type UserCustomFieldValue = {
  __typename?: 'UserCustomFieldValue';
  customField?: Maybe<CustomField>;
  key: Scalars['String']['output'];
  selectedOptions?: Maybe<Array<Maybe<UserCustomFieldSelectedOption>>>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type UserFeeSetting = {
  __typename?: 'UserFeeSetting';
  applicableBillingSchedule?: Maybe<BillingSchedule>;
  applicableFeeTier?: Maybe<FeeTier>;
  billingSchedule?: Maybe<BillingSchedule>;
  feeTier?: Maybe<FeeTier>;
};

export type UserFilterInput = {
  affiliateUsersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  restrictToOrganizationId?: InputMaybe<Scalars['Boolean']['input']>;
  skippedUserIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  /** limits search to specific entity types */
  types?: InputMaybe<Array<InputMaybe<EntityTypes>>>;
};

/** Type definition for user's IdVerification */
export type UserIdVerificationResponse = {
  __typename?: 'UserIDVerificationResponse';
  /** idVerification Object */
  idVerification: IdVerification;
};

/** Input fields options to manage pagination and sorting for userIdVerfication Object */
export type UserIdVerificationPaginationAndSorting = {
  /**
   * The number of records to skip per page from the
   * beginning of the elements per page
   */
  offSet?: InputMaybe<Scalars['Int']['input']>;
  /** Elements per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** To sort in descending order or not */
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  /** To sort the list by the fields for the userIdVerfication object */
  sortField?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for userId verification filters */
export type UserIdVerificationQueryFilter = {
  /** Method of ID verification */
  methodOfIDVerification?: InputMaybe<IdVerificationMethods>;
  /** UserID  */
  userId: Scalars['ObjectID']['input'];
  /**
   * Date the ID was verified on in YYYY-MM-DD format.
   * It allows filtering dates on the calender after a selected date
   */
  verifiedAtAfter?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /**
   * Date the ID was verified on in YYYY-MM-DD format.
   * It allows filtering dates on the calender before a selected date
   */
  verifiedAtBefore?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

/** The integration enum and unique integration id  */
export type UserIntegration = {
  __typename?: 'UserIntegration';
  /** Attributes from the external system that are relevant for this document */
  externalData?: Maybe<Scalars['Object']['output']>;
  /** External system ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The id for the entity, in the given specific integration */
  iid: Scalars['String']['output'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: Maybe<Scalars['ObjectID']['output']>;
  /** Enumeration for the integration type  */
  type?: Maybe<UserIntegrationTypes>;
};

/** Input type for integrations field */
export type UserIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** group id the custodian connection */
  groupId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** iid is the unique identifier for this entity in the given integration */
  iid: Scalars['SafeString']['input'];
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** Integrations type derives from enumeration */
  type?: InputMaybe<UserIntegrationTypes>;
};

/** Integrations for User */
export enum UserIntegrationTypes {
  Apex = 'APEX',
  Atb = 'ATB',
  CibcMellon = 'CIBC_MELLON',
  Ciis = 'CIIS',
  CustomClient = 'CUSTOM_CLIENT',
  DriveWealth = 'DRIVE_WEALTH',
  Envestnet = 'ENVESTNET',
  Fc = 'FC',
  Flinks = 'FLINKS',
  Fundserv = 'FUNDSERV',
  Ibkr = 'IBKR',
  Nbin = 'NBIN',
  NoConnection = 'NO_CONNECTION',
  Pershing = 'PERSHING',
  Plaid = 'PLAID',
  Pwl = 'PWL',
  Rbc = 'RBC',
  Rbroker = 'RBROKER',
  Salesforce = 'SALESFORCE',
  Schwab = 'SCHWAB'
}

export type UserLogsInput = {
  filter?: InputMaybe<UserLogsQueryFilter>;
  pagination?: InputMaybe<PaginationAndSorting>;
};

export type UserLogsQueryFilter = {
  after?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  before?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  userOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserNotificationPreference = {
  __typename?: 'UserNotificationPreference';
  notificationGroup: NotificationGroup;
  preferences?: Maybe<NotificationPreference>;
};

export type UserNotificationPreferenceInput = {
  notificationGroupId: Scalars['ObjectID']['input'];
  preferences?: InputMaybe<NotificationPreferenceInput>;
};

export type UserOrganizationUserDisplayOptions = {
  __typename?: 'UserOrganizationUserDisplayOptions';
  account?: Maybe<Account>;
  advisorContact?: Maybe<AdvisorContact>;
  hide: Scalars['Boolean']['output'];
  id: Scalars['ObjectID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  organizationUser?: Maybe<OrganizationUser>;
  user: User;
};

/** Input fields options to manage pagination and sorting for user Object */
export type UserPaginationAndSorting = {
  /**
   * The number of records to skip per page from the
   * beginning of the elements per page
   */
  offSet?: InputMaybe<Scalars['Int']['input']>;
  /** Elements per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** To sort in descending order or not */
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  /** To sort the list by the fields for the user Object */
  sortField?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for filtering Users */
export type UserQueryFilter = {
  /** Filter users to only show affiliate users */
  affiliateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Date the user profile was completed
   * It allows filtering dates on the calender **after** a selected date
   */
  completedAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  /**
   * Date the user profile was completed
   * It allows filtering dates on the calender **before** a selected date
   */
  completedAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  complianceState?: InputMaybe<ComplianceStates>;
  /**
   * Filter users by custom field key/value pairs (AND logic).
   * Provide exactly one of value or valueIn per filter.
   */
  customFields?: InputMaybe<Array<UserCustomFieldQueryFilter>>;
  /** Used for date-based user searches in YYYY-MM-DD (ISO 8601 format)  */
  dateOfBirthAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  /** Used for date-based user searches in YYYY-MM-DD (ISO 8601 format).   */
  dateOfBirthBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  iDCheckCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  iDVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by integration external IDs (matches integrations.externalId) */
  integrationExternalIds?: InputMaybe<Array<Scalars['SafeString']['input']>>;
  /** Is the User profile complete? */
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  /** User ID on the Partner system that uses the OneVest embedded web-app */
  partnerUserId?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  /** Allows to search for a specific user by their first name, last name or email */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** User's Social Insurance Number */
  sin?: InputMaybe<Scalars['SafeString']['input']>;
  /** allows search users based on state */
  state?: InputMaybe<Array<InputMaybe<UserState>>>;
  suitabilityReviewDue?: InputMaybe<Scalars['Boolean']['input']>;
  /** allows search users among different entity types */
  types?: InputMaybe<Array<InputMaybe<EntityTypes>>>;
  /** returns records updated after the specified timestamp */
  updatedAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  /** returns records updated before the specified timestamp */
  updatedAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  /** Filter users by a list of IDs */
  userIds?: InputMaybe<Array<Scalars['SafeString']['input']>>;
};

export type UserRequiredToSign = {
  __typename?: 'UserRequiredToSign';
  id: Scalars['ObjectID']['output'];
  signedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  user: User;
};

export type UserSearchInput = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type UserSearchResult = {
  __typename?: 'UserSearchResult';
  totalCount: Scalars['Int']['output'];
  users: Array<User>;
};

export enum UserSourceOfFunds {
  Contributions = 'CONTRIBUTIONS',
  Debt = 'DEBT',
  Donations = 'DONATIONS',
  EmploymentIncome = 'EMPLOYMENT_INCOME',
  IncomeOrWorkingCapital = 'INCOME_OR_WORKING_CAPITAL',
  InheritancesAndGift = 'INHERITANCES_AND_GIFT',
  LotteryWinning = 'LOTTERY_WINNING',
  Other = 'OTHER',
  PensionRelease = 'PENSION_RELEASE',
  PersonalSavings = 'PERSONAL_SAVINGS',
  ProceedsFromInvestments = 'PROCEEDS_FROM_INVESTMENTS',
  PropertySale = 'PROPERTY_SALE',
  SaleOfLargeAsset = 'SALE_OF_LARGE_ASSET',
  SharesSalesAndDividends = 'SHARES_SALES_AND_DIVIDENDS'
}

export enum UserSourceOfWealth {
  BusinessOwnershipInterest = 'BUSINESS_OWNERSHIP_INTEREST',
  Debt = 'DEBT',
  EmploymentIncome = 'EMPLOYMENT_INCOME',
  FamilyEstate = 'FAMILY_ESTATE',
  Inheritance = 'INHERITANCE',
  Investment = 'INVESTMENT',
  LotteryWinning = 'LOTTERY_WINNING',
  Other = 'OTHER',
  PropertySale = 'PROPERTY_SALE',
  SaleOfLargeAsset = 'SALE_OF_LARGE_ASSET'
}

/** State of a user profile, where state indicates if a user completed required fields. */
export enum UserState {
  Active = 'ACTIVE',
  Frozen = 'FROZEN',
  Inactive = 'INACTIVE'
}

export type UserStateMachineChanges = {
  __typename?: 'UserStateMachineChanges';
  createdAt: Scalars['GraphQLDateTime']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

/** User's preferred honorific title.  */
export enum UserTitle {
  Dr = 'DR',
  Miss = 'MISS',
  Mr = 'MR',
  Mrs = 'MRS',
  Ms = 'MS'
}

/** Transition states for user's profile */
export enum UserTransition {
  Activate = 'activate',
  Deactivate = 'deactivate',
  Freeze = 'freeze'
}

export type UserTranslatedString = {
  __typename?: 'UserTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type UserUpdate = {
  __typename?: 'UserUpdate';
  d?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  o: Scalars['String']['output'];
  t: Scalars['GraphQLDateTime']['output'];
};

export type UserUpdatePaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserUpsertIntegrationInput = {
  /** Attributes from the external system that are relevant for this document */
  externalData?: InputMaybe<Scalars['Object']['input']>;
  /** externalId external source id */
  externalId?: InputMaybe<Scalars['SafeString']['input']>;
  /** Reference to the Integration document defined in organization-service */
  integrationId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type UserUpsertRelatedEntityInput = {
  entityId: Scalars['SafeString']['input'];
  relation: RelatedEntityTypes;
};

/** @deprecated(reason: "Not used anymore.") */
export type UsersDaily = {
  __typename?: 'UsersDaily';
  date: Scalars['GraphQLDateTime']['output'];
  holdings: Array<Holding>;
  id: Scalars['ObjectID']['output'];
  marketValueCents: Scalars['Long']['output'];
  moneyAvailableCents: Scalars['Long']['output'];
  netContributionCents: Scalars['Long']['output'];
  newContributionCents: Scalars['Long']['output'];
  user: User;
};

export type ValidateAgeOfMajorityResponse = {
  __typename?: 'ValidateAgeOfMajorityResponse';
  ageOfMajority: Scalars['Int']['output'];
  valid: Scalars['Boolean']['output'];
};

export type VerifySubTradeRequestsInput = {
  organizationId: Scalars['ObjectID']['input'];
  subTradeRequestIds: Array<Scalars['ObjectID']['input']>;
};

export type VerifyUserAndAddToAccountInput = {
  /** Account Id for the user */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** User's date of birth in YYYY-MM-DD (ISO 8601 format). */
  dateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  /** enabled attributes */
  enabledAttributes: Array<InputMaybe<Scalars['SafeString']['input']>>;
  /** User's first name. */
  firstName?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's last name. */
  lastName?: InputMaybe<Scalars['SafeString']['input']>;
  /** User's email address containing alphanumeric characters and allowed special symbols before the @ symbol, followed by a valid domain name. */
  primaryEmail?: InputMaybe<Scalars['SafeString']['input']>;
  /** UserID associated with the user who is going to verify */
  userId: Scalars['ID']['input'];
};

export type VerifyUserAndAddToAccountResponse = {
  __typename?: 'VerifyUserAndAddToAccountResponse';
  isVerified: Scalars['Boolean']['output'];
};

export enum VisibilityPrecedence {
  ContactSubjectOrgWide = 'CONTACT_SUBJECT_ORG_WIDE',
  ContactSubjectScoped = 'CONTACT_SUBJECT_SCOPED',
  DefaultVisible = 'DEFAULT_VISIBLE',
  UserSubjectOrgWide = 'USER_SUBJECT_ORG_WIDE',
  UserSubjectScoped = 'USER_SUBJECT_SCOPED'
}

export type Webhook = {
  __typename?: 'Webhook';
  /** Any custom headers that may need to be set to be sent with the mutation to the assigned url. */
  customHeaders?: Maybe<Scalars['Object']['output']>;
  /** Any custom payload that may need to be sent on the body along with the fetched data (REST type only). If informed, the fetched data will be sent as an object in the 'payload' attribute. */
  customPayloadAttributes?: Maybe<Scalars['Object']['output']>;
  /** The event type on the object that gets actioned to then send off the webhook. */
  eventType: Scalars['String']['output'];
  /** The graphql query string that would be used to query the OneVest partner gateway usually. The variable of '$id' is used for the actioned object. */
  gql: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  /** The name of the input that the webhook will pass, it will always pass as variable 'input' (GRAPHQL type only). */
  mutationInputName?: Maybe<Scalars['String']['output']>;
  /** The name of the mutation that the webhook will hit (GRAPHQL type only). */
  mutationName?: Maybe<Scalars['String']['output']>;
  /** The type of object you want to listen to, to receive a webhook on. */
  objectType: PublicEventObject;
  organization: Organization;
  publicOrganization?: Maybe<PublicOrganization>;
  /** Any custom header through which the signed JWT may need to be sent (REST type only). If not informed, the signed JWT will be sent in the 'OneVest-Authorization' header. */
  signedJwtHeader?: Maybe<Scalars['String']['output']>;
  /** Webhook type (GRAPHQL or REST) */
  type: WebhookTypes;
  /** GraphQL URL in which the webhook will hit. */
  url: Scalars['String']['output'];
};

export enum WebhookAuthenticationTypes {
  Bearer = 'BEARER'
}

export type WebhookInput = {
  apiToken?: InputMaybe<Scalars['String']['input']>;
  type: WebhookAuthenticationTypes;
  url: Scalars['String']['input'];
};

export type WebhookQueryFilter = {
  createdAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  eventType?: InputMaybe<EventType>;
  objectType?: InputMaybe<EventObject>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  type?: InputMaybe<WebhookTypes>;
};

/** Defines whether the data will sent as a Graphql request to a given mutationName or as REST POST request. */
export enum WebhookTypes {
  Graphql = 'GRAPHQL',
  Rest = 'REST'
}

export type Widget = {
  __typename?: 'Widget';
  /** Fields to display in the widget. */
  columns: Array<Scalars['String']['output']>;
  /** Filters for this widget only. Applied together with matching dashboard global filters. */
  filters: Array<WidgetFilter>;
  /** How numeric values are displayed (CENTS or FLOAT). */
  format: WidgetFormatTypes;
  /** How widget data is grouped and aggregated. */
  grouping: WidgetGrouping;
  /** How many grid rows the widget occupies. */
  height: Scalars['Int']['output'];
  /** Type of data this widget displays. Matching dashboard global filters also apply. */
  reportType: WidgetReportTypes;
  /** When true, sort descending. */
  sortDesc: Scalars['Boolean']['output'];
  /** Field used to sort widget data. */
  sortField: Scalars['String']['output'];
  /** @deprecated title is deprecated, use translatedTitle instead */
  title?: Maybe<Scalars['String']['output']>;
  translatedTitle?: Maybe<OrganizationTranslatedString>;
  /** Chart kind (NUMBER, PIE, LINE, or BAR). */
  type: WidgetChartTypes;
  /** How many grid columns the widget occupies. */
  width: Scalars['Int']['output'];
  /** Grid position. When omitted, the client chooses placement. */
  x?: Maybe<Scalars['Int']['output']>;
  /** Grid position. When omitted, the client chooses placement. */
  y?: Maybe<Scalars['Int']['output']>;
};

export enum WidgetChartTypes {
  Bar = 'BAR',
  Line = 'LINE',
  Number = 'NUMBER',
  Pie = 'PIE'
}

export type WidgetConfiguration = {
  __typename?: 'WidgetConfiguration';
  condition?: Maybe<PageConfigurationCondition>;
  constraints?: Maybe<Scalars['Object']['output']>;
  contextObject?: Maybe<ContextObjectTypes>;
  id: Scalars['ObjectID']['output'];
  options: Scalars['Object']['output'];
  type: WidgetConfigurationTypes;
};

export type WidgetConfigurationInput = {
  condition?: InputMaybe<PageConfigurationConditionInput>;
  contextObject?: InputMaybe<ContextObjectTypes>;
  options?: InputMaybe<Scalars['Object']['input']>;
  type: WidgetConfigurationTypes;
};

export enum WidgetConfigurationTypes {
  Access = 'ACCESS',
  Accounts = 'ACCOUNTS',
  AccountGroups = 'ACCOUNT_GROUPS',
  AdvisorContactInformation = 'ADVISOR_CONTACT_INFORMATION',
  AuditLog = 'AUDIT_LOG',
  BulkTradeRequests = 'BULK_TRADE_REQUESTS',
  ClientName = 'CLIENT_NAME',
  Compliance = 'COMPLIANCE',
  ConfigurableTableWidget = 'CONFIGURABLE_TABLE_WIDGET',
  Contacts = 'CONTACTS',
  CustomFieldsDisplay = 'CUSTOM_FIELDS_DISPLAY',
  DataWidget = 'DATA_WIDGET',
  Documents = 'DOCUMENTS',
  EditAccount = 'EDIT_ACCOUNT',
  EmploymentInformation = 'EMPLOYMENT_INFORMATION',
  Exposure = 'EXPOSURE',
  FeeDetails = 'FEE_DETAILS',
  FreeFormInput = 'FREE_FORM_INPUT',
  Goals = 'GOALS',
  GoalsAndAccounts = 'GOALS_AND_ACCOUNTS',
  GoalInformation = 'GOAL_INFORMATION',
  GoalSuitability = 'GOAL_SUITABILITY',
  Holdings = 'HOLDINGS',
  HouseholdModelPortfolio = 'HOUSEHOLD_MODEL_PORTFOLIO',
  HouseHoldMembers = 'HOUSE_HOLD_MEMBERS',
  IdVerification = 'ID_VERIFICATION',
  IncomeAssetsAndDebts = 'INCOME_ASSETS_AND_DEBTS',
  InitiateTransfer = 'INITIATE_TRANSFER',
  Layout = 'LAYOUT',
  Ledger = 'LEDGER',
  MarketValueChart = 'MARKET_VALUE_CHART',
  ModelPortfolioHoldings = 'MODEL_PORTFOLIO_HOLDINGS',
  NetWorth = 'NET_WORTH',
  NewsAndInsights = 'NEWS_AND_INSIGHTS',
  NextBestAction = 'NEXT_BEST_ACTION',
  NonIndividualInformation = 'NON_INDIVIDUAL_INFORMATION',
  Notes = 'NOTES',
  PersonalInformation = 'PERSONAL_INFORMATION',
  PersonsOfInterest = 'PERSONS_OF_INTEREST',
  Portfolio = 'PORTFOLIO',
  ProjectedIncomeReport = 'PROJECTED_INCOME_REPORT',
  RecentTransactions = 'RECENT_TRANSACTIONS',
  Refinitiv = 'REFINITIV',
  Relationships = 'RELATIONSHIPS',
  RelationshipInformation = 'RELATIONSHIP_INFORMATION',
  ResidencyInformation = 'RESIDENCY_INFORMATION',
  ReviewBankAccountInformation = 'REVIEW_BANK_ACCOUNT_INFORMATION',
  ScheduledTransfers = 'SCHEDULED_TRANSFERS',
  SubAccounts = 'SUB_ACCOUNTS',
  Suitability = 'SUITABILITY',
  TradeOrders = 'TRADE_ORDERS',
  Transfers = 'TRANSFERS',
  UpcomingTransactions = 'UPCOMING_TRANSACTIONS'
}

export type WidgetFilter = {
  __typename?: 'WidgetFilter';
  /** How the field is compared to the value. */
  comparison: WidgetFilterComparisonTypes;
  field: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** How a filter compares a field to its value. */
export enum WidgetFilterComparisonTypes {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanAgo = 'GREATER_THAN_AGO',
  In = 'IN',
  Includes = 'INCLUDES',
  LessThan = 'LESS_THAN',
  LessThanAgo = 'LESS_THAN_AGO',
  NotEquals = 'NOT_EQUALS',
  NotIncludes = 'NOT_INCLUDES',
  NotTextSearch = 'NOT_TEXT_SEARCH',
  TextSearch = 'TEXT_SEARCH'
}

export enum WidgetFormatTypes {
  Cents = 'CENTS',
  Float = 'FLOAT'
}

export type WidgetGrouping = {
  __typename?: 'WidgetGrouping';
  /** Field to group by. Used when type is GROUPING or a date grouping. */
  field?: Maybe<Scalars['String']['output']>;
  /** Time bucket for date grouping. Ignored for SINGLE_VALUE. */
  interval?: Maybe<WidgetInterval>;
  /** How results are grouped. SINGLE_VALUE returns one number; GROUPING, DATE, and FIRST_DATE_IN_INTERVAL return grouped results. */
  type: WidgetGroupingType;
  /** How to aggregate valueField (SUM, AVG, or VALUE_COUNT). */
  valueAggregation: WidgetValueAggregation;
  /** Field to aggregate. */
  valueField: Scalars['String']['output'];
};

export enum WidgetGroupingType {
  Date = 'DATE',
  FirstDateInInterval = 'FIRST_DATE_IN_INTERVAL',
  Grouping = 'GROUPING',
  SingleValue = 'SINGLE_VALUE'
}

export type WidgetInputFilter = {
  /** How the field is compared to the value. */
  comparison: WidgetFilterComparisonTypes;
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type WidgetInputGrouping = {
  /** Field to group by. Used when type is GROUPING or a date grouping. */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Time bucket for date grouping. Ignored for SINGLE_VALUE. */
  interval?: InputMaybe<WidgetInterval>;
  /** How results are grouped. SINGLE_VALUE returns one number; GROUPING, DATE, and FIRST_DATE_IN_INTERVAL return grouped results. */
  type: WidgetGroupingType;
  /** How to aggregate valueField (SUM, AVG, or VALUE_COUNT). */
  valueAggregation: WidgetValueAggregation;
  /** Field to aggregate. */
  valueField: Scalars['String']['input'];
};

export type WidgetInputType = {
  /** Fields to display in the widget. */
  columns: Array<Scalars['String']['input']>;
  /** Filters for this widget only. Applied together with matching dashboard global filters. */
  filters: Array<WidgetInputFilter>;
  /** How numeric values are displayed (CENTS or FLOAT). */
  format: WidgetFormatTypes;
  /** How widget data is grouped and aggregated. */
  grouping: WidgetInputGrouping;
  /** How many grid rows the widget occupies. */
  height: Scalars['Int']['input'];
  /** Type of data this widget displays. Matching dashboard global filters also apply. */
  reportType: WidgetReportTypes;
  /** When true, sort descending. */
  sortDesc: Scalars['Boolean']['input'];
  /** Field used to sort widget data. */
  sortField: Scalars['String']['input'];
  /** @deprecated title is deprecated, use translatedTitle instead */
  title?: InputMaybe<Scalars['String']['input']>;
  translatedTitle?: InputMaybe<OrganizationTranslatedStringInput>;
  /** Chart kind (NUMBER, PIE, LINE, or BAR). */
  type: WidgetChartTypes;
  /** How many grid columns the widget occupies. */
  width: Scalars['Int']['input'];
  /** Grid position. When omitted, the client chooses placement. */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Grid position. When omitted, the client chooses placement. */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export enum WidgetInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type WidgetOption = {
  __typename?: 'WidgetOption';
  customFieldFilter?: Maybe<Scalars['Object']['output']>;
  default: Scalars['Object']['output'];
  disabledIf?: Maybe<Scalars['Object']['output']>;
  info?: Maybe<OrganizationTranslatedString>;
  key: Scalars['String']['output'];
  label?: Maybe<OrganizationTranslatedString>;
  optionType: WidgetOptionTypes;
  options?: Maybe<Scalars['Object']['output']>;
  removeFromPages?: Maybe<Array<Maybe<PageConfigurationTypes>>>;
  replaceCustomField?: Maybe<Scalars['Boolean']['output']>;
  requiredIf?: Maybe<Scalars['Object']['output']>;
  showBasedOnCustodianConnection?: Maybe<Array<Maybe<Scalars['Object']['output']>>>;
  showCustomField?: Maybe<Scalars['Boolean']['output']>;
  showIf?: Maybe<Scalars['Object']['output']>;
  showWith?: Maybe<Scalars['String']['output']>;
};

export enum WidgetOptionTypes {
  Address = 'ADDRESS',
  Array = 'ARRAY',
  Attachment = 'ATTACHMENT',
  AutomatedBankingSelected = 'AUTOMATED_BANKING_SELECTED',
  BasicField = 'BASIC_FIELD',
  BasicOrSelectField = 'BASIC_OR_SELECT_FIELD',
  Boolean = 'BOOLEAN',
  Checkbox = 'CHECKBOX',
  ConfigurableTablePageSelectField = 'CONFIGURABLE_TABLE_PAGE_SELECT_FIELD',
  CountrySpecificTaxId = 'COUNTRY_SPECIFIC_TAX_ID',
  DraggableField = 'DRAGGABLE_FIELD',
  HtmlTemplate = 'HTML_TEMPLATE',
  LayoutSelectField = 'LAYOUT_SELECT_FIELD',
  OptionalTranslatedString = 'OPTIONAL_TRANSLATED_STRING',
  PlainTextField = 'PLAIN_TEXT_FIELD',
  RoleSelectField = 'ROLE_SELECT_FIELD',
  SchemaSearchField = 'SCHEMA_SEARCH_FIELD',
  SelectField = 'SELECT_FIELD',
  Table = 'TABLE',
  TitleField = 'TITLE_FIELD',
  TranslatedString = 'TRANSLATED_STRING',
  ValidatedTextField = 'VALIDATED_TEXT_FIELD',
  WorkflowSelectField = 'WORKFLOW_SELECT_FIELD'
}

export enum WidgetReportTypes {
  Account = 'ACCOUNT',
  ClientGroup = 'CLIENT_GROUP',
  DailyStats = 'DAILY_STATS',
  Goal = 'GOAL',
  SubAccount = 'SUB_ACCOUNT',
  Trade = 'TRADE',
  Transaction = 'TRANSACTION',
  Transfer = 'TRANSFER',
  User = 'USER'
}

export enum WidgetValueAggregation {
  Avg = 'AVG',
  Sum = 'SUM',
  ValueCount = 'VALUE_COUNT'
}

export type WithdrawAllAccountInput = {
  accountId: Scalars['ObjectID']['input'];
  bankAccountId: Scalars['ObjectID']['input'];
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  usaFederalTaxWithholdingPercentage?: InputMaybe<Scalars['Float']['input']>;
  usaStateTaxWithholdingPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type WithdrawAllAccountResponse = {
  __typename?: 'WithdrawAllAccountResponse';
  transfers?: Maybe<Array<Transfer>>;
};

export type WithdrawAllSubAccountInput = {
  bankAccountId: Scalars['ObjectID']['input'];
  requestId?: InputMaybe<Scalars['SafeString']['input']>;
  subAccountId: Scalars['ObjectID']['input'];
  usaFederalTaxWithholdingPercentage?: InputMaybe<Scalars['Float']['input']>;
  usaStateTaxWithholdingPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type WithdrawAllSubAccountResponse = {
  __typename?: 'WithdrawAllSubAccountResponse';
  transfer: Transfer;
};

export type WithdrawFee = {
  __typename?: 'WithdrawFee';
  amountCents?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<WithdrawFeeTypes>;
};

export enum WithdrawFeeTypes {
  Deregistration = 'DEREGISTRATION',
  DeregistrationTax = 'DEREGISTRATION_TAX',
  WithholdingTax = 'WITHHOLDING_TAX'
}

export enum WithdrawalMode {
  Gross = 'GROSS',
  Net = 'NET'
}

/** Withdrawal reasons. */
export enum WithdrawalReason {
  Car = 'CAR',
  CompletedMyGoal = 'COMPLETED_MY_GOAL',
  DissatisfiedWithOnevest = 'DISSATISFIED_WITH_ONEVEST',
  Education = 'EDUCATION',
  Emergency = 'EMERGENCY',
  HomeBuyersPlan = 'HOME_BUYERS_PLAN',
  House = 'HOUSE',
  InvestingIsNotForMe = 'INVESTING_IS_NOT_FOR_ME',
  LifelongLearningPlan = 'LIFELONG_LEARNING_PLAN',
  MajorPurchase = 'MAJOR_PURCHASE',
  Other = 'OTHER',
  ParentalLeave = 'PARENTAL_LEAVE',
  PoorReturns = 'POOR_RETURNS',
  RetirementIncome = 'RETIREMENT_INCOME',
  StartABusiness = 'START_A_BUSINESS',
  Vacation = 'VACATION',
  Wedding = 'WEDDING'
}

export type Workflow = WorkflowExtensionResource & {
  __typename?: 'Workflow';
  applicableRoleProfiles?: Maybe<Array<PublicRoleProfile>>;
  complex: Scalars['Boolean']['output'];
  createdAt: Scalars['GraphQLDateTime']['output'];
  eventType?: Maybe<Scalars['String']['output']>;
  extensionKey?: Maybe<Scalars['String']['output']>;
  extensionVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  name: WorkflowTranslatedString;
  objectType: WorkflowObjectTypes;
  organization?: Maybe<Organization>;
  publicOrganization?: Maybe<PublicOrganization>;
  resourceKey?: Maybe<Scalars['String']['output']>;
  settings: WorkflowSettings;
  state: WorkflowStates;
  steps: Array<Step>;
  totalSteps: Scalars['Int']['output'];
  triggerRules?: Maybe<Array<Maybe<TriggerRule>>>;
  triggerType: TriggerTypes;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  version: Scalars['Int']['output'];
};

export enum WorkflowActionTypes {
  SyncNetWorthAccountsFromPlaid = 'SYNC_NET_WORTH_ACCOUNTS_FROM_PLAID'
}

export enum WorkflowCombinator {
  And = 'and',
  Or = 'or'
}

export type WorkflowCompletion = {
  __typename?: 'WorkflowCompletion';
  context?: Maybe<Scalars['Object']['output']>;
  createdAt: Scalars['GraphQLDateTime']['output'];
  currentStep: Step;
  currentStepId: Scalars['ObjectID']['output'];
  currentSubStep: SubStep;
  currentSubStepId: Scalars['ObjectID']['output'];
  externalObjectId?: Maybe<Scalars['String']['output']>;
  formCompletions: Array<FormCompletion>;
  id: Scalars['ObjectID']['output'];
  object?: Maybe<WorkflowCompletionObject>;
  objectId?: Maybe<Scalars['String']['output']>;
  objectType: WorkflowObjectTypes;
  organization: Organization;
  parentWorkflowCompletionId?: Maybe<Scalars['ObjectID']['output']>;
  previousSteps?: Maybe<Array<PreviousStep>>;
  state: WorkflowCompletionStates;
  updatedAt: Scalars['GraphQLDateTime']['output'];
  /** The client the completion belongs to, derived from the object's owner when the completion is created. Null when there is no owning user (e.g. household completions, objects addressed by an external id, or older completions that were not backfilled). */
  user?: Maybe<User>;
  workflow: Workflow;
};

/** The entity a workflow completion runs against: a client (User), a household (ClientGroup), an account group (AccountGroup), an account (Account), a sub-account (SubAccount), or a goal (Goal). */
export type WorkflowCompletionObject = Account | AccountGroup | ClientGroup | Goal | SubAccount | User;

export type WorkflowCompletionPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowCompletionQueryFilter = {
  currentStepId?: InputMaybe<Scalars['ObjectID']['input']>;
  currentSubStepId?: InputMaybe<Scalars['ObjectID']['input']>;
  objectType?: InputMaybe<WorkflowObjectTypes>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<WorkflowCompletionStates>;
  updatedAtAfter?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  updatedAtBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ObjectID']['input']>;
};

export enum WorkflowCompletionStates {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED'
}

export enum WorkflowCompletionTransition {
  Cancel = 'cancel',
  Complete = 'complete'
}

export type WorkflowCondition = {
  __typename?: 'WorkflowCondition';
  ruleGroup?: Maybe<WorkflowRuleGroup>;
};

export enum WorkflowConditionCustomFieldType {
  AccountTypes = 'accountTypes',
  Boolean = 'boolean',
  Date = 'date',
  Jurisdiction = 'jurisdiction',
  MultiSelect = 'multiSelect',
  Number = 'number',
  Select = 'select',
  Text = 'text'
}

export type WorkflowConditionInput = {
  ruleGroup?: InputMaybe<WorkflowRuleGroupInput>;
};

export enum WorkflowConditionObjectType {
  Account = 'ACCOUNT',
  ClientGroup = 'CLIENT_GROUP',
  Goal = 'GOAL',
  SubAccount = 'SUB_ACCOUNT',
  Transfer = 'TRANSFER',
  User = 'USER'
}

/** Input type for filtering logs by a specific field in the 'workflowContext' object */
export type WorkflowContext = {
  stepId: Scalars['ObjectID']['input'];
  subStepId: Scalars['ObjectID']['input'];
  workflowCompletionId: Scalars['ObjectID']['input'];
};

export enum WorkflowContextObject {
  Account = 'ACCOUNT',
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  SubAccount = 'SUB_ACCOUNT',
  Transfer = 'TRANSFER'
}

/** Represents a resource that can be managed as part of an extension. */
export type WorkflowExtensionResource = {
  /** A unique key identifying the extension this resource belongs to. */
  extensionKey?: Maybe<Scalars['String']['output']>;
  /** The version of the extension when this resource was installed. */
  extensionVersion?: Maybe<Scalars['String']['output']>;
  /** A unique key for the resource within the scope of the extension. */
  resourceKey?: Maybe<Scalars['String']['output']>;
};

export enum WorkflowObjectTypes {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  Goal = 'GOAL',
  Household = 'HOUSEHOLD',
  SubAccount = 'SUB_ACCOUNT',
  User = 'USER'
}

export type WorkflowPaginationAndSorting = {
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowQueryFilter = {
  excludeRoleProfileFilter?: InputMaybe<Scalars['Boolean']['input']>;
  extensionKey?: InputMaybe<Scalars['String']['input']>;
  objectType?: InputMaybe<WorkflowObjectTypes>;
  organizationId?: InputMaybe<Scalars['ObjectID']['input']>;
  state?: InputMaybe<WorkflowStates>;
  states?: InputMaybe<Array<WorkflowStates>>;
};

export type WorkflowRuleGroup = {
  __typename?: 'WorkflowRuleGroup';
  combinator?: Maybe<WorkflowCombinator>;
  customFieldKey?: Maybe<Scalars['SafeString']['output']>;
  customFieldType?: Maybe<WorkflowConditionCustomFieldType>;
  field?: Maybe<Scalars['SafeString']['output']>;
  objectType?: Maybe<WorkflowConditionObjectType>;
  operator?: Maybe<WorkflowRuleGroupOperator>;
  rules?: Maybe<Array<Maybe<WorkflowRuleGroup>>>;
  value?: Maybe<Scalars['SafeString']['output']>;
};

export type WorkflowRuleGroupInput = {
  combinator?: InputMaybe<WorkflowCombinator>;
  customFieldKey?: InputMaybe<Scalars['SafeString']['input']>;
  customFieldType?: InputMaybe<WorkflowConditionCustomFieldType>;
  field?: InputMaybe<Scalars['SafeString']['input']>;
  objectType?: InputMaybe<WorkflowConditionObjectType>;
  operator?: InputMaybe<WorkflowRuleGroupOperator>;
  rules?: InputMaybe<Array<InputMaybe<WorkflowRuleGroupInput>>>;
  value?: InputMaybe<Scalars['SafeString']['input']>;
};

export enum WorkflowRuleGroupOperator {
  Contains = 'contains',
  EndsWith = 'endsWith',
  Equals = 'equals',
  Exists = 'exists',
  GreaterThan = 'greaterThan',
  GreaterThanOrEquals = 'greaterThanOrEquals',
  In = 'in',
  Includes = 'includes',
  IsAfter = 'isAfter',
  IsBefore = 'isBefore',
  IsEmpty = 'isEmpty',
  IsFalse = 'isFalse',
  IsNotEmpty = 'isNotEmpty',
  IsTrue = 'isTrue',
  LessThan = 'lessThan',
  LessThanOrEquals = 'lessThanOrEquals',
  NotContains = 'notContains',
  NotEquals = 'notEquals',
  NotExist = 'notExist',
  NotIn = 'notIn',
  NotIncludes = 'notIncludes',
  StartsWith = 'startsWith'
}

export type WorkflowSettings = {
  __typename?: 'WorkflowSettings';
  archiveObjectsOnClose: Scalars['Boolean']['output'];
  cancelOnClose: Scalars['Boolean']['output'];
  displayCloseButton: Scalars['Boolean']['output'];
};

export type WorkflowSettingsInput = {
  archiveObjectsOnClose?: InputMaybe<Scalars['Boolean']['input']>;
  cancelOnClose?: InputMaybe<Scalars['Boolean']['input']>;
  displayCloseButton?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WorkflowStates {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type WorkflowStepBranch = {
  __typename?: 'WorkflowStepBranch';
  condition?: Maybe<WorkflowCondition>;
  contextObject?: Maybe<WorkflowContextObject>;
  fromKey?: Maybe<Scalars['String']['output']>;
  subStepKey?: Maybe<Scalars['String']['output']>;
};

export type WorkflowStepBranchInput = {
  condition?: InputMaybe<WorkflowConditionInput>;
  contextObject?: InputMaybe<WorkflowContextObject>;
  fromKey?: InputMaybe<Scalars['String']['input']>;
  subStepKey?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkflowTransition {
  Activate = 'activate',
  Archive = 'archive',
  Draft = 'draft'
}

export type WorkflowTranslatedString = {
  __typename?: 'WorkflowTranslatedString';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
};

export type FetchCustodianTransactionTypesResponse = {
  __typename?: 'fetchCustodianTransactionTypesResponse';
  totalCount: Scalars['Int']['output'];
  types: Array<CustodianTransactionTypes>;
};

export type SetUserNotificationPreferencesInput = {
  organizationUserId: Scalars['ObjectID']['input'];
  userNotificationPreferences: Array<InputMaybe<UserNotificationPreferenceInput>>;
};

export type SetUserNotificationPreferencesResponse = {
  __typename?: 'setUserNotificationPreferencesResponse';
  organizationUser: OrganizationUser;
};

export type UpdateCustodianCustomFieldsResponse = {
  __typename?: 'updateCustodianCustomFieldsResponse';
  custodianCustomFields?: Maybe<Array<Maybe<CustodianCustomField>>>;
};

export type AddCurrencyDialogFetchAccountQueryVariables = Exact<{
  accountId: Scalars['SafeString']['input'];
  canReadAccountNumber: Scalars['Boolean']['input'];
}>;


export type AddCurrencyDialogFetchAccountQuery = { __typename?: 'Query', fetchAccount: { __typename?: 'FetchAccountResponse', account: { __typename?: 'Account', id: string, type: AccountTypes, state: AccountStates, baseCurrency?: AccountCurrencyTypes | null, availableCurrencies?: Array<AccountCurrencyTypes | null> | null, custodianAccountNumber?: string | null, organization: { __typename?: 'Organization', id: string }, custodianConnection?: { __typename?: 'CustodianConnection', id: string, name: string, type?: CustodianConnectionTypes | null, baseCurrency?: CustodianConnectionCurrencyTypes | null, organization?: { __typename?: 'PublicOrganization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } | null, accountTypeSettings?: Array<{ __typename?: 'AccountTypeSettings', type: CustodianConnectionAccountTypes, availableCurrencies: Array<CustodianConnectionCurrencyTypes | null> } | null> | null } | null, subAccounts?: Array<{ __typename?: 'SubAccount', id: string }> | null } } };

export type AddCurrencyMenuFetchAccountQueryVariables = Exact<{
  accountId: Scalars['SafeString']['input'];
}>;


export type AddCurrencyMenuFetchAccountQuery = { __typename?: 'Query', fetchAccount: { __typename?: 'FetchAccountResponse', account: { __typename?: 'Account', id: string, baseCurrency?: AccountCurrencyTypes | null, custodianConnection?: { __typename?: 'CustodianConnection', id: string, type?: CustodianConnectionTypes | null } | null } } };

export type AddCurrencyDialogFetchAccountCurrenciesQueryVariables = Exact<{
  accountId: Scalars['SafeString']['input'];
}>;


export type AddCurrencyDialogFetchAccountCurrenciesQuery = { __typename?: 'Query', fetchAccount: { __typename?: 'FetchAccountResponse', account: { __typename?: 'Account', id: string, availableCurrencies?: Array<AccountCurrencyTypes | null> | null } } };

export type AddCurrencyDialogFetchOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type AddCurrencyDialogFetchOrganizationQuery = { __typename?: 'Query', fetchOrganization: { __typename?: 'FetchOrganizationResponse', organization: { __typename?: 'Organization', id: string, productShelfCurrencies?: Array<CurrencyCodes | null> | null, useParentProductShelf: boolean, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, parent?: { __typename?: 'Organization', id: string } | null } } };

export type AddCurrencyDialogFetchHoldingsQueryVariables = Exact<{
  input: FetchHoldingsInput;
}>;


export type AddCurrencyDialogFetchHoldingsQuery = { __typename?: 'Query', fetchHoldings: { __typename?: 'FetchHoldingsResponse', holdings: Array<{ __typename?: 'StatisticHolding', isCash?: boolean | null, quantity?: number | null, financialProduct?: { __typename?: 'FinancialProduct', id: string, ticker?: string | null, originalCurrency?: Currencies | null } | null, originalCurrency?: { __typename?: 'StatisticHoldingOriginalCurrency', currency: StatisticsCurrencyTypes } | null }> } };

export type AddCurrencyDialogFetchSubAccountStatisticsQueryVariables = Exact<{
  subAccountId: Scalars['ObjectID']['input'];
  currency: StatisticsCurrencyTypes;
}>;


export type AddCurrencyDialogFetchSubAccountStatisticsQuery = { __typename?: 'Query', fetchSubAccount: { __typename?: 'FetchSubAccountResponse', subAccount: { __typename?: 'SubAccount', id: string, statistics?: { __typename?: 'Statistics', originalCurrencies?: Array<{ __typename?: 'StatisticOriginalCurrency', currency?: StatisticsCurrencyTypes | null, moneyAvailableCents?: number | null } | null> | null, originalCurrenciesMissingRate?: Array<{ __typename?: 'StatisticOriginalCurrency', currency?: StatisticsCurrencyTypes | null, moneyAvailableCents?: number | null } | null> | null, holdings?: Array<{ __typename?: 'StatisticHolding', isCash?: boolean | null, quantity?: number | null, financialProduct?: { __typename?: 'FinancialProduct', id: string } | null, originalCurrency?: { __typename?: 'StatisticHoldingOriginalCurrency', currency: StatisticsCurrencyTypes } | null }> | null } | null } } };

export type AddCurrencyDialogBulkUpsertAccountsMutationVariables = Exact<{
  input: BulkUpsertAccountsInput;
}>;


export type AddCurrencyDialogBulkUpsertAccountsMutation = { __typename?: 'Mutation', bulkUpsertAccounts: { __typename?: 'BulkUpsertAccountsResponse', bulkUpsertRequestId: string } };

export type AddCurrencyDialogUpdateAllHoldingsAndCashMutationVariables = Exact<{
  input: UpdateAllHoldingsAndCashInput;
}>;


export type AddCurrencyDialogUpdateAllHoldingsAndCashMutation = { __typename?: 'Mutation', updateAllHoldingsAndCash: { __typename?: 'UpdateAllHoldingsAndCashResponse', success: boolean } };

export type AddSecuritiesDialogSearchShelfQueryVariables = Exact<{
  input: FetchFinancialProductsInput;
}>;


export type AddSecuritiesDialogSearchShelfQuery = { __typename?: 'Query', fetchFinancialProducts: { __typename?: 'FetchFinancialProductsResponse', totalCount: number, financialProducts: Array<{ __typename?: 'FinancialProduct', id: string, ticker?: string | null, isCash?: boolean | null, exchange?: string | null, currency?: Currencies | null, currentPriceCents?: number | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, primaryAssetClass?: { __typename?: 'AssetClass', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, secondaryAssetClass?: { __typename?: 'AssetClass', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, tertiaryAssetClass?: { __typename?: 'AssetClass', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null }> } };

export type UseAssetClassColorsFetchRegistryQueryVariables = Exact<{
  input?: InputMaybe<FetchAssetClassesInput>;
}>;


export type UseAssetClassColorsFetchRegistryQuery = { __typename?: 'Query', fetchAssetClasses: { __typename?: 'FetchAssetClassesResponse', assetClasses: Array<{ __typename?: 'AssetClass', id: string, key: string, name: string }> } };

export type FetchBulkTraderTimestampQueryVariables = Exact<{
  bulkTraderId: Scalars['ObjectID']['input'];
}>;


export type FetchBulkTraderTimestampQuery = { __typename?: 'Query', fetchBulkTradeRun: { __typename?: 'FetchBulkTradeRunResponse', bulkTradeRun: { __typename?: 'BulkTradeRun', createdAt: string } } };

export type FormDefinitionOptionsFetchFormDefinitionsQueryVariables = Exact<{
  input: FetchFormDefinitionsInput;
}>;


export type FormDefinitionOptionsFetchFormDefinitionsQuery = { __typename?: 'Query', fetchFormDefinitions: { __typename?: 'FetchFormDefinitionsResponse', totalCount: number, formDefinitions: Array<{ __typename?: 'FormDefinition', id: string, key: string, objectType: FormDefinitionObjectTypes, translatedName: { __typename?: 'FormTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type UseHasHouseholdMenuItemsFetchPortfolioSettingQueryVariables = Exact<{
  clientGroupId: Scalars['SafeString']['input'];
}>;


export type UseHasHouseholdMenuItemsFetchPortfolioSettingQuery = { __typename?: 'Query', fetchClientGroup: { __typename?: 'FetchClientGroupResponse', clientGroup?: { __typename?: 'ClientGroup', id: string, organization?: { __typename?: 'Organization', id: string, allowPortfolioPerHousehold?: boolean | null } | null } | null } };

export type UseArchiveHouseholdCopyArchiveEntityBoundModelMutationVariables = Exact<{
  input: ArchiveEntityBoundModelInput;
}>;


export type UseArchiveHouseholdCopyArchiveEntityBoundModelMutation = { __typename?: 'Mutation', archiveEntityBoundModel: { __typename?: 'ArchiveEntityBoundModelResponse', archived: boolean, modelPortfolio?: { __typename?: 'FinancialProduct', id: string, state: FinancialProductState } | null } };

export type AppBarAvatarMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AppBarAvatarMeQuery = { __typename?: 'Query', me: { __typename?: 'OrganizationUser', avatar?: string | null, firstName: string, lastName?: string | null } };

export type ChangeAvatarModalMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ChangeAvatarModalMeQuery = { __typename?: 'Query', me: { __typename?: 'OrganizationUser', id: string, avatar?: string | null } };

export type ChangeAvatarModalFetchFileUploadUrlQueryVariables = Exact<{
  input: FetchFileUploadUrlInput;
}>;


export type ChangeAvatarModalFetchFileUploadUrlQuery = { __typename?: 'Query', fetchFileUploadUrl?: { __typename?: 'FetchFileUploadUrlResponse', temporarySignedURL?: string | null, timestamp?: number | null } | null };

export type ChangeAvatarModalCreateFileDocumentMutationVariables = Exact<{
  input: CreateFileDocumentInput;
}>;


export type ChangeAvatarModalCreateFileDocumentMutation = { __typename?: 'Mutation', createFileDocument: { __typename?: 'CreateFileDocumentResponse', fileDocument?: { __typename?: 'FileDocument', id: string } | null } };

export type ChangeAvatarModalDeleteFileDocumentMutationVariables = Exact<{
  fileDocumentId: Scalars['ObjectID']['input'];
}>;


export type ChangeAvatarModalDeleteFileDocumentMutation = { __typename?: 'Mutation', deleteFileDocument: { __typename?: 'DeleteFileDocumentResponse', fileDocument?: { __typename?: 'FileDocument', id: string } | null } };

export type ChangeAvatarModalUpdateOrganizationUserProfileMutationVariables = Exact<{
  input: UpdateOrganizationUserProfileInput;
}>;


export type ChangeAvatarModalUpdateOrganizationUserProfileMutation = { __typename?: 'Mutation', updateOrganizationUserProfile: { __typename?: 'UpdateOrganizationUserProfileResponse', organizationUser?: { __typename?: 'OrganizationUser', id: string, avatar?: string | null } | null } };

export type LanguageSelectionModalUpdateOrganizationUserProfileMutationVariables = Exact<{
  input: UpdateOrganizationUserProfileInput;
}>;


export type LanguageSelectionModalUpdateOrganizationUserProfileMutation = { __typename?: 'Mutation', updateOrganizationUserProfile: { __typename?: 'UpdateOrganizationUserProfileResponse', organizationUser?: { __typename?: 'OrganizationUser', id: string, language?: Languages | null } | null } };

export type NewOrganizationModalCreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type NewOrganizationModalCreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'CreateOrganizationResponse', organization?: { __typename?: 'Organization', id: string } | null } };

export type NotificationPreferencesModalSetUserNotificationPreferencesMutationVariables = Exact<{
  input: SetUserNotificationPreferencesInput;
}>;


export type NotificationPreferencesModalSetUserNotificationPreferencesMutation = { __typename?: 'Mutation', setUserNotificationPreferences: { __typename?: 'setUserNotificationPreferencesResponse', organizationUser: { __typename?: 'OrganizationUser', id: string } } };

export type NotificationsFieldsFragment = { __typename?: 'Notification', id: string, read: boolean, link?: string | null, createdAt: string, title: { __typename?: 'NotificationTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, body: { __typename?: 'NotificationTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, linkText?: { __typename?: 'NotificationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null };

export type CustodianNotificationsFieldsFragment = { __typename?: 'CustodianNotification', id?: string | null, read?: boolean | null, link?: string | null, createdAt?: string | null, title?: { __typename?: 'CustodianTranslatedString', en: string, fr?: string | null, es?: string | null } | null, body?: { __typename?: 'CustodianTranslatedString', en: string, fr?: string | null, es?: string | null } | null, linkText?: { __typename?: 'CustodianTranslatedString', en: string, fr?: string | null, es?: string | null } | null };

export type NotificationsFetchNotificationsQueryVariables = Exact<{
  input: FetchNotificationsInput;
}>;


export type NotificationsFetchNotificationsQuery = { __typename?: 'Query', fetchNotifications: { __typename?: 'FetchNotificationsResponse', totalCount: number, notifications: Array<{ __typename?: 'Notification', id: string, read: boolean, link?: string | null, createdAt: string, title: { __typename?: 'NotificationTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, body: { __typename?: 'NotificationTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, linkText?: { __typename?: 'NotificationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }> } };

export type NotificationsFetchCustodianNotificationsQueryVariables = Exact<{
  input: FetchCustodianNotificationsInput;
}>;


export type NotificationsFetchCustodianNotificationsQuery = { __typename?: 'Query', fetchCustodianNotifications: { __typename?: 'FetchCustodianNotificationsResponse', totalCount: number, notifications: Array<{ __typename?: 'CustodianNotification', id?: string | null, read?: boolean | null, link?: string | null, createdAt?: string | null, title?: { __typename?: 'CustodianTranslatedString', en: string, fr?: string | null, es?: string | null } | null, body?: { __typename?: 'CustodianTranslatedString', en: string, fr?: string | null, es?: string | null } | null, linkText?: { __typename?: 'CustodianTranslatedString', en: string, fr?: string | null, es?: string | null } | null }> } };

export type NotificationsMarkAsReadMutationVariables = Exact<{
  input: MarkNotificationAsReadInput;
}>;


export type NotificationsMarkAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: boolean };

export type NotificationsMarkAllAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationsMarkAllAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: boolean };

export type OrganizationLogoFetchFileDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<FileDocumentQueryFilter>;
}>;


export type OrganizationLogoFetchFileDocumentsQuery = { __typename?: 'Query', fetchFileDocuments: { __typename?: 'FetchFileDocumentsResponse', fileDocuments: Array<{ __typename?: 'FileDocument', id: string, name?: string | null }> } };

export type OrganizationSwitcherSearchOrganizationsQueryVariables = Exact<{
  input: FetchOrganizationsInput;
}>;


export type OrganizationSwitcherSearchOrganizationsQuery = { __typename?: 'Query', fetchOrganizations: { __typename?: 'FetchOrganizationsResponse', organizations: Array<{ __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, parents: Array<{ __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }> }> } };

export type OrganizationSwitcherFetchInitialOrganizationsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type OrganizationSwitcherFetchInitialOrganizationsQuery = { __typename?: 'Query', fetchOrganization: { __typename?: 'FetchOrganizationResponse', organization: { __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, parents: Array<{ __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, parent?: { __typename?: 'Organization', id: string } | null, children: Array<{ __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, children: Array<{ __typename?: 'Organization', id: string }> }> }> } } };

export type OrganizationSwitcherFetchChildOrganizationsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type OrganizationSwitcherFetchChildOrganizationsQuery = { __typename?: 'Query', fetchOrganization: { __typename?: 'FetchOrganizationResponse', organization: { __typename?: 'Organization', id: string, children: Array<{ __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, children: Array<{ __typename?: 'Organization', id: string }> }> } } };

export type AlertBannerInteractionFieldsFragment = { __typename?: 'AlertBannerInteraction', id: string, alertBanner: { __typename?: 'AlertBanner', id: string, name?: string | null, bannerType?: BannerType | null, persistenceBehaviour: PersistenceBehaviour, createdAt: string, bannerCopy?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, configuration: { __typename?: 'AlertConfiguration', displayOnWeb: boolean, displayOnIOS: boolean, displayOnAndroid: boolean, makeDismissible: boolean, enableAction: boolean }, actionButton?: { __typename?: 'ActionButton', url?: string | null, label?: string | null } | null } };

export type AlertBannerFetchVisibleAlertBannersQueryVariables = Exact<{
  input: FetchVisibleAlertBannersInput;
}>;


export type AlertBannerFetchVisibleAlertBannersQuery = { __typename?: 'Query', fetchVisibleAlertBanners: { __typename?: 'FetchVisibleAlertBannersResponse', totalCount: number, visibleAlertBanners: Array<{ __typename?: 'AlertBanner', id: string }> } };

export type AlertBannerUpsertAlertBannerInteractionsMutationVariables = Exact<{
  input: UpsertAlertBannerInteractionsInput;
}>;


export type AlertBannerUpsertAlertBannerInteractionsMutation = { __typename?: 'Mutation', upsertAlertBannerInteractions: { __typename?: 'UpsertAlertBannerInteractionsResponse', alertBannerInteractions: Array<{ __typename?: 'AlertBannerInteraction', id: string, alertBanner: { __typename?: 'AlertBanner', id: string, name?: string | null, bannerType?: BannerType | null, persistenceBehaviour: PersistenceBehaviour, createdAt: string, bannerCopy?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, configuration: { __typename?: 'AlertConfiguration', displayOnWeb: boolean, displayOnIOS: boolean, displayOnAndroid: boolean, makeDismissible: boolean, enableAction: boolean }, actionButton?: { __typename?: 'ActionButton', url?: string | null, label?: string | null } | null } }> } };

export type AlertBannerTransitionAlertBannerInteractionMutationVariables = Exact<{
  input: TransitionAlertBannerInteractionInput;
}>;


export type AlertBannerTransitionAlertBannerInteractionMutation = { __typename?: 'Mutation', transitionAlertBannerInteraction: { __typename?: 'TransitionAlertBannerInteractionResponse', alertBannerInteraction: { __typename?: 'AlertBannerInteraction', id: string } } };

export type ModelPortfolioSearchFieldOptionFragment = { __typename?: 'FinancialProduct', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } };

export type ModelPortfolioSearchFieldSearchModelPortfoliosQueryVariables = Exact<{
  input: FetchModelPortfoliosInput;
}>;


export type ModelPortfolioSearchFieldSearchModelPortfoliosQuery = { __typename?: 'Query', fetchModelPortfolios: { __typename?: 'FetchModelPortfoliosResponse', totalCount: number, modelPortfolios: Array<{ __typename?: 'FinancialProduct', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type ModelPortfolioSearchFieldFetchSelectedModelPortfolioQueryVariables = Exact<{
  modelPortfolioId: Scalars['ObjectID']['input'];
}>;


export type ModelPortfolioSearchFieldFetchSelectedModelPortfolioQuery = { __typename?: 'Query', fetchModelPortfolio: { __typename?: 'FetchModelPortfolioResponse', modelPortfolio: { __typename?: 'FinancialProduct', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } } };

export type CreateRepCodeMutationVariables = Exact<{
  input: CreateRepCodeInput;
}>;


export type CreateRepCodeMutation = { __typename?: 'Mutation', createRepCode: { __typename?: 'CreateRepCodeResponse', repCode?: { __typename?: 'RepCode', code: string } | null } };

export type UpdateRepCodeMutationVariables = Exact<{
  input: UpdateRepCodeInput;
}>;


export type UpdateRepCodeMutation = { __typename?: 'Mutation', updateRepCode: { __typename?: 'UpdateRepCodeResponse', repCode?: { __typename?: 'RepCode', code: string } | null } };

export type TransitionRepCodeMutationVariables = Exact<{
  input: TransitionRepCodeInput;
}>;


export type TransitionRepCodeMutation = { __typename?: 'Mutation', transitionRepCode: { __typename?: 'TransitionRepCodeResponse', repCode?: { __typename?: 'RepCode', code: string } | null } };

export type SecuritySearchSelectSearchSecuritiesQueryVariables = Exact<{
  input: FetchFinancialProductsInput;
}>;


export type SecuritySearchSelectSearchSecuritiesQuery = { __typename?: 'Query', fetchFinancialProducts: { __typename?: 'FetchFinancialProductsResponse', totalCount: number, financialProducts: Array<{ __typename?: 'FinancialProduct', id: string, ticker?: string | null, isCash?: boolean | null, taxRank?: number | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, primaryAssetClass?: { __typename?: 'AssetClass', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, secondaryAssetClass?: { __typename?: 'AssetClass', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, tertiaryAssetClass?: { __typename?: 'AssetClass', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null }> } };

export type WorkflowLauncherFetchWorkflowObjectTypeQueryVariables = Exact<{
  workflowId: Scalars['ObjectID']['input'];
}>;


export type WorkflowLauncherFetchWorkflowObjectTypeQuery = { __typename?: 'Query', fetchWorkflow: { __typename?: 'FetchWorkflowResponse', workflow: { __typename?: 'Workflow', id: string, objectType: WorkflowObjectTypes } } };

export type WorkflowLauncherCreateWorkflowCompletionMutationVariables = Exact<{
  input: CreateWorkflowCompletionInput;
}>;


export type WorkflowLauncherCreateWorkflowCompletionMutation = { __typename?: 'Mutation', createWorkflowCompletion: { __typename?: 'CreateWorkflowCompletionResponse', workflowCompletion: { __typename?: 'WorkflowCompletion', id: string } } };

export type SearchPhysicalAddressQueryVariables = Exact<{
  input: SearchPhysicalAddressInput;
}>;


export type SearchPhysicalAddressQuery = { __typename?: 'Query', searchPhysicalAddress: { __typename?: 'SearchPhysicalAddressResponse', suggestions: Array<{ __typename?: 'AddressSuggestion', id: string, text: string, next?: string | null }> } };

export type FetchPhysicalAddressQueryVariables = Exact<{
  input: FetchPhysicalAddressInput;
}>;


export type FetchPhysicalAddressQuery = { __typename?: 'Query', fetchPhysicalAddress: { __typename?: 'FetchPhysicalAddressResponse', addressDetails: { __typename?: 'AddressDetails', houseNumber?: string | null, unitNumber?: string | null, streetName?: string | null, city?: string | null, postal?: string | null, jurisdiction?: string | null, country?: string | null, neighborhood?: string | null, CountryIso2?: string | null, CountryIso3?: string | null, CountryName?: string | null, Province?: string | null, ProvinceCode?: string | null } } };

export type EditOrganizationLogoFetchFileDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<FileDocumentQueryFilter>;
}>;


export type EditOrganizationLogoFetchFileDocumentsQuery = { __typename?: 'Query', fetchFileDocuments: { __typename?: 'FetchFileDocumentsResponse', fileDocuments: Array<{ __typename?: 'FileDocument', id: string, name?: string | null }> } };

export type FormDefinitionSelectFetchFormDefinitionsQueryVariables = Exact<{
  input: FetchFormDefinitionsInput;
}>;


export type FormDefinitionSelectFetchFormDefinitionsQuery = { __typename?: 'Query', fetchFormDefinitions: { __typename?: 'FetchFormDefinitionsResponse', totalCount: number, formDefinitions: Array<{ __typename?: 'FormDefinition', id: string, key: string, objectType: FormDefinitionObjectTypes, translatedName: { __typename?: 'FormTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type GraphqlSchemaSelectFetchPageConfigurationSchemaTypeQueryVariables = Exact<{
  pageType: PageConfigurationTypes;
}>;


export type GraphqlSchemaSelectFetchPageConfigurationSchemaTypeQuery = { __typename?: 'Query', fetchPageConfigurationSchemaType: { __typename?: 'PageConfigurationSchemaType', name: string, fields: Array<{ __typename?: 'PageConfigurationSchemaField', path: string, ownerTypeName: string, graphQLTypeName: string, isTranslatedField: boolean, isNestedRepeatedType: boolean }> } };

export type FetchApiExportsQueryVariables = Exact<{
  input: FetchApiExportsInput;
}>;


export type FetchApiExportsQuery = { __typename?: 'Query', fetchApiExports: { __typename?: 'FetchApiExportsResponse', totalCount: number, apiExports: Array<{ __typename?: 'DataApiExport', id: string, fileName?: string | null, state: DataExportStates, createdAt: string, columns: Array<{ __typename?: 'DataApiExportColumn', gqlAlias: string }> }> } };

export type FetchApiExportDownloadQueryVariables = Exact<{
  input: FetchApiExportInput;
}>;


export type FetchApiExportDownloadQuery = { __typename?: 'Query', fetchApiExport: { __typename?: 'FetchApiExportResponse', apiExport: { __typename?: 'DataApiExport', fileUrl?: string | null } } };

export type FetchApiExportProgressQueryVariables = Exact<{
  input: FetchApiExportInput;
}>;


export type FetchApiExportProgressQuery = { __typename?: 'Query', fetchApiExport: { __typename?: 'FetchApiExportResponse', apiExport: { __typename?: 'DataApiExport', state: DataExportStates, progress?: number | null } } };

export type ExportApiReportMutationVariables = Exact<{
  input: ExportApiReportInput;
}>;


export type ExportApiReportMutation = { __typename?: 'Mutation', exportApiReport: { __typename?: 'ExportApiReportResponse', apiExport: { __typename?: 'DataApiExport', id: string } } };

export type WorkflowSelectFetchWorkflowsQueryVariables = Exact<{
  input: FetchWorkflowsInput;
}>;


export type WorkflowSelectFetchWorkflowsQuery = { __typename?: 'Query', fetchWorkflows: { __typename?: 'FetchWorkflowsResponse', totalCount: number, workflows: Array<{ __typename?: 'Workflow', id: string, objectType: WorkflowObjectTypes, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type WorkflowSelectFieldEditFetchWorkflowsQueryVariables = Exact<{
  input: FetchWorkflowsInput;
}>;


export type WorkflowSelectFieldEditFetchWorkflowsQuery = { __typename?: 'Query', fetchWorkflows: { __typename?: 'FetchWorkflowsResponse', totalCount: number, workflows: Array<{ __typename?: 'Workflow', id: string, objectType: WorkflowObjectTypes, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type DashboardGlobalFilterFieldsFragment = { __typename?: 'DashboardGlobalFilter', reportType: WidgetReportTypes, field: string, comparison: WidgetFilterComparisonTypes, value: string };

export type DashboardWidgetFieldsFragment = { __typename?: 'Widget', type: WidgetChartTypes, columns: Array<string>, format: WidgetFormatTypes, height: number, width: number, x?: number | null, y?: number | null, reportType: WidgetReportTypes, sortDesc: boolean, sortField: string, filters: Array<{ __typename?: 'WidgetFilter', comparison: WidgetFilterComparisonTypes, field: string, value: string }>, grouping: { __typename?: 'WidgetGrouping', field?: string | null, interval?: WidgetInterval | null, type: WidgetGroupingType, valueAggregation: WidgetValueAggregation, valueField: string }, translatedTitle?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null };

export type DashboardFetchOrganizationDashboardQueryVariables = Exact<{
  dashboardId: Scalars['ObjectID']['input'];
}>;


export type DashboardFetchOrganizationDashboardQuery = { __typename?: 'Query', fetchOrganizationDashboard: { __typename?: 'FetchOrganizationDashboardResponse', dashboard: { __typename?: 'Dashboard', id: string, organization: { __typename?: 'PublicOrganization', id: string }, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, globalFilters: Array<{ __typename?: 'DashboardGlobalFilter', reportType: WidgetReportTypes, field: string, comparison: WidgetFilterComparisonTypes, value: string }>, widgets: Array<{ __typename?: 'Widget', type: WidgetChartTypes, columns: Array<string>, format: WidgetFormatTypes, height: number, width: number, x?: number | null, y?: number | null, reportType: WidgetReportTypes, sortDesc: boolean, sortField: string, filters: Array<{ __typename?: 'WidgetFilter', comparison: WidgetFilterComparisonTypes, field: string, value: string }>, grouping: { __typename?: 'WidgetGrouping', field?: string | null, interval?: WidgetInterval | null, type: WidgetGroupingType, valueAggregation: WidgetValueAggregation, valueField: string }, translatedTitle?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }> } } };

export type DashboardFetchOrganizationDashboardNameQueryVariables = Exact<{
  dashboardId: Scalars['ObjectID']['input'];
}>;


export type DashboardFetchOrganizationDashboardNameQuery = { __typename?: 'Query', fetchOrganizationDashboard: { __typename?: 'FetchOrganizationDashboardResponse', dashboard: { __typename?: 'Dashboard', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } } };

export type DashboardUpdateOrganizationDashboardMutationVariables = Exact<{
  input: UpdateOrganizationDashboardInput;
}>;


export type DashboardUpdateOrganizationDashboardMutation = { __typename?: 'Mutation', updateOrganizationDashboard: { __typename?: 'UpdateOrganizationDashboardResponse', dashboard?: { __typename?: 'Dashboard', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } | null } };

export type DashboardFetchReportOptionsQueryVariables = Exact<{
  input: FetchReportOptionsInput;
}>;


export type DashboardFetchReportOptionsQuery = { __typename?: 'Query', fetchReportOptions: { __typename?: 'FetchReportOptionsResponse', columns: Array<string>, filters: Array<{ __typename?: 'ReportFilterOptions', field: string, comparisons: Array<{ __typename?: 'ReportFilterComparisons', comparison: ReportComparison, valueTypes: ReportValueType, options?: Array<string> | null }> }> } };

export type DashboardGenerateReportQueryVariables = Exact<{
  input: GenerateReportInput;
}>;


export type DashboardGenerateReportQuery = { __typename?: 'Query', generateReport: { __typename?: 'GenerateReportResponse', grouping?: Record<string, unknown> | null, data: Array<Array<string>>, columns: Array<string>, totalCount: number } };

export type FetchFlagGlossaryQueryVariables = Exact<{
  organizationId: Scalars['ObjectID']['input'];
}>;


export type FetchFlagGlossaryQuery = { __typename?: 'Query', fetchFlagGlossary: Array<{ __typename?: 'FlagGlossaryEntry', flagType: FlagTypes, label: string, category: FlagCategory, isActive: boolean, isAmountThresholdable: boolean, axis?: FlagAmountAxis | null, inherited: { __typename?: 'FlagGlossaryPolicyValues', priority: FlagPriority, thresholdCents?: number | null, percentThreshold?: number | null }, actual: { __typename?: 'FlagGlossaryPolicyValues', priority: FlagPriority, thresholdCents?: number | null, percentThreshold?: number | null } }> };

export type ClientSummaryFetchWorkflowsQueryVariables = Exact<{
  input: FetchWorkflowsInput;
}>;


export type ClientSummaryFetchWorkflowsQuery = { __typename?: 'Query', fetchWorkflows: { __typename?: 'FetchWorkflowsResponse', totalCount: number, workflows: Array<{ __typename?: 'Workflow', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type FetchAccountReconciliationSnapshotsForActivityQueryVariables = Exact<{
  input: FetchAccountReconciliationSnapshotsInput;
}>;


export type FetchAccountReconciliationSnapshotsForActivityQuery = { __typename?: 'Query', fetchAccountReconciliationSnapshots: { __typename?: 'FetchAccountReconciliationSnapshotsResponse', totalCount: number, accountReconciliationSnapshots: Array<{ __typename?: 'AccountReconciliationSnapshot', id: string, date: string, isFlagged?: boolean | null, oneVestUpdatedAt?: string | null, custodianUpdatedAt?: string | null, holdings: Array<{ __typename?: 'AccountReconciliationSnapshotHolding', isCash: boolean, currency: Currencies, oneVestQuantity?: number | null, oneVestPendingQuantity?: number | null, oneVestValueCents?: number | null, oneVestPendingValueCents?: number | null, custodianQuantity?: number | null, custodianValueCents?: number | null, financialProduct: { __typename?: 'FinancialProduct', id: string, ticker?: string | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } }> }> } };

export type FetchCustodianActivityMetricsQueryVariables = Exact<{
  input: FetchCustodianActivityMetricsInput;
}>;


export type FetchCustodianActivityMetricsQuery = { __typename?: 'Query', fetchCustodianActivityMetrics: { __typename?: 'FetchCustodianActivityMetricsResponse', metrics: { __typename?: 'CustodianActivityMetrics', createdCount: number, reconciledTodayCount: number, agingPendingCount: number, occurringTodayCount: number } } };

export type FetchCustodianActivityChartTodayQueryVariables = Exact<{
  input: FetchCustodianActivityChartTodayInput;
}>;


export type FetchCustodianActivityChartTodayQuery = { __typename?: 'Query', fetchCustodianActivityChartToday: { __typename?: 'FetchCustodianActivityChartTodayResponse', result: { __typename?: 'CustodianActivityChartTodayResult', asOf: string, bands: Array<{ __typename?: 'CustodianActivityChartBandBucket', band: CustodianActivityChartBand, count: number }> } } };

export type FetchCustodianActivityChartTrendQueryVariables = Exact<{
  input: FetchCustodianActivityChartTrendInput;
}>;


export type FetchCustodianActivityChartTrendQuery = { __typename?: 'Query', fetchCustodianActivityChartTrend: { __typename?: 'FetchCustodianActivityChartTrendResponse', result: { __typename?: 'CustodianActivityChartTrendResult', asOf: string, points: Array<{ __typename?: 'CustodianActivityChartDayPoint', date: string, inflowCount: number, outflowCount: number, bands: Array<{ __typename?: 'CustodianActivityChartBandBucket', band: CustodianActivityChartBand, count: number }> }> } } };

export type CustodianActivityGridFieldsFragment = { __typename?: 'CustodianActivity', id: string, clientName?: string | null, custodianAccountNumber?: string | null, processDate?: string | null, effectiveDate?: string | null, settleDate?: string | null, transactionType: string, transactionDesc?: string | null, transactionId?: string | null, subTransactionId?: string | null, amountValueCents?: number | null, quantity?: number | null, priceCents?: number | null, currency?: string | null, symbol?: string | null, cusip?: string | null, securityType?: string | null, commission?: string | null, accruedInterest?: string | null, bookValueAmountCents?: number | null, isCancel?: boolean | null, state: CustodianActivityStates, reconcileMethod?: ReconcileMethod | null, reconciledAt?: string | null, notes: Array<{ __typename?: 'CustodianActivityNote', text: string, author: string, authorId: string, createdAt: string }>, account?: { __typename?: 'Account', id: string, type: AccountTypes, custodianAccountNumber?: string | null, organization: { __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, entityName?: string | null } } | null, financialProduct?: { __typename?: 'FinancialProduct', id: string, ticker?: string | null, currency?: Currencies | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null };

export type FetchCustodianActivitiesForGridQueryVariables = Exact<{
  input: FetchCustodianActivitiesInputForGrid;
}>;


export type FetchCustodianActivitiesForGridQuery = { __typename?: 'Query', fetchCustodianActivitiesForGrid: { __typename?: 'FetchCustodianActivitiesResponse', totalCount: number, custodianActivities: Array<{ __typename?: 'CustodianActivity', id: string, clientName?: string | null, custodianAccountNumber?: string | null, processDate?: string | null, effectiveDate?: string | null, settleDate?: string | null, transactionType: string, transactionDesc?: string | null, transactionId?: string | null, subTransactionId?: string | null, amountValueCents?: number | null, quantity?: number | null, priceCents?: number | null, currency?: string | null, symbol?: string | null, cusip?: string | null, securityType?: string | null, commission?: string | null, accruedInterest?: string | null, bookValueAmountCents?: number | null, isCancel?: boolean | null, state: CustodianActivityStates, reconcileMethod?: ReconcileMethod | null, reconciledAt?: string | null, notes: Array<{ __typename?: 'CustodianActivityNote', text: string, author: string, authorId: string, createdAt: string }>, account?: { __typename?: 'Account', id: string, type: AccountTypes, custodianAccountNumber?: string | null, organization: { __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, entityName?: string | null } } | null, financialProduct?: { __typename?: 'FinancialProduct', id: string, ticker?: string | null, currency?: Currencies | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null }> } };

export type ReconcileCustodianActivityMutationVariables = Exact<{
  custodianActivityId: Scalars['ObjectID']['input'];
}>;


export type ReconcileCustodianActivityMutation = { __typename?: 'Mutation', reconcileCustodianActivity: { __typename?: 'ReconcileCustodianActivityResponse', failureType?: string | null, failureMessage?: string | null, custodianActivity: { __typename?: 'CustodianActivity', id: string, clientName?: string | null, custodianAccountNumber?: string | null, processDate?: string | null, effectiveDate?: string | null, settleDate?: string | null, transactionType: string, transactionDesc?: string | null, transactionId?: string | null, subTransactionId?: string | null, amountValueCents?: number | null, quantity?: number | null, priceCents?: number | null, currency?: string | null, symbol?: string | null, cusip?: string | null, securityType?: string | null, commission?: string | null, accruedInterest?: string | null, bookValueAmountCents?: number | null, isCancel?: boolean | null, state: CustodianActivityStates, reconcileMethod?: ReconcileMethod | null, reconciledAt?: string | null, notes: Array<{ __typename?: 'CustodianActivityNote', text: string, author: string, authorId: string, createdAt: string }>, account?: { __typename?: 'Account', id: string, type: AccountTypes, custodianAccountNumber?: string | null, organization: { __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, entityName?: string | null } } | null, financialProduct?: { __typename?: 'FinancialProduct', id: string, ticker?: string | null, currency?: Currencies | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null } } };

export type ForceReconcileCustodianActivityMutationVariables = Exact<{
  custodianActivityId: Scalars['ObjectID']['input'];
}>;


export type ForceReconcileCustodianActivityMutation = { __typename?: 'Mutation', forceReconcileCustodianActivity: { __typename?: 'ForceReconcileCustodianActivityResponse', custodianActivity: { __typename?: 'CustodianActivity', id: string, clientName?: string | null, custodianAccountNumber?: string | null, processDate?: string | null, effectiveDate?: string | null, settleDate?: string | null, transactionType: string, transactionDesc?: string | null, transactionId?: string | null, subTransactionId?: string | null, amountValueCents?: number | null, quantity?: number | null, priceCents?: number | null, currency?: string | null, symbol?: string | null, cusip?: string | null, securityType?: string | null, commission?: string | null, accruedInterest?: string | null, bookValueAmountCents?: number | null, isCancel?: boolean | null, state: CustodianActivityStates, reconcileMethod?: ReconcileMethod | null, reconciledAt?: string | null, notes: Array<{ __typename?: 'CustodianActivityNote', text: string, author: string, authorId: string, createdAt: string }>, account?: { __typename?: 'Account', id: string, type: AccountTypes, custodianAccountNumber?: string | null, organization: { __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, entityName?: string | null } } | null, financialProduct?: { __typename?: 'FinancialProduct', id: string, ticker?: string | null, currency?: Currencies | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null } } };

export type UpdateCustodianActivityNotesMutationVariables = Exact<{
  input: UpdateCustodianActivityNotesInput;
}>;


export type UpdateCustodianActivityNotesMutation = { __typename?: 'Mutation', updateCustodianActivityNotes: { __typename?: 'UpdateCustodianActivityNotesResponse', custodianActivity: { __typename?: 'CustodianActivity', id: string, clientName?: string | null, custodianAccountNumber?: string | null, processDate?: string | null, effectiveDate?: string | null, settleDate?: string | null, transactionType: string, transactionDesc?: string | null, transactionId?: string | null, subTransactionId?: string | null, amountValueCents?: number | null, quantity?: number | null, priceCents?: number | null, currency?: string | null, symbol?: string | null, cusip?: string | null, securityType?: string | null, commission?: string | null, accruedInterest?: string | null, bookValueAmountCents?: number | null, isCancel?: boolean | null, state: CustodianActivityStates, reconcileMethod?: ReconcileMethod | null, reconciledAt?: string | null, notes: Array<{ __typename?: 'CustodianActivityNote', text: string, author: string, authorId: string, createdAt: string }>, account?: { __typename?: 'Account', id: string, type: AccountTypes, custodianAccountNumber?: string | null, organization: { __typename?: 'Organization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, entityName?: string | null } } | null, financialProduct?: { __typename?: 'FinancialProduct', id: string, ticker?: string | null, currency?: Currencies | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null } } };

export type SearchUsersForReconFlagsGridQueryVariables = Exact<{
  input: UserSearchInput;
}>;


export type SearchUsersForReconFlagsGridQuery = { __typename?: 'Query', searchUsers?: { __typename?: 'UserSearchResult', users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, entityName?: string | null, primaryEmail?: string | null, accounts?: Array<{ __typename?: 'Account', id: string }> | null }> } | null };

export type FetchFlagsForGridQueryVariables = Exact<{
  input: FetchFlagsInputForGrid;
}>;


export type FetchFlagsForGridQuery = { __typename?: 'Query', fetchFlagsForGrid: { __typename?: 'FetchFlagsResponse', totalCount: number, flags: Array<{ __typename?: 'Flag', id: string, objectId?: string | null, objectType?: FlagObjects | null, type: FlagTypes, priority: FlagPriority, category: FlagCategory, message?: string | null, details?: Record<string, unknown> | null, state: FlagStates, createdAt: string, firstSeenAt: string, notes: Array<{ __typename?: 'FlagNote', text: string, author: string, authorId: string, createdAt: string }>, organization?: { __typename?: 'Organization', id: string } | null, account?: { __typename?: 'Account', id: string, custodianAccountNumber?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, entityName?: string | null } } | null }> } };

export type FetchFlagKpIsQueryVariables = Exact<{
  organizationId: Scalars['ObjectID']['input'];
  unresolvedBefore?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
}>;


export type FetchFlagKpIsQuery = { __typename?: 'Query', fetchFlagKPIs: { __typename?: 'FlagKPIs', totalFlags: number, unresolvedOverThreeDays: number, typeCounts: Array<{ __typename?: 'FlagTypeCount', flagType: FlagTypes, count: number }> } };

export type TransitionFlagMutationVariables = Exact<{
  input: TransitionFlagInput;
}>;


export type TransitionFlagMutation = { __typename?: 'Mutation', transitionFlag: { __typename?: 'TransitionFlagResponse', flag?: { __typename?: 'Flag', id: string } | null } };

export type BulkTransitionFlagsForGridMutationVariables = Exact<{
  input: BulkTransitionFlagsInput;
}>;


export type BulkTransitionFlagsForGridMutation = { __typename?: 'Mutation', bulkTransitionFlagsForGrid: { __typename?: 'BulkTransitionFlagsForGridResponse', succeeded: Array<{ __typename?: 'Flag', id: string, state: FlagStates }>, failed: Array<{ __typename?: 'BulkTransitionFailure', flagId: string, error: string }> } };

export type UpdateFlagNotesMutationVariables = Exact<{
  input: UpdateFlagNotesInput;
}>;


export type UpdateFlagNotesMutation = { __typename?: 'Mutation', updateFlagNotes: { __typename?: 'FetchFlagResponse', flag: { __typename?: 'Flag', id: string, notes: Array<{ __typename?: 'FlagNote', text: string, author: string, authorId: string, createdAt: string }> } } };

export type AdvisorContactInformationFetchResolvedAdvisorContactsQueryVariables = Exact<{
  input: FetchResolvedAdvisorContactsInput;
}>;


export type AdvisorContactInformationFetchResolvedAdvisorContactsQuery = { __typename?: 'Query', fetchResolvedAdvisorContacts: { __typename?: 'FetchResolvedAdvisorContactsResponse', resolvedAdvisorContacts: Array<{ __typename?: 'ResolvedAdvisorContact', firstName?: string | null, lastName?: string | null, phone?: string | null, phoneExtension?: string | null, email?: string | null, displayRoleLabel?: string | null, source: ResolvedAdvisorContactSources, advisorContact?: { __typename?: 'AdvisorContact', id: string } | null, organizationUser?: { __typename?: 'PublicOrganizationUser', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null, avatar?: string | null, displayRole?: { __typename?: 'DisplayRole', id: string, name: string } | null, role: { __typename?: 'PublicRole', translatedName: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } } | null, address?: { __typename?: 'AdvisorContactAddress', unitNumber?: string | null, houseNumber?: string | null, streetName?: string | null, neighborhood?: string | null, city?: string | null, province?: string | null, jurisdiction?: string | null, country?: string | null, postal?: string | null } | null, displayRole?: { __typename?: 'DisplayRole', id: string, name: string, order: number } | null, resolutionPath: { __typename?: 'ResolutionPath', reason: ResolutionReasons, viaRepCode?: string | null, fieldSources: { __typename?: 'ResolvedFieldSources', firstName: FieldSources, lastName: FieldSources, phone: FieldSources, phoneExtension: FieldSources, email: FieldSources, displayRole: FieldSources } } }> } };

export type FetchAuditLogsV2QueryVariables = Exact<{
  input: FetchLogsInput;
  withApiTokenFields: Scalars['Boolean']['input'];
}>;


export type FetchAuditLogsV2Query = { __typename?: 'Query', fetchLogs: { __typename?: 'FetchLogsResponse', totalCount: number, logs: Array<{ __typename?: 'Log', id: string, type: LogTypes, initiator: Initiator, objectType: string, objectId: string, changedByEmail?: string | null, changes?: Record<string, unknown> | null, timestamp: string, traceId?: string | null, organizationUser?: { __typename?: 'PublicOrganizationUser', referenceId?: string | null, firstName: string, lastName?: string | null } | null, user?: { __typename?: 'User', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, entityName?: string | null, type?: EntityTypes | null } | null, apiToken?: { __typename?: 'ApiToken', id: string, name: string, organizationUser: { __typename?: 'PublicOrganizationUser', firstName: string, lastName?: string | null } } | null }> } };

export type InitiateTransferCreateWorkflowCompletionMutationVariables = Exact<{
  input: CreateWorkflowCompletionInput;
}>;


export type InitiateTransferCreateWorkflowCompletionMutation = { __typename?: 'Mutation', createWorkflowCompletion: { __typename?: 'CreateWorkflowCompletionResponse', workflowCompletion: { __typename?: 'WorkflowCompletion', id: string, objectId?: string | null, externalObjectId?: string | null, objectType: WorkflowObjectTypes, context?: Record<string, unknown> | null, user?: { __typename?: 'User', stringId: string } | null, organization: { __typename?: 'Organization', id: string }, workflow: { __typename?: 'Workflow', id: string, complex: boolean, settings: { __typename?: 'WorkflowSettings', archiveObjectsOnClose: boolean, cancelOnClose: boolean, displayCloseButton: boolean }, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, steps: Array<{ __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes, options: Record<string, unknown> }> }> }, currentStep: { __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes }> }, currentSubStep: { __typename?: 'SubStep', id: string, options: Record<string, unknown>, type: SubStepTypes, canGoBack: boolean, skippable: boolean, rolesCompleteableBy: Array<{ __typename?: 'Role', id: string }>, branches?: Array<{ __typename?: 'WorkflowStepBranch', fromKey?: string | null }> | null } } } };

export type GoalLinkingFetchGoalNameQueryVariables = Exact<{
  goalId: Scalars['ObjectID']['input'];
}>;


export type GoalLinkingFetchGoalNameQuery = { __typename?: 'Query', fetchGoal: { __typename?: 'FetchGoalResponse', goal: { __typename?: 'Goal', id: string, name?: string | null } } };

export type ApprovalFetchHouseholdCustomFieldsQueryVariables = Exact<{
  clientGroupId: Scalars['SafeString']['input'];
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ApprovalFetchHouseholdCustomFieldsQuery = { __typename?: 'Query', fetchClientGroup: { __typename?: 'FetchClientGroupResponse', clientGroup?: { __typename?: 'ClientGroup', id: string, customFields?: Array<{ __typename?: 'UserCustomFieldValue', key: string, value?: Record<string, unknown> | null, customField?: { __typename?: 'CustomField', id: string, type: CustomFieldTypes, format?: CustomFieldFormats | null, objectType: CustomFieldObjectTypes, translatedName: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, translatedDescription?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } | null, selectedOptions?: Array<{ __typename?: 'UserCustomFieldSelectedOption', value: Record<string, unknown>, displayText?: { __typename?: 'UserTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } | null> | null } | null> | null } | null } };

export type ApprovalUpdateHouseholdCustomFieldsMutationVariables = Exact<{
  input: UpdateClientGroupInput;
}>;


export type ApprovalUpdateHouseholdCustomFieldsMutation = { __typename?: 'Mutation', updateClientGroup: { __typename?: 'UpdateClientGroupResponse', clientGroup?: { __typename?: 'ClientGroup', id: string } | null } };

export type FetchArchiveAccountsQueryVariables = Exact<{
  input: FetchAccountsInput;
}>;


export type FetchArchiveAccountsQuery = { __typename?: 'Query', fetchAccounts: { __typename?: 'FetchAccountsResponse', accounts: Array<{ __typename?: 'Account', id: string, translatedAccountType?: { __typename?: 'AccountTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, stateTranslated?: { __typename?: 'AccountTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }> } };

export type FetchArchiveGoalQueryVariables = Exact<{
  goalId: Scalars['ObjectID']['input'];
}>;


export type FetchArchiveGoalQuery = { __typename?: 'Query', fetchGoal: { __typename?: 'FetchGoalResponse', goal: { __typename?: 'Goal', id: string, name?: string | null } } };

export type FetchArchiveSubAccountQueryVariables = Exact<{
  subAccountId: Scalars['ObjectID']['input'];
}>;


export type FetchArchiveSubAccountQuery = { __typename?: 'Query', fetchSubAccount: { __typename?: 'FetchSubAccountResponse', subAccount: { __typename?: 'SubAccount', id: string, goal?: { __typename?: 'Goal', name?: string | null } | null, account: { __typename?: 'Account', translatedAccountType?: { __typename?: 'AccountTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } } } };

export type FetchArchiveTransfersQueryVariables = Exact<{
  input: FetchTransfersInput;
}>;


export type FetchArchiveTransfersQuery = { __typename?: 'Query', fetchTransfers: { __typename?: 'FetchTransfersResponse', transfers: Array<{ __typename?: 'Transfer', id: string, amountCents: number, currency: Currencies, typeTranslated?: { __typename?: 'HoldingTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }> } };

export type FetchArchiveScheduledTransferQueryVariables = Exact<{
  scheduledTransferId: Scalars['ObjectID']['input'];
}>;


export type FetchArchiveScheduledTransferQuery = { __typename?: 'Query', fetchScheduledTransfer: { __typename?: 'FetchScheduledTransferResponse', scheduledTransfer: { __typename?: 'ScheduledTransfer', id: string, amountCents?: number | null, currency: Currencies, typeTranslated?: { __typename?: 'HoldingTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } } };

export type FetchArchiveManualProcessQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchArchiveManualProcessQuery = { __typename?: 'Query', fetchManualProcess: { __typename?: 'FetchManualProcessResponse', manualProcess: { __typename?: 'ManualProcess', id: string, type: ManualProcessTypes, transferMethod?: ExternalTransferTypes | null, institution?: { __typename?: 'Institution', name: string } | null } } };

export type FetchUserQueryVariables = Exact<{
  userId: Scalars['SafeString']['input'];
}>;


export type FetchUserQuery = { __typename?: 'Query', fetchUser: { __typename?: 'FetchUserResponse', user: { __typename?: 'User', firstName?: string | null, lastName?: string | null, primaryEmail?: string | null, latestFormAgreements?: Array<{ __typename?: 'FormAgreement', id: string, type: FormTypes, integrations?: Array<{ __typename?: 'FormAgreementIntegration', iid: string, externalData?: Record<string, unknown> | null } | null> | null } | null> | null } } };

export type SendIntegrationFormAgreementMutationVariables = Exact<{
  input: SendIntegrationFormAgreementInput;
}>;


export type SendIntegrationFormAgreementMutation = { __typename?: 'Mutation', sendIntegrationFormAgreement: { __typename?: 'SendIntegrationFormAgreementResponse', formAgreement: { __typename?: 'FormAgreement', id: string } } };

export type FetchAccountSubAccountsQueryVariables = Exact<{
  accountId: Scalars['SafeString']['input'];
}>;


export type FetchAccountSubAccountsQuery = { __typename?: 'Query', fetchAccount: { __typename?: 'FetchAccountResponse', account: { __typename?: 'Account', subAccounts?: Array<{ __typename?: 'SubAccount', id: string, goal?: { __typename?: 'Goal', id: string } | null }> | null } } };

export type EditAccountAllocationsFetchPortfolioReportsQueryVariables = Exact<{
  input: FetchPortfolioReportsInput;
}>;


export type EditAccountAllocationsFetchPortfolioReportsQuery = { __typename?: 'Query', fetchPortfolioReports: { __typename?: 'FetchPortfolioReportsResponse', portfolioReports: Array<{ __typename?: 'PortfolioReport', id: string, expectedCashPercentage: number, modelPortfolio: { __typename?: 'FinancialProduct', strategy?: FinancialProductStrategy | null }, holdings: Array<{ __typename?: 'HoldingReport', expectedPercentage: number, isCashEquivalent?: boolean | null, customExpectedPercentage?: number | null, assetClassPercentage?: number | null, assetClassGroupPercentage?: number | null, assetClass?: { __typename?: 'AssetClass', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, financialProduct: { __typename?: 'FinancialProduct', id: string, ticker?: string | null, isCash?: boolean | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } }>, subAccounts: Array<{ __typename?: 'SubAccountReport', id: string, marketValueCents: number, subAccount: { __typename?: 'SubAccount', id: string, state: SubAccountStates, account: { __typename?: 'Account', id: string, custodianAccountNumber?: string | null, type: AccountTypes, user: { __typename?: 'User', firstName?: string | null, lastName?: string | null, entityName?: string | null } } }, holdings: Array<{ __typename?: 'HoldingReport', expectedPercentage: number, isCashEquivalent?: boolean | null, customExpectedPercentage?: number | null, assetClassPercentage?: number | null, assetClassGroupPercentage?: number | null, assetClass?: { __typename?: 'AssetClass', id: string, name: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, financialProduct: { __typename?: 'FinancialProduct', id: string, ticker?: string | null, isCash?: boolean | null, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } }> }> }> } };

export type DownloadAllFormsFetchUserQueryVariables = Exact<{
  userId: Scalars['SafeString']['input'];
}>;


export type DownloadAllFormsFetchUserQuery = { __typename?: 'Query', fetchUser: { __typename?: 'FetchUserResponse', user: { __typename?: 'User', type?: EntityTypes | null, firstName?: string | null, lastName?: string | null, entityName?: string | null, id: string } } };

export type DownloadAllFormsFetchClientGroupQueryVariables = Exact<{
  clientGroupId: Scalars['SafeString']['input'];
}>;


export type DownloadAllFormsFetchClientGroupQuery = { __typename?: 'Query', fetchClientGroup: { __typename?: 'FetchClientGroupResponse', clientGroup?: { __typename?: 'ClientGroup', name: string, id: string } | null } };

export type DownloadAllFormsFetchFormCompletionQueryVariables = Exact<{
  formCompletionId: Scalars['ObjectID']['input'];
}>;


export type DownloadAllFormsFetchFormCompletionQuery = { __typename?: 'Query', fetchFormCompletion: { __typename?: 'FormCompletion', id: string, unsignedUrl?: string | null, resolvedPdfFileName?: { __typename?: 'FormTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, translatedName: { __typename?: 'FormTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, unsignedDocument?: { __typename?: 'FileDocument', downloadUrl?: string | null, fileName: string } | null } };

export type DepositEligibleSubAccountsFetchSubAccountsQueryVariables = Exact<{
  input: FetchSubAccountsInput;
  canReadAccountNumber: Scalars['Boolean']['input'];
}>;


export type DepositEligibleSubAccountsFetchSubAccountsQuery = { __typename?: 'Query', fetchSubAccounts: { __typename?: 'FetchSubAccountsResponse', subAccounts: Array<{ __typename?: 'SubAccount', id: string, account: { __typename?: 'Account', id: string, type: AccountTypes, state: AccountStates, baseCurrency?: AccountCurrencyTypes | null, availableCurrencies?: Array<AccountCurrencyTypes | null> | null, custodianAccountNumber?: string | null, statistics?: { __typename?: 'Statistics', marketValueCents?: number | null } | null }, financialProduct?: { __typename?: 'FinancialProduct', translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, statistics?: { __typename?: 'Statistics', currency?: StatisticsCurrencyTypes | null, marketValueCents?: number | null } | null }> } };

export type CloseAccountMutationVariables = Exact<{
  input: CloseAccountInput;
}>;


export type CloseAccountMutation = { __typename?: 'Mutation', closeAccount: { __typename?: 'CloseAccountResponse', account?: { __typename?: 'Account', id: string } | null } };

export type RunWorkflowSubStepActionMutationVariables = Exact<{
  input: RunWorkflowSubStepActionInput;
}>;


export type RunWorkflowSubStepActionMutation = { __typename?: 'Mutation', runWorkflowSubStepAction: { __typename?: 'RunWorkflowSubStepActionResponse', workflowCompletion: { __typename?: 'WorkflowCompletion', id: string } } };

export type CreateLinkTokenMutationVariables = Exact<{
  input: CreateLinkTokenInput;
}>;


export type CreateLinkTokenMutation = { __typename?: 'Mutation', createLinkToken: { __typename?: 'CreateLinkTokenResponse', linkToken?: string | null } };

export type CreateTransactionMutationVariables = Exact<{
  input: CreateTransactionInput;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction: { __typename?: 'CreateTransactionResponse', transaction: { __typename?: 'Transaction', id: string } } };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'UpdateAccountResponse', account: { __typename?: 'Account', id: string } } };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'CreateAccountResponse', account: { __typename?: 'Account', id: string, type: AccountTypes } } };

export type CreateSubAccountMutationVariables = Exact<{
  input: CreateSubAccountInput;
}>;


export type CreateSubAccountMutation = { __typename?: 'Mutation', createSubAccount: { __typename?: 'CreateSubAccountResponse', subAccount: { __typename?: 'SubAccount', id: string } } };

export type ValidateAgeOfMajorityQueryVariables = Exact<{
  dateOfBirth: Scalars['String']['input'];
  country: AddressCountries;
  jurisdiction?: InputMaybe<AddressJurisdiction>;
}>;


export type ValidateAgeOfMajorityQuery = { __typename?: 'Query', validateAgeOfMajority: { __typename?: 'ValidateAgeOfMajorityResponse', valid: boolean, ageOfMajority: number } };

export type SelectModelPortfolioEditTypeFetchHouseholdQueryVariables = Exact<{
  clientGroupId: Scalars['ObjectID']['input'];
}>;


export type SelectModelPortfolioEditTypeFetchHouseholdQuery = { __typename?: 'Query', fetchPortfolioReports: { __typename?: 'FetchPortfolioReportsResponse', portfolioReports: Array<{ __typename?: 'PortfolioReport', id: string, subAccounts: Array<{ __typename?: 'SubAccountReport', id: string }> }> } };

export type WithdrawalBreakdownCalculateWithdrawFeesQueryVariables = Exact<{
  input: CalculateWithdrawFeesInput;
}>;


export type WithdrawalBreakdownCalculateWithdrawFeesQuery = { __typename?: 'Query', calculateWithdrawFees: { __typename?: 'CalculateWithdrawFeesResponse', withdrawFees?: Array<{ __typename?: 'WithdrawFee', type?: WithdrawFeeTypes | null, amountCents?: number | null } | null> | null } };

export type QueryFetchLogsQueryVariables = Exact<{
  input: FetchLogsInput;
}>;


export type QueryFetchLogsQuery = { __typename?: 'Query', fetchLogs: { __typename?: 'FetchLogsResponse', totalCount: number, logs: Array<{ __typename?: 'Log', originalDocument?: Record<string, unknown> | null, newDocument?: Record<string, unknown> | null, changes?: Record<string, unknown> | null, timestamp: string, workflowContext?: { __typename?: 'LogWorkflowContext', workflowCompletionId?: string | null, stepId?: string | null, subStepId?: string | null } | null }> } };

export type GetTotalLogsQueryVariables = Exact<{
  input: FetchLogsInput;
}>;


export type GetTotalLogsQuery = { __typename?: 'Query', fetchLogs: { __typename?: 'FetchLogsResponse', totalCount: number } };

export type CreateWorkflowCompletionMutationVariables = Exact<{
  input: CreateWorkflowCompletionInput;
}>;


export type CreateWorkflowCompletionMutation = { __typename?: 'Mutation', createWorkflowCompletion: { __typename?: 'CreateWorkflowCompletionResponse', workflowCompletion: { __typename?: 'WorkflowCompletion', id: string, user?: { __typename?: 'User', stringId: string } | null } } };

export type FetchRepCodesForDesignationQueryVariables = Exact<{
  input: FetchRepCodesInput;
}>;


export type FetchRepCodesForDesignationQuery = { __typename?: 'Query', fetchRepCodes: { __typename?: 'FetchRepCodesResponse', totalCount: number, repCodes: Array<{ __typename?: 'RepCode', id: string, code: string, name?: string | null }> } };

export type FetchResolvedAdvisorContactsQueryVariables = Exact<{
  input: FetchResolvedAdvisorContactsInput;
}>;


export type FetchResolvedAdvisorContactsQuery = { __typename?: 'Query', fetchResolvedAdvisorContacts: { __typename?: 'FetchResolvedAdvisorContactsResponse', resolvedAdvisorContacts: Array<{ __typename?: 'ResolvedAdvisorContact', firstName?: string | null, lastName?: string | null, phone?: string | null, phoneExtension?: string | null, email?: string | null, displayRoleLabel?: string | null, source: ResolvedAdvisorContactSources, advisorContact?: { __typename?: 'AdvisorContact', id: string } | null, organizationUser?: { __typename?: 'PublicOrganizationUser', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null, avatar?: string | null, displayRole?: { __typename?: 'DisplayRole', id: string, name: string } | null, role: { __typename?: 'PublicRole', translatedName: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } } | null, address?: { __typename?: 'AdvisorContactAddress', unitNumber?: string | null, houseNumber?: string | null, streetName?: string | null, neighborhood?: string | null, city?: string | null, province?: string | null, jurisdiction?: string | null, country?: string | null, postal?: string | null } | null, displayRole?: { __typename?: 'DisplayRole', id: string, name: string, order: number } | null, resolutionPath: { __typename?: 'ResolutionPath', reason: ResolutionReasons, viaRepCode?: string | null, fieldSources: { __typename?: 'ResolvedFieldSources', firstName: FieldSources, lastName: FieldSources, phone: FieldSources, phoneExtension: FieldSources, email: FieldSources, displayRole: FieldSources } } }> } };

export type FetchClientAdvisorVisibilityQueryVariables = Exact<{
  input: FetchClientAdvisorVisibilityInput;
}>;


export type FetchClientAdvisorVisibilityQuery = { __typename?: 'Query', fetchClientAdvisorVisibility: { __typename?: 'FetchClientAdvisorVisibilityResponse', visibilityEntries: Array<{ __typename?: 'ClientAdvisorVisibilityEntry', effectiveHide: boolean, displayLabel: string, precedence?: VisibilityPrecedence | null, contributingAccountIds?: Array<string> | null, advisorContact?: { __typename?: 'AdvisorContact', id: string, firstName: string, lastName?: string | null } | null, organizationUser?: { __typename?: 'PublicOrganizationUser', id: string, firstName: string, lastName?: string | null } | null }> } };

export type SearchAdvisorContactClientsQueryVariables = Exact<{
  input: UserSearchInput;
}>;


export type SearchAdvisorContactClientsQuery = { __typename?: 'Query', searchUsers?: { __typename?: 'UserSearchResult', totalCount: number, users: Array<{ __typename?: 'User', id: string, type?: EntityTypes | null, firstName?: string | null, lastName?: string | null, primaryEmail?: string | null, entityName?: string | null }> } | null };

export type SearchAdvisorContactClientsWithoutPiiQueryVariables = Exact<{
  input: UserSearchInput;
}>;


export type SearchAdvisorContactClientsWithoutPiiQuery = { __typename?: 'Query', searchUsers?: { __typename?: 'UserSearchResult', totalCount: number, users: Array<{ __typename?: 'User', id: string, type?: EntityTypes | null }> } | null };

export type FetchAdvisorContactClientAccountsQueryVariables = Exact<{
  input: FetchAccountsInput;
}>;


export type FetchAdvisorContactClientAccountsQuery = { __typename?: 'Query', fetchAccounts: { __typename?: 'FetchAccountsResponse', totalCount: number, accounts: Array<{ __typename?: 'Account', type: AccountTypes, custodianAccountNumber?: string | null, id: string }> } };

export type FetchAdvisorContactClientHouseholdsQueryVariables = Exact<{
  userId: Scalars['SafeString']['input'];
}>;


export type FetchAdvisorContactClientHouseholdsQuery = { __typename?: 'Query', fetchUser: { __typename?: 'FetchUserResponse', user: { __typename?: 'User', type?: EntityTypes | null, firstName?: string | null, lastName?: string | null, entityName?: string | null, primaryEmail?: string | null, id: string, households?: Array<{ __typename?: 'ClientGroup', name: string, id: string, relationships?: Array<{ __typename?: 'Relationship', user: { __typename?: 'User', id: string } }> | null } | null> | null } } };

export type FetchAdvisorContactClientHouseholdsWithoutPiiQueryVariables = Exact<{
  userId: Scalars['SafeString']['input'];
}>;


export type FetchAdvisorContactClientHouseholdsWithoutPiiQuery = { __typename?: 'Query', fetchUser: { __typename?: 'FetchUserResponse', user: { __typename?: 'User', type?: EntityTypes | null, id: string, households?: Array<{ __typename?: 'ClientGroup', name: string, id: string, relationships?: Array<{ __typename?: 'Relationship', user: { __typename?: 'User', id: string } }> | null } | null> | null } } };

export type FetchAdvisorContactPageOptionsQueryVariables = Exact<{
  input: FetchPageConfigurationsInput;
}>;


export type FetchAdvisorContactPageOptionsQuery = { __typename?: 'Query', fetchPageConfigurations: { __typename?: 'FetchPageConfigurationsResponse', pageConfigurations: Array<{ __typename?: 'PageConfiguration', id: string, name: string, type: PageConfigurationTypes, tabs: Array<{ __typename?: 'TabConfiguration', widgets: Array<{ __typename?: 'WidgetConfiguration', type: WidgetConfigurationTypes, options: Record<string, unknown> }> }> }> } };

export type UpdateAdvisorContactClientVisibilityMutationVariables = Exact<{
  input: UpdateUserOrganizationUserDisplayOptionsInput;
}>;


export type UpdateAdvisorContactClientVisibilityMutation = { __typename?: 'Mutation', updateUserOrganizationUserDisplayOptions: { __typename?: 'UpdateUserOrganizationUserDisplayOptionsResponse', userOrganizationUserDisplayOptions: Array<{ __typename?: 'UserOrganizationUserDisplayOptions', hide: boolean, advisorContact?: { __typename?: 'AdvisorContact', id: string } | null, organizationUser?: { __typename?: 'OrganizationUser', id: string } | null }> } };

export type FetchOrganizationQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type FetchOrganizationQuery = { __typename?: 'Query', fetchOrganization: { __typename?: 'FetchOrganizationResponse', organization: { __typename?: 'Organization', id: string, useParentDisplayRoles: boolean } } };

export type CreateDisplayRoleMutationVariables = Exact<{
  input: CreateDisplayRoleInput;
}>;


export type CreateDisplayRoleMutation = { __typename?: 'Mutation', createDisplayRole: { __typename?: 'CreateDisplayRoleResponse', displayRole: { __typename?: 'DisplayRole', id: string, name: string, order: number, isInherited?: boolean | null, advisorContactCount: number } } };

export type UpdateDisplayRoleMutationVariables = Exact<{
  input: UpdateDisplayRoleInput;
}>;


export type UpdateDisplayRoleMutation = { __typename?: 'Mutation', updateDisplayRole: { __typename?: 'UpdateDisplayRoleResponse', displayRole: { __typename?: 'DisplayRole', id: string, name: string, order: number, isInherited?: boolean | null, advisorContactCount: number } } };

export type ReorderDisplayRolesMutationVariables = Exact<{
  input: ReorderDisplayRolesInput;
}>;


export type ReorderDisplayRolesMutation = { __typename?: 'Mutation', reorderDisplayRoles: { __typename?: 'ReorderDisplayRolesResponse', displayRoles: Array<{ __typename?: 'DisplayRole', id: string, name: string, order: number, isInherited?: boolean | null, advisorContactCount: number }> } };

export type TransitionDisplayRoleMutationVariables = Exact<{
  input: TransitionDisplayRoleInput;
}>;


export type TransitionDisplayRoleMutation = { __typename?: 'Mutation', transitionDisplayRole: { __typename?: 'TransitionDisplayRoleResponse', displayRole: { __typename?: 'DisplayRole', id: string, name: string, order: number, state: DisplayRoleStates, isInherited?: boolean | null, advisorContactCount: number } } };

export type FetchTableExternalDataQueryVariables = Exact<{
  input: FetchTableExternalDataInput;
}>;


export type FetchTableExternalDataQuery = { __typename?: 'Query', fetchTableExternalData: { __typename?: 'FetchTableExternalDataResponse', tableExternalData?: Array<Record<string, unknown> | null> | null, totalCount?: number | null, totalValues?: Record<string, unknown> | null, widgets: Array<{ __typename?: 'ConfigurableTablePageWidget', type: ConfigurableTablePageWidgetTypes, options: Record<string, unknown> }>, cursor?: { __typename?: 'FetchTableExternalDataResponseCursor', prev?: string | null, next?: string | null } | null } };

export type FetchConfigurableTableFilterOptionsQueryVariables = Exact<{
  input: FetchConfigurableTableFilterOptionsInput;
}>;


export type FetchConfigurableTableFilterOptionsQuery = { __typename?: 'Query', fetchConfigurableTableFilterOptions: { __typename?: 'FetchConfigurableTableFilterOptionsResponse', key: string, populatedOptions: Array<{ __typename?: 'ConfigurableTablePageFilterStaticOptions', key: string, label: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type ExportConfigurableTablePageReportMutationVariables = Exact<{
  input: ExportConfigurableTablePageReportInput;
}>;


export type ExportConfigurableTablePageReportMutation = { __typename?: 'Mutation', exportConfigurableTablePageReport: { __typename?: 'ExportConfigurableTablePageReportResponse', configurableTablePageExport: { __typename?: 'ConfigurableTablePageExport', id: string } } };

export type FetchConfigurableTablePageReportQueryVariables = Exact<{
  configurableTablePageExportId: Scalars['ObjectID']['input'];
}>;


export type FetchConfigurableTablePageReportQuery = { __typename?: 'Query', fetchConfigurableTablePageReport: { __typename?: 'FetchConfigurableTablePageReportResponse', configurableTablePageExport: { __typename?: 'ConfigurableTablePageExport', id: string, progress?: number | null, state: ConfigurableTablePageExportStates, fileUrl?: string | null, fileName?: string | null } } };

export type UpdateSubAccountBillingMutationVariables = Exact<{
  input: UpdateSubAccountBillingInput;
}>;


export type UpdateSubAccountBillingMutation = { __typename?: 'Mutation', updateSubAccountBilling: { __typename?: 'UpdateSubAccountBillingResponse', subAccountBilling: { __typename?: 'SubAccountBilling', id: string } } };

export type OverrideFeesModalFetchSalesTaxConfigurationQueryVariables = Exact<{
  input: FetchSalesTaxConfigurationInput;
}>;


export type OverrideFeesModalFetchSalesTaxConfigurationQuery = { __typename?: 'Query', fetchSalesTaxConfiguration: { __typename?: 'FetchSalesTaxConfigurationResponse', salesTaxConfiguration: { __typename?: 'SalesTaxConfiguration', applicableDate: string, effectiveConfiguration: { __typename?: 'EffectiveSalesTaxConfiguration', configurableTaxes: Array<{ __typename?: 'ConfigurableSalesTax', identity: ConfigurableSalesTaxIdentity, enabled: boolean }> } } } };

export type FormMapResultQueryVariables = Exact<{
  input: FormMapResultInput;
  includePdf: Scalars['Boolean']['input'];
  pdfTemplateBase64: Scalars['String']['input'];
  flattenPdf?: InputMaybe<Scalars['Boolean']['input']>;
  eSignProvider?: InputMaybe<ESignProvider>;
}>;


export type FormMapResultQuery = { __typename?: 'Query', formMapResult: { __typename?: 'FormMapResultPayload', resolvedFormMap: { __typename?: 'ResolvedFormMapPayload', value: { __typename?: 'ResolvedFormMap', formDefinitionId: string, objectType?: FormMapObjectType | null, fields: Array<{ __typename?: 'ResolvedFormMapField', templateLabel: string, type: string, value: string, additionalValue?: string | null, defaultValue?: string | null, errorWhenEmpty?: boolean | null, formatter?: FormMapFormatter | null }> }, errors: Array<{ __typename?: 'FormMapError', code: FormMapErrorCode, field?: string | null, message: string }> }, pdf?: { __typename?: 'FilledPdfPayload', base64?: string | null, signatureFieldLocations: Array<{ __typename?: 'SignatureFieldLocation', signerKey: string, signerUserId?: string | null, pageNumber: number, x: number, y: number, width: number, height: number }>, errors: Array<{ __typename?: 'FormMapError', code: FormMapErrorCode, field?: string | null, message: string }> } } };

export type FetchFormMapQueryVariables = Exact<{
  formMapId: Scalars['ObjectID']['input'];
}>;


export type FetchFormMapQuery = { __typename?: 'Query', fetchFormMap: { __typename?: 'FormMap', id: string, objectType?: FormMapObjectType | null, language: FormLanguageCode, state: FormMapState, templateS3Key?: string | null, removePdfMaxLength: boolean, signaturePageNumberBase: SignaturePageNumberBase, templateUrl?: string | null, formDefinition: { __typename?: 'FormDefinition', id: string }, fields: Array<{ __typename?: 'FormMapFieldOutput', templateLabel: string, type: FormMapFieldType, value?: string | null, signerKey?: string | null, customFunc?: string | null, customFuncContextKeys?: Array<string> | null, formatter?: FormMapFormatter | null, errorWhenEmpty?: boolean | null, defaultValue?: string | null, dataMasks?: Array<{ __typename?: 'DataMaskOutput', mask: string, optionValue: string }> | null }> } };

export type CreateFormMapMutationVariables = Exact<{
  input: CreateFormMapInput;
}>;


export type CreateFormMapMutation = { __typename?: 'Mutation', createFormMap: { __typename?: 'CreateFormMapResponse', formMap: { __typename?: 'FormMap', id: string, createdAt: string } } };

export type UpdateFormMapMutationVariables = Exact<{
  input: UpdateFormMapInput;
}>;


export type UpdateFormMapMutation = { __typename?: 'Mutation', updateFormMap: { __typename?: 'UpdateFormMapResponse', formMap: { __typename?: 'FormMap', id: string, language: FormLanguageCode, state: FormMapState, templateS3Key?: string | null, updatedAt: string, createdAt: string, fields: Array<{ __typename?: 'FormMapFieldOutput', type: FormMapFieldType, value?: string | null, templateLabel: string, signerKey?: string | null, formatter?: FormMapFormatter | null, errorWhenEmpty?: boolean | null, defaultValue?: string | null, dataMasks?: Array<{ __typename?: 'DataMaskOutput', mask: string, optionValue: string }> | null }>, formDefinition: { __typename?: 'FormDefinition', id: string } } } };

export type FormTemplateBreadcrumbFetchFormTemplateNameQueryVariables = Exact<{
  input: FetchFormTemplateInput;
}>;


export type FormTemplateBreadcrumbFetchFormTemplateNameQuery = { __typename?: 'Query', fetchFormTemplate: { __typename?: 'FormTemplate', translatedDisplayName?: { __typename?: 'FormTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } };

export type EditArticleDialogFetchArticleQueryVariables = Exact<{
  articleId: Scalars['ObjectID']['input'];
}>;


export type EditArticleDialogFetchArticleQuery = { __typename?: 'Query', fetchArticle: { __typename?: 'FetchArticleResponse', article: { __typename?: 'Article', id: string, articleUrl?: string | null, imageUrl?: string | null, visibleToRoleIds?: Array<string> | null, organization?: { __typename?: 'PublicOrganization', id: string } | null, translatedDescription?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, translatedName: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } } };

export type ArticleListFetchArticlesQueryVariables = Exact<{
  input: FetchArticlesInput;
}>;


export type ArticleListFetchArticlesQuery = { __typename?: 'Query', fetchArticles: { __typename?: 'FetchArticlesResponse', totalCount: number, articles: Array<{ __typename?: 'Article', id: string, articleUrl?: string | null, createdAt?: string | null, state?: ArticleStates | null, imageUrl?: string | null, updatedAt?: string | null, visibleToRoleIds?: Array<string> | null, createdBy?: { __typename?: 'PublicOrganizationUser', id: string, firstName: string, lastName?: string | null } | null, organization?: { __typename?: 'PublicOrganization', id: string } | null, translatedDescription?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, translatedName: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type VisibleToRolesLabelFetchRolesQueryVariables = Exact<{
  input: FetchRolesInput;
}>;


export type VisibleToRolesLabelFetchRolesQuery = { __typename?: 'Query', fetchRoles: { __typename?: 'FetchRolesResponse', roles: Array<{ __typename?: 'Role', id: string, translatedName: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type OrgSettingsEditOrganizationLogoFetchFileDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<FileDocumentQueryFilter>;
}>;


export type OrgSettingsEditOrganizationLogoFetchFileDocumentsQuery = { __typename?: 'Query', fetchFileDocuments: { __typename?: 'FetchFileDocumentsResponse', fileDocuments: Array<{ __typename?: 'FileDocument', id: string, name?: string | null }> } };

export type PortfolioOptimizerBreadcrumbFetchPortfolioOptimizerRanAtQueryVariables = Exact<{
  input: FetchPortfolioOptimizerInput;
}>;


export type PortfolioOptimizerBreadcrumbFetchPortfolioOptimizerRanAtQuery = { __typename?: 'Query', fetchPortfolioOptimizer: { __typename?: 'FetchPortfolioOptimizerResponse', portfolioOptimizer: { __typename?: 'PortfolioOptimizer', createdAt: string } } };

export type AccountSnapshotBreadcrumbFetchAccountSnapshotLabelQueryVariables = Exact<{
  accountReconciliationSnapshotId: Scalars['ObjectID']['input'];
}>;


export type AccountSnapshotBreadcrumbFetchAccountSnapshotLabelQuery = { __typename?: 'Query', fetchAccountReconciliationSnapshot: { __typename?: 'FetchAccountReconciliationSnapshotResponse', accountReconciliationSnapshot: { __typename?: 'AccountReconciliationSnapshot', account: { __typename?: 'Account', type: AccountTypes, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, entityName?: string | null } } } } };

export type UseObjectActiveWorkflowCompletionsGetAccountQueryVariables = Exact<{
  objectId: Scalars['SafeString']['input'];
}>;


export type UseObjectActiveWorkflowCompletionsGetAccountQuery = { __typename?: 'Query', fetchObject: { __typename?: 'FetchAccountResponse', object: { __typename?: 'Account', id: string, activeWorkflowCompletions: Array<{ __typename?: 'WorkflowCompletion', id: string, objectId?: string | null, externalObjectId?: string | null, objectType: WorkflowObjectTypes, context?: Record<string, unknown> | null, user?: { __typename?: 'User', stringId: string } | null, organization: { __typename?: 'Organization', id: string }, workflow: { __typename?: 'Workflow', id: string, complex: boolean, settings: { __typename?: 'WorkflowSettings', archiveObjectsOnClose: boolean, cancelOnClose: boolean, displayCloseButton: boolean }, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, steps: Array<{ __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes, options: Record<string, unknown> }> }> }, currentStep: { __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes }> }, currentSubStep: { __typename?: 'SubStep', id: string, options: Record<string, unknown>, type: SubStepTypes, canGoBack: boolean, skippable: boolean, rolesCompleteableBy: Array<{ __typename?: 'Role', id: string }>, branches?: Array<{ __typename?: 'WorkflowStepBranch', fromKey?: string | null }> | null } }> } } };

export type UseObjectActiveWorkflowCompletionsGetGoalQueryVariables = Exact<{
  objectId: Scalars['ObjectID']['input'];
}>;


export type UseObjectActiveWorkflowCompletionsGetGoalQuery = { __typename?: 'Query', fetchObject: { __typename?: 'FetchGoalResponse', object: { __typename?: 'Goal', id: string, activeWorkflowCompletions: Array<{ __typename?: 'WorkflowCompletion', id: string, objectId?: string | null, externalObjectId?: string | null, objectType: WorkflowObjectTypes, context?: Record<string, unknown> | null, user?: { __typename?: 'User', stringId: string } | null, organization: { __typename?: 'Organization', id: string }, workflow: { __typename?: 'Workflow', id: string, complex: boolean, settings: { __typename?: 'WorkflowSettings', archiveObjectsOnClose: boolean, cancelOnClose: boolean, displayCloseButton: boolean }, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, steps: Array<{ __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes, options: Record<string, unknown> }> }> }, currentStep: { __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes }> }, currentSubStep: { __typename?: 'SubStep', id: string, options: Record<string, unknown>, type: SubStepTypes, canGoBack: boolean, skippable: boolean, rolesCompleteableBy: Array<{ __typename?: 'Role', id: string }>, branches?: Array<{ __typename?: 'WorkflowStepBranch', fromKey?: string | null }> | null } }> } } };

export type UseObjectActiveWorkflowCompletionsGetSubAccountQueryVariables = Exact<{
  objectId: Scalars['ObjectID']['input'];
}>;


export type UseObjectActiveWorkflowCompletionsGetSubAccountQuery = { __typename?: 'Query', fetchObject: { __typename?: 'FetchSubAccountResponse', object: { __typename?: 'SubAccount', id: string, activeWorkflowCompletions: Array<{ __typename?: 'WorkflowCompletion', id: string, objectId?: string | null, externalObjectId?: string | null, objectType: WorkflowObjectTypes, context?: Record<string, unknown> | null, user?: { __typename?: 'User', stringId: string } | null, organization: { __typename?: 'Organization', id: string }, workflow: { __typename?: 'Workflow', id: string, complex: boolean, settings: { __typename?: 'WorkflowSettings', archiveObjectsOnClose: boolean, cancelOnClose: boolean, displayCloseButton: boolean }, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, steps: Array<{ __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes, options: Record<string, unknown> }> }> }, currentStep: { __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes }> }, currentSubStep: { __typename?: 'SubStep', id: string, options: Record<string, unknown>, type: SubStepTypes, canGoBack: boolean, skippable: boolean, rolesCompleteableBy: Array<{ __typename?: 'Role', id: string }>, branches?: Array<{ __typename?: 'WorkflowStepBranch', fromKey?: string | null }> | null } }> } } };

export type ActiveWorkflowCompletionFieldsFragment = { __typename?: 'WorkflowCompletion', id: string, objectId?: string | null, externalObjectId?: string | null, objectType: WorkflowObjectTypes, context?: Record<string, unknown> | null, user?: { __typename?: 'User', stringId: string } | null, organization: { __typename?: 'Organization', id: string }, workflow: { __typename?: 'Workflow', id: string, complex: boolean, settings: { __typename?: 'WorkflowSettings', archiveObjectsOnClose: boolean, cancelOnClose: boolean, displayCloseButton: boolean }, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, steps: Array<{ __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes, options: Record<string, unknown> }> }> }, currentStep: { __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes }> }, currentSubStep: { __typename?: 'SubStep', id: string, options: Record<string, unknown>, type: SubStepTypes, canGoBack: boolean, skippable: boolean, rolesCompleteableBy: Array<{ __typename?: 'Role', id: string }>, branches?: Array<{ __typename?: 'WorkflowStepBranch', fromKey?: string | null }> | null } };

export type GetActiveWorkflowsQueryVariables = Exact<{
  userId: Scalars['SafeString']['input'];
}>;


export type GetActiveWorkflowsQuery = { __typename?: 'Query', fetchUser: { __typename?: 'FetchUserResponse', user: { __typename?: 'User', id: string, activeWorkflowCompletions: Array<{ __typename?: 'WorkflowCompletion', id: string, objectId?: string | null, externalObjectId?: string | null, objectType: WorkflowObjectTypes, context?: Record<string, unknown> | null, user?: { __typename?: 'User', stringId: string } | null, organization: { __typename?: 'Organization', id: string }, workflow: { __typename?: 'Workflow', id: string, complex: boolean, settings: { __typename?: 'WorkflowSettings', archiveObjectsOnClose: boolean, cancelOnClose: boolean, displayCloseButton: boolean }, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, steps: Array<{ __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes, options: Record<string, unknown> }> }> }, currentStep: { __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes }> }, currentSubStep: { __typename?: 'SubStep', id: string, options: Record<string, unknown>, type: SubStepTypes, canGoBack: boolean, skippable: boolean, rolesCompleteableBy: Array<{ __typename?: 'Role', id: string }>, branches?: Array<{ __typename?: 'WorkflowStepBranch', fromKey?: string | null }> | null } }> } } };

export type GetHouseholdActiveWorkflowsQueryVariables = Exact<{
  clientGroupId: Scalars['SafeString']['input'];
}>;


export type GetHouseholdActiveWorkflowsQuery = { __typename?: 'Query', fetchClientGroup: { __typename?: 'FetchClientGroupResponse', clientGroup?: { __typename?: 'ClientGroup', id: string, activeWorkflowCompletions: Array<{ __typename?: 'WorkflowCompletion', id: string, objectId?: string | null, externalObjectId?: string | null, objectType: WorkflowObjectTypes, context?: Record<string, unknown> | null, user?: { __typename?: 'User', stringId: string } | null, organization: { __typename?: 'Organization', id: string }, workflow: { __typename?: 'Workflow', id: string, complex: boolean, settings: { __typename?: 'WorkflowSettings', archiveObjectsOnClose: boolean, cancelOnClose: boolean, displayCloseButton: boolean }, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, steps: Array<{ __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes, options: Record<string, unknown> }> }> }, currentStep: { __typename?: 'Step', id: string, name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, subSteps: Array<{ __typename?: 'SubStep', id: string, type: SubStepTypes }> }, currentSubStep: { __typename?: 'SubStep', id: string, options: Record<string, unknown>, type: SubStepTypes, canGoBack: boolean, skippable: boolean, rolesCompleteableBy: Array<{ __typename?: 'Role', id: string }>, branches?: Array<{ __typename?: 'WorkflowStepBranch', fromKey?: string | null }> | null } }> } | null } };

export type AlertBannerBreadcrumbFetchAlertBannerNameQueryVariables = Exact<{
  alertBannerId: Scalars['ObjectID']['input'];
}>;


export type AlertBannerBreadcrumbFetchAlertBannerNameQuery = { __typename?: 'Query', fetchAlertBanner: { __typename?: 'FetchAlertBannerResponse', alertBanner: { __typename?: 'AlertBanner', name?: string | null } } };

export type BillingScheduleBreadcrumbFetchBillingScheduleFrequencyQueryVariables = Exact<{
  billingScheduleId: Scalars['ObjectID']['input'];
}>;


export type BillingScheduleBreadcrumbFetchBillingScheduleFrequencyQuery = { __typename?: 'Query', fetchBillingSchedule: { __typename?: 'FetchBillingScheduleResponse', billingSchedule: { __typename?: 'BillingSchedule', frequency: BillingScheduleFrequencies } } };

export type CreateFeeTierMutationVariables = Exact<{
  input: CreateFeeTierInput;
}>;


export type CreateFeeTierMutation = { __typename?: 'Mutation', createFeeTier: { __typename?: 'CreateFeeTierResponse', feeTier: { __typename?: 'FeeTier', id: string } } };

export type CustodianConnectionBreadcrumbFetchCustodianConnectionNamesQueryVariables = Exact<{
  input: FetchCustodianConnectionsInput;
}>;


export type CustodianConnectionBreadcrumbFetchCustodianConnectionNamesQuery = { __typename?: 'Query', fetchCustodianConnections: { __typename?: 'FetchCustodianConnectionsResponse', custodianConnections: Array<{ __typename?: 'CustodianConnection', id: string, name: string }> } };

export type DashboardListFetchOrganizationDashboardsQueryVariables = Exact<{
  input: FetchOrganizationDashboardsInput;
}>;


export type DashboardListFetchOrganizationDashboardsQuery = { __typename?: 'Query', fetchOrganizationDashboards: { __typename?: 'FetchOrganizationDashboardsResponse', totalCount: number, dashboards: Array<{ __typename?: 'Dashboard', id: string, state: DashboardStates, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, organization: { __typename?: 'PublicOrganization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }, widgets: Array<{ __typename?: 'Widget', type: WidgetChartTypes }> }> } };

export type DashboardListCreateOrganizationDashboardMutationVariables = Exact<{
  input: CreateOrganizationDashboardInput;
}>;


export type DashboardListCreateOrganizationDashboardMutation = { __typename?: 'Mutation', createOrganizationDashboard: { __typename?: 'CreateOrganizationDashboardResponse', dashboard?: { __typename?: 'Dashboard', id: string } | null } };

export type DashboardListTransitionOrganizationDashboardMutationVariables = Exact<{
  input: TransitionOrganizationDashboardInput;
}>;


export type DashboardListTransitionOrganizationDashboardMutation = { __typename?: 'Mutation', transitionOrganizationDashboard: { __typename?: 'TransitionOrganizationDashboardResponse', dashboard?: { __typename?: 'Dashboard', id: string, state: DashboardStates } | null } };

export type CopyFromDashboardDialogFetchOrganizationDashboardsQueryVariables = Exact<{
  input: FetchOrganizationDashboardsInput;
}>;


export type CopyFromDashboardDialogFetchOrganizationDashboardsQuery = { __typename?: 'Query', fetchOrganizationDashboards: { __typename?: 'FetchOrganizationDashboardsResponse', totalCount: number, dashboards: Array<{ __typename?: 'Dashboard', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null, organization: { __typename?: 'PublicOrganization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }, widgets: Array<{ __typename?: 'Widget', reportType: WidgetReportTypes }> }> } };

export type CopyFromDashboardDialogFetchOrganizationDashboardQueryVariables = Exact<{
  dashboardId: Scalars['ObjectID']['input'];
}>;


export type CopyFromDashboardDialogFetchOrganizationDashboardQuery = { __typename?: 'Query', fetchOrganizationDashboard: { __typename?: 'FetchOrganizationDashboardResponse', dashboard: { __typename?: 'Dashboard', id: string, globalFilters: Array<{ __typename?: 'DashboardGlobalFilter', reportType: WidgetReportTypes, field: string, comparison: WidgetFilterComparisonTypes, value: string }>, widgets: Array<{ __typename?: 'Widget', type: WidgetChartTypes, columns: Array<string>, format: WidgetFormatTypes, height: number, width: number, x?: number | null, y?: number | null, reportType: WidgetReportTypes, sortDesc: boolean, sortField: string, filters: Array<{ __typename?: 'WidgetFilter', comparison: WidgetFilterComparisonTypes, field: string, value: string }>, grouping: { __typename?: 'WidgetGrouping', field?: string | null, interval?: WidgetInterval | null, type: WidgetGroupingType, valueAggregation: WidgetValueAggregation, valueField: string }, translatedTitle?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null }> } } };

export type AssignSearchUsersQueryVariables = Exact<{
  input: UserSearchInput;
}>;


export type AssignSearchUsersQuery = { __typename?: 'Query', searchUsers?: { __typename?: 'UserSearchResult', totalCount: number, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, entityName?: string | null, type?: EntityTypes | null, state: UserState, feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null, feeSetting?: { __typename?: 'UserFeeSetting', feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null } | null }> } | null };

export type AssignFetchClientGroupsQueryVariables = Exact<{
  input: FetchClientGroupsInput;
}>;


export type AssignFetchClientGroupsQuery = { __typename?: 'Query', fetchClientGroups: { __typename?: 'FetchClientGroupsResponse', totalCount: number, clientGroups: Array<{ __typename?: 'ClientGroup', id: string, name: string, state: ClientGroupStates, feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null, feeSetting?: { __typename?: 'ClientGroupFeeSetting', feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null } | null }> } };

export type AssignSearchAccountsQueryVariables = Exact<{
  input: AccountSearchInput;
}>;


export type AssignSearchAccountsQuery = { __typename?: 'Query', searchAccounts?: { __typename?: 'AccountSearchResult', totalCount: number, accounts: Array<{ __typename?: 'Account', id: string, type: AccountTypes, custodianAccountNumber?: string | null, state: AccountStates, feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null, feeSetting?: { __typename?: 'AccountFeeSetting', feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null } | null }> } | null };

export type AssignFetchAccountGroupsQueryVariables = Exact<{
  input: FetchAccountGroupsInput;
}>;


export type AssignFetchAccountGroupsQuery = { __typename?: 'Query', fetchAccountGroups: { __typename?: 'FetchAccountGroupsResponse', totalCount: number, accountGroups: Array<{ __typename?: 'AccountGroup', id: string, state: AccountGroupStates, translatedName: { __typename?: 'AccountTranslatedString', en?: string | null, fr?: string | null, es?: string | null }, feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null, feeSetting?: { __typename?: 'AccountGroupFeeSetting', feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null } | null }> } };

export type AssignFetchSubAccountsQueryVariables = Exact<{
  input: FetchSubAccountsInput;
}>;


export type AssignFetchSubAccountsQuery = { __typename?: 'Query', fetchSubAccounts: { __typename?: 'FetchSubAccountsResponse', totalCount: number, subAccounts: Array<{ __typename?: 'SubAccount', id: string, name?: string | null, state: SubAccountStates, goal?: { __typename?: 'Goal', id: string, type?: GoalTypes | null, name?: string | null } | null, financialProduct?: { __typename?: 'FinancialProduct', translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, account: { __typename?: 'Account', type: AccountTypes, custodianAccountNumber?: string | null, user: { __typename?: 'User', firstName?: string | null, middleName?: string | null, lastName?: string | null, entityName?: string | null, type?: EntityTypes | null } }, feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null, feeSetting?: { __typename?: 'SubAccountFeeSetting', feeTier?: { __typename?: 'FeeTier', id: string, name: string } | null } | null }> } };

export type FeeGridBreadcrumbFetchFeeGridNameQueryVariables = Exact<{
  feeTierId: Scalars['ObjectID']['input'];
}>;


export type FeeGridBreadcrumbFetchFeeGridNameQuery = { __typename?: 'Query', fetchFeeTier: { __typename?: 'FetchFeeTierResponse', feeTier: { __typename?: 'FeeTier', name: string } } };

export type FetchFeeTierEntityCountsQueryVariables = Exact<{
  feeTierId: Scalars['ObjectID']['input'];
}>;


export type FetchFeeTierEntityCountsQuery = { __typename?: 'Query', subAccount: { __typename?: 'FetchEntityFeeSettingsResponse', totalCount: number }, account: { __typename?: 'FetchEntityFeeSettingsResponse', totalCount: number }, accountGroup: { __typename?: 'FetchEntityFeeSettingsResponse', totalCount: number }, user: { __typename?: 'FetchEntityFeeSettingsResponse', totalCount: number }, clientGroup: { __typename?: 'FetchEntityFeeSettingsResponse', totalCount: number } };

export type UnassignEntityFeeTierMutationVariables = Exact<{
  entity: FeeEntityIdentifier;
  input: UpdateEntityFeeInput;
}>;


export type UnassignEntityFeeTierMutation = { __typename?: 'Mutation', updateEntityFeeSetting: { __typename?: 'UpdateEntityFeeResponse', subAccount?: { __typename?: 'SubAccount', id: string } | null, account?: { __typename?: 'Account', id: string } | null, accountGroup?: { __typename?: 'AccountGroup', id: string } | null, user?: { __typename?: 'User', id: string } | null, clientGroup?: { __typename?: 'ClientGroup', id: string } | null } };

export type AssignEntityFeeTierMutationVariables = Exact<{
  entity: FeeEntityIdentifier;
  input: UpdateEntityFeeInput;
}>;


export type AssignEntityFeeTierMutation = { __typename?: 'Mutation', updateEntityFeeSetting: { __typename?: 'UpdateEntityFeeResponse', subAccount?: { __typename?: 'SubAccount', id: string } | null, account?: { __typename?: 'Account', id: string } | null, accountGroup?: { __typename?: 'AccountGroup', id: string } | null, user?: { __typename?: 'User', id: string } | null, clientGroup?: { __typename?: 'ClientGroup', id: string } | null } };

export type FetchEntityFeeSettingsListQueryVariables = Exact<{
  entityType: FeeEntity;
  feeTierId: Scalars['ObjectID']['input'];
  offSet?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchEntityFeeSettingsListQuery = { __typename?: 'Query', fetchEntityFeeSettings: { __typename?: 'FetchEntityFeeSettingsResponse', totalCount: number, entityFeeSettings: Array<{ __typename?: 'EntityFeeSetting', id: string, subAccount?: { __typename?: 'SubAccount', id: string, name?: string | null, state: SubAccountStates, goal?: { __typename?: 'Goal', id: string, type?: GoalTypes | null, name?: string | null } | null, financialProduct?: { __typename?: 'FinancialProduct', id: string, translatedName: { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, statistics?: { __typename?: 'Statistics', marketValueCents?: number | null } | null, account: { __typename?: 'Account', id: string, type: AccountTypes, user: { __typename?: 'User', id: string, type?: EntityTypes | null } } } | null, account?: { __typename?: 'Account', id: string, type: AccountTypes, custodianAccountNumber?: string | null, state: AccountStates, user: { __typename?: 'User', id: string, type?: EntityTypes | null } } | null, accountGroup?: { __typename?: 'AccountGroup', id: string, state: AccountGroupStates, translatedName: { __typename?: 'AccountTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } | null, clientGroup?: { __typename?: 'ClientGroup', id: string, name: string, state: ClientGroupStates } | null, user?: { __typename?: 'User', id: string, entityName?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, state: UserState, type?: EntityTypes | null } | null }> } };

export type FetchFeeTierQueryVariables = Exact<{
  feeTierId: Scalars['ObjectID']['input'];
}>;


export type FetchFeeTierQuery = { __typename?: 'Query', fetchFeeTier: { __typename?: 'FetchFeeTierResponse', feeTier: { __typename?: 'FeeTier', id: string, state: FeeTierStates, name: string, default: boolean, chargeForCash?: boolean | null, chargeForCashOnHold?: boolean | null, flatAnnualFeeBps?: number | null, gridScopeType?: FeeGridScopeTypes | null, blendedGrid?: boolean | null, grid?: Array<{ __typename?: 'FeeGrid', minMarketValueCents?: number | null, annualFeeBps?: number | null, annualFeeCents?: number | null } | null> | null, organization?: { __typename?: 'PublicOrganization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } | null } } };

export type UpdateFeeTierMutationVariables = Exact<{
  input: UpdateFeeTierInput;
}>;


export type UpdateFeeTierMutation = { __typename?: 'Mutation', updateFeeTier: { __typename?: 'UpdateFeeTierResponse', feeTier: { __typename?: 'FeeTier', id: string } } };

export type TransitionFeeTierMutationVariables = Exact<{
  input: TransitionFeeTierInput;
}>;


export type TransitionFeeTierMutation = { __typename?: 'Mutation', transitionFeeTier: { __typename?: 'TransitionFeeTierResponse', feeTier: { __typename?: 'FeeTier', id: string } } };

export type HomePageConfigurationBreadcrumbFetchHomePageConfigurationNameQueryVariables = Exact<{
  homePageConfigurationId: Scalars['ObjectID']['input'];
}>;


export type HomePageConfigurationBreadcrumbFetchHomePageConfigurationNameQuery = { __typename?: 'Query', fetchHomePageConfiguration: { __typename?: 'FetchHomePageConfigurationResponse', homePageConfiguration: { __typename?: 'HomePageConfiguration', translatedName: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } } };

export type PageConfigurationBreadcrumbFetchPageConfigurationNameQueryVariables = Exact<{
  pageConfigurationId: Scalars['ObjectID']['input'];
}>;


export type PageConfigurationBreadcrumbFetchPageConfigurationNameQuery = { __typename?: 'Query', fetchPageConfiguration: { __typename?: 'FetchPageConfigurationResponse', pageConfiguration: { __typename?: 'PageConfiguration', name: string } } };

export type ReconToleranceOwnPolicyFieldsFragment = { __typename?: 'ReconTolerancePolicy', breakType: ReconToleranceBreakType, enabled: boolean, thresholdCents?: number | null, dailyCapCents?: number | null, notifyOnReconcile: boolean };

export type ReconToleranceEffectivePolicyFieldsFragment = { __typename?: 'EffectiveReconTolerancePolicy', breakType: ReconToleranceBreakType, enabled: boolean, thresholdCents: number, dailyCapCents: number, notifyOnReconcile: boolean, policySource: ReconTolerancePolicySource, policySourceOrganizationId?: string | null };

export type ReconToleranceFetchOrganizationPoliciesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReconToleranceFetchOrganizationPoliciesQuery = { __typename?: 'Query', fetchOrganization: { __typename?: 'FetchOrganizationResponse', organization: { __typename?: 'Organization', id: string, reconTolerancePolicies: Array<{ __typename?: 'ReconTolerancePolicy', breakType: ReconToleranceBreakType, enabled: boolean, thresholdCents?: number | null, dailyCapCents?: number | null, notifyOnReconcile: boolean }>, effectiveReconTolerancePolicies: Array<{ __typename?: 'EffectiveReconTolerancePolicy', breakType: ReconToleranceBreakType, enabled: boolean, thresholdCents: number, dailyCapCents: number, notifyOnReconcile: boolean, policySource: ReconTolerancePolicySource, policySourceOrganizationId?: string | null }> } } };

export type ReconToleranceUpdateOrgPolicyMutationVariables = Exact<{
  input: UpdateOrgReconTolerancePolicyInput;
}>;


export type ReconToleranceUpdateOrgPolicyMutation = { __typename?: 'Mutation', updateOrgReconTolerancePolicy: { __typename?: 'Organization', id: string, reconTolerancePolicies: Array<{ __typename?: 'ReconTolerancePolicy', breakType: ReconToleranceBreakType, enabled: boolean, thresholdCents?: number | null, dailyCapCents?: number | null, notifyOnReconcile: boolean }>, effectiveReconTolerancePolicies: Array<{ __typename?: 'EffectiveReconTolerancePolicy', breakType: ReconToleranceBreakType, enabled: boolean, thresholdCents: number, dailyCapCents: number, notifyOnReconcile: boolean, policySource: ReconTolerancePolicySource, policySourceOrganizationId?: string | null }> } };

export type SalesTaxFetchConfigurationQueryVariables = Exact<{
  input: FetchSalesTaxConfigurationInput;
}>;


export type SalesTaxFetchConfigurationQuery = { __typename?: 'Query', fetchSalesTaxConfiguration: { __typename?: 'FetchSalesTaxConfigurationResponse', salesTaxConfiguration: { __typename?: 'SalesTaxConfiguration', applicableDate: string, localRevision?: { __typename?: 'SalesTaxConfigurationRevision', id: string, effectiveFrom: string } | null, effectiveConfiguration: { __typename?: 'EffectiveSalesTaxConfiguration', source: SalesTaxConfigurationSource, inherited: boolean, configurableTaxes: Array<{ __typename?: 'ConfigurableSalesTax', identity: ConfigurableSalesTaxIdentity, enabled: boolean }>, revision?: { __typename?: 'SalesTaxConfigurationRevision', id: string, effectiveFrom: string } | null, configurationOwner?: { __typename?: 'PublicOrganization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } | null, legacyFallbackSource?: { __typename?: 'PublicOrganization', id: string, translatedName?: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } | null } | null } } } };

export type SalesTaxCreateConfigurationRevisionMutationVariables = Exact<{
  input: CreateSalesTaxConfigurationRevisionInput;
}>;


export type SalesTaxCreateConfigurationRevisionMutation = { __typename?: 'Mutation', createSalesTaxConfigurationRevision: { __typename?: 'CreateSalesTaxConfigurationRevisionResponse', salesTaxConfigurationRevision: { __typename?: 'SalesTaxConfigurationRevision', id: string, effectiveFrom: string } } };

export type SalesTaxPollInheritanceQueryVariables = Exact<{
  input: FetchSalesTaxConfigurationInput;
}>;


export type SalesTaxPollInheritanceQuery = { __typename?: 'Query', fetchSalesTaxConfiguration: { __typename?: 'FetchSalesTaxConfigurationResponse', salesTaxConfiguration: { __typename?: 'SalesTaxConfiguration', applicableDate: string, effectiveConfiguration: { __typename?: 'EffectiveSalesTaxConfiguration', inherited: boolean } } } };

export type SalesTaxFetchOrganizationInheritanceQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type SalesTaxFetchOrganizationInheritanceQuery = { __typename?: 'Query', fetchOrganization: { __typename?: 'FetchOrganizationResponse', organization: { __typename?: 'Organization', id: string, useParentSalesTaxConfiguration?: boolean | null } } };

export type StaticPageWidgetConfigurationBreadcrumbFetchStaticPageWidgetConfigurationNameQueryVariables = Exact<{
  staticPageWidgetConfigurationId: Scalars['ObjectID']['input'];
}>;


export type StaticPageWidgetConfigurationBreadcrumbFetchStaticPageWidgetConfigurationNameQuery = { __typename?: 'Query', fetchStaticPageWidgetConfiguration: { __typename?: 'FetchStaticPageWidgetConfigurationResponse', staticPageWidgetConfiguration: { __typename?: 'StaticPageWidgetConfiguration', name: string } } };

export type FetchOrganizationThemeTokensQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type FetchOrganizationThemeTokensQuery = { __typename?: 'Query', fetchOrganization: { __typename?: 'FetchOrganizationResponse', organization: { __typename?: 'Organization', id: string, themeTokens?: Record<string, unknown> | null, useParentThemeTokens?: boolean | null } } };

export type UpdateOrganizationThemeTokensMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationThemeTokensMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationResponse', organization?: { __typename?: 'Organization', id: string } | null } };

export type FetchFormDefinitionsQueryVariables = Exact<{
  input: FetchFormDefinitionsInput;
}>;


export type FetchFormDefinitionsQuery = { __typename?: 'Query', fetchFormDefinitions: { __typename?: 'FetchFormDefinitionsResponse', formDefinitions: Array<{ __typename?: 'FormDefinition', id: string, key: string, state: FormDefinitionStates, translatedName: { __typename?: 'FormTranslatedString', en?: string | null, fr?: string | null, es?: string | null } }> } };

export type FetchRoleProfilesQueryVariables = Exact<{
  input: FetchRoleProfilesInput;
}>;


export type FetchRoleProfilesQuery = { __typename?: 'Query', fetchRoleProfiles: { __typename?: 'FetchRoleProfilesResponse', roleProfiles: Array<{ __typename?: 'RoleProfile', id: string, organization?: { __typename?: 'Organization', id: string } | null, translatedName: { __typename?: 'OrganizationTranslatedString', en?: string | null }, translatedDescription: { __typename?: 'OrganizationTranslatedString', en?: string | null }, template?: { __typename?: 'RoleProfileTemplate', permissions: Array<string>, accessiblePages: Array<Pages>, dashboards: Array<{ __typename?: 'Dashboard', id: string, name?: string | null }> } | null }> } };

export type WorkflowBreadcrumbFetchWorkflowNameQueryVariables = Exact<{
  workflowId: Scalars['ObjectID']['input'];
}>;


export type WorkflowBreadcrumbFetchWorkflowNameQuery = { __typename?: 'Query', fetchWorkflow: { __typename?: 'FetchWorkflowResponse', workflow: { __typename?: 'Workflow', name: { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } } };

export type ResolvedAdvisorContactFieldsFragment = { __typename?: 'ResolvedAdvisorContact', firstName?: string | null, lastName?: string | null, phone?: string | null, phoneExtension?: string | null, email?: string | null, displayRoleLabel?: string | null, source: ResolvedAdvisorContactSources, advisorContact?: { __typename?: 'AdvisorContact', id: string } | null, organizationUser?: { __typename?: 'PublicOrganizationUser', id: string, firstName: string, lastName?: string | null, email?: string | null, phone?: string | null, avatar?: string | null, displayRole?: { __typename?: 'DisplayRole', id: string, name: string } | null, role: { __typename?: 'PublicRole', translatedName: { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null } } } | null, address?: { __typename?: 'AdvisorContactAddress', unitNumber?: string | null, houseNumber?: string | null, streetName?: string | null, neighborhood?: string | null, city?: string | null, province?: string | null, jurisdiction?: string | null, country?: string | null, postal?: string | null } | null, displayRole?: { __typename?: 'DisplayRole', id: string, name: string, order: number } | null, resolutionPath: { __typename?: 'ResolutionPath', reason: ResolutionReasons, viaRepCode?: string | null, fieldSources: { __typename?: 'ResolvedFieldSources', firstName: FieldSources, lastName: FieldSources, phone: FieldSources, phoneExtension: FieldSources, email: FieldSources, displayRole: FieldSources } } };

export type OrganizationTranslatedStringFragment = { __typename?: 'OrganizationTranslatedString', en?: string | null, fr?: string | null, es?: string | null };

export type NotificationTranslatedStringFragment = { __typename?: 'NotificationTranslatedString', en?: string | null, fr?: string | null, es?: string | null };

export type CustodianTranslatedStringFragment = { __typename?: 'CustodianTranslatedString', en: string, fr?: string | null, es?: string | null };

export type WorkflowTranslatedStringFragment = { __typename?: 'WorkflowTranslatedString', en?: string | null, fr?: string | null, es?: string | null };

export type ProductTranslatedStringFragment = { __typename?: 'ProductTranslatedString', en?: string | null, fr?: string | null, es?: string | null };

export type FormTranslatedStringFragment = { __typename?: 'FormTranslatedString', en?: string | null, fr?: string | null, es?: string | null };

export type UserTranslatedStringFragment = { __typename?: 'UserTranslatedString', en?: string | null, fr?: string | null, es?: string | null };

export const NotificationTranslatedStringFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<NotificationTranslatedStringFragment, unknown>;
export const NotificationsFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<NotificationsFieldsFragment, unknown>;
export const CustodianTranslatedStringFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<CustodianTranslatedStringFragment, unknown>;
export const CustodianNotificationsFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianNotificationsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<CustodianNotificationsFieldsFragment, unknown>;
export const OrganizationTranslatedStringFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<OrganizationTranslatedStringFragment, unknown>;
export const AlertBannerInteractionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AlertBannerInteractionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlertBannerInteraction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertBanner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bannerType"}},{"kind":"Field","name":{"kind":"Name","value":"bannerCopy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayOnWeb"}},{"kind":"Field","name":{"kind":"Name","value":"displayOnIOS"}},{"kind":"Field","name":{"kind":"Name","value":"displayOnAndroid"}},{"kind":"Field","name":{"kind":"Name","value":"makeDismissible"}},{"kind":"Field","name":{"kind":"Name","value":"enableAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"persistenceBehaviour"}},{"kind":"Field","name":{"kind":"Name","value":"actionButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<AlertBannerInteractionFieldsFragment, unknown>;
export const ProductTranslatedStringFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<ProductTranslatedStringFragment, unknown>;
export const ModelPortfolioSearchFieldOptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModelPortfolioSearchFieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<ModelPortfolioSearchFieldOptionFragment, unknown>;
export const DashboardGlobalFilterFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardGlobalFilterFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardGlobalFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<DashboardGlobalFilterFieldsFragment, unknown>;
export const DashboardWidgetFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardWidgetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Widget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"grouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"valueAggregation"}},{"kind":"Field","name":{"kind":"Name","value":"valueField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"sortDesc"}},{"kind":"Field","name":{"kind":"Name","value":"sortField"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]} as unknown as DocumentNode<DashboardWidgetFieldsFragment, unknown>;
export const CustodianActivityGridFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianActivityGridFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"processDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"settleDate"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"transactionDesc"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"subTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"amountValueCents"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"cusip"}},{"kind":"Field","name":{"kind":"Name","value":"securityType"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"accruedInterest"}},{"kind":"Field","name":{"kind":"Name","value":"bookValueAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"isCancel"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"reconcileMethod"}},{"kind":"Field","name":{"kind":"Name","value":"reconciledAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]} as unknown as DocumentNode<CustodianActivityGridFieldsFragment, unknown>;
export const WorkflowTranslatedStringFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<WorkflowTranslatedStringFragment, unknown>;
export const ActiveWorkflowCompletionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowCompletion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"externalObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"complex"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveObjectsOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"cancelOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"displayCloseButton"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSubStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"canGoBack"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"rolesCompleteableBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromKey"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<ActiveWorkflowCompletionFieldsFragment, unknown>;
export const ReconToleranceOwnPolicyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReconToleranceOwnPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReconTolerancePolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdCents"}},{"kind":"Field","name":{"kind":"Name","value":"dailyCapCents"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOnReconcile"}}]}}]} as unknown as DocumentNode<ReconToleranceOwnPolicyFieldsFragment, unknown>;
export const ReconToleranceEffectivePolicyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReconToleranceEffectivePolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EffectiveReconTolerancePolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdCents"}},{"kind":"Field","name":{"kind":"Name","value":"dailyCapCents"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOnReconcile"}},{"kind":"Field","name":{"kind":"Name","value":"policySource"}},{"kind":"Field","name":{"kind":"Name","value":"policySourceOrganizationId"}}]}}]} as unknown as DocumentNode<ReconToleranceEffectivePolicyFieldsFragment, unknown>;
export const ResolvedAdvisorContactFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResolvedAdvisorContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResolvedAdvisorContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advisorContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"displayRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phoneExtension"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"jurisdiction"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayRoleLabel"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"viaRepCode"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phoneExtension"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayRole"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<ResolvedAdvisorContactFieldsFragment, unknown>;
export const FormTranslatedStringFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<FormTranslatedStringFragment, unknown>;
export const UserTranslatedStringFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<UserTranslatedStringFragment, unknown>;
export const AddCurrencyDialogFetchAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addCurrencyDialogFetchAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canReadAccountNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"baseCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"availableCurrencies"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canReadAccountNumber"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"custodianConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"baseCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountTypeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"availableCurrencies"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<AddCurrencyDialogFetchAccountQuery, AddCurrencyDialogFetchAccountQueryVariables>;
export const AddCurrencyMenuFetchAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addCurrencyMenuFetchAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"baseCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"custodianConnection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddCurrencyMenuFetchAccountQuery, AddCurrencyMenuFetchAccountQueryVariables>;
export const AddCurrencyDialogFetchAccountCurrenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addCurrencyDialogFetchAccountCurrencies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableCurrencies"}}]}}]}}]}}]} as unknown as DocumentNode<AddCurrencyDialogFetchAccountCurrenciesQuery, AddCurrencyDialogFetchAccountCurrenciesQueryVariables>;
export const AddCurrencyDialogFetchOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addCurrencyDialogFetchOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productShelfCurrencies"}},{"kind":"Field","name":{"kind":"Name","value":"useParentProductShelf"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<AddCurrencyDialogFetchOrganizationQuery, AddCurrencyDialogFetchOrganizationQueryVariables>;
export const AddCurrencyDialogFetchHoldingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addCurrencyDialogFetchHoldings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchHoldingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchHoldings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCash"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"originalCurrency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddCurrencyDialogFetchHoldingsQuery, AddCurrencyDialogFetchHoldingsQueryVariables>;
export const AddCurrencyDialogFetchSubAccountStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addCurrencyDialogFetchSubAccountStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatisticsCurrencyTypes"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchSubAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalCurrencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"moneyAvailableCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalCurrenciesMissingRate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"moneyAvailableCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCash"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"originalCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddCurrencyDialogFetchSubAccountStatisticsQuery, AddCurrencyDialogFetchSubAccountStatisticsQueryVariables>;
export const AddCurrencyDialogBulkUpsertAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCurrencyDialogBulkUpsertAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpsertAccountsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpsertAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpsertRequestId"}}]}}]}}]} as unknown as DocumentNode<AddCurrencyDialogBulkUpsertAccountsMutation, AddCurrencyDialogBulkUpsertAccountsMutationVariables>;
export const AddCurrencyDialogUpdateAllHoldingsAndCashDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCurrencyDialogUpdateAllHoldingsAndCash"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAllHoldingsAndCashInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAllHoldingsAndCash"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AddCurrencyDialogUpdateAllHoldingsAndCashMutation, AddCurrencyDialogUpdateAllHoldingsAndCashMutationVariables>;
export const AddSecuritiesDialogSearchShelfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addSecuritiesDialogSearchShelf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchFinancialProductsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFinancialProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"financialProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"isCash"}},{"kind":"Field","name":{"kind":"Name","value":"exchange"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"currentPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryAssetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryAssetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tertiaryAssetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<AddSecuritiesDialogSearchShelfQuery, AddSecuritiesDialogSearchShelfQueryVariables>;
export const UseAssetClassColorsFetchRegistryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"useAssetClassColorsFetchRegistry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchAssetClassesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAssetClasses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClasses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UseAssetClassColorsFetchRegistryQuery, UseAssetClassColorsFetchRegistryQueryVariables>;
export const FetchBulkTraderTimestampDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchBulkTraderTimestamp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bulkTraderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchBulkTradeRun"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bulkTradeRunId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bulkTraderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkTradeRun"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<FetchBulkTraderTimestampQuery, FetchBulkTraderTimestampQueryVariables>;
export const FormDefinitionOptionsFetchFormDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formDefinitionOptionsFetchFormDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchFormDefinitionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFormDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formDefinitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<FormDefinitionOptionsFetchFormDefinitionsQuery, FormDefinitionOptionsFetchFormDefinitionsQueryVariables>;
export const UseHasHouseholdMenuItemsFetchPortfolioSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"useHasHouseholdMenuItemsFetchPortfolioSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchClientGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clientGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowPortfolioPerHousehold"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UseHasHouseholdMenuItemsFetchPortfolioSettingQuery, UseHasHouseholdMenuItemsFetchPortfolioSettingQueryVariables>;
export const UseArchiveHouseholdCopyArchiveEntityBoundModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"useArchiveHouseholdCopyArchiveEntityBoundModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArchiveEntityBoundModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveEntityBoundModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"modelPortfolio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]} as unknown as DocumentNode<UseArchiveHouseholdCopyArchiveEntityBoundModelMutation, UseArchiveHouseholdCopyArchiveEntityBoundModelMutationVariables>;
export const AppBarAvatarMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appBarAvatarMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<AppBarAvatarMeQuery, AppBarAvatarMeQueryVariables>;
export const ChangeAvatarModalMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"changeAvatarModalMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]} as unknown as DocumentNode<ChangeAvatarModalMeQuery, ChangeAvatarModalMeQueryVariables>;
export const ChangeAvatarModalFetchFileUploadUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"changeAvatarModalFetchFileUploadUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchFileUploadUrlInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFileUploadUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"temporarySignedURL"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<ChangeAvatarModalFetchFileUploadUrlQuery, ChangeAvatarModalFetchFileUploadUrlQueryVariables>;
export const ChangeAvatarModalCreateFileDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeAvatarModalCreateFileDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFileDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFileDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeAvatarModalCreateFileDocumentMutation, ChangeAvatarModalCreateFileDocumentMutationVariables>;
export const ChangeAvatarModalDeleteFileDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeAvatarModalDeleteFileDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileDocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFileDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fileDocumentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileDocumentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeAvatarModalDeleteFileDocumentMutation, ChangeAvatarModalDeleteFileDocumentMutationVariables>;
export const ChangeAvatarModalUpdateOrganizationUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeAvatarModalUpdateOrganizationUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeAvatarModalUpdateOrganizationUserProfileMutation, ChangeAvatarModalUpdateOrganizationUserProfileMutationVariables>;
export const LanguageSelectionModalUpdateOrganizationUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"languageSelectionModalUpdateOrganizationUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]} as unknown as DocumentNode<LanguageSelectionModalUpdateOrganizationUserProfileMutation, LanguageSelectionModalUpdateOrganizationUserProfileMutationVariables>;
export const NewOrganizationModalCreateOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"newOrganizationModalCreateOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<NewOrganizationModalCreateOrganizationMutation, NewOrganizationModalCreateOrganizationMutationVariables>;
export const NotificationPreferencesModalSetUserNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationPreferencesModalSetUserNotificationPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"setUserNotificationPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setUserNotificationPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<NotificationPreferencesModalSetUserNotificationPreferencesMutation, NotificationPreferencesModalSetUserNotificationPreferencesMutationVariables>;
export const NotificationsFetchNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"notificationsFetchNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchNotificationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationsFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Notification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<NotificationsFetchNotificationsQuery, NotificationsFetchNotificationsQueryVariables>;
export const NotificationsFetchCustodianNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"notificationsFetchCustodianNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchCustodianNotificationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchCustodianNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianNotificationsFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianNotificationsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"body"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<NotificationsFetchCustodianNotificationsQuery, NotificationsFetchCustodianNotificationsQueryVariables>;
export const NotificationsMarkAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationsMarkAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkNotificationAsReadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markNotificationAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>;
export const NotificationsMarkAllAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"notificationsMarkAllAsRead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAllNotificationsAsRead"}}]}}]} as unknown as DocumentNode<NotificationsMarkAllAsReadMutation, NotificationsMarkAllAsReadMutationVariables>;
export const OrganizationLogoFetchFileDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationLogoFetchFileDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FileDocumentQueryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFileDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"1"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortDesc"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortField"},"value":{"kind":"StringValue","value":"createdAt","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationLogoFetchFileDocumentsQuery, OrganizationLogoFetchFileDocumentsQueryVariables>;
export const OrganizationSwitcherSearchOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationSwitcherSearchOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchOrganizationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<OrganizationSwitcherSearchOrganizationsQuery, OrganizationSwitcherSearchOrganizationsQueryVariables>;
export const OrganizationSwitcherFetchInitialOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationSwitcherFetchInitialOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<OrganizationSwitcherFetchInitialOrganizationsQuery, OrganizationSwitcherFetchInitialOrganizationsQueryVariables>;
export const OrganizationSwitcherFetchChildOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationSwitcherFetchChildOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<OrganizationSwitcherFetchChildOrganizationsQuery, OrganizationSwitcherFetchChildOrganizationsQueryVariables>;
export const AlertBannerFetchVisibleAlertBannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"alertBannerFetchVisibleAlertBanners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchVisibleAlertBannersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchVisibleAlertBanners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"visibleAlertBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AlertBannerFetchVisibleAlertBannersQuery, AlertBannerFetchVisibleAlertBannersQueryVariables>;
export const AlertBannerUpsertAlertBannerInteractionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"alertBannerUpsertAlertBannerInteractions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertAlertBannerInteractionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAlertBannerInteractions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alertBannerInteractions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AlertBannerInteractionFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AlertBannerInteractionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlertBannerInteraction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alertBanner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bannerType"}},{"kind":"Field","name":{"kind":"Name","value":"bannerCopy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayOnWeb"}},{"kind":"Field","name":{"kind":"Name","value":"displayOnIOS"}},{"kind":"Field","name":{"kind":"Name","value":"displayOnAndroid"}},{"kind":"Field","name":{"kind":"Name","value":"makeDismissible"}},{"kind":"Field","name":{"kind":"Name","value":"enableAction"}}]}},{"kind":"Field","name":{"kind":"Name","value":"persistenceBehaviour"}},{"kind":"Field","name":{"kind":"Name","value":"actionButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<AlertBannerUpsertAlertBannerInteractionsMutation, AlertBannerUpsertAlertBannerInteractionsMutationVariables>;
export const AlertBannerTransitionAlertBannerInteractionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"alertBannerTransitionAlertBannerInteraction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransitionAlertBannerInteractionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transitionAlertBannerInteraction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alertBannerInteraction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AlertBannerTransitionAlertBannerInteractionMutation, AlertBannerTransitionAlertBannerInteractionMutationVariables>;
export const ModelPortfolioSearchFieldSearchModelPortfoliosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"modelPortfolioSearchFieldSearchModelPortfolios"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchModelPortfoliosInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchModelPortfolios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"modelPortfolios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModelPortfolioSearchFieldOption"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModelPortfolioSearchFieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}}]} as unknown as DocumentNode<ModelPortfolioSearchFieldSearchModelPortfoliosQuery, ModelPortfolioSearchFieldSearchModelPortfoliosQueryVariables>;
export const ModelPortfolioSearchFieldFetchSelectedModelPortfolioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"modelPortfolioSearchFieldFetchSelectedModelPortfolio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modelPortfolioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchModelPortfolio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"modelPortfolioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modelPortfolioId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"modelPortfolio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModelPortfolioSearchFieldOption"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModelPortfolioSearchFieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}}]} as unknown as DocumentNode<ModelPortfolioSearchFieldFetchSelectedModelPortfolioQuery, ModelPortfolioSearchFieldFetchSelectedModelPortfolioQueryVariables>;
export const CreateRepCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRepCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRepCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRepCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRepCodeMutation, CreateRepCodeMutationVariables>;
export const UpdateRepCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRepCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRepCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRepCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRepCodeMutation, UpdateRepCodeMutationVariables>;
export const TransitionRepCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"transitionRepCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransitionRepCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transitionRepCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<TransitionRepCodeMutation, TransitionRepCodeMutationVariables>;
export const SecuritySearchSelectSearchSecuritiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"securitySearchSelectSearchSecurities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchFinancialProductsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFinancialProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"financialProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"isCash"}},{"kind":"Field","name":{"kind":"Name","value":"taxRank"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryAssetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryAssetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tertiaryAssetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<SecuritySearchSelectSearchSecuritiesQuery, SecuritySearchSelectSearchSecuritiesQueryVariables>;
export const WorkflowLauncherFetchWorkflowObjectTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workflowLauncherFetchWorkflowObjectType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workflowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}}]}}]}}]} as unknown as DocumentNode<WorkflowLauncherFetchWorkflowObjectTypeQuery, WorkflowLauncherFetchWorkflowObjectTypeQueryVariables>;
export const WorkflowLauncherCreateWorkflowCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"workflowLauncherCreateWorkflowCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkflowCompletionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkflowCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowCompletion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<WorkflowLauncherCreateWorkflowCompletionMutation, WorkflowLauncherCreateWorkflowCompletionMutationVariables>;
export const SearchPhysicalAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchPhysicalAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchPhysicalAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPhysicalAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"next"}}]}}]}}]}}]} as unknown as DocumentNode<SearchPhysicalAddressQuery, SearchPhysicalAddressQueryVariables>;
export const FetchPhysicalAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchPhysicalAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchPhysicalAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPhysicalAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postal"}},{"kind":"Field","name":{"kind":"Name","value":"jurisdiction"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"CountryIso2"}},{"kind":"Field","name":{"kind":"Name","value":"CountryIso3"}},{"kind":"Field","name":{"kind":"Name","value":"CountryName"}},{"kind":"Field","name":{"kind":"Name","value":"Province"}},{"kind":"Field","name":{"kind":"Name","value":"ProvinceCode"}}]}}]}}]}}]} as unknown as DocumentNode<FetchPhysicalAddressQuery, FetchPhysicalAddressQueryVariables>;
export const EditOrganizationLogoFetchFileDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"editOrganizationLogoFetchFileDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FileDocumentQueryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFileDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"1"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortDesc"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortField"},"value":{"kind":"StringValue","value":"createdAt","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<EditOrganizationLogoFetchFileDocumentsQuery, EditOrganizationLogoFetchFileDocumentsQueryVariables>;
export const FormDefinitionSelectFetchFormDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formDefinitionSelectFetchFormDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchFormDefinitionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFormDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formDefinitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<FormDefinitionSelectFetchFormDefinitionsQuery, FormDefinitionSelectFetchFormDefinitionsQueryVariables>;
export const GraphqlSchemaSelectFetchPageConfigurationSchemaTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"graphqlSchemaSelectFetchPageConfigurationSchemaType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PageConfigurationTypes"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPageConfigurationSchemaType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"ownerTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"graphQLTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"isTranslatedField"}},{"kind":"Field","name":{"kind":"Name","value":"isNestedRepeatedType"}}]}}]}}]}}]} as unknown as DocumentNode<GraphqlSchemaSelectFetchPageConfigurationSchemaTypeQuery, GraphqlSchemaSelectFetchPageConfigurationSchemaTypeQueryVariables>;
export const FetchApiExportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchApiExports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchApiExportsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchApiExports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiExports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"columns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gqlAlias"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FetchApiExportsQuery, FetchApiExportsQueryVariables>;
export const FetchApiExportDownloadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchApiExportDownload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchApiExportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchApiExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}}]}}]}}]}}]} as unknown as DocumentNode<FetchApiExportDownloadQuery, FetchApiExportDownloadQueryVariables>;
export const FetchApiExportProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchApiExportProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchApiExportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchApiExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}}]}}]} as unknown as DocumentNode<FetchApiExportProgressQuery, FetchApiExportProgressQueryVariables>;
export const ExportApiReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exportApiReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportApiReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportApiReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ExportApiReportMutation, ExportApiReportMutationVariables>;
export const WorkflowSelectFetchWorkflowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workflowSelectFetchWorkflows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchWorkflowsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchWorkflows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<WorkflowSelectFetchWorkflowsQuery, WorkflowSelectFetchWorkflowsQueryVariables>;
export const WorkflowSelectFieldEditFetchWorkflowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workflowSelectFieldEditFetchWorkflows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchWorkflowsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchWorkflows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<WorkflowSelectFieldEditFetchWorkflowsQuery, WorkflowSelectFieldEditFetchWorkflowsQueryVariables>;
export const DashboardFetchOrganizationDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardFetchOrganizationDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganizationDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dashboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"globalFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardGlobalFilterFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardWidgetFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardGlobalFilterFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardGlobalFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardWidgetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Widget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"grouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"valueAggregation"}},{"kind":"Field","name":{"kind":"Name","value":"valueField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"sortDesc"}},{"kind":"Field","name":{"kind":"Name","value":"sortField"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]} as unknown as DocumentNode<DashboardFetchOrganizationDashboardQuery, DashboardFetchOrganizationDashboardQueryVariables>;
export const DashboardFetchOrganizationDashboardNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardFetchOrganizationDashboardName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganizationDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dashboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardFetchOrganizationDashboardNameQuery, DashboardFetchOrganizationDashboardNameQueryVariables>;
export const DashboardUpdateOrganizationDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"dashboardUpdateOrganizationDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationDashboardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardUpdateOrganizationDashboardMutation, DashboardUpdateOrganizationDashboardMutationVariables>;
export const DashboardFetchReportOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardFetchReportOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchReportOptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchReportOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"comparisons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"valueTypes"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"columns"}}]}}]}}]} as unknown as DocumentNode<DashboardFetchReportOptionsQuery, DashboardFetchReportOptionsQueryVariables>;
export const DashboardGenerateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardGenerateReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grouping"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DashboardGenerateReportQuery, DashboardGenerateReportQueryVariables>;
export const FetchFlagGlossaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchFlagGlossary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFlagGlossary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagType"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isAmountThresholdable"}},{"kind":"Field","name":{"kind":"Name","value":"axis"}},{"kind":"Field","name":{"kind":"Name","value":"inherited"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdCents"}},{"kind":"Field","name":{"kind":"Name","value":"percentThreshold"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actual"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdCents"}},{"kind":"Field","name":{"kind":"Name","value":"percentThreshold"}}]}}]}}]}}]} as unknown as DocumentNode<FetchFlagGlossaryQuery, FetchFlagGlossaryQueryVariables>;
export const ClientSummaryFetchWorkflowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clientSummaryFetchWorkflows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchWorkflowsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchWorkflows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<ClientSummaryFetchWorkflowsQuery, ClientSummaryFetchWorkflowsQueryVariables>;
export const FetchAccountReconciliationSnapshotsForActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchAccountReconciliationSnapshotsForActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchAccountReconciliationSnapshotsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAccountReconciliationSnapshots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountReconciliationSnapshots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"isFlagged"}},{"kind":"Field","name":{"kind":"Name","value":"oneVestUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"custodianUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCash"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"oneVestQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"oneVestPendingQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"oneVestValueCents"}},{"kind":"Field","name":{"kind":"Name","value":"oneVestPendingValueCents"}},{"kind":"Field","name":{"kind":"Name","value":"custodianQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"custodianValueCents"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FetchAccountReconciliationSnapshotsForActivityQuery, FetchAccountReconciliationSnapshotsForActivityQueryVariables>;
export const FetchCustodianActivityMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchCustodianActivityMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchCustodianActivityMetricsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchCustodianActivityMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdCount"}},{"kind":"Field","name":{"kind":"Name","value":"reconciledTodayCount"}},{"kind":"Field","name":{"kind":"Name","value":"agingPendingCount"}},{"kind":"Field","name":{"kind":"Name","value":"occurringTodayCount"}}]}}]}}]}}]} as unknown as DocumentNode<FetchCustodianActivityMetricsQuery, FetchCustodianActivityMetricsQueryVariables>;
export const FetchCustodianActivityChartTodayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchCustodianActivityChartToday"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchCustodianActivityChartTodayInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchCustodianActivityChartToday"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asOf"}},{"kind":"Field","name":{"kind":"Name","value":"bands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"band"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchCustodianActivityChartTodayQuery, FetchCustodianActivityChartTodayQueryVariables>;
export const FetchCustodianActivityChartTrendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchCustodianActivityChartTrend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchCustodianActivityChartTrendInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchCustodianActivityChartTrend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asOf"}},{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"inflowCount"}},{"kind":"Field","name":{"kind":"Name","value":"outflowCount"}},{"kind":"Field","name":{"kind":"Name","value":"bands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"band"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchCustodianActivityChartTrendQuery, FetchCustodianActivityChartTrendQueryVariables>;
export const FetchCustodianActivitiesForGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchCustodianActivitiesForGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchCustodianActivitiesInputForGrid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchCustodianActivitiesForGrid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"custodianActivities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianActivityGridFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianActivityGridFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"processDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"settleDate"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"transactionDesc"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"subTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"amountValueCents"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"cusip"}},{"kind":"Field","name":{"kind":"Name","value":"securityType"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"accruedInterest"}},{"kind":"Field","name":{"kind":"Name","value":"bookValueAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"isCancel"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"reconcileMethod"}},{"kind":"Field","name":{"kind":"Name","value":"reconciledAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]} as unknown as DocumentNode<FetchCustodianActivitiesForGridQuery, FetchCustodianActivitiesForGridQueryVariables>;
export const ReconcileCustodianActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"reconcileCustodianActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"custodianActivityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reconcileCustodianActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"custodianActivityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"custodianActivityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failureType"}},{"kind":"Field","name":{"kind":"Name","value":"failureMessage"}},{"kind":"Field","name":{"kind":"Name","value":"custodianActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianActivityGridFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianActivityGridFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"processDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"settleDate"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"transactionDesc"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"subTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"amountValueCents"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"cusip"}},{"kind":"Field","name":{"kind":"Name","value":"securityType"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"accruedInterest"}},{"kind":"Field","name":{"kind":"Name","value":"bookValueAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"isCancel"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"reconcileMethod"}},{"kind":"Field","name":{"kind":"Name","value":"reconciledAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]} as unknown as DocumentNode<ReconcileCustodianActivityMutation, ReconcileCustodianActivityMutationVariables>;
export const ForceReconcileCustodianActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"forceReconcileCustodianActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"custodianActivityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forceReconcileCustodianActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"custodianActivityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"custodianActivityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custodianActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianActivityGridFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianActivityGridFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"processDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"settleDate"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"transactionDesc"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"subTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"amountValueCents"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"cusip"}},{"kind":"Field","name":{"kind":"Name","value":"securityType"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"accruedInterest"}},{"kind":"Field","name":{"kind":"Name","value":"bookValueAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"isCancel"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"reconcileMethod"}},{"kind":"Field","name":{"kind":"Name","value":"reconciledAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]} as unknown as DocumentNode<ForceReconcileCustodianActivityMutation, ForceReconcileCustodianActivityMutationVariables>;
export const UpdateCustodianActivityNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCustodianActivityNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustodianActivityNotesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustodianActivityNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custodianActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustodianActivityGridFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustodianActivityGridFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustodianActivity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientName"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"processDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"settleDate"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"transactionDesc"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"subTransactionId"}},{"kind":"Field","name":{"kind":"Name","value":"amountValueCents"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"cusip"}},{"kind":"Field","name":{"kind":"Name","value":"securityType"}},{"kind":"Field","name":{"kind":"Name","value":"commission"}},{"kind":"Field","name":{"kind":"Name","value":"accruedInterest"}},{"kind":"Field","name":{"kind":"Name","value":"bookValueAmountCents"}},{"kind":"Field","name":{"kind":"Name","value":"isCancel"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"reconcileMethod"}},{"kind":"Field","name":{"kind":"Name","value":"reconciledAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustodianActivityNotesMutation, UpdateCustodianActivityNotesMutationVariables>;
export const SearchUsersForReconFlagsGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchUsersForReconFlagsGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchUsersForReconFlagsGridQuery, SearchUsersForReconFlagsGridQueryVariables>;
export const FetchFlagsForGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchFlagsForGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchFlagsInputForGrid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFlagsForGrid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FetchFlagsForGridQuery, FetchFlagsForGridQueryVariables>;
export const FetchFlagKpIsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchFlagKPIs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unresolvedBefore"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GraphQLDateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFlagKPIs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"unresolvedBefore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unresolvedBefore"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalFlags"}},{"kind":"Field","name":{"kind":"Name","value":"unresolvedOverThreeDays"}},{"kind":"Field","name":{"kind":"Name","value":"typeCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<FetchFlagKpIsQuery, FetchFlagKpIsQueryVariables>;
export const TransitionFlagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"transitionFlag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransitionFlagInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transitionFlag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TransitionFlagMutation, TransitionFlagMutationVariables>;
export const BulkTransitionFlagsForGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkTransitionFlagsForGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkTransitionFlagsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkTransitionFlagsForGrid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"succeeded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flagId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<BulkTransitionFlagsForGridMutation, BulkTransitionFlagsForGridMutationVariables>;
export const UpdateFlagNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFlagNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFlagNotesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFlagNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFlagNotesMutation, UpdateFlagNotesMutationVariables>;
export const AdvisorContactInformationFetchResolvedAdvisorContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"advisorContactInformationFetchResolvedAdvisorContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchResolvedAdvisorContactsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchResolvedAdvisorContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolvedAdvisorContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResolvedAdvisorContactFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResolvedAdvisorContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResolvedAdvisorContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advisorContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"displayRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phoneExtension"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"jurisdiction"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayRoleLabel"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"viaRepCode"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phoneExtension"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayRole"}}]}}]}}]}}]} as unknown as DocumentNode<AdvisorContactInformationFetchResolvedAdvisorContactsQuery, AdvisorContactInformationFetchResolvedAdvisorContactsQueryVariables>;
export const FetchAuditLogsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchAuditLogsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchLogsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withApiTokenFields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"changedByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"traceId"}},{"kind":"Field","name":{"kind":"Name","value":"apiToken"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withApiTokenFields"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchAuditLogsV2Query, FetchAuditLogsV2QueryVariables>;
export const InitiateTransferCreateWorkflowCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"initiateTransferCreateWorkflowCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkflowCompletionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkflowCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowCompletion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowCompletion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"externalObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"complex"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveObjectsOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"cancelOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"displayCloseButton"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSubStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"canGoBack"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"rolesCompleteableBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromKey"}}]}}]}}]}}]} as unknown as DocumentNode<InitiateTransferCreateWorkflowCompletionMutation, InitiateTransferCreateWorkflowCompletionMutationVariables>;
export const GoalLinkingFetchGoalNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"goalLinkingFetchGoalName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"goalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"goalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"goalId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GoalLinkingFetchGoalNameQuery, GoalLinkingFetchGoalNameQueryVariables>;
export const ApprovalFetchHouseholdCustomFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"approvalFetchHouseholdCustomFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchClientGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clientGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"customField"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translatedDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"displayText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTranslatedString"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<ApprovalFetchHouseholdCustomFieldsQuery, ApprovalFetchHouseholdCustomFieldsQueryVariables>;
export const ApprovalUpdateHouseholdCustomFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"approvalUpdateHouseholdCustomFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClientGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClientGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApprovalUpdateHouseholdCustomFieldsMutation, ApprovalUpdateHouseholdCustomFieldsMutationVariables>;
export const FetchArchiveAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchArchiveAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchAccountsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"translatedAccountType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stateTranslated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchArchiveAccountsQuery, FetchArchiveAccountsQueryVariables>;
export const FetchArchiveGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchArchiveGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"goalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"goalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"goalId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FetchArchiveGoalQuery, FetchArchiveGoalQueryVariables>;
export const FetchArchiveSubAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchArchiveSubAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchSubAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translatedAccountType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchArchiveSubAccountQuery, FetchArchiveSubAccountQueryVariables>;
export const FetchArchiveTransfersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchArchiveTransfers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchTransfersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchTransfers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transfers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeTranslated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<FetchArchiveTransfersQuery, FetchArchiveTransfersQueryVariables>;
export const FetchArchiveScheduledTransferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchArchiveScheduledTransfer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scheduledTransferId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchScheduledTransfer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scheduledTransferId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scheduledTransferId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledTransfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typeTranslated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<FetchArchiveScheduledTransferQuery, FetchArchiveScheduledTransferQueryVariables>;
export const FetchArchiveManualProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchArchiveManualProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchManualProcess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manualProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"institution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transferMethod"}}]}}]}}]}}]} as unknown as DocumentNode<FetchArchiveManualProcessQuery, FetchArchiveManualProcessQueryVariables>;
export const FetchUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"latestFormAgreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iid"}},{"kind":"Field","name":{"kind":"Name","value":"externalData"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchUserQuery, FetchUserQueryVariables>;
export const SendIntegrationFormAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendIntegrationFormAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendIntegrationFormAgreementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendIntegrationFormAgreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formAgreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SendIntegrationFormAgreementMutation, SendIntegrationFormAgreementMutationVariables>;
export const FetchAccountSubAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchAccountSubAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchAccountSubAccountsQuery, FetchAccountSubAccountsQueryVariables>;
export const EditAccountAllocationsFetchPortfolioReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"editAccountAllocationsFetchPortfolioReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchPortfolioReportsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPortfolioReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expectedCashPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"modelPortfolio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strategy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expectedPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"isCashEquivalent"}},{"kind":"Field","name":{"kind":"Name","value":"customExpectedPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetClassPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetClassGroupPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCash"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"marketValueCents"}},{"kind":"Field","name":{"kind":"Name","value":"subAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expectedPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"isCashEquivalent"}},{"kind":"Field","name":{"kind":"Name","value":"customExpectedPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetClassPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetClassGroupPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"assetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ticker"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCash"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditAccountAllocationsFetchPortfolioReportsQuery, EditAccountAllocationsFetchPortfolioReportsQueryVariables>;
export const DownloadAllFormsFetchUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"downloadAllFormsFetchUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}}]}}]} as unknown as DocumentNode<DownloadAllFormsFetchUserQuery, DownloadAllFormsFetchUserQueryVariables>;
export const DownloadAllFormsFetchClientGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"downloadAllFormsFetchClientGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchClientGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clientGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DownloadAllFormsFetchClientGroupQuery, DownloadAllFormsFetchClientGroupQueryVariables>;
export const DownloadAllFormsFetchFormCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"downloadAllFormsFetchFormCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formCompletionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFormCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"formCompletionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formCompletionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unsignedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedPdfFileName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsignedDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<DownloadAllFormsFetchFormCompletionQuery, DownloadAllFormsFetchFormCompletionQueryVariables>;
export const DepositEligibleSubAccountsFetchSubAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"depositEligibleSubAccountsFetchSubAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchSubAccountsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canReadAccountNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchSubAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"baseCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"availableCurrencies"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canReadAccountNumber"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketValueCents"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"marketValueCents"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<DepositEligibleSubAccountsFetchSubAccountsQuery, DepositEligibleSubAccountsFetchSubAccountsQueryVariables>;
export const CloseAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"closeAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CloseAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CloseAccountMutation, CloseAccountMutationVariables>;
export const RunWorkflowSubStepActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"runWorkflowSubStepAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RunWorkflowSubStepActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runWorkflowSubStepAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowCompletion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RunWorkflowSubStepActionMutation, RunWorkflowSubStepActionMutationVariables>;
export const CreateLinkTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLinkToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLinkTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLinkToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkToken"}}]}}]}}]} as unknown as DocumentNode<CreateLinkTokenMutation, CreateLinkTokenMutationVariables>;
export const CreateTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTransactionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const UpdateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const CreateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAccountMutation, CreateAccountMutationVariables>;
export const CreateSubAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSubAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSubAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSubAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSubAccountMutation, CreateSubAccountMutationVariables>;
export const ValidateAgeOfMajorityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateAgeOfMajority"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressCountries"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jurisdiction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressJurisdiction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateAgeOfMajority"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dateOfBirth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateOfBirth"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"jurisdiction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jurisdiction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valid"}},{"kind":"Field","name":{"kind":"Name","value":"ageOfMajority"}}]}}]}}]} as unknown as DocumentNode<ValidateAgeOfMajorityQuery, ValidateAgeOfMajorityQueryVariables>;
export const SelectModelPortfolioEditTypeFetchHouseholdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"selectModelPortfolioEditTypeFetchHousehold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPortfolioReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"householdClientGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SelectModelPortfolioEditTypeFetchHouseholdQuery, SelectModelPortfolioEditTypeFetchHouseholdQueryVariables>;
export const WithdrawalBreakdownCalculateWithdrawFeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"withdrawalBreakdownCalculateWithdrawFees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculateWithdrawFeesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateWithdrawFees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amountCents"}}]}}]}}]}}]} as unknown as DocumentNode<WithdrawalBreakdownCalculateWithdrawFeesQuery, WithdrawalBreakdownCalculateWithdrawFeesQueryVariables>;
export const QueryFetchLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryFetchLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchLogsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalDocument"}},{"kind":"Field","name":{"kind":"Name","value":"newDocument"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}},{"kind":"Field","name":{"kind":"Name","value":"workflowContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowCompletionId"}},{"kind":"Field","name":{"kind":"Name","value":"stepId"}},{"kind":"Field","name":{"kind":"Name","value":"subStepId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<QueryFetchLogsQuery, QueryFetchLogsQueryVariables>;
export const GetTotalLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTotalLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchLogsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetTotalLogsQuery, GetTotalLogsQueryVariables>;
export const CreateWorkflowCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWorkflowCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkflowCompletionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWorkflowCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowCompletion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateWorkflowCompletionMutation, CreateWorkflowCompletionMutationVariables>;
export const FetchRepCodesForDesignationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchRepCodesForDesignation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchRepCodesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchRepCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"repCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FetchRepCodesForDesignationQuery, FetchRepCodesForDesignationQueryVariables>;
export const FetchResolvedAdvisorContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchResolvedAdvisorContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchResolvedAdvisorContactsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchResolvedAdvisorContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolvedAdvisorContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResolvedAdvisorContactFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResolvedAdvisorContactFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ResolvedAdvisorContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advisorContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"displayRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phoneExtension"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"houseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"streetName"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"jurisdiction"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayRoleLabel"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionPath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"viaRepCode"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phoneExtension"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayRole"}}]}}]}}]}}]} as unknown as DocumentNode<FetchResolvedAdvisorContactsQuery, FetchResolvedAdvisorContactsQueryVariables>;
export const FetchClientAdvisorVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchClientAdvisorVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchClientAdvisorVisibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchClientAdvisorVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visibilityEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advisorContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effectiveHide"}},{"kind":"Field","name":{"kind":"Name","value":"displayLabel"}},{"kind":"Field","name":{"kind":"Name","value":"precedence"}},{"kind":"Field","name":{"kind":"Name","value":"contributingAccountIds"}}]}}]}}]}}]} as unknown as DocumentNode<FetchClientAdvisorVisibilityQuery, FetchClientAdvisorVisibilityQueryVariables>;
export const SearchAdvisorContactClientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchAdvisorContactClients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}}]}}]} as unknown as DocumentNode<SearchAdvisorContactClientsQuery, SearchAdvisorContactClientsQueryVariables>;
export const SearchAdvisorContactClientsWithoutPiiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchAdvisorContactClientsWithoutPii"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<SearchAdvisorContactClientsWithoutPiiQuery, SearchAdvisorContactClientsWithoutPiiQueryVariables>;
export const FetchAdvisorContactClientAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchAdvisorContactClientAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchAccountsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}}]}}]}}]}}]} as unknown as DocumentNode<FetchAdvisorContactClientAccountsQuery, FetchAdvisorContactClientAccountsQueryVariables>;
export const FetchAdvisorContactClientHouseholdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchAdvisorContactClientHouseholds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"households"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchAdvisorContactClientHouseholdsQuery, FetchAdvisorContactClientHouseholdsQueryVariables>;
export const FetchAdvisorContactClientHouseholdsWithoutPiiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchAdvisorContactClientHouseholdsWithoutPii"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"households"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchAdvisorContactClientHouseholdsWithoutPiiQuery, FetchAdvisorContactClientHouseholdsWithoutPiiQueryVariables>;
export const FetchAdvisorContactPageOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchAdvisorContactPageOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchPageConfigurationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPageConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchAdvisorContactPageOptionsQuery, FetchAdvisorContactPageOptionsQueryVariables>;
export const UpdateAdvisorContactClientVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAdvisorContactClientVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserOrganizationUserDisplayOptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserOrganizationUserDisplayOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOrganizationUserDisplayOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hide"}},{"kind":"Field","name":{"kind":"Name","value":"advisorContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAdvisorContactClientVisibilityMutation, UpdateAdvisorContactClientVisibilityMutationVariables>;
export const FetchOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"useParentDisplayRoles"}}]}}]}}]}}]} as unknown as DocumentNode<FetchOrganizationQuery, FetchOrganizationQueryVariables>;
export const CreateDisplayRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDisplayRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDisplayRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDisplayRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"isInherited"}},{"kind":"Field","name":{"kind":"Name","value":"advisorContactCount"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDisplayRoleMutation, CreateDisplayRoleMutationVariables>;
export const UpdateDisplayRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDisplayRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDisplayRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDisplayRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"isInherited"}},{"kind":"Field","name":{"kind":"Name","value":"advisorContactCount"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDisplayRoleMutation, UpdateDisplayRoleMutationVariables>;
export const ReorderDisplayRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"reorderDisplayRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReorderDisplayRolesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reorderDisplayRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"isInherited"}},{"kind":"Field","name":{"kind":"Name","value":"advisorContactCount"}}]}}]}}]}}]} as unknown as DocumentNode<ReorderDisplayRolesMutation, ReorderDisplayRolesMutationVariables>;
export const TransitionDisplayRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"transitionDisplayRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransitionDisplayRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transitionDisplayRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"isInherited"}},{"kind":"Field","name":{"kind":"Name","value":"advisorContactCount"}}]}}]}}]}}]} as unknown as DocumentNode<TransitionDisplayRoleMutation, TransitionDisplayRoleMutationVariables>;
export const FetchTableExternalDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchTableExternalData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchTableExternalDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchTableExternalData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tableExternalData"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValues"}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prev"}},{"kind":"Field","name":{"kind":"Name","value":"next"}}]}}]}}]}}]} as unknown as DocumentNode<FetchTableExternalDataQuery, FetchTableExternalDataQueryVariables>;
export const FetchConfigurableTableFilterOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchConfigurableTableFilterOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchConfigurableTableFilterOptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchConfigurableTableFilterOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"populatedOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<FetchConfigurableTableFilterOptionsQuery, FetchConfigurableTableFilterOptionsQueryVariables>;
export const ExportConfigurableTablePageReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exportConfigurableTablePageReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportConfigurableTablePageReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportConfigurableTablePageReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configurableTablePageExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ExportConfigurableTablePageReportMutation, ExportConfigurableTablePageReportMutationVariables>;
export const FetchConfigurableTablePageReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchConfigurableTablePageReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"configurableTablePageExportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchConfigurableTablePageReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configurableTablePageExportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"configurableTablePageExportId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configurableTablePageExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]}}]} as unknown as DocumentNode<FetchConfigurableTablePageReportQuery, FetchConfigurableTablePageReportQueryVariables>;
export const UpdateSubAccountBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubAccountBilling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubAccountBillingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubAccountBilling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subAccountBilling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubAccountBillingMutation, UpdateSubAccountBillingMutationVariables>;
export const OverrideFeesModalFetchSalesTaxConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"overrideFeesModalFetchSalesTaxConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchSalesTaxConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchSalesTaxConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesTaxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicableDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configurableTaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identity"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OverrideFeesModalFetchSalesTaxConfigurationQuery, OverrideFeesModalFetchSalesTaxConfigurationQueryVariables>;
export const FormMapResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formMapResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormMapResultInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePdf"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdfTemplateBase64"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flattenPdf"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eSignProvider"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ESignProvider"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formMapResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolvedFormMap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formDefinitionId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"additionalValue"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"errorWhenEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"formatter"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pdfTemplateBase64"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdfTemplateBase64"}}},{"kind":"Argument","name":{"kind":"Name","value":"flattenPdf"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flattenPdf"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePdf"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"signatureFieldLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eSignProvider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eSignProvider"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signerKey"}},{"kind":"Field","name":{"kind":"Name","value":"signerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FormMapResultQuery, FormMapResultQueryVariables>;
export const FetchFormMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchFormMap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formMapId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFormMap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"formMapId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formMapId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"templateS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"removePdfMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"signaturePageNumberBase"}},{"kind":"Field","name":{"kind":"Name","value":"templateUrl"}},{"kind":"Field","name":{"kind":"Name","value":"formDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"signerKey"}},{"kind":"Field","name":{"kind":"Name","value":"customFunc"}},{"kind":"Field","name":{"kind":"Name","value":"customFuncContextKeys"}},{"kind":"Field","name":{"kind":"Name","value":"formatter"}},{"kind":"Field","name":{"kind":"Name","value":"errorWhenEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"dataMasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mask"}},{"kind":"Field","name":{"kind":"Name","value":"optionValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchFormMapQuery, FetchFormMapQueryVariables>;
export const CreateFormMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFormMap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFormMapInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFormMap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formMap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFormMapMutation, CreateFormMapMutationVariables>;
export const UpdateFormMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFormMap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFormMapInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFormMap"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formMap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"templateLabel"}},{"kind":"Field","name":{"kind":"Name","value":"signerKey"}},{"kind":"Field","name":{"kind":"Name","value":"formatter"}},{"kind":"Field","name":{"kind":"Name","value":"errorWhenEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"dataMasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mask"}},{"kind":"Field","name":{"kind":"Name","value":"optionValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formDefinition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"templateS3Key"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFormMapMutation, UpdateFormMapMutationVariables>;
export const FormTemplateBreadcrumbFetchFormTemplateNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formTemplateBreadcrumbFetchFormTemplateName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchFormTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFormTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translatedDisplayName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormTranslatedString"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<FormTemplateBreadcrumbFetchFormTemplateNameQuery, FormTemplateBreadcrumbFetchFormTemplateNameQueryVariables>;
export const EditArticleDialogFetchArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"editArticleDialogFetchArticle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchArticle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"articleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"articleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ignoreRoleTargeting"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"article"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"articleUrl"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translatedDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToRoleIds"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<EditArticleDialogFetchArticleQuery, EditArticleDialogFetchArticleQueryVariables>;
export const ArticleListFetchArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"articleListFetchArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchArticlesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchArticles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"articleUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"translatedDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToRoleIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<ArticleListFetchArticlesQuery, ArticleListFetchArticlesQueryVariables>;
export const VisibleToRolesLabelFetchRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"visibleToRolesLabelFetchRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchRolesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<VisibleToRolesLabelFetchRolesQuery, VisibleToRolesLabelFetchRolesQueryVariables>;
export const OrgSettingsEditOrganizationLogoFetchFileDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orgSettingsEditOrganizationLogoFetchFileDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FileDocumentQueryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFileDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"1"}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortDesc"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"sortField"},"value":{"kind":"StringValue","value":"createdAt","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<OrgSettingsEditOrganizationLogoFetchFileDocumentsQuery, OrgSettingsEditOrganizationLogoFetchFileDocumentsQueryVariables>;
export const PortfolioOptimizerBreadcrumbFetchPortfolioOptimizerRanAtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"portfolioOptimizerBreadcrumbFetchPortfolioOptimizerRanAt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchPortfolioOptimizerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPortfolioOptimizer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolioOptimizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<PortfolioOptimizerBreadcrumbFetchPortfolioOptimizerRanAtQuery, PortfolioOptimizerBreadcrumbFetchPortfolioOptimizerRanAtQueryVariables>;
export const AccountSnapshotBreadcrumbFetchAccountSnapshotLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accountSnapshotBreadcrumbFetchAccountSnapshotLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountReconciliationSnapshotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAccountReconciliationSnapshot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountReconciliationSnapshotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountReconciliationSnapshotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountReconciliationSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountSnapshotBreadcrumbFetchAccountSnapshotLabelQuery, AccountSnapshotBreadcrumbFetchAccountSnapshotLabelQueryVariables>;
export const UseObjectActiveWorkflowCompletionsGetAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"useObjectActiveWorkflowCompletionsGetAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fetchObject"},"name":{"kind":"Name","value":"fetchAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"object"},"name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"activeWorkflowCompletions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowCompletion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"externalObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"complex"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveObjectsOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"cancelOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"displayCloseButton"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSubStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"canGoBack"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"rolesCompleteableBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromKey"}}]}}]}}]}}]} as unknown as DocumentNode<UseObjectActiveWorkflowCompletionsGetAccountQuery, UseObjectActiveWorkflowCompletionsGetAccountQueryVariables>;
export const UseObjectActiveWorkflowCompletionsGetGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"useObjectActiveWorkflowCompletionsGetGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fetchObject"},"name":{"kind":"Name","value":"fetchGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"goalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"object"},"name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeWorkflowCompletions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowCompletion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"externalObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"complex"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveObjectsOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"cancelOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"displayCloseButton"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSubStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"canGoBack"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"rolesCompleteableBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromKey"}}]}}]}}]}}]} as unknown as DocumentNode<UseObjectActiveWorkflowCompletionsGetGoalQuery, UseObjectActiveWorkflowCompletionsGetGoalQueryVariables>;
export const UseObjectActiveWorkflowCompletionsGetSubAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"useObjectActiveWorkflowCompletionsGetSubAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fetchObject"},"name":{"kind":"Name","value":"fetchSubAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"object"},"name":{"kind":"Name","value":"subAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeWorkflowCompletions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowCompletion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"externalObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"complex"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveObjectsOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"cancelOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"displayCloseButton"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSubStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"canGoBack"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"rolesCompleteableBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromKey"}}]}}]}}]}}]} as unknown as DocumentNode<UseObjectActiveWorkflowCompletionsGetSubAccountQuery, UseObjectActiveWorkflowCompletionsGetSubAccountQueryVariables>;
export const GetActiveWorkflowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveWorkflows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"activeWorkflowCompletions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowCompletion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"externalObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"complex"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveObjectsOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"cancelOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"displayCloseButton"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSubStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"canGoBack"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"rolesCompleteableBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromKey"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveWorkflowsQuery, GetActiveWorkflowsQueryVariables>;
export const GetHouseholdActiveWorkflowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHouseholdActiveWorkflows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SafeString"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchClientGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clientGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientGroupId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"stringId"}},{"kind":"Field","name":{"kind":"Name","value":"activeWorkflowCompletions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveWorkflowCompletionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowCompletion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"externalObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stringId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"context"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"complex"}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveObjectsOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"cancelOnClose"}},{"kind":"Field","name":{"kind":"Name","value":"displayCloseButton"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSubStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"canGoBack"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"rolesCompleteableBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"branches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromKey"}}]}}]}}]}}]} as unknown as DocumentNode<GetHouseholdActiveWorkflowsQuery, GetHouseholdActiveWorkflowsQueryVariables>;
export const AlertBannerBreadcrumbFetchAlertBannerNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"alertBannerBreadcrumbFetchAlertBannerName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alertBannerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAlertBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"alertBannerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alertBannerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alertBanner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AlertBannerBreadcrumbFetchAlertBannerNameQuery, AlertBannerBreadcrumbFetchAlertBannerNameQueryVariables>;
export const BillingScheduleBreadcrumbFetchBillingScheduleFrequencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"billingScheduleBreadcrumbFetchBillingScheduleFrequency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingScheduleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchBillingSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"billingScheduleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingScheduleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}}]}}]}}]} as unknown as DocumentNode<BillingScheduleBreadcrumbFetchBillingScheduleFrequencyQuery, BillingScheduleBreadcrumbFetchBillingScheduleFrequencyQueryVariables>;
export const CreateFeeTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFeeTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFeeTierInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeeTier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFeeTierMutation, CreateFeeTierMutationVariables>;
export const CustodianConnectionBreadcrumbFetchCustodianConnectionNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"custodianConnectionBreadcrumbFetchCustodianConnectionNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchCustodianConnectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchCustodianConnections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"custodianConnections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CustodianConnectionBreadcrumbFetchCustodianConnectionNamesQuery, CustodianConnectionBreadcrumbFetchCustodianConnectionNamesQueryVariables>;
export const DashboardListFetchOrganizationDashboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dashboardListFetchOrganizationDashboards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchOrganizationDashboardsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganizationDashboards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<DashboardListFetchOrganizationDashboardsQuery, DashboardListFetchOrganizationDashboardsQueryVariables>;
export const DashboardListCreateOrganizationDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"dashboardListCreateOrganizationDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationDashboardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganizationDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardListCreateOrganizationDashboardMutation, DashboardListCreateOrganizationDashboardMutationVariables>;
export const DashboardListTransitionOrganizationDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"dashboardListTransitionOrganizationDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransitionOrganizationDashboardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transitionOrganizationDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]} as unknown as DocumentNode<DashboardListTransitionOrganizationDashboardMutation, DashboardListTransitionOrganizationDashboardMutationVariables>;
export const CopyFromDashboardDialogFetchOrganizationDashboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"copyFromDashboardDialogFetchOrganizationDashboards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchOrganizationDashboardsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganizationDashboards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CopyFromDashboardDialogFetchOrganizationDashboardsQuery, CopyFromDashboardDialogFetchOrganizationDashboardsQueryVariables>;
export const CopyFromDashboardDialogFetchOrganizationDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"copyFromDashboardDialogFetchOrganizationDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganizationDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dashboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dashboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"globalFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardGlobalFilterFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"widgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardWidgetFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardGlobalFilterFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardGlobalFilter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardWidgetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Widget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparison"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"grouping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"valueAggregation"}},{"kind":"Field","name":{"kind":"Name","value":"valueField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"sortDesc"}},{"kind":"Field","name":{"kind":"Name","value":"sortField"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]} as unknown as DocumentNode<CopyFromDashboardDialogFetchOrganizationDashboardQuery, CopyFromDashboardDialogFetchOrganizationDashboardQueryVariables>;
export const AssignSearchUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignSearchUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignSearchUsersQuery, AssignSearchUsersQueryVariables>;
export const AssignFetchClientGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignFetchClientGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchClientGroupsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchClientGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"clientGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignFetchClientGroupsQuery, AssignFetchClientGroupsQueryVariables>;
export const AssignSearchAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignSearchAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignSearchAccountsQuery, AssignSearchAccountsQueryVariables>;
export const AssignFetchAccountGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignFetchAccountGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchAccountGroupsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchAccountGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"accountGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignFetchAccountGroupsQuery, AssignFetchAccountGroupsQueryVariables>;
export const AssignFetchSubAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignFetchSubAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchSubAccountsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchSubAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"subAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignFetchSubAccountsQuery, AssignFetchSubAccountsQueryVariables>;
export const FeeGridBreadcrumbFetchFeeGridNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"feeGridBreadcrumbFetchFeeGridName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFeeTier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feeTierId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FeeGridBreadcrumbFetchFeeGridNameQuery, FeeGridBreadcrumbFetchFeeGridNameQueryVariables>;
export const FetchFeeTierEntityCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchFeeTierEntityCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"subAccount"},"name":{"kind":"Name","value":"fetchEntityFeeSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"EnumValue","value":"SUB_ACCOUNT"}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"fetchEntityFeeSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"EnumValue","value":"ACCOUNT"}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountGroup"},"name":{"kind":"Name","value":"fetchEntityFeeSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"EnumValue","value":"ACCOUNT_GROUP"}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"user"},"name":{"kind":"Name","value":"fetchEntityFeeSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"EnumValue","value":"USER"}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clientGroup"},"name":{"kind":"Name","value":"fetchEntityFeeSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"EnumValue","value":"CLIENT_GROUP"}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FetchFeeTierEntityCountsQuery, FetchFeeTierEntityCountsQueryVariables>;
export const UnassignEntityFeeTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"unassignEntityFeeTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeeEntityIdentifier"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEntityFeeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEntityFeeSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entity"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UnassignEntityFeeTierMutation, UnassignEntityFeeTierMutationVariables>;
export const AssignEntityFeeTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"assignEntityFeeTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeeEntityIdentifier"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEntityFeeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEntityFeeSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entity"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AssignEntityFeeTierMutation, AssignEntityFeeTierMutationVariables>;
export const FetchEntityFeeSettingsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchEntityFeeSettingsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeeEntity"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offSet"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchEntityFeeSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeTierId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offSet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offSet"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"entityFeeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"goal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketValueCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"custodianAccountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchEntityFeeSettingsListQuery, FetchEntityFeeSettingsListQueryVariables>;
export const FetchFeeTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchFeeTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFeeTier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feeTierId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feeTierId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"chargeForCash"}},{"kind":"Field","name":{"kind":"Name","value":"chargeForCashOnHold"}},{"kind":"Field","name":{"kind":"Name","value":"flatAnnualFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"grid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minMarketValueCents"}},{"kind":"Field","name":{"kind":"Name","value":"annualFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"annualFeeCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gridScopeType"}},{"kind":"Field","name":{"kind":"Name","value":"blendedGrid"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchFeeTierQuery, FetchFeeTierQueryVariables>;
export const UpdateFeeTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateFeeTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFeeTierInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFeeTier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFeeTierMutation, UpdateFeeTierMutationVariables>;
export const TransitionFeeTierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"transitionFeeTier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransitionFeeTierInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transitionFeeTier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeTier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TransitionFeeTierMutation, TransitionFeeTierMutationVariables>;
export const HomePageConfigurationBreadcrumbFetchHomePageConfigurationNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"homePageConfigurationBreadcrumbFetchHomePageConfigurationName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"homePageConfigurationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchHomePageConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"homePageConfigurationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"homePageConfigurationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homePageConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<HomePageConfigurationBreadcrumbFetchHomePageConfigurationNameQuery, HomePageConfigurationBreadcrumbFetchHomePageConfigurationNameQueryVariables>;
export const PageConfigurationBreadcrumbFetchPageConfigurationNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pageConfigurationBreadcrumbFetchPageConfigurationName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageConfigurationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPageConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageConfigurationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageConfigurationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PageConfigurationBreadcrumbFetchPageConfigurationNameQuery, PageConfigurationBreadcrumbFetchPageConfigurationNameQueryVariables>;
export const ReconToleranceFetchOrganizationPoliciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"reconToleranceFetchOrganizationPolicies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reconTolerancePolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReconToleranceOwnPolicyFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effectiveReconTolerancePolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReconToleranceEffectivePolicyFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReconToleranceOwnPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReconTolerancePolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdCents"}},{"kind":"Field","name":{"kind":"Name","value":"dailyCapCents"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOnReconcile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReconToleranceEffectivePolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EffectiveReconTolerancePolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdCents"}},{"kind":"Field","name":{"kind":"Name","value":"dailyCapCents"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOnReconcile"}},{"kind":"Field","name":{"kind":"Name","value":"policySource"}},{"kind":"Field","name":{"kind":"Name","value":"policySourceOrganizationId"}}]}}]} as unknown as DocumentNode<ReconToleranceFetchOrganizationPoliciesQuery, ReconToleranceFetchOrganizationPoliciesQueryVariables>;
export const ReconToleranceUpdateOrgPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"reconToleranceUpdateOrgPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrgReconTolerancePolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrgReconTolerancePolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reconTolerancePolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReconToleranceOwnPolicyFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effectiveReconTolerancePolicies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReconToleranceEffectivePolicyFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReconToleranceOwnPolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReconTolerancePolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdCents"}},{"kind":"Field","name":{"kind":"Name","value":"dailyCapCents"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOnReconcile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReconToleranceEffectivePolicyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EffectiveReconTolerancePolicy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breakType"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"thresholdCents"}},{"kind":"Field","name":{"kind":"Name","value":"dailyCapCents"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOnReconcile"}},{"kind":"Field","name":{"kind":"Name","value":"policySource"}},{"kind":"Field","name":{"kind":"Name","value":"policySourceOrganizationId"}}]}}]} as unknown as DocumentNode<ReconToleranceUpdateOrgPolicyMutation, ReconToleranceUpdateOrgPolicyMutationVariables>;
export const SalesTaxFetchConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"salesTaxFetchConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchSalesTaxConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchSalesTaxConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesTaxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicableDate"}},{"kind":"Field","name":{"kind":"Name","value":"localRevision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveFrom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effectiveConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"inherited"}},{"kind":"Field","name":{"kind":"Name","value":"configurableTaxes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identity"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"revision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveFrom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configurationOwner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"legacyFallbackSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationTranslatedString"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<SalesTaxFetchConfigurationQuery, SalesTaxFetchConfigurationQueryVariables>;
export const SalesTaxCreateConfigurationRevisionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"salesTaxCreateConfigurationRevision"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSalesTaxConfigurationRevisionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSalesTaxConfigurationRevision"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesTaxConfigurationRevision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveFrom"}}]}}]}}]}}]} as unknown as DocumentNode<SalesTaxCreateConfigurationRevisionMutation, SalesTaxCreateConfigurationRevisionMutationVariables>;
export const SalesTaxPollInheritanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"salesTaxPollInheritance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchSalesTaxConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchSalesTaxConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesTaxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicableDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inherited"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SalesTaxPollInheritanceQuery, SalesTaxPollInheritanceQueryVariables>;
export const SalesTaxFetchOrganizationInheritanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"salesTaxFetchOrganizationInheritance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"useParentSalesTaxConfiguration"}}]}}]}}]}}]} as unknown as DocumentNode<SalesTaxFetchOrganizationInheritanceQuery, SalesTaxFetchOrganizationInheritanceQueryVariables>;
export const StaticPageWidgetConfigurationBreadcrumbFetchStaticPageWidgetConfigurationNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"staticPageWidgetConfigurationBreadcrumbFetchStaticPageWidgetConfigurationName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"staticPageWidgetConfigurationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchStaticPageWidgetConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"staticPageWidgetConfigurationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"staticPageWidgetConfigurationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staticPageWidgetConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<StaticPageWidgetConfigurationBreadcrumbFetchStaticPageWidgetConfigurationNameQuery, StaticPageWidgetConfigurationBreadcrumbFetchStaticPageWidgetConfigurationNameQueryVariables>;
export const FetchOrganizationThemeTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchOrganizationThemeTokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"themeTokens"}},{"kind":"Field","name":{"kind":"Name","value":"useParentThemeTokens"}}]}}]}}]}}]} as unknown as DocumentNode<FetchOrganizationThemeTokensQuery, FetchOrganizationThemeTokensQueryVariables>;
export const UpdateOrganizationThemeTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganizationThemeTokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationThemeTokensMutation, UpdateOrganizationThemeTokensMutationVariables>;
export const FetchFormDefinitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchFormDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchFormDefinitionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchFormDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formDefinitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchFormDefinitionsQuery, FetchFormDefinitionsQueryVariables>;
export const FetchRoleProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchRoleProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchRoleProfilesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchRoleProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translatedDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"accessiblePages"}},{"kind":"Field","name":{"kind":"Name","value":"dashboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchRoleProfilesQuery, FetchRoleProfilesQueryVariables>;
export const WorkflowBreadcrumbFetchWorkflowNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"workflowBreadcrumbFetchWorkflowName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchWorkflow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workflowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkflowTranslatedString"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkflowTranslatedString"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkflowTranslatedString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"fr"}},{"kind":"Field","name":{"kind":"Name","value":"es"}}]}}]} as unknown as DocumentNode<WorkflowBreadcrumbFetchWorkflowNameQuery, WorkflowBreadcrumbFetchWorkflowNameQueryVariables>;